// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: schema/schema.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../google/protobuf/timestamp";
import {
  AssertCategoryType,
  assertCategoryTypeFromJSON,
  assertCategoryTypeToJSON,
  AssertDeviceType,
  assertDeviceTypeFromJSON,
  assertDeviceTypeToJSON,
  AssertSeverityType,
  assertSeverityTypeFromJSON,
  assertSeverityTypeToJSON,
  AssertStateType,
  assertStateTypeFromJSON,
  assertStateTypeToJSON,
} from "../models/assert";
import {
  KnownProvider,
  knownProviderFromJSON,
  knownProviderToJSON,
  RestKeyType,
  restKeyTypeFromJSON,
  restKeyTypeToJSON,
  Theme,
  themeFromJSON,
  themeToJSON,
  TimeFormat,
  timeFormatFromJSON,
  timeFormatToJSON,
  TokenScope,
  tokenScopeFromJSON,
  tokenScopeToJSON,
  UserRole,
  userRoleFromJSON,
  userRoleToJSON,
} from "../models/auth";
import {
  CableType,
  cableTypeFromJSON,
  cableTypeToJSON,
  FabricTopology,
  fabricTopologyFromJSON,
  fabricTopologyToJSON,
  NodeRole,
  nodeRoleFromJSON,
  nodeRoleToJSON,
  NodeType,
  nodeTypeFromJSON,
  nodeTypeToJSON,
  PortRole,
  portRoleFromJSON,
  portRoleToJSON,
} from "../models/fabric";
import {
  AdminState,
  adminStateFromJSON,
  adminStateToJSON,
  EntitlementLevel,
  entitlementLevelFromJSON,
  entitlementLevelToJSON,
  FabricType,
  fabricTypeFromJSON,
  fabricTypeToJSON,
  Geo,
  geoFromJSON,
  geoToJSON,
  OperState,
  operStateFromJSON,
  operStateToJSON,
  OrgKind,
  orgKindFromJSON,
  orgKindToJSON,
  OsType,
  osTypeFromJSON,
  osTypeToJSON,
} from "../models/global";
import {
  BmcProductType,
  bmcProductTypeFromJSON,
  bmcProductTypeToJSON,
  BmcStateType,
  bmcStateTypeFromJSON,
  bmcStateTypeToJSON,
  ConnectivityStatus,
  connectivityStatusFromJSON,
  connectivityStatusToJSON,
  ManagedEndpointType,
  managedEndpointTypeFromJSON,
  managedEndpointTypeToJSON,
} from "../models/server";
import { PathId } from "../schema_path/path_id";

export const protobufPackage = "schema";

export enum TestEnum {
  TEST_ENUM_INVALID = 0,
  TEST_ENUM_ONE = 1,
  TEST_ENUM_TWO = 2,
  UNRECOGNIZED = -1,
}

export function testEnumFromJSON(object: any): TestEnum {
  switch (object) {
    case 0:
    case "TEST_ENUM_INVALID":
      return TestEnum.TEST_ENUM_INVALID;
    case 1:
    case "TEST_ENUM_ONE":
      return TestEnum.TEST_ENUM_ONE;
    case 2:
    case "TEST_ENUM_TWO":
      return TestEnum.TEST_ENUM_TWO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TestEnum.UNRECOGNIZED;
  }
}

export function testEnumToJSON(object: TestEnum): string {
  switch (object) {
    case TestEnum.TEST_ENUM_INVALID:
      return "TEST_ENUM_INVALID";
    case TestEnum.TEST_ENUM_ONE:
      return "TEST_ENUM_ONE";
    case TestEnum.TEST_ENUM_TWO:
      return "TEST_ENUM_TWO";
    case TestEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** TemperatureSensors gives the well known names for temperature sensors. */
export enum TemperatureSensors {
  INVALID_SENSOR = 0,
  ACPI = 1,
  CPU_U17_P1P05V_TEMP = 2,
  CPU_U17_PVCCIN_TEMP = 3,
  CPU_U117_P1P2V_TEMP = 4,
  CPU_U117_P1P05V_TEMP = 5,
  DIMM_TEMP1 = 6,
  DIMM_TEMP2 = 7,
  FAN_Sensor = 8,
  MB_JM01_L1_TEMP = 9,
  MB_JM01_L2_TEMP = 10,
  MB_JM11_L1_TEMP = 11,
  MB_JM11_L2_TEMP = 12,
  MB_JM21_L1_TEMP = 13,
  MB_JM21_L2_TEMP = 14,
  MB_PORT_Sensor = 15,
  MB_TMP421_Local = 16,
  PSU0HSNK_Temp = 17,
  PSU0Inlet_Temp = 18,
  PSU0Outlet_Temp = 19,
  PSU1HSNK_Temp = 20,
  PSU1Inlet_Temp = 21,
  PSU1Outlet_Temp = 22,
  SSD_Temp = 23,
  X86_CORE_0_T = 24,
  X86_CORE_1_T = 25,
  X86_CORE_2_T = 26,
  X86_CORE_3_T = 27,
  X86_PKG_TEMP = 28,
  MB_3_3V_R_VDDCK_TEMP_L1 = 29,
  MB_3_3V_R_VDDCK_TEMP_L2 = 30,
  MB_GB_CORE_TEMP_L1 = 31,
  MB_VDDS_VDDA_TEMP_L1 = 32,
  MB_VDDS_VDDA_TEMP_L2 = 33,
  PSU0HSNK_Temp1 = 34,
  PSU0HSNK_Temp2 = 35,
  PSU1HSNK_Temp1 = 36,
  PSU1HSNK_Temp2 = 37,
  NPU0_TEMP_0 = 38,
  NPU0_TEMP_1 = 39,
  NPU0_TEMP_2 = 40,
  NPU0_TEMP_3 = 41,
  NPU0_TEMP_4 = 42,
  NPU0_TEMP_5 = 43,
  NPU0_TEMP_6 = 44,
  NPU0_TEMP_7 = 45,
  NPU0_TEMP_8 = 46,
  NPU0_TEMP_9 = 47,
  NPU1_TEMP_0 = 48,
  NPU1_TEMP_1 = 49,
  NPU1_TEMP_2 = 50,
  NPU1_TEMP_3 = 51,
  NPU1_TEMP_4 = 52,
  NPU1_TEMP_5 = 53,
  NPU1_TEMP_6 = 54,
  NPU1_TEMP_7 = 55,
  NPU1_TEMP_8 = 56,
  NPU1_TEMP_9 = 57,
  NPU1_TEMP_10 = 58,
  PSU2HSNK_Temp = 59,
  PSU2Inlet_Temp = 60,
  PSU2Outlet_Temp = 61,
  X86_CORE_4_T = 62,
  CPU_BRD_T = 63,
  CPU_CORE_TEMP_1_T = 64,
  CPU_CORE_TEMP_2_T = 65,
  CPU_CORE_TEMP_3_T = 66,
  CPU_CORE_TEMP_4_T = 67,
  CPU_CORE_TEMP_5_T = 68,
  CPU_CORE_TEMP_6_T = 69,
  CPU_CORE_TEMP_7_T = 70,
  CPU_CORE_TEMP_8_T = 71,
  CPU_PKG_TEMP_T = 72,
  FANIO_BRD_T = 73,
  MB_1_T = 74,
  MB_2_T = 75,
  MB_3_T = 76,
  NPU1_HBM_TEMP_1 = 77,
  NPU1_HBM_TEMP_2 = 78,
  SODIMM_1_TEMP_T = 79,
  SODIMM_2_TEMP_T = 80,
  SSD_TEMP_T = 81,
  XINDI_L_1_T = 82,
  XINDI_L_2_T = 83,
  XINDI_R_1_T = 84,
  XINDI_R_2_T = 85,
  G0_GB_CORE_L1_TEMP = 86,
  MB_JM31_L1_TEMP = 87,
  MB_JM31_L2_TEMP = 88,
  BRD_OUTLET_TEMP_T = 89,
  CHAS_HOT_T_EXT_T = 90,
  CHAS_HOT_T_INT_T = 91,
  CHAS_INLET_T_INT_T = 92,
  IOB_Ambient_T = 93,
  LTC2979_A_TEMP_T = 94,
  LTC2979_B_TEMP_T = 95,
  NPU0_CHIPLET0_T0_T = 96,
  NPU0_CHIPLET0_T1_T = 97,
  NPU0_CHIPLET0_T2_T = 98,
  NPU0_CHIPLET0_T3_T = 99,
  NPU0_CHIPLET0_T4_T = 100,
  NPU0_CHIPLET0_T5_T = 101,
  NPU0_CHIPLET0_T6_T = 102,
  NPU0_CHIPLET1_T0_T = 103,
  NPU0_CHIPLET1_T1_T = 104,
  NPU0_CHIPLET1_T2_T = 105,
  NPU0_CHIPLET1_T3_T = 106,
  NPU0_CHIPLET1_T4_T = 107,
  NPU0_CHIPLET1_T5_T = 108,
  NPU0_CHIPLET1_T6_T = 109,
  NPU0_CHIPLET2_T0_T = 110,
  NPU0_CHIPLET2_T1_T = 111,
  NPU0_CHIPLET2_T2_T = 112,
  NPU0_CHIPLET2_T3_T = 113,
  NPU0_CHIPLET2_T4_T = 114,
  NPU0_CHIPLET2_T5_T = 115,
  NPU0_CHIPLET2_T6_T = 116,
  NPU0_CHIPLET3_T0_T = 117,
  NPU0_CHIPLET3_T1_T = 118,
  NPU0_CHIPLET3_T2_T = 119,
  NPU0_CHIPLET3_T3_T = 120,
  NPU0_CHIPLET3_T4_T = 121,
  NPU0_CHIPLET3_T5_T = 122,
  NPU0_CHIPLET3_T6_T = 123,
  NPU0_CHIPLET4_T0_T = 124,
  NPU0_CHIPLET4_T1_T = 125,
  NPU0_CHIPLET4_T2_T = 126,
  NPU0_CHIPLET4_T3_T = 127,
  NPU0_CHIPLET4_T4_T = 128,
  NPU0_CHIPLET4_T5_T = 129,
  NPU0_CHIPLET4_T6_T = 130,
  NPU0_CHIPLET5_T0_T = 131,
  NPU0_CHIPLET5_T1_T = 132,
  NPU0_CHIPLET5_T2_T = 133,
  NPU0_CHIPLET5_T3_T = 134,
  NPU0_CHIPLET5_T4_T = 135,
  NPU0_CHIPLET5_T5_T = 136,
  NPU0_CHIPLET5_T6_T = 137,
  NPU0_CHIPLET6_T0_T = 138,
  NPU0_CHIPLET6_T1_T = 139,
  NPU0_CHIPLET6_T2_T = 140,
  NPU0_CHIPLET6_T3_T = 141,
  NPU0_CHIPLET6_T4_T = 142,
  NPU0_CHIPLET6_T5_T = 143,
  NPU0_CHIPLET6_T6_T = 144,
  NPU0_CHIPLET7_T0_T = 145,
  NPU0_CHIPLET7_T1_T = 146,
  NPU0_CHIPLET7_T2_T = 147,
  NPU0_CHIPLET7_T3_T = 148,
  NPU0_CHIPLET7_T4_T = 149,
  NPU0_CHIPLET7_T5_T = 150,
  NPU0_CHIPLET7_T6_T = 151,
  NPU0_T0_T = 152,
  NPU0_T1_T = 153,
  NPU0_T2_T = 154,
  NPU0_T3_T = 155,
  NPU0_T4_T = 156,
  NPU0_T5_T = 157,
  NPU0_T6_T = 158,
  NPU0_T7_T = 159,
  NP_CVDDC_K0EXT_T = 160,
  NP_CVDDC_K0INT_T = 161,
  NP_CVDDC_K1EXT_T = 162,
  NP_CVDDC_K1INT_T = 163,
  NP_CVDDC_K2EXT_T = 164,
  NP_CVDDC_K2INT_T = 165,
  NP_FVDDA_K0EXT_T = 166,
  NP_FVDDA_K0INT_T = 167,
  NP_FVDDI_K1EXT_T = 168,
  NP_FVDD_K1INT_T = 169,
  NP_VDDA_K0EXT_T = 170,
  NP_VDDA_K0INT_T = 171,
  NP_VDDI_K0EXT_T = 172,
  NP_VDDI_K0INT_T = 173,
  NP_VDDM_K0EXT_T = 174,
  NP_VDDM_K0INT_T = 175,
  NP_VDDS_K0EXT_T = 176,
  NP_VDDS_K0INT_T = 177,
  P3V3_L_K0EXT_T = 178,
  P3V3_L_K0INT_T = 179,
  P3V3_R_K0EXT_T = 180,
  P3V3_R_K0INT_T = 181,
  SODIMM_0_TEMP_T = 182,
  TI_1PLUS1_TEMP_T = 183,
  TI_2PLUS1_TEMP_T = 184,
  U14_A_DIE_T = 185,
  U1_ADC0_A_DIE_T = 186,
  U1_ADC0_B_DIE_T = 187,
  U1_ADC1_A_DIE_T = 188,
  U1_ADC1_B_DIE_T = 189,
  SUNDOWN1 = 190,
  CPU_BOARD_TEMP = 191,
  CPU_CORE_TEMP_0 = 192,
  CPU_CORE_TEMP_1 = 193,
  CPU_CORE_TEMP_2 = 194,
  CPU_CORE_TEMP_3 = 195,
  FAN_BOARD_TEMP_0 = 196,
  FAN_BOARD_TEMP_1 = 197,
  SYS_TEMP = 198,
  UPPER_SYS_TEMP = 199,
  LEFT_TEMP = 200,
  RIGHT_TEMP = 201,
  MAC_UPPER_TEMP = 202,
  P3V3_OSFP_0 = 203,
  P3V3_OSFP_1 = 204,
  P3V3_OSFP_2 = 205,
  P3V3_OSFP_3 = 206,
  PVDDQ = 207,
  P0V72_VDD_T0 = 208,
  P0V72_VDD_T1 = 209,
  P0V72_VDD_T2 = 210,
  P0V72_VDD_T3 = 211,
  P0V72_VDD_T4 = 212,
  P0V72_VDD_T5 = 213,
  P0V72_VDD_T6 = 214,
  P0V72_VDD_T7 = 215,
  P0V75_VDDSCC = 216,
  P0V75_VDD_M = 217,
  P0V86_DVDD_M = 218,
  P0V86_DVDD_T0 = 219,
  P0V86_DVDD_T1 = 220,
  P0V86_DVDD_T2 = 221,
  P0V86_DVDD_T3 = 222,
  P0V86_DVDD_T4 = 223,
  P0V86_DVDD_T5 = 224,
  P0V86_DVDD_T6 = 225,
  P0V86_DVDD_T7 = 226,
  P1V05 = 227,
  P1V2_HVDD_T03 = 228,
  P1V2_HVDD_T47 = 229,
  P1V8 = 230,
  PVCCANA = 231,
  PVCCIN = 232,
  PVNN_NAC = 233,
  PVNN_PCH = 234,
  DIMM_TEMP = 235,
  MB_B2B_Connector = 236,
  UNRECOGNIZED = -1,
}

export function temperatureSensorsFromJSON(object: any): TemperatureSensors {
  switch (object) {
    case 0:
    case "INVALID_SENSOR":
      return TemperatureSensors.INVALID_SENSOR;
    case 1:
    case "ACPI":
      return TemperatureSensors.ACPI;
    case 2:
    case "CPU_U17_P1P05V_TEMP":
      return TemperatureSensors.CPU_U17_P1P05V_TEMP;
    case 3:
    case "CPU_U17_PVCCIN_TEMP":
      return TemperatureSensors.CPU_U17_PVCCIN_TEMP;
    case 4:
    case "CPU_U117_P1P2V_TEMP":
      return TemperatureSensors.CPU_U117_P1P2V_TEMP;
    case 5:
    case "CPU_U117_P1P05V_TEMP":
      return TemperatureSensors.CPU_U117_P1P05V_TEMP;
    case 6:
    case "DIMM_TEMP1":
      return TemperatureSensors.DIMM_TEMP1;
    case 7:
    case "DIMM_TEMP2":
      return TemperatureSensors.DIMM_TEMP2;
    case 8:
    case "FAN_Sensor":
      return TemperatureSensors.FAN_Sensor;
    case 9:
    case "MB_JM01_L1_TEMP":
      return TemperatureSensors.MB_JM01_L1_TEMP;
    case 10:
    case "MB_JM01_L2_TEMP":
      return TemperatureSensors.MB_JM01_L2_TEMP;
    case 11:
    case "MB_JM11_L1_TEMP":
      return TemperatureSensors.MB_JM11_L1_TEMP;
    case 12:
    case "MB_JM11_L2_TEMP":
      return TemperatureSensors.MB_JM11_L2_TEMP;
    case 13:
    case "MB_JM21_L1_TEMP":
      return TemperatureSensors.MB_JM21_L1_TEMP;
    case 14:
    case "MB_JM21_L2_TEMP":
      return TemperatureSensors.MB_JM21_L2_TEMP;
    case 15:
    case "MB_PORT_Sensor":
      return TemperatureSensors.MB_PORT_Sensor;
    case 16:
    case "MB_TMP421_Local":
      return TemperatureSensors.MB_TMP421_Local;
    case 17:
    case "PSU0HSNK_Temp":
      return TemperatureSensors.PSU0HSNK_Temp;
    case 18:
    case "PSU0Inlet_Temp":
      return TemperatureSensors.PSU0Inlet_Temp;
    case 19:
    case "PSU0Outlet_Temp":
      return TemperatureSensors.PSU0Outlet_Temp;
    case 20:
    case "PSU1HSNK_Temp":
      return TemperatureSensors.PSU1HSNK_Temp;
    case 21:
    case "PSU1Inlet_Temp":
      return TemperatureSensors.PSU1Inlet_Temp;
    case 22:
    case "PSU1Outlet_Temp":
      return TemperatureSensors.PSU1Outlet_Temp;
    case 23:
    case "SSD_Temp":
      return TemperatureSensors.SSD_Temp;
    case 24:
    case "X86_CORE_0_T":
      return TemperatureSensors.X86_CORE_0_T;
    case 25:
    case "X86_CORE_1_T":
      return TemperatureSensors.X86_CORE_1_T;
    case 26:
    case "X86_CORE_2_T":
      return TemperatureSensors.X86_CORE_2_T;
    case 27:
    case "X86_CORE_3_T":
      return TemperatureSensors.X86_CORE_3_T;
    case 28:
    case "X86_PKG_TEMP":
      return TemperatureSensors.X86_PKG_TEMP;
    case 29:
    case "MB_3_3V_R_VDDCK_TEMP_L1":
      return TemperatureSensors.MB_3_3V_R_VDDCK_TEMP_L1;
    case 30:
    case "MB_3_3V_R_VDDCK_TEMP_L2":
      return TemperatureSensors.MB_3_3V_R_VDDCK_TEMP_L2;
    case 31:
    case "MB_GB_CORE_TEMP_L1":
      return TemperatureSensors.MB_GB_CORE_TEMP_L1;
    case 32:
    case "MB_VDDS_VDDA_TEMP_L1":
      return TemperatureSensors.MB_VDDS_VDDA_TEMP_L1;
    case 33:
    case "MB_VDDS_VDDA_TEMP_L2":
      return TemperatureSensors.MB_VDDS_VDDA_TEMP_L2;
    case 34:
    case "PSU0HSNK_Temp1":
      return TemperatureSensors.PSU0HSNK_Temp1;
    case 35:
    case "PSU0HSNK_Temp2":
      return TemperatureSensors.PSU0HSNK_Temp2;
    case 36:
    case "PSU1HSNK_Temp1":
      return TemperatureSensors.PSU1HSNK_Temp1;
    case 37:
    case "PSU1HSNK_Temp2":
      return TemperatureSensors.PSU1HSNK_Temp2;
    case 38:
    case "NPU0_TEMP_0":
      return TemperatureSensors.NPU0_TEMP_0;
    case 39:
    case "NPU0_TEMP_1":
      return TemperatureSensors.NPU0_TEMP_1;
    case 40:
    case "NPU0_TEMP_2":
      return TemperatureSensors.NPU0_TEMP_2;
    case 41:
    case "NPU0_TEMP_3":
      return TemperatureSensors.NPU0_TEMP_3;
    case 42:
    case "NPU0_TEMP_4":
      return TemperatureSensors.NPU0_TEMP_4;
    case 43:
    case "NPU0_TEMP_5":
      return TemperatureSensors.NPU0_TEMP_5;
    case 44:
    case "NPU0_TEMP_6":
      return TemperatureSensors.NPU0_TEMP_6;
    case 45:
    case "NPU0_TEMP_7":
      return TemperatureSensors.NPU0_TEMP_7;
    case 46:
    case "NPU0_TEMP_8":
      return TemperatureSensors.NPU0_TEMP_8;
    case 47:
    case "NPU0_TEMP_9":
      return TemperatureSensors.NPU0_TEMP_9;
    case 48:
    case "NPU1_TEMP_0":
      return TemperatureSensors.NPU1_TEMP_0;
    case 49:
    case "NPU1_TEMP_1":
      return TemperatureSensors.NPU1_TEMP_1;
    case 50:
    case "NPU1_TEMP_2":
      return TemperatureSensors.NPU1_TEMP_2;
    case 51:
    case "NPU1_TEMP_3":
      return TemperatureSensors.NPU1_TEMP_3;
    case 52:
    case "NPU1_TEMP_4":
      return TemperatureSensors.NPU1_TEMP_4;
    case 53:
    case "NPU1_TEMP_5":
      return TemperatureSensors.NPU1_TEMP_5;
    case 54:
    case "NPU1_TEMP_6":
      return TemperatureSensors.NPU1_TEMP_6;
    case 55:
    case "NPU1_TEMP_7":
      return TemperatureSensors.NPU1_TEMP_7;
    case 56:
    case "NPU1_TEMP_8":
      return TemperatureSensors.NPU1_TEMP_8;
    case 57:
    case "NPU1_TEMP_9":
      return TemperatureSensors.NPU1_TEMP_9;
    case 58:
    case "NPU1_TEMP_10":
      return TemperatureSensors.NPU1_TEMP_10;
    case 59:
    case "PSU2HSNK_Temp":
      return TemperatureSensors.PSU2HSNK_Temp;
    case 60:
    case "PSU2Inlet_Temp":
      return TemperatureSensors.PSU2Inlet_Temp;
    case 61:
    case "PSU2Outlet_Temp":
      return TemperatureSensors.PSU2Outlet_Temp;
    case 62:
    case "X86_CORE_4_T":
      return TemperatureSensors.X86_CORE_4_T;
    case 63:
    case "CPU_BRD_T":
      return TemperatureSensors.CPU_BRD_T;
    case 64:
    case "CPU_CORE_TEMP_1_T":
      return TemperatureSensors.CPU_CORE_TEMP_1_T;
    case 65:
    case "CPU_CORE_TEMP_2_T":
      return TemperatureSensors.CPU_CORE_TEMP_2_T;
    case 66:
    case "CPU_CORE_TEMP_3_T":
      return TemperatureSensors.CPU_CORE_TEMP_3_T;
    case 67:
    case "CPU_CORE_TEMP_4_T":
      return TemperatureSensors.CPU_CORE_TEMP_4_T;
    case 68:
    case "CPU_CORE_TEMP_5_T":
      return TemperatureSensors.CPU_CORE_TEMP_5_T;
    case 69:
    case "CPU_CORE_TEMP_6_T":
      return TemperatureSensors.CPU_CORE_TEMP_6_T;
    case 70:
    case "CPU_CORE_TEMP_7_T":
      return TemperatureSensors.CPU_CORE_TEMP_7_T;
    case 71:
    case "CPU_CORE_TEMP_8_T":
      return TemperatureSensors.CPU_CORE_TEMP_8_T;
    case 72:
    case "CPU_PKG_TEMP_T":
      return TemperatureSensors.CPU_PKG_TEMP_T;
    case 73:
    case "FANIO_BRD_T":
      return TemperatureSensors.FANIO_BRD_T;
    case 74:
    case "MB_1_T":
      return TemperatureSensors.MB_1_T;
    case 75:
    case "MB_2_T":
      return TemperatureSensors.MB_2_T;
    case 76:
    case "MB_3_T":
      return TemperatureSensors.MB_3_T;
    case 77:
    case "NPU1_HBM_TEMP_1":
      return TemperatureSensors.NPU1_HBM_TEMP_1;
    case 78:
    case "NPU1_HBM_TEMP_2":
      return TemperatureSensors.NPU1_HBM_TEMP_2;
    case 79:
    case "SODIMM_1_TEMP_T":
      return TemperatureSensors.SODIMM_1_TEMP_T;
    case 80:
    case "SODIMM_2_TEMP_T":
      return TemperatureSensors.SODIMM_2_TEMP_T;
    case 81:
    case "SSD_TEMP_T":
      return TemperatureSensors.SSD_TEMP_T;
    case 82:
    case "XINDI_L_1_T":
      return TemperatureSensors.XINDI_L_1_T;
    case 83:
    case "XINDI_L_2_T":
      return TemperatureSensors.XINDI_L_2_T;
    case 84:
    case "XINDI_R_1_T":
      return TemperatureSensors.XINDI_R_1_T;
    case 85:
    case "XINDI_R_2_T":
      return TemperatureSensors.XINDI_R_2_T;
    case 86:
    case "G0_GB_CORE_L1_TEMP":
      return TemperatureSensors.G0_GB_CORE_L1_TEMP;
    case 87:
    case "MB_JM31_L1_TEMP":
      return TemperatureSensors.MB_JM31_L1_TEMP;
    case 88:
    case "MB_JM31_L2_TEMP":
      return TemperatureSensors.MB_JM31_L2_TEMP;
    case 89:
    case "BRD_OUTLET_TEMP_T":
      return TemperatureSensors.BRD_OUTLET_TEMP_T;
    case 90:
    case "CHAS_HOT_T_EXT_T":
      return TemperatureSensors.CHAS_HOT_T_EXT_T;
    case 91:
    case "CHAS_HOT_T_INT_T":
      return TemperatureSensors.CHAS_HOT_T_INT_T;
    case 92:
    case "CHAS_INLET_T_INT_T":
      return TemperatureSensors.CHAS_INLET_T_INT_T;
    case 93:
    case "IOB_Ambient_T":
      return TemperatureSensors.IOB_Ambient_T;
    case 94:
    case "LTC2979_A_TEMP_T":
      return TemperatureSensors.LTC2979_A_TEMP_T;
    case 95:
    case "LTC2979_B_TEMP_T":
      return TemperatureSensors.LTC2979_B_TEMP_T;
    case 96:
    case "NPU0_CHIPLET0_T0_T":
      return TemperatureSensors.NPU0_CHIPLET0_T0_T;
    case 97:
    case "NPU0_CHIPLET0_T1_T":
      return TemperatureSensors.NPU0_CHIPLET0_T1_T;
    case 98:
    case "NPU0_CHIPLET0_T2_T":
      return TemperatureSensors.NPU0_CHIPLET0_T2_T;
    case 99:
    case "NPU0_CHIPLET0_T3_T":
      return TemperatureSensors.NPU0_CHIPLET0_T3_T;
    case 100:
    case "NPU0_CHIPLET0_T4_T":
      return TemperatureSensors.NPU0_CHIPLET0_T4_T;
    case 101:
    case "NPU0_CHIPLET0_T5_T":
      return TemperatureSensors.NPU0_CHIPLET0_T5_T;
    case 102:
    case "NPU0_CHIPLET0_T6_T":
      return TemperatureSensors.NPU0_CHIPLET0_T6_T;
    case 103:
    case "NPU0_CHIPLET1_T0_T":
      return TemperatureSensors.NPU0_CHIPLET1_T0_T;
    case 104:
    case "NPU0_CHIPLET1_T1_T":
      return TemperatureSensors.NPU0_CHIPLET1_T1_T;
    case 105:
    case "NPU0_CHIPLET1_T2_T":
      return TemperatureSensors.NPU0_CHIPLET1_T2_T;
    case 106:
    case "NPU0_CHIPLET1_T3_T":
      return TemperatureSensors.NPU0_CHIPLET1_T3_T;
    case 107:
    case "NPU0_CHIPLET1_T4_T":
      return TemperatureSensors.NPU0_CHIPLET1_T4_T;
    case 108:
    case "NPU0_CHIPLET1_T5_T":
      return TemperatureSensors.NPU0_CHIPLET1_T5_T;
    case 109:
    case "NPU0_CHIPLET1_T6_T":
      return TemperatureSensors.NPU0_CHIPLET1_T6_T;
    case 110:
    case "NPU0_CHIPLET2_T0_T":
      return TemperatureSensors.NPU0_CHIPLET2_T0_T;
    case 111:
    case "NPU0_CHIPLET2_T1_T":
      return TemperatureSensors.NPU0_CHIPLET2_T1_T;
    case 112:
    case "NPU0_CHIPLET2_T2_T":
      return TemperatureSensors.NPU0_CHIPLET2_T2_T;
    case 113:
    case "NPU0_CHIPLET2_T3_T":
      return TemperatureSensors.NPU0_CHIPLET2_T3_T;
    case 114:
    case "NPU0_CHIPLET2_T4_T":
      return TemperatureSensors.NPU0_CHIPLET2_T4_T;
    case 115:
    case "NPU0_CHIPLET2_T5_T":
      return TemperatureSensors.NPU0_CHIPLET2_T5_T;
    case 116:
    case "NPU0_CHIPLET2_T6_T":
      return TemperatureSensors.NPU0_CHIPLET2_T6_T;
    case 117:
    case "NPU0_CHIPLET3_T0_T":
      return TemperatureSensors.NPU0_CHIPLET3_T0_T;
    case 118:
    case "NPU0_CHIPLET3_T1_T":
      return TemperatureSensors.NPU0_CHIPLET3_T1_T;
    case 119:
    case "NPU0_CHIPLET3_T2_T":
      return TemperatureSensors.NPU0_CHIPLET3_T2_T;
    case 120:
    case "NPU0_CHIPLET3_T3_T":
      return TemperatureSensors.NPU0_CHIPLET3_T3_T;
    case 121:
    case "NPU0_CHIPLET3_T4_T":
      return TemperatureSensors.NPU0_CHIPLET3_T4_T;
    case 122:
    case "NPU0_CHIPLET3_T5_T":
      return TemperatureSensors.NPU0_CHIPLET3_T5_T;
    case 123:
    case "NPU0_CHIPLET3_T6_T":
      return TemperatureSensors.NPU0_CHIPLET3_T6_T;
    case 124:
    case "NPU0_CHIPLET4_T0_T":
      return TemperatureSensors.NPU0_CHIPLET4_T0_T;
    case 125:
    case "NPU0_CHIPLET4_T1_T":
      return TemperatureSensors.NPU0_CHIPLET4_T1_T;
    case 126:
    case "NPU0_CHIPLET4_T2_T":
      return TemperatureSensors.NPU0_CHIPLET4_T2_T;
    case 127:
    case "NPU0_CHIPLET4_T3_T":
      return TemperatureSensors.NPU0_CHIPLET4_T3_T;
    case 128:
    case "NPU0_CHIPLET4_T4_T":
      return TemperatureSensors.NPU0_CHIPLET4_T4_T;
    case 129:
    case "NPU0_CHIPLET4_T5_T":
      return TemperatureSensors.NPU0_CHIPLET4_T5_T;
    case 130:
    case "NPU0_CHIPLET4_T6_T":
      return TemperatureSensors.NPU0_CHIPLET4_T6_T;
    case 131:
    case "NPU0_CHIPLET5_T0_T":
      return TemperatureSensors.NPU0_CHIPLET5_T0_T;
    case 132:
    case "NPU0_CHIPLET5_T1_T":
      return TemperatureSensors.NPU0_CHIPLET5_T1_T;
    case 133:
    case "NPU0_CHIPLET5_T2_T":
      return TemperatureSensors.NPU0_CHIPLET5_T2_T;
    case 134:
    case "NPU0_CHIPLET5_T3_T":
      return TemperatureSensors.NPU0_CHIPLET5_T3_T;
    case 135:
    case "NPU0_CHIPLET5_T4_T":
      return TemperatureSensors.NPU0_CHIPLET5_T4_T;
    case 136:
    case "NPU0_CHIPLET5_T5_T":
      return TemperatureSensors.NPU0_CHIPLET5_T5_T;
    case 137:
    case "NPU0_CHIPLET5_T6_T":
      return TemperatureSensors.NPU0_CHIPLET5_T6_T;
    case 138:
    case "NPU0_CHIPLET6_T0_T":
      return TemperatureSensors.NPU0_CHIPLET6_T0_T;
    case 139:
    case "NPU0_CHIPLET6_T1_T":
      return TemperatureSensors.NPU0_CHIPLET6_T1_T;
    case 140:
    case "NPU0_CHIPLET6_T2_T":
      return TemperatureSensors.NPU0_CHIPLET6_T2_T;
    case 141:
    case "NPU0_CHIPLET6_T3_T":
      return TemperatureSensors.NPU0_CHIPLET6_T3_T;
    case 142:
    case "NPU0_CHIPLET6_T4_T":
      return TemperatureSensors.NPU0_CHIPLET6_T4_T;
    case 143:
    case "NPU0_CHIPLET6_T5_T":
      return TemperatureSensors.NPU0_CHIPLET6_T5_T;
    case 144:
    case "NPU0_CHIPLET6_T6_T":
      return TemperatureSensors.NPU0_CHIPLET6_T6_T;
    case 145:
    case "NPU0_CHIPLET7_T0_T":
      return TemperatureSensors.NPU0_CHIPLET7_T0_T;
    case 146:
    case "NPU0_CHIPLET7_T1_T":
      return TemperatureSensors.NPU0_CHIPLET7_T1_T;
    case 147:
    case "NPU0_CHIPLET7_T2_T":
      return TemperatureSensors.NPU0_CHIPLET7_T2_T;
    case 148:
    case "NPU0_CHIPLET7_T3_T":
      return TemperatureSensors.NPU0_CHIPLET7_T3_T;
    case 149:
    case "NPU0_CHIPLET7_T4_T":
      return TemperatureSensors.NPU0_CHIPLET7_T4_T;
    case 150:
    case "NPU0_CHIPLET7_T5_T":
      return TemperatureSensors.NPU0_CHIPLET7_T5_T;
    case 151:
    case "NPU0_CHIPLET7_T6_T":
      return TemperatureSensors.NPU0_CHIPLET7_T6_T;
    case 152:
    case "NPU0_T0_T":
      return TemperatureSensors.NPU0_T0_T;
    case 153:
    case "NPU0_T1_T":
      return TemperatureSensors.NPU0_T1_T;
    case 154:
    case "NPU0_T2_T":
      return TemperatureSensors.NPU0_T2_T;
    case 155:
    case "NPU0_T3_T":
      return TemperatureSensors.NPU0_T3_T;
    case 156:
    case "NPU0_T4_T":
      return TemperatureSensors.NPU0_T4_T;
    case 157:
    case "NPU0_T5_T":
      return TemperatureSensors.NPU0_T5_T;
    case 158:
    case "NPU0_T6_T":
      return TemperatureSensors.NPU0_T6_T;
    case 159:
    case "NPU0_T7_T":
      return TemperatureSensors.NPU0_T7_T;
    case 160:
    case "NP_CVDDC_K0EXT_T":
      return TemperatureSensors.NP_CVDDC_K0EXT_T;
    case 161:
    case "NP_CVDDC_K0INT_T":
      return TemperatureSensors.NP_CVDDC_K0INT_T;
    case 162:
    case "NP_CVDDC_K1EXT_T":
      return TemperatureSensors.NP_CVDDC_K1EXT_T;
    case 163:
    case "NP_CVDDC_K1INT_T":
      return TemperatureSensors.NP_CVDDC_K1INT_T;
    case 164:
    case "NP_CVDDC_K2EXT_T":
      return TemperatureSensors.NP_CVDDC_K2EXT_T;
    case 165:
    case "NP_CVDDC_K2INT_T":
      return TemperatureSensors.NP_CVDDC_K2INT_T;
    case 166:
    case "NP_FVDDA_K0EXT_T":
      return TemperatureSensors.NP_FVDDA_K0EXT_T;
    case 167:
    case "NP_FVDDA_K0INT_T":
      return TemperatureSensors.NP_FVDDA_K0INT_T;
    case 168:
    case "NP_FVDDI_K1EXT_T":
      return TemperatureSensors.NP_FVDDI_K1EXT_T;
    case 169:
    case "NP_FVDD_K1INT_T":
      return TemperatureSensors.NP_FVDD_K1INT_T;
    case 170:
    case "NP_VDDA_K0EXT_T":
      return TemperatureSensors.NP_VDDA_K0EXT_T;
    case 171:
    case "NP_VDDA_K0INT_T":
      return TemperatureSensors.NP_VDDA_K0INT_T;
    case 172:
    case "NP_VDDI_K0EXT_T":
      return TemperatureSensors.NP_VDDI_K0EXT_T;
    case 173:
    case "NP_VDDI_K0INT_T":
      return TemperatureSensors.NP_VDDI_K0INT_T;
    case 174:
    case "NP_VDDM_K0EXT_T":
      return TemperatureSensors.NP_VDDM_K0EXT_T;
    case 175:
    case "NP_VDDM_K0INT_T":
      return TemperatureSensors.NP_VDDM_K0INT_T;
    case 176:
    case "NP_VDDS_K0EXT_T":
      return TemperatureSensors.NP_VDDS_K0EXT_T;
    case 177:
    case "NP_VDDS_K0INT_T":
      return TemperatureSensors.NP_VDDS_K0INT_T;
    case 178:
    case "P3V3_L_K0EXT_T":
      return TemperatureSensors.P3V3_L_K0EXT_T;
    case 179:
    case "P3V3_L_K0INT_T":
      return TemperatureSensors.P3V3_L_K0INT_T;
    case 180:
    case "P3V3_R_K0EXT_T":
      return TemperatureSensors.P3V3_R_K0EXT_T;
    case 181:
    case "P3V3_R_K0INT_T":
      return TemperatureSensors.P3V3_R_K0INT_T;
    case 182:
    case "SODIMM_0_TEMP_T":
      return TemperatureSensors.SODIMM_0_TEMP_T;
    case 183:
    case "TI_1PLUS1_TEMP_T":
      return TemperatureSensors.TI_1PLUS1_TEMP_T;
    case 184:
    case "TI_2PLUS1_TEMP_T":
      return TemperatureSensors.TI_2PLUS1_TEMP_T;
    case 185:
    case "U14_A_DIE_T":
      return TemperatureSensors.U14_A_DIE_T;
    case 186:
    case "U1_ADC0_A_DIE_T":
      return TemperatureSensors.U1_ADC0_A_DIE_T;
    case 187:
    case "U1_ADC0_B_DIE_T":
      return TemperatureSensors.U1_ADC0_B_DIE_T;
    case 188:
    case "U1_ADC1_A_DIE_T":
      return TemperatureSensors.U1_ADC1_A_DIE_T;
    case 189:
    case "U1_ADC1_B_DIE_T":
      return TemperatureSensors.U1_ADC1_B_DIE_T;
    case 190:
    case "SUNDOWN1":
      return TemperatureSensors.SUNDOWN1;
    case 191:
    case "CPU_BOARD_TEMP":
      return TemperatureSensors.CPU_BOARD_TEMP;
    case 192:
    case "CPU_CORE_TEMP_0":
      return TemperatureSensors.CPU_CORE_TEMP_0;
    case 193:
    case "CPU_CORE_TEMP_1":
      return TemperatureSensors.CPU_CORE_TEMP_1;
    case 194:
    case "CPU_CORE_TEMP_2":
      return TemperatureSensors.CPU_CORE_TEMP_2;
    case 195:
    case "CPU_CORE_TEMP_3":
      return TemperatureSensors.CPU_CORE_TEMP_3;
    case 196:
    case "FAN_BOARD_TEMP_0":
      return TemperatureSensors.FAN_BOARD_TEMP_0;
    case 197:
    case "FAN_BOARD_TEMP_1":
      return TemperatureSensors.FAN_BOARD_TEMP_1;
    case 198:
    case "SYS_TEMP":
      return TemperatureSensors.SYS_TEMP;
    case 199:
    case "UPPER_SYS_TEMP":
      return TemperatureSensors.UPPER_SYS_TEMP;
    case 200:
    case "LEFT_TEMP":
      return TemperatureSensors.LEFT_TEMP;
    case 201:
    case "RIGHT_TEMP":
      return TemperatureSensors.RIGHT_TEMP;
    case 202:
    case "MAC_UPPER_TEMP":
      return TemperatureSensors.MAC_UPPER_TEMP;
    case 203:
    case "P3V3_OSFP_0":
      return TemperatureSensors.P3V3_OSFP_0;
    case 204:
    case "P3V3_OSFP_1":
      return TemperatureSensors.P3V3_OSFP_1;
    case 205:
    case "P3V3_OSFP_2":
      return TemperatureSensors.P3V3_OSFP_2;
    case 206:
    case "P3V3_OSFP_3":
      return TemperatureSensors.P3V3_OSFP_3;
    case 207:
    case "PVDDQ":
      return TemperatureSensors.PVDDQ;
    case 208:
    case "P0V72_VDD_T0":
      return TemperatureSensors.P0V72_VDD_T0;
    case 209:
    case "P0V72_VDD_T1":
      return TemperatureSensors.P0V72_VDD_T1;
    case 210:
    case "P0V72_VDD_T2":
      return TemperatureSensors.P0V72_VDD_T2;
    case 211:
    case "P0V72_VDD_T3":
      return TemperatureSensors.P0V72_VDD_T3;
    case 212:
    case "P0V72_VDD_T4":
      return TemperatureSensors.P0V72_VDD_T4;
    case 213:
    case "P0V72_VDD_T5":
      return TemperatureSensors.P0V72_VDD_T5;
    case 214:
    case "P0V72_VDD_T6":
      return TemperatureSensors.P0V72_VDD_T6;
    case 215:
    case "P0V72_VDD_T7":
      return TemperatureSensors.P0V72_VDD_T7;
    case 216:
    case "P0V75_VDDSCC":
      return TemperatureSensors.P0V75_VDDSCC;
    case 217:
    case "P0V75_VDD_M":
      return TemperatureSensors.P0V75_VDD_M;
    case 218:
    case "P0V86_DVDD_M":
      return TemperatureSensors.P0V86_DVDD_M;
    case 219:
    case "P0V86_DVDD_T0":
      return TemperatureSensors.P0V86_DVDD_T0;
    case 220:
    case "P0V86_DVDD_T1":
      return TemperatureSensors.P0V86_DVDD_T1;
    case 221:
    case "P0V86_DVDD_T2":
      return TemperatureSensors.P0V86_DVDD_T2;
    case 222:
    case "P0V86_DVDD_T3":
      return TemperatureSensors.P0V86_DVDD_T3;
    case 223:
    case "P0V86_DVDD_T4":
      return TemperatureSensors.P0V86_DVDD_T4;
    case 224:
    case "P0V86_DVDD_T5":
      return TemperatureSensors.P0V86_DVDD_T5;
    case 225:
    case "P0V86_DVDD_T6":
      return TemperatureSensors.P0V86_DVDD_T6;
    case 226:
    case "P0V86_DVDD_T7":
      return TemperatureSensors.P0V86_DVDD_T7;
    case 227:
    case "P1V05":
      return TemperatureSensors.P1V05;
    case 228:
    case "P1V2_HVDD_T03":
      return TemperatureSensors.P1V2_HVDD_T03;
    case 229:
    case "P1V2_HVDD_T47":
      return TemperatureSensors.P1V2_HVDD_T47;
    case 230:
    case "P1V8":
      return TemperatureSensors.P1V8;
    case 231:
    case "PVCCANA":
      return TemperatureSensors.PVCCANA;
    case 232:
    case "PVCCIN":
      return TemperatureSensors.PVCCIN;
    case 233:
    case "PVNN_NAC":
      return TemperatureSensors.PVNN_NAC;
    case 234:
    case "PVNN_PCH":
      return TemperatureSensors.PVNN_PCH;
    case 235:
    case "DIMM_TEMP":
      return TemperatureSensors.DIMM_TEMP;
    case 236:
    case "MB_B2B_Connector":
      return TemperatureSensors.MB_B2B_Connector;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TemperatureSensors.UNRECOGNIZED;
  }
}

export function temperatureSensorsToJSON(object: TemperatureSensors): string {
  switch (object) {
    case TemperatureSensors.INVALID_SENSOR:
      return "INVALID_SENSOR";
    case TemperatureSensors.ACPI:
      return "ACPI";
    case TemperatureSensors.CPU_U17_P1P05V_TEMP:
      return "CPU_U17_P1P05V_TEMP";
    case TemperatureSensors.CPU_U17_PVCCIN_TEMP:
      return "CPU_U17_PVCCIN_TEMP";
    case TemperatureSensors.CPU_U117_P1P2V_TEMP:
      return "CPU_U117_P1P2V_TEMP";
    case TemperatureSensors.CPU_U117_P1P05V_TEMP:
      return "CPU_U117_P1P05V_TEMP";
    case TemperatureSensors.DIMM_TEMP1:
      return "DIMM_TEMP1";
    case TemperatureSensors.DIMM_TEMP2:
      return "DIMM_TEMP2";
    case TemperatureSensors.FAN_Sensor:
      return "FAN_Sensor";
    case TemperatureSensors.MB_JM01_L1_TEMP:
      return "MB_JM01_L1_TEMP";
    case TemperatureSensors.MB_JM01_L2_TEMP:
      return "MB_JM01_L2_TEMP";
    case TemperatureSensors.MB_JM11_L1_TEMP:
      return "MB_JM11_L1_TEMP";
    case TemperatureSensors.MB_JM11_L2_TEMP:
      return "MB_JM11_L2_TEMP";
    case TemperatureSensors.MB_JM21_L1_TEMP:
      return "MB_JM21_L1_TEMP";
    case TemperatureSensors.MB_JM21_L2_TEMP:
      return "MB_JM21_L2_TEMP";
    case TemperatureSensors.MB_PORT_Sensor:
      return "MB_PORT_Sensor";
    case TemperatureSensors.MB_TMP421_Local:
      return "MB_TMP421_Local";
    case TemperatureSensors.PSU0HSNK_Temp:
      return "PSU0HSNK_Temp";
    case TemperatureSensors.PSU0Inlet_Temp:
      return "PSU0Inlet_Temp";
    case TemperatureSensors.PSU0Outlet_Temp:
      return "PSU0Outlet_Temp";
    case TemperatureSensors.PSU1HSNK_Temp:
      return "PSU1HSNK_Temp";
    case TemperatureSensors.PSU1Inlet_Temp:
      return "PSU1Inlet_Temp";
    case TemperatureSensors.PSU1Outlet_Temp:
      return "PSU1Outlet_Temp";
    case TemperatureSensors.SSD_Temp:
      return "SSD_Temp";
    case TemperatureSensors.X86_CORE_0_T:
      return "X86_CORE_0_T";
    case TemperatureSensors.X86_CORE_1_T:
      return "X86_CORE_1_T";
    case TemperatureSensors.X86_CORE_2_T:
      return "X86_CORE_2_T";
    case TemperatureSensors.X86_CORE_3_T:
      return "X86_CORE_3_T";
    case TemperatureSensors.X86_PKG_TEMP:
      return "X86_PKG_TEMP";
    case TemperatureSensors.MB_3_3V_R_VDDCK_TEMP_L1:
      return "MB_3_3V_R_VDDCK_TEMP_L1";
    case TemperatureSensors.MB_3_3V_R_VDDCK_TEMP_L2:
      return "MB_3_3V_R_VDDCK_TEMP_L2";
    case TemperatureSensors.MB_GB_CORE_TEMP_L1:
      return "MB_GB_CORE_TEMP_L1";
    case TemperatureSensors.MB_VDDS_VDDA_TEMP_L1:
      return "MB_VDDS_VDDA_TEMP_L1";
    case TemperatureSensors.MB_VDDS_VDDA_TEMP_L2:
      return "MB_VDDS_VDDA_TEMP_L2";
    case TemperatureSensors.PSU0HSNK_Temp1:
      return "PSU0HSNK_Temp1";
    case TemperatureSensors.PSU0HSNK_Temp2:
      return "PSU0HSNK_Temp2";
    case TemperatureSensors.PSU1HSNK_Temp1:
      return "PSU1HSNK_Temp1";
    case TemperatureSensors.PSU1HSNK_Temp2:
      return "PSU1HSNK_Temp2";
    case TemperatureSensors.NPU0_TEMP_0:
      return "NPU0_TEMP_0";
    case TemperatureSensors.NPU0_TEMP_1:
      return "NPU0_TEMP_1";
    case TemperatureSensors.NPU0_TEMP_2:
      return "NPU0_TEMP_2";
    case TemperatureSensors.NPU0_TEMP_3:
      return "NPU0_TEMP_3";
    case TemperatureSensors.NPU0_TEMP_4:
      return "NPU0_TEMP_4";
    case TemperatureSensors.NPU0_TEMP_5:
      return "NPU0_TEMP_5";
    case TemperatureSensors.NPU0_TEMP_6:
      return "NPU0_TEMP_6";
    case TemperatureSensors.NPU0_TEMP_7:
      return "NPU0_TEMP_7";
    case TemperatureSensors.NPU0_TEMP_8:
      return "NPU0_TEMP_8";
    case TemperatureSensors.NPU0_TEMP_9:
      return "NPU0_TEMP_9";
    case TemperatureSensors.NPU1_TEMP_0:
      return "NPU1_TEMP_0";
    case TemperatureSensors.NPU1_TEMP_1:
      return "NPU1_TEMP_1";
    case TemperatureSensors.NPU1_TEMP_2:
      return "NPU1_TEMP_2";
    case TemperatureSensors.NPU1_TEMP_3:
      return "NPU1_TEMP_3";
    case TemperatureSensors.NPU1_TEMP_4:
      return "NPU1_TEMP_4";
    case TemperatureSensors.NPU1_TEMP_5:
      return "NPU1_TEMP_5";
    case TemperatureSensors.NPU1_TEMP_6:
      return "NPU1_TEMP_6";
    case TemperatureSensors.NPU1_TEMP_7:
      return "NPU1_TEMP_7";
    case TemperatureSensors.NPU1_TEMP_8:
      return "NPU1_TEMP_8";
    case TemperatureSensors.NPU1_TEMP_9:
      return "NPU1_TEMP_9";
    case TemperatureSensors.NPU1_TEMP_10:
      return "NPU1_TEMP_10";
    case TemperatureSensors.PSU2HSNK_Temp:
      return "PSU2HSNK_Temp";
    case TemperatureSensors.PSU2Inlet_Temp:
      return "PSU2Inlet_Temp";
    case TemperatureSensors.PSU2Outlet_Temp:
      return "PSU2Outlet_Temp";
    case TemperatureSensors.X86_CORE_4_T:
      return "X86_CORE_4_T";
    case TemperatureSensors.CPU_BRD_T:
      return "CPU_BRD_T";
    case TemperatureSensors.CPU_CORE_TEMP_1_T:
      return "CPU_CORE_TEMP_1_T";
    case TemperatureSensors.CPU_CORE_TEMP_2_T:
      return "CPU_CORE_TEMP_2_T";
    case TemperatureSensors.CPU_CORE_TEMP_3_T:
      return "CPU_CORE_TEMP_3_T";
    case TemperatureSensors.CPU_CORE_TEMP_4_T:
      return "CPU_CORE_TEMP_4_T";
    case TemperatureSensors.CPU_CORE_TEMP_5_T:
      return "CPU_CORE_TEMP_5_T";
    case TemperatureSensors.CPU_CORE_TEMP_6_T:
      return "CPU_CORE_TEMP_6_T";
    case TemperatureSensors.CPU_CORE_TEMP_7_T:
      return "CPU_CORE_TEMP_7_T";
    case TemperatureSensors.CPU_CORE_TEMP_8_T:
      return "CPU_CORE_TEMP_8_T";
    case TemperatureSensors.CPU_PKG_TEMP_T:
      return "CPU_PKG_TEMP_T";
    case TemperatureSensors.FANIO_BRD_T:
      return "FANIO_BRD_T";
    case TemperatureSensors.MB_1_T:
      return "MB_1_T";
    case TemperatureSensors.MB_2_T:
      return "MB_2_T";
    case TemperatureSensors.MB_3_T:
      return "MB_3_T";
    case TemperatureSensors.NPU1_HBM_TEMP_1:
      return "NPU1_HBM_TEMP_1";
    case TemperatureSensors.NPU1_HBM_TEMP_2:
      return "NPU1_HBM_TEMP_2";
    case TemperatureSensors.SODIMM_1_TEMP_T:
      return "SODIMM_1_TEMP_T";
    case TemperatureSensors.SODIMM_2_TEMP_T:
      return "SODIMM_2_TEMP_T";
    case TemperatureSensors.SSD_TEMP_T:
      return "SSD_TEMP_T";
    case TemperatureSensors.XINDI_L_1_T:
      return "XINDI_L_1_T";
    case TemperatureSensors.XINDI_L_2_T:
      return "XINDI_L_2_T";
    case TemperatureSensors.XINDI_R_1_T:
      return "XINDI_R_1_T";
    case TemperatureSensors.XINDI_R_2_T:
      return "XINDI_R_2_T";
    case TemperatureSensors.G0_GB_CORE_L1_TEMP:
      return "G0_GB_CORE_L1_TEMP";
    case TemperatureSensors.MB_JM31_L1_TEMP:
      return "MB_JM31_L1_TEMP";
    case TemperatureSensors.MB_JM31_L2_TEMP:
      return "MB_JM31_L2_TEMP";
    case TemperatureSensors.BRD_OUTLET_TEMP_T:
      return "BRD_OUTLET_TEMP_T";
    case TemperatureSensors.CHAS_HOT_T_EXT_T:
      return "CHAS_HOT_T_EXT_T";
    case TemperatureSensors.CHAS_HOT_T_INT_T:
      return "CHAS_HOT_T_INT_T";
    case TemperatureSensors.CHAS_INLET_T_INT_T:
      return "CHAS_INLET_T_INT_T";
    case TemperatureSensors.IOB_Ambient_T:
      return "IOB_Ambient_T";
    case TemperatureSensors.LTC2979_A_TEMP_T:
      return "LTC2979_A_TEMP_T";
    case TemperatureSensors.LTC2979_B_TEMP_T:
      return "LTC2979_B_TEMP_T";
    case TemperatureSensors.NPU0_CHIPLET0_T0_T:
      return "NPU0_CHIPLET0_T0_T";
    case TemperatureSensors.NPU0_CHIPLET0_T1_T:
      return "NPU0_CHIPLET0_T1_T";
    case TemperatureSensors.NPU0_CHIPLET0_T2_T:
      return "NPU0_CHIPLET0_T2_T";
    case TemperatureSensors.NPU0_CHIPLET0_T3_T:
      return "NPU0_CHIPLET0_T3_T";
    case TemperatureSensors.NPU0_CHIPLET0_T4_T:
      return "NPU0_CHIPLET0_T4_T";
    case TemperatureSensors.NPU0_CHIPLET0_T5_T:
      return "NPU0_CHIPLET0_T5_T";
    case TemperatureSensors.NPU0_CHIPLET0_T6_T:
      return "NPU0_CHIPLET0_T6_T";
    case TemperatureSensors.NPU0_CHIPLET1_T0_T:
      return "NPU0_CHIPLET1_T0_T";
    case TemperatureSensors.NPU0_CHIPLET1_T1_T:
      return "NPU0_CHIPLET1_T1_T";
    case TemperatureSensors.NPU0_CHIPLET1_T2_T:
      return "NPU0_CHIPLET1_T2_T";
    case TemperatureSensors.NPU0_CHIPLET1_T3_T:
      return "NPU0_CHIPLET1_T3_T";
    case TemperatureSensors.NPU0_CHIPLET1_T4_T:
      return "NPU0_CHIPLET1_T4_T";
    case TemperatureSensors.NPU0_CHIPLET1_T5_T:
      return "NPU0_CHIPLET1_T5_T";
    case TemperatureSensors.NPU0_CHIPLET1_T6_T:
      return "NPU0_CHIPLET1_T6_T";
    case TemperatureSensors.NPU0_CHIPLET2_T0_T:
      return "NPU0_CHIPLET2_T0_T";
    case TemperatureSensors.NPU0_CHIPLET2_T1_T:
      return "NPU0_CHIPLET2_T1_T";
    case TemperatureSensors.NPU0_CHIPLET2_T2_T:
      return "NPU0_CHIPLET2_T2_T";
    case TemperatureSensors.NPU0_CHIPLET2_T3_T:
      return "NPU0_CHIPLET2_T3_T";
    case TemperatureSensors.NPU0_CHIPLET2_T4_T:
      return "NPU0_CHIPLET2_T4_T";
    case TemperatureSensors.NPU0_CHIPLET2_T5_T:
      return "NPU0_CHIPLET2_T5_T";
    case TemperatureSensors.NPU0_CHIPLET2_T6_T:
      return "NPU0_CHIPLET2_T6_T";
    case TemperatureSensors.NPU0_CHIPLET3_T0_T:
      return "NPU0_CHIPLET3_T0_T";
    case TemperatureSensors.NPU0_CHIPLET3_T1_T:
      return "NPU0_CHIPLET3_T1_T";
    case TemperatureSensors.NPU0_CHIPLET3_T2_T:
      return "NPU0_CHIPLET3_T2_T";
    case TemperatureSensors.NPU0_CHIPLET3_T3_T:
      return "NPU0_CHIPLET3_T3_T";
    case TemperatureSensors.NPU0_CHIPLET3_T4_T:
      return "NPU0_CHIPLET3_T4_T";
    case TemperatureSensors.NPU0_CHIPLET3_T5_T:
      return "NPU0_CHIPLET3_T5_T";
    case TemperatureSensors.NPU0_CHIPLET3_T6_T:
      return "NPU0_CHIPLET3_T6_T";
    case TemperatureSensors.NPU0_CHIPLET4_T0_T:
      return "NPU0_CHIPLET4_T0_T";
    case TemperatureSensors.NPU0_CHIPLET4_T1_T:
      return "NPU0_CHIPLET4_T1_T";
    case TemperatureSensors.NPU0_CHIPLET4_T2_T:
      return "NPU0_CHIPLET4_T2_T";
    case TemperatureSensors.NPU0_CHIPLET4_T3_T:
      return "NPU0_CHIPLET4_T3_T";
    case TemperatureSensors.NPU0_CHIPLET4_T4_T:
      return "NPU0_CHIPLET4_T4_T";
    case TemperatureSensors.NPU0_CHIPLET4_T5_T:
      return "NPU0_CHIPLET4_T5_T";
    case TemperatureSensors.NPU0_CHIPLET4_T6_T:
      return "NPU0_CHIPLET4_T6_T";
    case TemperatureSensors.NPU0_CHIPLET5_T0_T:
      return "NPU0_CHIPLET5_T0_T";
    case TemperatureSensors.NPU0_CHIPLET5_T1_T:
      return "NPU0_CHIPLET5_T1_T";
    case TemperatureSensors.NPU0_CHIPLET5_T2_T:
      return "NPU0_CHIPLET5_T2_T";
    case TemperatureSensors.NPU0_CHIPLET5_T3_T:
      return "NPU0_CHIPLET5_T3_T";
    case TemperatureSensors.NPU0_CHIPLET5_T4_T:
      return "NPU0_CHIPLET5_T4_T";
    case TemperatureSensors.NPU0_CHIPLET5_T5_T:
      return "NPU0_CHIPLET5_T5_T";
    case TemperatureSensors.NPU0_CHIPLET5_T6_T:
      return "NPU0_CHIPLET5_T6_T";
    case TemperatureSensors.NPU0_CHIPLET6_T0_T:
      return "NPU0_CHIPLET6_T0_T";
    case TemperatureSensors.NPU0_CHIPLET6_T1_T:
      return "NPU0_CHIPLET6_T1_T";
    case TemperatureSensors.NPU0_CHIPLET6_T2_T:
      return "NPU0_CHIPLET6_T2_T";
    case TemperatureSensors.NPU0_CHIPLET6_T3_T:
      return "NPU0_CHIPLET6_T3_T";
    case TemperatureSensors.NPU0_CHIPLET6_T4_T:
      return "NPU0_CHIPLET6_T4_T";
    case TemperatureSensors.NPU0_CHIPLET6_T5_T:
      return "NPU0_CHIPLET6_T5_T";
    case TemperatureSensors.NPU0_CHIPLET6_T6_T:
      return "NPU0_CHIPLET6_T6_T";
    case TemperatureSensors.NPU0_CHIPLET7_T0_T:
      return "NPU0_CHIPLET7_T0_T";
    case TemperatureSensors.NPU0_CHIPLET7_T1_T:
      return "NPU0_CHIPLET7_T1_T";
    case TemperatureSensors.NPU0_CHIPLET7_T2_T:
      return "NPU0_CHIPLET7_T2_T";
    case TemperatureSensors.NPU0_CHIPLET7_T3_T:
      return "NPU0_CHIPLET7_T3_T";
    case TemperatureSensors.NPU0_CHIPLET7_T4_T:
      return "NPU0_CHIPLET7_T4_T";
    case TemperatureSensors.NPU0_CHIPLET7_T5_T:
      return "NPU0_CHIPLET7_T5_T";
    case TemperatureSensors.NPU0_CHIPLET7_T6_T:
      return "NPU0_CHIPLET7_T6_T";
    case TemperatureSensors.NPU0_T0_T:
      return "NPU0_T0_T";
    case TemperatureSensors.NPU0_T1_T:
      return "NPU0_T1_T";
    case TemperatureSensors.NPU0_T2_T:
      return "NPU0_T2_T";
    case TemperatureSensors.NPU0_T3_T:
      return "NPU0_T3_T";
    case TemperatureSensors.NPU0_T4_T:
      return "NPU0_T4_T";
    case TemperatureSensors.NPU0_T5_T:
      return "NPU0_T5_T";
    case TemperatureSensors.NPU0_T6_T:
      return "NPU0_T6_T";
    case TemperatureSensors.NPU0_T7_T:
      return "NPU0_T7_T";
    case TemperatureSensors.NP_CVDDC_K0EXT_T:
      return "NP_CVDDC_K0EXT_T";
    case TemperatureSensors.NP_CVDDC_K0INT_T:
      return "NP_CVDDC_K0INT_T";
    case TemperatureSensors.NP_CVDDC_K1EXT_T:
      return "NP_CVDDC_K1EXT_T";
    case TemperatureSensors.NP_CVDDC_K1INT_T:
      return "NP_CVDDC_K1INT_T";
    case TemperatureSensors.NP_CVDDC_K2EXT_T:
      return "NP_CVDDC_K2EXT_T";
    case TemperatureSensors.NP_CVDDC_K2INT_T:
      return "NP_CVDDC_K2INT_T";
    case TemperatureSensors.NP_FVDDA_K0EXT_T:
      return "NP_FVDDA_K0EXT_T";
    case TemperatureSensors.NP_FVDDA_K0INT_T:
      return "NP_FVDDA_K0INT_T";
    case TemperatureSensors.NP_FVDDI_K1EXT_T:
      return "NP_FVDDI_K1EXT_T";
    case TemperatureSensors.NP_FVDD_K1INT_T:
      return "NP_FVDD_K1INT_T";
    case TemperatureSensors.NP_VDDA_K0EXT_T:
      return "NP_VDDA_K0EXT_T";
    case TemperatureSensors.NP_VDDA_K0INT_T:
      return "NP_VDDA_K0INT_T";
    case TemperatureSensors.NP_VDDI_K0EXT_T:
      return "NP_VDDI_K0EXT_T";
    case TemperatureSensors.NP_VDDI_K0INT_T:
      return "NP_VDDI_K0INT_T";
    case TemperatureSensors.NP_VDDM_K0EXT_T:
      return "NP_VDDM_K0EXT_T";
    case TemperatureSensors.NP_VDDM_K0INT_T:
      return "NP_VDDM_K0INT_T";
    case TemperatureSensors.NP_VDDS_K0EXT_T:
      return "NP_VDDS_K0EXT_T";
    case TemperatureSensors.NP_VDDS_K0INT_T:
      return "NP_VDDS_K0INT_T";
    case TemperatureSensors.P3V3_L_K0EXT_T:
      return "P3V3_L_K0EXT_T";
    case TemperatureSensors.P3V3_L_K0INT_T:
      return "P3V3_L_K0INT_T";
    case TemperatureSensors.P3V3_R_K0EXT_T:
      return "P3V3_R_K0EXT_T";
    case TemperatureSensors.P3V3_R_K0INT_T:
      return "P3V3_R_K0INT_T";
    case TemperatureSensors.SODIMM_0_TEMP_T:
      return "SODIMM_0_TEMP_T";
    case TemperatureSensors.TI_1PLUS1_TEMP_T:
      return "TI_1PLUS1_TEMP_T";
    case TemperatureSensors.TI_2PLUS1_TEMP_T:
      return "TI_2PLUS1_TEMP_T";
    case TemperatureSensors.U14_A_DIE_T:
      return "U14_A_DIE_T";
    case TemperatureSensors.U1_ADC0_A_DIE_T:
      return "U1_ADC0_A_DIE_T";
    case TemperatureSensors.U1_ADC0_B_DIE_T:
      return "U1_ADC0_B_DIE_T";
    case TemperatureSensors.U1_ADC1_A_DIE_T:
      return "U1_ADC1_A_DIE_T";
    case TemperatureSensors.U1_ADC1_B_DIE_T:
      return "U1_ADC1_B_DIE_T";
    case TemperatureSensors.SUNDOWN1:
      return "SUNDOWN1";
    case TemperatureSensors.CPU_BOARD_TEMP:
      return "CPU_BOARD_TEMP";
    case TemperatureSensors.CPU_CORE_TEMP_0:
      return "CPU_CORE_TEMP_0";
    case TemperatureSensors.CPU_CORE_TEMP_1:
      return "CPU_CORE_TEMP_1";
    case TemperatureSensors.CPU_CORE_TEMP_2:
      return "CPU_CORE_TEMP_2";
    case TemperatureSensors.CPU_CORE_TEMP_3:
      return "CPU_CORE_TEMP_3";
    case TemperatureSensors.FAN_BOARD_TEMP_0:
      return "FAN_BOARD_TEMP_0";
    case TemperatureSensors.FAN_BOARD_TEMP_1:
      return "FAN_BOARD_TEMP_1";
    case TemperatureSensors.SYS_TEMP:
      return "SYS_TEMP";
    case TemperatureSensors.UPPER_SYS_TEMP:
      return "UPPER_SYS_TEMP";
    case TemperatureSensors.LEFT_TEMP:
      return "LEFT_TEMP";
    case TemperatureSensors.RIGHT_TEMP:
      return "RIGHT_TEMP";
    case TemperatureSensors.MAC_UPPER_TEMP:
      return "MAC_UPPER_TEMP";
    case TemperatureSensors.P3V3_OSFP_0:
      return "P3V3_OSFP_0";
    case TemperatureSensors.P3V3_OSFP_1:
      return "P3V3_OSFP_1";
    case TemperatureSensors.P3V3_OSFP_2:
      return "P3V3_OSFP_2";
    case TemperatureSensors.P3V3_OSFP_3:
      return "P3V3_OSFP_3";
    case TemperatureSensors.PVDDQ:
      return "PVDDQ";
    case TemperatureSensors.P0V72_VDD_T0:
      return "P0V72_VDD_T0";
    case TemperatureSensors.P0V72_VDD_T1:
      return "P0V72_VDD_T1";
    case TemperatureSensors.P0V72_VDD_T2:
      return "P0V72_VDD_T2";
    case TemperatureSensors.P0V72_VDD_T3:
      return "P0V72_VDD_T3";
    case TemperatureSensors.P0V72_VDD_T4:
      return "P0V72_VDD_T4";
    case TemperatureSensors.P0V72_VDD_T5:
      return "P0V72_VDD_T5";
    case TemperatureSensors.P0V72_VDD_T6:
      return "P0V72_VDD_T6";
    case TemperatureSensors.P0V72_VDD_T7:
      return "P0V72_VDD_T7";
    case TemperatureSensors.P0V75_VDDSCC:
      return "P0V75_VDDSCC";
    case TemperatureSensors.P0V75_VDD_M:
      return "P0V75_VDD_M";
    case TemperatureSensors.P0V86_DVDD_M:
      return "P0V86_DVDD_M";
    case TemperatureSensors.P0V86_DVDD_T0:
      return "P0V86_DVDD_T0";
    case TemperatureSensors.P0V86_DVDD_T1:
      return "P0V86_DVDD_T1";
    case TemperatureSensors.P0V86_DVDD_T2:
      return "P0V86_DVDD_T2";
    case TemperatureSensors.P0V86_DVDD_T3:
      return "P0V86_DVDD_T3";
    case TemperatureSensors.P0V86_DVDD_T4:
      return "P0V86_DVDD_T4";
    case TemperatureSensors.P0V86_DVDD_T5:
      return "P0V86_DVDD_T5";
    case TemperatureSensors.P0V86_DVDD_T6:
      return "P0V86_DVDD_T6";
    case TemperatureSensors.P0V86_DVDD_T7:
      return "P0V86_DVDD_T7";
    case TemperatureSensors.P1V05:
      return "P1V05";
    case TemperatureSensors.P1V2_HVDD_T03:
      return "P1V2_HVDD_T03";
    case TemperatureSensors.P1V2_HVDD_T47:
      return "P1V2_HVDD_T47";
    case TemperatureSensors.P1V8:
      return "P1V8";
    case TemperatureSensors.PVCCANA:
      return "PVCCANA";
    case TemperatureSensors.PVCCIN:
      return "PVCCIN";
    case TemperatureSensors.PVNN_NAC:
      return "PVNN_NAC";
    case TemperatureSensors.PVNN_PCH:
      return "PVNN_PCH";
    case TemperatureSensors.DIMM_TEMP:
      return "DIMM_TEMP";
    case TemperatureSensors.MB_B2B_Connector:
      return "MB_B2B_Connector";
    case TemperatureSensors.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum HostName {
  HOST_NAME_UNSPECIFIED = 0,
  UNRECOGNIZED = -1,
}

export function hostNameFromJSON(object: any): HostName {
  switch (object) {
    case 0:
    case "HOST_NAME_UNSPECIFIED":
      return HostName.HOST_NAME_UNSPECIFIED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HostName.UNRECOGNIZED;
  }
}

export function hostNameToJSON(object: HostName): string {
  switch (object) {
    case HostName.HOST_NAME_UNSPECIFIED:
      return "HOST_NAME_UNSPECIFIED";
    case HostName.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ApplicationIdentity {
  APPLICATION_IDENTITY_UNSPECIFIED = 0,
  APPLICATION_IDENTITY_BILGE = 1,
  APPLICATION_IDENTITY_BRIG = 2,
  APPLICATION_IDENTITY_CONFIGD = 3,
  APPLICATION_IDENTITY_SEXTANT = 4,
  APPLICATION_IDENTITY_MIZZEN = 5,
  APPLICATION_IDENTITY_RUDDER = 6,
  APPLICATION_IDENTITY_FRED = 7,
  APPLICATION_IDENTITY_GINGER = 8,
  UNRECOGNIZED = -1,
}

export function applicationIdentityFromJSON(object: any): ApplicationIdentity {
  switch (object) {
    case 0:
    case "APPLICATION_IDENTITY_UNSPECIFIED":
      return ApplicationIdentity.APPLICATION_IDENTITY_UNSPECIFIED;
    case 1:
    case "APPLICATION_IDENTITY_BILGE":
      return ApplicationIdentity.APPLICATION_IDENTITY_BILGE;
    case 2:
    case "APPLICATION_IDENTITY_BRIG":
      return ApplicationIdentity.APPLICATION_IDENTITY_BRIG;
    case 3:
    case "APPLICATION_IDENTITY_CONFIGD":
      return ApplicationIdentity.APPLICATION_IDENTITY_CONFIGD;
    case 4:
    case "APPLICATION_IDENTITY_SEXTANT":
      return ApplicationIdentity.APPLICATION_IDENTITY_SEXTANT;
    case 5:
    case "APPLICATION_IDENTITY_MIZZEN":
      return ApplicationIdentity.APPLICATION_IDENTITY_MIZZEN;
    case 6:
    case "APPLICATION_IDENTITY_RUDDER":
      return ApplicationIdentity.APPLICATION_IDENTITY_RUDDER;
    case 7:
    case "APPLICATION_IDENTITY_FRED":
      return ApplicationIdentity.APPLICATION_IDENTITY_FRED;
    case 8:
    case "APPLICATION_IDENTITY_GINGER":
      return ApplicationIdentity.APPLICATION_IDENTITY_GINGER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ApplicationIdentity.UNRECOGNIZED;
  }
}

export function applicationIdentityToJSON(object: ApplicationIdentity): string {
  switch (object) {
    case ApplicationIdentity.APPLICATION_IDENTITY_UNSPECIFIED:
      return "APPLICATION_IDENTITY_UNSPECIFIED";
    case ApplicationIdentity.APPLICATION_IDENTITY_BILGE:
      return "APPLICATION_IDENTITY_BILGE";
    case ApplicationIdentity.APPLICATION_IDENTITY_BRIG:
      return "APPLICATION_IDENTITY_BRIG";
    case ApplicationIdentity.APPLICATION_IDENTITY_CONFIGD:
      return "APPLICATION_IDENTITY_CONFIGD";
    case ApplicationIdentity.APPLICATION_IDENTITY_SEXTANT:
      return "APPLICATION_IDENTITY_SEXTANT";
    case ApplicationIdentity.APPLICATION_IDENTITY_MIZZEN:
      return "APPLICATION_IDENTITY_MIZZEN";
    case ApplicationIdentity.APPLICATION_IDENTITY_RUDDER:
      return "APPLICATION_IDENTITY_RUDDER";
    case ApplicationIdentity.APPLICATION_IDENTITY_FRED:
      return "APPLICATION_IDENTITY_FRED";
    case ApplicationIdentity.APPLICATION_IDENTITY_GINGER:
      return "APPLICATION_IDENTITY_GINGER";
    case ApplicationIdentity.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ResourceType {
  RESOURCE_TYPE_UNSPECIFIED = 0,
  RESOURCE_TYPE_FABRIC = 1,
  RESOURCE_TYPE_ORG = 2,
  UNRECOGNIZED = -1,
}

export function resourceTypeFromJSON(object: any): ResourceType {
  switch (object) {
    case 0:
    case "RESOURCE_TYPE_UNSPECIFIED":
      return ResourceType.RESOURCE_TYPE_UNSPECIFIED;
    case 1:
    case "RESOURCE_TYPE_FABRIC":
      return ResourceType.RESOURCE_TYPE_FABRIC;
    case 2:
    case "RESOURCE_TYPE_ORG":
      return ResourceType.RESOURCE_TYPE_ORG;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ResourceType.UNRECOGNIZED;
  }
}

export function resourceTypeToJSON(object: ResourceType): string {
  switch (object) {
    case ResourceType.RESOURCE_TYPE_UNSPECIFIED:
      return "RESOURCE_TYPE_UNSPECIFIED";
    case ResourceType.RESOURCE_TYPE_FABRIC:
      return "RESOURCE_TYPE_FABRIC";
    case ResourceType.RESOURCE_TYPE_ORG:
      return "RESOURCE_TYPE_ORG";
    case ResourceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AssignmentState {
  AssignmentStateUnknown = 0,
  AssignmentStateStandby = 1,
  AssignmentStateActive = 2,
  AssignmentStateLoading = 3,
  /** AssignmentStateUnassigned - Instance has discovered a resource that has no assignment */
  AssignmentStateUnassigned = 4,
  /** AssignmentStateDeleted - Instance was assigned a resource but that resource should be deleted */
  AssignmentStateDeleted = 5,
  UNRECOGNIZED = -1,
}

export function assignmentStateFromJSON(object: any): AssignmentState {
  switch (object) {
    case 0:
    case "AssignmentStateUnknown":
      return AssignmentState.AssignmentStateUnknown;
    case 1:
    case "AssignmentStateStandby":
      return AssignmentState.AssignmentStateStandby;
    case 2:
    case "AssignmentStateActive":
      return AssignmentState.AssignmentStateActive;
    case 3:
    case "AssignmentStateLoading":
      return AssignmentState.AssignmentStateLoading;
    case 4:
    case "AssignmentStateUnassigned":
      return AssignmentState.AssignmentStateUnassigned;
    case 5:
    case "AssignmentStateDeleted":
      return AssignmentState.AssignmentStateDeleted;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssignmentState.UNRECOGNIZED;
  }
}

export function assignmentStateToJSON(object: AssignmentState): string {
  switch (object) {
    case AssignmentState.AssignmentStateUnknown:
      return "AssignmentStateUnknown";
    case AssignmentState.AssignmentStateStandby:
      return "AssignmentStateStandby";
    case AssignmentState.AssignmentStateActive:
      return "AssignmentStateActive";
    case AssignmentState.AssignmentStateLoading:
      return "AssignmentStateLoading";
    case AssignmentState.AssignmentStateUnassigned:
      return "AssignmentStateUnassigned";
    case AssignmentState.AssignmentStateDeleted:
      return "AssignmentStateDeleted";
    case AssignmentState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FabricEvent {
  FABRIC_EVENT_UNSPECIFIED = 0,
  FABRIC_EVENT_ADD_DEVICE = 1,
  FABRIC_EVENT_REMOVE_DEVICE = 2,
  FABRIC_EVENT_BIND_DEVICE = 3,
  FABRIC_EVENT_UNBIND_DEVICE = 4,
  UNRECOGNIZED = -1,
}

export function fabricEventFromJSON(object: any): FabricEvent {
  switch (object) {
    case 0:
    case "FABRIC_EVENT_UNSPECIFIED":
      return FabricEvent.FABRIC_EVENT_UNSPECIFIED;
    case 1:
    case "FABRIC_EVENT_ADD_DEVICE":
      return FabricEvent.FABRIC_EVENT_ADD_DEVICE;
    case 2:
    case "FABRIC_EVENT_REMOVE_DEVICE":
      return FabricEvent.FABRIC_EVENT_REMOVE_DEVICE;
    case 3:
    case "FABRIC_EVENT_BIND_DEVICE":
      return FabricEvent.FABRIC_EVENT_BIND_DEVICE;
    case 4:
    case "FABRIC_EVENT_UNBIND_DEVICE":
      return FabricEvent.FABRIC_EVENT_UNBIND_DEVICE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FabricEvent.UNRECOGNIZED;
  }
}

export function fabricEventToJSON(object: FabricEvent): string {
  switch (object) {
    case FabricEvent.FABRIC_EVENT_UNSPECIFIED:
      return "FABRIC_EVENT_UNSPECIFIED";
    case FabricEvent.FABRIC_EVENT_ADD_DEVICE:
      return "FABRIC_EVENT_ADD_DEVICE";
    case FabricEvent.FABRIC_EVENT_REMOVE_DEVICE:
      return "FABRIC_EVENT_REMOVE_DEVICE";
    case FabricEvent.FABRIC_EVENT_BIND_DEVICE:
      return "FABRIC_EVENT_BIND_DEVICE";
    case FabricEvent.FABRIC_EVENT_UNBIND_DEVICE:
      return "FABRIC_EVENT_UNBIND_DEVICE";
    case FabricEvent.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** EnvStatus defines an enumeration of hardware operational states. */
export enum EnvStatus {
  ENV_STATUS_UNSPECIFIED = 0,
  OK = 1,
  NOT_OK = 2,
  WARNING = 3,
  NOT_PRESENT = 4,
  UNRECOGNIZED = -1,
}

export function envStatusFromJSON(object: any): EnvStatus {
  switch (object) {
    case 0:
    case "ENV_STATUS_UNSPECIFIED":
      return EnvStatus.ENV_STATUS_UNSPECIFIED;
    case 1:
    case "OK":
      return EnvStatus.OK;
    case 2:
    case "NOT_OK":
      return EnvStatus.NOT_OK;
    case 3:
    case "WARNING":
      return EnvStatus.WARNING;
    case 4:
    case "NOT_PRESENT":
      return EnvStatus.NOT_PRESENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EnvStatus.UNRECOGNIZED;
  }
}

export function envStatusToJSON(object: EnvStatus): string {
  switch (object) {
    case EnvStatus.ENV_STATUS_UNSPECIFIED:
      return "ENV_STATUS_UNSPECIFIED";
    case EnvStatus.OK:
      return "OK";
    case EnvStatus.NOT_OK:
      return "NOT_OK";
    case EnvStatus.WARNING:
      return "WARNING";
    case EnvStatus.NOT_PRESENT:
      return "NOT_PRESENT";
    case EnvStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** EnvLedStatus defines an enumeration of LED states. */
export enum EnvLedStatus {
  ENV_LED_STATUS_UNSPECIFIED = 0,
  GREEN = 1,
  RED = 2,
  OFF = 3,
  AMBER = 4,
  UNRECOGNIZED = -1,
}

export function envLedStatusFromJSON(object: any): EnvLedStatus {
  switch (object) {
    case 0:
    case "ENV_LED_STATUS_UNSPECIFIED":
      return EnvLedStatus.ENV_LED_STATUS_UNSPECIFIED;
    case 1:
    case "GREEN":
      return EnvLedStatus.GREEN;
    case 2:
    case "RED":
      return EnvLedStatus.RED;
    case 3:
    case "OFF":
      return EnvLedStatus.OFF;
    case 4:
    case "AMBER":
      return EnvLedStatus.AMBER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EnvLedStatus.UNRECOGNIZED;
  }
}

export function envLedStatusToJSON(object: EnvLedStatus): string {
  switch (object) {
    case EnvLedStatus.ENV_LED_STATUS_UNSPECIFIED:
      return "ENV_LED_STATUS_UNSPECIFIED";
    case EnvLedStatus.GREEN:
      return "GREEN";
    case EnvLedStatus.RED:
      return "RED";
    case EnvLedStatus.OFF:
      return "OFF";
    case EnvLedStatus.AMBER:
      return "AMBER";
    case EnvLedStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * FanDirection defines an enumeration of airflow directions for of Fan.
 * The airflow direction is relative to the port-side.
 */
export enum FanDirection {
  FAN_DIRECTION_UNSPECIFIED = 0,
  INTAKE = 1,
  EXHAUST = 2,
  UNRECOGNIZED = -1,
}

export function fanDirectionFromJSON(object: any): FanDirection {
  switch (object) {
    case 0:
    case "FAN_DIRECTION_UNSPECIFIED":
      return FanDirection.FAN_DIRECTION_UNSPECIFIED;
    case 1:
    case "INTAKE":
      return FanDirection.INTAKE;
    case 2:
    case "EXHAUST":
      return FanDirection.EXHAUST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FanDirection.UNRECOGNIZED;
  }
}

export function fanDirectionToJSON(object: FanDirection): string {
  switch (object) {
    case FanDirection.FAN_DIRECTION_UNSPECIFIED:
      return "FAN_DIRECTION_UNSPECIFIED";
    case FanDirection.INTAKE:
      return "INTAKE";
    case FanDirection.EXHAUST:
      return "EXHAUST";
    case FanDirection.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** DEPRECATED */
export enum LLDPSysCapabilityType {
  LLDP_SYS_CAPABILITY_TYPE_UNSPECIFIED = 0,
  REPEATER = 1,
  BRIDGE = 2,
  WLAN = 3,
  ROUTER = 4,
  TELEPHONE = 5,
  DOCSIS_CABLE_DEVICE = 6,
  STATION = 7,
  UNRECOGNIZED = -1,
}

export function lLDPSysCapabilityTypeFromJSON(object: any): LLDPSysCapabilityType {
  switch (object) {
    case 0:
    case "LLDP_SYS_CAPABILITY_TYPE_UNSPECIFIED":
      return LLDPSysCapabilityType.LLDP_SYS_CAPABILITY_TYPE_UNSPECIFIED;
    case 1:
    case "REPEATER":
      return LLDPSysCapabilityType.REPEATER;
    case 2:
    case "BRIDGE":
      return LLDPSysCapabilityType.BRIDGE;
    case 3:
    case "WLAN":
      return LLDPSysCapabilityType.WLAN;
    case 4:
    case "ROUTER":
      return LLDPSysCapabilityType.ROUTER;
    case 5:
    case "TELEPHONE":
      return LLDPSysCapabilityType.TELEPHONE;
    case 6:
    case "DOCSIS_CABLE_DEVICE":
      return LLDPSysCapabilityType.DOCSIS_CABLE_DEVICE;
    case 7:
    case "STATION":
      return LLDPSysCapabilityType.STATION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LLDPSysCapabilityType.UNRECOGNIZED;
  }
}

export function lLDPSysCapabilityTypeToJSON(object: LLDPSysCapabilityType): string {
  switch (object) {
    case LLDPSysCapabilityType.LLDP_SYS_CAPABILITY_TYPE_UNSPECIFIED:
      return "LLDP_SYS_CAPABILITY_TYPE_UNSPECIFIED";
    case LLDPSysCapabilityType.REPEATER:
      return "REPEATER";
    case LLDPSysCapabilityType.BRIDGE:
      return "BRIDGE";
    case LLDPSysCapabilityType.WLAN:
      return "WLAN";
    case LLDPSysCapabilityType.ROUTER:
      return "ROUTER";
    case LLDPSysCapabilityType.TELEPHONE:
      return "TELEPHONE";
    case LLDPSysCapabilityType.DOCSIS_CABLE_DEVICE:
      return "DOCSIS_CABLE_DEVICE";
    case LLDPSysCapabilityType.STATION:
      return "STATION";
    case LLDPSysCapabilityType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum LLDPRemoteDeviceHostSubType {
  LLDP_REMOTE_DEVICE_HOST_SUB_TYPE_UNSPECIFIED = 0,
  IF_ALIAS = 1,
  LOCAL = 2,
  MAC = 3,
  IP = 4,
  IFNAME = 5,
  UNRECOGNIZED = -1,
}

export function lLDPRemoteDeviceHostSubTypeFromJSON(object: any): LLDPRemoteDeviceHostSubType {
  switch (object) {
    case 0:
    case "LLDP_REMOTE_DEVICE_HOST_SUB_TYPE_UNSPECIFIED":
      return LLDPRemoteDeviceHostSubType.LLDP_REMOTE_DEVICE_HOST_SUB_TYPE_UNSPECIFIED;
    case 1:
    case "IF_ALIAS":
      return LLDPRemoteDeviceHostSubType.IF_ALIAS;
    case 2:
    case "LOCAL":
      return LLDPRemoteDeviceHostSubType.LOCAL;
    case 3:
    case "MAC":
      return LLDPRemoteDeviceHostSubType.MAC;
    case 4:
    case "IP":
      return LLDPRemoteDeviceHostSubType.IP;
    case 5:
    case "IFNAME":
      return LLDPRemoteDeviceHostSubType.IFNAME;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LLDPRemoteDeviceHostSubType.UNRECOGNIZED;
  }
}

export function lLDPRemoteDeviceHostSubTypeToJSON(object: LLDPRemoteDeviceHostSubType): string {
  switch (object) {
    case LLDPRemoteDeviceHostSubType.LLDP_REMOTE_DEVICE_HOST_SUB_TYPE_UNSPECIFIED:
      return "LLDP_REMOTE_DEVICE_HOST_SUB_TYPE_UNSPECIFIED";
    case LLDPRemoteDeviceHostSubType.IF_ALIAS:
      return "IF_ALIAS";
    case LLDPRemoteDeviceHostSubType.LOCAL:
      return "LOCAL";
    case LLDPRemoteDeviceHostSubType.MAC:
      return "MAC";
    case LLDPRemoteDeviceHostSubType.IP:
      return "IP";
    case LLDPRemoteDeviceHostSubType.IFNAME:
      return "IFNAME";
    case LLDPRemoteDeviceHostSubType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum L3TableEntrySource {
  L3_TABLE_IP_SOURCE_UNSPECIFIED = 0,
  ARP = 1,
  ND = 2,
  UNRECOGNIZED = -1,
}

export function l3TableEntrySourceFromJSON(object: any): L3TableEntrySource {
  switch (object) {
    case 0:
    case "L3_TABLE_IP_SOURCE_UNSPECIFIED":
      return L3TableEntrySource.L3_TABLE_IP_SOURCE_UNSPECIFIED;
    case 1:
    case "ARP":
      return L3TableEntrySource.ARP;
    case 2:
    case "ND":
      return L3TableEntrySource.ND;
    case -1:
    case "UNRECOGNIZED":
    default:
      return L3TableEntrySource.UNRECOGNIZED;
  }
}

export function l3TableEntrySourceToJSON(object: L3TableEntrySource): string {
  switch (object) {
    case L3TableEntrySource.L3_TABLE_IP_SOURCE_UNSPECIFIED:
      return "L3_TABLE_IP_SOURCE_UNSPECIFIED";
    case L3TableEntrySource.ARP:
      return "ARP";
    case L3TableEntrySource.ND:
      return "ND";
    case L3TableEntrySource.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpIdType {
  BGP_ID_TYPE_UNSPECIFIED = 0,
  IPV6 = 1,
  IPV4 = 2,
  INTERFACE = 3,
  UNRECOGNIZED = -1,
}

export function bgpIdTypeFromJSON(object: any): BgpIdType {
  switch (object) {
    case 0:
    case "BGP_ID_TYPE_UNSPECIFIED":
      return BgpIdType.BGP_ID_TYPE_UNSPECIFIED;
    case 1:
    case "IPV6":
      return BgpIdType.IPV6;
    case 2:
    case "IPV4":
      return BgpIdType.IPV4;
    case 3:
    case "INTERFACE":
      return BgpIdType.INTERFACE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpIdType.UNRECOGNIZED;
  }
}

export function bgpIdTypeToJSON(object: BgpIdType): string {
  switch (object) {
    case BgpIdType.BGP_ID_TYPE_UNSPECIFIED:
      return "BGP_ID_TYPE_UNSPECIFIED";
    case BgpIdType.IPV6:
      return "IPV6";
    case BgpIdType.IPV4:
      return "IPV4";
    case BgpIdType.INTERFACE:
      return "INTERFACE";
    case BgpIdType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpPeerConnectionState {
  BGP_PEER_CONNECTION_STATE_UNSPECIFIED = 0,
  ESTABLISHED = 1,
  NOT_ESTABLISHED = 2,
  IDLE = 3,
  CONNECT = 4,
  OPEN_SENT = 5,
  OPEN_CONFIRM = 6,
  BGP_STATE_ACTIVE = 7,
  BGP_STATE_CLEARING = 8,
  BGP_STATE_DELETED = 9,
  UNRECOGNIZED = -1,
}

export function bgpPeerConnectionStateFromJSON(object: any): BgpPeerConnectionState {
  switch (object) {
    case 0:
    case "BGP_PEER_CONNECTION_STATE_UNSPECIFIED":
      return BgpPeerConnectionState.BGP_PEER_CONNECTION_STATE_UNSPECIFIED;
    case 1:
    case "ESTABLISHED":
      return BgpPeerConnectionState.ESTABLISHED;
    case 2:
    case "NOT_ESTABLISHED":
      return BgpPeerConnectionState.NOT_ESTABLISHED;
    case 3:
    case "IDLE":
      return BgpPeerConnectionState.IDLE;
    case 4:
    case "CONNECT":
      return BgpPeerConnectionState.CONNECT;
    case 5:
    case "OPEN_SENT":
      return BgpPeerConnectionState.OPEN_SENT;
    case 6:
    case "OPEN_CONFIRM":
      return BgpPeerConnectionState.OPEN_CONFIRM;
    case 7:
    case "BGP_STATE_ACTIVE":
      return BgpPeerConnectionState.BGP_STATE_ACTIVE;
    case 8:
    case "BGP_STATE_CLEARING":
      return BgpPeerConnectionState.BGP_STATE_CLEARING;
    case 9:
    case "BGP_STATE_DELETED":
      return BgpPeerConnectionState.BGP_STATE_DELETED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpPeerConnectionState.UNRECOGNIZED;
  }
}

export function bgpPeerConnectionStateToJSON(object: BgpPeerConnectionState): string {
  switch (object) {
    case BgpPeerConnectionState.BGP_PEER_CONNECTION_STATE_UNSPECIFIED:
      return "BGP_PEER_CONNECTION_STATE_UNSPECIFIED";
    case BgpPeerConnectionState.ESTABLISHED:
      return "ESTABLISHED";
    case BgpPeerConnectionState.NOT_ESTABLISHED:
      return "NOT_ESTABLISHED";
    case BgpPeerConnectionState.IDLE:
      return "IDLE";
    case BgpPeerConnectionState.CONNECT:
      return "CONNECT";
    case BgpPeerConnectionState.OPEN_SENT:
      return "OPEN_SENT";
    case BgpPeerConnectionState.OPEN_CONFIRM:
      return "OPEN_CONFIRM";
    case BgpPeerConnectionState.BGP_STATE_ACTIVE:
      return "BGP_STATE_ACTIVE";
    case BgpPeerConnectionState.BGP_STATE_CLEARING:
      return "BGP_STATE_CLEARING";
    case BgpPeerConnectionState.BGP_STATE_DELETED:
      return "BGP_STATE_DELETED";
    case BgpPeerConnectionState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpPeerState {
  BGP_PEER_STATE_UNSPECIFIED = 0,
  PEER_STATE_OK = 1,
  PEER_STATE_NOT_OK = 2,
  UNRECOGNIZED = -1,
}

export function bgpPeerStateFromJSON(object: any): BgpPeerState {
  switch (object) {
    case 0:
    case "BGP_PEER_STATE_UNSPECIFIED":
      return BgpPeerState.BGP_PEER_STATE_UNSPECIFIED;
    case 1:
    case "PEER_STATE_OK":
      return BgpPeerState.PEER_STATE_OK;
    case 2:
    case "PEER_STATE_NOT_OK":
      return BgpPeerState.PEER_STATE_NOT_OK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpPeerState.UNRECOGNIZED;
  }
}

export function bgpPeerStateToJSON(object: BgpPeerState): string {
  switch (object) {
    case BgpPeerState.BGP_PEER_STATE_UNSPECIFIED:
      return "BGP_PEER_STATE_UNSPECIFIED";
    case BgpPeerState.PEER_STATE_OK:
      return "PEER_STATE_OK";
    case BgpPeerState.PEER_STATE_NOT_OK:
      return "PEER_STATE_NOT_OK";
    case BgpPeerState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpAddressFamily {
  BGP_ADDRESS_FAMILY_UNSPECIFIED = 0,
  IPV6_UNICAST = 1,
  L2_VPN_EVPN = 2,
  IPV4_UNICAST = 3,
  UNRECOGNIZED = -1,
}

export function bgpAddressFamilyFromJSON(object: any): BgpAddressFamily {
  switch (object) {
    case 0:
    case "BGP_ADDRESS_FAMILY_UNSPECIFIED":
      return BgpAddressFamily.BGP_ADDRESS_FAMILY_UNSPECIFIED;
    case 1:
    case "IPV6_UNICAST":
      return BgpAddressFamily.IPV6_UNICAST;
    case 2:
    case "L2_VPN_EVPN":
      return BgpAddressFamily.L2_VPN_EVPN;
    case 3:
    case "IPV4_UNICAST":
      return BgpAddressFamily.IPV4_UNICAST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpAddressFamily.UNRECOGNIZED;
  }
}

export function bgpAddressFamilyToJSON(object: BgpAddressFamily): string {
  switch (object) {
    case BgpAddressFamily.BGP_ADDRESS_FAMILY_UNSPECIFIED:
      return "BGP_ADDRESS_FAMILY_UNSPECIFIED";
    case BgpAddressFamily.IPV6_UNICAST:
      return "IPV6_UNICAST";
    case BgpAddressFamily.L2_VPN_EVPN:
      return "L2_VPN_EVPN";
    case BgpAddressFamily.IPV4_UNICAST:
      return "IPV4_UNICAST";
    case BgpAddressFamily.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PlannedConfigPhase {
  CONFIG_PHASE_UNSPECIFIED = 0,
  CONFIG_PHASE_ACK = 1,
  CONFIG_PHASE_RECEIVING = 2,
  CONFIG_PHASE_APPLYING = 3,
  CONFIG_PHASE_COMPLETED = 4,
  UNRECOGNIZED = -1,
}

export function plannedConfigPhaseFromJSON(object: any): PlannedConfigPhase {
  switch (object) {
    case 0:
    case "CONFIG_PHASE_UNSPECIFIED":
      return PlannedConfigPhase.CONFIG_PHASE_UNSPECIFIED;
    case 1:
    case "CONFIG_PHASE_ACK":
      return PlannedConfigPhase.CONFIG_PHASE_ACK;
    case 2:
    case "CONFIG_PHASE_RECEIVING":
      return PlannedConfigPhase.CONFIG_PHASE_RECEIVING;
    case 3:
    case "CONFIG_PHASE_APPLYING":
      return PlannedConfigPhase.CONFIG_PHASE_APPLYING;
    case 4:
    case "CONFIG_PHASE_COMPLETED":
      return PlannedConfigPhase.CONFIG_PHASE_COMPLETED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PlannedConfigPhase.UNRECOGNIZED;
  }
}

export function plannedConfigPhaseToJSON(object: PlannedConfigPhase): string {
  switch (object) {
    case PlannedConfigPhase.CONFIG_PHASE_UNSPECIFIED:
      return "CONFIG_PHASE_UNSPECIFIED";
    case PlannedConfigPhase.CONFIG_PHASE_ACK:
      return "CONFIG_PHASE_ACK";
    case PlannedConfigPhase.CONFIG_PHASE_RECEIVING:
      return "CONFIG_PHASE_RECEIVING";
    case PlannedConfigPhase.CONFIG_PHASE_APPLYING:
      return "CONFIG_PHASE_APPLYING";
    case PlannedConfigPhase.CONFIG_PHASE_COMPLETED:
      return "CONFIG_PHASE_COMPLETED";
    case PlannedConfigPhase.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TemperatureSensorCategory {
  TEMPERATURE_SENSOR_CATEGORY_UNSPECIFIED = 0,
  CPU = 1,
  GPU = 2,
  DIMM = 3,
  ENV = 4,
  NVMe = 5,
  PCIe = 6,
  POWER_PSU = 7,
  POWER_PDB = 8,
  LINE_PROCESSING_SENSORS = 9,
  FRONT_HAUL_SENSORS = 10,
  BOARD_NPU = 11,
  FAN = 12,
  OTHERS = 13,
  DDR_RAM = 14,
  NSV = 15,
  HSC = 16,
  PCB = 17,
  AIR_FLOW = 18,
  RTM = 19,
  UNRECOGNIZED = -1,
}

export function temperatureSensorCategoryFromJSON(object: any): TemperatureSensorCategory {
  switch (object) {
    case 0:
    case "TEMPERATURE_SENSOR_CATEGORY_UNSPECIFIED":
      return TemperatureSensorCategory.TEMPERATURE_SENSOR_CATEGORY_UNSPECIFIED;
    case 1:
    case "CPU":
      return TemperatureSensorCategory.CPU;
    case 2:
    case "GPU":
      return TemperatureSensorCategory.GPU;
    case 3:
    case "DIMM":
      return TemperatureSensorCategory.DIMM;
    case 4:
    case "ENV":
      return TemperatureSensorCategory.ENV;
    case 5:
    case "NVMe":
      return TemperatureSensorCategory.NVMe;
    case 6:
    case "PCIe":
      return TemperatureSensorCategory.PCIe;
    case 7:
    case "POWER_PSU":
      return TemperatureSensorCategory.POWER_PSU;
    case 8:
    case "POWER_PDB":
      return TemperatureSensorCategory.POWER_PDB;
    case 9:
    case "LINE_PROCESSING_SENSORS":
      return TemperatureSensorCategory.LINE_PROCESSING_SENSORS;
    case 10:
    case "FRONT_HAUL_SENSORS":
      return TemperatureSensorCategory.FRONT_HAUL_SENSORS;
    case 11:
    case "BOARD_NPU":
      return TemperatureSensorCategory.BOARD_NPU;
    case 12:
    case "FAN":
      return TemperatureSensorCategory.FAN;
    case 13:
    case "OTHERS":
      return TemperatureSensorCategory.OTHERS;
    case 14:
    case "DDR_RAM":
      return TemperatureSensorCategory.DDR_RAM;
    case 15:
    case "NSV":
      return TemperatureSensorCategory.NSV;
    case 16:
    case "HSC":
      return TemperatureSensorCategory.HSC;
    case 17:
    case "PCB":
      return TemperatureSensorCategory.PCB;
    case 18:
    case "AIR_FLOW":
      return TemperatureSensorCategory.AIR_FLOW;
    case 19:
    case "RTM":
      return TemperatureSensorCategory.RTM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TemperatureSensorCategory.UNRECOGNIZED;
  }
}

export function temperatureSensorCategoryToJSON(object: TemperatureSensorCategory): string {
  switch (object) {
    case TemperatureSensorCategory.TEMPERATURE_SENSOR_CATEGORY_UNSPECIFIED:
      return "TEMPERATURE_SENSOR_CATEGORY_UNSPECIFIED";
    case TemperatureSensorCategory.CPU:
      return "CPU";
    case TemperatureSensorCategory.GPU:
      return "GPU";
    case TemperatureSensorCategory.DIMM:
      return "DIMM";
    case TemperatureSensorCategory.ENV:
      return "ENV";
    case TemperatureSensorCategory.NVMe:
      return "NVMe";
    case TemperatureSensorCategory.PCIe:
      return "PCIe";
    case TemperatureSensorCategory.POWER_PSU:
      return "POWER_PSU";
    case TemperatureSensorCategory.POWER_PDB:
      return "POWER_PDB";
    case TemperatureSensorCategory.LINE_PROCESSING_SENSORS:
      return "LINE_PROCESSING_SENSORS";
    case TemperatureSensorCategory.FRONT_HAUL_SENSORS:
      return "FRONT_HAUL_SENSORS";
    case TemperatureSensorCategory.BOARD_NPU:
      return "BOARD_NPU";
    case TemperatureSensorCategory.FAN:
      return "FAN";
    case TemperatureSensorCategory.OTHERS:
      return "OTHERS";
    case TemperatureSensorCategory.DDR_RAM:
      return "DDR_RAM";
    case TemperatureSensorCategory.NSV:
      return "NSV";
    case TemperatureSensorCategory.HSC:
      return "HSC";
    case TemperatureSensorCategory.PCB:
      return "PCB";
    case TemperatureSensorCategory.AIR_FLOW:
      return "AIR_FLOW";
    case TemperatureSensorCategory.RTM:
      return "RTM";
    case TemperatureSensorCategory.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ServerTemperatureSensors {
  INVALID_SERVER_SENSOR = 0,
  TEMP_AMBIENT = 1,
  TEMP_DCSCM = 2,
  TEMP_MB_CPU0 = 3,
  TEMP_MB_CPU1 = 4,
  TEMP_DIMM_ZONE1 = 5,
  TEMP_DIMM_ZONE2 = 6,
  TEMP_DIMM_ZONE3 = 7,
  TEMP_DIMM_ZONE4 = 8,
  TEMP_MB_CPU0_IN = 9,
  TEMP_MB_CPU1_IN = 10,
  TEMP_MB_OUTLET = 11,
  TEMP_MB_PSU1_IN = 12,
  TEMP_MB_PSU2_IN = 13,
  TEMP_OCP1 = 14,
  TEMP_OCP2 = 15,
  TEMP_MIDPLANE = 16,
  TEMP_CEMSlot_1 = 17,
  TEMP_CEMSlot_2 = 18,
  TEMP_CEMBB = 19,
  TEMP_NVME_1 = 20,
  TEMP_NVME_2 = 21,
  TEMP_NVME_3 = 22,
  TEMP_NVME_4 = 23,
  TEMP_NVME_5 = 24,
  TEMP_NVME_6 = 25,
  TEMP_NVME_7 = 26,
  TEMP_NVME_8 = 27,
  TEMP_NVME_9 = 28,
  TEMP_NVME_10 = 29,
  TEMP_NVME_11 = 30,
  TEMP_NVME_12 = 31,
  TEMP_NVME_13 = 32,
  TEMP_NVME_14 = 33,
  TEMP_NVME_15 = 34,
  TEMP_NVME_16 = 35,
  TEMP_HIB_PEX1 = 36,
  TEMP_HIB_PEX2 = 37,
  TEMP_HIB_PEX3 = 38,
  TEMP_HIB_PEX4 = 39,
  TEMP_MI300_GPU0 = 40,
  TEMP_MI300_GPU1 = 41,
  TEMP_MI300_GPU2 = 42,
  TEMP_MI300_GPU3 = 43,
  TEMP_MI300_GPU4 = 44,
  TEMP_MI300_GPU5 = 45,
  TEMP_MI300_GPU6 = 46,
  TEMP_MI300_GPU7 = 47,
  TEMP_MI300_GPU0M = 48,
  TEMP_MI300_GPU1M = 49,
  TEMP_MI300_GPU2M = 50,
  TEMP_MI300_GPU3M = 51,
  TEMP_MI300_GPU4M = 52,
  TEMP_MI300_GPU5M = 53,
  TEMP_MI300_GPU6M = 54,
  TEMP_MI300_GPU7M = 55,
  TEMP_MI300_HSC0 = 56,
  TEMP_MI300_HSC1 = 57,
  TEMP_MI300_HSC2 = 58,
  TEMP_MI300_HSC3 = 59,
  TEMP_MI300_HSC4 = 60,
  TEMP_MI300_HSC5 = 61,
  TEMP_MI300_HSC6 = 62,
  TEMP_MI300_HSC7 = 63,
  TEMP_MI300_RTM0 = 64,
  TEMP_MI300_RTM1 = 65,
  TEMP_MI300_RTM2 = 66,
  TEMP_MI300_RTM3 = 67,
  TEMP_MI300_RTM4 = 68,
  TEMP_MI300_RTM5 = 69,
  TEMP_MI300_RTM6 = 70,
  TEMP_MI300_RTM7 = 71,
  TEMP_MI300_IBC = 72,
  TEMP_MI300_BACK = 73,
  TEMP_MI300_FRONT = 74,
  TEMP_MI300_FPGA = 75,
  TEMP_MB_PSU1 = 76,
  TEMP_MB_PSU2 = 77,
  TEMP_PDB_PSU1 = 78,
  TEMP_PDB_PSU2 = 79,
  TEMP_PDB_PSU3 = 80,
  TEMP_PDB_PSU4 = 81,
  TEMP_PDB_PSU5 = 82,
  TEMP_PDB_PSU6 = 83,
  TEMP_LP1_Chip = 84,
  TEMP_LP1_TRX = 85,
  TEMP_LP2_Chip = 86,
  TEMP_LP2_TRX = 87,
  TEMP_LP3_Chip = 88,
  TEMP_LP3_TRX = 89,
  TEMP_LP4_Chip = 90,
  TEMP_LP4_TRX = 91,
  TEMP_LP5_Chip = 92,
  TEMP_LP5_TRX = 93,
  TEMP_LP6_Chip = 94,
  TEMP_LP6_TRX = 95,
  TEMP_LP7_Chip = 96,
  TEMP_LP7_TRX = 97,
  TEMP_LP8_Chip = 98,
  TEMP_LP8_TRX = 99,
  TEMP_FH11_Chip = 100,
  TEMP_FH11_TRX = 101,
  TEMP_FH12_Chip = 102,
  TEMP_FH12_TRX = 103,
  TEMP_FH13_Chip = 104,
  TEMP_FH13_TRX = 105,
  TEMP_FH14_Chip = 106,
  TEMP_FH14_TRX = 107,
  TEMP_FH15_Chip = 108,
  TEMP_FH15_TRX = 109,
  DDR5_P1_A1_TMP = 110,
  DDR5_P1_B1_TMP = 111,
  DDR5_P1_C1_TMP = 112,
  DDR5_P1_D1_TMP = 113,
  DDR5_P1_E1_TMP = 114,
  DDR5_P1_F1_TMP = 115,
  DDR5_P1_G1_TMP = 116,
  DDR5_P1_H1_TMP = 117,
  DDR5_P1_I1_TMP = 118,
  DDR5_P1_J1_TMP = 119,
  DDR5_P1_K1_TMP = 120,
  DDR5_P1_L1_TMP = 121,
  TEMP_SENS_FRONT = 122,
  P1_TEMP_SENS = 123,
  PSU1_TEMP = 124,
  PSU2_TEMP = 125,
  TEMP_GB_GPU1 = 126,
  TEMP_GB_GPU2 = 127,
  TEMP_GB_GPU3 = 128,
  TEMP_GB_GPU4 = 129,
  TEMP_GB_GPU5 = 130,
  TEMP_GB_GPU6 = 131,
  TEMP_GB_GPU7 = 132,
  TEMP_GB_GPU8 = 133,
  TEMP_GB_GPU1_M = 134,
  TEMP_GB_GPU2_M = 135,
  TEMP_GB_GPU3_M = 136,
  TEMP_GB_GPU4_M = 137,
  TEMP_GB_GPU5_M = 138,
  TEMP_GB_GPU6_M = 139,
  TEMP_GB_GPU7_M = 140,
  TEMP_GB_GPU8_M = 141,
  TEMP_GB_NVS1 = 142,
  TEMP_GB_NVS2 = 143,
  TEMP_GB_NVS3 = 144,
  TEMP_GB_NVS4 = 145,
  TEMP_GB_HSC1 = 146,
  TEMP_GB_HSC2 = 147,
  TEMP_GB_HSC3 = 148,
  TEMP_GB_HSC4 = 149,
  TEMP_GB_HSC5 = 150,
  TEMP_GB_HSC6 = 151,
  TEMP_GB_HSC7 = 152,
  TEMP_GB_HSC8 = 153,
  TEMP_GB_HSC9 = 154,
  TEMP_GB_HSC10 = 155,
  TEMP_STBY_HSC = 156,
  TEMP_GB_PCB1 = 157,
  TEMP_GB_PCB2 = 158,
  TEMP_GB_PCB3 = 159,
  TEMP_GB_PCB4 = 160,
  TEMP_GB_PEX_SW = 161,
  TEMP_GB_FPGA = 162,
  TEMP_GB_RTM1 = 163,
  TEMP_GB_RTM2 = 164,
  TEMP_GB_RTM3 = 165,
  TEMP_GB_RTM4 = 166,
  TEMP_GB_RTM5 = 167,
  TEMP_GB_RTM6 = 168,
  TEMP_GB_RTM7 = 169,
  TEMP_GB_RTM8 = 170,
  TEMP_GB_INLET1 = 171,
  TEMP_GB_INLET2 = 172,
  TEMP_FH12_TRX_HI = 173,
  TEMP_FH13_TRX_HI = 174,
  TEMP_FH14_TRX_HI = 175,
  TEMP_LP1_TRX_HI = 176,
  TEMP_LP2_TRX_HI = 177,
  TEMP_LP3_TRX_HI = 178,
  TEMP_LP4_TRX_HI = 179,
  TEMP_LP5_TRX_HI = 180,
  TEMP_LP6_TRX_HI = 181,
  TEMP_LP7_TRX_HI = 182,
  TEMP_LP8_TRX_HI = 183,
  TEMP_FH11_TRX_HI = 184,
  /** TEMP_CPU1 - Mustang CPU sensors */
  TEMP_CPU1 = 185,
  TEMP_CPU2 = 186,
  /** TEMP_GPU1 - Mustang GPU sensors */
  TEMP_GPU1 = 187,
  TEMP_GPU2 = 188,
  TEMP_GPU3 = 189,
  TEMP_GPU4 = 190,
  TEMP_GPU5 = 191,
  TEMP_GPU6 = 192,
  TEMP_GPU7 = 193,
  TEMP_GPU8 = 194,
  /** TEMP_GPU1_Memory - Mustang GPU memory sensors */
  TEMP_GPU1_Memory = 195,
  TEMP_GPU2_Memory = 196,
  TEMP_GPU3_Memory = 197,
  TEMP_GPU4_Memory = 198,
  TEMP_GPU5_Memory = 199,
  TEMP_GPU6_Memory = 200,
  TEMP_GPU7_Memory = 201,
  TEMP_GPU8_Memory = 202,
  /** TEMP_NVME_17 - Mustang NVME sensors (17-20 extend existing 1-16) */
  TEMP_NVME_17 = 203,
  TEMP_NVME_18 = 204,
  TEMP_NVME_19 = 205,
  TEMP_NVME_20 = 206,
  /** TEMP_OCP - Mustang OCP NIC sensor */
  TEMP_OCP = 207,
  /** TEMP_P1_DIMM_ZN1 - Mustang DIMM zone sensors */
  TEMP_P1_DIMM_ZN1 = 208,
  TEMP_P1_DIMM_ZN2 = 209,
  TEMP_P2_DIMM_ZN1 = 210,
  TEMP_P2_DIMM_ZN2 = 211,
  /** TEMP_P1_VR_ZN1 - Mustang voltage regulator zone sensors */
  TEMP_P1_VR_ZN1 = 212,
  TEMP_P1_VR_ZN2 = 213,
  TEMP_P1_VR_ZN3 = 214,
  TEMP_P2_VR_ZN1 = 215,
  TEMP_P2_VR_ZN2 = 216,
  TEMP_P2_VR_ZN3 = 217,
  /** TEMP_PCIe9_CHIP - Mustang PCIe slot sensors */
  TEMP_PCIe9_CHIP = 218,
  TEMP_PCIe9_TRANS = 219,
  TEMP_PCIe10_CHIP = 220,
  TEMP_PCIe10_TRANS = 221,
  TEMP_PCIe11_CHIP = 222,
  TEMP_PCIe11_TRANS = 223,
  TEMP_PCIe12_CHIP = 224,
  TEMP_PCIe12_TRANS = 225,
  TEMP_PCIe13_CHIP = 226,
  TEMP_PCIe13_TRANS = 227,
  /** TEMP_PSU1 - Mustang PSU sensors */
  TEMP_PSU1 = 228,
  TEMP_PSU2 = 229,
  TEMP_PSU3 = 230,
  TEMP_PSU4 = 231,
  /** TEMP_SW_VR - Mustang switch/fabric sensors */
  TEMP_SW_VR = 232,
  TEMP_SWITCH1 = 233,
  TEMP_SWITCH2 = 234,
  /** TEMP_PSU5 - C880A PSU sensors (extends PSU1-4 from Mustang) */
  TEMP_PSU5 = 235,
  TEMP_PSU6 = 236,
  TEMP_PSU7 = 237,
  TEMP_PSU8 = 238,
  TEMP_PSU9 = 239,
  TEMP_PSU10 = 240,
  TEMP_PSU11 = 241,
  TEMP_PSU12 = 242,
  /** TEMP_CPU0 - C880A CPU sensors */
  TEMP_CPU0 = 243,
  TEMP_CPU0_ABCD = 244,
  TEMP_CPU0_EFGH = 245,
  TEMP_CPU1_IJKL = 246,
  TEMP_CPU1_MNOP = 247,
  /** TEMP_CX7_QSFP0 - C880A ConnectX sensors */
  TEMP_CX7_QSFP0 = 248,
  TEMP_CX7_QSFP1 = 249,
  TEMP_CX7_QSFP2 = 250,
  TEMP_CX7_QSFP3 = 251,
  TEMP_CX8_0 = 252,
  TEMP_CX8_0_OSFP0 = 253,
  TEMP_CX8_1 = 254,
  TEMP_CX8_1_OSFP0 = 255,
  TEMP_CX8_2 = 256,
  TEMP_CX8_2_OSFP0 = 257,
  TEMP_CX8_3 = 258,
  TEMP_CX8_3_OSFP0 = 259,
  TEMP_CX8_4 = 260,
  TEMP_CX8_4_OSFP0 = 261,
  TEMP_CX8_5 = 262,
  TEMP_CX8_5_OSFP0 = 263,
  TEMP_CX8_6 = 264,
  TEMP_CX8_6_OSFP0 = 265,
  TEMP_CX8_7 = 266,
  TEMP_CX8_7_OSFP0 = 267,
  /** TEMP_E1S_NVME1 - C880A E1S NVMe sensors */
  TEMP_E1S_NVME1 = 268,
  TEMP_E1S_NVME2 = 269,
  TEMP_E1S_NVME3 = 270,
  TEMP_E1S_NVME4 = 271,
  TEMP_E1S_NVME5 = 272,
  TEMP_E1S_NVME6 = 273,
  TEMP_E1S_NVME7 = 274,
  TEMP_E1S_NVME8 = 275,
  /** TEMP_GB1_INLET1 - C880A GPU baseboard sensors */
  TEMP_GB1_INLET1 = 276,
  TEMP_GB1_INLET2 = 277,
  TEMP_GB_CX8MCU_1 = 278,
  TEMP_GB_CX8MCU_2 = 279,
  TEMP_GB_CX8MCU_3 = 280,
  TEMP_GB_CX8MCU_4 = 281,
  TEMP_GB_HMC = 282,
  TEMP_GB_HSCC1 = 283,
  TEMP_GB_HSCC2 = 284,
  TEMP_GB_HSCC3 = 285,
  TEMP_GB_HSCC4 = 286,
  TEMP_GB_HSCC5 = 287,
  TEMP_GB_MCU_1 = 288,
  TEMP_GB_MCU_2 = 289,
  TEMP_GB_MCU_3 = 290,
  TEMP_GB_MCU_4 = 291,
  TEMP_GB_MCU_5 = 292,
  TEMP_GB_MCU_6 = 293,
  TEMP_GB_MCU_7 = 294,
  TEMP_GB_MCU_8 = 295,
  TEMP_GB_SXM1 = 296,
  TEMP_GB_SXM1_M = 297,
  TEMP_GB_SXM2 = 298,
  TEMP_GB_SXM2_M = 299,
  TEMP_GB_SXM3 = 300,
  TEMP_GB_SXM3_M = 301,
  TEMP_GB_SXM4 = 302,
  TEMP_GB_SXM4_M = 303,
  TEMP_GB_SXM5 = 304,
  TEMP_GB_SXM5_M = 305,
  TEMP_GB_SXM6 = 306,
  TEMP_GB_SXM6_M = 307,
  TEMP_GB_SXM7 = 308,
  TEMP_GB_SXM7_M = 309,
  TEMP_GB_SXM8 = 310,
  TEMP_GB_SXM8_M = 311,
  /** TEMP_M_2_RISER - C880A motherboard sensors */
  TEMP_M_2_RISER = 312,
  TEMP_MB_1G_LAN = 313,
  TEMP_MB_HV_CPU0 = 314,
  TEMP_MB_HV_CPU1 = 315,
  TEMP_MB_INF_CPU0 = 316,
  TEMP_MB_INF_CPU1 = 317,
  TEMP_MB_INLET = 318,
  TEMP_MB_VRM0 = 319,
  TEMP_MB_VRM1 = 320,
  /** TEMP_PCIE_CX7_1 - C880A PCIe sensors */
  TEMP_PCIE_CX7_1 = 321,
  TEMP_PCIE_CX7_2 = 322,
  TEMP_PCIE_SW_0 = 323,
  TEMP_PCIE_SW_1 = 324,
  /** TEMP_PDB0 - C880A PDB sensors */
  TEMP_PDB0 = 325,
  TEMP_PDB1 = 326,
  TEMP_PDB_FAN_HSC = 327,
  TEMP_PDB_VRM = 328,
  /** TEMP_VR_CPU0 - C880A VR sensors */
  TEMP_VR_CPU0 = 329,
  TEMP_VR_CPU1 = 330,
  /** TEMP_DCSCM_0 - C880A DCSCM sensor */
  TEMP_DCSCM_0 = 331,
  /** TLIMIT_GB_SXM1 - C880A GPU temperature limit sensors */
  TLIMIT_GB_SXM1 = 332,
  TLIMIT_GB_SXM2 = 333,
  TLIMIT_GB_SXM3 = 334,
  TLIMIT_GB_SXM4 = 335,
  TLIMIT_GB_SXM5 = 336,
  TLIMIT_GB_SXM6 = 337,
  TLIMIT_GB_SXM7 = 338,
  TLIMIT_GB_SXM8 = 339,
  UNRECOGNIZED = -1,
}

export function serverTemperatureSensorsFromJSON(object: any): ServerTemperatureSensors {
  switch (object) {
    case 0:
    case "INVALID_SERVER_SENSOR":
      return ServerTemperatureSensors.INVALID_SERVER_SENSOR;
    case 1:
    case "TEMP_AMBIENT":
      return ServerTemperatureSensors.TEMP_AMBIENT;
    case 2:
    case "TEMP_DCSCM":
      return ServerTemperatureSensors.TEMP_DCSCM;
    case 3:
    case "TEMP_MB_CPU0":
      return ServerTemperatureSensors.TEMP_MB_CPU0;
    case 4:
    case "TEMP_MB_CPU1":
      return ServerTemperatureSensors.TEMP_MB_CPU1;
    case 5:
    case "TEMP_DIMM_ZONE1":
      return ServerTemperatureSensors.TEMP_DIMM_ZONE1;
    case 6:
    case "TEMP_DIMM_ZONE2":
      return ServerTemperatureSensors.TEMP_DIMM_ZONE2;
    case 7:
    case "TEMP_DIMM_ZONE3":
      return ServerTemperatureSensors.TEMP_DIMM_ZONE3;
    case 8:
    case "TEMP_DIMM_ZONE4":
      return ServerTemperatureSensors.TEMP_DIMM_ZONE4;
    case 9:
    case "TEMP_MB_CPU0_IN":
      return ServerTemperatureSensors.TEMP_MB_CPU0_IN;
    case 10:
    case "TEMP_MB_CPU1_IN":
      return ServerTemperatureSensors.TEMP_MB_CPU1_IN;
    case 11:
    case "TEMP_MB_OUTLET":
      return ServerTemperatureSensors.TEMP_MB_OUTLET;
    case 12:
    case "TEMP_MB_PSU1_IN":
      return ServerTemperatureSensors.TEMP_MB_PSU1_IN;
    case 13:
    case "TEMP_MB_PSU2_IN":
      return ServerTemperatureSensors.TEMP_MB_PSU2_IN;
    case 14:
    case "TEMP_OCP1":
      return ServerTemperatureSensors.TEMP_OCP1;
    case 15:
    case "TEMP_OCP2":
      return ServerTemperatureSensors.TEMP_OCP2;
    case 16:
    case "TEMP_MIDPLANE":
      return ServerTemperatureSensors.TEMP_MIDPLANE;
    case 17:
    case "TEMP_CEMSlot_1":
      return ServerTemperatureSensors.TEMP_CEMSlot_1;
    case 18:
    case "TEMP_CEMSlot_2":
      return ServerTemperatureSensors.TEMP_CEMSlot_2;
    case 19:
    case "TEMP_CEMBB":
      return ServerTemperatureSensors.TEMP_CEMBB;
    case 20:
    case "TEMP_NVME_1":
      return ServerTemperatureSensors.TEMP_NVME_1;
    case 21:
    case "TEMP_NVME_2":
      return ServerTemperatureSensors.TEMP_NVME_2;
    case 22:
    case "TEMP_NVME_3":
      return ServerTemperatureSensors.TEMP_NVME_3;
    case 23:
    case "TEMP_NVME_4":
      return ServerTemperatureSensors.TEMP_NVME_4;
    case 24:
    case "TEMP_NVME_5":
      return ServerTemperatureSensors.TEMP_NVME_5;
    case 25:
    case "TEMP_NVME_6":
      return ServerTemperatureSensors.TEMP_NVME_6;
    case 26:
    case "TEMP_NVME_7":
      return ServerTemperatureSensors.TEMP_NVME_7;
    case 27:
    case "TEMP_NVME_8":
      return ServerTemperatureSensors.TEMP_NVME_8;
    case 28:
    case "TEMP_NVME_9":
      return ServerTemperatureSensors.TEMP_NVME_9;
    case 29:
    case "TEMP_NVME_10":
      return ServerTemperatureSensors.TEMP_NVME_10;
    case 30:
    case "TEMP_NVME_11":
      return ServerTemperatureSensors.TEMP_NVME_11;
    case 31:
    case "TEMP_NVME_12":
      return ServerTemperatureSensors.TEMP_NVME_12;
    case 32:
    case "TEMP_NVME_13":
      return ServerTemperatureSensors.TEMP_NVME_13;
    case 33:
    case "TEMP_NVME_14":
      return ServerTemperatureSensors.TEMP_NVME_14;
    case 34:
    case "TEMP_NVME_15":
      return ServerTemperatureSensors.TEMP_NVME_15;
    case 35:
    case "TEMP_NVME_16":
      return ServerTemperatureSensors.TEMP_NVME_16;
    case 36:
    case "TEMP_HIB_PEX1":
      return ServerTemperatureSensors.TEMP_HIB_PEX1;
    case 37:
    case "TEMP_HIB_PEX2":
      return ServerTemperatureSensors.TEMP_HIB_PEX2;
    case 38:
    case "TEMP_HIB_PEX3":
      return ServerTemperatureSensors.TEMP_HIB_PEX3;
    case 39:
    case "TEMP_HIB_PEX4":
      return ServerTemperatureSensors.TEMP_HIB_PEX4;
    case 40:
    case "TEMP_MI300_GPU0":
      return ServerTemperatureSensors.TEMP_MI300_GPU0;
    case 41:
    case "TEMP_MI300_GPU1":
      return ServerTemperatureSensors.TEMP_MI300_GPU1;
    case 42:
    case "TEMP_MI300_GPU2":
      return ServerTemperatureSensors.TEMP_MI300_GPU2;
    case 43:
    case "TEMP_MI300_GPU3":
      return ServerTemperatureSensors.TEMP_MI300_GPU3;
    case 44:
    case "TEMP_MI300_GPU4":
      return ServerTemperatureSensors.TEMP_MI300_GPU4;
    case 45:
    case "TEMP_MI300_GPU5":
      return ServerTemperatureSensors.TEMP_MI300_GPU5;
    case 46:
    case "TEMP_MI300_GPU6":
      return ServerTemperatureSensors.TEMP_MI300_GPU6;
    case 47:
    case "TEMP_MI300_GPU7":
      return ServerTemperatureSensors.TEMP_MI300_GPU7;
    case 48:
    case "TEMP_MI300_GPU0M":
      return ServerTemperatureSensors.TEMP_MI300_GPU0M;
    case 49:
    case "TEMP_MI300_GPU1M":
      return ServerTemperatureSensors.TEMP_MI300_GPU1M;
    case 50:
    case "TEMP_MI300_GPU2M":
      return ServerTemperatureSensors.TEMP_MI300_GPU2M;
    case 51:
    case "TEMP_MI300_GPU3M":
      return ServerTemperatureSensors.TEMP_MI300_GPU3M;
    case 52:
    case "TEMP_MI300_GPU4M":
      return ServerTemperatureSensors.TEMP_MI300_GPU4M;
    case 53:
    case "TEMP_MI300_GPU5M":
      return ServerTemperatureSensors.TEMP_MI300_GPU5M;
    case 54:
    case "TEMP_MI300_GPU6M":
      return ServerTemperatureSensors.TEMP_MI300_GPU6M;
    case 55:
    case "TEMP_MI300_GPU7M":
      return ServerTemperatureSensors.TEMP_MI300_GPU7M;
    case 56:
    case "TEMP_MI300_HSC0":
      return ServerTemperatureSensors.TEMP_MI300_HSC0;
    case 57:
    case "TEMP_MI300_HSC1":
      return ServerTemperatureSensors.TEMP_MI300_HSC1;
    case 58:
    case "TEMP_MI300_HSC2":
      return ServerTemperatureSensors.TEMP_MI300_HSC2;
    case 59:
    case "TEMP_MI300_HSC3":
      return ServerTemperatureSensors.TEMP_MI300_HSC3;
    case 60:
    case "TEMP_MI300_HSC4":
      return ServerTemperatureSensors.TEMP_MI300_HSC4;
    case 61:
    case "TEMP_MI300_HSC5":
      return ServerTemperatureSensors.TEMP_MI300_HSC5;
    case 62:
    case "TEMP_MI300_HSC6":
      return ServerTemperatureSensors.TEMP_MI300_HSC6;
    case 63:
    case "TEMP_MI300_HSC7":
      return ServerTemperatureSensors.TEMP_MI300_HSC7;
    case 64:
    case "TEMP_MI300_RTM0":
      return ServerTemperatureSensors.TEMP_MI300_RTM0;
    case 65:
    case "TEMP_MI300_RTM1":
      return ServerTemperatureSensors.TEMP_MI300_RTM1;
    case 66:
    case "TEMP_MI300_RTM2":
      return ServerTemperatureSensors.TEMP_MI300_RTM2;
    case 67:
    case "TEMP_MI300_RTM3":
      return ServerTemperatureSensors.TEMP_MI300_RTM3;
    case 68:
    case "TEMP_MI300_RTM4":
      return ServerTemperatureSensors.TEMP_MI300_RTM4;
    case 69:
    case "TEMP_MI300_RTM5":
      return ServerTemperatureSensors.TEMP_MI300_RTM5;
    case 70:
    case "TEMP_MI300_RTM6":
      return ServerTemperatureSensors.TEMP_MI300_RTM6;
    case 71:
    case "TEMP_MI300_RTM7":
      return ServerTemperatureSensors.TEMP_MI300_RTM7;
    case 72:
    case "TEMP_MI300_IBC":
      return ServerTemperatureSensors.TEMP_MI300_IBC;
    case 73:
    case "TEMP_MI300_BACK":
      return ServerTemperatureSensors.TEMP_MI300_BACK;
    case 74:
    case "TEMP_MI300_FRONT":
      return ServerTemperatureSensors.TEMP_MI300_FRONT;
    case 75:
    case "TEMP_MI300_FPGA":
      return ServerTemperatureSensors.TEMP_MI300_FPGA;
    case 76:
    case "TEMP_MB_PSU1":
      return ServerTemperatureSensors.TEMP_MB_PSU1;
    case 77:
    case "TEMP_MB_PSU2":
      return ServerTemperatureSensors.TEMP_MB_PSU2;
    case 78:
    case "TEMP_PDB_PSU1":
      return ServerTemperatureSensors.TEMP_PDB_PSU1;
    case 79:
    case "TEMP_PDB_PSU2":
      return ServerTemperatureSensors.TEMP_PDB_PSU2;
    case 80:
    case "TEMP_PDB_PSU3":
      return ServerTemperatureSensors.TEMP_PDB_PSU3;
    case 81:
    case "TEMP_PDB_PSU4":
      return ServerTemperatureSensors.TEMP_PDB_PSU4;
    case 82:
    case "TEMP_PDB_PSU5":
      return ServerTemperatureSensors.TEMP_PDB_PSU5;
    case 83:
    case "TEMP_PDB_PSU6":
      return ServerTemperatureSensors.TEMP_PDB_PSU6;
    case 84:
    case "TEMP_LP1_Chip":
      return ServerTemperatureSensors.TEMP_LP1_Chip;
    case 85:
    case "TEMP_LP1_TRX":
      return ServerTemperatureSensors.TEMP_LP1_TRX;
    case 86:
    case "TEMP_LP2_Chip":
      return ServerTemperatureSensors.TEMP_LP2_Chip;
    case 87:
    case "TEMP_LP2_TRX":
      return ServerTemperatureSensors.TEMP_LP2_TRX;
    case 88:
    case "TEMP_LP3_Chip":
      return ServerTemperatureSensors.TEMP_LP3_Chip;
    case 89:
    case "TEMP_LP3_TRX":
      return ServerTemperatureSensors.TEMP_LP3_TRX;
    case 90:
    case "TEMP_LP4_Chip":
      return ServerTemperatureSensors.TEMP_LP4_Chip;
    case 91:
    case "TEMP_LP4_TRX":
      return ServerTemperatureSensors.TEMP_LP4_TRX;
    case 92:
    case "TEMP_LP5_Chip":
      return ServerTemperatureSensors.TEMP_LP5_Chip;
    case 93:
    case "TEMP_LP5_TRX":
      return ServerTemperatureSensors.TEMP_LP5_TRX;
    case 94:
    case "TEMP_LP6_Chip":
      return ServerTemperatureSensors.TEMP_LP6_Chip;
    case 95:
    case "TEMP_LP6_TRX":
      return ServerTemperatureSensors.TEMP_LP6_TRX;
    case 96:
    case "TEMP_LP7_Chip":
      return ServerTemperatureSensors.TEMP_LP7_Chip;
    case 97:
    case "TEMP_LP7_TRX":
      return ServerTemperatureSensors.TEMP_LP7_TRX;
    case 98:
    case "TEMP_LP8_Chip":
      return ServerTemperatureSensors.TEMP_LP8_Chip;
    case 99:
    case "TEMP_LP8_TRX":
      return ServerTemperatureSensors.TEMP_LP8_TRX;
    case 100:
    case "TEMP_FH11_Chip":
      return ServerTemperatureSensors.TEMP_FH11_Chip;
    case 101:
    case "TEMP_FH11_TRX":
      return ServerTemperatureSensors.TEMP_FH11_TRX;
    case 102:
    case "TEMP_FH12_Chip":
      return ServerTemperatureSensors.TEMP_FH12_Chip;
    case 103:
    case "TEMP_FH12_TRX":
      return ServerTemperatureSensors.TEMP_FH12_TRX;
    case 104:
    case "TEMP_FH13_Chip":
      return ServerTemperatureSensors.TEMP_FH13_Chip;
    case 105:
    case "TEMP_FH13_TRX":
      return ServerTemperatureSensors.TEMP_FH13_TRX;
    case 106:
    case "TEMP_FH14_Chip":
      return ServerTemperatureSensors.TEMP_FH14_Chip;
    case 107:
    case "TEMP_FH14_TRX":
      return ServerTemperatureSensors.TEMP_FH14_TRX;
    case 108:
    case "TEMP_FH15_Chip":
      return ServerTemperatureSensors.TEMP_FH15_Chip;
    case 109:
    case "TEMP_FH15_TRX":
      return ServerTemperatureSensors.TEMP_FH15_TRX;
    case 110:
    case "DDR5_P1_A1_TMP":
      return ServerTemperatureSensors.DDR5_P1_A1_TMP;
    case 111:
    case "DDR5_P1_B1_TMP":
      return ServerTemperatureSensors.DDR5_P1_B1_TMP;
    case 112:
    case "DDR5_P1_C1_TMP":
      return ServerTemperatureSensors.DDR5_P1_C1_TMP;
    case 113:
    case "DDR5_P1_D1_TMP":
      return ServerTemperatureSensors.DDR5_P1_D1_TMP;
    case 114:
    case "DDR5_P1_E1_TMP":
      return ServerTemperatureSensors.DDR5_P1_E1_TMP;
    case 115:
    case "DDR5_P1_F1_TMP":
      return ServerTemperatureSensors.DDR5_P1_F1_TMP;
    case 116:
    case "DDR5_P1_G1_TMP":
      return ServerTemperatureSensors.DDR5_P1_G1_TMP;
    case 117:
    case "DDR5_P1_H1_TMP":
      return ServerTemperatureSensors.DDR5_P1_H1_TMP;
    case 118:
    case "DDR5_P1_I1_TMP":
      return ServerTemperatureSensors.DDR5_P1_I1_TMP;
    case 119:
    case "DDR5_P1_J1_TMP":
      return ServerTemperatureSensors.DDR5_P1_J1_TMP;
    case 120:
    case "DDR5_P1_K1_TMP":
      return ServerTemperatureSensors.DDR5_P1_K1_TMP;
    case 121:
    case "DDR5_P1_L1_TMP":
      return ServerTemperatureSensors.DDR5_P1_L1_TMP;
    case 122:
    case "TEMP_SENS_FRONT":
      return ServerTemperatureSensors.TEMP_SENS_FRONT;
    case 123:
    case "P1_TEMP_SENS":
      return ServerTemperatureSensors.P1_TEMP_SENS;
    case 124:
    case "PSU1_TEMP":
      return ServerTemperatureSensors.PSU1_TEMP;
    case 125:
    case "PSU2_TEMP":
      return ServerTemperatureSensors.PSU2_TEMP;
    case 126:
    case "TEMP_GB_GPU1":
      return ServerTemperatureSensors.TEMP_GB_GPU1;
    case 127:
    case "TEMP_GB_GPU2":
      return ServerTemperatureSensors.TEMP_GB_GPU2;
    case 128:
    case "TEMP_GB_GPU3":
      return ServerTemperatureSensors.TEMP_GB_GPU3;
    case 129:
    case "TEMP_GB_GPU4":
      return ServerTemperatureSensors.TEMP_GB_GPU4;
    case 130:
    case "TEMP_GB_GPU5":
      return ServerTemperatureSensors.TEMP_GB_GPU5;
    case 131:
    case "TEMP_GB_GPU6":
      return ServerTemperatureSensors.TEMP_GB_GPU6;
    case 132:
    case "TEMP_GB_GPU7":
      return ServerTemperatureSensors.TEMP_GB_GPU7;
    case 133:
    case "TEMP_GB_GPU8":
      return ServerTemperatureSensors.TEMP_GB_GPU8;
    case 134:
    case "TEMP_GB_GPU1_M":
      return ServerTemperatureSensors.TEMP_GB_GPU1_M;
    case 135:
    case "TEMP_GB_GPU2_M":
      return ServerTemperatureSensors.TEMP_GB_GPU2_M;
    case 136:
    case "TEMP_GB_GPU3_M":
      return ServerTemperatureSensors.TEMP_GB_GPU3_M;
    case 137:
    case "TEMP_GB_GPU4_M":
      return ServerTemperatureSensors.TEMP_GB_GPU4_M;
    case 138:
    case "TEMP_GB_GPU5_M":
      return ServerTemperatureSensors.TEMP_GB_GPU5_M;
    case 139:
    case "TEMP_GB_GPU6_M":
      return ServerTemperatureSensors.TEMP_GB_GPU6_M;
    case 140:
    case "TEMP_GB_GPU7_M":
      return ServerTemperatureSensors.TEMP_GB_GPU7_M;
    case 141:
    case "TEMP_GB_GPU8_M":
      return ServerTemperatureSensors.TEMP_GB_GPU8_M;
    case 142:
    case "TEMP_GB_NVS1":
      return ServerTemperatureSensors.TEMP_GB_NVS1;
    case 143:
    case "TEMP_GB_NVS2":
      return ServerTemperatureSensors.TEMP_GB_NVS2;
    case 144:
    case "TEMP_GB_NVS3":
      return ServerTemperatureSensors.TEMP_GB_NVS3;
    case 145:
    case "TEMP_GB_NVS4":
      return ServerTemperatureSensors.TEMP_GB_NVS4;
    case 146:
    case "TEMP_GB_HSC1":
      return ServerTemperatureSensors.TEMP_GB_HSC1;
    case 147:
    case "TEMP_GB_HSC2":
      return ServerTemperatureSensors.TEMP_GB_HSC2;
    case 148:
    case "TEMP_GB_HSC3":
      return ServerTemperatureSensors.TEMP_GB_HSC3;
    case 149:
    case "TEMP_GB_HSC4":
      return ServerTemperatureSensors.TEMP_GB_HSC4;
    case 150:
    case "TEMP_GB_HSC5":
      return ServerTemperatureSensors.TEMP_GB_HSC5;
    case 151:
    case "TEMP_GB_HSC6":
      return ServerTemperatureSensors.TEMP_GB_HSC6;
    case 152:
    case "TEMP_GB_HSC7":
      return ServerTemperatureSensors.TEMP_GB_HSC7;
    case 153:
    case "TEMP_GB_HSC8":
      return ServerTemperatureSensors.TEMP_GB_HSC8;
    case 154:
    case "TEMP_GB_HSC9":
      return ServerTemperatureSensors.TEMP_GB_HSC9;
    case 155:
    case "TEMP_GB_HSC10":
      return ServerTemperatureSensors.TEMP_GB_HSC10;
    case 156:
    case "TEMP_STBY_HSC":
      return ServerTemperatureSensors.TEMP_STBY_HSC;
    case 157:
    case "TEMP_GB_PCB1":
      return ServerTemperatureSensors.TEMP_GB_PCB1;
    case 158:
    case "TEMP_GB_PCB2":
      return ServerTemperatureSensors.TEMP_GB_PCB2;
    case 159:
    case "TEMP_GB_PCB3":
      return ServerTemperatureSensors.TEMP_GB_PCB3;
    case 160:
    case "TEMP_GB_PCB4":
      return ServerTemperatureSensors.TEMP_GB_PCB4;
    case 161:
    case "TEMP_GB_PEX_SW":
      return ServerTemperatureSensors.TEMP_GB_PEX_SW;
    case 162:
    case "TEMP_GB_FPGA":
      return ServerTemperatureSensors.TEMP_GB_FPGA;
    case 163:
    case "TEMP_GB_RTM1":
      return ServerTemperatureSensors.TEMP_GB_RTM1;
    case 164:
    case "TEMP_GB_RTM2":
      return ServerTemperatureSensors.TEMP_GB_RTM2;
    case 165:
    case "TEMP_GB_RTM3":
      return ServerTemperatureSensors.TEMP_GB_RTM3;
    case 166:
    case "TEMP_GB_RTM4":
      return ServerTemperatureSensors.TEMP_GB_RTM4;
    case 167:
    case "TEMP_GB_RTM5":
      return ServerTemperatureSensors.TEMP_GB_RTM5;
    case 168:
    case "TEMP_GB_RTM6":
      return ServerTemperatureSensors.TEMP_GB_RTM6;
    case 169:
    case "TEMP_GB_RTM7":
      return ServerTemperatureSensors.TEMP_GB_RTM7;
    case 170:
    case "TEMP_GB_RTM8":
      return ServerTemperatureSensors.TEMP_GB_RTM8;
    case 171:
    case "TEMP_GB_INLET1":
      return ServerTemperatureSensors.TEMP_GB_INLET1;
    case 172:
    case "TEMP_GB_INLET2":
      return ServerTemperatureSensors.TEMP_GB_INLET2;
    case 173:
    case "TEMP_FH12_TRX_HI":
      return ServerTemperatureSensors.TEMP_FH12_TRX_HI;
    case 174:
    case "TEMP_FH13_TRX_HI":
      return ServerTemperatureSensors.TEMP_FH13_TRX_HI;
    case 175:
    case "TEMP_FH14_TRX_HI":
      return ServerTemperatureSensors.TEMP_FH14_TRX_HI;
    case 176:
    case "TEMP_LP1_TRX_HI":
      return ServerTemperatureSensors.TEMP_LP1_TRX_HI;
    case 177:
    case "TEMP_LP2_TRX_HI":
      return ServerTemperatureSensors.TEMP_LP2_TRX_HI;
    case 178:
    case "TEMP_LP3_TRX_HI":
      return ServerTemperatureSensors.TEMP_LP3_TRX_HI;
    case 179:
    case "TEMP_LP4_TRX_HI":
      return ServerTemperatureSensors.TEMP_LP4_TRX_HI;
    case 180:
    case "TEMP_LP5_TRX_HI":
      return ServerTemperatureSensors.TEMP_LP5_TRX_HI;
    case 181:
    case "TEMP_LP6_TRX_HI":
      return ServerTemperatureSensors.TEMP_LP6_TRX_HI;
    case 182:
    case "TEMP_LP7_TRX_HI":
      return ServerTemperatureSensors.TEMP_LP7_TRX_HI;
    case 183:
    case "TEMP_LP8_TRX_HI":
      return ServerTemperatureSensors.TEMP_LP8_TRX_HI;
    case 184:
    case "TEMP_FH11_TRX_HI":
      return ServerTemperatureSensors.TEMP_FH11_TRX_HI;
    case 185:
    case "TEMP_CPU1":
      return ServerTemperatureSensors.TEMP_CPU1;
    case 186:
    case "TEMP_CPU2":
      return ServerTemperatureSensors.TEMP_CPU2;
    case 187:
    case "TEMP_GPU1":
      return ServerTemperatureSensors.TEMP_GPU1;
    case 188:
    case "TEMP_GPU2":
      return ServerTemperatureSensors.TEMP_GPU2;
    case 189:
    case "TEMP_GPU3":
      return ServerTemperatureSensors.TEMP_GPU3;
    case 190:
    case "TEMP_GPU4":
      return ServerTemperatureSensors.TEMP_GPU4;
    case 191:
    case "TEMP_GPU5":
      return ServerTemperatureSensors.TEMP_GPU5;
    case 192:
    case "TEMP_GPU6":
      return ServerTemperatureSensors.TEMP_GPU6;
    case 193:
    case "TEMP_GPU7":
      return ServerTemperatureSensors.TEMP_GPU7;
    case 194:
    case "TEMP_GPU8":
      return ServerTemperatureSensors.TEMP_GPU8;
    case 195:
    case "TEMP_GPU1_Memory":
      return ServerTemperatureSensors.TEMP_GPU1_Memory;
    case 196:
    case "TEMP_GPU2_Memory":
      return ServerTemperatureSensors.TEMP_GPU2_Memory;
    case 197:
    case "TEMP_GPU3_Memory":
      return ServerTemperatureSensors.TEMP_GPU3_Memory;
    case 198:
    case "TEMP_GPU4_Memory":
      return ServerTemperatureSensors.TEMP_GPU4_Memory;
    case 199:
    case "TEMP_GPU5_Memory":
      return ServerTemperatureSensors.TEMP_GPU5_Memory;
    case 200:
    case "TEMP_GPU6_Memory":
      return ServerTemperatureSensors.TEMP_GPU6_Memory;
    case 201:
    case "TEMP_GPU7_Memory":
      return ServerTemperatureSensors.TEMP_GPU7_Memory;
    case 202:
    case "TEMP_GPU8_Memory":
      return ServerTemperatureSensors.TEMP_GPU8_Memory;
    case 203:
    case "TEMP_NVME_17":
      return ServerTemperatureSensors.TEMP_NVME_17;
    case 204:
    case "TEMP_NVME_18":
      return ServerTemperatureSensors.TEMP_NVME_18;
    case 205:
    case "TEMP_NVME_19":
      return ServerTemperatureSensors.TEMP_NVME_19;
    case 206:
    case "TEMP_NVME_20":
      return ServerTemperatureSensors.TEMP_NVME_20;
    case 207:
    case "TEMP_OCP":
      return ServerTemperatureSensors.TEMP_OCP;
    case 208:
    case "TEMP_P1_DIMM_ZN1":
      return ServerTemperatureSensors.TEMP_P1_DIMM_ZN1;
    case 209:
    case "TEMP_P1_DIMM_ZN2":
      return ServerTemperatureSensors.TEMP_P1_DIMM_ZN2;
    case 210:
    case "TEMP_P2_DIMM_ZN1":
      return ServerTemperatureSensors.TEMP_P2_DIMM_ZN1;
    case 211:
    case "TEMP_P2_DIMM_ZN2":
      return ServerTemperatureSensors.TEMP_P2_DIMM_ZN2;
    case 212:
    case "TEMP_P1_VR_ZN1":
      return ServerTemperatureSensors.TEMP_P1_VR_ZN1;
    case 213:
    case "TEMP_P1_VR_ZN2":
      return ServerTemperatureSensors.TEMP_P1_VR_ZN2;
    case 214:
    case "TEMP_P1_VR_ZN3":
      return ServerTemperatureSensors.TEMP_P1_VR_ZN3;
    case 215:
    case "TEMP_P2_VR_ZN1":
      return ServerTemperatureSensors.TEMP_P2_VR_ZN1;
    case 216:
    case "TEMP_P2_VR_ZN2":
      return ServerTemperatureSensors.TEMP_P2_VR_ZN2;
    case 217:
    case "TEMP_P2_VR_ZN3":
      return ServerTemperatureSensors.TEMP_P2_VR_ZN3;
    case 218:
    case "TEMP_PCIe9_CHIP":
      return ServerTemperatureSensors.TEMP_PCIe9_CHIP;
    case 219:
    case "TEMP_PCIe9_TRANS":
      return ServerTemperatureSensors.TEMP_PCIe9_TRANS;
    case 220:
    case "TEMP_PCIe10_CHIP":
      return ServerTemperatureSensors.TEMP_PCIe10_CHIP;
    case 221:
    case "TEMP_PCIe10_TRANS":
      return ServerTemperatureSensors.TEMP_PCIe10_TRANS;
    case 222:
    case "TEMP_PCIe11_CHIP":
      return ServerTemperatureSensors.TEMP_PCIe11_CHIP;
    case 223:
    case "TEMP_PCIe11_TRANS":
      return ServerTemperatureSensors.TEMP_PCIe11_TRANS;
    case 224:
    case "TEMP_PCIe12_CHIP":
      return ServerTemperatureSensors.TEMP_PCIe12_CHIP;
    case 225:
    case "TEMP_PCIe12_TRANS":
      return ServerTemperatureSensors.TEMP_PCIe12_TRANS;
    case 226:
    case "TEMP_PCIe13_CHIP":
      return ServerTemperatureSensors.TEMP_PCIe13_CHIP;
    case 227:
    case "TEMP_PCIe13_TRANS":
      return ServerTemperatureSensors.TEMP_PCIe13_TRANS;
    case 228:
    case "TEMP_PSU1":
      return ServerTemperatureSensors.TEMP_PSU1;
    case 229:
    case "TEMP_PSU2":
      return ServerTemperatureSensors.TEMP_PSU2;
    case 230:
    case "TEMP_PSU3":
      return ServerTemperatureSensors.TEMP_PSU3;
    case 231:
    case "TEMP_PSU4":
      return ServerTemperatureSensors.TEMP_PSU4;
    case 232:
    case "TEMP_SW_VR":
      return ServerTemperatureSensors.TEMP_SW_VR;
    case 233:
    case "TEMP_SWITCH1":
      return ServerTemperatureSensors.TEMP_SWITCH1;
    case 234:
    case "TEMP_SWITCH2":
      return ServerTemperatureSensors.TEMP_SWITCH2;
    case 235:
    case "TEMP_PSU5":
      return ServerTemperatureSensors.TEMP_PSU5;
    case 236:
    case "TEMP_PSU6":
      return ServerTemperatureSensors.TEMP_PSU6;
    case 237:
    case "TEMP_PSU7":
      return ServerTemperatureSensors.TEMP_PSU7;
    case 238:
    case "TEMP_PSU8":
      return ServerTemperatureSensors.TEMP_PSU8;
    case 239:
    case "TEMP_PSU9":
      return ServerTemperatureSensors.TEMP_PSU9;
    case 240:
    case "TEMP_PSU10":
      return ServerTemperatureSensors.TEMP_PSU10;
    case 241:
    case "TEMP_PSU11":
      return ServerTemperatureSensors.TEMP_PSU11;
    case 242:
    case "TEMP_PSU12":
      return ServerTemperatureSensors.TEMP_PSU12;
    case 243:
    case "TEMP_CPU0":
      return ServerTemperatureSensors.TEMP_CPU0;
    case 244:
    case "TEMP_CPU0_ABCD":
      return ServerTemperatureSensors.TEMP_CPU0_ABCD;
    case 245:
    case "TEMP_CPU0_EFGH":
      return ServerTemperatureSensors.TEMP_CPU0_EFGH;
    case 246:
    case "TEMP_CPU1_IJKL":
      return ServerTemperatureSensors.TEMP_CPU1_IJKL;
    case 247:
    case "TEMP_CPU1_MNOP":
      return ServerTemperatureSensors.TEMP_CPU1_MNOP;
    case 248:
    case "TEMP_CX7_QSFP0":
      return ServerTemperatureSensors.TEMP_CX7_QSFP0;
    case 249:
    case "TEMP_CX7_QSFP1":
      return ServerTemperatureSensors.TEMP_CX7_QSFP1;
    case 250:
    case "TEMP_CX7_QSFP2":
      return ServerTemperatureSensors.TEMP_CX7_QSFP2;
    case 251:
    case "TEMP_CX7_QSFP3":
      return ServerTemperatureSensors.TEMP_CX7_QSFP3;
    case 252:
    case "TEMP_CX8_0":
      return ServerTemperatureSensors.TEMP_CX8_0;
    case 253:
    case "TEMP_CX8_0_OSFP0":
      return ServerTemperatureSensors.TEMP_CX8_0_OSFP0;
    case 254:
    case "TEMP_CX8_1":
      return ServerTemperatureSensors.TEMP_CX8_1;
    case 255:
    case "TEMP_CX8_1_OSFP0":
      return ServerTemperatureSensors.TEMP_CX8_1_OSFP0;
    case 256:
    case "TEMP_CX8_2":
      return ServerTemperatureSensors.TEMP_CX8_2;
    case 257:
    case "TEMP_CX8_2_OSFP0":
      return ServerTemperatureSensors.TEMP_CX8_2_OSFP0;
    case 258:
    case "TEMP_CX8_3":
      return ServerTemperatureSensors.TEMP_CX8_3;
    case 259:
    case "TEMP_CX8_3_OSFP0":
      return ServerTemperatureSensors.TEMP_CX8_3_OSFP0;
    case 260:
    case "TEMP_CX8_4":
      return ServerTemperatureSensors.TEMP_CX8_4;
    case 261:
    case "TEMP_CX8_4_OSFP0":
      return ServerTemperatureSensors.TEMP_CX8_4_OSFP0;
    case 262:
    case "TEMP_CX8_5":
      return ServerTemperatureSensors.TEMP_CX8_5;
    case 263:
    case "TEMP_CX8_5_OSFP0":
      return ServerTemperatureSensors.TEMP_CX8_5_OSFP0;
    case 264:
    case "TEMP_CX8_6":
      return ServerTemperatureSensors.TEMP_CX8_6;
    case 265:
    case "TEMP_CX8_6_OSFP0":
      return ServerTemperatureSensors.TEMP_CX8_6_OSFP0;
    case 266:
    case "TEMP_CX8_7":
      return ServerTemperatureSensors.TEMP_CX8_7;
    case 267:
    case "TEMP_CX8_7_OSFP0":
      return ServerTemperatureSensors.TEMP_CX8_7_OSFP0;
    case 268:
    case "TEMP_E1S_NVME1":
      return ServerTemperatureSensors.TEMP_E1S_NVME1;
    case 269:
    case "TEMP_E1S_NVME2":
      return ServerTemperatureSensors.TEMP_E1S_NVME2;
    case 270:
    case "TEMP_E1S_NVME3":
      return ServerTemperatureSensors.TEMP_E1S_NVME3;
    case 271:
    case "TEMP_E1S_NVME4":
      return ServerTemperatureSensors.TEMP_E1S_NVME4;
    case 272:
    case "TEMP_E1S_NVME5":
      return ServerTemperatureSensors.TEMP_E1S_NVME5;
    case 273:
    case "TEMP_E1S_NVME6":
      return ServerTemperatureSensors.TEMP_E1S_NVME6;
    case 274:
    case "TEMP_E1S_NVME7":
      return ServerTemperatureSensors.TEMP_E1S_NVME7;
    case 275:
    case "TEMP_E1S_NVME8":
      return ServerTemperatureSensors.TEMP_E1S_NVME8;
    case 276:
    case "TEMP_GB1_INLET1":
      return ServerTemperatureSensors.TEMP_GB1_INLET1;
    case 277:
    case "TEMP_GB1_INLET2":
      return ServerTemperatureSensors.TEMP_GB1_INLET2;
    case 278:
    case "TEMP_GB_CX8MCU_1":
      return ServerTemperatureSensors.TEMP_GB_CX8MCU_1;
    case 279:
    case "TEMP_GB_CX8MCU_2":
      return ServerTemperatureSensors.TEMP_GB_CX8MCU_2;
    case 280:
    case "TEMP_GB_CX8MCU_3":
      return ServerTemperatureSensors.TEMP_GB_CX8MCU_3;
    case 281:
    case "TEMP_GB_CX8MCU_4":
      return ServerTemperatureSensors.TEMP_GB_CX8MCU_4;
    case 282:
    case "TEMP_GB_HMC":
      return ServerTemperatureSensors.TEMP_GB_HMC;
    case 283:
    case "TEMP_GB_HSCC1":
      return ServerTemperatureSensors.TEMP_GB_HSCC1;
    case 284:
    case "TEMP_GB_HSCC2":
      return ServerTemperatureSensors.TEMP_GB_HSCC2;
    case 285:
    case "TEMP_GB_HSCC3":
      return ServerTemperatureSensors.TEMP_GB_HSCC3;
    case 286:
    case "TEMP_GB_HSCC4":
      return ServerTemperatureSensors.TEMP_GB_HSCC4;
    case 287:
    case "TEMP_GB_HSCC5":
      return ServerTemperatureSensors.TEMP_GB_HSCC5;
    case 288:
    case "TEMP_GB_MCU_1":
      return ServerTemperatureSensors.TEMP_GB_MCU_1;
    case 289:
    case "TEMP_GB_MCU_2":
      return ServerTemperatureSensors.TEMP_GB_MCU_2;
    case 290:
    case "TEMP_GB_MCU_3":
      return ServerTemperatureSensors.TEMP_GB_MCU_3;
    case 291:
    case "TEMP_GB_MCU_4":
      return ServerTemperatureSensors.TEMP_GB_MCU_4;
    case 292:
    case "TEMP_GB_MCU_5":
      return ServerTemperatureSensors.TEMP_GB_MCU_5;
    case 293:
    case "TEMP_GB_MCU_6":
      return ServerTemperatureSensors.TEMP_GB_MCU_6;
    case 294:
    case "TEMP_GB_MCU_7":
      return ServerTemperatureSensors.TEMP_GB_MCU_7;
    case 295:
    case "TEMP_GB_MCU_8":
      return ServerTemperatureSensors.TEMP_GB_MCU_8;
    case 296:
    case "TEMP_GB_SXM1":
      return ServerTemperatureSensors.TEMP_GB_SXM1;
    case 297:
    case "TEMP_GB_SXM1_M":
      return ServerTemperatureSensors.TEMP_GB_SXM1_M;
    case 298:
    case "TEMP_GB_SXM2":
      return ServerTemperatureSensors.TEMP_GB_SXM2;
    case 299:
    case "TEMP_GB_SXM2_M":
      return ServerTemperatureSensors.TEMP_GB_SXM2_M;
    case 300:
    case "TEMP_GB_SXM3":
      return ServerTemperatureSensors.TEMP_GB_SXM3;
    case 301:
    case "TEMP_GB_SXM3_M":
      return ServerTemperatureSensors.TEMP_GB_SXM3_M;
    case 302:
    case "TEMP_GB_SXM4":
      return ServerTemperatureSensors.TEMP_GB_SXM4;
    case 303:
    case "TEMP_GB_SXM4_M":
      return ServerTemperatureSensors.TEMP_GB_SXM4_M;
    case 304:
    case "TEMP_GB_SXM5":
      return ServerTemperatureSensors.TEMP_GB_SXM5;
    case 305:
    case "TEMP_GB_SXM5_M":
      return ServerTemperatureSensors.TEMP_GB_SXM5_M;
    case 306:
    case "TEMP_GB_SXM6":
      return ServerTemperatureSensors.TEMP_GB_SXM6;
    case 307:
    case "TEMP_GB_SXM6_M":
      return ServerTemperatureSensors.TEMP_GB_SXM6_M;
    case 308:
    case "TEMP_GB_SXM7":
      return ServerTemperatureSensors.TEMP_GB_SXM7;
    case 309:
    case "TEMP_GB_SXM7_M":
      return ServerTemperatureSensors.TEMP_GB_SXM7_M;
    case 310:
    case "TEMP_GB_SXM8":
      return ServerTemperatureSensors.TEMP_GB_SXM8;
    case 311:
    case "TEMP_GB_SXM8_M":
      return ServerTemperatureSensors.TEMP_GB_SXM8_M;
    case 312:
    case "TEMP_M_2_RISER":
      return ServerTemperatureSensors.TEMP_M_2_RISER;
    case 313:
    case "TEMP_MB_1G_LAN":
      return ServerTemperatureSensors.TEMP_MB_1G_LAN;
    case 314:
    case "TEMP_MB_HV_CPU0":
      return ServerTemperatureSensors.TEMP_MB_HV_CPU0;
    case 315:
    case "TEMP_MB_HV_CPU1":
      return ServerTemperatureSensors.TEMP_MB_HV_CPU1;
    case 316:
    case "TEMP_MB_INF_CPU0":
      return ServerTemperatureSensors.TEMP_MB_INF_CPU0;
    case 317:
    case "TEMP_MB_INF_CPU1":
      return ServerTemperatureSensors.TEMP_MB_INF_CPU1;
    case 318:
    case "TEMP_MB_INLET":
      return ServerTemperatureSensors.TEMP_MB_INLET;
    case 319:
    case "TEMP_MB_VRM0":
      return ServerTemperatureSensors.TEMP_MB_VRM0;
    case 320:
    case "TEMP_MB_VRM1":
      return ServerTemperatureSensors.TEMP_MB_VRM1;
    case 321:
    case "TEMP_PCIE_CX7_1":
      return ServerTemperatureSensors.TEMP_PCIE_CX7_1;
    case 322:
    case "TEMP_PCIE_CX7_2":
      return ServerTemperatureSensors.TEMP_PCIE_CX7_2;
    case 323:
    case "TEMP_PCIE_SW_0":
      return ServerTemperatureSensors.TEMP_PCIE_SW_0;
    case 324:
    case "TEMP_PCIE_SW_1":
      return ServerTemperatureSensors.TEMP_PCIE_SW_1;
    case 325:
    case "TEMP_PDB0":
      return ServerTemperatureSensors.TEMP_PDB0;
    case 326:
    case "TEMP_PDB1":
      return ServerTemperatureSensors.TEMP_PDB1;
    case 327:
    case "TEMP_PDB_FAN_HSC":
      return ServerTemperatureSensors.TEMP_PDB_FAN_HSC;
    case 328:
    case "TEMP_PDB_VRM":
      return ServerTemperatureSensors.TEMP_PDB_VRM;
    case 329:
    case "TEMP_VR_CPU0":
      return ServerTemperatureSensors.TEMP_VR_CPU0;
    case 330:
    case "TEMP_VR_CPU1":
      return ServerTemperatureSensors.TEMP_VR_CPU1;
    case 331:
    case "TEMP_DCSCM_0":
      return ServerTemperatureSensors.TEMP_DCSCM_0;
    case 332:
    case "TLIMIT_GB_SXM1":
      return ServerTemperatureSensors.TLIMIT_GB_SXM1;
    case 333:
    case "TLIMIT_GB_SXM2":
      return ServerTemperatureSensors.TLIMIT_GB_SXM2;
    case 334:
    case "TLIMIT_GB_SXM3":
      return ServerTemperatureSensors.TLIMIT_GB_SXM3;
    case 335:
    case "TLIMIT_GB_SXM4":
      return ServerTemperatureSensors.TLIMIT_GB_SXM4;
    case 336:
    case "TLIMIT_GB_SXM5":
      return ServerTemperatureSensors.TLIMIT_GB_SXM5;
    case 337:
    case "TLIMIT_GB_SXM6":
      return ServerTemperatureSensors.TLIMIT_GB_SXM6;
    case 338:
    case "TLIMIT_GB_SXM7":
      return ServerTemperatureSensors.TLIMIT_GB_SXM7;
    case 339:
    case "TLIMIT_GB_SXM8":
      return ServerTemperatureSensors.TLIMIT_GB_SXM8;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ServerTemperatureSensors.UNRECOGNIZED;
  }
}

export function serverTemperatureSensorsToJSON(object: ServerTemperatureSensors): string {
  switch (object) {
    case ServerTemperatureSensors.INVALID_SERVER_SENSOR:
      return "INVALID_SERVER_SENSOR";
    case ServerTemperatureSensors.TEMP_AMBIENT:
      return "TEMP_AMBIENT";
    case ServerTemperatureSensors.TEMP_DCSCM:
      return "TEMP_DCSCM";
    case ServerTemperatureSensors.TEMP_MB_CPU0:
      return "TEMP_MB_CPU0";
    case ServerTemperatureSensors.TEMP_MB_CPU1:
      return "TEMP_MB_CPU1";
    case ServerTemperatureSensors.TEMP_DIMM_ZONE1:
      return "TEMP_DIMM_ZONE1";
    case ServerTemperatureSensors.TEMP_DIMM_ZONE2:
      return "TEMP_DIMM_ZONE2";
    case ServerTemperatureSensors.TEMP_DIMM_ZONE3:
      return "TEMP_DIMM_ZONE3";
    case ServerTemperatureSensors.TEMP_DIMM_ZONE4:
      return "TEMP_DIMM_ZONE4";
    case ServerTemperatureSensors.TEMP_MB_CPU0_IN:
      return "TEMP_MB_CPU0_IN";
    case ServerTemperatureSensors.TEMP_MB_CPU1_IN:
      return "TEMP_MB_CPU1_IN";
    case ServerTemperatureSensors.TEMP_MB_OUTLET:
      return "TEMP_MB_OUTLET";
    case ServerTemperatureSensors.TEMP_MB_PSU1_IN:
      return "TEMP_MB_PSU1_IN";
    case ServerTemperatureSensors.TEMP_MB_PSU2_IN:
      return "TEMP_MB_PSU2_IN";
    case ServerTemperatureSensors.TEMP_OCP1:
      return "TEMP_OCP1";
    case ServerTemperatureSensors.TEMP_OCP2:
      return "TEMP_OCP2";
    case ServerTemperatureSensors.TEMP_MIDPLANE:
      return "TEMP_MIDPLANE";
    case ServerTemperatureSensors.TEMP_CEMSlot_1:
      return "TEMP_CEMSlot_1";
    case ServerTemperatureSensors.TEMP_CEMSlot_2:
      return "TEMP_CEMSlot_2";
    case ServerTemperatureSensors.TEMP_CEMBB:
      return "TEMP_CEMBB";
    case ServerTemperatureSensors.TEMP_NVME_1:
      return "TEMP_NVME_1";
    case ServerTemperatureSensors.TEMP_NVME_2:
      return "TEMP_NVME_2";
    case ServerTemperatureSensors.TEMP_NVME_3:
      return "TEMP_NVME_3";
    case ServerTemperatureSensors.TEMP_NVME_4:
      return "TEMP_NVME_4";
    case ServerTemperatureSensors.TEMP_NVME_5:
      return "TEMP_NVME_5";
    case ServerTemperatureSensors.TEMP_NVME_6:
      return "TEMP_NVME_6";
    case ServerTemperatureSensors.TEMP_NVME_7:
      return "TEMP_NVME_7";
    case ServerTemperatureSensors.TEMP_NVME_8:
      return "TEMP_NVME_8";
    case ServerTemperatureSensors.TEMP_NVME_9:
      return "TEMP_NVME_9";
    case ServerTemperatureSensors.TEMP_NVME_10:
      return "TEMP_NVME_10";
    case ServerTemperatureSensors.TEMP_NVME_11:
      return "TEMP_NVME_11";
    case ServerTemperatureSensors.TEMP_NVME_12:
      return "TEMP_NVME_12";
    case ServerTemperatureSensors.TEMP_NVME_13:
      return "TEMP_NVME_13";
    case ServerTemperatureSensors.TEMP_NVME_14:
      return "TEMP_NVME_14";
    case ServerTemperatureSensors.TEMP_NVME_15:
      return "TEMP_NVME_15";
    case ServerTemperatureSensors.TEMP_NVME_16:
      return "TEMP_NVME_16";
    case ServerTemperatureSensors.TEMP_HIB_PEX1:
      return "TEMP_HIB_PEX1";
    case ServerTemperatureSensors.TEMP_HIB_PEX2:
      return "TEMP_HIB_PEX2";
    case ServerTemperatureSensors.TEMP_HIB_PEX3:
      return "TEMP_HIB_PEX3";
    case ServerTemperatureSensors.TEMP_HIB_PEX4:
      return "TEMP_HIB_PEX4";
    case ServerTemperatureSensors.TEMP_MI300_GPU0:
      return "TEMP_MI300_GPU0";
    case ServerTemperatureSensors.TEMP_MI300_GPU1:
      return "TEMP_MI300_GPU1";
    case ServerTemperatureSensors.TEMP_MI300_GPU2:
      return "TEMP_MI300_GPU2";
    case ServerTemperatureSensors.TEMP_MI300_GPU3:
      return "TEMP_MI300_GPU3";
    case ServerTemperatureSensors.TEMP_MI300_GPU4:
      return "TEMP_MI300_GPU4";
    case ServerTemperatureSensors.TEMP_MI300_GPU5:
      return "TEMP_MI300_GPU5";
    case ServerTemperatureSensors.TEMP_MI300_GPU6:
      return "TEMP_MI300_GPU6";
    case ServerTemperatureSensors.TEMP_MI300_GPU7:
      return "TEMP_MI300_GPU7";
    case ServerTemperatureSensors.TEMP_MI300_GPU0M:
      return "TEMP_MI300_GPU0M";
    case ServerTemperatureSensors.TEMP_MI300_GPU1M:
      return "TEMP_MI300_GPU1M";
    case ServerTemperatureSensors.TEMP_MI300_GPU2M:
      return "TEMP_MI300_GPU2M";
    case ServerTemperatureSensors.TEMP_MI300_GPU3M:
      return "TEMP_MI300_GPU3M";
    case ServerTemperatureSensors.TEMP_MI300_GPU4M:
      return "TEMP_MI300_GPU4M";
    case ServerTemperatureSensors.TEMP_MI300_GPU5M:
      return "TEMP_MI300_GPU5M";
    case ServerTemperatureSensors.TEMP_MI300_GPU6M:
      return "TEMP_MI300_GPU6M";
    case ServerTemperatureSensors.TEMP_MI300_GPU7M:
      return "TEMP_MI300_GPU7M";
    case ServerTemperatureSensors.TEMP_MI300_HSC0:
      return "TEMP_MI300_HSC0";
    case ServerTemperatureSensors.TEMP_MI300_HSC1:
      return "TEMP_MI300_HSC1";
    case ServerTemperatureSensors.TEMP_MI300_HSC2:
      return "TEMP_MI300_HSC2";
    case ServerTemperatureSensors.TEMP_MI300_HSC3:
      return "TEMP_MI300_HSC3";
    case ServerTemperatureSensors.TEMP_MI300_HSC4:
      return "TEMP_MI300_HSC4";
    case ServerTemperatureSensors.TEMP_MI300_HSC5:
      return "TEMP_MI300_HSC5";
    case ServerTemperatureSensors.TEMP_MI300_HSC6:
      return "TEMP_MI300_HSC6";
    case ServerTemperatureSensors.TEMP_MI300_HSC7:
      return "TEMP_MI300_HSC7";
    case ServerTemperatureSensors.TEMP_MI300_RTM0:
      return "TEMP_MI300_RTM0";
    case ServerTemperatureSensors.TEMP_MI300_RTM1:
      return "TEMP_MI300_RTM1";
    case ServerTemperatureSensors.TEMP_MI300_RTM2:
      return "TEMP_MI300_RTM2";
    case ServerTemperatureSensors.TEMP_MI300_RTM3:
      return "TEMP_MI300_RTM3";
    case ServerTemperatureSensors.TEMP_MI300_RTM4:
      return "TEMP_MI300_RTM4";
    case ServerTemperatureSensors.TEMP_MI300_RTM5:
      return "TEMP_MI300_RTM5";
    case ServerTemperatureSensors.TEMP_MI300_RTM6:
      return "TEMP_MI300_RTM6";
    case ServerTemperatureSensors.TEMP_MI300_RTM7:
      return "TEMP_MI300_RTM7";
    case ServerTemperatureSensors.TEMP_MI300_IBC:
      return "TEMP_MI300_IBC";
    case ServerTemperatureSensors.TEMP_MI300_BACK:
      return "TEMP_MI300_BACK";
    case ServerTemperatureSensors.TEMP_MI300_FRONT:
      return "TEMP_MI300_FRONT";
    case ServerTemperatureSensors.TEMP_MI300_FPGA:
      return "TEMP_MI300_FPGA";
    case ServerTemperatureSensors.TEMP_MB_PSU1:
      return "TEMP_MB_PSU1";
    case ServerTemperatureSensors.TEMP_MB_PSU2:
      return "TEMP_MB_PSU2";
    case ServerTemperatureSensors.TEMP_PDB_PSU1:
      return "TEMP_PDB_PSU1";
    case ServerTemperatureSensors.TEMP_PDB_PSU2:
      return "TEMP_PDB_PSU2";
    case ServerTemperatureSensors.TEMP_PDB_PSU3:
      return "TEMP_PDB_PSU3";
    case ServerTemperatureSensors.TEMP_PDB_PSU4:
      return "TEMP_PDB_PSU4";
    case ServerTemperatureSensors.TEMP_PDB_PSU5:
      return "TEMP_PDB_PSU5";
    case ServerTemperatureSensors.TEMP_PDB_PSU6:
      return "TEMP_PDB_PSU6";
    case ServerTemperatureSensors.TEMP_LP1_Chip:
      return "TEMP_LP1_Chip";
    case ServerTemperatureSensors.TEMP_LP1_TRX:
      return "TEMP_LP1_TRX";
    case ServerTemperatureSensors.TEMP_LP2_Chip:
      return "TEMP_LP2_Chip";
    case ServerTemperatureSensors.TEMP_LP2_TRX:
      return "TEMP_LP2_TRX";
    case ServerTemperatureSensors.TEMP_LP3_Chip:
      return "TEMP_LP3_Chip";
    case ServerTemperatureSensors.TEMP_LP3_TRX:
      return "TEMP_LP3_TRX";
    case ServerTemperatureSensors.TEMP_LP4_Chip:
      return "TEMP_LP4_Chip";
    case ServerTemperatureSensors.TEMP_LP4_TRX:
      return "TEMP_LP4_TRX";
    case ServerTemperatureSensors.TEMP_LP5_Chip:
      return "TEMP_LP5_Chip";
    case ServerTemperatureSensors.TEMP_LP5_TRX:
      return "TEMP_LP5_TRX";
    case ServerTemperatureSensors.TEMP_LP6_Chip:
      return "TEMP_LP6_Chip";
    case ServerTemperatureSensors.TEMP_LP6_TRX:
      return "TEMP_LP6_TRX";
    case ServerTemperatureSensors.TEMP_LP7_Chip:
      return "TEMP_LP7_Chip";
    case ServerTemperatureSensors.TEMP_LP7_TRX:
      return "TEMP_LP7_TRX";
    case ServerTemperatureSensors.TEMP_LP8_Chip:
      return "TEMP_LP8_Chip";
    case ServerTemperatureSensors.TEMP_LP8_TRX:
      return "TEMP_LP8_TRX";
    case ServerTemperatureSensors.TEMP_FH11_Chip:
      return "TEMP_FH11_Chip";
    case ServerTemperatureSensors.TEMP_FH11_TRX:
      return "TEMP_FH11_TRX";
    case ServerTemperatureSensors.TEMP_FH12_Chip:
      return "TEMP_FH12_Chip";
    case ServerTemperatureSensors.TEMP_FH12_TRX:
      return "TEMP_FH12_TRX";
    case ServerTemperatureSensors.TEMP_FH13_Chip:
      return "TEMP_FH13_Chip";
    case ServerTemperatureSensors.TEMP_FH13_TRX:
      return "TEMP_FH13_TRX";
    case ServerTemperatureSensors.TEMP_FH14_Chip:
      return "TEMP_FH14_Chip";
    case ServerTemperatureSensors.TEMP_FH14_TRX:
      return "TEMP_FH14_TRX";
    case ServerTemperatureSensors.TEMP_FH15_Chip:
      return "TEMP_FH15_Chip";
    case ServerTemperatureSensors.TEMP_FH15_TRX:
      return "TEMP_FH15_TRX";
    case ServerTemperatureSensors.DDR5_P1_A1_TMP:
      return "DDR5_P1_A1_TMP";
    case ServerTemperatureSensors.DDR5_P1_B1_TMP:
      return "DDR5_P1_B1_TMP";
    case ServerTemperatureSensors.DDR5_P1_C1_TMP:
      return "DDR5_P1_C1_TMP";
    case ServerTemperatureSensors.DDR5_P1_D1_TMP:
      return "DDR5_P1_D1_TMP";
    case ServerTemperatureSensors.DDR5_P1_E1_TMP:
      return "DDR5_P1_E1_TMP";
    case ServerTemperatureSensors.DDR5_P1_F1_TMP:
      return "DDR5_P1_F1_TMP";
    case ServerTemperatureSensors.DDR5_P1_G1_TMP:
      return "DDR5_P1_G1_TMP";
    case ServerTemperatureSensors.DDR5_P1_H1_TMP:
      return "DDR5_P1_H1_TMP";
    case ServerTemperatureSensors.DDR5_P1_I1_TMP:
      return "DDR5_P1_I1_TMP";
    case ServerTemperatureSensors.DDR5_P1_J1_TMP:
      return "DDR5_P1_J1_TMP";
    case ServerTemperatureSensors.DDR5_P1_K1_TMP:
      return "DDR5_P1_K1_TMP";
    case ServerTemperatureSensors.DDR5_P1_L1_TMP:
      return "DDR5_P1_L1_TMP";
    case ServerTemperatureSensors.TEMP_SENS_FRONT:
      return "TEMP_SENS_FRONT";
    case ServerTemperatureSensors.P1_TEMP_SENS:
      return "P1_TEMP_SENS";
    case ServerTemperatureSensors.PSU1_TEMP:
      return "PSU1_TEMP";
    case ServerTemperatureSensors.PSU2_TEMP:
      return "PSU2_TEMP";
    case ServerTemperatureSensors.TEMP_GB_GPU1:
      return "TEMP_GB_GPU1";
    case ServerTemperatureSensors.TEMP_GB_GPU2:
      return "TEMP_GB_GPU2";
    case ServerTemperatureSensors.TEMP_GB_GPU3:
      return "TEMP_GB_GPU3";
    case ServerTemperatureSensors.TEMP_GB_GPU4:
      return "TEMP_GB_GPU4";
    case ServerTemperatureSensors.TEMP_GB_GPU5:
      return "TEMP_GB_GPU5";
    case ServerTemperatureSensors.TEMP_GB_GPU6:
      return "TEMP_GB_GPU6";
    case ServerTemperatureSensors.TEMP_GB_GPU7:
      return "TEMP_GB_GPU7";
    case ServerTemperatureSensors.TEMP_GB_GPU8:
      return "TEMP_GB_GPU8";
    case ServerTemperatureSensors.TEMP_GB_GPU1_M:
      return "TEMP_GB_GPU1_M";
    case ServerTemperatureSensors.TEMP_GB_GPU2_M:
      return "TEMP_GB_GPU2_M";
    case ServerTemperatureSensors.TEMP_GB_GPU3_M:
      return "TEMP_GB_GPU3_M";
    case ServerTemperatureSensors.TEMP_GB_GPU4_M:
      return "TEMP_GB_GPU4_M";
    case ServerTemperatureSensors.TEMP_GB_GPU5_M:
      return "TEMP_GB_GPU5_M";
    case ServerTemperatureSensors.TEMP_GB_GPU6_M:
      return "TEMP_GB_GPU6_M";
    case ServerTemperatureSensors.TEMP_GB_GPU7_M:
      return "TEMP_GB_GPU7_M";
    case ServerTemperatureSensors.TEMP_GB_GPU8_M:
      return "TEMP_GB_GPU8_M";
    case ServerTemperatureSensors.TEMP_GB_NVS1:
      return "TEMP_GB_NVS1";
    case ServerTemperatureSensors.TEMP_GB_NVS2:
      return "TEMP_GB_NVS2";
    case ServerTemperatureSensors.TEMP_GB_NVS3:
      return "TEMP_GB_NVS3";
    case ServerTemperatureSensors.TEMP_GB_NVS4:
      return "TEMP_GB_NVS4";
    case ServerTemperatureSensors.TEMP_GB_HSC1:
      return "TEMP_GB_HSC1";
    case ServerTemperatureSensors.TEMP_GB_HSC2:
      return "TEMP_GB_HSC2";
    case ServerTemperatureSensors.TEMP_GB_HSC3:
      return "TEMP_GB_HSC3";
    case ServerTemperatureSensors.TEMP_GB_HSC4:
      return "TEMP_GB_HSC4";
    case ServerTemperatureSensors.TEMP_GB_HSC5:
      return "TEMP_GB_HSC5";
    case ServerTemperatureSensors.TEMP_GB_HSC6:
      return "TEMP_GB_HSC6";
    case ServerTemperatureSensors.TEMP_GB_HSC7:
      return "TEMP_GB_HSC7";
    case ServerTemperatureSensors.TEMP_GB_HSC8:
      return "TEMP_GB_HSC8";
    case ServerTemperatureSensors.TEMP_GB_HSC9:
      return "TEMP_GB_HSC9";
    case ServerTemperatureSensors.TEMP_GB_HSC10:
      return "TEMP_GB_HSC10";
    case ServerTemperatureSensors.TEMP_STBY_HSC:
      return "TEMP_STBY_HSC";
    case ServerTemperatureSensors.TEMP_GB_PCB1:
      return "TEMP_GB_PCB1";
    case ServerTemperatureSensors.TEMP_GB_PCB2:
      return "TEMP_GB_PCB2";
    case ServerTemperatureSensors.TEMP_GB_PCB3:
      return "TEMP_GB_PCB3";
    case ServerTemperatureSensors.TEMP_GB_PCB4:
      return "TEMP_GB_PCB4";
    case ServerTemperatureSensors.TEMP_GB_PEX_SW:
      return "TEMP_GB_PEX_SW";
    case ServerTemperatureSensors.TEMP_GB_FPGA:
      return "TEMP_GB_FPGA";
    case ServerTemperatureSensors.TEMP_GB_RTM1:
      return "TEMP_GB_RTM1";
    case ServerTemperatureSensors.TEMP_GB_RTM2:
      return "TEMP_GB_RTM2";
    case ServerTemperatureSensors.TEMP_GB_RTM3:
      return "TEMP_GB_RTM3";
    case ServerTemperatureSensors.TEMP_GB_RTM4:
      return "TEMP_GB_RTM4";
    case ServerTemperatureSensors.TEMP_GB_RTM5:
      return "TEMP_GB_RTM5";
    case ServerTemperatureSensors.TEMP_GB_RTM6:
      return "TEMP_GB_RTM6";
    case ServerTemperatureSensors.TEMP_GB_RTM7:
      return "TEMP_GB_RTM7";
    case ServerTemperatureSensors.TEMP_GB_RTM8:
      return "TEMP_GB_RTM8";
    case ServerTemperatureSensors.TEMP_GB_INLET1:
      return "TEMP_GB_INLET1";
    case ServerTemperatureSensors.TEMP_GB_INLET2:
      return "TEMP_GB_INLET2";
    case ServerTemperatureSensors.TEMP_FH12_TRX_HI:
      return "TEMP_FH12_TRX_HI";
    case ServerTemperatureSensors.TEMP_FH13_TRX_HI:
      return "TEMP_FH13_TRX_HI";
    case ServerTemperatureSensors.TEMP_FH14_TRX_HI:
      return "TEMP_FH14_TRX_HI";
    case ServerTemperatureSensors.TEMP_LP1_TRX_HI:
      return "TEMP_LP1_TRX_HI";
    case ServerTemperatureSensors.TEMP_LP2_TRX_HI:
      return "TEMP_LP2_TRX_HI";
    case ServerTemperatureSensors.TEMP_LP3_TRX_HI:
      return "TEMP_LP3_TRX_HI";
    case ServerTemperatureSensors.TEMP_LP4_TRX_HI:
      return "TEMP_LP4_TRX_HI";
    case ServerTemperatureSensors.TEMP_LP5_TRX_HI:
      return "TEMP_LP5_TRX_HI";
    case ServerTemperatureSensors.TEMP_LP6_TRX_HI:
      return "TEMP_LP6_TRX_HI";
    case ServerTemperatureSensors.TEMP_LP7_TRX_HI:
      return "TEMP_LP7_TRX_HI";
    case ServerTemperatureSensors.TEMP_LP8_TRX_HI:
      return "TEMP_LP8_TRX_HI";
    case ServerTemperatureSensors.TEMP_FH11_TRX_HI:
      return "TEMP_FH11_TRX_HI";
    case ServerTemperatureSensors.TEMP_CPU1:
      return "TEMP_CPU1";
    case ServerTemperatureSensors.TEMP_CPU2:
      return "TEMP_CPU2";
    case ServerTemperatureSensors.TEMP_GPU1:
      return "TEMP_GPU1";
    case ServerTemperatureSensors.TEMP_GPU2:
      return "TEMP_GPU2";
    case ServerTemperatureSensors.TEMP_GPU3:
      return "TEMP_GPU3";
    case ServerTemperatureSensors.TEMP_GPU4:
      return "TEMP_GPU4";
    case ServerTemperatureSensors.TEMP_GPU5:
      return "TEMP_GPU5";
    case ServerTemperatureSensors.TEMP_GPU6:
      return "TEMP_GPU6";
    case ServerTemperatureSensors.TEMP_GPU7:
      return "TEMP_GPU7";
    case ServerTemperatureSensors.TEMP_GPU8:
      return "TEMP_GPU8";
    case ServerTemperatureSensors.TEMP_GPU1_Memory:
      return "TEMP_GPU1_Memory";
    case ServerTemperatureSensors.TEMP_GPU2_Memory:
      return "TEMP_GPU2_Memory";
    case ServerTemperatureSensors.TEMP_GPU3_Memory:
      return "TEMP_GPU3_Memory";
    case ServerTemperatureSensors.TEMP_GPU4_Memory:
      return "TEMP_GPU4_Memory";
    case ServerTemperatureSensors.TEMP_GPU5_Memory:
      return "TEMP_GPU5_Memory";
    case ServerTemperatureSensors.TEMP_GPU6_Memory:
      return "TEMP_GPU6_Memory";
    case ServerTemperatureSensors.TEMP_GPU7_Memory:
      return "TEMP_GPU7_Memory";
    case ServerTemperatureSensors.TEMP_GPU8_Memory:
      return "TEMP_GPU8_Memory";
    case ServerTemperatureSensors.TEMP_NVME_17:
      return "TEMP_NVME_17";
    case ServerTemperatureSensors.TEMP_NVME_18:
      return "TEMP_NVME_18";
    case ServerTemperatureSensors.TEMP_NVME_19:
      return "TEMP_NVME_19";
    case ServerTemperatureSensors.TEMP_NVME_20:
      return "TEMP_NVME_20";
    case ServerTemperatureSensors.TEMP_OCP:
      return "TEMP_OCP";
    case ServerTemperatureSensors.TEMP_P1_DIMM_ZN1:
      return "TEMP_P1_DIMM_ZN1";
    case ServerTemperatureSensors.TEMP_P1_DIMM_ZN2:
      return "TEMP_P1_DIMM_ZN2";
    case ServerTemperatureSensors.TEMP_P2_DIMM_ZN1:
      return "TEMP_P2_DIMM_ZN1";
    case ServerTemperatureSensors.TEMP_P2_DIMM_ZN2:
      return "TEMP_P2_DIMM_ZN2";
    case ServerTemperatureSensors.TEMP_P1_VR_ZN1:
      return "TEMP_P1_VR_ZN1";
    case ServerTemperatureSensors.TEMP_P1_VR_ZN2:
      return "TEMP_P1_VR_ZN2";
    case ServerTemperatureSensors.TEMP_P1_VR_ZN3:
      return "TEMP_P1_VR_ZN3";
    case ServerTemperatureSensors.TEMP_P2_VR_ZN1:
      return "TEMP_P2_VR_ZN1";
    case ServerTemperatureSensors.TEMP_P2_VR_ZN2:
      return "TEMP_P2_VR_ZN2";
    case ServerTemperatureSensors.TEMP_P2_VR_ZN3:
      return "TEMP_P2_VR_ZN3";
    case ServerTemperatureSensors.TEMP_PCIe9_CHIP:
      return "TEMP_PCIe9_CHIP";
    case ServerTemperatureSensors.TEMP_PCIe9_TRANS:
      return "TEMP_PCIe9_TRANS";
    case ServerTemperatureSensors.TEMP_PCIe10_CHIP:
      return "TEMP_PCIe10_CHIP";
    case ServerTemperatureSensors.TEMP_PCIe10_TRANS:
      return "TEMP_PCIe10_TRANS";
    case ServerTemperatureSensors.TEMP_PCIe11_CHIP:
      return "TEMP_PCIe11_CHIP";
    case ServerTemperatureSensors.TEMP_PCIe11_TRANS:
      return "TEMP_PCIe11_TRANS";
    case ServerTemperatureSensors.TEMP_PCIe12_CHIP:
      return "TEMP_PCIe12_CHIP";
    case ServerTemperatureSensors.TEMP_PCIe12_TRANS:
      return "TEMP_PCIe12_TRANS";
    case ServerTemperatureSensors.TEMP_PCIe13_CHIP:
      return "TEMP_PCIe13_CHIP";
    case ServerTemperatureSensors.TEMP_PCIe13_TRANS:
      return "TEMP_PCIe13_TRANS";
    case ServerTemperatureSensors.TEMP_PSU1:
      return "TEMP_PSU1";
    case ServerTemperatureSensors.TEMP_PSU2:
      return "TEMP_PSU2";
    case ServerTemperatureSensors.TEMP_PSU3:
      return "TEMP_PSU3";
    case ServerTemperatureSensors.TEMP_PSU4:
      return "TEMP_PSU4";
    case ServerTemperatureSensors.TEMP_SW_VR:
      return "TEMP_SW_VR";
    case ServerTemperatureSensors.TEMP_SWITCH1:
      return "TEMP_SWITCH1";
    case ServerTemperatureSensors.TEMP_SWITCH2:
      return "TEMP_SWITCH2";
    case ServerTemperatureSensors.TEMP_PSU5:
      return "TEMP_PSU5";
    case ServerTemperatureSensors.TEMP_PSU6:
      return "TEMP_PSU6";
    case ServerTemperatureSensors.TEMP_PSU7:
      return "TEMP_PSU7";
    case ServerTemperatureSensors.TEMP_PSU8:
      return "TEMP_PSU8";
    case ServerTemperatureSensors.TEMP_PSU9:
      return "TEMP_PSU9";
    case ServerTemperatureSensors.TEMP_PSU10:
      return "TEMP_PSU10";
    case ServerTemperatureSensors.TEMP_PSU11:
      return "TEMP_PSU11";
    case ServerTemperatureSensors.TEMP_PSU12:
      return "TEMP_PSU12";
    case ServerTemperatureSensors.TEMP_CPU0:
      return "TEMP_CPU0";
    case ServerTemperatureSensors.TEMP_CPU0_ABCD:
      return "TEMP_CPU0_ABCD";
    case ServerTemperatureSensors.TEMP_CPU0_EFGH:
      return "TEMP_CPU0_EFGH";
    case ServerTemperatureSensors.TEMP_CPU1_IJKL:
      return "TEMP_CPU1_IJKL";
    case ServerTemperatureSensors.TEMP_CPU1_MNOP:
      return "TEMP_CPU1_MNOP";
    case ServerTemperatureSensors.TEMP_CX7_QSFP0:
      return "TEMP_CX7_QSFP0";
    case ServerTemperatureSensors.TEMP_CX7_QSFP1:
      return "TEMP_CX7_QSFP1";
    case ServerTemperatureSensors.TEMP_CX7_QSFP2:
      return "TEMP_CX7_QSFP2";
    case ServerTemperatureSensors.TEMP_CX7_QSFP3:
      return "TEMP_CX7_QSFP3";
    case ServerTemperatureSensors.TEMP_CX8_0:
      return "TEMP_CX8_0";
    case ServerTemperatureSensors.TEMP_CX8_0_OSFP0:
      return "TEMP_CX8_0_OSFP0";
    case ServerTemperatureSensors.TEMP_CX8_1:
      return "TEMP_CX8_1";
    case ServerTemperatureSensors.TEMP_CX8_1_OSFP0:
      return "TEMP_CX8_1_OSFP0";
    case ServerTemperatureSensors.TEMP_CX8_2:
      return "TEMP_CX8_2";
    case ServerTemperatureSensors.TEMP_CX8_2_OSFP0:
      return "TEMP_CX8_2_OSFP0";
    case ServerTemperatureSensors.TEMP_CX8_3:
      return "TEMP_CX8_3";
    case ServerTemperatureSensors.TEMP_CX8_3_OSFP0:
      return "TEMP_CX8_3_OSFP0";
    case ServerTemperatureSensors.TEMP_CX8_4:
      return "TEMP_CX8_4";
    case ServerTemperatureSensors.TEMP_CX8_4_OSFP0:
      return "TEMP_CX8_4_OSFP0";
    case ServerTemperatureSensors.TEMP_CX8_5:
      return "TEMP_CX8_5";
    case ServerTemperatureSensors.TEMP_CX8_5_OSFP0:
      return "TEMP_CX8_5_OSFP0";
    case ServerTemperatureSensors.TEMP_CX8_6:
      return "TEMP_CX8_6";
    case ServerTemperatureSensors.TEMP_CX8_6_OSFP0:
      return "TEMP_CX8_6_OSFP0";
    case ServerTemperatureSensors.TEMP_CX8_7:
      return "TEMP_CX8_7";
    case ServerTemperatureSensors.TEMP_CX8_7_OSFP0:
      return "TEMP_CX8_7_OSFP0";
    case ServerTemperatureSensors.TEMP_E1S_NVME1:
      return "TEMP_E1S_NVME1";
    case ServerTemperatureSensors.TEMP_E1S_NVME2:
      return "TEMP_E1S_NVME2";
    case ServerTemperatureSensors.TEMP_E1S_NVME3:
      return "TEMP_E1S_NVME3";
    case ServerTemperatureSensors.TEMP_E1S_NVME4:
      return "TEMP_E1S_NVME4";
    case ServerTemperatureSensors.TEMP_E1S_NVME5:
      return "TEMP_E1S_NVME5";
    case ServerTemperatureSensors.TEMP_E1S_NVME6:
      return "TEMP_E1S_NVME6";
    case ServerTemperatureSensors.TEMP_E1S_NVME7:
      return "TEMP_E1S_NVME7";
    case ServerTemperatureSensors.TEMP_E1S_NVME8:
      return "TEMP_E1S_NVME8";
    case ServerTemperatureSensors.TEMP_GB1_INLET1:
      return "TEMP_GB1_INLET1";
    case ServerTemperatureSensors.TEMP_GB1_INLET2:
      return "TEMP_GB1_INLET2";
    case ServerTemperatureSensors.TEMP_GB_CX8MCU_1:
      return "TEMP_GB_CX8MCU_1";
    case ServerTemperatureSensors.TEMP_GB_CX8MCU_2:
      return "TEMP_GB_CX8MCU_2";
    case ServerTemperatureSensors.TEMP_GB_CX8MCU_3:
      return "TEMP_GB_CX8MCU_3";
    case ServerTemperatureSensors.TEMP_GB_CX8MCU_4:
      return "TEMP_GB_CX8MCU_4";
    case ServerTemperatureSensors.TEMP_GB_HMC:
      return "TEMP_GB_HMC";
    case ServerTemperatureSensors.TEMP_GB_HSCC1:
      return "TEMP_GB_HSCC1";
    case ServerTemperatureSensors.TEMP_GB_HSCC2:
      return "TEMP_GB_HSCC2";
    case ServerTemperatureSensors.TEMP_GB_HSCC3:
      return "TEMP_GB_HSCC3";
    case ServerTemperatureSensors.TEMP_GB_HSCC4:
      return "TEMP_GB_HSCC4";
    case ServerTemperatureSensors.TEMP_GB_HSCC5:
      return "TEMP_GB_HSCC5";
    case ServerTemperatureSensors.TEMP_GB_MCU_1:
      return "TEMP_GB_MCU_1";
    case ServerTemperatureSensors.TEMP_GB_MCU_2:
      return "TEMP_GB_MCU_2";
    case ServerTemperatureSensors.TEMP_GB_MCU_3:
      return "TEMP_GB_MCU_3";
    case ServerTemperatureSensors.TEMP_GB_MCU_4:
      return "TEMP_GB_MCU_4";
    case ServerTemperatureSensors.TEMP_GB_MCU_5:
      return "TEMP_GB_MCU_5";
    case ServerTemperatureSensors.TEMP_GB_MCU_6:
      return "TEMP_GB_MCU_6";
    case ServerTemperatureSensors.TEMP_GB_MCU_7:
      return "TEMP_GB_MCU_7";
    case ServerTemperatureSensors.TEMP_GB_MCU_8:
      return "TEMP_GB_MCU_8";
    case ServerTemperatureSensors.TEMP_GB_SXM1:
      return "TEMP_GB_SXM1";
    case ServerTemperatureSensors.TEMP_GB_SXM1_M:
      return "TEMP_GB_SXM1_M";
    case ServerTemperatureSensors.TEMP_GB_SXM2:
      return "TEMP_GB_SXM2";
    case ServerTemperatureSensors.TEMP_GB_SXM2_M:
      return "TEMP_GB_SXM2_M";
    case ServerTemperatureSensors.TEMP_GB_SXM3:
      return "TEMP_GB_SXM3";
    case ServerTemperatureSensors.TEMP_GB_SXM3_M:
      return "TEMP_GB_SXM3_M";
    case ServerTemperatureSensors.TEMP_GB_SXM4:
      return "TEMP_GB_SXM4";
    case ServerTemperatureSensors.TEMP_GB_SXM4_M:
      return "TEMP_GB_SXM4_M";
    case ServerTemperatureSensors.TEMP_GB_SXM5:
      return "TEMP_GB_SXM5";
    case ServerTemperatureSensors.TEMP_GB_SXM5_M:
      return "TEMP_GB_SXM5_M";
    case ServerTemperatureSensors.TEMP_GB_SXM6:
      return "TEMP_GB_SXM6";
    case ServerTemperatureSensors.TEMP_GB_SXM6_M:
      return "TEMP_GB_SXM6_M";
    case ServerTemperatureSensors.TEMP_GB_SXM7:
      return "TEMP_GB_SXM7";
    case ServerTemperatureSensors.TEMP_GB_SXM7_M:
      return "TEMP_GB_SXM7_M";
    case ServerTemperatureSensors.TEMP_GB_SXM8:
      return "TEMP_GB_SXM8";
    case ServerTemperatureSensors.TEMP_GB_SXM8_M:
      return "TEMP_GB_SXM8_M";
    case ServerTemperatureSensors.TEMP_M_2_RISER:
      return "TEMP_M_2_RISER";
    case ServerTemperatureSensors.TEMP_MB_1G_LAN:
      return "TEMP_MB_1G_LAN";
    case ServerTemperatureSensors.TEMP_MB_HV_CPU0:
      return "TEMP_MB_HV_CPU0";
    case ServerTemperatureSensors.TEMP_MB_HV_CPU1:
      return "TEMP_MB_HV_CPU1";
    case ServerTemperatureSensors.TEMP_MB_INF_CPU0:
      return "TEMP_MB_INF_CPU0";
    case ServerTemperatureSensors.TEMP_MB_INF_CPU1:
      return "TEMP_MB_INF_CPU1";
    case ServerTemperatureSensors.TEMP_MB_INLET:
      return "TEMP_MB_INLET";
    case ServerTemperatureSensors.TEMP_MB_VRM0:
      return "TEMP_MB_VRM0";
    case ServerTemperatureSensors.TEMP_MB_VRM1:
      return "TEMP_MB_VRM1";
    case ServerTemperatureSensors.TEMP_PCIE_CX7_1:
      return "TEMP_PCIE_CX7_1";
    case ServerTemperatureSensors.TEMP_PCIE_CX7_2:
      return "TEMP_PCIE_CX7_2";
    case ServerTemperatureSensors.TEMP_PCIE_SW_0:
      return "TEMP_PCIE_SW_0";
    case ServerTemperatureSensors.TEMP_PCIE_SW_1:
      return "TEMP_PCIE_SW_1";
    case ServerTemperatureSensors.TEMP_PDB0:
      return "TEMP_PDB0";
    case ServerTemperatureSensors.TEMP_PDB1:
      return "TEMP_PDB1";
    case ServerTemperatureSensors.TEMP_PDB_FAN_HSC:
      return "TEMP_PDB_FAN_HSC";
    case ServerTemperatureSensors.TEMP_PDB_VRM:
      return "TEMP_PDB_VRM";
    case ServerTemperatureSensors.TEMP_VR_CPU0:
      return "TEMP_VR_CPU0";
    case ServerTemperatureSensors.TEMP_VR_CPU1:
      return "TEMP_VR_CPU1";
    case ServerTemperatureSensors.TEMP_DCSCM_0:
      return "TEMP_DCSCM_0";
    case ServerTemperatureSensors.TLIMIT_GB_SXM1:
      return "TLIMIT_GB_SXM1";
    case ServerTemperatureSensors.TLIMIT_GB_SXM2:
      return "TLIMIT_GB_SXM2";
    case ServerTemperatureSensors.TLIMIT_GB_SXM3:
      return "TLIMIT_GB_SXM3";
    case ServerTemperatureSensors.TLIMIT_GB_SXM4:
      return "TLIMIT_GB_SXM4";
    case ServerTemperatureSensors.TLIMIT_GB_SXM5:
      return "TLIMIT_GB_SXM5";
    case ServerTemperatureSensors.TLIMIT_GB_SXM6:
      return "TLIMIT_GB_SXM6";
    case ServerTemperatureSensors.TLIMIT_GB_SXM7:
      return "TLIMIT_GB_SXM7";
    case ServerTemperatureSensors.TLIMIT_GB_SXM8:
      return "TLIMIT_GB_SXM8";
    case ServerTemperatureSensors.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TLSVerifyError {
  /** ERROR_OK - No error. Verification is successful */
  ERROR_OK = 0,
  /** UNKNOWN_ERROR - Unknown Error. Should not happen */
  UNKNOWN_ERROR = 1,
  /** NOT_AUTHORIZED_TO_SIGN - results when a certificate is signed by another which isn't marked as a CA certificate. */
  NOT_AUTHORIZED_TO_SIGN = 2,
  /** CERTIFICATE_EXPIRED - results when a certificate has expired, based on the time in the VerifyOptions. */
  CERTIFICATE_EXPIRED = 3,
  /** CA_NOT_AUTHORIZED_FOR_THIS_NAME - results when an intermediate or root certificate has a name constraint which doesn't permit a DNS or other name (including IP address) in the leaf certificate. */
  CA_NOT_AUTHORIZED_FOR_THIS_NAME = 4,
  /** TOO_MANY_INTERMEDIATES - results when a path length constraint is violated. */
  TOO_MANY_INTERMEDIATES = 5,
  /** INCOMPATIBLE_USAGE - results when the certificate's key usage indicates that it may only be used for a different purpose. */
  INCOMPATIBLE_USAGE = 6,
  /** NAME_MISMATCH - results when the subject name of a parent certificate does not match the issuer name in the child. */
  NAME_MISMATCH = 7,
  /** NAME_CONSTRAINTS_WITHOUT_SANS - is a legacy error and is no longer returned. */
  NAME_CONSTRAINTS_WITHOUT_SANS = 8,
  /** UNCONSTRAINED_NAME - results when a CA certificate contains permitted name constraints, but leaf certificate contains a name of an unsupported or unconstrained type. */
  UNCONSTRAINED_NAME = 9,
  /** TOO_MANY_CONSTRAINTS - results when the number of comparison operations needed to check a certificate exceeds the limit set by VerifyOptions.MaxConstraintComparisions. This limit exists to prevent pathological certificates can consuming excessive amounts of CPU time to verify. */
  TOO_MANY_CONSTRAINTS = 10,
  /** CA_NOT_AUTHORIZED_FOR_EXTKEYUSAGE - results when an intermediate or root certificate does not permit a requested extended key usage. */
  CA_NOT_AUTHORIZED_FOR_EXTKEYUSAGE = 11,
  /** HOST_NAME_ERROR - results when the set of authorized names doesn't match the requested name. */
  HOST_NAME_ERROR = 12,
  /** UNKNOWN_AUTHORITY_ERROR - results when the certificate issuer is unknown */
  UNKNOWN_AUTHORITY_ERROR = 13,
  /** SYSTEM_ROOTS_ERROR - results when we fail to load the system root certificates. */
  SYSTEM_ROOTS_ERROR = 14,
  UNRECOGNIZED = -1,
}

export function tLSVerifyErrorFromJSON(object: any): TLSVerifyError {
  switch (object) {
    case 0:
    case "ERROR_OK":
      return TLSVerifyError.ERROR_OK;
    case 1:
    case "UNKNOWN_ERROR":
      return TLSVerifyError.UNKNOWN_ERROR;
    case 2:
    case "NOT_AUTHORIZED_TO_SIGN":
      return TLSVerifyError.NOT_AUTHORIZED_TO_SIGN;
    case 3:
    case "CERTIFICATE_EXPIRED":
      return TLSVerifyError.CERTIFICATE_EXPIRED;
    case 4:
    case "CA_NOT_AUTHORIZED_FOR_THIS_NAME":
      return TLSVerifyError.CA_NOT_AUTHORIZED_FOR_THIS_NAME;
    case 5:
    case "TOO_MANY_INTERMEDIATES":
      return TLSVerifyError.TOO_MANY_INTERMEDIATES;
    case 6:
    case "INCOMPATIBLE_USAGE":
      return TLSVerifyError.INCOMPATIBLE_USAGE;
    case 7:
    case "NAME_MISMATCH":
      return TLSVerifyError.NAME_MISMATCH;
    case 8:
    case "NAME_CONSTRAINTS_WITHOUT_SANS":
      return TLSVerifyError.NAME_CONSTRAINTS_WITHOUT_SANS;
    case 9:
    case "UNCONSTRAINED_NAME":
      return TLSVerifyError.UNCONSTRAINED_NAME;
    case 10:
    case "TOO_MANY_CONSTRAINTS":
      return TLSVerifyError.TOO_MANY_CONSTRAINTS;
    case 11:
    case "CA_NOT_AUTHORIZED_FOR_EXTKEYUSAGE":
      return TLSVerifyError.CA_NOT_AUTHORIZED_FOR_EXTKEYUSAGE;
    case 12:
    case "HOST_NAME_ERROR":
      return TLSVerifyError.HOST_NAME_ERROR;
    case 13:
    case "UNKNOWN_AUTHORITY_ERROR":
      return TLSVerifyError.UNKNOWN_AUTHORITY_ERROR;
    case 14:
    case "SYSTEM_ROOTS_ERROR":
      return TLSVerifyError.SYSTEM_ROOTS_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TLSVerifyError.UNRECOGNIZED;
  }
}

export function tLSVerifyErrorToJSON(object: TLSVerifyError): string {
  switch (object) {
    case TLSVerifyError.ERROR_OK:
      return "ERROR_OK";
    case TLSVerifyError.UNKNOWN_ERROR:
      return "UNKNOWN_ERROR";
    case TLSVerifyError.NOT_AUTHORIZED_TO_SIGN:
      return "NOT_AUTHORIZED_TO_SIGN";
    case TLSVerifyError.CERTIFICATE_EXPIRED:
      return "CERTIFICATE_EXPIRED";
    case TLSVerifyError.CA_NOT_AUTHORIZED_FOR_THIS_NAME:
      return "CA_NOT_AUTHORIZED_FOR_THIS_NAME";
    case TLSVerifyError.TOO_MANY_INTERMEDIATES:
      return "TOO_MANY_INTERMEDIATES";
    case TLSVerifyError.INCOMPATIBLE_USAGE:
      return "INCOMPATIBLE_USAGE";
    case TLSVerifyError.NAME_MISMATCH:
      return "NAME_MISMATCH";
    case TLSVerifyError.NAME_CONSTRAINTS_WITHOUT_SANS:
      return "NAME_CONSTRAINTS_WITHOUT_SANS";
    case TLSVerifyError.UNCONSTRAINED_NAME:
      return "UNCONSTRAINED_NAME";
    case TLSVerifyError.TOO_MANY_CONSTRAINTS:
      return "TOO_MANY_CONSTRAINTS";
    case TLSVerifyError.CA_NOT_AUTHORIZED_FOR_EXTKEYUSAGE:
      return "CA_NOT_AUTHORIZED_FOR_EXTKEYUSAGE";
    case TLSVerifyError.HOST_NAME_ERROR:
      return "HOST_NAME_ERROR";
    case TLSVerifyError.UNKNOWN_AUTHORITY_ERROR:
      return "UNKNOWN_AUTHORITY_ERROR";
    case TLSVerifyError.SYSTEM_ROOTS_ERROR:
      return "SYSTEM_ROOTS_ERROR";
    case TLSVerifyError.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TlsConnectionState {
  TLS_CONNECTION_STATE_UNSPECIFIED = 0,
  CONNECTING = 1,
  CONNECTED = 2,
  DISCONNECTED = 3,
  CONNECTION_FAILED = 4,
  UNRECOGNIZED = -1,
}

export function tlsConnectionStateFromJSON(object: any): TlsConnectionState {
  switch (object) {
    case 0:
    case "TLS_CONNECTION_STATE_UNSPECIFIED":
      return TlsConnectionState.TLS_CONNECTION_STATE_UNSPECIFIED;
    case 1:
    case "CONNECTING":
      return TlsConnectionState.CONNECTING;
    case 2:
    case "CONNECTED":
      return TlsConnectionState.CONNECTED;
    case 3:
    case "DISCONNECTED":
      return TlsConnectionState.DISCONNECTED;
    case 4:
    case "CONNECTION_FAILED":
      return TlsConnectionState.CONNECTION_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TlsConnectionState.UNRECOGNIZED;
  }
}

export function tlsConnectionStateToJSON(object: TlsConnectionState): string {
  switch (object) {
    case TlsConnectionState.TLS_CONNECTION_STATE_UNSPECIFIED:
      return "TLS_CONNECTION_STATE_UNSPECIFIED";
    case TlsConnectionState.CONNECTING:
      return "CONNECTING";
    case TlsConnectionState.CONNECTED:
      return "CONNECTED";
    case TlsConnectionState.DISCONNECTED:
      return "DISCONNECTED";
    case TlsConnectionState.CONNECTION_FAILED:
      return "CONNECTION_FAILED";
    case TlsConnectionState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TlsSessionState {
  TLS_SESSION_STATE_UNSPECIFIED = 0,
  VERIFY_IN_PROGRESS = 1,
  VERIFY_INVALID = 2,
  VERIFY_VALID = 3,
  UNRECOGNIZED = -1,
}

export function tlsSessionStateFromJSON(object: any): TlsSessionState {
  switch (object) {
    case 0:
    case "TLS_SESSION_STATE_UNSPECIFIED":
      return TlsSessionState.TLS_SESSION_STATE_UNSPECIFIED;
    case 1:
    case "VERIFY_IN_PROGRESS":
      return TlsSessionState.VERIFY_IN_PROGRESS;
    case 2:
    case "VERIFY_INVALID":
      return TlsSessionState.VERIFY_INVALID;
    case 3:
    case "VERIFY_VALID":
      return TlsSessionState.VERIFY_VALID;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TlsSessionState.UNRECOGNIZED;
  }
}

export function tlsSessionStateToJSON(object: TlsSessionState): string {
  switch (object) {
    case TlsSessionState.TLS_SESSION_STATE_UNSPECIFIED:
      return "TLS_SESSION_STATE_UNSPECIFIED";
    case TlsSessionState.VERIFY_IN_PROGRESS:
      return "VERIFY_IN_PROGRESS";
    case TlsSessionState.VERIFY_INVALID:
      return "VERIFY_INVALID";
    case TlsSessionState.VERIFY_VALID:
      return "VERIFY_VALID";
    case TlsSessionState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ProxyAuthState {
  CLOUD_AUTH_UNSPECIFIED = 0,
  CLOUD_AUTH_IN_PROGRESS = 1,
  CLOUD_AUTH_DONE = 2,
  CLOUD_AUTH_FAILED = 3,
  /** CLOUD_AUTH_NONE - When would we have NONE as a valid state? */
  CLOUD_AUTH_NONE = 4,
  UNRECOGNIZED = -1,
}

export function proxyAuthStateFromJSON(object: any): ProxyAuthState {
  switch (object) {
    case 0:
    case "CLOUD_AUTH_UNSPECIFIED":
      return ProxyAuthState.CLOUD_AUTH_UNSPECIFIED;
    case 1:
    case "CLOUD_AUTH_IN_PROGRESS":
      return ProxyAuthState.CLOUD_AUTH_IN_PROGRESS;
    case 2:
    case "CLOUD_AUTH_DONE":
      return ProxyAuthState.CLOUD_AUTH_DONE;
    case 3:
    case "CLOUD_AUTH_FAILED":
      return ProxyAuthState.CLOUD_AUTH_FAILED;
    case 4:
    case "CLOUD_AUTH_NONE":
      return ProxyAuthState.CLOUD_AUTH_NONE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ProxyAuthState.UNRECOGNIZED;
  }
}

export function proxyAuthStateToJSON(object: ProxyAuthState): string {
  switch (object) {
    case ProxyAuthState.CLOUD_AUTH_UNSPECIFIED:
      return "CLOUD_AUTH_UNSPECIFIED";
    case ProxyAuthState.CLOUD_AUTH_IN_PROGRESS:
      return "CLOUD_AUTH_IN_PROGRESS";
    case ProxyAuthState.CLOUD_AUTH_DONE:
      return "CLOUD_AUTH_DONE";
    case ProxyAuthState.CLOUD_AUTH_FAILED:
      return "CLOUD_AUTH_FAILED";
    case ProxyAuthState.CLOUD_AUTH_NONE:
      return "CLOUD_AUTH_NONE";
    case ProxyAuthState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum LivenessStatus {
  LIVENESS_ADMIN_DOWN = 0,
  LIVENESS_UP = 1,
  LIVENESS_DOWN = 2,
  UNRECOGNIZED = -1,
}

export function livenessStatusFromJSON(object: any): LivenessStatus {
  switch (object) {
    case 0:
    case "LIVENESS_ADMIN_DOWN":
      return LivenessStatus.LIVENESS_ADMIN_DOWN;
    case 1:
    case "LIVENESS_UP":
      return LivenessStatus.LIVENESS_UP;
    case 2:
    case "LIVENESS_DOWN":
      return LivenessStatus.LIVENESS_DOWN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LivenessStatus.UNRECOGNIZED;
  }
}

export function livenessStatusToJSON(object: LivenessStatus): string {
  switch (object) {
    case LivenessStatus.LIVENESS_ADMIN_DOWN:
      return "LIVENESS_ADMIN_DOWN";
    case LivenessStatus.LIVENESS_UP:
      return "LIVENESS_UP";
    case LivenessStatus.LIVENESS_DOWN:
      return "LIVENESS_DOWN";
    case LivenessStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum L2FdbEntryType {
  L2_FDB_ENTRY_TYPE_UNSPECIFIED = 0,
  L2_FDB_ENTRY_TYPE_LOCAL = 1,
  L2_FDB_ENTRY_TYPE_REMOTE = 2,
  L2_FDB_ENTRY_TYPE_STATIC = 3,
  UNRECOGNIZED = -1,
}

export function l2FdbEntryTypeFromJSON(object: any): L2FdbEntryType {
  switch (object) {
    case 0:
    case "L2_FDB_ENTRY_TYPE_UNSPECIFIED":
      return L2FdbEntryType.L2_FDB_ENTRY_TYPE_UNSPECIFIED;
    case 1:
    case "L2_FDB_ENTRY_TYPE_LOCAL":
      return L2FdbEntryType.L2_FDB_ENTRY_TYPE_LOCAL;
    case 2:
    case "L2_FDB_ENTRY_TYPE_REMOTE":
      return L2FdbEntryType.L2_FDB_ENTRY_TYPE_REMOTE;
    case 3:
    case "L2_FDB_ENTRY_TYPE_STATIC":
      return L2FdbEntryType.L2_FDB_ENTRY_TYPE_STATIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return L2FdbEntryType.UNRECOGNIZED;
  }
}

export function l2FdbEntryTypeToJSON(object: L2FdbEntryType): string {
  switch (object) {
    case L2FdbEntryType.L2_FDB_ENTRY_TYPE_UNSPECIFIED:
      return "L2_FDB_ENTRY_TYPE_UNSPECIFIED";
    case L2FdbEntryType.L2_FDB_ENTRY_TYPE_LOCAL:
      return "L2_FDB_ENTRY_TYPE_LOCAL";
    case L2FdbEntryType.L2_FDB_ENTRY_TYPE_REMOTE:
      return "L2_FDB_ENTRY_TYPE_REMOTE";
    case L2FdbEntryType.L2_FDB_ENTRY_TYPE_STATIC:
      return "L2_FDB_ENTRY_TYPE_STATIC";
    case L2FdbEntryType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum L2FdbEntryLocatorType {
  L2_FDB_LOCATOR_ENTRY_TYPE_UNSPECIFIED = 0,
  L2_FDB_LOCATOR_ENTRY_TYPE_INTERFACE = 1,
  L2_FDB_LOCATOR_ENTRY_TYPE_REMOTE_VTEP = 2,
  L2_FDB_LOCATOR_ENTRY_TYPE_REMOTE_ESI = 3,
  UNRECOGNIZED = -1,
}

export function l2FdbEntryLocatorTypeFromJSON(object: any): L2FdbEntryLocatorType {
  switch (object) {
    case 0:
    case "L2_FDB_LOCATOR_ENTRY_TYPE_UNSPECIFIED":
      return L2FdbEntryLocatorType.L2_FDB_LOCATOR_ENTRY_TYPE_UNSPECIFIED;
    case 1:
    case "L2_FDB_LOCATOR_ENTRY_TYPE_INTERFACE":
      return L2FdbEntryLocatorType.L2_FDB_LOCATOR_ENTRY_TYPE_INTERFACE;
    case 2:
    case "L2_FDB_LOCATOR_ENTRY_TYPE_REMOTE_VTEP":
      return L2FdbEntryLocatorType.L2_FDB_LOCATOR_ENTRY_TYPE_REMOTE_VTEP;
    case 3:
    case "L2_FDB_LOCATOR_ENTRY_TYPE_REMOTE_ESI":
      return L2FdbEntryLocatorType.L2_FDB_LOCATOR_ENTRY_TYPE_REMOTE_ESI;
    case -1:
    case "UNRECOGNIZED":
    default:
      return L2FdbEntryLocatorType.UNRECOGNIZED;
  }
}

export function l2FdbEntryLocatorTypeToJSON(object: L2FdbEntryLocatorType): string {
  switch (object) {
    case L2FdbEntryLocatorType.L2_FDB_LOCATOR_ENTRY_TYPE_UNSPECIFIED:
      return "L2_FDB_LOCATOR_ENTRY_TYPE_UNSPECIFIED";
    case L2FdbEntryLocatorType.L2_FDB_LOCATOR_ENTRY_TYPE_INTERFACE:
      return "L2_FDB_LOCATOR_ENTRY_TYPE_INTERFACE";
    case L2FdbEntryLocatorType.L2_FDB_LOCATOR_ENTRY_TYPE_REMOTE_VTEP:
      return "L2_FDB_LOCATOR_ENTRY_TYPE_REMOTE_VTEP";
    case L2FdbEntryLocatorType.L2_FDB_LOCATOR_ENTRY_TYPE_REMOTE_ESI:
      return "L2_FDB_LOCATOR_ENTRY_TYPE_REMOTE_ESI";
    case L2FdbEntryLocatorType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum L2FdbRemoteEntryLocation {
  L2_FDB_REMOTE_ENTRY_LOCATION_UNSPECIFIED = 0,
  L2_FDB_REMOTE_ENTRY_LOCATION_LOCAL_FABRIC = 1,
  L2_FDB_REMOTE_ENTRY_LOCATION_REMOTE_FABRIC = 2,
  UNRECOGNIZED = -1,
}

export function l2FdbRemoteEntryLocationFromJSON(object: any): L2FdbRemoteEntryLocation {
  switch (object) {
    case 0:
    case "L2_FDB_REMOTE_ENTRY_LOCATION_UNSPECIFIED":
      return L2FdbRemoteEntryLocation.L2_FDB_REMOTE_ENTRY_LOCATION_UNSPECIFIED;
    case 1:
    case "L2_FDB_REMOTE_ENTRY_LOCATION_LOCAL_FABRIC":
      return L2FdbRemoteEntryLocation.L2_FDB_REMOTE_ENTRY_LOCATION_LOCAL_FABRIC;
    case 2:
    case "L2_FDB_REMOTE_ENTRY_LOCATION_REMOTE_FABRIC":
      return L2FdbRemoteEntryLocation.L2_FDB_REMOTE_ENTRY_LOCATION_REMOTE_FABRIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return L2FdbRemoteEntryLocation.UNRECOGNIZED;
  }
}

export function l2FdbRemoteEntryLocationToJSON(object: L2FdbRemoteEntryLocation): string {
  switch (object) {
    case L2FdbRemoteEntryLocation.L2_FDB_REMOTE_ENTRY_LOCATION_UNSPECIFIED:
      return "L2_FDB_REMOTE_ENTRY_LOCATION_UNSPECIFIED";
    case L2FdbRemoteEntryLocation.L2_FDB_REMOTE_ENTRY_LOCATION_LOCAL_FABRIC:
      return "L2_FDB_REMOTE_ENTRY_LOCATION_LOCAL_FABRIC";
    case L2FdbRemoteEntryLocation.L2_FDB_REMOTE_ENTRY_LOCATION_REMOTE_FABRIC:
      return "L2_FDB_REMOTE_ENTRY_LOCATION_REMOTE_FABRIC";
    case L2FdbRemoteEntryLocation.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SpyglassSessionStatus {
  SPYGLASS_SESSION_STATUS_UNSPECIFIED = 0,
  SPYGLASS_SESSION_INVALID = 1,
  SPYGLASS_SESSION_INIT = 2,
  SPYGLASS_SESSION_READY_LOCAL = 3,
  SPYGLASS_SESSION_CONNECTED = 4,
  SPYGLASS_SESSION_COMPLETE = 5,
  UNRECOGNIZED = -1,
}

export function spyglassSessionStatusFromJSON(object: any): SpyglassSessionStatus {
  switch (object) {
    case 0:
    case "SPYGLASS_SESSION_STATUS_UNSPECIFIED":
      return SpyglassSessionStatus.SPYGLASS_SESSION_STATUS_UNSPECIFIED;
    case 1:
    case "SPYGLASS_SESSION_INVALID":
      return SpyglassSessionStatus.SPYGLASS_SESSION_INVALID;
    case 2:
    case "SPYGLASS_SESSION_INIT":
      return SpyglassSessionStatus.SPYGLASS_SESSION_INIT;
    case 3:
    case "SPYGLASS_SESSION_READY_LOCAL":
      return SpyglassSessionStatus.SPYGLASS_SESSION_READY_LOCAL;
    case 4:
    case "SPYGLASS_SESSION_CONNECTED":
      return SpyglassSessionStatus.SPYGLASS_SESSION_CONNECTED;
    case 5:
    case "SPYGLASS_SESSION_COMPLETE":
      return SpyglassSessionStatus.SPYGLASS_SESSION_COMPLETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SpyglassSessionStatus.UNRECOGNIZED;
  }
}

export function spyglassSessionStatusToJSON(object: SpyglassSessionStatus): string {
  switch (object) {
    case SpyglassSessionStatus.SPYGLASS_SESSION_STATUS_UNSPECIFIED:
      return "SPYGLASS_SESSION_STATUS_UNSPECIFIED";
    case SpyglassSessionStatus.SPYGLASS_SESSION_INVALID:
      return "SPYGLASS_SESSION_INVALID";
    case SpyglassSessionStatus.SPYGLASS_SESSION_INIT:
      return "SPYGLASS_SESSION_INIT";
    case SpyglassSessionStatus.SPYGLASS_SESSION_READY_LOCAL:
      return "SPYGLASS_SESSION_READY_LOCAL";
    case SpyglassSessionStatus.SPYGLASS_SESSION_CONNECTED:
      return "SPYGLASS_SESSION_CONNECTED";
    case SpyglassSessionStatus.SPYGLASS_SESSION_COMPLETE:
      return "SPYGLASS_SESSION_COMPLETE";
    case SpyglassSessionStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RemedyActionCode {
  REMEDY_ACTION_UNSPECIFIED = 0,
  FIX_CONNECTION = 1,
  ADD_MISSING_CONNECTION = 2,
  REMOVE_UNEXPECTED_CONNECTION = 3,
  UNRECOGNIZED = -1,
}

export function remedyActionCodeFromJSON(object: any): RemedyActionCode {
  switch (object) {
    case 0:
    case "REMEDY_ACTION_UNSPECIFIED":
      return RemedyActionCode.REMEDY_ACTION_UNSPECIFIED;
    case 1:
    case "FIX_CONNECTION":
      return RemedyActionCode.FIX_CONNECTION;
    case 2:
    case "ADD_MISSING_CONNECTION":
      return RemedyActionCode.ADD_MISSING_CONNECTION;
    case 3:
    case "REMOVE_UNEXPECTED_CONNECTION":
      return RemedyActionCode.REMOVE_UNEXPECTED_CONNECTION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RemedyActionCode.UNRECOGNIZED;
  }
}

export function remedyActionCodeToJSON(object: RemedyActionCode): string {
  switch (object) {
    case RemedyActionCode.REMEDY_ACTION_UNSPECIFIED:
      return "REMEDY_ACTION_UNSPECIFIED";
    case RemedyActionCode.FIX_CONNECTION:
      return "FIX_CONNECTION";
    case RemedyActionCode.ADD_MISSING_CONNECTION:
      return "ADD_MISSING_CONNECTION";
    case RemedyActionCode.REMOVE_UNEXPECTED_CONNECTION:
      return "REMOVE_UNEXPECTED_CONNECTION";
    case RemedyActionCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum NeighborType {
  UNKNOWN_NEIGHBOR_TYPE = 0,
  /** DRAKE_FABRIC - Our neighbor is a Tortuga node and part of the same fabric */
  DRAKE_FABRIC = 1,
  /** DRAKE_NOT_FABRIC - Our neighbor is a Tortuga node but not part of our fabric */
  DRAKE_NOT_FABRIC = 2,
  UNRECOGNIZED = -1,
}

export function neighborTypeFromJSON(object: any): NeighborType {
  switch (object) {
    case 0:
    case "UNKNOWN_NEIGHBOR_TYPE":
      return NeighborType.UNKNOWN_NEIGHBOR_TYPE;
    case 1:
    case "DRAKE_FABRIC":
      return NeighborType.DRAKE_FABRIC;
    case 2:
    case "DRAKE_NOT_FABRIC":
      return NeighborType.DRAKE_NOT_FABRIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NeighborType.UNRECOGNIZED;
  }
}

export function neighborTypeToJSON(object: NeighborType): string {
  switch (object) {
    case NeighborType.UNKNOWN_NEIGHBOR_TYPE:
      return "UNKNOWN_NEIGHBOR_TYPE";
    case NeighborType.DRAKE_FABRIC:
      return "DRAKE_FABRIC";
    case NeighborType.DRAKE_NOT_FABRIC:
      return "DRAKE_NOT_FABRIC";
    case NeighborType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FecType {
  FEC_TYPE_UNSPECIFIED = 0,
  FEC_TYPE_NONE = 1,
  FEC_TYPE_RS = 2,
  FEC_TYPE_FC = 3,
  FEC_TYPE_BASER = 4,
  UNRECOGNIZED = -1,
}

export function fecTypeFromJSON(object: any): FecType {
  switch (object) {
    case 0:
    case "FEC_TYPE_UNSPECIFIED":
      return FecType.FEC_TYPE_UNSPECIFIED;
    case 1:
    case "FEC_TYPE_NONE":
      return FecType.FEC_TYPE_NONE;
    case 2:
    case "FEC_TYPE_RS":
      return FecType.FEC_TYPE_RS;
    case 3:
    case "FEC_TYPE_FC":
      return FecType.FEC_TYPE_FC;
    case 4:
    case "FEC_TYPE_BASER":
      return FecType.FEC_TYPE_BASER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FecType.UNRECOGNIZED;
  }
}

export function fecTypeToJSON(object: FecType): string {
  switch (object) {
    case FecType.FEC_TYPE_UNSPECIFIED:
      return "FEC_TYPE_UNSPECIFIED";
    case FecType.FEC_TYPE_NONE:
      return "FEC_TYPE_NONE";
    case FecType.FEC_TYPE_RS:
      return "FEC_TYPE_RS";
    case FecType.FEC_TYPE_FC:
      return "FEC_TYPE_FC";
    case FecType.FEC_TYPE_BASER:
      return "FEC_TYPE_BASER";
    case FecType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AutoPortCfgState {
  AUTO_PORT_CFG_STATE_UNSPECIFIED = 0,
  AUTO_PORT_CFG_STATE_NOT_APPLIED = 1,
  AUTO_PORT_CFG_STATE_MANUAL = 2,
  AUTO_PORT_CFG_STATE_AUTO = 3,
  UNRECOGNIZED = -1,
}

export function autoPortCfgStateFromJSON(object: any): AutoPortCfgState {
  switch (object) {
    case 0:
    case "AUTO_PORT_CFG_STATE_UNSPECIFIED":
      return AutoPortCfgState.AUTO_PORT_CFG_STATE_UNSPECIFIED;
    case 1:
    case "AUTO_PORT_CFG_STATE_NOT_APPLIED":
      return AutoPortCfgState.AUTO_PORT_CFG_STATE_NOT_APPLIED;
    case 2:
    case "AUTO_PORT_CFG_STATE_MANUAL":
      return AutoPortCfgState.AUTO_PORT_CFG_STATE_MANUAL;
    case 3:
    case "AUTO_PORT_CFG_STATE_AUTO":
      return AutoPortCfgState.AUTO_PORT_CFG_STATE_AUTO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AutoPortCfgState.UNRECOGNIZED;
  }
}

export function autoPortCfgStateToJSON(object: AutoPortCfgState): string {
  switch (object) {
    case AutoPortCfgState.AUTO_PORT_CFG_STATE_UNSPECIFIED:
      return "AUTO_PORT_CFG_STATE_UNSPECIFIED";
    case AutoPortCfgState.AUTO_PORT_CFG_STATE_NOT_APPLIED:
      return "AUTO_PORT_CFG_STATE_NOT_APPLIED";
    case AutoPortCfgState.AUTO_PORT_CFG_STATE_MANUAL:
      return "AUTO_PORT_CFG_STATE_MANUAL";
    case AutoPortCfgState.AUTO_PORT_CFG_STATE_AUTO:
      return "AUTO_PORT_CFG_STATE_AUTO";
    case AutoPortCfgState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum VlanTaggingMode {
  VLAN_TAGGING_MODE_UNSPECIFIED = 0,
  VLAN_TAGGING_MODE_TAGGED = 1,
  VLAN_TAGGING_MODE_UNTAGGED = 2,
  VLAN_TAGGING_MODE_PRIORITY_TAGGED = 3,
  UNRECOGNIZED = -1,
}

export function vlanTaggingModeFromJSON(object: any): VlanTaggingMode {
  switch (object) {
    case 0:
    case "VLAN_TAGGING_MODE_UNSPECIFIED":
      return VlanTaggingMode.VLAN_TAGGING_MODE_UNSPECIFIED;
    case 1:
    case "VLAN_TAGGING_MODE_TAGGED":
      return VlanTaggingMode.VLAN_TAGGING_MODE_TAGGED;
    case 2:
    case "VLAN_TAGGING_MODE_UNTAGGED":
      return VlanTaggingMode.VLAN_TAGGING_MODE_UNTAGGED;
    case 3:
    case "VLAN_TAGGING_MODE_PRIORITY_TAGGED":
      return VlanTaggingMode.VLAN_TAGGING_MODE_PRIORITY_TAGGED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VlanTaggingMode.UNRECOGNIZED;
  }
}

export function vlanTaggingModeToJSON(object: VlanTaggingMode): string {
  switch (object) {
    case VlanTaggingMode.VLAN_TAGGING_MODE_UNSPECIFIED:
      return "VLAN_TAGGING_MODE_UNSPECIFIED";
    case VlanTaggingMode.VLAN_TAGGING_MODE_TAGGED:
      return "VLAN_TAGGING_MODE_TAGGED";
    case VlanTaggingMode.VLAN_TAGGING_MODE_UNTAGGED:
      return "VLAN_TAGGING_MODE_UNTAGGED";
    case VlanTaggingMode.VLAN_TAGGING_MODE_PRIORITY_TAGGED:
      return "VLAN_TAGGING_MODE_PRIORITY_TAGGED";
    case VlanTaggingMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ProtocolType {
  PROTOCOL_TYPE_UNSPECIFIED = 0,
  SYSTEM = 1,
  KERNEL = 2,
  DIRECTLY_CONNECTED = 3,
  STATIC = 4,
  RIP = 5,
  RIPNG = 6,
  OSFP = 7,
  OSFP6 = 8,
  ISIS = 9,
  BGP = 10,
  PIM = 11,
  HSLS = 12,
  OLSR = 13,
  BABEL = 14,
  ADJACENCY = 15,
  UNRECOGNIZED = -1,
}

export function protocolTypeFromJSON(object: any): ProtocolType {
  switch (object) {
    case 0:
    case "PROTOCOL_TYPE_UNSPECIFIED":
      return ProtocolType.PROTOCOL_TYPE_UNSPECIFIED;
    case 1:
    case "SYSTEM":
      return ProtocolType.SYSTEM;
    case 2:
    case "KERNEL":
      return ProtocolType.KERNEL;
    case 3:
    case "DIRECTLY_CONNECTED":
      return ProtocolType.DIRECTLY_CONNECTED;
    case 4:
    case "STATIC":
      return ProtocolType.STATIC;
    case 5:
    case "RIP":
      return ProtocolType.RIP;
    case 6:
    case "RIPNG":
      return ProtocolType.RIPNG;
    case 7:
    case "OSFP":
      return ProtocolType.OSFP;
    case 8:
    case "OSFP6":
      return ProtocolType.OSFP6;
    case 9:
    case "ISIS":
      return ProtocolType.ISIS;
    case 10:
    case "BGP":
      return ProtocolType.BGP;
    case 11:
    case "PIM":
      return ProtocolType.PIM;
    case 12:
    case "HSLS":
      return ProtocolType.HSLS;
    case 13:
    case "OLSR":
      return ProtocolType.OLSR;
    case 14:
    case "BABEL":
      return ProtocolType.BABEL;
    case 15:
    case "ADJACENCY":
      return ProtocolType.ADJACENCY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ProtocolType.UNRECOGNIZED;
  }
}

export function protocolTypeToJSON(object: ProtocolType): string {
  switch (object) {
    case ProtocolType.PROTOCOL_TYPE_UNSPECIFIED:
      return "PROTOCOL_TYPE_UNSPECIFIED";
    case ProtocolType.SYSTEM:
      return "SYSTEM";
    case ProtocolType.KERNEL:
      return "KERNEL";
    case ProtocolType.DIRECTLY_CONNECTED:
      return "DIRECTLY_CONNECTED";
    case ProtocolType.STATIC:
      return "STATIC";
    case ProtocolType.RIP:
      return "RIP";
    case ProtocolType.RIPNG:
      return "RIPNG";
    case ProtocolType.OSFP:
      return "OSFP";
    case ProtocolType.OSFP6:
      return "OSFP6";
    case ProtocolType.ISIS:
      return "ISIS";
    case ProtocolType.BGP:
      return "BGP";
    case ProtocolType.PIM:
      return "PIM";
    case ProtocolType.HSLS:
      return "HSLS";
    case ProtocolType.OLSR:
      return "OLSR";
    case ProtocolType.BABEL:
      return "BABEL";
    case ProtocolType.ADJACENCY:
      return "ADJACENCY";
    case ProtocolType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum IpFamilyType {
  IP_FAMILY_TYPE_UNSPECIFIED = 0,
  IPv4 = 1,
  IPv6 = 2,
  UNRECOGNIZED = -1,
}

export function ipFamilyTypeFromJSON(object: any): IpFamilyType {
  switch (object) {
    case 0:
    case "IP_FAMILY_TYPE_UNSPECIFIED":
      return IpFamilyType.IP_FAMILY_TYPE_UNSPECIFIED;
    case 1:
    case "IPv4":
      return IpFamilyType.IPv4;
    case 2:
    case "IPv6":
      return IpFamilyType.IPv6;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IpFamilyType.UNRECOGNIZED;
  }
}

export function ipFamilyTypeToJSON(object: IpFamilyType): string {
  switch (object) {
    case IpFamilyType.IP_FAMILY_TYPE_UNSPECIFIED:
      return "IP_FAMILY_TYPE_UNSPECIFIED";
    case IpFamilyType.IPv4:
      return "IPv4";
    case IpFamilyType.IPv6:
      return "IPv6";
    case IpFamilyType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpTransceiverModule {
  QSFP_TRANSCEIVER_MODULE_UNSPECIFIED = 0,
  COPPER = 1,
  FIBER = 2,
  FIBER_400GBASE_DR4 = 3,
  FIBER_400GBASE_FR4 = 4,
  FIBER_400GBASE_SR8 = 5,
  FIBER_400GBASE_LR8 = 6,
  UNRECOGNIZED = -1,
}

export function qsfpTransceiverModuleFromJSON(object: any): QsfpTransceiverModule {
  switch (object) {
    case 0:
    case "QSFP_TRANSCEIVER_MODULE_UNSPECIFIED":
      return QsfpTransceiverModule.QSFP_TRANSCEIVER_MODULE_UNSPECIFIED;
    case 1:
    case "COPPER":
      return QsfpTransceiverModule.COPPER;
    case 2:
    case "FIBER":
      return QsfpTransceiverModule.FIBER;
    case 3:
    case "FIBER_400GBASE_DR4":
      return QsfpTransceiverModule.FIBER_400GBASE_DR4;
    case 4:
    case "FIBER_400GBASE_FR4":
      return QsfpTransceiverModule.FIBER_400GBASE_FR4;
    case 5:
    case "FIBER_400GBASE_SR8":
      return QsfpTransceiverModule.FIBER_400GBASE_SR8;
    case 6:
    case "FIBER_400GBASE_LR8":
      return QsfpTransceiverModule.FIBER_400GBASE_LR8;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpTransceiverModule.UNRECOGNIZED;
  }
}

export function qsfpTransceiverModuleToJSON(object: QsfpTransceiverModule): string {
  switch (object) {
    case QsfpTransceiverModule.QSFP_TRANSCEIVER_MODULE_UNSPECIFIED:
      return "QSFP_TRANSCEIVER_MODULE_UNSPECIFIED";
    case QsfpTransceiverModule.COPPER:
      return "COPPER";
    case QsfpTransceiverModule.FIBER:
      return "FIBER";
    case QsfpTransceiverModule.FIBER_400GBASE_DR4:
      return "FIBER_400GBASE_DR4";
    case QsfpTransceiverModule.FIBER_400GBASE_FR4:
      return "FIBER_400GBASE_FR4";
    case QsfpTransceiverModule.FIBER_400GBASE_SR8:
      return "FIBER_400GBASE_SR8";
    case QsfpTransceiverModule.FIBER_400GBASE_LR8:
      return "FIBER_400GBASE_LR8";
    case QsfpTransceiverModule.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** OperationStatus defines an enumeration of operational statuses of an interface or a port. */
export enum OperationStatus {
  OPERATION_STATUS_UNSPECIFIED = 0,
  UP = 1,
  DOWN = 2,
  UNRECOGNIZED = -1,
}

export function operationStatusFromJSON(object: any): OperationStatus {
  switch (object) {
    case 0:
    case "OPERATION_STATUS_UNSPECIFIED":
      return OperationStatus.OPERATION_STATUS_UNSPECIFIED;
    case 1:
    case "UP":
      return OperationStatus.UP;
    case 2:
    case "DOWN":
      return OperationStatus.DOWN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OperationStatus.UNRECOGNIZED;
  }
}

export function operationStatusToJSON(object: OperationStatus): string {
  switch (object) {
    case OperationStatus.OPERATION_STATUS_UNSPECIFIED:
      return "OPERATION_STATUS_UNSPECIFIED";
    case OperationStatus.UP:
      return "UP";
    case OperationStatus.DOWN:
      return "DOWN";
    case OperationStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum L3Status {
  L3_STATUS_UNSPECIFIED = 0,
  UNKNOWN = 1,
  NO_ARP = 2,
  STALE = 3,
  REACHABLE = 4,
  PERMANENT = 5,
  NONE = 6,
  INCOMPLETE = 7,
  DELAY = 8,
  PROBE = 9,
  FAILED = 10,
  UNRECOGNIZED = -1,
}

export function l3StatusFromJSON(object: any): L3Status {
  switch (object) {
    case 0:
    case "L3_STATUS_UNSPECIFIED":
      return L3Status.L3_STATUS_UNSPECIFIED;
    case 1:
    case "UNKNOWN":
      return L3Status.UNKNOWN;
    case 2:
    case "NO_ARP":
      return L3Status.NO_ARP;
    case 3:
    case "STALE":
      return L3Status.STALE;
    case 4:
    case "REACHABLE":
      return L3Status.REACHABLE;
    case 5:
    case "PERMANENT":
      return L3Status.PERMANENT;
    case 6:
    case "NONE":
      return L3Status.NONE;
    case 7:
    case "INCOMPLETE":
      return L3Status.INCOMPLETE;
    case 8:
    case "DELAY":
      return L3Status.DELAY;
    case 9:
    case "PROBE":
      return L3Status.PROBE;
    case 10:
    case "FAILED":
      return L3Status.FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return L3Status.UNRECOGNIZED;
  }
}

export function l3StatusToJSON(object: L3Status): string {
  switch (object) {
    case L3Status.L3_STATUS_UNSPECIFIED:
      return "L3_STATUS_UNSPECIFIED";
    case L3Status.UNKNOWN:
      return "UNKNOWN";
    case L3Status.NO_ARP:
      return "NO_ARP";
    case L3Status.STALE:
      return "STALE";
    case L3Status.REACHABLE:
      return "REACHABLE";
    case L3Status.PERMANENT:
      return "PERMANENT";
    case L3Status.NONE:
      return "NONE";
    case L3Status.INCOMPLETE:
      return "INCOMPLETE";
    case L3Status.DELAY:
      return "DELAY";
    case L3Status.PROBE:
      return "PROBE";
    case L3Status.FAILED:
      return "FAILED";
    case L3Status.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpPathSource {
  BGP_PATH_SORUCE_UNSPECIFIED = 0,
  BGP_PATH_SORUCE_LOCAL = 1,
  BGP_PATH_SORUCE_STATIC = 2,
  BGP_PATH_SORUCE_NORMAL = 3,
  BGP_PATH_SORUCE_EXTERNAL = 4,
  BGP_PATH_SORUCE_REDISTRIBUTE = 5,
  BGP_PATH_SORUCE_AGGREGATE = 6,
  BGP_PATH_SORUCE_CONNECTED = 7,
  BGP_PATH_SORUCE_IMPORTED = 8,
  UNRECOGNIZED = -1,
}

export function bgpPathSourceFromJSON(object: any): BgpPathSource {
  switch (object) {
    case 0:
    case "BGP_PATH_SORUCE_UNSPECIFIED":
      return BgpPathSource.BGP_PATH_SORUCE_UNSPECIFIED;
    case 1:
    case "BGP_PATH_SORUCE_LOCAL":
      return BgpPathSource.BGP_PATH_SORUCE_LOCAL;
    case 2:
    case "BGP_PATH_SORUCE_STATIC":
      return BgpPathSource.BGP_PATH_SORUCE_STATIC;
    case 3:
    case "BGP_PATH_SORUCE_NORMAL":
      return BgpPathSource.BGP_PATH_SORUCE_NORMAL;
    case 4:
    case "BGP_PATH_SORUCE_EXTERNAL":
      return BgpPathSource.BGP_PATH_SORUCE_EXTERNAL;
    case 5:
    case "BGP_PATH_SORUCE_REDISTRIBUTE":
      return BgpPathSource.BGP_PATH_SORUCE_REDISTRIBUTE;
    case 6:
    case "BGP_PATH_SORUCE_AGGREGATE":
      return BgpPathSource.BGP_PATH_SORUCE_AGGREGATE;
    case 7:
    case "BGP_PATH_SORUCE_CONNECTED":
      return BgpPathSource.BGP_PATH_SORUCE_CONNECTED;
    case 8:
    case "BGP_PATH_SORUCE_IMPORTED":
      return BgpPathSource.BGP_PATH_SORUCE_IMPORTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpPathSource.UNRECOGNIZED;
  }
}

export function bgpPathSourceToJSON(object: BgpPathSource): string {
  switch (object) {
    case BgpPathSource.BGP_PATH_SORUCE_UNSPECIFIED:
      return "BGP_PATH_SORUCE_UNSPECIFIED";
    case BgpPathSource.BGP_PATH_SORUCE_LOCAL:
      return "BGP_PATH_SORUCE_LOCAL";
    case BgpPathSource.BGP_PATH_SORUCE_STATIC:
      return "BGP_PATH_SORUCE_STATIC";
    case BgpPathSource.BGP_PATH_SORUCE_NORMAL:
      return "BGP_PATH_SORUCE_NORMAL";
    case BgpPathSource.BGP_PATH_SORUCE_EXTERNAL:
      return "BGP_PATH_SORUCE_EXTERNAL";
    case BgpPathSource.BGP_PATH_SORUCE_REDISTRIBUTE:
      return "BGP_PATH_SORUCE_REDISTRIBUTE";
    case BgpPathSource.BGP_PATH_SORUCE_AGGREGATE:
      return "BGP_PATH_SORUCE_AGGREGATE";
    case BgpPathSource.BGP_PATH_SORUCE_CONNECTED:
      return "BGP_PATH_SORUCE_CONNECTED";
    case BgpPathSource.BGP_PATH_SORUCE_IMPORTED:
      return "BGP_PATH_SORUCE_IMPORTED";
    case BgpPathSource.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpPathSelectionReason {
  BGP_PATH_SELECTION_UNSPECIFIED = 0,
  BGP_PATH_SELECTION_LOCAL_PREF = 1,
  BGP_PATH_SELECTION_AS_PATH = 2,
  BGP_PATH_SELECTION_ORIGIN = 3,
  BGP_PATH_SELECTION_MED = 4,
  BGP_PATH_SELECTION_EBGP_IBGP = 5,
  BGP_PATH_SELECTION_IGP_COST = 6,
  BGP_PATH_SELECTION_ROUTER_ID = 7,
  BGP_PATH_SELECTION_OLDEST_PATH = 8,
  BGP_PATH_SELECTION_MULTIPATH = 9,
  BGP_PATH_SELECTION_TIE_BREAK = 10,
  BGP_PATH_SELECTION_WEIGHT = 11,
  BGP_PATH_SELECTION_FIRST_PATH_RECEIVED = 12,
  UNRECOGNIZED = -1,
}

export function bgpPathSelectionReasonFromJSON(object: any): BgpPathSelectionReason {
  switch (object) {
    case 0:
    case "BGP_PATH_SELECTION_UNSPECIFIED":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_UNSPECIFIED;
    case 1:
    case "BGP_PATH_SELECTION_LOCAL_PREF":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_LOCAL_PREF;
    case 2:
    case "BGP_PATH_SELECTION_AS_PATH":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_AS_PATH;
    case 3:
    case "BGP_PATH_SELECTION_ORIGIN":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_ORIGIN;
    case 4:
    case "BGP_PATH_SELECTION_MED":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_MED;
    case 5:
    case "BGP_PATH_SELECTION_EBGP_IBGP":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_EBGP_IBGP;
    case 6:
    case "BGP_PATH_SELECTION_IGP_COST":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_IGP_COST;
    case 7:
    case "BGP_PATH_SELECTION_ROUTER_ID":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_ROUTER_ID;
    case 8:
    case "BGP_PATH_SELECTION_OLDEST_PATH":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_OLDEST_PATH;
    case 9:
    case "BGP_PATH_SELECTION_MULTIPATH":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_MULTIPATH;
    case 10:
    case "BGP_PATH_SELECTION_TIE_BREAK":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_TIE_BREAK;
    case 11:
    case "BGP_PATH_SELECTION_WEIGHT":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_WEIGHT;
    case 12:
    case "BGP_PATH_SELECTION_FIRST_PATH_RECEIVED":
      return BgpPathSelectionReason.BGP_PATH_SELECTION_FIRST_PATH_RECEIVED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpPathSelectionReason.UNRECOGNIZED;
  }
}

export function bgpPathSelectionReasonToJSON(object: BgpPathSelectionReason): string {
  switch (object) {
    case BgpPathSelectionReason.BGP_PATH_SELECTION_UNSPECIFIED:
      return "BGP_PATH_SELECTION_UNSPECIFIED";
    case BgpPathSelectionReason.BGP_PATH_SELECTION_LOCAL_PREF:
      return "BGP_PATH_SELECTION_LOCAL_PREF";
    case BgpPathSelectionReason.BGP_PATH_SELECTION_AS_PATH:
      return "BGP_PATH_SELECTION_AS_PATH";
    case BgpPathSelectionReason.BGP_PATH_SELECTION_ORIGIN:
      return "BGP_PATH_SELECTION_ORIGIN";
    case BgpPathSelectionReason.BGP_PATH_SELECTION_MED:
      return "BGP_PATH_SELECTION_MED";
    case BgpPathSelectionReason.BGP_PATH_SELECTION_EBGP_IBGP:
      return "BGP_PATH_SELECTION_EBGP_IBGP";
    case BgpPathSelectionReason.BGP_PATH_SELECTION_IGP_COST:
      return "BGP_PATH_SELECTION_IGP_COST";
    case BgpPathSelectionReason.BGP_PATH_SELECTION_ROUTER_ID:
      return "BGP_PATH_SELECTION_ROUTER_ID";
    case BgpPathSelectionReason.BGP_PATH_SELECTION_OLDEST_PATH:
      return "BGP_PATH_SELECTION_OLDEST_PATH";
    case BgpPathSelectionReason.BGP_PATH_SELECTION_MULTIPATH:
      return "BGP_PATH_SELECTION_MULTIPATH";
    case BgpPathSelectionReason.BGP_PATH_SELECTION_TIE_BREAK:
      return "BGP_PATH_SELECTION_TIE_BREAK";
    case BgpPathSelectionReason.BGP_PATH_SELECTION_WEIGHT:
      return "BGP_PATH_SELECTION_WEIGHT";
    case BgpPathSelectionReason.BGP_PATH_SELECTION_FIRST_PATH_RECEIVED:
      return "BGP_PATH_SELECTION_FIRST_PATH_RECEIVED";
    case BgpPathSelectionReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpRouteOriginType {
  BGP_ROUTE_ORIGIN_TYPE_UNSPECIFIED = 0,
  BGP_ROUTE_ORIGIN_TYPE_IGP = 1,
  BGP_ROUTE_ORIGIN_TYPE_EGP = 2,
  BGP_ROUTE_ORIGIN_TYPE_INCOMPLETE = 3,
  UNRECOGNIZED = -1,
}

export function bgpRouteOriginTypeFromJSON(object: any): BgpRouteOriginType {
  switch (object) {
    case 0:
    case "BGP_ROUTE_ORIGIN_TYPE_UNSPECIFIED":
      return BgpRouteOriginType.BGP_ROUTE_ORIGIN_TYPE_UNSPECIFIED;
    case 1:
    case "BGP_ROUTE_ORIGIN_TYPE_IGP":
      return BgpRouteOriginType.BGP_ROUTE_ORIGIN_TYPE_IGP;
    case 2:
    case "BGP_ROUTE_ORIGIN_TYPE_EGP":
      return BgpRouteOriginType.BGP_ROUTE_ORIGIN_TYPE_EGP;
    case 3:
    case "BGP_ROUTE_ORIGIN_TYPE_INCOMPLETE":
      return BgpRouteOriginType.BGP_ROUTE_ORIGIN_TYPE_INCOMPLETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpRouteOriginType.UNRECOGNIZED;
  }
}

export function bgpRouteOriginTypeToJSON(object: BgpRouteOriginType): string {
  switch (object) {
    case BgpRouteOriginType.BGP_ROUTE_ORIGIN_TYPE_UNSPECIFIED:
      return "BGP_ROUTE_ORIGIN_TYPE_UNSPECIFIED";
    case BgpRouteOriginType.BGP_ROUTE_ORIGIN_TYPE_IGP:
      return "BGP_ROUTE_ORIGIN_TYPE_IGP";
    case BgpRouteOriginType.BGP_ROUTE_ORIGIN_TYPE_EGP:
      return "BGP_ROUTE_ORIGIN_TYPE_EGP";
    case BgpRouteOriginType.BGP_ROUTE_ORIGIN_TYPE_INCOMPLETE:
      return "BGP_ROUTE_ORIGIN_TYPE_INCOMPLETE";
    case BgpRouteOriginType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum NetworkInterfaceType {
  NETWORK_INTERFACE_TYPE_UNSPECIFIED = 0,
  NETWORK_INTERFACE_TYPE_SVI = 1,
  NETWORK_INTERFACE_TYPE_ROUTED = 2,
  NETWORK_INTERFACE_TYPE_LOOPBACK = 3,
  NETWORK_INTERFACE_TYPE_PORT_CHANNEL = 4,
  NETWORK_INTERFACE_TYPE_SUB_INTERFACE = 5,
  UNRECOGNIZED = -1,
}

export function networkInterfaceTypeFromJSON(object: any): NetworkInterfaceType {
  switch (object) {
    case 0:
    case "NETWORK_INTERFACE_TYPE_UNSPECIFIED":
      return NetworkInterfaceType.NETWORK_INTERFACE_TYPE_UNSPECIFIED;
    case 1:
    case "NETWORK_INTERFACE_TYPE_SVI":
      return NetworkInterfaceType.NETWORK_INTERFACE_TYPE_SVI;
    case 2:
    case "NETWORK_INTERFACE_TYPE_ROUTED":
      return NetworkInterfaceType.NETWORK_INTERFACE_TYPE_ROUTED;
    case 3:
    case "NETWORK_INTERFACE_TYPE_LOOPBACK":
      return NetworkInterfaceType.NETWORK_INTERFACE_TYPE_LOOPBACK;
    case 4:
    case "NETWORK_INTERFACE_TYPE_PORT_CHANNEL":
      return NetworkInterfaceType.NETWORK_INTERFACE_TYPE_PORT_CHANNEL;
    case 5:
    case "NETWORK_INTERFACE_TYPE_SUB_INTERFACE":
      return NetworkInterfaceType.NETWORK_INTERFACE_TYPE_SUB_INTERFACE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NetworkInterfaceType.UNRECOGNIZED;
  }
}

export function networkInterfaceTypeToJSON(object: NetworkInterfaceType): string {
  switch (object) {
    case NetworkInterfaceType.NETWORK_INTERFACE_TYPE_UNSPECIFIED:
      return "NETWORK_INTERFACE_TYPE_UNSPECIFIED";
    case NetworkInterfaceType.NETWORK_INTERFACE_TYPE_SVI:
      return "NETWORK_INTERFACE_TYPE_SVI";
    case NetworkInterfaceType.NETWORK_INTERFACE_TYPE_ROUTED:
      return "NETWORK_INTERFACE_TYPE_ROUTED";
    case NetworkInterfaceType.NETWORK_INTERFACE_TYPE_LOOPBACK:
      return "NETWORK_INTERFACE_TYPE_LOOPBACK";
    case NetworkInterfaceType.NETWORK_INTERFACE_TYPE_PORT_CHANNEL:
      return "NETWORK_INTERFACE_TYPE_PORT_CHANNEL";
    case NetworkInterfaceType.NETWORK_INTERFACE_TYPE_SUB_INTERFACE:
      return "NETWORK_INTERFACE_TYPE_SUB_INTERFACE";
    case NetworkInterfaceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpNeighborRole {
  BGP_NEIGHBOR_ROLE_UNSPECIFIED = 0,
  BGP_NEIGHBOR_ROLE_UNDEFINED = 1,
  I_BGP = 2,
  E_BGP = 3,
  UNRECOGNIZED = -1,
}

export function bgpNeighborRoleFromJSON(object: any): BgpNeighborRole {
  switch (object) {
    case 0:
    case "BGP_NEIGHBOR_ROLE_UNSPECIFIED":
      return BgpNeighborRole.BGP_NEIGHBOR_ROLE_UNSPECIFIED;
    case 1:
    case "BGP_NEIGHBOR_ROLE_UNDEFINED":
      return BgpNeighborRole.BGP_NEIGHBOR_ROLE_UNDEFINED;
    case 2:
    case "I_BGP":
      return BgpNeighborRole.I_BGP;
    case 3:
    case "E_BGP":
      return BgpNeighborRole.E_BGP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpNeighborRole.UNRECOGNIZED;
  }
}

export function bgpNeighborRoleToJSON(object: BgpNeighborRole): string {
  switch (object) {
    case BgpNeighborRole.BGP_NEIGHBOR_ROLE_UNSPECIFIED:
      return "BGP_NEIGHBOR_ROLE_UNSPECIFIED";
    case BgpNeighborRole.BGP_NEIGHBOR_ROLE_UNDEFINED:
      return "BGP_NEIGHBOR_ROLE_UNDEFINED";
    case BgpNeighborRole.I_BGP:
      return "I_BGP";
    case BgpNeighborRole.E_BGP:
      return "E_BGP";
    case BgpNeighborRole.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpNeighborPeerGroup {
  BGP_NEIGHBOR_PEER_GROUP_UNSPECIFIED = 0,
  TRANSIT = 1,
  TRANSIT_IPV6 = 2,
  OVERLAY = 3,
  UNRECOGNIZED = -1,
}

export function bgpNeighborPeerGroupFromJSON(object: any): BgpNeighborPeerGroup {
  switch (object) {
    case 0:
    case "BGP_NEIGHBOR_PEER_GROUP_UNSPECIFIED":
      return BgpNeighborPeerGroup.BGP_NEIGHBOR_PEER_GROUP_UNSPECIFIED;
    case 1:
    case "TRANSIT":
      return BgpNeighborPeerGroup.TRANSIT;
    case 2:
    case "TRANSIT_IPV6":
      return BgpNeighborPeerGroup.TRANSIT_IPV6;
    case 3:
    case "OVERLAY":
      return BgpNeighborPeerGroup.OVERLAY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpNeighborPeerGroup.UNRECOGNIZED;
  }
}

export function bgpNeighborPeerGroupToJSON(object: BgpNeighborPeerGroup): string {
  switch (object) {
    case BgpNeighborPeerGroup.BGP_NEIGHBOR_PEER_GROUP_UNSPECIFIED:
      return "BGP_NEIGHBOR_PEER_GROUP_UNSPECIFIED";
    case BgpNeighborPeerGroup.TRANSIT:
      return "TRANSIT";
    case BgpNeighborPeerGroup.TRANSIT_IPV6:
      return "TRANSIT_IPV6";
    case BgpNeighborPeerGroup.OVERLAY:
      return "OVERLAY";
    case BgpNeighborPeerGroup.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpNeighborCapability {
  BGP_NEIGHBOR_CAPABILITY_UNSPECIFIED = 0,
  ADVERTISED_AND_RECEIVED = 1,
  ADVERTISED = 2,
  ADVERTISED_AND_RECEIVED_OLD = 3,
  ADVERTISED_AND_RECEIVED_NEW = 4,
  ADVERTISED_AND_RECEIVED_OLD_NEW = 5,
  UNRECOGNIZED = -1,
}

export function bgpNeighborCapabilityFromJSON(object: any): BgpNeighborCapability {
  switch (object) {
    case 0:
    case "BGP_NEIGHBOR_CAPABILITY_UNSPECIFIED":
      return BgpNeighborCapability.BGP_NEIGHBOR_CAPABILITY_UNSPECIFIED;
    case 1:
    case "ADVERTISED_AND_RECEIVED":
      return BgpNeighborCapability.ADVERTISED_AND_RECEIVED;
    case 2:
    case "ADVERTISED":
      return BgpNeighborCapability.ADVERTISED;
    case 3:
    case "ADVERTISED_AND_RECEIVED_OLD":
      return BgpNeighborCapability.ADVERTISED_AND_RECEIVED_OLD;
    case 4:
    case "ADVERTISED_AND_RECEIVED_NEW":
      return BgpNeighborCapability.ADVERTISED_AND_RECEIVED_NEW;
    case 5:
    case "ADVERTISED_AND_RECEIVED_OLD_NEW":
      return BgpNeighborCapability.ADVERTISED_AND_RECEIVED_OLD_NEW;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpNeighborCapability.UNRECOGNIZED;
  }
}

export function bgpNeighborCapabilityToJSON(object: BgpNeighborCapability): string {
  switch (object) {
    case BgpNeighborCapability.BGP_NEIGHBOR_CAPABILITY_UNSPECIFIED:
      return "BGP_NEIGHBOR_CAPABILITY_UNSPECIFIED";
    case BgpNeighborCapability.ADVERTISED_AND_RECEIVED:
      return "ADVERTISED_AND_RECEIVED";
    case BgpNeighborCapability.ADVERTISED:
      return "ADVERTISED";
    case BgpNeighborCapability.ADVERTISED_AND_RECEIVED_OLD:
      return "ADVERTISED_AND_RECEIVED_OLD";
    case BgpNeighborCapability.ADVERTISED_AND_RECEIVED_NEW:
      return "ADVERTISED_AND_RECEIVED_NEW";
    case BgpNeighborCapability.ADVERTISED_AND_RECEIVED_OLD_NEW:
      return "ADVERTISED_AND_RECEIVED_OLD_NEW";
    case BgpNeighborCapability.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpPeerBfdState {
  BGP_PEER_BFD_STATE_UNSPECIFIED = 0,
  BFD_STATE_UNKNOWN = 1,
  BFD_STATE_DOWN = 2,
  BFD_STATE_INIT = 3,
  BFD_STATE_UP = 4,
  BFD_STATE_ADMIN_DOWN = 5,
  UNRECOGNIZED = -1,
}

export function bgpPeerBfdStateFromJSON(object: any): BgpPeerBfdState {
  switch (object) {
    case 0:
    case "BGP_PEER_BFD_STATE_UNSPECIFIED":
      return BgpPeerBfdState.BGP_PEER_BFD_STATE_UNSPECIFIED;
    case 1:
    case "BFD_STATE_UNKNOWN":
      return BgpPeerBfdState.BFD_STATE_UNKNOWN;
    case 2:
    case "BFD_STATE_DOWN":
      return BgpPeerBfdState.BFD_STATE_DOWN;
    case 3:
    case "BFD_STATE_INIT":
      return BgpPeerBfdState.BFD_STATE_INIT;
    case 4:
    case "BFD_STATE_UP":
      return BgpPeerBfdState.BFD_STATE_UP;
    case 5:
    case "BFD_STATE_ADMIN_DOWN":
      return BgpPeerBfdState.BFD_STATE_ADMIN_DOWN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpPeerBfdState.UNRECOGNIZED;
  }
}

export function bgpPeerBfdStateToJSON(object: BgpPeerBfdState): string {
  switch (object) {
    case BgpPeerBfdState.BGP_PEER_BFD_STATE_UNSPECIFIED:
      return "BGP_PEER_BFD_STATE_UNSPECIFIED";
    case BgpPeerBfdState.BFD_STATE_UNKNOWN:
      return "BFD_STATE_UNKNOWN";
    case BgpPeerBfdState.BFD_STATE_DOWN:
      return "BFD_STATE_DOWN";
    case BgpPeerBfdState.BFD_STATE_INIT:
      return "BFD_STATE_INIT";
    case BgpPeerBfdState.BFD_STATE_UP:
      return "BFD_STATE_UP";
    case BgpPeerBfdState.BFD_STATE_ADMIN_DOWN:
      return "BFD_STATE_ADMIN_DOWN";
    case BgpPeerBfdState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpNeighborThreadState {
  BGP_NEIGHBOR_THREAD_STATE_UNSPECIFIED = 0,
  THREAD_STATE_ON = 1,
  THREAD_STATE_OFF = 2,
  UNRECOGNIZED = -1,
}

export function bgpNeighborThreadStateFromJSON(object: any): BgpNeighborThreadState {
  switch (object) {
    case 0:
    case "BGP_NEIGHBOR_THREAD_STATE_UNSPECIFIED":
      return BgpNeighborThreadState.BGP_NEIGHBOR_THREAD_STATE_UNSPECIFIED;
    case 1:
    case "THREAD_STATE_ON":
      return BgpNeighborThreadState.THREAD_STATE_ON;
    case 2:
    case "THREAD_STATE_OFF":
      return BgpNeighborThreadState.THREAD_STATE_OFF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpNeighborThreadState.UNRECOGNIZED;
  }
}

export function bgpNeighborThreadStateToJSON(object: BgpNeighborThreadState): string {
  switch (object) {
    case BgpNeighborThreadState.BGP_NEIGHBOR_THREAD_STATE_UNSPECIFIED:
      return "BGP_NEIGHBOR_THREAD_STATE_UNSPECIFIED";
    case BgpNeighborThreadState.THREAD_STATE_ON:
      return "THREAD_STATE_ON";
    case BgpNeighborThreadState.THREAD_STATE_OFF:
      return "THREAD_STATE_OFF";
    case BgpNeighborThreadState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpPeerAuthenticationStatus {
  BGP_PEER_AUTH_UNSPECIFIED = 0,
  BGP_PEER_AUTH_ENABLE = 1,
  BGP_PEER_AUTH_DISABLE = 2,
  UNRECOGNIZED = -1,
}

export function bgpPeerAuthenticationStatusFromJSON(object: any): BgpPeerAuthenticationStatus {
  switch (object) {
    case 0:
    case "BGP_PEER_AUTH_UNSPECIFIED":
      return BgpPeerAuthenticationStatus.BGP_PEER_AUTH_UNSPECIFIED;
    case 1:
    case "BGP_PEER_AUTH_ENABLE":
      return BgpPeerAuthenticationStatus.BGP_PEER_AUTH_ENABLE;
    case 2:
    case "BGP_PEER_AUTH_DISABLE":
      return BgpPeerAuthenticationStatus.BGP_PEER_AUTH_DISABLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpPeerAuthenticationStatus.UNRECOGNIZED;
  }
}

export function bgpPeerAuthenticationStatusToJSON(object: BgpPeerAuthenticationStatus): string {
  switch (object) {
    case BgpPeerAuthenticationStatus.BGP_PEER_AUTH_UNSPECIFIED:
      return "BGP_PEER_AUTH_UNSPECIFIED";
    case BgpPeerAuthenticationStatus.BGP_PEER_AUTH_ENABLE:
      return "BGP_PEER_AUTH_ENABLE";
    case BgpPeerAuthenticationStatus.BGP_PEER_AUTH_DISABLE:
      return "BGP_PEER_AUTH_DISABLE";
    case BgpPeerAuthenticationStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BgpNeighborReceivedRouteOrigin {
  BGP_NEIGHBOR_RECEIVED_ROUTE_ORIGIN_TYPE_UNSPECIFIED = 0,
  IGP = 2,
  EGP = 3,
  IN_COMPLETE = 4,
  UNRECOGNIZED = -1,
}

export function bgpNeighborReceivedRouteOriginFromJSON(object: any): BgpNeighborReceivedRouteOrigin {
  switch (object) {
    case 0:
    case "BGP_NEIGHBOR_RECEIVED_ROUTE_ORIGIN_TYPE_UNSPECIFIED":
      return BgpNeighborReceivedRouteOrigin.BGP_NEIGHBOR_RECEIVED_ROUTE_ORIGIN_TYPE_UNSPECIFIED;
    case 2:
    case "IGP":
      return BgpNeighborReceivedRouteOrigin.IGP;
    case 3:
    case "EGP":
      return BgpNeighborReceivedRouteOrigin.EGP;
    case 4:
    case "IN_COMPLETE":
      return BgpNeighborReceivedRouteOrigin.IN_COMPLETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BgpNeighborReceivedRouteOrigin.UNRECOGNIZED;
  }
}

export function bgpNeighborReceivedRouteOriginToJSON(object: BgpNeighborReceivedRouteOrigin): string {
  switch (object) {
    case BgpNeighborReceivedRouteOrigin.BGP_NEIGHBOR_RECEIVED_ROUTE_ORIGIN_TYPE_UNSPECIFIED:
      return "BGP_NEIGHBOR_RECEIVED_ROUTE_ORIGIN_TYPE_UNSPECIFIED";
    case BgpNeighborReceivedRouteOrigin.IGP:
      return "IGP";
    case BgpNeighborReceivedRouteOrigin.EGP:
      return "EGP";
    case BgpNeighborReceivedRouteOrigin.IN_COMPLETE:
      return "IN_COMPLETE";
    case BgpNeighborReceivedRouteOrigin.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PortChannelMemberInfoState {
  PORT_CHANNEL_MEMBER_INFO_STATE_UNSPECIFIED = 0,
  DISABLED = 1,
  CURRENT = 2,
  EXPIRED = 3,
  DEFAULTED = 4,
  UNRECOGNIZED = -1,
}

export function portChannelMemberInfoStateFromJSON(object: any): PortChannelMemberInfoState {
  switch (object) {
    case 0:
    case "PORT_CHANNEL_MEMBER_INFO_STATE_UNSPECIFIED":
      return PortChannelMemberInfoState.PORT_CHANNEL_MEMBER_INFO_STATE_UNSPECIFIED;
    case 1:
    case "DISABLED":
      return PortChannelMemberInfoState.DISABLED;
    case 2:
    case "CURRENT":
      return PortChannelMemberInfoState.CURRENT;
    case 3:
    case "EXPIRED":
      return PortChannelMemberInfoState.EXPIRED;
    case 4:
    case "DEFAULTED":
      return PortChannelMemberInfoState.DEFAULTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PortChannelMemberInfoState.UNRECOGNIZED;
  }
}

export function portChannelMemberInfoStateToJSON(object: PortChannelMemberInfoState): string {
  switch (object) {
    case PortChannelMemberInfoState.PORT_CHANNEL_MEMBER_INFO_STATE_UNSPECIFIED:
      return "PORT_CHANNEL_MEMBER_INFO_STATE_UNSPECIFIED";
    case PortChannelMemberInfoState.DISABLED:
      return "DISABLED";
    case PortChannelMemberInfoState.CURRENT:
      return "CURRENT";
    case PortChannelMemberInfoState.EXPIRED:
      return "EXPIRED";
    case PortChannelMemberInfoState.DEFAULTED:
      return "DEFAULTED";
    case PortChannelMemberInfoState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PortChannelStatus {
  PORT_CHANNEL_STATUS_UNSPECIFIED = 0,
  PORT_CHANNEL_STATUS_OK = 1,
  PORT_CHANNEL_STATUS_NOT_OK = 2,
  PORT_CHANNEL_STATUS_UP = 3,
  PORT_CHANNEL_STATUS_DOWN = 4,
  UNRECOGNIZED = -1,
}

export function portChannelStatusFromJSON(object: any): PortChannelStatus {
  switch (object) {
    case 0:
    case "PORT_CHANNEL_STATUS_UNSPECIFIED":
      return PortChannelStatus.PORT_CHANNEL_STATUS_UNSPECIFIED;
    case 1:
    case "PORT_CHANNEL_STATUS_OK":
      return PortChannelStatus.PORT_CHANNEL_STATUS_OK;
    case 2:
    case "PORT_CHANNEL_STATUS_NOT_OK":
      return PortChannelStatus.PORT_CHANNEL_STATUS_NOT_OK;
    case 3:
    case "PORT_CHANNEL_STATUS_UP":
      return PortChannelStatus.PORT_CHANNEL_STATUS_UP;
    case 4:
    case "PORT_CHANNEL_STATUS_DOWN":
      return PortChannelStatus.PORT_CHANNEL_STATUS_DOWN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PortChannelStatus.UNRECOGNIZED;
  }
}

export function portChannelStatusToJSON(object: PortChannelStatus): string {
  switch (object) {
    case PortChannelStatus.PORT_CHANNEL_STATUS_UNSPECIFIED:
      return "PORT_CHANNEL_STATUS_UNSPECIFIED";
    case PortChannelStatus.PORT_CHANNEL_STATUS_OK:
      return "PORT_CHANNEL_STATUS_OK";
    case PortChannelStatus.PORT_CHANNEL_STATUS_NOT_OK:
      return "PORT_CHANNEL_STATUS_NOT_OK";
    case PortChannelStatus.PORT_CHANNEL_STATUS_UP:
      return "PORT_CHANNEL_STATUS_UP";
    case PortChannelStatus.PORT_CHANNEL_STATUS_DOWN:
      return "PORT_CHANNEL_STATUS_DOWN";
    case PortChannelStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PortChannelKernelTeamMode {
  PORT_CHANNEL_KERNEL_TEAM_MODE = 0,
  LOAD_BALANCE = 1,
  ROUND_ROBIN = 2,
  UNRECOGNIZED = -1,
}

export function portChannelKernelTeamModeFromJSON(object: any): PortChannelKernelTeamMode {
  switch (object) {
    case 0:
    case "PORT_CHANNEL_KERNEL_TEAM_MODE":
      return PortChannelKernelTeamMode.PORT_CHANNEL_KERNEL_TEAM_MODE;
    case 1:
    case "LOAD_BALANCE":
      return PortChannelKernelTeamMode.LOAD_BALANCE;
    case 2:
    case "ROUND_ROBIN":
      return PortChannelKernelTeamMode.ROUND_ROBIN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PortChannelKernelTeamMode.UNRECOGNIZED;
  }
}

export function portChannelKernelTeamModeToJSON(object: PortChannelKernelTeamMode): string {
  switch (object) {
    case PortChannelKernelTeamMode.PORT_CHANNEL_KERNEL_TEAM_MODE:
      return "PORT_CHANNEL_KERNEL_TEAM_MODE";
    case PortChannelKernelTeamMode.LOAD_BALANCE:
      return "LOAD_BALANCE";
    case PortChannelKernelTeamMode.ROUND_ROBIN:
      return "ROUND_ROBIN";
    case PortChannelKernelTeamMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PortChannelProtocol {
  PORT_CHANNEL_PROTOCOL_UNSPECIFIED = 0,
  LACP = 1,
  UNRECOGNIZED = -1,
}

export function portChannelProtocolFromJSON(object: any): PortChannelProtocol {
  switch (object) {
    case 0:
    case "PORT_CHANNEL_PROTOCOL_UNSPECIFIED":
      return PortChannelProtocol.PORT_CHANNEL_PROTOCOL_UNSPECIFIED;
    case 1:
    case "LACP":
      return PortChannelProtocol.LACP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PortChannelProtocol.UNRECOGNIZED;
  }
}

export function portChannelProtocolToJSON(object: PortChannelProtocol): string {
  switch (object) {
    case PortChannelProtocol.PORT_CHANNEL_PROTOCOL_UNSPECIFIED:
      return "PORT_CHANNEL_PROTOCOL_UNSPECIFIED";
    case PortChannelProtocol.LACP:
      return "LACP";
    case PortChannelProtocol.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * A greatly simplified set of readiness states for a given instance
 * of a Tortuga application.
 */
export enum ApplicationReadiness {
  APPLICATION_READINESS_UNSPECIFIED = 0,
  /** APPLICATION_READINESS_PENDING - Starting up - not ready yet */
  APPLICATION_READINESS_PENDING = 1,
  /** APPLICATION_READINESS_READY - Fully ready to be used. */
  APPLICATION_READINESS_READY = 2,
  /** APPLICATION_READINESS_FAILED - Some type of error seen.  Listeners should expect it to be unavailable. */
  APPLICATION_READINESS_FAILED = 3,
  /** APPLICATION_READINESS_OFFLINE - App is administratively offline. */
  APPLICATION_READINESS_OFFLINE = 4,
  /** APPLICATION_READINESS_DRAINING - App is administratively offline.  Listeners should evacuate any assignments. */
  APPLICATION_READINESS_DRAINING = 5,
  /** APPLICATION_READINESS_STARTING - All containers starting, but not ready to serve requests */
  APPLICATION_READINESS_STARTING = 6,
  /** APPLICATION_READINESS_TERMINATING - App has been requested to terminate by Kubernetes, but is still shutting down */
  APPLICATION_READINESS_TERMINATING = 7,
  UNRECOGNIZED = -1,
}

export function applicationReadinessFromJSON(object: any): ApplicationReadiness {
  switch (object) {
    case 0:
    case "APPLICATION_READINESS_UNSPECIFIED":
      return ApplicationReadiness.APPLICATION_READINESS_UNSPECIFIED;
    case 1:
    case "APPLICATION_READINESS_PENDING":
      return ApplicationReadiness.APPLICATION_READINESS_PENDING;
    case 2:
    case "APPLICATION_READINESS_READY":
      return ApplicationReadiness.APPLICATION_READINESS_READY;
    case 3:
    case "APPLICATION_READINESS_FAILED":
      return ApplicationReadiness.APPLICATION_READINESS_FAILED;
    case 4:
    case "APPLICATION_READINESS_OFFLINE":
      return ApplicationReadiness.APPLICATION_READINESS_OFFLINE;
    case 5:
    case "APPLICATION_READINESS_DRAINING":
      return ApplicationReadiness.APPLICATION_READINESS_DRAINING;
    case 6:
    case "APPLICATION_READINESS_STARTING":
      return ApplicationReadiness.APPLICATION_READINESS_STARTING;
    case 7:
    case "APPLICATION_READINESS_TERMINATING":
      return ApplicationReadiness.APPLICATION_READINESS_TERMINATING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ApplicationReadiness.UNRECOGNIZED;
  }
}

export function applicationReadinessToJSON(object: ApplicationReadiness): string {
  switch (object) {
    case ApplicationReadiness.APPLICATION_READINESS_UNSPECIFIED:
      return "APPLICATION_READINESS_UNSPECIFIED";
    case ApplicationReadiness.APPLICATION_READINESS_PENDING:
      return "APPLICATION_READINESS_PENDING";
    case ApplicationReadiness.APPLICATION_READINESS_READY:
      return "APPLICATION_READINESS_READY";
    case ApplicationReadiness.APPLICATION_READINESS_FAILED:
      return "APPLICATION_READINESS_FAILED";
    case ApplicationReadiness.APPLICATION_READINESS_OFFLINE:
      return "APPLICATION_READINESS_OFFLINE";
    case ApplicationReadiness.APPLICATION_READINESS_DRAINING:
      return "APPLICATION_READINESS_DRAINING";
    case ApplicationReadiness.APPLICATION_READINESS_STARTING:
      return "APPLICATION_READINESS_STARTING";
    case ApplicationReadiness.APPLICATION_READINESS_TERMINATING:
      return "APPLICATION_READINESS_TERMINATING";
    case ApplicationReadiness.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpDupex {
  QSFP_DUPLEX_UNSPECIFIED = 0,
  FULL = 1,
  HALF = 2,
  UNRECOGNIZED = -1,
}

export function qsfpDupexFromJSON(object: any): QsfpDupex {
  switch (object) {
    case 0:
    case "QSFP_DUPLEX_UNSPECIFIED":
      return QsfpDupex.QSFP_DUPLEX_UNSPECIFIED;
    case 1:
    case "FULL":
      return QsfpDupex.FULL;
    case 2:
    case "HALF":
      return QsfpDupex.HALF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpDupex.UNRECOGNIZED;
  }
}

export function qsfpDupexToJSON(object: QsfpDupex): string {
  switch (object) {
    case QsfpDupex.QSFP_DUPLEX_UNSPECIFIED:
      return "QSFP_DUPLEX_UNSPECIFIED";
    case QsfpDupex.FULL:
      return "FULL";
    case QsfpDupex.HALF:
      return "HALF";
    case QsfpDupex.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpAutoNegotiation {
  QSFP_AUTO_NEGOTIATION_UNSPECIFIED = 0,
  QSFP_AUTO_NEGOTIATION_ON = 1,
  QSFP_AUTO_NEGOTIATION_OFF = 2,
  UNRECOGNIZED = -1,
}

export function qsfpAutoNegotiationFromJSON(object: any): QsfpAutoNegotiation {
  switch (object) {
    case 0:
    case "QSFP_AUTO_NEGOTIATION_UNSPECIFIED":
      return QsfpAutoNegotiation.QSFP_AUTO_NEGOTIATION_UNSPECIFIED;
    case 1:
    case "QSFP_AUTO_NEGOTIATION_ON":
      return QsfpAutoNegotiation.QSFP_AUTO_NEGOTIATION_ON;
    case 2:
    case "QSFP_AUTO_NEGOTIATION_OFF":
      return QsfpAutoNegotiation.QSFP_AUTO_NEGOTIATION_OFF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpAutoNegotiation.UNRECOGNIZED;
  }
}

export function qsfpAutoNegotiationToJSON(object: QsfpAutoNegotiation): string {
  switch (object) {
    case QsfpAutoNegotiation.QSFP_AUTO_NEGOTIATION_UNSPECIFIED:
      return "QSFP_AUTO_NEGOTIATION_UNSPECIFIED";
    case QsfpAutoNegotiation.QSFP_AUTO_NEGOTIATION_ON:
      return "QSFP_AUTO_NEGOTIATION_ON";
    case QsfpAutoNegotiation.QSFP_AUTO_NEGOTIATION_OFF:
      return "QSFP_AUTO_NEGOTIATION_OFF";
    case QsfpAutoNegotiation.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpAdvertisedAutoNegotiation {
  QSFP_ADVERTISED_AUTO_NEGOTIATION_UNSPECIFIED = 0,
  QSFP_ADVERTISED_AUTO_NEGOTIATION_YES = 1,
  QSFP_ADVERTISED_AUTO_NEGOTIATION_NO = 2,
  UNRECOGNIZED = -1,
}

export function qsfpAdvertisedAutoNegotiationFromJSON(object: any): QsfpAdvertisedAutoNegotiation {
  switch (object) {
    case 0:
    case "QSFP_ADVERTISED_AUTO_NEGOTIATION_UNSPECIFIED":
      return QsfpAdvertisedAutoNegotiation.QSFP_ADVERTISED_AUTO_NEGOTIATION_UNSPECIFIED;
    case 1:
    case "QSFP_ADVERTISED_AUTO_NEGOTIATION_YES":
      return QsfpAdvertisedAutoNegotiation.QSFP_ADVERTISED_AUTO_NEGOTIATION_YES;
    case 2:
    case "QSFP_ADVERTISED_AUTO_NEGOTIATION_NO":
      return QsfpAdvertisedAutoNegotiation.QSFP_ADVERTISED_AUTO_NEGOTIATION_NO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpAdvertisedAutoNegotiation.UNRECOGNIZED;
  }
}

export function qsfpAdvertisedAutoNegotiationToJSON(object: QsfpAdvertisedAutoNegotiation): string {
  switch (object) {
    case QsfpAdvertisedAutoNegotiation.QSFP_ADVERTISED_AUTO_NEGOTIATION_UNSPECIFIED:
      return "QSFP_ADVERTISED_AUTO_NEGOTIATION_UNSPECIFIED";
    case QsfpAdvertisedAutoNegotiation.QSFP_ADVERTISED_AUTO_NEGOTIATION_YES:
      return "QSFP_ADVERTISED_AUTO_NEGOTIATION_YES";
    case QsfpAdvertisedAutoNegotiation.QSFP_ADVERTISED_AUTO_NEGOTIATION_NO:
      return "QSFP_ADVERTISED_AUTO_NEGOTIATION_NO";
    case QsfpAdvertisedAutoNegotiation.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpTransceiver {
  QSFP_TRANSCEIVER_UNSPECIFIED = 0,
  QSFP_TRANSCEIVER_INTERNAL = 1,
  QSFP_TRANSCEIVER_EXTERNAL = 2,
  UNRECOGNIZED = -1,
}

export function qsfpTransceiverFromJSON(object: any): QsfpTransceiver {
  switch (object) {
    case 0:
    case "QSFP_TRANSCEIVER_UNSPECIFIED":
      return QsfpTransceiver.QSFP_TRANSCEIVER_UNSPECIFIED;
    case 1:
    case "QSFP_TRANSCEIVER_INTERNAL":
      return QsfpTransceiver.QSFP_TRANSCEIVER_INTERNAL;
    case 2:
    case "QSFP_TRANSCEIVER_EXTERNAL":
      return QsfpTransceiver.QSFP_TRANSCEIVER_EXTERNAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpTransceiver.UNRECOGNIZED;
  }
}

export function qsfpTransceiverToJSON(object: QsfpTransceiver): string {
  switch (object) {
    case QsfpTransceiver.QSFP_TRANSCEIVER_UNSPECIFIED:
      return "QSFP_TRANSCEIVER_UNSPECIFIED";
    case QsfpTransceiver.QSFP_TRANSCEIVER_INTERNAL:
      return "QSFP_TRANSCEIVER_INTERNAL";
    case QsfpTransceiver.QSFP_TRANSCEIVER_EXTERNAL:
      return "QSFP_TRANSCEIVER_EXTERNAL";
    case QsfpTransceiver.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpDataPathState {
  QSFP_DATA_PATH_STATE_UNSPECIFIED = 0,
  QSFP_DATA_PATH_STATE_DEACTIVATED = 1,
  QSFP_DATA_PATH_STATE_INIT = 2,
  QSFP_DATA_PATH_STATE_DEINIT = 3,
  QSFP_DATA_PATH_STATE_ACTIVATED = 4,
  QSFP_DATA_PATH_STATE_TX_TURN_ON = 5,
  QSFP_DATA_PATH_STATE_TX_TURN_OFF = 6,
  QSFP_DATA_PATH_STATE_INITIALIZED = 7,
  UNRECOGNIZED = -1,
}

export function qsfpDataPathStateFromJSON(object: any): QsfpDataPathState {
  switch (object) {
    case 0:
    case "QSFP_DATA_PATH_STATE_UNSPECIFIED":
      return QsfpDataPathState.QSFP_DATA_PATH_STATE_UNSPECIFIED;
    case 1:
    case "QSFP_DATA_PATH_STATE_DEACTIVATED":
      return QsfpDataPathState.QSFP_DATA_PATH_STATE_DEACTIVATED;
    case 2:
    case "QSFP_DATA_PATH_STATE_INIT":
      return QsfpDataPathState.QSFP_DATA_PATH_STATE_INIT;
    case 3:
    case "QSFP_DATA_PATH_STATE_DEINIT":
      return QsfpDataPathState.QSFP_DATA_PATH_STATE_DEINIT;
    case 4:
    case "QSFP_DATA_PATH_STATE_ACTIVATED":
      return QsfpDataPathState.QSFP_DATA_PATH_STATE_ACTIVATED;
    case 5:
    case "QSFP_DATA_PATH_STATE_TX_TURN_ON":
      return QsfpDataPathState.QSFP_DATA_PATH_STATE_TX_TURN_ON;
    case 6:
    case "QSFP_DATA_PATH_STATE_TX_TURN_OFF":
      return QsfpDataPathState.QSFP_DATA_PATH_STATE_TX_TURN_OFF;
    case 7:
    case "QSFP_DATA_PATH_STATE_INITIALIZED":
      return QsfpDataPathState.QSFP_DATA_PATH_STATE_INITIALIZED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpDataPathState.UNRECOGNIZED;
  }
}

export function qsfpDataPathStateToJSON(object: QsfpDataPathState): string {
  switch (object) {
    case QsfpDataPathState.QSFP_DATA_PATH_STATE_UNSPECIFIED:
      return "QSFP_DATA_PATH_STATE_UNSPECIFIED";
    case QsfpDataPathState.QSFP_DATA_PATH_STATE_DEACTIVATED:
      return "QSFP_DATA_PATH_STATE_DEACTIVATED";
    case QsfpDataPathState.QSFP_DATA_PATH_STATE_INIT:
      return "QSFP_DATA_PATH_STATE_INIT";
    case QsfpDataPathState.QSFP_DATA_PATH_STATE_DEINIT:
      return "QSFP_DATA_PATH_STATE_DEINIT";
    case QsfpDataPathState.QSFP_DATA_PATH_STATE_ACTIVATED:
      return "QSFP_DATA_PATH_STATE_ACTIVATED";
    case QsfpDataPathState.QSFP_DATA_PATH_STATE_TX_TURN_ON:
      return "QSFP_DATA_PATH_STATE_TX_TURN_ON";
    case QsfpDataPathState.QSFP_DATA_PATH_STATE_TX_TURN_OFF:
      return "QSFP_DATA_PATH_STATE_TX_TURN_OFF";
    case QsfpDataPathState.QSFP_DATA_PATH_STATE_INITIALIZED:
      return "QSFP_DATA_PATH_STATE_INITIALIZED";
    case QsfpDataPathState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpConfigState {
  QSFP_CONFIG_STATE_UNDEFINED = 0,
  QSFP_CONFIG_STATE_SUCCESS = 1,
  QSFP_CONFIG_STATE_REJECTED = 2,
  QSFP_CONFIG_STATE_REJECTED_INVALID_APP_SEL = 3,
  QSFP_CONFIG_STATE_REJECTED_INVALID_DATA_PATH = 4,
  QSFP_CONFIG_STATE_REJECTED_INVALID_SI = 5,
  QSFP_CONFIG_STATE_REJECTED_LANE_IN_USE = 6,
  QSFP_CONFIG_STATE_REJECTED_PARTIAL_DATA_PATH = 7,
  QSFP_CONFIG_STATE_IN_PROGRESS = 12,
  UNRECOGNIZED = -1,
}

export function qsfpConfigStateFromJSON(object: any): QsfpConfigState {
  switch (object) {
    case 0:
    case "QSFP_CONFIG_STATE_UNDEFINED":
      return QsfpConfigState.QSFP_CONFIG_STATE_UNDEFINED;
    case 1:
    case "QSFP_CONFIG_STATE_SUCCESS":
      return QsfpConfigState.QSFP_CONFIG_STATE_SUCCESS;
    case 2:
    case "QSFP_CONFIG_STATE_REJECTED":
      return QsfpConfigState.QSFP_CONFIG_STATE_REJECTED;
    case 3:
    case "QSFP_CONFIG_STATE_REJECTED_INVALID_APP_SEL":
      return QsfpConfigState.QSFP_CONFIG_STATE_REJECTED_INVALID_APP_SEL;
    case 4:
    case "QSFP_CONFIG_STATE_REJECTED_INVALID_DATA_PATH":
      return QsfpConfigState.QSFP_CONFIG_STATE_REJECTED_INVALID_DATA_PATH;
    case 5:
    case "QSFP_CONFIG_STATE_REJECTED_INVALID_SI":
      return QsfpConfigState.QSFP_CONFIG_STATE_REJECTED_INVALID_SI;
    case 6:
    case "QSFP_CONFIG_STATE_REJECTED_LANE_IN_USE":
      return QsfpConfigState.QSFP_CONFIG_STATE_REJECTED_LANE_IN_USE;
    case 7:
    case "QSFP_CONFIG_STATE_REJECTED_PARTIAL_DATA_PATH":
      return QsfpConfigState.QSFP_CONFIG_STATE_REJECTED_PARTIAL_DATA_PATH;
    case 12:
    case "QSFP_CONFIG_STATE_IN_PROGRESS":
      return QsfpConfigState.QSFP_CONFIG_STATE_IN_PROGRESS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpConfigState.UNRECOGNIZED;
  }
}

export function qsfpConfigStateToJSON(object: QsfpConfigState): string {
  switch (object) {
    case QsfpConfigState.QSFP_CONFIG_STATE_UNDEFINED:
      return "QSFP_CONFIG_STATE_UNDEFINED";
    case QsfpConfigState.QSFP_CONFIG_STATE_SUCCESS:
      return "QSFP_CONFIG_STATE_SUCCESS";
    case QsfpConfigState.QSFP_CONFIG_STATE_REJECTED:
      return "QSFP_CONFIG_STATE_REJECTED";
    case QsfpConfigState.QSFP_CONFIG_STATE_REJECTED_INVALID_APP_SEL:
      return "QSFP_CONFIG_STATE_REJECTED_INVALID_APP_SEL";
    case QsfpConfigState.QSFP_CONFIG_STATE_REJECTED_INVALID_DATA_PATH:
      return "QSFP_CONFIG_STATE_REJECTED_INVALID_DATA_PATH";
    case QsfpConfigState.QSFP_CONFIG_STATE_REJECTED_INVALID_SI:
      return "QSFP_CONFIG_STATE_REJECTED_INVALID_SI";
    case QsfpConfigState.QSFP_CONFIG_STATE_REJECTED_LANE_IN_USE:
      return "QSFP_CONFIG_STATE_REJECTED_LANE_IN_USE";
    case QsfpConfigState.QSFP_CONFIG_STATE_REJECTED_PARTIAL_DATA_PATH:
      return "QSFP_CONFIG_STATE_REJECTED_PARTIAL_DATA_PATH";
    case QsfpConfigState.QSFP_CONFIG_STATE_IN_PROGRESS:
      return "QSFP_CONFIG_STATE_IN_PROGRESS";
    case QsfpConfigState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpCmisState {
  QSFP_CMIS_STATE_UNSPECIFIED = 0,
  QSFP_CMIS_STATE_UNKNOWN = 1,
  QSFP_CMIS_STATE_INSERTED = 2,
  QSFP_CMIS_STATE_REMOVED = 3,
  QSFP_CMIS_STATE_READY = 4,
  QSFP_CMIS_STATE_FAULT = 5,
  UNRECOGNIZED = -1,
}

export function qsfpCmisStateFromJSON(object: any): QsfpCmisState {
  switch (object) {
    case 0:
    case "QSFP_CMIS_STATE_UNSPECIFIED":
      return QsfpCmisState.QSFP_CMIS_STATE_UNSPECIFIED;
    case 1:
    case "QSFP_CMIS_STATE_UNKNOWN":
      return QsfpCmisState.QSFP_CMIS_STATE_UNKNOWN;
    case 2:
    case "QSFP_CMIS_STATE_INSERTED":
      return QsfpCmisState.QSFP_CMIS_STATE_INSERTED;
    case 3:
    case "QSFP_CMIS_STATE_REMOVED":
      return QsfpCmisState.QSFP_CMIS_STATE_REMOVED;
    case 4:
    case "QSFP_CMIS_STATE_READY":
      return QsfpCmisState.QSFP_CMIS_STATE_READY;
    case 5:
    case "QSFP_CMIS_STATE_FAULT":
      return QsfpCmisState.QSFP_CMIS_STATE_FAULT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpCmisState.UNRECOGNIZED;
  }
}

export function qsfpCmisStateToJSON(object: QsfpCmisState): string {
  switch (object) {
    case QsfpCmisState.QSFP_CMIS_STATE_UNSPECIFIED:
      return "QSFP_CMIS_STATE_UNSPECIFIED";
    case QsfpCmisState.QSFP_CMIS_STATE_UNKNOWN:
      return "QSFP_CMIS_STATE_UNKNOWN";
    case QsfpCmisState.QSFP_CMIS_STATE_INSERTED:
      return "QSFP_CMIS_STATE_INSERTED";
    case QsfpCmisState.QSFP_CMIS_STATE_REMOVED:
      return "QSFP_CMIS_STATE_REMOVED";
    case QsfpCmisState.QSFP_CMIS_STATE_READY:
      return "QSFP_CMIS_STATE_READY";
    case QsfpCmisState.QSFP_CMIS_STATE_FAULT:
      return "QSFP_CMIS_STATE_FAULT";
    case QsfpCmisState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpModuleState {
  QSFP_MODULE_STATE_UNSPECIFIED = 0,
  QSFP_MODULE_STATE_LOW_PWR = 1,
  QSFP_MODULE_STATE_PWR_UP = 2,
  QSFP_MODULE_STATE_READY = 3,
  QSFP_MODULE_STATE_PWR_DN = 4,
  QSFP_MODULE_STATE_FAULT = 5,
  UNRECOGNIZED = -1,
}

export function qsfpModuleStateFromJSON(object: any): QsfpModuleState {
  switch (object) {
    case 0:
    case "QSFP_MODULE_STATE_UNSPECIFIED":
      return QsfpModuleState.QSFP_MODULE_STATE_UNSPECIFIED;
    case 1:
    case "QSFP_MODULE_STATE_LOW_PWR":
      return QsfpModuleState.QSFP_MODULE_STATE_LOW_PWR;
    case 2:
    case "QSFP_MODULE_STATE_PWR_UP":
      return QsfpModuleState.QSFP_MODULE_STATE_PWR_UP;
    case 3:
    case "QSFP_MODULE_STATE_READY":
      return QsfpModuleState.QSFP_MODULE_STATE_READY;
    case 4:
    case "QSFP_MODULE_STATE_PWR_DN":
      return QsfpModuleState.QSFP_MODULE_STATE_PWR_DN;
    case 5:
    case "QSFP_MODULE_STATE_FAULT":
      return QsfpModuleState.QSFP_MODULE_STATE_FAULT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpModuleState.UNRECOGNIZED;
  }
}

export function qsfpModuleStateToJSON(object: QsfpModuleState): string {
  switch (object) {
    case QsfpModuleState.QSFP_MODULE_STATE_UNSPECIFIED:
      return "QSFP_MODULE_STATE_UNSPECIFIED";
    case QsfpModuleState.QSFP_MODULE_STATE_LOW_PWR:
      return "QSFP_MODULE_STATE_LOW_PWR";
    case QsfpModuleState.QSFP_MODULE_STATE_PWR_UP:
      return "QSFP_MODULE_STATE_PWR_UP";
    case QsfpModuleState.QSFP_MODULE_STATE_READY:
      return "QSFP_MODULE_STATE_READY";
    case QsfpModuleState.QSFP_MODULE_STATE_PWR_DN:
      return "QSFP_MODULE_STATE_PWR_DN";
    case QsfpModuleState.QSFP_MODULE_STATE_FAULT:
      return "QSFP_MODULE_STATE_FAULT";
    case QsfpModuleState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpModuleFaultCause {
  QSFP_MODULE_FAULT_CAUSE_NO_FAULT = 0,
  QSFP_MODULE_FAULT_CAUSE_TEC_RUNAWAY = 1,
  QSFP_MODULE_FAULT_CAUSE_DATA_MEMORY_CORRUPTED = 2,
  QSFP_MODULE_FAULT_CAUSE_PROGRAM_MEMORY_CORRUPTED = 3,
  QSFP_MODULE_FAULT_CAUSE_TRANSMITTER_FAULT = 4,
  QSFP_MODULE_FAULT_CAUSE_RECEIVER_FAULT = 5,
  QSFP_MODULE_FAULT_CAUSE_TEMPERATURE_FAULT = 6,
  UNRECOGNIZED = -1,
}

export function qsfpModuleFaultCauseFromJSON(object: any): QsfpModuleFaultCause {
  switch (object) {
    case 0:
    case "QSFP_MODULE_FAULT_CAUSE_NO_FAULT":
      return QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_NO_FAULT;
    case 1:
    case "QSFP_MODULE_FAULT_CAUSE_TEC_RUNAWAY":
      return QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_TEC_RUNAWAY;
    case 2:
    case "QSFP_MODULE_FAULT_CAUSE_DATA_MEMORY_CORRUPTED":
      return QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_DATA_MEMORY_CORRUPTED;
    case 3:
    case "QSFP_MODULE_FAULT_CAUSE_PROGRAM_MEMORY_CORRUPTED":
      return QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_PROGRAM_MEMORY_CORRUPTED;
    case 4:
    case "QSFP_MODULE_FAULT_CAUSE_TRANSMITTER_FAULT":
      return QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_TRANSMITTER_FAULT;
    case 5:
    case "QSFP_MODULE_FAULT_CAUSE_RECEIVER_FAULT":
      return QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_RECEIVER_FAULT;
    case 6:
    case "QSFP_MODULE_FAULT_CAUSE_TEMPERATURE_FAULT":
      return QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_TEMPERATURE_FAULT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpModuleFaultCause.UNRECOGNIZED;
  }
}

export function qsfpModuleFaultCauseToJSON(object: QsfpModuleFaultCause): string {
  switch (object) {
    case QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_NO_FAULT:
      return "QSFP_MODULE_FAULT_CAUSE_NO_FAULT";
    case QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_TEC_RUNAWAY:
      return "QSFP_MODULE_FAULT_CAUSE_TEC_RUNAWAY";
    case QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_DATA_MEMORY_CORRUPTED:
      return "QSFP_MODULE_FAULT_CAUSE_DATA_MEMORY_CORRUPTED";
    case QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_PROGRAM_MEMORY_CORRUPTED:
      return "QSFP_MODULE_FAULT_CAUSE_PROGRAM_MEMORY_CORRUPTED";
    case QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_TRANSMITTER_FAULT:
      return "QSFP_MODULE_FAULT_CAUSE_TRANSMITTER_FAULT";
    case QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_RECEIVER_FAULT:
      return "QSFP_MODULE_FAULT_CAUSE_RECEIVER_FAULT";
    case QsfpModuleFaultCause.QSFP_MODULE_FAULT_CAUSE_TEMPERATURE_FAULT:
      return "QSFP_MODULE_FAULT_CAUSE_TEMPERATURE_FAULT";
    case QsfpModuleFaultCause.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ApiProtocol {
  API_PROTOCOL_TYPE_UNSPECIFIED = 0,
  API_PROTOCOL_TYPE_REST = 1,
  API_PROTOCOL_TYPE_GRPC = 2,
  UNRECOGNIZED = -1,
}

export function apiProtocolFromJSON(object: any): ApiProtocol {
  switch (object) {
    case 0:
    case "API_PROTOCOL_TYPE_UNSPECIFIED":
      return ApiProtocol.API_PROTOCOL_TYPE_UNSPECIFIED;
    case 1:
    case "API_PROTOCOL_TYPE_REST":
      return ApiProtocol.API_PROTOCOL_TYPE_REST;
    case 2:
    case "API_PROTOCOL_TYPE_GRPC":
      return ApiProtocol.API_PROTOCOL_TYPE_GRPC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ApiProtocol.UNRECOGNIZED;
  }
}

export function apiProtocolToJSON(object: ApiProtocol): string {
  switch (object) {
    case ApiProtocol.API_PROTOCOL_TYPE_UNSPECIFIED:
      return "API_PROTOCOL_TYPE_UNSPECIFIED";
    case ApiProtocol.API_PROTOCOL_TYPE_REST:
      return "API_PROTOCOL_TYPE_REST";
    case ApiProtocol.API_PROTOCOL_TYPE_GRPC:
      return "API_PROTOCOL_TYPE_GRPC";
    case ApiProtocol.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RoutingPolicy {
  ROUTING_POLICY_UNKNOWN = 0,
  ROUTING_POLICY_LOAD_BALANCED = 1,
  ROUTING_POLICY_ASSIGNMENT = 2,
  UNRECOGNIZED = -1,
}

export function routingPolicyFromJSON(object: any): RoutingPolicy {
  switch (object) {
    case 0:
    case "ROUTING_POLICY_UNKNOWN":
      return RoutingPolicy.ROUTING_POLICY_UNKNOWN;
    case 1:
    case "ROUTING_POLICY_LOAD_BALANCED":
      return RoutingPolicy.ROUTING_POLICY_LOAD_BALANCED;
    case 2:
    case "ROUTING_POLICY_ASSIGNMENT":
      return RoutingPolicy.ROUTING_POLICY_ASSIGNMENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RoutingPolicy.UNRECOGNIZED;
  }
}

export function routingPolicyToJSON(object: RoutingPolicy): string {
  switch (object) {
    case RoutingPolicy.ROUTING_POLICY_UNKNOWN:
      return "ROUTING_POLICY_UNKNOWN";
    case RoutingPolicy.ROUTING_POLICY_LOAD_BALANCED:
      return "ROUTING_POLICY_LOAD_BALANCED";
    case RoutingPolicy.ROUTING_POLICY_ASSIGNMENT:
      return "ROUTING_POLICY_ASSIGNMENT";
    case RoutingPolicy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TwampSessionState {
  TWAMP_SESSION_STATE_UNKNOWN = 0,
  TWAMP_SESSION_STATE_UP = 1,
  TWAMP_SESSION_STATE_DOWN = 2,
  UNRECOGNIZED = -1,
}

export function twampSessionStateFromJSON(object: any): TwampSessionState {
  switch (object) {
    case 0:
    case "TWAMP_SESSION_STATE_UNKNOWN":
      return TwampSessionState.TWAMP_SESSION_STATE_UNKNOWN;
    case 1:
    case "TWAMP_SESSION_STATE_UP":
      return TwampSessionState.TWAMP_SESSION_STATE_UP;
    case 2:
    case "TWAMP_SESSION_STATE_DOWN":
      return TwampSessionState.TWAMP_SESSION_STATE_DOWN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TwampSessionState.UNRECOGNIZED;
  }
}

export function twampSessionStateToJSON(object: TwampSessionState): string {
  switch (object) {
    case TwampSessionState.TWAMP_SESSION_STATE_UNKNOWN:
      return "TWAMP_SESSION_STATE_UNKNOWN";
    case TwampSessionState.TWAMP_SESSION_STATE_UP:
      return "TWAMP_SESSION_STATE_UP";
    case TwampSessionState.TWAMP_SESSION_STATE_DOWN:
      return "TWAMP_SESSION_STATE_DOWN";
    case TwampSessionState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TwampPathMtuDiscoveryReason {
  TWAMP_PATH_MTU_DISCOVERY_REASON_UNSPECIFIED = 0,
  TWAMP_PATH_MTU_DISCOVERY_REASON_NOT_DISCOVERED = 1,
  TWAMP_PATH_MTU_DISCOVERY_REASON_PROBING_CONVERGENCE = 2,
  TWAMP_PATH_MTU_DISCOVERY_REASON_ICMP_RESPONSE = 3,
  UNRECOGNIZED = -1,
}

export function twampPathMtuDiscoveryReasonFromJSON(object: any): TwampPathMtuDiscoveryReason {
  switch (object) {
    case 0:
    case "TWAMP_PATH_MTU_DISCOVERY_REASON_UNSPECIFIED":
      return TwampPathMtuDiscoveryReason.TWAMP_PATH_MTU_DISCOVERY_REASON_UNSPECIFIED;
    case 1:
    case "TWAMP_PATH_MTU_DISCOVERY_REASON_NOT_DISCOVERED":
      return TwampPathMtuDiscoveryReason.TWAMP_PATH_MTU_DISCOVERY_REASON_NOT_DISCOVERED;
    case 2:
    case "TWAMP_PATH_MTU_DISCOVERY_REASON_PROBING_CONVERGENCE":
      return TwampPathMtuDiscoveryReason.TWAMP_PATH_MTU_DISCOVERY_REASON_PROBING_CONVERGENCE;
    case 3:
    case "TWAMP_PATH_MTU_DISCOVERY_REASON_ICMP_RESPONSE":
      return TwampPathMtuDiscoveryReason.TWAMP_PATH_MTU_DISCOVERY_REASON_ICMP_RESPONSE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TwampPathMtuDiscoveryReason.UNRECOGNIZED;
  }
}

export function twampPathMtuDiscoveryReasonToJSON(object: TwampPathMtuDiscoveryReason): string {
  switch (object) {
    case TwampPathMtuDiscoveryReason.TWAMP_PATH_MTU_DISCOVERY_REASON_UNSPECIFIED:
      return "TWAMP_PATH_MTU_DISCOVERY_REASON_UNSPECIFIED";
    case TwampPathMtuDiscoveryReason.TWAMP_PATH_MTU_DISCOVERY_REASON_NOT_DISCOVERED:
      return "TWAMP_PATH_MTU_DISCOVERY_REASON_NOT_DISCOVERED";
    case TwampPathMtuDiscoveryReason.TWAMP_PATH_MTU_DISCOVERY_REASON_PROBING_CONVERGENCE:
      return "TWAMP_PATH_MTU_DISCOVERY_REASON_PROBING_CONVERGENCE";
    case TwampPathMtuDiscoveryReason.TWAMP_PATH_MTU_DISCOVERY_REASON_ICMP_RESPONSE:
      return "TWAMP_PATH_MTU_DISCOVERY_REASON_ICMP_RESPONSE";
    case TwampPathMtuDiscoveryReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SoftwareUpdateState {
  SOFTWARE_UPDATE_STATE_UNKNOWN = 0,
  /** SOFTWARE_UPDATE_STATE_UP_TO_DATE - Software is up to date; no changes pending */
  SOFTWARE_UPDATE_STATE_UP_TO_DATE = 1,
  /** SOFTWARE_UPDATE_STATE_PREPARING - Device has been instructed to update, and is downloading or otherwise preparing an update */
  SOFTWARE_UPDATE_STATE_PREPARING = 2,
  /** SOFTWARE_UPDATE_STATE_READY - Device is ready to update and waiting on user input to proceed */
  SOFTWARE_UPDATE_STATE_READY = 3,
  /** SOFTWARE_UPDATE_STATE_VERIFYING - Device has completed installation and is performing final checks */
  SOFTWARE_UPDATE_STATE_VERIFYING = 4,
  /** SOFTWARE_UPDATE_STATE_APPLYING - Device is in the process of applying an update */
  SOFTWARE_UPDATE_STATE_APPLYING = 5,
  /** SOFTWARE_UPDATE_STATE_REBOOTING - Device has applied an update and is rebooting */
  SOFTWARE_UPDATE_STATE_REBOOTING = 6,
  /** SOFTWARE_UPDATE_STATE_FAILED - Device attempted to apply an update and encountered a failure (user action required) */
  SOFTWARE_UPDATE_STATE_FAILED = 7,
  /** SOFTWARE_UPDATE_STATE_LOADING_MANIFEST - The device is downloading the latest update manifest from the controller. */
  SOFTWARE_UPDATE_STATE_LOADING_MANIFEST = 8,
  UNRECOGNIZED = -1,
}

export function softwareUpdateStateFromJSON(object: any): SoftwareUpdateState {
  switch (object) {
    case 0:
    case "SOFTWARE_UPDATE_STATE_UNKNOWN":
      return SoftwareUpdateState.SOFTWARE_UPDATE_STATE_UNKNOWN;
    case 1:
    case "SOFTWARE_UPDATE_STATE_UP_TO_DATE":
      return SoftwareUpdateState.SOFTWARE_UPDATE_STATE_UP_TO_DATE;
    case 2:
    case "SOFTWARE_UPDATE_STATE_PREPARING":
      return SoftwareUpdateState.SOFTWARE_UPDATE_STATE_PREPARING;
    case 3:
    case "SOFTWARE_UPDATE_STATE_READY":
      return SoftwareUpdateState.SOFTWARE_UPDATE_STATE_READY;
    case 4:
    case "SOFTWARE_UPDATE_STATE_VERIFYING":
      return SoftwareUpdateState.SOFTWARE_UPDATE_STATE_VERIFYING;
    case 5:
    case "SOFTWARE_UPDATE_STATE_APPLYING":
      return SoftwareUpdateState.SOFTWARE_UPDATE_STATE_APPLYING;
    case 6:
    case "SOFTWARE_UPDATE_STATE_REBOOTING":
      return SoftwareUpdateState.SOFTWARE_UPDATE_STATE_REBOOTING;
    case 7:
    case "SOFTWARE_UPDATE_STATE_FAILED":
      return SoftwareUpdateState.SOFTWARE_UPDATE_STATE_FAILED;
    case 8:
    case "SOFTWARE_UPDATE_STATE_LOADING_MANIFEST":
      return SoftwareUpdateState.SOFTWARE_UPDATE_STATE_LOADING_MANIFEST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SoftwareUpdateState.UNRECOGNIZED;
  }
}

export function softwareUpdateStateToJSON(object: SoftwareUpdateState): string {
  switch (object) {
    case SoftwareUpdateState.SOFTWARE_UPDATE_STATE_UNKNOWN:
      return "SOFTWARE_UPDATE_STATE_UNKNOWN";
    case SoftwareUpdateState.SOFTWARE_UPDATE_STATE_UP_TO_DATE:
      return "SOFTWARE_UPDATE_STATE_UP_TO_DATE";
    case SoftwareUpdateState.SOFTWARE_UPDATE_STATE_PREPARING:
      return "SOFTWARE_UPDATE_STATE_PREPARING";
    case SoftwareUpdateState.SOFTWARE_UPDATE_STATE_READY:
      return "SOFTWARE_UPDATE_STATE_READY";
    case SoftwareUpdateState.SOFTWARE_UPDATE_STATE_VERIFYING:
      return "SOFTWARE_UPDATE_STATE_VERIFYING";
    case SoftwareUpdateState.SOFTWARE_UPDATE_STATE_APPLYING:
      return "SOFTWARE_UPDATE_STATE_APPLYING";
    case SoftwareUpdateState.SOFTWARE_UPDATE_STATE_REBOOTING:
      return "SOFTWARE_UPDATE_STATE_REBOOTING";
    case SoftwareUpdateState.SOFTWARE_UPDATE_STATE_FAILED:
      return "SOFTWARE_UPDATE_STATE_FAILED";
    case SoftwareUpdateState.SOFTWARE_UPDATE_STATE_LOADING_MANIFEST:
      return "SOFTWARE_UPDATE_STATE_LOADING_MANIFEST";
    case SoftwareUpdateState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ManifestImagePartitionStatus {
  PARTITION_STATUS_UNSPECIFIED = 0,
  PARTITION_STATUS_ACTIVE = 1,
  PARTITION_STATUS_STANDBY_READY = 2,
  PARTITION_STATUS_ARTIFACTS_NOT_FULLY_SPECIFIED = 3,
  PARTITION_STATUS_DOWNLOADING_ARTIFACTS = 4,
  PARTITION_STATUS_STAGING_IN_PROGRESS = 5,
  PARTITION_STATUS_STAGING_COMPLETED = 6,
  PARTITION_STATUS_STAGING_FAILED = 7,
  PARTITION_STATUS_VERIFY_IN_PROGRESS = 8,
  PARTITION_STATUS_VERIFY_COMPLETED = 9,
  PARTITION_STATUS_VERIFY_FAILED = 10,
  PARTITION_STATUS_UPGRADE_IN_PROGRESS = 11,
  PARTITION_STATUS_UPGRADE_FAILED = 12,
  PARTITION_STATUS_FIRMWARE_UPGRADE_IN_PROGRESS = 13,
  /** PARTITION_STATUS_BACKUP_STAGING_IN_PROGRESS - these statuses are used when staging the standby to match the active */
  PARTITION_STATUS_BACKUP_STAGING_IN_PROGRESS = 14,
  PARTITION_STATUS_BACKUP_STAGING_COMPLETED = 15,
  PARTITION_STATUS_BACKUP_STAGING_FAILED = 16,
  PARTITION_STATUS_BACKUP_VERIFY_IN_PROGRESS = 17,
  PARTITION_STATUS_BACKUP_VERIFY_COMPLETED = 18,
  PARTITION_STATUS_BACKUP_VERIFY_FAILED = 19,
  /** PARTITION_STATUS_STANDBY_DOWNLOAD_COMPLETE - indicates that all pre-staged artifacts have been downloaded */
  PARTITION_STATUS_STANDBY_DOWNLOAD_COMPLETE = 20,
  UNRECOGNIZED = -1,
}

export function manifestImagePartitionStatusFromJSON(object: any): ManifestImagePartitionStatus {
  switch (object) {
    case 0:
    case "PARTITION_STATUS_UNSPECIFIED":
      return ManifestImagePartitionStatus.PARTITION_STATUS_UNSPECIFIED;
    case 1:
    case "PARTITION_STATUS_ACTIVE":
      return ManifestImagePartitionStatus.PARTITION_STATUS_ACTIVE;
    case 2:
    case "PARTITION_STATUS_STANDBY_READY":
      return ManifestImagePartitionStatus.PARTITION_STATUS_STANDBY_READY;
    case 3:
    case "PARTITION_STATUS_ARTIFACTS_NOT_FULLY_SPECIFIED":
      return ManifestImagePartitionStatus.PARTITION_STATUS_ARTIFACTS_NOT_FULLY_SPECIFIED;
    case 4:
    case "PARTITION_STATUS_DOWNLOADING_ARTIFACTS":
      return ManifestImagePartitionStatus.PARTITION_STATUS_DOWNLOADING_ARTIFACTS;
    case 5:
    case "PARTITION_STATUS_STAGING_IN_PROGRESS":
      return ManifestImagePartitionStatus.PARTITION_STATUS_STAGING_IN_PROGRESS;
    case 6:
    case "PARTITION_STATUS_STAGING_COMPLETED":
      return ManifestImagePartitionStatus.PARTITION_STATUS_STAGING_COMPLETED;
    case 7:
    case "PARTITION_STATUS_STAGING_FAILED":
      return ManifestImagePartitionStatus.PARTITION_STATUS_STAGING_FAILED;
    case 8:
    case "PARTITION_STATUS_VERIFY_IN_PROGRESS":
      return ManifestImagePartitionStatus.PARTITION_STATUS_VERIFY_IN_PROGRESS;
    case 9:
    case "PARTITION_STATUS_VERIFY_COMPLETED":
      return ManifestImagePartitionStatus.PARTITION_STATUS_VERIFY_COMPLETED;
    case 10:
    case "PARTITION_STATUS_VERIFY_FAILED":
      return ManifestImagePartitionStatus.PARTITION_STATUS_VERIFY_FAILED;
    case 11:
    case "PARTITION_STATUS_UPGRADE_IN_PROGRESS":
      return ManifestImagePartitionStatus.PARTITION_STATUS_UPGRADE_IN_PROGRESS;
    case 12:
    case "PARTITION_STATUS_UPGRADE_FAILED":
      return ManifestImagePartitionStatus.PARTITION_STATUS_UPGRADE_FAILED;
    case 13:
    case "PARTITION_STATUS_FIRMWARE_UPGRADE_IN_PROGRESS":
      return ManifestImagePartitionStatus.PARTITION_STATUS_FIRMWARE_UPGRADE_IN_PROGRESS;
    case 14:
    case "PARTITION_STATUS_BACKUP_STAGING_IN_PROGRESS":
      return ManifestImagePartitionStatus.PARTITION_STATUS_BACKUP_STAGING_IN_PROGRESS;
    case 15:
    case "PARTITION_STATUS_BACKUP_STAGING_COMPLETED":
      return ManifestImagePartitionStatus.PARTITION_STATUS_BACKUP_STAGING_COMPLETED;
    case 16:
    case "PARTITION_STATUS_BACKUP_STAGING_FAILED":
      return ManifestImagePartitionStatus.PARTITION_STATUS_BACKUP_STAGING_FAILED;
    case 17:
    case "PARTITION_STATUS_BACKUP_VERIFY_IN_PROGRESS":
      return ManifestImagePartitionStatus.PARTITION_STATUS_BACKUP_VERIFY_IN_PROGRESS;
    case 18:
    case "PARTITION_STATUS_BACKUP_VERIFY_COMPLETED":
      return ManifestImagePartitionStatus.PARTITION_STATUS_BACKUP_VERIFY_COMPLETED;
    case 19:
    case "PARTITION_STATUS_BACKUP_VERIFY_FAILED":
      return ManifestImagePartitionStatus.PARTITION_STATUS_BACKUP_VERIFY_FAILED;
    case 20:
    case "PARTITION_STATUS_STANDBY_DOWNLOAD_COMPLETE":
      return ManifestImagePartitionStatus.PARTITION_STATUS_STANDBY_DOWNLOAD_COMPLETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ManifestImagePartitionStatus.UNRECOGNIZED;
  }
}

export function manifestImagePartitionStatusToJSON(object: ManifestImagePartitionStatus): string {
  switch (object) {
    case ManifestImagePartitionStatus.PARTITION_STATUS_UNSPECIFIED:
      return "PARTITION_STATUS_UNSPECIFIED";
    case ManifestImagePartitionStatus.PARTITION_STATUS_ACTIVE:
      return "PARTITION_STATUS_ACTIVE";
    case ManifestImagePartitionStatus.PARTITION_STATUS_STANDBY_READY:
      return "PARTITION_STATUS_STANDBY_READY";
    case ManifestImagePartitionStatus.PARTITION_STATUS_ARTIFACTS_NOT_FULLY_SPECIFIED:
      return "PARTITION_STATUS_ARTIFACTS_NOT_FULLY_SPECIFIED";
    case ManifestImagePartitionStatus.PARTITION_STATUS_DOWNLOADING_ARTIFACTS:
      return "PARTITION_STATUS_DOWNLOADING_ARTIFACTS";
    case ManifestImagePartitionStatus.PARTITION_STATUS_STAGING_IN_PROGRESS:
      return "PARTITION_STATUS_STAGING_IN_PROGRESS";
    case ManifestImagePartitionStatus.PARTITION_STATUS_STAGING_COMPLETED:
      return "PARTITION_STATUS_STAGING_COMPLETED";
    case ManifestImagePartitionStatus.PARTITION_STATUS_STAGING_FAILED:
      return "PARTITION_STATUS_STAGING_FAILED";
    case ManifestImagePartitionStatus.PARTITION_STATUS_VERIFY_IN_PROGRESS:
      return "PARTITION_STATUS_VERIFY_IN_PROGRESS";
    case ManifestImagePartitionStatus.PARTITION_STATUS_VERIFY_COMPLETED:
      return "PARTITION_STATUS_VERIFY_COMPLETED";
    case ManifestImagePartitionStatus.PARTITION_STATUS_VERIFY_FAILED:
      return "PARTITION_STATUS_VERIFY_FAILED";
    case ManifestImagePartitionStatus.PARTITION_STATUS_UPGRADE_IN_PROGRESS:
      return "PARTITION_STATUS_UPGRADE_IN_PROGRESS";
    case ManifestImagePartitionStatus.PARTITION_STATUS_UPGRADE_FAILED:
      return "PARTITION_STATUS_UPGRADE_FAILED";
    case ManifestImagePartitionStatus.PARTITION_STATUS_FIRMWARE_UPGRADE_IN_PROGRESS:
      return "PARTITION_STATUS_FIRMWARE_UPGRADE_IN_PROGRESS";
    case ManifestImagePartitionStatus.PARTITION_STATUS_BACKUP_STAGING_IN_PROGRESS:
      return "PARTITION_STATUS_BACKUP_STAGING_IN_PROGRESS";
    case ManifestImagePartitionStatus.PARTITION_STATUS_BACKUP_STAGING_COMPLETED:
      return "PARTITION_STATUS_BACKUP_STAGING_COMPLETED";
    case ManifestImagePartitionStatus.PARTITION_STATUS_BACKUP_STAGING_FAILED:
      return "PARTITION_STATUS_BACKUP_STAGING_FAILED";
    case ManifestImagePartitionStatus.PARTITION_STATUS_BACKUP_VERIFY_IN_PROGRESS:
      return "PARTITION_STATUS_BACKUP_VERIFY_IN_PROGRESS";
    case ManifestImagePartitionStatus.PARTITION_STATUS_BACKUP_VERIFY_COMPLETED:
      return "PARTITION_STATUS_BACKUP_VERIFY_COMPLETED";
    case ManifestImagePartitionStatus.PARTITION_STATUS_BACKUP_VERIFY_FAILED:
      return "PARTITION_STATUS_BACKUP_VERIFY_FAILED";
    case ManifestImagePartitionStatus.PARTITION_STATUS_STANDBY_DOWNLOAD_COMPLETE:
      return "PARTITION_STATUS_STANDBY_DOWNLOAD_COMPLETE";
    case ManifestImagePartitionStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ImageStatus {
  IMAGE_STATE_UNSPECIFIED = 0,
  ACTIVE = 1,
  STAND_BY = 2,
  UNRECOGNIZED = -1,
}

export function imageStatusFromJSON(object: any): ImageStatus {
  switch (object) {
    case 0:
    case "IMAGE_STATE_UNSPECIFIED":
      return ImageStatus.IMAGE_STATE_UNSPECIFIED;
    case 1:
    case "ACTIVE":
      return ImageStatus.ACTIVE;
    case 2:
    case "STAND_BY":
      return ImageStatus.STAND_BY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ImageStatus.UNRECOGNIZED;
  }
}

export function imageStatusToJSON(object: ImageStatus): string {
  switch (object) {
    case ImageStatus.IMAGE_STATE_UNSPECIFIED:
      return "IMAGE_STATE_UNSPECIFIED";
    case ImageStatus.ACTIVE:
      return "ACTIVE";
    case ImageStatus.STAND_BY:
      return "STAND_BY";
    case ImageStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CacheStatus {
  PRESENT_VERIFIED = 0,
  PRESENT_PENDING_VERIFICATION = 1,
  FETCHING = 2,
  FAILED_VERIFICATION_PENDING_REFETCH = 3,
  FAILED_VERIFICATION_REFETCHING = 4,
  FETCH_PENDING = 5,
  UNRECOGNIZED = -1,
}

export function cacheStatusFromJSON(object: any): CacheStatus {
  switch (object) {
    case 0:
    case "PRESENT_VERIFIED":
      return CacheStatus.PRESENT_VERIFIED;
    case 1:
    case "PRESENT_PENDING_VERIFICATION":
      return CacheStatus.PRESENT_PENDING_VERIFICATION;
    case 2:
    case "FETCHING":
      return CacheStatus.FETCHING;
    case 3:
    case "FAILED_VERIFICATION_PENDING_REFETCH":
      return CacheStatus.FAILED_VERIFICATION_PENDING_REFETCH;
    case 4:
    case "FAILED_VERIFICATION_REFETCHING":
      return CacheStatus.FAILED_VERIFICATION_REFETCHING;
    case 5:
    case "FETCH_PENDING":
      return CacheStatus.FETCH_PENDING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CacheStatus.UNRECOGNIZED;
  }
}

export function cacheStatusToJSON(object: CacheStatus): string {
  switch (object) {
    case CacheStatus.PRESENT_VERIFIED:
      return "PRESENT_VERIFIED";
    case CacheStatus.PRESENT_PENDING_VERIFICATION:
      return "PRESENT_PENDING_VERIFICATION";
    case CacheStatus.FETCHING:
      return "FETCHING";
    case CacheStatus.FAILED_VERIFICATION_PENDING_REFETCH:
      return "FAILED_VERIFICATION_PENDING_REFETCH";
    case CacheStatus.FAILED_VERIFICATION_REFETCHING:
      return "FAILED_VERIFICATION_REFETCHING";
    case CacheStatus.FETCH_PENDING:
      return "FETCH_PENDING";
    case CacheStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StpVlanPortStateStatus {
  STP_VLAN_PORT_STATE_STATUS_UNSPECIFIED = 0,
  STP_VLAN_PORT_STATE_DISABLED = 1,
  STP_VLAN_PORT_STATE_BLOCKING = 2,
  STP_VLAN_PORT_STATE_LISTENING = 3,
  STP_VLAN_PORT_STATE_LEARNING = 4,
  STP_VLAN_PORT_STATE_FORWARDING = 5,
  STP_VLAN_PORT_STATE_UNKNOWN = 6,
  STP_VLAN_PORT_STATE_BROKEN = 7,
  STP_VLAN_PORT_STATE_BPDU_DIS = 8,
  STP_VLAN_PORT_STATE_BLOCKING_ROOT_GUARD_INCONSISTENT = 9,
  STP_VLAN_PORT_STATE_LISTENING_ROOT_GUARD_INCONSISTENT = 10,
  STP_VLAN_PORT_STATE_LEARNING_ROOT_GUARD_INCONSISTENT = 11,
  STP_VLAN_PORT_STATE_BPDU_DIS_ROOT_GUARD_INCONSISTENT = 12,
  STP_VLAN_PORT_STATE_BLOCKING_ROOT_INCONSISTENT = 13,
  UNRECOGNIZED = -1,
}

export function stpVlanPortStateStatusFromJSON(object: any): StpVlanPortStateStatus {
  switch (object) {
    case 0:
    case "STP_VLAN_PORT_STATE_STATUS_UNSPECIFIED":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_STATUS_UNSPECIFIED;
    case 1:
    case "STP_VLAN_PORT_STATE_DISABLED":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_DISABLED;
    case 2:
    case "STP_VLAN_PORT_STATE_BLOCKING":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_BLOCKING;
    case 3:
    case "STP_VLAN_PORT_STATE_LISTENING":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_LISTENING;
    case 4:
    case "STP_VLAN_PORT_STATE_LEARNING":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_LEARNING;
    case 5:
    case "STP_VLAN_PORT_STATE_FORWARDING":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_FORWARDING;
    case 6:
    case "STP_VLAN_PORT_STATE_UNKNOWN":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_UNKNOWN;
    case 7:
    case "STP_VLAN_PORT_STATE_BROKEN":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_BROKEN;
    case 8:
    case "STP_VLAN_PORT_STATE_BPDU_DIS":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_BPDU_DIS;
    case 9:
    case "STP_VLAN_PORT_STATE_BLOCKING_ROOT_GUARD_INCONSISTENT":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_BLOCKING_ROOT_GUARD_INCONSISTENT;
    case 10:
    case "STP_VLAN_PORT_STATE_LISTENING_ROOT_GUARD_INCONSISTENT":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_LISTENING_ROOT_GUARD_INCONSISTENT;
    case 11:
    case "STP_VLAN_PORT_STATE_LEARNING_ROOT_GUARD_INCONSISTENT":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_LEARNING_ROOT_GUARD_INCONSISTENT;
    case 12:
    case "STP_VLAN_PORT_STATE_BPDU_DIS_ROOT_GUARD_INCONSISTENT":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_BPDU_DIS_ROOT_GUARD_INCONSISTENT;
    case 13:
    case "STP_VLAN_PORT_STATE_BLOCKING_ROOT_INCONSISTENT":
      return StpVlanPortStateStatus.STP_VLAN_PORT_STATE_BLOCKING_ROOT_INCONSISTENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StpVlanPortStateStatus.UNRECOGNIZED;
  }
}

export function stpVlanPortStateStatusToJSON(object: StpVlanPortStateStatus): string {
  switch (object) {
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_STATUS_UNSPECIFIED:
      return "STP_VLAN_PORT_STATE_STATUS_UNSPECIFIED";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_DISABLED:
      return "STP_VLAN_PORT_STATE_DISABLED";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_BLOCKING:
      return "STP_VLAN_PORT_STATE_BLOCKING";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_LISTENING:
      return "STP_VLAN_PORT_STATE_LISTENING";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_LEARNING:
      return "STP_VLAN_PORT_STATE_LEARNING";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_FORWARDING:
      return "STP_VLAN_PORT_STATE_FORWARDING";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_UNKNOWN:
      return "STP_VLAN_PORT_STATE_UNKNOWN";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_BROKEN:
      return "STP_VLAN_PORT_STATE_BROKEN";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_BPDU_DIS:
      return "STP_VLAN_PORT_STATE_BPDU_DIS";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_BLOCKING_ROOT_GUARD_INCONSISTENT:
      return "STP_VLAN_PORT_STATE_BLOCKING_ROOT_GUARD_INCONSISTENT";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_LISTENING_ROOT_GUARD_INCONSISTENT:
      return "STP_VLAN_PORT_STATE_LISTENING_ROOT_GUARD_INCONSISTENT";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_LEARNING_ROOT_GUARD_INCONSISTENT:
      return "STP_VLAN_PORT_STATE_LEARNING_ROOT_GUARD_INCONSISTENT";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_BPDU_DIS_ROOT_GUARD_INCONSISTENT:
      return "STP_VLAN_PORT_STATE_BPDU_DIS_ROOT_GUARD_INCONSISTENT";
    case StpVlanPortStateStatus.STP_VLAN_PORT_STATE_BLOCKING_ROOT_INCONSISTENT:
      return "STP_VLAN_PORT_STATE_BLOCKING_ROOT_INCONSISTENT";
    case StpVlanPortStateStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum IpMethodType {
  IP_METHOD_TYPE_UNSPECIFIED = 0,
  IP_METHOD_TYPE_STATIC = 1,
  IP_METHOD_TYPE_DYNAMIC = 2,
  UNRECOGNIZED = -1,
}

export function ipMethodTypeFromJSON(object: any): IpMethodType {
  switch (object) {
    case 0:
    case "IP_METHOD_TYPE_UNSPECIFIED":
      return IpMethodType.IP_METHOD_TYPE_UNSPECIFIED;
    case 1:
    case "IP_METHOD_TYPE_STATIC":
      return IpMethodType.IP_METHOD_TYPE_STATIC;
    case 2:
    case "IP_METHOD_TYPE_DYNAMIC":
      return IpMethodType.IP_METHOD_TYPE_DYNAMIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IpMethodType.UNRECOGNIZED;
  }
}

export function ipMethodTypeToJSON(object: IpMethodType): string {
  switch (object) {
    case IpMethodType.IP_METHOD_TYPE_UNSPECIFIED:
      return "IP_METHOD_TYPE_UNSPECIFIED";
    case IpMethodType.IP_METHOD_TYPE_STATIC:
      return "IP_METHOD_TYPE_STATIC";
    case IpMethodType.IP_METHOD_TYPE_DYNAMIC:
      return "IP_METHOD_TYPE_DYNAMIC";
    case IpMethodType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ServerIpRouteScope {
  SERVER_ROUTE_SCOPE_UNSPECIFIED = 0,
  SERVER_ROUTE_SCOPE_LINK = 1,
  SERVER_ROUTE_SCOPE_HOST = 2,
  UNRECOGNIZED = -1,
}

export function serverIpRouteScopeFromJSON(object: any): ServerIpRouteScope {
  switch (object) {
    case 0:
    case "SERVER_ROUTE_SCOPE_UNSPECIFIED":
      return ServerIpRouteScope.SERVER_ROUTE_SCOPE_UNSPECIFIED;
    case 1:
    case "SERVER_ROUTE_SCOPE_LINK":
      return ServerIpRouteScope.SERVER_ROUTE_SCOPE_LINK;
    case 2:
    case "SERVER_ROUTE_SCOPE_HOST":
      return ServerIpRouteScope.SERVER_ROUTE_SCOPE_HOST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ServerIpRouteScope.UNRECOGNIZED;
  }
}

export function serverIpRouteScopeToJSON(object: ServerIpRouteScope): string {
  switch (object) {
    case ServerIpRouteScope.SERVER_ROUTE_SCOPE_UNSPECIFIED:
      return "SERVER_ROUTE_SCOPE_UNSPECIFIED";
    case ServerIpRouteScope.SERVER_ROUTE_SCOPE_LINK:
      return "SERVER_ROUTE_SCOPE_LINK";
    case ServerIpRouteScope.SERVER_ROUTE_SCOPE_HOST:
      return "SERVER_ROUTE_SCOPE_HOST";
    case ServerIpRouteScope.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ServerIpRouteType {
  SERVER_ROUTE_TYPE_UNSPECIFIED = 0,
  SERVER_ROUTE_TYPE_LOCAL = 1,
  SERVER_ROUTE_TYPE_BROADCAST = 2,
  SEVER_ROUTE_TYPE_MULTICAST = 3,
  UNRECOGNIZED = -1,
}

export function serverIpRouteTypeFromJSON(object: any): ServerIpRouteType {
  switch (object) {
    case 0:
    case "SERVER_ROUTE_TYPE_UNSPECIFIED":
      return ServerIpRouteType.SERVER_ROUTE_TYPE_UNSPECIFIED;
    case 1:
    case "SERVER_ROUTE_TYPE_LOCAL":
      return ServerIpRouteType.SERVER_ROUTE_TYPE_LOCAL;
    case 2:
    case "SERVER_ROUTE_TYPE_BROADCAST":
      return ServerIpRouteType.SERVER_ROUTE_TYPE_BROADCAST;
    case 3:
    case "SEVER_ROUTE_TYPE_MULTICAST":
      return ServerIpRouteType.SEVER_ROUTE_TYPE_MULTICAST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ServerIpRouteType.UNRECOGNIZED;
  }
}

export function serverIpRouteTypeToJSON(object: ServerIpRouteType): string {
  switch (object) {
    case ServerIpRouteType.SERVER_ROUTE_TYPE_UNSPECIFIED:
      return "SERVER_ROUTE_TYPE_UNSPECIFIED";
    case ServerIpRouteType.SERVER_ROUTE_TYPE_LOCAL:
      return "SERVER_ROUTE_TYPE_LOCAL";
    case ServerIpRouteType.SERVER_ROUTE_TYPE_BROADCAST:
      return "SERVER_ROUTE_TYPE_BROADCAST";
    case ServerIpRouteType.SEVER_ROUTE_TYPE_MULTICAST:
      return "SEVER_ROUTE_TYPE_MULTICAST";
    case ServerIpRouteType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ServerType {
  SERVER_TYPE_UNSPECIFIED = 0,
  SERVER_TYPE_BRONCO = 1,
  SERVER_TYPE_UCS_C225 = 2,
  SERVER_TYPE_UCS_MUSTANG = 3,
  SERVER_TYPE_UCS_C880A = 4,
  UNRECOGNIZED = -1,
}

export function serverTypeFromJSON(object: any): ServerType {
  switch (object) {
    case 0:
    case "SERVER_TYPE_UNSPECIFIED":
      return ServerType.SERVER_TYPE_UNSPECIFIED;
    case 1:
    case "SERVER_TYPE_BRONCO":
      return ServerType.SERVER_TYPE_BRONCO;
    case 2:
    case "SERVER_TYPE_UCS_C225":
      return ServerType.SERVER_TYPE_UCS_C225;
    case 3:
    case "SERVER_TYPE_UCS_MUSTANG":
      return ServerType.SERVER_TYPE_UCS_MUSTANG;
    case 4:
    case "SERVER_TYPE_UCS_C880A":
      return ServerType.SERVER_TYPE_UCS_C880A;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ServerType.UNRECOGNIZED;
  }
}

export function serverTypeToJSON(object: ServerType): string {
  switch (object) {
    case ServerType.SERVER_TYPE_UNSPECIFIED:
      return "SERVER_TYPE_UNSPECIFIED";
    case ServerType.SERVER_TYPE_BRONCO:
      return "SERVER_TYPE_BRONCO";
    case ServerType.SERVER_TYPE_UCS_C225:
      return "SERVER_TYPE_UCS_C225";
    case ServerType.SERVER_TYPE_UCS_MUSTANG:
      return "SERVER_TYPE_UCS_MUSTANG";
    case ServerType.SERVER_TYPE_UCS_C880A:
      return "SERVER_TYPE_UCS_C880A";
    case ServerType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PowerStateEnum {
  POWER_STATE_UNKNOWN = 0,
  POWER_STATE_ON = 1,
  POWER_STATE_OFF = 2,
  POWER_STATE_POWERING_ON = 3,
  POWER_STATE_POWERING_OFF = 4,
  POWER_STATE_PAUSED = 5,
  UNRECOGNIZED = -1,
}

export function powerStateEnumFromJSON(object: any): PowerStateEnum {
  switch (object) {
    case 0:
    case "POWER_STATE_UNKNOWN":
      return PowerStateEnum.POWER_STATE_UNKNOWN;
    case 1:
    case "POWER_STATE_ON":
      return PowerStateEnum.POWER_STATE_ON;
    case 2:
    case "POWER_STATE_OFF":
      return PowerStateEnum.POWER_STATE_OFF;
    case 3:
    case "POWER_STATE_POWERING_ON":
      return PowerStateEnum.POWER_STATE_POWERING_ON;
    case 4:
    case "POWER_STATE_POWERING_OFF":
      return PowerStateEnum.POWER_STATE_POWERING_OFF;
    case 5:
    case "POWER_STATE_PAUSED":
      return PowerStateEnum.POWER_STATE_PAUSED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PowerStateEnum.UNRECOGNIZED;
  }
}

export function powerStateEnumToJSON(object: PowerStateEnum): string {
  switch (object) {
    case PowerStateEnum.POWER_STATE_UNKNOWN:
      return "POWER_STATE_UNKNOWN";
    case PowerStateEnum.POWER_STATE_ON:
      return "POWER_STATE_ON";
    case PowerStateEnum.POWER_STATE_OFF:
      return "POWER_STATE_OFF";
    case PowerStateEnum.POWER_STATE_POWERING_ON:
      return "POWER_STATE_POWERING_ON";
    case PowerStateEnum.POWER_STATE_POWERING_OFF:
      return "POWER_STATE_POWERING_OFF";
    case PowerStateEnum.POWER_STATE_PAUSED:
      return "POWER_STATE_PAUSED";
    case PowerStateEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ManagedEndpointOtherStateEnum {
  ME_OTHER_STATE_UNKNOWN = 0,
  ME_OTHER_STATE_BIOS_OPROM_OPT_ENABLED = 1,
  ME_OTHER_STATE_SPDM_FAILURE = 2,
  UNRECOGNIZED = -1,
}

export function managedEndpointOtherStateEnumFromJSON(object: any): ManagedEndpointOtherStateEnum {
  switch (object) {
    case 0:
    case "ME_OTHER_STATE_UNKNOWN":
      return ManagedEndpointOtherStateEnum.ME_OTHER_STATE_UNKNOWN;
    case 1:
    case "ME_OTHER_STATE_BIOS_OPROM_OPT_ENABLED":
      return ManagedEndpointOtherStateEnum.ME_OTHER_STATE_BIOS_OPROM_OPT_ENABLED;
    case 2:
    case "ME_OTHER_STATE_SPDM_FAILURE":
      return ManagedEndpointOtherStateEnum.ME_OTHER_STATE_SPDM_FAILURE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ManagedEndpointOtherStateEnum.UNRECOGNIZED;
  }
}

export function managedEndpointOtherStateEnumToJSON(object: ManagedEndpointOtherStateEnum): string {
  switch (object) {
    case ManagedEndpointOtherStateEnum.ME_OTHER_STATE_UNKNOWN:
      return "ME_OTHER_STATE_UNKNOWN";
    case ManagedEndpointOtherStateEnum.ME_OTHER_STATE_BIOS_OPROM_OPT_ENABLED:
      return "ME_OTHER_STATE_BIOS_OPROM_OPT_ENABLED";
    case ManagedEndpointOtherStateEnum.ME_OTHER_STATE_SPDM_FAILURE:
      return "ME_OTHER_STATE_SPDM_FAILURE";
    case ManagedEndpointOtherStateEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Depreciated will be removed in future... */
export enum ServerFanPosition {
  FAN_POSITION_UNKNOWN = 0,
  FAN_POSITION_FRONT = 1,
  FAN_POSITION_REAR = 2,
  UNRECOGNIZED = -1,
}

export function serverFanPositionFromJSON(object: any): ServerFanPosition {
  switch (object) {
    case 0:
    case "FAN_POSITION_UNKNOWN":
      return ServerFanPosition.FAN_POSITION_UNKNOWN;
    case 1:
    case "FAN_POSITION_FRONT":
      return ServerFanPosition.FAN_POSITION_FRONT;
    case 2:
    case "FAN_POSITION_REAR":
      return ServerFanPosition.FAN_POSITION_REAR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ServerFanPosition.UNRECOGNIZED;
  }
}

export function serverFanPositionToJSON(object: ServerFanPosition): string {
  switch (object) {
    case ServerFanPosition.FAN_POSITION_UNKNOWN:
      return "FAN_POSITION_UNKNOWN";
    case ServerFanPosition.FAN_POSITION_FRONT:
      return "FAN_POSITION_FRONT";
    case ServerFanPosition.FAN_POSITION_REAR:
      return "FAN_POSITION_REAR";
    case ServerFanPosition.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SmartHandsCompletionStatus {
  /** COMPLETION_STATUS_UNSPECIFIED - Null value, not expected to be seen */
  COMPLETION_STATUS_UNSPECIFIED = 0,
  /** COMPLETION_STATUS_UNKNOWN - We don't have the data to say whether this task is completed or not */
  COMPLETION_STATUS_UNKNOWN = 1,
  /** COMPLETION_STATUS_COMPLETE - This task is completed correctly */
  COMPLETION_STATUS_COMPLETE = 2,
  /** COMPLETION_STATUS_ERROR - This task has been done incorrectly */
  COMPLETION_STATUS_ERROR = 3,
  UNRECOGNIZED = -1,
}

export function smartHandsCompletionStatusFromJSON(object: any): SmartHandsCompletionStatus {
  switch (object) {
    case 0:
    case "COMPLETION_STATUS_UNSPECIFIED":
      return SmartHandsCompletionStatus.COMPLETION_STATUS_UNSPECIFIED;
    case 1:
    case "COMPLETION_STATUS_UNKNOWN":
      return SmartHandsCompletionStatus.COMPLETION_STATUS_UNKNOWN;
    case 2:
    case "COMPLETION_STATUS_COMPLETE":
      return SmartHandsCompletionStatus.COMPLETION_STATUS_COMPLETE;
    case 3:
    case "COMPLETION_STATUS_ERROR":
      return SmartHandsCompletionStatus.COMPLETION_STATUS_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SmartHandsCompletionStatus.UNRECOGNIZED;
  }
}

export function smartHandsCompletionStatusToJSON(object: SmartHandsCompletionStatus): string {
  switch (object) {
    case SmartHandsCompletionStatus.COMPLETION_STATUS_UNSPECIFIED:
      return "COMPLETION_STATUS_UNSPECIFIED";
    case SmartHandsCompletionStatus.COMPLETION_STATUS_UNKNOWN:
      return "COMPLETION_STATUS_UNKNOWN";
    case SmartHandsCompletionStatus.COMPLETION_STATUS_COMPLETE:
      return "COMPLETION_STATUS_COMPLETE";
    case SmartHandsCompletionStatus.COMPLETION_STATUS_ERROR:
      return "COMPLETION_STATUS_ERROR";
    case SmartHandsCompletionStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BulkUpliftJobType {
  BULK_UPLIFT_JOB_UNSPECIFIED = 0,
  BULK_UPLIFT_JOB_SYSLOG = 1,
  BULK_UPLIFT_JOB_PCAP = 2,
  BULK_UPLIFT_JOB_ALWAYS_ON_SYSLOG = 3,
  BULK_UPLIFT_JOB_ALWAYS_ON_PROMETHEUS_METRICS = 4,
  UNRECOGNIZED = -1,
}

export function bulkUpliftJobTypeFromJSON(object: any): BulkUpliftJobType {
  switch (object) {
    case 0:
    case "BULK_UPLIFT_JOB_UNSPECIFIED":
      return BulkUpliftJobType.BULK_UPLIFT_JOB_UNSPECIFIED;
    case 1:
    case "BULK_UPLIFT_JOB_SYSLOG":
      return BulkUpliftJobType.BULK_UPLIFT_JOB_SYSLOG;
    case 2:
    case "BULK_UPLIFT_JOB_PCAP":
      return BulkUpliftJobType.BULK_UPLIFT_JOB_PCAP;
    case 3:
    case "BULK_UPLIFT_JOB_ALWAYS_ON_SYSLOG":
      return BulkUpliftJobType.BULK_UPLIFT_JOB_ALWAYS_ON_SYSLOG;
    case 4:
    case "BULK_UPLIFT_JOB_ALWAYS_ON_PROMETHEUS_METRICS":
      return BulkUpliftJobType.BULK_UPLIFT_JOB_ALWAYS_ON_PROMETHEUS_METRICS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BulkUpliftJobType.UNRECOGNIZED;
  }
}

export function bulkUpliftJobTypeToJSON(object: BulkUpliftJobType): string {
  switch (object) {
    case BulkUpliftJobType.BULK_UPLIFT_JOB_UNSPECIFIED:
      return "BULK_UPLIFT_JOB_UNSPECIFIED";
    case BulkUpliftJobType.BULK_UPLIFT_JOB_SYSLOG:
      return "BULK_UPLIFT_JOB_SYSLOG";
    case BulkUpliftJobType.BULK_UPLIFT_JOB_PCAP:
      return "BULK_UPLIFT_JOB_PCAP";
    case BulkUpliftJobType.BULK_UPLIFT_JOB_ALWAYS_ON_SYSLOG:
      return "BULK_UPLIFT_JOB_ALWAYS_ON_SYSLOG";
    case BulkUpliftJobType.BULK_UPLIFT_JOB_ALWAYS_ON_PROMETHEUS_METRICS:
      return "BULK_UPLIFT_JOB_ALWAYS_ON_PROMETHEUS_METRICS";
    case BulkUpliftJobType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BulkUpliftStatus {
  BULK_UPLIFT_STATUS_UNSPECIFIED = 0,
  BULK_UPLIFT_STATUS_PENDING = 1,
  BULK_UPLIFT_STATUS_IN_PROGRESS = 2,
  BULK_UPLIFT_STATUS_COMPLETED = 3,
  BULK_UPLIFT_STATUS_FAILED = 4,
  UNRECOGNIZED = -1,
}

export function bulkUpliftStatusFromJSON(object: any): BulkUpliftStatus {
  switch (object) {
    case 0:
    case "BULK_UPLIFT_STATUS_UNSPECIFIED":
      return BulkUpliftStatus.BULK_UPLIFT_STATUS_UNSPECIFIED;
    case 1:
    case "BULK_UPLIFT_STATUS_PENDING":
      return BulkUpliftStatus.BULK_UPLIFT_STATUS_PENDING;
    case 2:
    case "BULK_UPLIFT_STATUS_IN_PROGRESS":
      return BulkUpliftStatus.BULK_UPLIFT_STATUS_IN_PROGRESS;
    case 3:
    case "BULK_UPLIFT_STATUS_COMPLETED":
      return BulkUpliftStatus.BULK_UPLIFT_STATUS_COMPLETED;
    case 4:
    case "BULK_UPLIFT_STATUS_FAILED":
      return BulkUpliftStatus.BULK_UPLIFT_STATUS_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BulkUpliftStatus.UNRECOGNIZED;
  }
}

export function bulkUpliftStatusToJSON(object: BulkUpliftStatus): string {
  switch (object) {
    case BulkUpliftStatus.BULK_UPLIFT_STATUS_UNSPECIFIED:
      return "BULK_UPLIFT_STATUS_UNSPECIFIED";
    case BulkUpliftStatus.BULK_UPLIFT_STATUS_PENDING:
      return "BULK_UPLIFT_STATUS_PENDING";
    case BulkUpliftStatus.BULK_UPLIFT_STATUS_IN_PROGRESS:
      return "BULK_UPLIFT_STATUS_IN_PROGRESS";
    case BulkUpliftStatus.BULK_UPLIFT_STATUS_COMPLETED:
      return "BULK_UPLIFT_STATUS_COMPLETED";
    case BulkUpliftStatus.BULK_UPLIFT_STATUS_FAILED:
      return "BULK_UPLIFT_STATUS_FAILED";
    case BulkUpliftStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Enum for the state of a reference point job
 * Ordering is important - later states are bigger
 */
export enum RefPointJobState {
  REF_POINT_JOB_STATE_UNSPECIFIED = 0,
  REF_POINT_JOB_NOT_REQUESTED = 1,
  REF_POINT_JOB_QUEUED = 2,
  REF_POINT_JOB_PROCESSING = 3,
  REF_POINT_JOB_READY = 4,
  REF_POINT_JOB_FAILED = 5,
  UNRECOGNIZED = -1,
}

export function refPointJobStateFromJSON(object: any): RefPointJobState {
  switch (object) {
    case 0:
    case "REF_POINT_JOB_STATE_UNSPECIFIED":
      return RefPointJobState.REF_POINT_JOB_STATE_UNSPECIFIED;
    case 1:
    case "REF_POINT_JOB_NOT_REQUESTED":
      return RefPointJobState.REF_POINT_JOB_NOT_REQUESTED;
    case 2:
    case "REF_POINT_JOB_QUEUED":
      return RefPointJobState.REF_POINT_JOB_QUEUED;
    case 3:
    case "REF_POINT_JOB_PROCESSING":
      return RefPointJobState.REF_POINT_JOB_PROCESSING;
    case 4:
    case "REF_POINT_JOB_READY":
      return RefPointJobState.REF_POINT_JOB_READY;
    case 5:
    case "REF_POINT_JOB_FAILED":
      return RefPointJobState.REF_POINT_JOB_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RefPointJobState.UNRECOGNIZED;
  }
}

export function refPointJobStateToJSON(object: RefPointJobState): string {
  switch (object) {
    case RefPointJobState.REF_POINT_JOB_STATE_UNSPECIFIED:
      return "REF_POINT_JOB_STATE_UNSPECIFIED";
    case RefPointJobState.REF_POINT_JOB_NOT_REQUESTED:
      return "REF_POINT_JOB_NOT_REQUESTED";
    case RefPointJobState.REF_POINT_JOB_QUEUED:
      return "REF_POINT_JOB_QUEUED";
    case RefPointJobState.REF_POINT_JOB_PROCESSING:
      return "REF_POINT_JOB_PROCESSING";
    case RefPointJobState.REF_POINT_JOB_READY:
      return "REF_POINT_JOB_READY";
    case RefPointJobState.REF_POINT_JOB_FAILED:
      return "REF_POINT_JOB_FAILED";
    case RefPointJobState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RefPointJobType {
  REF_POINT_JOB_TYPE_UNSPECIFIED = 0,
  REF_POINT_JOB_TYPE_CREATE = 1,
  REF_POINT_JOB_TYPE_DIFF = 2,
  UNRECOGNIZED = -1,
}

export function refPointJobTypeFromJSON(object: any): RefPointJobType {
  switch (object) {
    case 0:
    case "REF_POINT_JOB_TYPE_UNSPECIFIED":
      return RefPointJobType.REF_POINT_JOB_TYPE_UNSPECIFIED;
    case 1:
    case "REF_POINT_JOB_TYPE_CREATE":
      return RefPointJobType.REF_POINT_JOB_TYPE_CREATE;
    case 2:
    case "REF_POINT_JOB_TYPE_DIFF":
      return RefPointJobType.REF_POINT_JOB_TYPE_DIFF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RefPointJobType.UNRECOGNIZED;
  }
}

export function refPointJobTypeToJSON(object: RefPointJobType): string {
  switch (object) {
    case RefPointJobType.REF_POINT_JOB_TYPE_UNSPECIFIED:
      return "REF_POINT_JOB_TYPE_UNSPECIFIED";
    case RefPointJobType.REF_POINT_JOB_TYPE_CREATE:
      return "REF_POINT_JOB_TYPE_CREATE";
    case RefPointJobType.REF_POINT_JOB_TYPE_DIFF:
      return "REF_POINT_JOB_TYPE_DIFF";
    case RefPointJobType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DbTableEnum {
  DB_TABLE_UNKNOWN = 0,
  DB_TABLE_AUTH_USER = 1,
  DB_TABLE_AUTH_BEARER_TOKEN = 2,
  DB_TABLE_AUTH_API_KEY = 3,
  DB_TABLE_TENANCY_TENANT = 4,
  DB_TABLE_TENANCY_ORGANIZATION = 5,
  UNRECOGNIZED = -1,
}

export function dbTableEnumFromJSON(object: any): DbTableEnum {
  switch (object) {
    case 0:
    case "DB_TABLE_UNKNOWN":
      return DbTableEnum.DB_TABLE_UNKNOWN;
    case 1:
    case "DB_TABLE_AUTH_USER":
      return DbTableEnum.DB_TABLE_AUTH_USER;
    case 2:
    case "DB_TABLE_AUTH_BEARER_TOKEN":
      return DbTableEnum.DB_TABLE_AUTH_BEARER_TOKEN;
    case 3:
    case "DB_TABLE_AUTH_API_KEY":
      return DbTableEnum.DB_TABLE_AUTH_API_KEY;
    case 4:
    case "DB_TABLE_TENANCY_TENANT":
      return DbTableEnum.DB_TABLE_TENANCY_TENANT;
    case 5:
    case "DB_TABLE_TENANCY_ORGANIZATION":
      return DbTableEnum.DB_TABLE_TENANCY_ORGANIZATION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DbTableEnum.UNRECOGNIZED;
  }
}

export function dbTableEnumToJSON(object: DbTableEnum): string {
  switch (object) {
    case DbTableEnum.DB_TABLE_UNKNOWN:
      return "DB_TABLE_UNKNOWN";
    case DbTableEnum.DB_TABLE_AUTH_USER:
      return "DB_TABLE_AUTH_USER";
    case DbTableEnum.DB_TABLE_AUTH_BEARER_TOKEN:
      return "DB_TABLE_AUTH_BEARER_TOKEN";
    case DbTableEnum.DB_TABLE_AUTH_API_KEY:
      return "DB_TABLE_AUTH_API_KEY";
    case DbTableEnum.DB_TABLE_TENANCY_TENANT:
      return "DB_TABLE_TENANCY_TENANT";
    case DbTableEnum.DB_TABLE_TENANCY_ORGANIZATION:
      return "DB_TABLE_TENANCY_ORGANIZATION";
    case DbTableEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RemoteEntryLocation {
  REMOTE_ENTRY_LOCATION_UNSPECIFIED = 0,
  REMOTE_ENTRY_LOCATION_LOCAL = 1,
  REMOTE_ENTRY_LOCATION_REMOTE = 2,
  UNRECOGNIZED = -1,
}

export function remoteEntryLocationFromJSON(object: any): RemoteEntryLocation {
  switch (object) {
    case 0:
    case "REMOTE_ENTRY_LOCATION_UNSPECIFIED":
      return RemoteEntryLocation.REMOTE_ENTRY_LOCATION_UNSPECIFIED;
    case 1:
    case "REMOTE_ENTRY_LOCATION_LOCAL":
      return RemoteEntryLocation.REMOTE_ENTRY_LOCATION_LOCAL;
    case 2:
    case "REMOTE_ENTRY_LOCATION_REMOTE":
      return RemoteEntryLocation.REMOTE_ENTRY_LOCATION_REMOTE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RemoteEntryLocation.UNRECOGNIZED;
  }
}

export function remoteEntryLocationToJSON(object: RemoteEntryLocation): string {
  switch (object) {
    case RemoteEntryLocation.REMOTE_ENTRY_LOCATION_UNSPECIFIED:
      return "REMOTE_ENTRY_LOCATION_UNSPECIFIED";
    case RemoteEntryLocation.REMOTE_ENTRY_LOCATION_LOCAL:
      return "REMOTE_ENTRY_LOCATION_LOCAL";
    case RemoteEntryLocation.REMOTE_ENTRY_LOCATION_REMOTE:
      return "REMOTE_ENTRY_LOCATION_REMOTE";
    case RemoteEntryLocation.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SigningKeyEnum {
  SIGNING_KEY_UNKNOWN = 0,
  SIGNING_KEY_SSO = 1,
  /** @deprecated */
  SIGNING_KEY_CSRF = 2,
  SIGNING_KEY_USER_JWT = 3,
  SIGNING_KEY_AGENT_JWT = 4,
  UNRECOGNIZED = -1,
}

export function signingKeyEnumFromJSON(object: any): SigningKeyEnum {
  switch (object) {
    case 0:
    case "SIGNING_KEY_UNKNOWN":
      return SigningKeyEnum.SIGNING_KEY_UNKNOWN;
    case 1:
    case "SIGNING_KEY_SSO":
      return SigningKeyEnum.SIGNING_KEY_SSO;
    case 2:
    case "SIGNING_KEY_CSRF":
      return SigningKeyEnum.SIGNING_KEY_CSRF;
    case 3:
    case "SIGNING_KEY_USER_JWT":
      return SigningKeyEnum.SIGNING_KEY_USER_JWT;
    case 4:
    case "SIGNING_KEY_AGENT_JWT":
      return SigningKeyEnum.SIGNING_KEY_AGENT_JWT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SigningKeyEnum.UNRECOGNIZED;
  }
}

export function signingKeyEnumToJSON(object: SigningKeyEnum): string {
  switch (object) {
    case SigningKeyEnum.SIGNING_KEY_UNKNOWN:
      return "SIGNING_KEY_UNKNOWN";
    case SigningKeyEnum.SIGNING_KEY_SSO:
      return "SIGNING_KEY_SSO";
    case SigningKeyEnum.SIGNING_KEY_CSRF:
      return "SIGNING_KEY_CSRF";
    case SigningKeyEnum.SIGNING_KEY_USER_JWT:
      return "SIGNING_KEY_USER_JWT";
    case SigningKeyEnum.SIGNING_KEY_AGENT_JWT:
      return "SIGNING_KEY_AGENT_JWT";
    case SigningKeyEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum IpSlaProbeConnectionType {
  IP_SLA_PROBE_TYPE_UNSPECIFIED = 0,
  IP_SLA_PROBE_TYPE_TCP_CONNECT = 1,
  IP_SLA_PROBE_TYPE_ICMP_PING = 2,
  IP_SLA_PROBE_TYPE_UDP_ECHO = 3,
  UNRECOGNIZED = -1,
}

export function ipSlaProbeConnectionTypeFromJSON(object: any): IpSlaProbeConnectionType {
  switch (object) {
    case 0:
    case "IP_SLA_PROBE_TYPE_UNSPECIFIED":
      return IpSlaProbeConnectionType.IP_SLA_PROBE_TYPE_UNSPECIFIED;
    case 1:
    case "IP_SLA_PROBE_TYPE_TCP_CONNECT":
      return IpSlaProbeConnectionType.IP_SLA_PROBE_TYPE_TCP_CONNECT;
    case 2:
    case "IP_SLA_PROBE_TYPE_ICMP_PING":
      return IpSlaProbeConnectionType.IP_SLA_PROBE_TYPE_ICMP_PING;
    case 3:
    case "IP_SLA_PROBE_TYPE_UDP_ECHO":
      return IpSlaProbeConnectionType.IP_SLA_PROBE_TYPE_UDP_ECHO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IpSlaProbeConnectionType.UNRECOGNIZED;
  }
}

export function ipSlaProbeConnectionTypeToJSON(object: IpSlaProbeConnectionType): string {
  switch (object) {
    case IpSlaProbeConnectionType.IP_SLA_PROBE_TYPE_UNSPECIFIED:
      return "IP_SLA_PROBE_TYPE_UNSPECIFIED";
    case IpSlaProbeConnectionType.IP_SLA_PROBE_TYPE_TCP_CONNECT:
      return "IP_SLA_PROBE_TYPE_TCP_CONNECT";
    case IpSlaProbeConnectionType.IP_SLA_PROBE_TYPE_ICMP_PING:
      return "IP_SLA_PROBE_TYPE_ICMP_PING";
    case IpSlaProbeConnectionType.IP_SLA_PROBE_TYPE_UDP_ECHO:
      return "IP_SLA_PROBE_TYPE_UDP_ECHO";
    case IpSlaProbeConnectionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum IpSlaProbeOpStateType {
  IP_SLA_PROBE_OP_STATE_UNSPECIFIED = 0,
  IP_SLA_PROBE_OP_STATE_ACTIVE = 1,
  IP_SLA_PROBE_OP_STATE_INACTIVE = 2,
  UNRECOGNIZED = -1,
}

export function ipSlaProbeOpStateTypeFromJSON(object: any): IpSlaProbeOpStateType {
  switch (object) {
    case 0:
    case "IP_SLA_PROBE_OP_STATE_UNSPECIFIED":
      return IpSlaProbeOpStateType.IP_SLA_PROBE_OP_STATE_UNSPECIFIED;
    case 1:
    case "IP_SLA_PROBE_OP_STATE_ACTIVE":
      return IpSlaProbeOpStateType.IP_SLA_PROBE_OP_STATE_ACTIVE;
    case 2:
    case "IP_SLA_PROBE_OP_STATE_INACTIVE":
      return IpSlaProbeOpStateType.IP_SLA_PROBE_OP_STATE_INACTIVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IpSlaProbeOpStateType.UNRECOGNIZED;
  }
}

export function ipSlaProbeOpStateTypeToJSON(object: IpSlaProbeOpStateType): string {
  switch (object) {
    case IpSlaProbeOpStateType.IP_SLA_PROBE_OP_STATE_UNSPECIFIED:
      return "IP_SLA_PROBE_OP_STATE_UNSPECIFIED";
    case IpSlaProbeOpStateType.IP_SLA_PROBE_OP_STATE_ACTIVE:
      return "IP_SLA_PROBE_OP_STATE_ACTIVE";
    case IpSlaProbeOpStateType.IP_SLA_PROBE_OP_STATE_INACTIVE:
      return "IP_SLA_PROBE_OP_STATE_INACTIVE";
    case IpSlaProbeOpStateType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SpanSessionStatus {
  SPAN_SESSION_STATUS_UNSPECIFIED = 0,
  SPAN_SESSION_STATUS_ACTIVE = 1,
  SPAN_SESSION_STATUS_INACTIVE = 2,
  SPAN_SESSION_STATUS_ERROR = 3,
  UNRECOGNIZED = -1,
}

export function spanSessionStatusFromJSON(object: any): SpanSessionStatus {
  switch (object) {
    case 0:
    case "SPAN_SESSION_STATUS_UNSPECIFIED":
      return SpanSessionStatus.SPAN_SESSION_STATUS_UNSPECIFIED;
    case 1:
    case "SPAN_SESSION_STATUS_ACTIVE":
      return SpanSessionStatus.SPAN_SESSION_STATUS_ACTIVE;
    case 2:
    case "SPAN_SESSION_STATUS_INACTIVE":
      return SpanSessionStatus.SPAN_SESSION_STATUS_INACTIVE;
    case 3:
    case "SPAN_SESSION_STATUS_ERROR":
      return SpanSessionStatus.SPAN_SESSION_STATUS_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SpanSessionStatus.UNRECOGNIZED;
  }
}

export function spanSessionStatusToJSON(object: SpanSessionStatus): string {
  switch (object) {
    case SpanSessionStatus.SPAN_SESSION_STATUS_UNSPECIFIED:
      return "SPAN_SESSION_STATUS_UNSPECIFIED";
    case SpanSessionStatus.SPAN_SESSION_STATUS_ACTIVE:
      return "SPAN_SESSION_STATUS_ACTIVE";
    case SpanSessionStatus.SPAN_SESSION_STATUS_INACTIVE:
      return "SPAN_SESSION_STATUS_INACTIVE";
    case SpanSessionStatus.SPAN_SESSION_STATUS_ERROR:
      return "SPAN_SESSION_STATUS_ERROR";
    case SpanSessionStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** ArsMode represents the routing mode for ARS */
export enum ArsMode {
  ARS_MODE_UNSPECIFIED = 0,
  ARS_MODE_FLOWLET_QUALITY = 1,
  ARS_MODE_PER_PACKET_QUALITY = 2,
  UNRECOGNIZED = -1,
}

export function arsModeFromJSON(object: any): ArsMode {
  switch (object) {
    case 0:
    case "ARS_MODE_UNSPECIFIED":
      return ArsMode.ARS_MODE_UNSPECIFIED;
    case 1:
    case "ARS_MODE_FLOWLET_QUALITY":
      return ArsMode.ARS_MODE_FLOWLET_QUALITY;
    case 2:
    case "ARS_MODE_PER_PACKET_QUALITY":
      return ArsMode.ARS_MODE_PER_PACKET_QUALITY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ArsMode.UNRECOGNIZED;
  }
}

export function arsModeToJSON(object: ArsMode): string {
  switch (object) {
    case ArsMode.ARS_MODE_UNSPECIFIED:
      return "ARS_MODE_UNSPECIFIED";
    case ArsMode.ARS_MODE_FLOWLET_QUALITY:
      return "ARS_MODE_FLOWLET_QUALITY";
    case ArsMode.ARS_MODE_PER_PACKET_QUALITY:
      return "ARS_MODE_PER_PACKET_QUALITY";
    case ArsMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum VxlanTunnelSrcType {
  VXLAN_TUNNEL_SRC_TYPE_UNSPECIFIED = 0,
  VXLAN_TUNNEL_SRC_TYPE_EVPN = 1,
  VXLAN_TUNNEL_SRC_TYPE_CLI = 2,
  UNRECOGNIZED = -1,
}

export function vxlanTunnelSrcTypeFromJSON(object: any): VxlanTunnelSrcType {
  switch (object) {
    case 0:
    case "VXLAN_TUNNEL_SRC_TYPE_UNSPECIFIED":
      return VxlanTunnelSrcType.VXLAN_TUNNEL_SRC_TYPE_UNSPECIFIED;
    case 1:
    case "VXLAN_TUNNEL_SRC_TYPE_EVPN":
      return VxlanTunnelSrcType.VXLAN_TUNNEL_SRC_TYPE_EVPN;
    case 2:
    case "VXLAN_TUNNEL_SRC_TYPE_CLI":
      return VxlanTunnelSrcType.VXLAN_TUNNEL_SRC_TYPE_CLI;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VxlanTunnelSrcType.UNRECOGNIZED;
  }
}

export function vxlanTunnelSrcTypeToJSON(object: VxlanTunnelSrcType): string {
  switch (object) {
    case VxlanTunnelSrcType.VXLAN_TUNNEL_SRC_TYPE_UNSPECIFIED:
      return "VXLAN_TUNNEL_SRC_TYPE_UNSPECIFIED";
    case VxlanTunnelSrcType.VXLAN_TUNNEL_SRC_TYPE_EVPN:
      return "VXLAN_TUNNEL_SRC_TYPE_EVPN";
    case VxlanTunnelSrcType.VXLAN_TUNNEL_SRC_TYPE_CLI:
      return "VXLAN_TUNNEL_SRC_TYPE_CLI";
    case VxlanTunnelSrcType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CommandOutputStream {
  COMMAND_OUTPUT_UNSPECIFIED = 0,
  COMMAND_OUTPUT_STDOUT = 1,
  COMMAND_OUTPUT_STDERR = 2,
  COMMAND_OUTPUT_ALL = 3,
  UNRECOGNIZED = -1,
}

export function commandOutputStreamFromJSON(object: any): CommandOutputStream {
  switch (object) {
    case 0:
    case "COMMAND_OUTPUT_UNSPECIFIED":
      return CommandOutputStream.COMMAND_OUTPUT_UNSPECIFIED;
    case 1:
    case "COMMAND_OUTPUT_STDOUT":
      return CommandOutputStream.COMMAND_OUTPUT_STDOUT;
    case 2:
    case "COMMAND_OUTPUT_STDERR":
      return CommandOutputStream.COMMAND_OUTPUT_STDERR;
    case 3:
    case "COMMAND_OUTPUT_ALL":
      return CommandOutputStream.COMMAND_OUTPUT_ALL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CommandOutputStream.UNRECOGNIZED;
  }
}

export function commandOutputStreamToJSON(object: CommandOutputStream): string {
  switch (object) {
    case CommandOutputStream.COMMAND_OUTPUT_UNSPECIFIED:
      return "COMMAND_OUTPUT_UNSPECIFIED";
    case CommandOutputStream.COMMAND_OUTPUT_STDOUT:
      return "COMMAND_OUTPUT_STDOUT";
    case CommandOutputStream.COMMAND_OUTPUT_STDERR:
      return "COMMAND_OUTPUT_STDERR";
    case CommandOutputStream.COMMAND_OUTPUT_ALL:
      return "COMMAND_OUTPUT_ALL";
    case CommandOutputStream.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CommandStatus {
  COMMAND_STATUS_UNSPECIFIED = 0,
  COMMAND_STATUS_STARTED = 1,
  COMMAND_STATUS_COMPLETED = 2,
  COMMAND_STATUS_FAILED = 3,
  COMMAND_STATUS_KILLED = 4,
  COMMAND_STATUS_EXPIRED = 5,
  UNRECOGNIZED = -1,
}

export function commandStatusFromJSON(object: any): CommandStatus {
  switch (object) {
    case 0:
    case "COMMAND_STATUS_UNSPECIFIED":
      return CommandStatus.COMMAND_STATUS_UNSPECIFIED;
    case 1:
    case "COMMAND_STATUS_STARTED":
      return CommandStatus.COMMAND_STATUS_STARTED;
    case 2:
    case "COMMAND_STATUS_COMPLETED":
      return CommandStatus.COMMAND_STATUS_COMPLETED;
    case 3:
    case "COMMAND_STATUS_FAILED":
      return CommandStatus.COMMAND_STATUS_FAILED;
    case 4:
    case "COMMAND_STATUS_KILLED":
      return CommandStatus.COMMAND_STATUS_KILLED;
    case 5:
    case "COMMAND_STATUS_EXPIRED":
      return CommandStatus.COMMAND_STATUS_EXPIRED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CommandStatus.UNRECOGNIZED;
  }
}

export function commandStatusToJSON(object: CommandStatus): string {
  switch (object) {
    case CommandStatus.COMMAND_STATUS_UNSPECIFIED:
      return "COMMAND_STATUS_UNSPECIFIED";
    case CommandStatus.COMMAND_STATUS_STARTED:
      return "COMMAND_STATUS_STARTED";
    case CommandStatus.COMMAND_STATUS_COMPLETED:
      return "COMMAND_STATUS_COMPLETED";
    case CommandStatus.COMMAND_STATUS_FAILED:
      return "COMMAND_STATUS_FAILED";
    case CommandStatus.COMMAND_STATUS_KILLED:
      return "COMMAND_STATUS_KILLED";
    case CommandStatus.COMMAND_STATUS_EXPIRED:
      return "COMMAND_STATUS_EXPIRED";
    case CommandStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum OpticsFirmwareUpdateStatus {
  OPTICS_FW_UPDATE_STATUS_UNSPECIFIED = 0,
  /** OPTICS_FW_UPDATE_STATUS_NOT_REQUESTED - no optics firmware update has been requested */
  OPTICS_FW_UPDATE_STATUS_NOT_REQUESTED = 1,
  /** OPTICS_FW_UPDATE_STATUS_NOT_PRESENT - optic not currently present */
  OPTICS_FW_UPDATE_STATUS_NOT_PRESENT = 2,
  /** OPTICS_FW_UPDATE_STATUS_DL_PENDING - optics firmware download pending */
  OPTICS_FW_UPDATE_STATUS_DL_PENDING = 3,
  /** OPTICS_FW_UPDATE_STATUS_DL_COMPLETE - optics firmware download complete, ready to install */
  OPTICS_FW_UPDATE_STATUS_DL_COMPLETE = 4,
  /** OPTICS_FW_UPDATE_STATUE_IN_QUEUE - optics firmware is enqueued and waiting */
  OPTICS_FW_UPDATE_STATUE_IN_QUEUE = 5,
  /** OPTICS_FW_UPDATE_STATUS_PUSH_IN_PROGRESS - pushing new firmware to optic */
  OPTICS_FW_UPDATE_STATUS_PUSH_IN_PROGRESS = 6,
  /** OPTICS_FW_UPDATE_STATUS_PUSH_FAILED - unable to push new firmware to optic */
  OPTICS_FW_UPDATE_STATUS_PUSH_FAILED = 7,
  /** OPTICS_FW_UPDATE_STATUS_RUN_IN_PROGRESS - attempting to run new optics firmware */
  OPTICS_FW_UPDATE_STATUS_RUN_IN_PROGRESS = 8,
  /** OPTICS_FW_UPDATE_STATUS_RUN_FAILED - new optics firmware failed to run */
  OPTICS_FW_UPDATE_STATUS_RUN_FAILED = 9,
  /** OPTICS_FW_UPDATE_STATUS_COMMIT_IN_PROGRESS - attempting to commit new optics firmware */
  OPTICS_FW_UPDATE_STATUS_COMMIT_IN_PROGRESS = 10,
  /** OPTICS_FW_UPDATE_STATUS_COMMIT_FAILED - new optics firmware failed to commit */
  OPTICS_FW_UPDATE_STATUS_COMMIT_FAILED = 11,
  /** OPTICS_FW_UPDATE_STATUS_AT_TARGET - optics firmware is at target version */
  OPTICS_FW_UPDATE_STATUS_AT_TARGET = 12,
  /** OPTICS_FW_UPDATE_STATUS_MISMATCH - optic in manifest doesn't match current state */
  OPTICS_FW_UPDATE_STATUS_MISMATCH = 13,
  /** OPTICS_FW_UPDATE_STATUS_VERIFY_FAILED - supplied artifacts could not be verified with embedded certs */
  OPTICS_FW_UPDATE_STATUS_VERIFY_FAILED = 14,
  UNRECOGNIZED = -1,
}

export function opticsFirmwareUpdateStatusFromJSON(object: any): OpticsFirmwareUpdateStatus {
  switch (object) {
    case 0:
    case "OPTICS_FW_UPDATE_STATUS_UNSPECIFIED":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_UNSPECIFIED;
    case 1:
    case "OPTICS_FW_UPDATE_STATUS_NOT_REQUESTED":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_NOT_REQUESTED;
    case 2:
    case "OPTICS_FW_UPDATE_STATUS_NOT_PRESENT":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_NOT_PRESENT;
    case 3:
    case "OPTICS_FW_UPDATE_STATUS_DL_PENDING":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_DL_PENDING;
    case 4:
    case "OPTICS_FW_UPDATE_STATUS_DL_COMPLETE":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_DL_COMPLETE;
    case 5:
    case "OPTICS_FW_UPDATE_STATUE_IN_QUEUE":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUE_IN_QUEUE;
    case 6:
    case "OPTICS_FW_UPDATE_STATUS_PUSH_IN_PROGRESS":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_PUSH_IN_PROGRESS;
    case 7:
    case "OPTICS_FW_UPDATE_STATUS_PUSH_FAILED":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_PUSH_FAILED;
    case 8:
    case "OPTICS_FW_UPDATE_STATUS_RUN_IN_PROGRESS":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_RUN_IN_PROGRESS;
    case 9:
    case "OPTICS_FW_UPDATE_STATUS_RUN_FAILED":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_RUN_FAILED;
    case 10:
    case "OPTICS_FW_UPDATE_STATUS_COMMIT_IN_PROGRESS":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_COMMIT_IN_PROGRESS;
    case 11:
    case "OPTICS_FW_UPDATE_STATUS_COMMIT_FAILED":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_COMMIT_FAILED;
    case 12:
    case "OPTICS_FW_UPDATE_STATUS_AT_TARGET":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_AT_TARGET;
    case 13:
    case "OPTICS_FW_UPDATE_STATUS_MISMATCH":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_MISMATCH;
    case 14:
    case "OPTICS_FW_UPDATE_STATUS_VERIFY_FAILED":
      return OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_VERIFY_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OpticsFirmwareUpdateStatus.UNRECOGNIZED;
  }
}

export function opticsFirmwareUpdateStatusToJSON(object: OpticsFirmwareUpdateStatus): string {
  switch (object) {
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_UNSPECIFIED:
      return "OPTICS_FW_UPDATE_STATUS_UNSPECIFIED";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_NOT_REQUESTED:
      return "OPTICS_FW_UPDATE_STATUS_NOT_REQUESTED";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_NOT_PRESENT:
      return "OPTICS_FW_UPDATE_STATUS_NOT_PRESENT";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_DL_PENDING:
      return "OPTICS_FW_UPDATE_STATUS_DL_PENDING";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_DL_COMPLETE:
      return "OPTICS_FW_UPDATE_STATUS_DL_COMPLETE";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUE_IN_QUEUE:
      return "OPTICS_FW_UPDATE_STATUE_IN_QUEUE";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_PUSH_IN_PROGRESS:
      return "OPTICS_FW_UPDATE_STATUS_PUSH_IN_PROGRESS";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_PUSH_FAILED:
      return "OPTICS_FW_UPDATE_STATUS_PUSH_FAILED";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_RUN_IN_PROGRESS:
      return "OPTICS_FW_UPDATE_STATUS_RUN_IN_PROGRESS";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_RUN_FAILED:
      return "OPTICS_FW_UPDATE_STATUS_RUN_FAILED";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_COMMIT_IN_PROGRESS:
      return "OPTICS_FW_UPDATE_STATUS_COMMIT_IN_PROGRESS";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_COMMIT_FAILED:
      return "OPTICS_FW_UPDATE_STATUS_COMMIT_FAILED";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_AT_TARGET:
      return "OPTICS_FW_UPDATE_STATUS_AT_TARGET";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_MISMATCH:
      return "OPTICS_FW_UPDATE_STATUS_MISMATCH";
    case OpticsFirmwareUpdateStatus.OPTICS_FW_UPDATE_STATUS_VERIFY_FAILED:
      return "OPTICS_FW_UPDATE_STATUS_VERIFY_FAILED";
    case OpticsFirmwareUpdateStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface TestSubMessage {
  subInt32: number;
  subRepeatedString: string[];
}

export interface TestRootOne {
  id: PathId | undefined;
  rootBool: boolean;
  rootEnum: TestEnum;
  rootInt32: number;
  rootSint32: number;
  rootSfixed32: number;
  rootUint32: number;
  rootInt64: string;
  rootSint64: string;
  rootSfixed64: string;
  rootFloat: number;
  rootDouble: number;
  rootString: string;
  rootBytes: Uint8Array;
  rootTimestamp: Date | undefined;
  rootMacaddress: string;
  rstr: string[];
  rint32: number[];
  subMessage: TestSubMessage[];
  rootIpaddress: string;
  rootIpprefix: string;
  rootRepeatedMac: string[];
  rootMemo: string;
}

export interface TestRootTwo {
  id: PathId | undefined;
}

export interface TestMidOne {
  id: PathId | undefined;
}

export interface TestLeafOne {
  id: PathId | undefined;
}

export interface TestIpPrefix {
  id: PathId | undefined;
}

export interface TestIpAddress {
  id: PathId | undefined;
}

export interface TestMacAddress {
  id: PathId | undefined;
}

/** Universal counters for L2/L3 entities */
export interface BasicCounters {
  bytesIn: string;
  bytesOut: string;
  pktsIn: string;
  pktsOut: string;
  errPktsIn: string;
  errPktsOut: string;
}

export interface BaseAssertCounts {
  assertCountTrue: number;
  assertCountFalse: number;
  assertCountUnknown: number;
}

export interface LatchedAssertCounts {
  latched: BaseAssertCounts | undefined;
  unlatched: BaseAssertCounts | undefined;
}

export interface SeverityAssertCounts {
  red: LatchedAssertCounts | undefined;
  yellow: LatchedAssertCounts | undefined;
  unspecified: LatchedAssertCounts | undefined;
}

export interface CategoryAssertCounts {
  device: SeverityAssertCounts | undefined;
  port: SeverityAssertCounts | undefined;
  network: SeverityAssertCounts | undefined;
}

export interface DeviceTypeAssertCounts {
  switch: CategoryAssertCounts | undefined;
  server: CategoryAssertCounts | undefined;
  unspecified: CategoryAssertCounts | undefined;
}

export interface Fabric {
  id: PathId | undefined;
  orgId: string;
  numDevices: number;
}

/** FabricDevice determines the assignment of a given device id to a fabric id. */
export interface FabricDevice {
  id: PathId | undefined;
  deviceId: string;
  fabricId: string;
  orgId: string;
  nodeId: string;
  plannedConfig: PlannedConfigData | undefined;
  mgmtPortState: ManagementState | undefined;
  assertCounts: CategoryAssertCounts | undefined;
  ipv4Routes: number;
  ipv6Routes: number;
  bgpPeers: number;
}

export interface BorderPort {
  id: PathId | undefined;
  isDci: boolean;
  isBgpNorthbound: boolean;
  isBgpMultisiteNorthbound: boolean;
  isDefaultGateway: boolean;
}

export interface FabricConfigNotification {
  id: PathId | undefined;
  configFp: string;
  fabricId: string;
  sequence: string;
  releaseTag: string;
  targetTag: string;
  holddownFp: string;
  manifestAuxFp: string;
}

export interface FabricTransaction {
  id: PathId | undefined;
  changedAt: Date | undefined;
  committed: boolean;
  orgId: string;
}

export interface StandbyAssignment {
  standbyInstance: string;
  syncFromInstance: string;
  standbyInstanceId: string;
  promoteStandby: boolean;
}

export interface Application {
  id: PathId | undefined;
}

export interface ResourceAssignment {
  id: PathId | undefined;
  resourceType: ResourceType;
  orgId: string;
  active: string;
  activeDemote: string;
  /** list of UUIDS */
  standby: string[];
  standbyPromote: string;
  sourceUrl: string;
  revision: number;
  updatedAt: Date | undefined;
  boostFactor: number;
  isStandbyCell: boolean;
}

export interface AssignmentStatus {
  id: PathId | undefined;
  assignmentState: AssignmentState;
  instanceId: string;
  revision: number;
  orgId: string;
  resourceType: ResourceType;
  fabricType: FabricType;
}

export interface FabricMemoryUsage {
  id: PathId | undefined;
}

export interface TypeMemoryUsage {
  id: PathId | undefined;
  bytes: string;
}

export interface FabricConfig {
  id: PathId | undefined;
  name: string;
  description: string;
  fabricId: string;
  adminState: AdminState;
  topology: FabricTopology;
  type: FabricType;
  modifiedAt: Date | undefined;
  orgId: string;
  tags: string[];
  assignmentRevision: number;
  location: string;
  level: EntitlementLevel;
  interconnects: InterconnectInfo[];
  migrationStatus: string;
  multisiteConfigs: MultisiteInfo[];
  runningImageTag: string;
}

export interface InterconnectInfo {
  id: string;
  revision: string;
}

export interface MultisiteInfo {
  multisiteId: string;
  fabrics: MultisiteFabricInfo[];
  multisiteVnis: MultisiteVni[];
}

export interface MultisiteFabricInfo {
  fabricId: string;
  virtualIp: string;
  asn: number;
  enabled: boolean;
}

export interface MultisiteVni {
  vni: number;
  isL3: boolean;
  enabled: boolean;
  vrfs: MultisiteVrf[];
}

export interface MultisiteVrf {
  name: string;
  vrfVni: number;
  normalizedVni: number;
  enabled: boolean;
}

export interface FabricInterconnectConfig {
  id: PathId | undefined;
  interconnect: InterconnectInfo | undefined;
  latestRevision: string;
}

export interface FabricConfigEvent {
  id: PathId | undefined;
  event: FabricEvent;
  nodeId: string;
  deviceId: string;
}

/** A detected Device */
export interface Device {
  id: PathId | undefined;
  info:
    | DeviceInfo
    | undefined;
  /** @deprecated */
  fabricId: string;
  /** @deprecated */
  firstSeen:
    | Date
    | undefined;
  /** @deprecated */
  lastSeen: Date | undefined;
  commonPortSpeed: string;
}

export interface DeviceConnection {
  id:
    | PathId
    | undefined;
  /** Number of websocket connections that are currently up */
  wsConnected: number;
  /** Time at which any websocket connection was last made */
  wsLastConnectedAt:
    | Date
    | undefined;
  /** Time at which any websocket connection was last lost */
  wsLastDisconnectedAt:
    | Date
    | undefined;
  /** Grace period for initial connection after device is marked active */
  wsMustConnectBy:
    | Date
    | undefined;
  /** Set to true when the device has uplifted too much data and has been stopped uplifting any more data */
  upliftLimitReached: boolean;
}

export interface PlannedConfigData {
  currentConfigFp: string;
  plannedConfigFp: string;
  plannedConfigUpdatedAt: Date | undefined;
  plannedConfigPhase: PlannedConfigPhase;
}

export interface PlannedConfig {
  id: PathId | undefined;
  plannedConfig: PlannedConfigData | undefined;
}

export interface DeviceInfo {
  model: string;
  psuNum: string;
  revision: string;
  serial: string;
  name: string;
  lldpLocId: string;
  sonicVersion: string;
  agentsVersion: string;
  monitored: boolean;
  osType: OsType;
  nxosNoLldp: boolean;
  nxosNoGrpc: boolean;
}

export interface FirmwareVersion {
  id: PathId | undefined;
  biosVersion: string;
  aikidoVersion: string;
  tamVersion: string;
  cpldlVersion: string;
  cpldgVersion: string;
  cpldrVersion: string;
  ssdVersion: string;
  iofpgaVersion: string;
}

export interface NodeConfig {
  id: PathId | undefined;
  nodeId: string;
  fabricId: string;
  deviceId: string;
  name: string;
  type: NodeType;
  adminState: AdminState;
  description: string;
  serialNumber: string;
  modelName: string;
  role: NodeRole;
  osType: OsType;
  modifiedAt: Date | undefined;
  tags: string[];
  orgId: string;
  configFp: string;
  /** TODO: Make this a bitflag */
  bound: boolean;
  claimedAt: Date | undefined;
  activeGpuSlots: number[];
  activeGpuBitmap: number;
  monitored: boolean;
  releaseTag: string;
  targetTag: string;
  holddownFp: string;
  manifestAuxFp: string;
}

/** A Fan represents an hardware fan module of a Device. */
export interface Fan {
  /** The unique identifier of the Fan. */
  id:
    | PathId
    | undefined;
  /** The Fan speed as a percentage of the maximum rated speed. */
  speed: number;
  /** The name of the Fan. */
  name: string;
  /** @deprecated */
  deprecatedDirection: string;
  /** The operational status of the Fan. */
  status: EnvStatus;
  /** The state of the status LED of the Fan. */
  ledStatus: EnvLedStatus;
  /** The tray or drawer to which the Fan belongs to. */
  drawer: string;
  /**
   * The time the data was last collected in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  collectedAt:
    | Date
    | undefined;
  /** The port-side airflow direction of the Fan. */
  direction: FanDirection;
  /** The serial number of the Fan. */
  serial: string;
  /** The model name of the Fan. */
  model: string;
}

export interface ProcTable {
  id: PathId | undefined;
  processes: Process[];
  collectedAt: Date | undefined;
}

export interface Process {
  /**
   * FIXME: we should probably report CPU in CPU core units rather than
   * percent
   */
  cpuPercent: number;
  /** FIXME: we should report memory in MB */
  memPercent: number;
  cmd: string;
  /** CPU time in seconds */
  cpuTimeS: string;
}

/** A PSU represents an hardware power supply unit of a Device. */
export interface Psu {
  /** The unique identifier of the PSU. */
  id:
    | PathId
    | undefined;
  /** The power usage of the PSU. */
  watts: number;
  /** The fan speed as a percentage of the maximum rated speed */
  fanSpeed: number;
  /** The name of the PSU. */
  name: string;
  /** The operational status of the PSU. */
  status: EnvStatus;
  /** The state of the status LED of the PSU. */
  ledStatus: EnvLedStatus;
  /** The model name of the PSU. */
  model: string;
  /** The serial number of the PSU. */
  serial: string;
  /** The input voltage of the PSU in volts (V). */
  voltage: number;
  /** The input current of the PSU in amperes (A). */
  current: number;
}

export interface TempSensor {
  id: PathId | undefined;
  degC: number;
  degCelsius: number;
  highThreshold: number;
  lowThreshold: number;
  category: TemperatureSensorCategory;
}

/**
 * ProxyStats contains useful debug information we can use
 * to examine network issues between Drakes and the cloud.
 * For now, this should not be user-facing.
 */
export interface ProxyStats {
  id:
    | PathId
    | undefined;
  /** TLS stats only for now */
  reqCount: string;
  reqErrors: string;
  respCount: string;
  respErrors: string;
  minRtt: number;
  maxRtt: number;
  meanRtt: number;
  medianRtt: number;
}

export interface UnderlayInfo {
  id:
    | PathId
    | undefined;
  /** TODO: not populated yet */
  proxySessionInfo: ProxySessionInfo | undefined;
  gatewayInfo: GatewayInfo | undefined;
}

export interface ProxySessionInfo {
  proxyAuthState: ProxyAuthState;
  /** TODO: document the cert format */
  certChain: string[];
  initiatedAt: Date | undefined;
  validUntil: Date | undefined;
}

export interface ProxyConnectionState {
  id: PathId | undefined;
  sourcePort: number;
  destPort: number;
  sourceIp: string;
  destIp: string;
  outerTlsConnectionState: TlsConnectionState;
  outerTlsSessionState: TlsSessionState;
  /** An error string used for internal debugging */
  outerTlsErr: string;
  innerTlsConnectionState: TlsConnectionState;
  innerTlsErr: string;
  /** All certificates are base64 encoded DER certificates */
  outerTlsLeafCert: string;
  outerTlsIntermediateCerts: string[];
  outerTlsRootCerts: string[];
  outerTlsVerifyErr: TLSVerifyError;
  outerTlsVerifyErrString: string;
  proxyUrl: string;
  source: string;
  fabricPath: string;
  /** Session initiation time */
  initiatedAt: Date | undefined;
  collectedAt: Date | undefined;
}

export interface ProxyConnectionStats {
  id: PathId | undefined;
  bytesIn: string;
  bytesOut: string;
  inBitsps: number;
  outBitsps: number;
  collectedAt: Date | undefined;
}

export interface GatewayInfo {
  isGateway: boolean;
}

export interface LineCard {
  id: PathId | undefined;
}

export interface Breakout {
  id: PathId | undefined;
  state: PortState | undefined;
}

export interface DacQsfp {
  id: PathId | undefined;
  counters: DacCounters | undefined;
}

export interface DacCounters {
  inOctets: string;
}

export interface FiberQsfp {
  id: PathId | undefined;
  counters: FiberCounters | undefined;
}

export interface FiberCounters {
  inOctets: string;
}

export interface PortConfig {
  id: PathId | undefined;
  config: PortConfigDetails | undefined;
}

export interface PortConfigDetails {
  portName: string;
  portIndex: number;
  portRole: PortRole;
  adminState: AdminState;
  mtu: number;
  deviceId: string;
  targetDeviceId: string;
  targetPortName: string;
  modifiedAt: Date | undefined;
  breakOut: boolean;
  portAliasName: string;
}

export interface Port {
  id: PathId | undefined;
}

export interface SubInterface {
  id: PathId | undefined;
  details: SubInterfaceDetails | undefined;
}

export interface SubInterfaceDetails {
  subInterfaceName: string;
  portName: string;
  adminState: AdminState;
  operState: OperState;
  mtu: number;
  macAddr: string;
  vlan: number;
  collectedAt: Date | undefined;
}

export interface PortCounters {
  id: PathId | undefined;
  inOctets: string;
  inPkts: string;
  inUnicastPkts: string;
  inBroadcastPkts: string;
  inMulticastPkts: string;
  inDiscards: string;
  inErrors: string;
  inUnknownProtos: string;
  inFcsErrors: string;
  outOctets: string;
  outPkts: string;
  outUnicastPkts: string;
  outBroadcastPkts: string;
  outMulticastPkts: string;
  outDiscards: string;
  outErrors: string;
  carrierTransitions: string;
  inPfc0Pkts: string;
  outPfc0Pkts: string;
  inPfc1Pkts: string;
  outPfc1Pkts: string;
  inPfc2Pkts: string;
  outPfc2Pkts: string;
  inPfc3Pkts: string;
  outPfc3Pkts: string;
  inPfc4Pkts: string;
  outPfc4Pkts: string;
  inPfc5Pkts: string;
  outPfc5Pkts: string;
  inPfc6Pkts: string;
  outPfc6Pkts: string;
  inPfc7Pkts: string;
  outPfc7Pkts: string;
  /** bytes per second */
  inBitsps: number;
  outBitsps: number;
  /** packets per second */
  inPps: number;
  outPps: number;
  /** unicast packets per second */
  inUnicastPps: number;
  outUnicastPps: number;
  /** Aggregate packets per second over all PFC counters */
  inPfcPps: number;
  outPfcPps: number;
  lastClear: Date | undefined;
  collectedAt: Date | undefined;
  portAlias: string;
}

export interface IpmSessionId {
  id: PathId | undefined;
}

export interface IpmSessionParameters {
  description: string;
  srcAddr: string;
  dstAddr: string;
  vrf: string;
  flowLabel: number;
  dscp: number;
  confSessionId: string;
}

export interface IpmRawLatencyCounters {
  id: PathId | undefined;
  rxBin0: string;
  rxBin1: string;
  rxBin2: string;
  rxBin3: string;
  rxBin4: string;
  rxBin5: string;
  rxBin6: string;
  rxBin7: string;
  rxBin8: string;
  rxBin9: string;
  rxBin10: string;
  rxBin11: string;
  rxBin12: string;
  rxBin13: string;
  rxBin14: string;
  rxBin15: string;
  rxBin16: string;
  rxBin17: string;
  rxBin18: string;
  rxBin19: string;
  rxBin20: string;
  rxBin21: string;
  rxBin22: string;
  rxBin23: string;
  rxBin24: string;
  rxBin25: string;
  rxBin26: string;
  rxBin27: string;
  maxBin0: string;
  maxBin1: string;
  maxBin2: string;
  maxBin3: string;
  maxBin4: string;
  maxBin5: string;
  maxBin6: string;
  maxBin7: string;
  maxBin8: string;
  maxBin9: string;
  maxBin10: string;
  maxBin11: string;
  maxBin12: string;
  maxBin13: string;
  maxBin14: string;
  maxBin15: string;
  maxBin16: string;
  maxBin17: string;
  maxBin18: string;
  maxBin19: string;
  maxBin20: string;
  maxBin21: string;
  maxBin22: string;
  maxBin23: string;
  maxBin24: string;
  maxBin25: string;
  maxBin26: string;
  maxBin27: string;
  ipmParams: IpmSessionParameters | undefined;
  collectedAt: Date | undefined;
}

export interface IpmProcLatencyCounters {
  id: PathId | undefined;
  exceedingSuspicious: number;
  exceedingCritical: number;
  ipmParams: IpmSessionParameters | undefined;
  collectedAt: Date | undefined;
  exceedingSuspiciousEma: number;
  exceedingCriticalEma: number;
  rxBin0Ema: number;
  rxBin1Ema: number;
  rxBin2Ema: number;
  rxBin3Ema: number;
  rxBin4Ema: number;
  rxBin5Ema: number;
  rxBin6Ema: number;
  rxBin7Ema: number;
  rxBin8Ema: number;
  rxBin9Ema: number;
  rxBin10Ema: number;
  rxBin11Ema: number;
  rxBin12Ema: number;
  rxBin13Ema: number;
  rxBin14Ema: number;
  rxBin15Ema: number;
  rxBin16Ema: number;
  rxBin17Ema: number;
  rxBin18Ema: number;
  rxBin19Ema: number;
  rxBin20Ema: number;
  rxBin21Ema: number;
  rxBin22Ema: number;
  rxBin23Ema: number;
  rxBin24Ema: number;
  rxBin25Ema: number;
  rxBin26Ema: number;
  rxBin27Ema: number;
  suspiciousThreshold: number;
  criticalThreshold: number;
  suspiciousLatency: boolean;
  criticalLatency: boolean;
  suspiciousThresholdPercentage: number;
  criticalThresholdPercentage: number;
}

export interface IpmProcLossCounters {
  id: PathId | undefined;
  transmittedPackets: string;
  receivedPackets: string;
  loss: string;
  pLoss: number;
  ipmParams: IpmSessionParameters | undefined;
  collectedAt: Date | undefined;
  pLossEma: number;
  alternateMarkingInterval: number;
}

export interface IpmLivenessCounters {
  id: PathId | undefined;
  state: LivenessStatus;
  livenessTimer: number;
  ipmParams: IpmSessionParameters | undefined;
  collectedAt: Date | undefined;
}

export interface IpmProcJitterCounters {
  id: PathId | undefined;
  latPercentile0: number;
  latPercentile5: number;
  latPercentile10: number;
  latPercentile25: number;
  latPercentile50: number;
  latPercentile75: number;
  latPercentile90: number;
  latPercentile95: number;
  latPercentile100: number;
  jitter50: number;
  jitter80: number;
  jitter90: number;
  jitter100: number;
  jitter50Ema: number;
  jitter80Ema: number;
  jitter90Ema: number;
  jitter100Ema: number;
  ipmParams: IpmSessionParameters | undefined;
  collectedAt: Date | undefined;
}

export interface PortVlanInfo {
  id: PathId | undefined;
  vlan: number;
  taggingMode: VlanTaggingMode;
  collectedAt: Date | undefined;
}

export interface VlanCounters {
  id: PathId | undefined;
  bytesIn: string;
  bytesOut: string;
  pktsIn: string;
  pktsOut: string;
  errIn: string;
  errOut: string;
  errPktsIn: string;
  errPktsOut: string;
  collectedAt: Date | undefined;
  anyPortUp: boolean;
}

export interface RoutedInterfaceCounters {
  id: PathId | undefined;
  bytesIn: string;
  bytesOut: string;
  pktsIn: string;
  pktsOut: string;
  errIn: string;
  errOut: string;
  errPktsIn: string;
  errPktsOut: string;
  collectedAt: Date | undefined;
}

export interface L2Fdb {
  id:
    | PathId
    | undefined;
  /**
   * TBD collection time
   * TBD min/max key values for block
   */
  l2entries: L2FdbEntry[];
}

export interface L2FdbSingleVlan {
  id: PathId | undefined;
}

export interface VniMacCounts {
  id: PathId | undefined;
  l2Count: number;
}

export interface VrfEndpointCounts {
  id: PathId | undefined;
  ipv4Count: number;
  ipv6Count: number;
}

export interface L2FdbSingle {
  id: PathId | undefined;
  l2entry: L2Entry | undefined;
}

export interface L2FdbEntry {
  macAddress: string;
  vlanId: number;
  /** Give this a field type for port ref */
  portRef: string;
  /** Was entry added statically? */
  staticEntry: boolean;
  vni: number;
  entryDiscoveredAt:
    | Date
    | undefined;
  /** TBD valid or removed bit? */
  entryType: L2FdbEntryType;
}

export interface L2FdbBucketed {
  id: PathId | undefined;
  l2entries: L2Entry[];
}

export interface L2Entry {
  macAddress: number;
  vlanId: number;
  vni: number;
  entryType: L2FdbEntryType;
  entryDiscoveredAt: Date | undefined;
  portRef: string;
  locatorType: L2FdbEntryLocatorType;
  remoteVtep: string;
  remoteEsi: string;
  fabricLocation: L2FdbRemoteEntryLocation;
  remoteFabricId: string;
}

export interface L2FdbBucketedMultisite {
  id: PathId | undefined;
  l2entries: L2EntryMultisite[];
}

export interface L2EntryMultisite {
  macAddress: number;
  fabricLocation: L2FdbRemoteEntryLocation;
  remoteFabricId: string;
}

export interface VxlanTunnel {
  id: PathId | undefined;
  sourceIp: string;
  collectedAt: Date | undefined;
}

export interface VxlanTunnelMapping {
  id: PathId | undefined;
  vni: number;
  vlanId: number;
  collectedAt: Date | undefined;
}

export interface VxlanRemoteVtepMapping {
  id: PathId | undefined;
  vlanId: number;
  vni: number;
  sourceVtep: string;
  collectedAt: Date | undefined;
}

/** For the table of current Spyglass sessions; maps TCP port to device */
export interface SpyglassSshSessionEntry {
  id: PathId | undefined;
  tcpPort: number;
  deviceId: string;
}

/** Uplifted from Configd for Spyglass Broker status */
export interface SpyglassBrokerEntry {
  id: PathId | undefined;
  deviceId: string;
  connectedInternal: boolean;
  connectedExternal: boolean;
  /** Packets sent to external intf */
  pktsIntToExt: string;
  /** Packets sent to internal intf */
  pktsExtToInt: string;
  internalConnectionCreated: Date | undefined;
  externalConnectionCreated: Date | undefined;
}

/**
 * For the table of DELEGATED READ ONLY authorized users
 * TODO: deprecate this message and use AuthorizedUserDROEntry instead
 */
export interface AuthorizedUserEntry {
  id: PathId | undefined;
  user: string;
  orgId: string;
}

/** For the table of DELEGATED READ ONLY authorized users */
export interface DelegatedReadOnlyUserEntry {
  id: PathId | undefined;
  user: string;
  orgId: string;
}

/** Uplifted from Lira, contains the internal keys */
export interface TestPlaceHolder1Secret {
  id: PathId | undefined;
}

/** A Spyglass device is indexed by a device-id (switch MAC) */
export interface SpyglassDevice {
  id: PathId | undefined;
  connectedAt: Date | undefined;
  listenerCount: number;
}

/** A Spyglass listener is a child of a spyglass device and is indexed by its TCP port */
export interface SpyglassTcpListener {
  id: PathId | undefined;
  createdAt: Date | undefined;
  currentSessionCount: number;
  totalSessionCount: number;
  maxConcurrentSessions: number;
  failedConnectionCount: number;
}

/**
 * A Spyglass session is spawned from a listener (for a device)
 * It is indexed by its session port
 */
export interface SpyglassTcpSession {
  id: PathId | undefined;
  created: Date | undefined;
}

/** DEPRECATED */
export interface SpyglassGingerEntry {
  id: PathId | undefined;
  deviceId: string;
  tcpPort: number;
  status: SpyglassSessionStatus;
  connectionCreated: Date | undefined;
}

export interface RemedyActionFixConnection {
  moveFrom: string;
  moveTo: string;
  connectFrom: string;
  connectTo: string;
}

export interface RemedyActionAddMissingConnection {
  connectFrom: string;
  connectTo: string;
}

export interface RemedyActionRemoveUnexpectedConnection {
  disconnectFrom: string;
  disconnectTo: string;
}

export interface RemedyAction {
  id: PathId | undefined;
  relatedAsserts: PathId[];
  /** Indicates which of the following fields is in-use */
  actionType: RemedyActionCode;
  fixConnection: RemedyActionFixConnection | undefined;
  addConnection: RemedyActionAddMissingConnection | undefined;
  removeConnection: RemedyActionRemoveUnexpectedConnection | undefined;
}

/** DEPRECATED */
export interface RemoteSysCapability {
  sysCapability: LLDPSysCapabilityType;
  enabled: boolean;
}

export interface AdvertisedAutoNegotiation {
  type: string;
  hd: boolean;
  fd: boolean;
}

export interface RemotePortAutoNegotiation {
  supported: boolean;
  enabled: boolean;
  current: string;
  advertised: AdvertisedAutoNegotiation[];
}

export interface BmcDiscovery {
  /**
   * This is the Id assigned to the relevant BMC in the BMC threadlist.
   * To get extended discovery information, use the bmc_id to look up the BMC
   * Bmc path can be constructed using switch's DeviceId / bmc_id
   */
  bmcId: number;
}

export interface ExtendedDiscovery {
  /** Could be > 1 BMC on a port */
  bmcDiscovery: BmcDiscovery[];
}

/** PortNeighbor encapsulates the state of the remote side of a port's link. */
export interface PortNeighbor {
  id: PathId | undefined;
  remotePortDesc: string;
  remotePortId: string;
  remoteSysDescription: string;
  remoteSysName: string;
  remoteManagementAddrIpv4: string;
  remoteManagementAddrIpv6: string;
  remoteDeviceId: string;
  remoteIndex: number;
  remotePortIdSubtype: LLDPRemoteDeviceHostSubType;
  remoteDeviceIdSubtype: LLDPRemoteDeviceHostSubType;
  remoteTimeMark: string;
  /** @deprecated */
  deprecatedRemoteSysCap: RemoteSysCapability[];
  collectedAt: Date | undefined;
  localPort: string;
  neighborType: NeighborType;
  remotePortTtl: number;
  remotePortAutoNegotiation: RemotePortAutoNegotiation | undefined;
  RemoteSysCapabilityRepeater: boolean;
  RemoteSysCapabilityBridge: boolean;
  RemoteSysCapabilityWlan: boolean;
  RemoteSysCapabilityRouter: boolean;
  RemoteSysCapabilityTelephone: boolean;
  RemoteSysCapabilityDocsisCableDevice: boolean;
  RemoteSysCapabilityStation: boolean;
  portAlias: string;
  /**
   * Use ExtendedDiscovery / BmcDiscovery instead
   *
   * @deprecated
   */
  meType: ManagedEndpointType;
  /** @deprecated */
  serverInfo:
    | ManagedEndpointServerInfo
    | undefined;
  /** Generalization for other forms of additional discovery information */
  extendedDiscovery: ExtendedDiscovery | undefined;
}

export interface PortState {
  adminState: AdminState;
  operState: OperState;
  ipv4: string;
  /** Incremented whenever admin state goes ENABLED -> DISABLED */
  adminDownCounter: string;
  /** Incremented whenever operational state goes ENABLED -> DISABLED */
  operDownCounter: string;
  speed: string;
  mtu: number;
  fec: FecType;
  collectedAt: Date | undefined;
  portAlias: string;
  canonicalPortName: string;
  autoPortCfg: AutoPortCfgState;
  lastUpTime: Date | undefined;
}

export interface Vtep {
  id: PathId | undefined;
  bytesIn: string;
  bytesOut: string;
  pktsIn: string;
  pktsOut: string;
  collectedAt: Date | undefined;
}

export interface RemoteVtep {
  id: PathId | undefined;
  bytesIn: string;
  bytesOut: string;
  pktsIn: string;
  pktsOut: string;
  collectedAt: Date | undefined;
}

/** Vni encapsulates the per-port VNI counters. */
export interface VniPort {
  id: PathId | undefined;
  counters: BasicCounters | undefined;
}

/** MACs observed on a VNI port */
export interface Mac {
  id: PathId | undefined;
  macAddress: string;
}

export interface PortVlan {
  id: PathId | undefined;
  vlan: number;
  /** @deprecated */
  deprecatedUntagged: string;
  taggingMode: VlanTaggingMode;
  collectedAt: Date | undefined;
}

export interface VlanState {
  id: PathId | undefined;
  adminState: AdminState;
  hostIfname: string;
  macAddr: string;
  mtu: number;
  vlanId: number;
  vlanName: string;
  vni: number;
  collectedAt: Date | undefined;
}

export interface UnknownVlanPort {
  id: PathId | undefined;
}

export interface UnknownVlan {
  id: PathId | undefined;
  vlanId: number;
  port: string;
  lastRxPkt: Date | undefined;
  collectedAt: Date | undefined;
}

export interface QsfpDomSensor {
  id: PathId | undefined;
  laserTemperature: number;
  voltage: number;
  rx1power: number;
  rx2power: number;
  rx3power: number;
  rx4power: number;
  rx5power: number;
  rx6power: number;
  rx7power: number;
  rx8power: number;
  temperature: number;
  tx1bias: number;
  tx2bias: number;
  tx3bias: number;
  tx4bias: number;
  tx5bias: number;
  tx6bias: number;
  tx7bias: number;
  tx8bias: number;
  tx1power: number;
  tx2power: number;
  tx3power: number;
  tx4power: number;
  tx5power: number;
  tx6power: number;
  tx7power: number;
  tx8power: number;
  mediaLaneCount: number;
  collectedAt: Date | undefined;
}

export interface QsfpDomThreshold {
  id: PathId | undefined;
  lasertemphighalarm: number;
  lasertemphighwarning: number;
  lasertemplowalarm: number;
  lasertemplowwarning: number;
  rxpowerhighalarm: number;
  rxpowerhighwarning: number;
  rxpowerlowalarm: number;
  rxpowerlowwarning: number;
  temphighalarm: number;
  temphighwarning: number;
  templowalarm: number;
  templowwarning: number;
  txbiashighalarm: number;
  txbiashighwarning: number;
  txbiaslowalarm: number;
  txbiaslowwarning: number;
  txpowerhighalarm: number;
  txpowerhighwarning: number;
  txpowerlowalarm: number;
  txpowerlowwarning: number;
  vcchighalarm: number;
  vcchighwarning: number;
  vcclowalarm: number;
  vcclowwarning: number;
  collectedAt: Date | undefined;
}

export interface L2Mac {
  id: PathId | undefined;
}

export interface L3Table {
  id: PathId | undefined;
  macAddress: string;
  ifName: string;
  ipAddress: string;
  familyType: IpFamilyType;
  vlan: number;
  vni: number;
  /** @deprecated */
  stale: boolean;
  collectedAt: Date | undefined;
  learnedFrom: L3TableEntrySource;
  status: L3Status;
  entryDiscoveredAt: Date | undefined;
  internal: boolean;
  vrfName: string;
}

export interface IpPrefix {
  id: PathId | undefined;
}

export interface Vrf {
  id: PathId | undefined;
  collectedAt:
    | Date
    | undefined;
  /** Summary counts of objects in this VRF */
  sviCount: number;
  routedInterfaceCount: number;
  loopbackInterfaceCount: number;
  subInterfaceCount: number;
}

export interface IpNextHop {
  id: PathId | undefined;
  flags: number;
  fib: boolean;
  directlyConnected: boolean;
  ip: string;
  /** @deprecated */
  deprecatedAfi: string;
  interfaceIndex: number;
  interfaceName: string;
  active: boolean;
  onLink: boolean;
  weight: number;
  collectedAt: Date | undefined;
  afi: IpFamilyType;
  routerMac: string;
  recursive: boolean;
  blackHole: boolean;
}

export interface IpRouteTable {
  id: PathId | undefined;
  prefix: string;
  prefixLen: number;
  /** @deprecated */
  deprecatedProtocol: string;
  vrfId: number;
  vrfName: string;
  selected: boolean;
  destSelected: boolean;
  distance: number;
  metric: number;
  installed: boolean;
  offloaded: boolean;
  table: number;
  internalStatus: number;
  internalFlags: number;
  internalNextHopNum: number;
  internalNextHopActiveNum: number;
  nextHopGroupId: number;
  installedNextHopGroupId: number;
  uptime: string;
  ipFamily: IpFamilyType;
  collectedAt: Date | undefined;
  protocol: ProtocolType;
  multipleDiffNextHops: boolean;
  /** BGP Route Info Details */
  origin: BgpRouteOriginType;
  peerId: string;
  peerAsnPath: string;
  pathFrom: BgpPathSource;
  selectionReason: BgpPathSelectionReason;
  weight: number;
  med: number;
  nhIp: string;
  nhName: string;
}

export interface VlanVniMap {
  id: PathId | undefined;
  vni: number;
  vlan: number;
  collectedAt: Date | undefined;
}

export interface NetworkInterfaceSummary {
  id: PathId | undefined;
  vlanId: number;
  vni: number;
  vrfName: string;
  ipAddress: string;
  interfaceName: string;
  collectedAt: Date | undefined;
  interfaceType: NetworkInterfaceType;
}

export interface ManagementConfig {
  id: PathId | undefined;
  sonic: SonicConfig | undefined;
  proxy: ProxyConfig | undefined;
  dns: DnsConfig | undefined;
  drake: DrakeConfig | undefined;
  ntpServers: string[];
  configSource: string;
  ipv4Method: string;
  ipv6Method: string;
}

export interface ManagementState {
  id: PathId | undefined;
  sonic: SonicConfig | undefined;
  proxy: ProxyConfig | undefined;
  dns: DnsConfig | undefined;
  drake: DrakeConfig | undefined;
  ntpServers: string[];
  configSource: string;
  ipv4Method: string;
  ipv6Method: string;
  operationStatus: OperationStatus;
  collectedAt: Date | undefined;
  secondaryIpv4Addr: string;
  secondaryIpv4Method: string;
  ifNameAlias: string;
}

export interface BgpNeighborFamily {
  id: PathId | undefined;
}

export interface BgpNeighborSummary {
  id: PathId | undefined;
  routerId: string;
  as: number;
  vrfId: number;
  vrfName: string;
  tableVersion: number;
  ribCount: number;
  ribMemory: number;
  peerCount: number;
  peerMemory: number;
  peerGroupCount: number;
  peerGroupMemory: number;
  peerName: string;
  peerHostname: string;
  peerRemoteAs: number;
  peerLocalAs: number;
  peerTableVersion: number;
  peerMsgRcvd: number;
  peerMsgSent: number;
  peerOutQ: number;
  peerInQ: number;
  peerUptime: string;
  peerUptimeMsec: string;
  peerUptimeEstablishedEpoch: string;
  peerPfxRcd: number;
  peerPfxSnt: number;
  peerConnectionState: BgpPeerConnectionState;
  peerState: BgpPeerState;
  peerConnectionsEstablished: number;
  peerConnectionsDropped: number;
  peerIdType: BgpIdType;
  failedPeers: number;
  displayedPeers: number;
  totalPeers: number;
  dynamicPeers: number;
  addressFamily: BgpAddressFamily;
  multiPathRelax: boolean;
  peerVersion: number;
  collectedAt: Date | undefined;
  updateRecord: boolean;
  peerIsDynamic: boolean;
  holdTimerRemainingMs: number;
  receivedRoutesCount: number;
  advertisedRoutesCount: number;
}

export interface BgpNeighborAddressFamily {
  l2VpnEvpn: BgpNeighborAddressFamilyInfo | undefined;
  ipv6Unicast: BgpNeighborAddressFamilyInfo | undefined;
  ipv4Unicast: BgpNeighborAddressFamilyInfo | undefined;
}

export interface BgpNeighborAddressFamilyInfo {
  bgpAddressFamily: BgpAddressFamily;
  updateGroupId: number;
  subGroupId: number;
  packetQueueLength: number;
  acceptedPrefixCounter: number;
  sentPrefixCounter: number;
  allowAsInCount: number;
  peerGroupMember: string;
  commAttriSentToNbr: string;
  unchangedNextHopPropogatedToNbr: boolean;
  advertiseAllVnis: boolean;
  routerAlwaysNextHop: boolean;
  inboundPathPolicyConfig: boolean;
  outboundPathPolicyConfig: boolean;
  routeMapForIncomingAdvertisements: string;
  routeMapForOutgoingAdvertisements: string;
}

export interface BgpPeerBfdInfo {
  type: string;
  detectMultiplier: number;
  rxMinInterval: number;
  txMinInterval: number;
  status: BgpPeerBfdState;
  lastUpdate: string;
}

export interface BgpNeighborCapabilitiesAddPathInfo {
  rxAdvertiseAndReceived: boolean;
}

export interface BgpNeighborCapabilitiesAddPath {
  l2VpnEvpn: BgpNeighborCapabilitiesAddPathInfo | undefined;
  ipv4Unicast: BgpNeighborCapabilitiesAddPathInfo | undefined;
  ipv6Unicast: BgpNeighborCapabilitiesAddPathInfo | undefined;
}

export interface BgpNeighborCapabilitiesMultiProtocolExtensions {
  l2VpnEvpn: BgpNeighborCapabilitiesAddPathInfo | undefined;
  ipv4Unicast: BgpNeighborCapabilitiesAddPathInfo | undefined;
  ipv6Unicast: BgpNeighborCapabilitiesAddPathInfo | undefined;
}

export interface BgpNeighborCapabilitiesMultiProtocolExtensionsInfo {
  advertisedAndReceived: boolean;
}

export interface BgpNeighborCapabilitiesHostName {
  advHostName: string;
  advDomainName: string;
  rcvHostName: string;
  rcvDomainName: string;
}

export interface BgpNeighborCapabilities {
  fourByteAs: BgpNeighborCapability;
  extendedMessage: BgpNeighborCapability;
  longLivedGracefulRestart: BgpNeighborCapability;
  routeRefresh: BgpNeighborCapability;
  enhancedRouteRefresh: BgpNeighborCapability;
  gracefulRestart: BgpNeighborCapability;
  gracefulRestartRemoteTimerMsecs: number;
  addressFamiliesByPeer: string;
  multiprotocolExtensions: BgpNeighborCapabilitiesMultiProtocolExtensions | undefined;
  addPath: BgpNeighborCapabilitiesAddPath | undefined;
  hostName: BgpNeighborCapabilitiesHostName | undefined;
}

export interface BgpNeighborMessageStats {
  depthInq: number;
  depthOutq: number;
  opensSent: number;
  opensRecv: number;
  notificationsSent: number;
  notificationsRecv: number;
  updatesSent: number;
  updatesRecv: number;
  keepalivesSent: number;
  keepalivesRecv: number;
  routeRefreshSent: number;
  routeRefreshRecv: number;
  capabilitySent: number;
  capabilityRecv: number;
  totalSent: number;
  totalRecv: number;
}

export interface BgpNeighborGracefulRestartTimers {
  configuredRestartTimer: number;
  receivedRestartTimer: number;
  stalePathTimer: number;
}

export interface BgpNeighborGracefulRestartEndOfRibInfo {
  l2VpnEvpn: boolean;
  ipv4Unicast: boolean;
  ipv6Unicast: boolean;
}

export interface BgpNeighborGracefulRestartInfoEndOfRibStatus {
  fBit: boolean;
  endOfRibSend: boolean;
  endOfRibSentAfterUpdate: boolean;
  endOfRibRecv: boolean;
  timers: BgpNeighborGracefulRestartTimers | undefined;
}

export interface BgpNeighborGracefulRestartInfo {
  endOfRibSend: BgpNeighborGracefulRestartEndOfRibInfo | undefined;
  endOfRibRecv: BgpNeighborGracefulRestartEndOfRibInfo | undefined;
  timers: BgpNeighborGracefulRestartTimers | undefined;
  localGrMode: string;
  remoteGrMode: string;
  rBit: boolean;
  nBit: boolean;
  l2VpnEvpn: BgpNeighborGracefulRestartInfoEndOfRibStatus | undefined;
  ipv4Unicast: BgpNeighborGracefulRestartInfoEndOfRibStatus | undefined;
  ipv6Unicast: BgpNeighborGracefulRestartInfoEndOfRibStatus | undefined;
}

export interface BgpNeighborInfo {
  id: PathId | undefined;
  vrfId: number;
  vrfName: string;
  remoteAs: number;
  localAs: number;
  nbrExternalLink: boolean;
  localRole: BgpNeighborRole;
  remoteRole: BgpNeighborRole;
  hostname: string;
  bgpVersion: number;
  remoteRouterId: string;
  localRouterId: string;
  bgpState: BgpPeerConnectionState;
  bgpTimerUpMsec: number;
  bgpTimerUpString: string;
  bgpTimerUpEstablishedEpoch: number;
  bgpTimerLastRead: number;
  bgpTimerLastWrite: number;
  bgpInUpdateElapsedTimeMsecs: number;
  bgpTimerConfiguredHoldTimeMsecs: number;
  bgpTimerConfiguredKeepAliveIntervalMsecs: number;
  bgpTimerHoldTimeMsecs: number;
  bgpTimerKeepAliveIntervalMsecs: number;
  extendedOptionalParametersLength: boolean;
  connectionsEstablished: number;
  connectionsDropped: number;
  lastResetTimerMsecs: number;
  lastResetDueTo: string;
  lastResetCode: number;
  externalBgpNbrMaxHopsAway: number;
  hostLocal: string;
  portLocal: number;
  hostForeign: string;
  portForeign: number;
  nextHop: string;
  nextHopGlobal: string;
  nextHopLocal: string;
  bgpConnection: string;
  connectRetryTimer: number;
  estimatedRttInMsecs: number;
  readThread: BgpNeighborThreadState;
  writeThread: BgpNeighborThreadState;
  peerBfdInfo: BgpPeerBfdInfo | undefined;
  addressFamilyInfo: BgpNeighborAddressFamily | undefined;
  minBtwnAdvertisementRunsTimerMsecs: number;
  updateSource: string;
  messageStats: BgpNeighborMessageStats | undefined;
  gracefulRestartInfo: BgpNeighborGracefulRestartInfo | undefined;
  neighborCapabilities: BgpNeighborCapabilities | undefined;
  peerGroup: BgpNeighborPeerGroup;
  bgpTimerConfiguredConditionalAdvertisementsSec: number;
  peerAuthEnable: BgpPeerAuthenticationStatus;
  internalBgpNbrMaxHopsAway: number;
  nextHopInterface: string;
}

export interface BgpNeighborReceivedRoute {
  id: PathId | undefined;
  bgpLocalRouterId: string;
  bgpTableVersion: number;
  localAs: number;
  addrPrefix: string;
  prefixLen: number;
  network: string;
  nextHop: string;
  metric: number;
  weight: number;
  path: string;
  valid: boolean;
  best: boolean;
  suppressed: boolean;
  damped: boolean;
  history: boolean;
  internal: boolean;
  ribFailure: boolean;
  stale: boolean;
  bgpOriginCode: string;
  origin: BgpNeighborReceivedRouteOrigin;
  receivedRoute: string;
  bgpNeighborOriginVrf: string;
  bgpNeighborOriginAddressFamily: BgpAddressFamily;
  defaultLocPrf: number;
  totalPrefixCounter: number;
  filteredPrefixCounter: number;
  collectedAt: Date | undefined;
  locPrf: number;
  isAsPathTruncated: boolean;
  community: string;
}

export interface BgpNeighborAdvertisedRoute {
  id: PathId | undefined;
  bgpLocalRouterId: string;
  bgpTableVersion: number;
  localAs: number;
  addrPrefix: string;
  prefixLen: number;
  network: string;
  nextHop: string;
  metric: number;
  weight: number;
  path: string;
  valid: boolean;
  best: boolean;
  suppressed: boolean;
  damped: boolean;
  history: boolean;
  internal: boolean;
  ribFailure: boolean;
  stale: boolean;
  bgpOriginCode: string;
  origin: BgpNeighborReceivedRouteOrigin;
  routePrefix: string;
  bgpNeighborOriginVrf: string;
  bgpNeighborOriginAddressFamily: BgpAddressFamily;
  defaultLocPrf: number;
  totalPrefixCounter: number;
  filteredPrefixCounter: number;
  collectedAt: Date | undefined;
  locPrf: number;
  isAsPathTruncated: boolean;
  community: string;
}

export interface PortRateCounters {
  id: PathId | undefined;
  portName: string;
  rxBps: number;
  rxPps: number;
  txBps: number;
  txPps: number;
  saiPortStatIfInNonUcastPktsLast: string;
  saiPortStatIfInOctetsLast: string;
  saiPortStatIfInUcastPktsLast: string;
  saiPortStatIfOutNonUcastPktsLast: string;
  saiPortStatIfOutOctetsLast: string;
  saiPortStatIfOutUcastPktsLast: string;
  collectedAt: Date | undefined;
}

export interface SystemStats {
  id: PathId | undefined;
  CpuUsed: number;
  CpuIdle: number;
  MemTotal: string;
  MemUsed: string;
  MemFree: string;
  DiskTotal: string;
  DiskUsed: string;
  DiskFree: string;
  collectedAt: Date | undefined;
}

export interface PortChannelMemberState {
  id: PathId | undefined;
  name: string;
  memberInterfaceName: string;
  devAddr: string;
  ifIndex: number;
  linkUp: boolean;
  linkWatchUp: boolean;
  actorLacpduInfoPort: number;
  actorLacpduInfoState: number;
  actorLacpduInfoSystem: string;
  partnerLacpduInfoPort: number;
  partnerLacpduInfoState: number;
  partnerLacpduInfoSystem: string;
  aggregatorId: number;
  aggregatorSelected: boolean;
  selected: boolean;
  state: PortChannelMemberInfoState;
  protocol: PortChannelProtocol;
  collectedAt: Date | undefined;
  lacpStatus: boolean;
}

export interface PortChannelState {
  id: PathId | undefined;
  name: string;
  adminStatus: OperState;
  mtu: number;
  operStatus: OperState;
  state: PortChannelStatus;
  runnerActive: boolean;
  runnerFallback: boolean;
  runnerFastRate: boolean;
  setupKernelTeamModeName: PortChannelKernelTeamMode;
  setupPid: number;
  teamDeviceIfInfoDevAddr: string;
  teamDeviceIfInfoIfIndex: number;
  protocol: PortChannelProtocol;
  collectedAt: Date | undefined;
}

/** FIXME: Should not need DeviceType */
export interface OrgUuid {
  id: PathId | undefined;
  labels: string[];
}

export interface OrgMetadata {
  id: PathId | undefined;
  orgName: string;
  optInC3: boolean;
  cuiTenantId: string;
}

export interface FabricUuid {
  id: PathId | undefined;
}

export interface OrgToCellPairMapping {
  id: PathId | undefined;
  orgUuid: string;
  cellPairUuid: string;
  /**
   * was svc_proxy (fred) for cell A
   *
   * @deprecated
   */
  reserved5: string;
  /**
   * was svc_proxy (fred) for cell B
   *
   * @deprecated
   */
  reserved6: string;
  /** monotonically increasing number */
  generation: number;
  orgKind: OrgKind;
  createdBy: string;
  /** Deprecate once rolled out */
  activeCellUuid: string;
  /** Deprecate once rolled out */
  standbyCellUuid: string;
  /** Deprecate once rolled out */
  activeSvcProxyHost: string;
  labels: string[];
  /** Deprecate once rolled out */
  activeSvcProxy:
    | HostPort
    | undefined;
  /** Geographic region of the cell serving this org. */
  geo: Geo;
  updatedTs: Date | undefined;
}

export interface CellPair {
  id: PathId | undefined;
  cellPairUuid: string;
  cellAUuid: string;
  cellBUuid: string;
  activeCellUuid: string;
  standbyCellUuid: string;
  activeSvcProxy: HostPort | undefined;
  updatedTs: Date | undefined;
}

export interface HostPort {
  host: string;
  httpsPort: number;
  grpcPort: number;
  privatePort: number;
}

export interface K8sNodeInfo {
  nodeName: string;
  nodeIp: string;
  availabilityZone: string;
}

export interface KubernetesServiceInstance {
  id: PathId | undefined;
  podUuid: string;
  appName: ApplicationIdentity;
  appReadiness: ApplicationReadiness;
  instanceName: string;
  instanceId: number;
  softwareVersion: string;
  /** cluster or cell identifier */
  clusterId: string;
  host: HostPort | undefined;
  loadBalancedHost: HostPort | undefined;
  nodeInfo: K8sNodeInfo | undefined;
  updatedTs: Date | undefined;
}

export interface QsfpInfo {
  id: PathId | undefined;
  activeApselHostlane1: boolean;
  activeApselHostlane2: boolean;
  activeApselHostlane3: boolean;
  activeApselHostlane4: boolean;
  activeApselHostlane5: boolean;
  activeApselHostlane6: boolean;
  activeApselHostlane7: boolean;
  activeApselHostlane8: boolean;
  activeFirmware: string;
  /** This will likely be truncated but that is fine. */
  applicationAdvertisement: string;
  cableLength: number;
  cableType: string;
  cmisRev: number;
  connector: string;
  domCapability: string;
  encoding: string;
  extIdentifier: string;
  extRateselectCompliance: string;
  hardwareRev: number;
  hostElectricalInterface: string;
  hostLaneAssignmentOption: number;
  hostLaneCount: number;
  inactiveFirmware: string;
  isReplaceable: boolean;
  manufacturer: string;
  mediaInterfaceCode: string;
  mediaInterfaceTechnology: string;
  mediaLaneAssignmentOption: number;
  mediaLaneCount: number;
  model: string;
  nominalBitRate: number;
  serial: string;
  specificationCompliance: string;
  supportedMaxLaserFreq: number;
  supportedMaxTxPower: number;
  supportedMinLaserFreq: number;
  supportedMinTxPower: number;
  type: string;
  vendorDate: Date | undefined;
  vendorOui: string;
  vendorRev: string;
  transceiverModule: QsfpTransceiverModule;
  pid: string;
  interfaceName: string;
  neighborType: NeighborType;
  collectedAt: Date | undefined;
  duplex: QsfpDupex;
  advertisedAutoNegotiation: QsfpAdvertisedAutoNegotiation;
  transceiver: QsfpTransceiver;
  phyAd: number;
  wakeOn: string;
  advertisedFec: FecType;
  advertisedPauseFrameUse: string;
  autoNegotiation: QsfpAutoNegotiation;
  portAlias: string;
  lot: string;
  qsfpOperStatus: QsfpOperStatus | undefined;
  hasAdapter: boolean;
  adapterInfo: QsfpAdapterInfo | undefined;
}

export interface QsfpAdapterInfo {
  manufacturer: string;
  model: string;
  serial: string;
  vendorRev: string;
  vendorOui: string;
  vendorDate: Date | undefined;
  pid: string;
  type: string;
}

export interface QsfpOperStatus {
  cmisState: QsfpCmisState;
  moduleState: QsfpModuleState;
  moduleFaultCause: QsfpModuleFaultCause;
  dp1State: QsfpDataPathState;
  dp2State: QsfpDataPathState;
  dp3State: QsfpDataPathState;
  dp4State: QsfpDataPathState;
  dp5State: QsfpDataPathState;
  dp6State: QsfpDataPathState;
  dp7State: QsfpDataPathState;
  dp8State: QsfpDataPathState;
  configStateHostlane1: QsfpConfigState;
  configStateHostlane2: QsfpConfigState;
  configStateHostlane3: QsfpConfigState;
  configStateHostlane4: QsfpConfigState;
  configStateHostlane5: QsfpConfigState;
  configStateHostlane6: QsfpConfigState;
  configStateHostlane7: QsfpConfigState;
  configStateHostlane8: QsfpConfigState;
  txLoss1: boolean;
  txLoss2: boolean;
  txLoss3: boolean;
  txLoss4: boolean;
  txLoss5: boolean;
  txLoss6: boolean;
  txLoss7: boolean;
  txLoss8: boolean;
  rxLoss1: boolean;
  rxLoss2: boolean;
  rxLoss3: boolean;
  rxLoss4: boolean;
  rxLoss5: boolean;
  rxLoss6: boolean;
  rxLoss7: boolean;
  rxLoss8: boolean;
}

export interface DeviceClaimData {
  activeDeviceClaim1: string;
  activeDeviceClaim1Expiry: Date | undefined;
  activeDeviceClaim2: string;
  activeDeviceClaim2Expiry: Date | undefined;
  usbClaimOperation: boolean;
}

export interface DeviceClaim {
  id:
    | PathId
    | undefined;
  /** @deprecated */
  activeDeviceClaim1: string;
  /** @deprecated */
  activeDeviceClaim1Expiry:
    | Date
    | undefined;
  /** @deprecated */
  activeDeviceClaim2: string;
  /** @deprecated */
  activeDeviceClaim2Expiry:
    | Date
    | undefined;
  /** @deprecated */
  usbClaimOperation: boolean;
  collectedAt: Date | undefined;
  deviceClaim: DeviceClaimData | undefined;
}

export interface AggregatedDeviceClaim {
  id: PathId | undefined;
  deviceClaim: DeviceClaimData | undefined;
  adjacencyBloomFilter: Uint8Array;
  collectedAt: Date | undefined;
}

export interface ApiPathProtocol {
  id: PathId | undefined;
}

export interface ApiPathMethod {
  id: PathId | undefined;
}

export interface ApiPath {
  id: PathId | undefined;
}

/**
 * FORMAT . METHOD . PATH. Mapping
 * e.g. API_FORMAT_TYPE_REST . GET . /ui/v1/sessions
 */
export interface ApiServiceMapping {
  id:
    | PathId
    | undefined;
  /** @deprecated */
  deprecatedApi: string;
  /** @deprecated */
  deprecatedMethod: string;
  /** @deprecated */
  deprecatedSvc: string;
  /** @deprecated */
  deprecatedRoutingPolicy: string;
  app: ApplicationIdentity;
  routingPolicy: RoutingPolicy;
  noAuth: boolean;
  deviceAuth: boolean;
  restAuth: boolean;
  webAuth: boolean;
}

export interface TenantUuid {
  id: PathId | undefined;
}

export interface UserEmail {
  id: PathId | undefined;
  orgUuid: string;
  tenantUuid: string;
  userEmail: string;
  orgKind: OrgKind;
  lastLogin: Date | undefined;
  userRole: UserRole;
  provider: KnownProvider;
  invalidBeforeTs: Date | undefined;
  userUuid: string;
}

export interface ServiceInstanceHealth {
  id: PathId | undefined;
  collectedAt:
    | Date
    | undefined;
  /** UUID representing the "incarnation" of this instance (e.g. container uuid) */
  instanceUid: string;
  memoryTotal: string;
  memoryFree: string;
  /** Number of seconds of CPU user runtime since process start */
  cpuUserTime: number;
  /** Number of seconds of CPU system runtime since process start */
  cpuSystemTime: number;
}

export interface AssertConfigLinkUpData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  port: PortConfigDetails | undefined;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigPortLinkUp {
  id: PathId | undefined;
  config: AssertConfigLinkUpData | undefined;
}

export interface AssertPortLinkUp {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigLinkUpData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigSubInterfaceUpData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  subInterface: SubInterfaceDetails | undefined;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigSubInterfaceUp {
  id: PathId | undefined;
  config: AssertConfigSubInterfaceUpData | undefined;
}

export interface AssertSubInterfaceUp {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigSubInterfaceUpData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigSubInterfaceDownData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  subInterface: SubInterfaceDetails | undefined;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigSubInterfaceDown {
  id: PathId | undefined;
  config: AssertConfigSubInterfaceDownData | undefined;
}

export interface AssertSubInterfaceDown {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigSubInterfaceDownData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigLinkDownData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  port: PortConfigDetails | undefined;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigPortLinkDown {
  id: PathId | undefined;
  config: AssertConfigLinkDownData | undefined;
}

export interface AssertPortLinkDown {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigLinkDownData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  remoteDeviceId: string;
  remotePortName: string;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigPortChannelMemberUpData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  portChannelMember: PortChannelMemberState | undefined;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigPortChannelMemberUp {
  id: PathId | undefined;
  config: AssertConfigPortChannelMemberUpData | undefined;
}

export interface AssertPortChannelMemberUp {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigPortChannelMemberUpData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigPortVlanStpStateConsistentData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  stpVlanPortState: StpVlanPortState | undefined;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigPortVlanStpStateConsistent {
  id: PathId | undefined;
  config: AssertConfigPortVlanStpStateConsistentData | undefined;
}

export interface AssertPortVlanStpStateConsistent {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigPortVlanStpStateConsistentData | undefined;
  observedStpVlanPortState: StpVlanPortStateStatus;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface PortPluggableDetails {
  pid: string;
  portType: NeighborType;
  portName: string;
}

export interface AssertConfigPortPluggablePidSameData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  pluggableDetails: PortPluggableDetails | undefined;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigPortPluggablePidSame {
  id: PathId | undefined;
  config: AssertConfigPortPluggablePidSameData | undefined;
}

export interface AssertPortPluggablePidSame {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigPortPluggablePidSameData | undefined;
  observedPortPluggableDetails: PortPluggableDetails | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface QsfpHealthDetails {
  laserTemperatureWithinThreshold: boolean;
  temperatureWithinThreshold: boolean;
  voltageWithinThreshold: boolean;
  rx1powerWithinThreshold: boolean;
  rx2powerWithinThreshold: boolean;
  rx3powerWithinThreshold: boolean;
  rx4powerWithinThreshold: boolean;
  rx5powerWithinThreshold: boolean;
  rx6powerWithinThreshold: boolean;
  rx7powerWithinThreshold: boolean;
  rx8powerWithinThreshold: boolean;
  tx1powerWithinThreshold: boolean;
  tx2powerWithinThreshold: boolean;
  tx3powerWithinThreshold: boolean;
  tx4powerWithinThreshold: boolean;
  tx5powerWithinThreshold: boolean;
  tx6powerWithinThreshold: boolean;
  tx7powerWithinThreshold: boolean;
  tx8powerWithinThreshold: boolean;
  tx1biasWithinThreshold: boolean;
  tx2biasWithinThreshold: boolean;
  tx3biasWithinThreshold: boolean;
  tx4biasWithinThreshold: boolean;
  tx5biasWithinThreshold: boolean;
  tx6biasWithinThreshold: boolean;
  tx7biasWithinThreshold: boolean;
  tx8biasWithinThreshold: boolean;
}

export interface AssertConfigPortQsfpHealthyData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  hostname: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigPortQsfpHealthy {
  id: PathId | undefined;
  config: AssertConfigPortQsfpHealthyData | undefined;
}

export interface AssertPortQsfpHealthy {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigPortQsfpHealthyData | undefined;
  observedQsfpHealthDetails: QsfpHealthDetails | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigConnectedToCloudData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigDeviceConnectedToCloud {
  id: PathId | undefined;
  config: AssertConfigConnectedToCloudData | undefined;
}

export interface AssertDeviceConnectedToCloud {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigConnectedToCloudData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigExpectedNeighborData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  port: PortConfigDetails | undefined;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigPortExpectedNeighbor {
  id: PathId | undefined;
  config: AssertConfigExpectedNeighborData | undefined;
}

export interface AssertPortExpectedNeighbor {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigExpectedNeighborData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  remoteDeviceId: string;
  remotePortName: string;
  numNeighbors: number;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigNotConnectedToFabricData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  port: PortConfigDetails | undefined;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigPortNotConnectedToFabric {
  id: PathId | undefined;
  config: AssertConfigNotConnectedToFabricData | undefined;
}

export interface AssertPortNotConnectedToFabric {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigNotConnectedToFabricData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  remoteDeviceId: string;
  remotePortName: string;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigConnectedToFabricData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigDeviceConnectedToFabric {
  id: PathId | undefined;
  config: AssertConfigConnectedToFabricData | undefined;
}

export interface AssertDeviceConnectedToFabric {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigConnectedToFabricData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigConnectedPortSpeedsMatchData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  port: PortConfigDetails | undefined;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigPortConnectionSpeedMatch {
  id: PathId | undefined;
  config: AssertConfigConnectedPortSpeedsMatchData | undefined;
}

export interface AssertPortConnectionSpeedMatch {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigConnectedPortSpeedsMatchData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  localPortSpeed: string;
  remotePortName: string;
  remoteDeviceId: string;
  remotePortSpeed: string;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigPortSpeedConsistentData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  port: PortConfigDetails | undefined;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigPortSpeedConsistent {
  id: PathId | undefined;
  config: AssertConfigPortSpeedConsistentData | undefined;
}

export interface AssertPortSpeedConsistent {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigPortSpeedConsistentData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  localPortSpeed: string;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigVlanHasTrafficData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
  maxVlanId: number;
}

export interface AssertConfigVlanHasTraffic {
  id: PathId | undefined;
  config: AssertConfigVlanHasTrafficData | undefined;
}

export interface AssertVlanHasTraffic {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigVlanHasTrafficData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  lastTrafficBytes: string;
  lastTrafficTime: Date | undefined;
  recentTrafficBytes: string;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigStaticDefaultRouteExistsData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigStaticDefaultRouteExists {
  id: PathId | undefined;
  config: AssertConfigStaticDefaultRouteExistsData | undefined;
  interfaceName: string;
}

export interface AssertStaticDefaultRouteExists {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigStaticDefaultRouteExistsData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigManagementPortConfigData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  mgmtPortState: ManagementState | undefined;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigManagementPortConfigSame {
  id: PathId | undefined;
  config: AssertConfigManagementPortConfigData | undefined;
}

export interface AssertManagementPortConfigSame {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigManagementPortConfigData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  operationalMgmtPortState: ManagementState | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigExpectedPortBreakoutExistsData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  expectedPortBreakoutCfg: PortBreakoutConfig | undefined;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigExpectedPortBreakoutExists {
  id: PathId | undefined;
  config: AssertConfigExpectedPortBreakoutExistsData | undefined;
}

export interface AssertExpectedPortBreakoutExists {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigExpectedPortBreakoutExistsData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface PortBreakoutConfig {
  speed: string;
  media: CableType;
  name: string;
}

export interface AssertConfigDeviceResourceUsageBelowThresholdData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  cpuThreshold: number;
  memoryThreshold: number;
  diskThreshold: number;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigDeviceResourceUsageBelowThreshold {
  id: PathId | undefined;
  config: AssertConfigDeviceResourceUsageBelowThresholdData | undefined;
}

export interface AssertDeviceResourceUsageBelowThreshold {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigDeviceResourceUsageBelowThresholdData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  currentSystemStats: SystemStats | undefined;
  highCpuUtil: boolean;
  highMemUtil: boolean;
  highDiskUtil: boolean;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigDevicePsuUsageBelowThreshold {
  id: PathId | undefined;
  config: AssertConfigDevicePsuUsageBelowThresholdData | undefined;
}

export interface AssertConfigDevicePsuUsageBelowThresholdData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  fanSpeedThreshold: number;
  powerDrawnThreshold: number;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertDevicePsuUsageBelowThreshold {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigDevicePsuUsageBelowThresholdData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigDeviceFanSpeedBelowThreshold {
  id: PathId | undefined;
  config: AssertConfigDeviceFanSpeedBelowThresholdData | undefined;
}

export interface AssertConfigDeviceFanSpeedBelowThresholdData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  fanSpeedThreshold: number;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertDeviceFanSpeedBelowThreshold {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigDeviceFanSpeedBelowThresholdData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigDeviceTemperatureBelowThreshold {
  id: PathId | undefined;
  config: AssertConfigDeviceTemperatureBelowThresholdData | undefined;
}

export interface AssertConfigDeviceTemperatureBelowThresholdData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertDeviceTemperatureBelowThreshold {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigDeviceTemperatureBelowThresholdData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigBgpPeerEstablishedData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  orgId: string;
  peerRemoteAs: number;
  vrfName: string;
  fabricId: string;
  peerIp: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
  /** Primary IP address of remote peer. Counterpart of local_bgp_peer_id. */
  bgpPeerId: string;
  /** Name of remote peer. */
  bgpPeerName: string;
  isMultisitePeer: boolean;
  multisiteName: string;
  multisiteId: string;
  /** Local IP address as used by remote TWAMP probes. Counterpart of what's in id.MultisiteLink. */
  localMultisiteLinkIp: string;
  /** Primary IP address of local peer. Counterpart of bgp_peer_id. */
  localBgpPeerId: string;
}

export interface AssertConfigBgpPeerEstablished {
  id: PathId | undefined;
  config: AssertConfigBgpPeerEstablishedData | undefined;
}

export interface AssertBgpPeerEstablished {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigBgpPeerEstablishedData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigPortNoUnknownVlanFoundData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
  portName: string;
}

export interface AssertConfigPortNoUnknownVlanFound {
  id: PathId | undefined;
  config: AssertConfigPortNoUnknownVlanFoundData | undefined;
}

export interface AssertPortNoUnknownVlanFound {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigPortNoUnknownVlanFoundData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  unknownVlan1: number;
  unknownVlan2: number;
  unknownVlan3: number;
  unknownVlan4: number;
  unknownVlan5: number;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
  hasAdditionalUnknownVlans: boolean;
}

export interface MultisiteLink {
  id: PathId | undefined;
}

export interface TwampSession {
  /** Remote IP being probed by TWAMP is in the MultisiteLinkType index */
  id: PathId | undefined;
  localIp: string;
  state: TwampSessionState;
  lastProbe:
    | Date
    | undefined;
  /** latency of the last probe in microseconds */
  lastProbeRttUs: number;
  /** rolling median latency in microseconds */
  medianRttUs: number;
  /** rolling standard deviation of latency in microseconds */
  stdDevRttUs: number;
  discoveredPathMtu: number;
  /** reason/description behind the discovered path MTU value */
  mtuDiscoveryReason: TwampPathMtuDiscoveryReason;
  /** counter of consecutive RTT deviations beyond a configured threshold when compared with current median RTT */
  consecutiveRttDeviations: number;
  /** rolling minimum latency in microseconds */
  minRttUs: number;
  /** rolling maximum latency in microseconds */
  maxRttUs: number;
}

export interface AssertConfigMultisiteLinkUpData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  severity: AssertSeverityType;
  groupShortName: string;
  deviceType: AssertDeviceType;
  /** Primary IP address of remote peer. Counterpart of local_bgp_peer_id. */
  bgpPeerId: string;
  bgpPeerName: string;
  multisiteName: string;
  multisiteId: string;
  /** Local IP address as used by remote TWAMP probes. Counterpart of what's in id.MultisiteLink. */
  localMultisiteLinkIp: string;
  /** Primary IP address of local peer. Counterpart of bgp_peer_id. */
  localBgpPeerId: string;
}

export interface AssertConfigMultisiteLinkUp {
  /** Remote IP being probed by TWAMP is in the MultisiteLinkType index. Counterpart of config.local_multisite_link_ip. */
  id: PathId | undefined;
  config: AssertConfigMultisiteLinkUpData | undefined;
}

export interface AssertMultisiteLinkUp {
  /** Remote IP being probed by TWAMP is in the MultisiteLinkType index. Counterpart of config.local_multisite_link_ip. */
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigMultisiteLinkUpData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface AssertConfigMultisiteLatencyStableData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  severity: AssertSeverityType;
  groupShortName: string;
  deviceType: AssertDeviceType;
  /** Primary IP address of remote peer. Counterpart of local_bgp_peer_id. */
  bgpPeerId: string;
  bgpPeerName: string;
  multisiteName: string;
  multisiteId: string;
  /** Local IP address as used by remote TWAMP probes. Counterpart of what's in id.MultisiteLink. */
  localMultisiteLinkIp: string;
  /** Primary IP address of local peer. Counterpart of bgp_peer_id. */
  localBgpPeerId: string;
}

export interface AssertConfigMultisiteLatencyStable {
  /** Remote IP being probed by TWAMP is in the MultisiteLinkType index. Counterpart of config.local_multisite_link_ip. */
  id: PathId | undefined;
  config: AssertConfigMultisiteLatencyStableData | undefined;
}

export interface AssertMultisiteLatencyStable {
  /** Remote IP being probed by TWAMP is in the MultisiteLinkType index. Counterpart of config.local_multisite_link_ip. */
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigMultisiteLatencyStableData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
  /** discovered median latency in microseconds */
  medianRttUs: number;
  /** most recent latency in microseconds */
  lastRttUs: number;
  /** minimum latency corresponding to the median calculation window in microseconds */
  minRttUs: number;
  /** maximum latency corresponding to the median calculation window in microseconds */
  maxRttUs: number;
}

export interface AssertConfigMultisiteExpectedMtuData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  severity: AssertSeverityType;
  groupShortName: string;
  deviceType: AssertDeviceType;
  expectedMtu: number;
  /** Primary IP address of remote peer. Counterpart of local_bgp_peer_id. */
  bgpPeerId: string;
  bgpPeerName: string;
  multisiteName: string;
  multisiteId: string;
  /** Local IP address as used by remote TWAMP probes. Counterpart of what's in id.MultisiteLink. */
  localMultisiteLinkIp: string;
  /** Primary IP address of local peer. Counterpart of bgp_peer_id. */
  localBgpPeerId: string;
}

export interface AssertConfigMultisiteExpectedMtu {
  /** Remote IP being probed by TWAMP is in the MultisiteLinkType index. Counterpart of config.local_multisite_link_ip. */
  id: PathId | undefined;
  config: AssertConfigMultisiteExpectedMtuData | undefined;
}

export interface AssertMultisiteExpectedMtu {
  /** Remote IP being probed by TWAMP is in the MultisiteLinkType index. Counterpart of config.local_multisite_link_ip. */
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigMultisiteExpectedMtuData | undefined;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
  discoveredMtu: number;
}

export interface AssertConfigNxosDeviceExpectedFeaturesData {
  generationId: string;
  latchedAt: Date | undefined;
  latchTime: string;
  implicit: boolean;
  orgId: string;
  fabricId: string;
  groupShortName: string;
  severity: AssertSeverityType;
  deviceType: AssertDeviceType;
}

export interface AssertConfigNxosDeviceExpectedFeatures {
  id: PathId | undefined;
  config: AssertConfigNxosDeviceExpectedFeaturesData | undefined;
}

export interface AssertNxosDeviceExpectedFeatures {
  id: PathId | undefined;
  category: AssertCategoryType;
  assertState: AssertStateType;
  modifiedAt: Date | undefined;
  config: AssertConfigNxosDeviceExpectedFeaturesData | undefined;
  grpcEnabled: boolean;
  lldpEnabled: boolean;
  masked: boolean;
  readyToLatchAt: Date | undefined;
  maskedByPortLinkUp: boolean;
  maskedByConnectionToCloud: boolean;
}

export interface SonicConfig {
  ipv4Addr: string;
  ipv6Addr: string;
  ipv4Gateway: string;
  ipv6Gateway: string;
  hostname: string;
}

export interface ProxyConfig {
  httpProxy: string;
  httpsProxy: string;
  noProxy: string;
  user: string;
  pass: string;
}

export interface DnsConfig {
  dnsServers: string[];
}

export interface DrakeConfig {
  cloudBaseUrlList: string[];
}

/**
 * Consolidated information about any in-progress software updates for a device, from the device's perspective.
 * This data is generally populated from ManifestRunningImageStatus reports from the device, along with using the
 * device's connectivity to the cloud to attempt to infer the rebooting phase of an upgrade.
 */
export interface SoftwareUpdateStatus {
  id:
    | PathId
    | undefined;
  /** The overall state of the software update */
  state: SoftwareUpdateState;
  /** Progress bar for the current operation or sub-operation, when applicable */
  progress: number;
  /** Populated when the device is (assumed to be) rebooting */
  deviceDisconnectedAt:
    | Date
    | undefined;
  /** The manifest fingerprint most recently reported by the device */
  manifestFp: string;
  /** Indicates that the fabric is in maintenance mode */
  inSoftwareUpdate: boolean;
  /** The configured image tag for the fabric */
  fabricTag: string;
  /** The target image tag that the fabric is to be updated to */
  fabricTargetTag: string;
  /** The current image tag running on the device */
  currentTag: string;
  /** The image tag intended to be running on the device */
  desiredTag: string;
  /** The detailed status for the running image */
  runningPartitionStatus: ManifestImagePartitionStatus;
  /** The detailed status for the standby image, when applicable */
  standbyPartitionStatus: ManifestImagePartitionStatus;
  /** The number of errors encountered since the last upgrade success */
  upgradeErrorCount: number;
  /** The most recent partition-level failure status reported */
  lastUpgradeError: ManifestImagePartitionStatus;
}

/** Software download manifest status definitions */
export interface ManifestRunningImageStatus {
  id: PathId | undefined;
  activeRunningImage: ManifestImageInfo | undefined;
  standByImage: ManifestImageInfo | undefined;
  collectedAt: Date | undefined;
  manifestFp: string;
}

export interface ManifestImageInfo {
  manifestIssued: Date | undefined;
  bootloaderSha: string;
  bootloaderActualFileName: string;
  kernelSha: string;
  kernelActualFileName: string;
  monolithSha: string;
  monolithActualFileName: string;
  agentsSha: string;
  agentsActualFileName: string;
  dockerfsSha: string;
  dockerfsActualFileName: string;
  initrdSha: string;
  initrdActualFileName: string;
  partitionName: string;
  partitionStatus: ManifestImagePartitionStatus;
  releaseTag: string;
  downloadProgress: number;
  bootloaderCfgSha: string;
  bootloaderCfgActualFileName: string;
  nexusOsSha: string;
  nexusOsActualFileName: string;
  upgradeErrorCount: number;
  lastUpgradeErrorStatus: ManifestImagePartitionStatus;
}

export interface ManifestImageState {
  id: PathId | undefined;
}

export interface ManifestPartitionFileCacheStatus {
  id: PathId | undefined;
  partitionName: string;
  file: FileCacheStatus | undefined;
  collectedAt: Date | undefined;
}

export interface FileCacheStatus {
  filename: string;
  expectedSize: string;
  actualSize: string;
  sha512224: string;
  lastChanged:
    | Date
    | undefined;
  /** when was this message generated */
  lastChecked: Date | undefined;
  status: CacheStatus;
  partitionName: string;
  packageName: string;
}

export interface StpPortState {
  id: PathId | undefined;
  portName: string;
  portFast: boolean;
  bpduGuardShutdown: boolean;
}

export interface StpVlanState {
  id: PathId | undefined;
  vlanId: number;
  bridgeId: string;
  designatedBridgeId: string;
  forwardDelay: number;
  helloTime: number;
  holdTime: number;
  lastTopologyChange: number;
  maxAge: number;
  rootBridgeId: string;
  rootForwardDelay: number;
  rootHelloTime: number;
  rootMaxAge: number;
  rootPathCost: number;
  rootPort: string;
  stpInstance: number;
  topologyChangeCount: number;
}

export interface StpVlanPortState {
  id: PathId | undefined;
  vlanId: number;
  portName: string;
  bpduReceived: number;
  bpduSent: number;
  desigBridge: string;
  desigCost: number;
  desigPort: string;
  desigRoot: string;
  fwdTransitions: number;
  pathCost: number;
  portNum: string;
  portState: StpVlanPortStateStatus;
  priority: number;
  rootGuardTimer: number;
  tcReceived: number;
  tcSent: number;
}

export interface EsiInfo {
  id: PathId | undefined;
  esi: string;
  accessPort: string;
  vniCount: number;
  macCount: number;
  dfPreference: number;
  nextHopGroup: number;
  local: boolean;
  remote: boolean;
  df: boolean;
  readyForBgp: boolean;
  bridgePort: boolean;
  operUp: boolean;
  nextHopGroupActive: boolean;
  collectedAt: Date | undefined;
}

export interface EsiVtepInfo {
  id: PathId | undefined;
  vtep: string;
  esi: string;
  dfAlgorithm: string;
  dfPreference: number;
  nextHopId: number;
  collectedAt: Date | undefined;
}

export interface ServerInterfaceInfo {
  id: PathId | undefined;
  macAddress: string;
  ifName: string;
  alias: string;
  ipv4Prefix1: string;
  ipv4Method1: IpMethodType;
  ipv4Prefix2: string;
  ipv4Method2: IpMethodType;
  vlanTagging: string;
  familyType: IpFamilyType;
  collectedAt: Date | undefined;
}

export interface ServerInterface {
  id: PathId | undefined;
}

export interface ServerMac {
  id: PathId | undefined;
}

export interface ServerL3Table {
  id: PathId | undefined;
  macAddress: string;
  ifName: string;
  ipAddress: string;
  familyType: IpFamilyType;
  status: L3Status;
  collectedAt: Date | undefined;
  alias: string;
}

export interface ServerIpRouteAddress {
  id: PathId | undefined;
}

export interface ServerIpRouteTable {
  id: PathId | undefined;
  dst: string;
  interfaceName: string;
  protocol: ProtocolType;
  scope: ServerIpRouteScope;
  prefSrc: string;
  metric: number;
  type: ServerIpRouteType;
  dstMask: number;
  collectedAt: Date | undefined;
  familyType: IpFamilyType;
  gatewayMacAddress: string;
  gateway: string;
}

export interface GpuDevice {
  id: PathId | undefined;
  description: string;
  product: string;
  vendor: string;
  busId: string;
  slot: number;
  collectedAt: Date | undefined;
}

export interface ServerInterfaceMapping {
  id: PathId | undefined;
  nativeInterfaceName: string;
  interfaceAlias: string;
  pciBusId: string;
  serverType: ServerType;
  serverProductName: string;
  collectedAt: Date | undefined;
  slot: number;
}

/** From BMC */
export interface ServerPsu {
  /** The unique identifier of the PSU. */
  id:
    | PathId
    | undefined;
  /** The power usage of the PSU. */
  watts: number;
  /**
   * Not available with the Psu
   *
   * @deprecated
   */
  fanSpeed: number;
  /** The operational status of the PSU. */
  status: EnvStatus;
  /** The name of the PSU. */
  name: string;
  /** The model name of the PSU. */
  model: string;
  /** The serial number of the PSU. */
  serial: string;
  /** Current of the PSU in Amps */
  current: number;
  currentHighCriticalThreshold: number;
  /** Voltage of the PSU in Volts */
  voltage: number;
  voltageHighCriticalThreshold: number;
  /** The PID of the PSU. */
  pid: string;
}

/**
 * Switch Device Id / Server Host Device Id -> path to BMC information
 * Sextant then creates ServerToBmc from this message to enable UI to do Server Host Device Id -> BMC path.
 */
export interface BmcServer {
  id: PathId | undefined;
  bmcId: PathId | undefined;
}

/** Server Host Device Id -> BMC path */
export interface ServerToBmc {
  id: PathId | undefined;
  bmcId: PathId | undefined;
}

/**
 * A switch reports PSU information from multiple BMCs (servers) using this,
 * which then gets mapped in TBD service to a per server TL of ServerPsu.
 */
export interface BmcServerPsu {
  id: PathId | undefined;
  serverPsu: ServerPsu | undefined;
}

/** From BMC */
export interface ServerTempSensor {
  id: PathId | undefined;
  degCelsius: number;
  highThreshold: number;
  lowThreshold: number;
  highCriticalThreshold: number;
  lowCriticalThreshold: number;
  category: TemperatureSensorCategory;
}

/** Similar for TempSensor */
export interface BmcServerTempSensor {
  id: PathId | undefined;
  serverTempSensor: ServerTempSensor | undefined;
}

/**
 * ServerBmcMinimalHardwareInfo
 * On BMC's with Redfish this information is available pre-authorization from the resource Service Root /redfish/v1
 */
export interface ServerBmcPreAuthInfo {
  id: string;
  vendor: string;
  product: string;
}

export interface ServerFirmwareInventoryItem {
  name: string;
  description: string;
  manufacturer: string;
  version: string;
}

export interface ServerIpv4Address {
  ipPrefix: string;
  gateway: string;
  addressOrigin: string;
}

export interface ServerIPv6Address {
  ipPrefix: string;
  addressOrigin: string;
}

export interface ServerEthernetInterface {
  id: string;
  name: string;
  description: string;
  macAddress: string;
  ipv4Addresses: ServerIpv4Address[];
  ipv6Addresses: ServerIPv6Address[];
  nameServers: string[];
  speedMbps: number;
  mtu: number;
}

export interface ServerPcieInterface {
  maxLanes: number;
  lanesInUse: number;
  pcieType: string;
}

/** ServerPcieDevice is populated from this resource of the Redfish data model from Chassis/<chassis>/PCIeDevices/<device>/index.json */
export interface ServerPcieDevice {
  id: string;
  /** -> Slot/Location/PartLocation/LocationOrdinalValue */
  slotNumber: number;
  /** Exceeds 32 bytes :( */
  name: string;
  partNumber: string;
  firmwareVersion: string;
  manufacturer: string;
  sku: string;
  serialNumber: string;
  model: string;
  pcieInterface: ServerPcieInterface | undefined;
}

export interface ServerPCIeFunction {
  id: string;
  name: string;
  vendorId: string;
  deviceId: string;
  deviceName: string;
  ethernetInterfaceIds: string[];
}

export interface ServerStorageController {
  id: string;
  manufacturer: string;
  model: string;
  serialNumber: string;
  firmwareVersion: string;
}

export interface ServerStorage {
  id: string;
  name: string;
  description: string;
  controllers: ServerStorageController[];
}

export interface ServerDrive {
  id: string;
  name: string;
  description: string;
  manufacturer: string;
  model: string;
  mediaType: string;
  blockSizeBytes: number;
  capacityBytes: string;
  revision: string;
  serialNumber: string;
}

export interface ServerTemperature {
  name: string;
  sensorNumber: number;
  memberId: string;
  physicalContext: string;
  readingCelsius: number;
  lowerThresholdCritical: number;
  lowerThresholdNonCritical: number;
  upperThresholdCritical: number;
  upperThresholdNonCritical: number;
  minReadingRangeTemp: number;
  maxReadingRangeTemp: number;
}

export interface ServerThermal {
  temperatures: ServerTemperature[];
}

export interface ServerManager {
  id: string;
  name: string;
  managerType: string;
  ethernetInterfaces: ServerEthernetInterface[];
  certificates: ServerCertificate[];
}

export interface ServerCertificateIssuerOrSubject {
  commonName: string;
  organization: string;
  organizationUnit: string;
  city: string;
  state: string;
  country: string;
}

export interface ServerCertificate {
  id: string;
  name: string;
  description: string;
  /** This is big, not going to uplift this for now unless there is a need */
  certString: string;
  certType: string;
  validNotBefore: string;
  validNotAfter: string;
  issuer: ServerCertificateIssuerOrSubject | undefined;
  subject: ServerCertificateIssuerOrSubject | undefined;
  serialNumber: string;
}

export interface ManagedEndpointServerInfo {
  manufacturer: string;
  product: string;
  version: string;
  serialNum: string;
  uuid: string;
  sku: string;
  family: string;
  /** Populated for DPU BMC and DPU, but not from a Server BMC */
  pcieSlot: number;
  /** Populated for DPU BMC and DPU, but not from a Server BMC */
  pcieBus: number;
  /** Populated for DPU BMC and DPU, but not from a Server BMC */
  pcieFunction: number;
}

/** Cannot include time, as we hash on this to determine change */
export interface ManagedEndpointLldpInfo {
  /** LldpRemChassisId -> MAC Address */
  macAddress: string;
  /** lldpSysName */
  sysName: string;
  /** lldpSysDesc */
  sysDesc: string;
  /** LocalPort */
  localInterface: string;
  /** lldpRemManAddr -> We expect a IPv6 LLA here, and possibly on IPv4 address with optionally more IPv6 addresses */
  mgmtAddrs: string[];
  serverInfo: ManagedEndpointServerInfo | undefined;
}

export interface ServerSystem {
  id: string;
  name: string;
  manufacturer: string;
  model: string;
  serialNum: string;
  uuid: string;
  hostName: string;
  powerState: PowerStateEnum;
}

export interface ManagedEndpointOtherState {
  state: ManagedEndpointOtherStateEnum;
  description: string;
}

export interface ManagedEndpoint {
  /** Information available in LLDP */
  lldpInfo: ManagedEndpointLldpInfo | undefined;
  lastLldpReceivedAt:
    | Date
    | undefined;
  /** Last time we successfully connected to Managed Endpoint */
  lastConnectedAt: Date | undefined;
  connectivityStatus: ConnectivityStatus;
  connectionReason: string;
  meType: ManagedEndpointType;
  spdmSupported: boolean;
  otherStates: ManagedEndpointOtherState[];
}

/**
 * Information about server networking ports accessible from the BMC.
 * This is a subset of information available from the Redfish model on network adaptors and interfaces.
 * The purpose of this information is to provide enough information to the Cloud to be able to
 * diagnose when the server host Drake is not reachable from the leaf switch.
 * This could be due to many reasons:
 *  - Tortuga agent package has not been installed on the server host
 *  - Tortuga agent package is installed but docker has crashed
 *  - Tortuga agents in container are running but there is an issue with Drake
 */
export interface ServerPortInfo {
  id:
    | PathId
    | undefined;
  /** Mapping of adaptor_id + port_id to normalized interface name */
  name: string;
  /** redfish.NetworkPort.AssociatedNetworkAddresses[0] */
  mac: string;
  /** redfish.NetworkPort.Status */
  adminState: AdminState;
  /** redfish.NetworkPort.LinkStatus */
  operState: OperState;
  /** redfish.NetworkPort.ID */
  adaptorId: string;
  /** redfish.NetworkAdaptor.ID */
  rfPortName: string;
  /** The OS native interface id */
  osNativeIfName: string;
}

/** Similar for PortInfo */
export interface BmcServerPortInfo {
  id: PathId | undefined;
  serverPortInfo: ServerPortInfo | undefined;
}

/** Discovered BMCs */
export interface Bmc {
  id: PathId | undefined;
  managedEndpoint: ManagedEndpoint | undefined;
  state: BmcStateType;
  /** Information below is available pre-authentication via a non-authenticated query to /redfish/v1/ */
  preAuthInfo: ServerBmcPreAuthInfo | undefined;
  bmcProduct: BmcProductType;
  /**
   * Information below is available Post authentication - the actual parts of the extensive BMC model we utilize will be adjusted based on requirements.
   * Query is done to get all firmware inventory items.
   */
  firmwareInventory: ServerFirmwareInventoryItem[];
  serverSystem: ServerSystem | undefined;
  bmcManager:
    | ServerManager
    | undefined;
  /** Only available after BMC authentication, and query of Ethernet Interface info */
  serverDeviceId: string;
}

/** From BMC */
export interface ServerFan {
  /** The unique identifier of the Fan. */
  id:
    | PathId
    | undefined;
  /**
   * Internal fan id.
   *
   * @deprecated
   */
  fanId: number;
  /** The Fan speed as rpm. */
  speed: number;
  /** The name of the Fan. */
  name: string;
  /** The operational status of the Fan. */
  status: EnvStatus;
  /** @deprecated */
  position: ServerFanPosition;
  /** @deprecated */
  highThreshold: number;
  /** @deprecated */
  lowThreshold: number;
  /** @deprecated */
  highCriticalThreshold: number;
  lowCriticalThreshold: number;
  /** The time the data was last collected in. */
  collectedAt: Date | undefined;
}

/** Similar for ServerFan */
export interface BmcServerFan {
  id: PathId | undefined;
  serverFan: ServerFan | undefined;
}

/**
 * BearerToken describes the metadata for a bearer token used during a REST API call.
 * Bearer tokens are scoped to a user within a tenant.
 */
export interface BearerToken {
  id:
    | PathId
    | undefined;
  /** The orgId that owns the tenant that owns the token. */
  orgId: string;
  /** The tenant that owns the token. */
  tenantId: string;
  /** The token owner. */
  email: string;
  /** The token owner provider. */
  provider: KnownProvider;
  /** The token owner role. */
  userRole: UserRole;
  /** The unique id for the token. This is embedded in the token JWT as the JTI claim. */
  tokenId: string;
  /** The fingerprint of the token. */
  fingerprint: string;
  /** The start of the validity period for a token. */
  notBefore:
    | Date
    | undefined;
  /** The end of the validity period for a token. */
  expires:
    | Date
    | undefined;
  /** The hardcoded scope of the token, read-write, admin etc. */
  scope: TokenScope;
  /** An ed25519 public key used to verify the token. The private key is owned by Brig. */
  signingPublicKey: string;
  /** The fingerprint of the signing public key. */
  signingPublicKeyFp: string;
  /** Set of permissions for the token restricting what it can be used for. */
  permissionOnboardDevice: boolean;
  permissionTest: boolean;
  permissionMcp: boolean;
}

/**
 * ApiKey describes the metadata for an API key used during a REST API call.
 * API keys are scoped to a user within a tenant.
 */
export interface ApiKey {
  id:
    | PathId
    | undefined;
  /** The orgId that owns the tenant that owns the key. */
  orgId: string;
  /** The tenant that owns the key. */
  tenantId: string;
  /** The key owner. */
  email: string;
  /** The key owner provider. */
  provider: KnownProvider;
  /** The key owner role. */
  userRole: UserRole;
  /** The unique id for the key. This is provided in the Authorization header in the request. */
  keyId: string;
  /** The fingerprint of the key. */
  fingerprint: string;
  /** The start of the validity period for a key. */
  notBefore:
    | Date
    | undefined;
  /** The end of the validity period for a key. */
  notAfter:
    | Date
    | undefined;
  /** The hardcoded scope of the key, read-write, admin etc. */
  scope: TokenScope;
  /** The key type. */
  keyType: RestKeyType;
  /**
   * The ed25519/RSA public key, provided by the user. The private key is not known to us.
   *
   * FIXME
   * Right now this is fixed at 64 which is enough for a hex encoded ed25519 public key.
   * RSA public keys are much larger, but whether we support RSA at all is still TBD.
   */
  publicKey: string;
}

/** Node anchors the blueprint config that configd sends to sextant to configure smarthands task for a blueprint slot */
export interface Node {
  id: PathId | undefined;
  deviceId: string;
  serialNumber: string;
  /** 1-based index of the slot. E.g. 1 for Leaf1, 2 for Leaf2, 2 for Spine2 */
  position: number;
  role: NodeRole;
  model: string;
  orgId: string;
  name: string;
  tags: string[];
  connectedToCloud: boolean;
  groupId: string;
  groupName: string;
  overallGroupPosition: number;
  groupShortName: string;
}

/** NodeLineCard is a linecard in a blueprint slot. 1-based. */
export interface NodeLineCard {
  id: PathId | undefined;
}

/** NodePort is a port in a blueprint slot. 1-based. */
export interface NodePort {
  id: PathId | undefined;
}

/** NodeBreakout is a breakout in a blueprint slot. If there is no breakout the breakout index is 0, otherwise it is 1-based. */
export interface NodeBreakout {
  id:
    | PathId
    | undefined;
  /** The port that this port should be cabled to */
  requiredToPort: SmartHandsPort | undefined;
  requiredOpticPid: string;
  interfaceName: string;
  requiredRemoteOpticPid: string;
  portRole: PortRole;
  usedInCablingPlan: boolean;
  /** True if this port is the destination end of the connection per connectivity rule order */
  isCablingDest: boolean;
}

/** SmartHandsPort represents a port on a device using the usual 0-based indexing scheme for linecard, port and breakout */
export interface SmartHandsPort {
  deviceId: string;
  interfaceName: string;
  /** 0-based index of the linecard */
  linecard: number;
  /** 0-based index of the port */
  port: number;
  /** 0 for no breakout, otherwise 0-based index of the breakout */
  breakout: number;
  nodeId: string;
  role: NodeRole;
  /** 1-based index of the slot. E.g. 1 for Leaf1, 2 for Leaf2, 2 for Spine2 */
  position: number;
  groupName: string;
}

/** SmartHandsCommonTask contains data common to all tasks */
export interface SmartHandsCommonTask {
  role: NodeRole;
  deviceId: string;
  nodeId: string;
  serialNumber: string;
  /** Short text hint to help if the observed state is not yet correct */
  hint: string;
  /** 1-based index of the slot. E.g. 1 for Leaf1, 2 for Leaf2, 2 for Spine2 */
  position: number;
  /** The sensible global task order */
  order: number;
  /** true if every required subtask has been completed */
  completed: SmartHandsCompletionStatus;
  /** The lexicographic task order within a single category */
  naturalOrder: string;
  /** The worker who this task is assigned to */
  worker: string;
  /** True if the device is connected to the cloud */
  connectedToCloud: boolean;
  groupName: string;
  /** 1-based index of the overall group position */
  groupPosition: number;
  groupId: string;
  /** The total number of tasks */
  totalTasks: number;
}

export interface SmartHandsPsu {
  /** true if this PSU is required for this device model */
  required: boolean;
  /** true if correct PSU PID is detected. The PID must be a compatible PID for this device model. */
  correctPid: SmartHandsCompletionStatus;
  foundPid: string;
  /** true if power is > 0 */
  poweredOn: SmartHandsCompletionStatus;
  requiredPid: string;
}

export interface SmartHandsFanTray {
  /** true if this fan tray is required for this device model */
  required: boolean;
  /** true if correct fan PID is detected. The PID must be a compatible PID for this device model and match the direction of the PSU fan. */
  correctPid: SmartHandsCompletionStatus;
  foundPid: string;
  /** true if fan speed is > 0 */
  running: SmartHandsCompletionStatus;
  requiredPid: string;
}

/**
 * UnpackAndAssembleTask is a task to unpack and assemble a device
 * This task is not initially monitored, we tell the user what they would check to know they did it right
 * Once the device has been claimed and bound we will update the status for fans and PSUs with the observed state
 */
export interface UnpackAndAssembleTask {
  id: PathId | undefined;
  common: SmartHandsCommonTask | undefined;
  psu1: SmartHandsPsu | undefined;
  psu2: SmartHandsPsu | undefined;
  fanTray1: SmartHandsFanTray | undefined;
  fanTray2: SmartHandsFanTray | undefined;
  fanTray3: SmartHandsFanTray | undefined;
  fanTray4: SmartHandsFanTray | undefined;
  fanTray5: SmartHandsFanTray | undefined;
  fanTray6: SmartHandsFanTray | undefined;
  connectManagementPort: boolean;
  /** True if management port link state is up */
  managementPortUp: SmartHandsCompletionStatus;
}

/**
 * ClaimAndBindTask is a task to claim the device and bind to a fabric
 * This task is monitored, we will check the device is claimed and bound by checking the state held for this device
 */
export interface ClaimAndBindTask {
  id: PathId | undefined;
  common: SmartHandsCommonTask | undefined;
  bound: SmartHandsCompletionStatus;
  connectedToCloud: SmartHandsCompletionStatus;
}

/**
 * PortSetupTask is a task to setup and connect a port to the network
 * This task is monitored, we will check the port is correctly setup by checking the state held for this device
 */
export interface PortSetupTask {
  id: PathId | undefined;
  common: SmartHandsCommonTask | undefined;
  requiredPid: string;
  correctPid: SmartHandsCompletionStatus;
  fromPort: SmartHandsPort | undefined;
}

/**
 * FabricConnectionTask is a task to connect two fabric ports
 * This task is monitored, we will check the ports are correctly connected by checking the state held for this device
 */
export interface FabricConnectionTask {
  id: PathId | undefined;
  common: SmartHandsCommonTask | undefined;
  requiredToPort: SmartHandsPort | undefined;
  foundToPort:
    | SmartHandsPort
    | undefined;
  /** True if the port is connected to the required_to_port */
  portConnected: SmartHandsCompletionStatus;
  fromPort: SmartHandsPort | undefined;
  fromPortState: OperState;
  toPortState: OperState;
  requiredFromPid: string;
  correctFromPid: SmartHandsCompletionStatus;
  requiredToPid: string;
  correctToPid: SmartHandsCompletionStatus;
}

/** NegativeConnectionTask is a task that indicates a connection needs to be removed/corrected */
export interface NegativeConnectionTask {
  id: PathId | undefined;
  common: SmartHandsCommonTask | undefined;
  foundToPort: SmartHandsPort | undefined;
  foundOpticPid: string;
  fromPort: SmartHandsPort | undefined;
}

/**
 * ActiveWorker is a record indicating a single worker who is currently assigned to work on setting up the fabric.
 * This is a set of unique values found in SmartHandsCommonTask.Worker for all tasks for this fabric.
 */
export interface ActiveWorker {
  id: PathId | undefined;
}

export interface TenantMetadata {
  id: PathId | undefined;
  orgName: string;
  tenantName: string;
  enabled: boolean;
  orgId: string;
  createdBy: string;
  orgKind: OrgKind;
  cellPairUuid: string;
  cuiTenantId: string;
}

export interface BulkUpliftJobRequest {
  id: PathId | undefined;
  jobType: BulkUpliftJobType;
  /** Sub directory in s3 where the data for this job will be stored */
  directory: string;
  /** File name in s3 where the data for this job will be stored */
  fileName: string;
  /** True if this job is customer visible in the main UI, false if only available to cisco support users */
  external: boolean;
  /** This job may not start until the job with this id has completed */
  dependsOn:
    | PathId
    | undefined;
  /** The interval in seconds for polling type jobs like "Prometheus Metrics" */
  pullInterval: number;
}

export interface BulkUpliftJobStatus {
  id: PathId | undefined;
  status: BulkUpliftStatus;
  /** In various scenarios the client will drop data and must update this field to indicate how much was dropped */
  bytesDropped: string;
  /** Total bytes uploaded to the backend for this job. Client does not need to set this, automatically set by the backend */
  bytesUploaded: string;
}

export interface RefPoint {
  id: PathId | undefined;
  orgId: string;
  name: string;
  created: Date | undefined;
  deviceIds: string[];
  createJobState: RefPointJobState;
  createCompleted: Date | undefined;
  diffJobState: RefPointJobState;
  diffAgainstTime: Date | undefined;
}

export interface RefPointStatus {
  id: PathId | undefined;
  jobType: RefPointJobType;
  jobState: RefPointJobState;
  completedAt: Date | undefined;
}

export interface UserPreferenceItem {
  id: PathId | undefined;
  provider: string;
  timezone: string;
  theme: Theme;
  skipVideoTour: boolean;
  skipFeatureHighlights: boolean;
  timeFormat: TimeFormat;
}

export interface UserEula {
  id: PathId | undefined;
  provider: string;
  version: string;
}

export interface BrigSymmetricSigningKey {
  id: PathId | undefined;
  keyId: number;
  keyValue: string;
  createdAt: Date | undefined;
}

/**
 * LoadBalancedSvcRoute is used to route to an application in a specific cell without a resource (i.e. any brig or any configd)
 * object: <cellId>, index: <appNum>
 */
export interface LoadBalancedSvcRoute {
  id: PathId | undefined;
  updatedTs: Date | undefined;
  host: HostPort | undefined;
}

/**
 * AssignmentSvcRoute is used to route to a service assigned a specific resource (i.e. the configd for a specified fabric)
 * object: <cellId>, index: <appNum> . <resourceId>
 */
export interface AssignmentSvcRoute {
  id: PathId | undefined;
  ready: boolean;
  /** only set for fabric assignments */
  orgId: string;
  /** technically non-meaningful, but used for tracking updates, best efforts made to only increment when needed */
  revision: number;
  updatedTs: Date | undefined;
  host: HostPort | undefined;
}

export interface DbTableUpdateNotification {
  id: PathId | undefined;
  instanceName: string;
  dbTable: DbTableEnum;
  tableUpdatedAt: Date | undefined;
  createdAt: Date | undefined;
}

/**
 * IpRouteJoinedView presents an aggregated view of the VRF table by combining data from a range of data sources,
 * such as IpRouteTable, IpNextHop, L3Table, NodeConfig.
 * TODO: rearrange the field order to optimize the alignments
 */
export interface IpRouteJoinedView {
  id: PathId | undefined;
  prefix: string;
  prefixLen: number;
  vrfId: number;
  vrfName: string;
  distance: number;
  metric: number;
  internalNextHopNum: number;
  internalNextHopActiveNum: number;
  ipFamily: IpFamilyType;
  protocol: ProtocolType;
  multipleDiffNextHops: boolean;
  directlyConnected: boolean;
  nexthopIp: string;
  interfaceName: string;
  active: boolean;
  onLink: boolean;
  weight: number;
  recursive: boolean;
  blackhole: boolean;
  macAddress: string;
  vlan: number;
  vni: number;
  internal: boolean;
  nexthopLocation: string;
  /** BGP Route Info Details */
  bgpOrigin: BgpRouteOriginType;
  bgpPeerId: string;
  bgpPeerAsnPath: string;
  bgpPathFrom: BgpPathSource;
  bgpSelectionReason: BgpPathSelectionReason;
  bgpWeight: number;
  bgpMed: number;
  bgpNhIp: string;
  bgpNhName: string;
  fabricLocation: RemoteEntryLocation;
  remoteFabricId: string;
}

export interface PluggableConnectionInfo {
  id: PathId | undefined;
  interfaceName: string;
  expectedPid: string;
  expectedRemoteDeviceId: string;
  expectedRemoteDeviceName: string;
  expectedRemoteInterfaceName: string;
  discoveredPid: string;
  discoveredRemoteDeviceId: string;
  discoveredRemoteDeviceName: string;
  discoveredRemoteInterfaceName: string;
}

export interface IpRouteJoinedViewCountSpace {
  id: PathId | undefined;
}

export interface IpRouteJoinedViewCount {
  id: PathId | undefined;
  vrfId: number;
  vrfName: string;
  entryCount: number;
  ipFamily: IpFamilyType;
  staticRoutesCount: number;
}

export interface IpRouteFabricJoinedViewCountSpace {
  id: PathId | undefined;
}

export interface IpRouteFabricJoinedViewCount {
  id: PathId | undefined;
  vrfId: number;
  vrfName: string;
  entryCount: number;
  ipFamily: IpFamilyType;
  staticRoutesCount: number;
}

export interface SigningKeyFlavor {
  id: PathId | undefined;
}

export interface SigningKey {
  id: PathId | undefined;
  clusterId: string;
  signingKeyType: SigningKeyEnum;
  keyCreatedAt: Date | undefined;
  publicKey: string;
}

/** StaticRoute represents configured static routes, both active and inactive */
export interface StaticRoute {
  id: PathId | undefined;
  nextHop: string;
  nextHopVrf: string;
  probeId: string;
  distance: number;
  isActive: boolean;
  blackhole: boolean;
}

/** IP SLA Probe represents SONiC APM telemetry */
export interface IpSlaProbe {
  id: PathId | undefined;
  probeId: string;
  type: IpSlaProbeConnectionType;
  operationalState: IpSlaProbeOpStateType;
  srcIp: string;
  srcIntf: string;
  vrf: string;
  dstIp: string;
  affectedRoutePrefix: string;
  affectedNexthop: string;
  frequency: number;
  timeout: number;
  multiplier: number;
  tos: number;
  ttl: number;
  dstPort: number;
  srcPort: number;
  pktSize: number;
  pktCount: number;
  successCount: number;
  failureCount: number;
  totalOperations: number;
  consecutiveFailures: number;
  latestRttMs: number;
  minRttMs: number;
  maxRttMs: number;
  avgRttMs: number;
  enabled: boolean;
  routeCurrentlyWithdrawn: boolean;
  lastSuccessTime: Date | undefined;
  lastFailureTime: Date | undefined;
  lastRouteWithdrawal: Date | undefined;
  lastRouteInstallation: Date | undefined;
  collectedAt: Date | undefined;
}

export interface Interconnect {
  id: PathId | undefined;
}

export interface InterconnectTransaction {
  id: PathId | undefined;
  orgId: string;
  committed: boolean;
}

/**
 * SpanSession represents SPAN/ERSPAN/mirror session telemetry for a device
 * This provides per-session bandwidth and status monitoring
 */
export interface SpanSession {
  id: PathId | undefined;
  status: SpanSessionStatus;
  rxBandwidth: number;
  txBandwidth: number;
  rxBytes: string;
  txBytes: string;
  rxPackets: string;
  txPackets: string;
  collectedAt: Date | undefined;
}

/**
 * ArsConfig represents Adaptive Routing and Signaling configuration for a device
 * This is sourced from SONiC CONFIG_DB ARS table
 */
export interface ArsConfig {
  id: PathId | undefined;
  enableAllPackets: boolean;
  mode: ArsMode;
  collectedAt: Date | undefined;
}

export interface ArsPortInfo {
  id: PathId | undefined;
  enabled: boolean;
  collectedAt: Date | undefined;
}

export interface BgpRouteStats {
  id: PathId | undefined;
  evpnType2RouteCount: number;
  collectedAt: Date | undefined;
  evpnType2PathCount: number;
}

export interface CommandRequest {
  id:
    | PathId
    | undefined;
  /** command to run */
  command: string;
  captureStream: CommandOutputStream;
  /** Expiry timestamp */
  expiry: Date | undefined;
  status: CommandStatus;
}

export interface CommandOutput {
  id: PathId | undefined;
  status: CommandStatus;
  exitCode: number;
  error: string;
  collectedAt: Date | undefined;
  startedAt: Date | undefined;
  endedAt: Date | undefined;
  totalRecords: number;
}

export interface CommandOutputRecord {
  id: PathId | undefined;
  output: string;
  captureStream: CommandOutputStream;
  collectedAt: Date | undefined;
}

/** ImageManifestInfo contains the device image manifest metadata */
export interface ImageManifestInfo {
  id: PathId | undefined;
  manifestFp: string;
  targetTag: string;
  runningTag: string;
  nodeTag: string;
  /** flag to indicate the device is in software update process */
  inSwUpdate: boolean;
  issuedAt: Date | undefined;
  agentVersion: string;
}

export interface OpticsFirmwareUpdate {
  id: PathId | undefined;
  pid: string;
  currentVersion: string;
  targetVersion: string;
  status: OpticsFirmwareUpdateStatus;
  collectedAt: Date | undefined;
}

export interface VxlanRemoteVtepInfo {
  id: PathId | undefined;
  srcIp: string;
  dstIp: string;
  tunnelSrc: VxlanTunnelSrcType;
  operStatus: OperState;
  collectedAt: Date | undefined;
}

export interface ArsInfo {
  id: PathId | undefined;
  sliceIndex: number;
  agingTimeUsec: string;
  incomingDlbPktCount: string;
  activeFlowsCount: string;
  maxFlowsSeen: string;
  agedFlowsCount: string;
  flowletPathChanges: string;
  droppedPktCount: string;
  loadAwareness: boolean;
  disableAging: boolean;
  decayFactor: number;
  collectedAt: Date | undefined;
}

function createBaseTestSubMessage(): TestSubMessage {
  return { subInt32: 0, subRepeatedString: [] };
}

export const TestSubMessage: MessageFns<TestSubMessage> = {
  encode(message: TestSubMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.subInt32 !== 0) {
      writer.uint32(8).int32(message.subInt32);
    }
    for (const v of message.subRepeatedString) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestSubMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestSubMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.subInt32 = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.subRepeatedString.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestSubMessage {
    return {
      subInt32: isSet(object.subInt32) ? globalThis.Number(object.subInt32) : 0,
      subRepeatedString: globalThis.Array.isArray(object?.subRepeatedString)
        ? object.subRepeatedString.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: TestSubMessage): unknown {
    const obj: any = {};
    if (message.subInt32 !== 0) {
      obj.subInt32 = Math.round(message.subInt32);
    }
    if (message.subRepeatedString?.length) {
      obj.subRepeatedString = message.subRepeatedString;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestSubMessage>, I>>(base?: I): TestSubMessage {
    return TestSubMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestSubMessage>, I>>(object: I): TestSubMessage {
    const message = createBaseTestSubMessage();
    message.subInt32 = object.subInt32 ?? 0;
    message.subRepeatedString = object.subRepeatedString?.map((e) => e) || [];
    return message;
  },
};

function createBaseTestRootOne(): TestRootOne {
  return {
    id: undefined,
    rootBool: false,
    rootEnum: 0,
    rootInt32: 0,
    rootSint32: 0,
    rootSfixed32: 0,
    rootUint32: 0,
    rootInt64: "0",
    rootSint64: "0",
    rootSfixed64: "0",
    rootFloat: 0,
    rootDouble: 0,
    rootString: "",
    rootBytes: new Uint8Array(0),
    rootTimestamp: undefined,
    rootMacaddress: "",
    rstr: [],
    rint32: [],
    subMessage: [],
    rootIpaddress: "",
    rootIpprefix: "",
    rootRepeatedMac: [],
    rootMemo: "",
  };
}

export const TestRootOne: MessageFns<TestRootOne> = {
  encode(message: TestRootOne, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.rootBool !== false) {
      writer.uint32(16).bool(message.rootBool);
    }
    if (message.rootEnum !== 0) {
      writer.uint32(24).int32(message.rootEnum);
    }
    if (message.rootInt32 !== 0) {
      writer.uint32(32).int32(message.rootInt32);
    }
    if (message.rootSint32 !== 0) {
      writer.uint32(40).sint32(message.rootSint32);
    }
    if (message.rootSfixed32 !== 0) {
      writer.uint32(53).sfixed32(message.rootSfixed32);
    }
    if (message.rootUint32 !== 0) {
      writer.uint32(56).uint32(message.rootUint32);
    }
    if (message.rootInt64 !== "0") {
      writer.uint32(64).int64(message.rootInt64);
    }
    if (message.rootSint64 !== "0") {
      writer.uint32(72).sint64(message.rootSint64);
    }
    if (message.rootSfixed64 !== "0") {
      writer.uint32(81).sfixed64(message.rootSfixed64);
    }
    if (message.rootFloat !== 0) {
      writer.uint32(93).float(message.rootFloat);
    }
    if (message.rootDouble !== 0) {
      writer.uint32(97).double(message.rootDouble);
    }
    if (message.rootString !== "") {
      writer.uint32(106).string(message.rootString);
    }
    if (message.rootBytes.length !== 0) {
      writer.uint32(114).bytes(message.rootBytes);
    }
    if (message.rootTimestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.rootTimestamp), writer.uint32(122).fork()).join();
    }
    if (message.rootMacaddress !== "") {
      writer.uint32(130).string(message.rootMacaddress);
    }
    for (const v of message.rstr) {
      writer.uint32(138).string(v!);
    }
    writer.uint32(146).fork();
    for (const v of message.rint32) {
      writer.int32(v);
    }
    writer.join();
    for (const v of message.subMessage) {
      TestSubMessage.encode(v!, writer.uint32(154).fork()).join();
    }
    if (message.rootIpaddress !== "") {
      writer.uint32(162).string(message.rootIpaddress);
    }
    if (message.rootIpprefix !== "") {
      writer.uint32(170).string(message.rootIpprefix);
    }
    for (const v of message.rootRepeatedMac) {
      writer.uint32(178).string(v!);
    }
    if (message.rootMemo !== "") {
      writer.uint32(186).string(message.rootMemo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestRootOne {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestRootOne();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.rootBool = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.rootEnum = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.rootInt32 = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.rootSint32 = reader.sint32();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.rootSfixed32 = reader.sfixed32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.rootUint32 = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.rootInt64 = reader.int64().toString();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.rootSint64 = reader.sint64().toString();
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.rootSfixed64 = reader.sfixed64().toString();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.rootFloat = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 97) {
            break;
          }

          message.rootDouble = reader.double();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.rootString = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.rootBytes = reader.bytes();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.rootTimestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.rootMacaddress = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.rstr.push(reader.string());
          continue;
        }
        case 18: {
          if (tag === 144) {
            message.rint32.push(reader.int32());

            continue;
          }

          if (tag === 146) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.rint32.push(reader.int32());
            }

            continue;
          }

          break;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.subMessage.push(TestSubMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.rootIpaddress = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.rootIpprefix = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.rootRepeatedMac.push(reader.string());
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.rootMemo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestRootOne {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      rootBool: isSet(object.rootBool) ? globalThis.Boolean(object.rootBool) : false,
      rootEnum: isSet(object.rootEnum) ? testEnumFromJSON(object.rootEnum) : 0,
      rootInt32: isSet(object.rootInt32) ? globalThis.Number(object.rootInt32) : 0,
      rootSint32: isSet(object.rootSint32) ? globalThis.Number(object.rootSint32) : 0,
      rootSfixed32: isSet(object.rootSfixed32) ? globalThis.Number(object.rootSfixed32) : 0,
      rootUint32: isSet(object.rootUint32) ? globalThis.Number(object.rootUint32) : 0,
      rootInt64: isSet(object.rootInt64) ? globalThis.String(object.rootInt64) : "0",
      rootSint64: isSet(object.rootSint64) ? globalThis.String(object.rootSint64) : "0",
      rootSfixed64: isSet(object.rootSfixed64) ? globalThis.String(object.rootSfixed64) : "0",
      rootFloat: isSet(object.rootFloat) ? globalThis.Number(object.rootFloat) : 0,
      rootDouble: isSet(object.rootDouble) ? globalThis.Number(object.rootDouble) : 0,
      rootString: isSet(object.rootString) ? globalThis.String(object.rootString) : "",
      rootBytes: isSet(object.rootBytes) ? bytesFromBase64(object.rootBytes) : new Uint8Array(0),
      rootTimestamp: isSet(object.rootTimestamp) ? fromJsonTimestamp(object.rootTimestamp) : undefined,
      rootMacaddress: isSet(object.rootMacaddress) ? globalThis.String(object.rootMacaddress) : "",
      rstr: globalThis.Array.isArray(object?.rstr) ? object.rstr.map((e: any) => globalThis.String(e)) : [],
      rint32: globalThis.Array.isArray(object?.rint32) ? object.rint32.map((e: any) => globalThis.Number(e)) : [],
      subMessage: globalThis.Array.isArray(object?.subMessage)
        ? object.subMessage.map((e: any) => TestSubMessage.fromJSON(e))
        : [],
      rootIpaddress: isSet(object.rootIpaddress) ? globalThis.String(object.rootIpaddress) : "",
      rootIpprefix: isSet(object.rootIpprefix) ? globalThis.String(object.rootIpprefix) : "",
      rootRepeatedMac: globalThis.Array.isArray(object?.rootRepeatedMac)
        ? object.rootRepeatedMac.map((e: any) => globalThis.String(e))
        : [],
      rootMemo: isSet(object.rootMemo) ? globalThis.String(object.rootMemo) : "",
    };
  },

  toJSON(message: TestRootOne): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.rootBool !== false) {
      obj.rootBool = message.rootBool;
    }
    if (message.rootEnum !== 0) {
      obj.rootEnum = testEnumToJSON(message.rootEnum);
    }
    if (message.rootInt32 !== 0) {
      obj.rootInt32 = Math.round(message.rootInt32);
    }
    if (message.rootSint32 !== 0) {
      obj.rootSint32 = Math.round(message.rootSint32);
    }
    if (message.rootSfixed32 !== 0) {
      obj.rootSfixed32 = Math.round(message.rootSfixed32);
    }
    if (message.rootUint32 !== 0) {
      obj.rootUint32 = Math.round(message.rootUint32);
    }
    if (message.rootInt64 !== "0") {
      obj.rootInt64 = message.rootInt64;
    }
    if (message.rootSint64 !== "0") {
      obj.rootSint64 = message.rootSint64;
    }
    if (message.rootSfixed64 !== "0") {
      obj.rootSfixed64 = message.rootSfixed64;
    }
    if (message.rootFloat !== 0) {
      obj.rootFloat = message.rootFloat;
    }
    if (message.rootDouble !== 0) {
      obj.rootDouble = message.rootDouble;
    }
    if (message.rootString !== "") {
      obj.rootString = message.rootString;
    }
    if (message.rootBytes.length !== 0) {
      obj.rootBytes = base64FromBytes(message.rootBytes);
    }
    if (message.rootTimestamp !== undefined) {
      obj.rootTimestamp = message.rootTimestamp.toISOString();
    }
    if (message.rootMacaddress !== "") {
      obj.rootMacaddress = message.rootMacaddress;
    }
    if (message.rstr?.length) {
      obj.rstr = message.rstr;
    }
    if (message.rint32?.length) {
      obj.rint32 = message.rint32.map((e) => Math.round(e));
    }
    if (message.subMessage?.length) {
      obj.subMessage = message.subMessage.map((e) => TestSubMessage.toJSON(e));
    }
    if (message.rootIpaddress !== "") {
      obj.rootIpaddress = message.rootIpaddress;
    }
    if (message.rootIpprefix !== "") {
      obj.rootIpprefix = message.rootIpprefix;
    }
    if (message.rootRepeatedMac?.length) {
      obj.rootRepeatedMac = message.rootRepeatedMac;
    }
    if (message.rootMemo !== "") {
      obj.rootMemo = message.rootMemo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestRootOne>, I>>(base?: I): TestRootOne {
    return TestRootOne.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestRootOne>, I>>(object: I): TestRootOne {
    const message = createBaseTestRootOne();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.rootBool = object.rootBool ?? false;
    message.rootEnum = object.rootEnum ?? 0;
    message.rootInt32 = object.rootInt32 ?? 0;
    message.rootSint32 = object.rootSint32 ?? 0;
    message.rootSfixed32 = object.rootSfixed32 ?? 0;
    message.rootUint32 = object.rootUint32 ?? 0;
    message.rootInt64 = object.rootInt64 ?? "0";
    message.rootSint64 = object.rootSint64 ?? "0";
    message.rootSfixed64 = object.rootSfixed64 ?? "0";
    message.rootFloat = object.rootFloat ?? 0;
    message.rootDouble = object.rootDouble ?? 0;
    message.rootString = object.rootString ?? "";
    message.rootBytes = object.rootBytes ?? new Uint8Array(0);
    message.rootTimestamp = object.rootTimestamp ?? undefined;
    message.rootMacaddress = object.rootMacaddress ?? "";
    message.rstr = object.rstr?.map((e) => e) || [];
    message.rint32 = object.rint32?.map((e) => e) || [];
    message.subMessage = object.subMessage?.map((e) => TestSubMessage.fromPartial(e)) || [];
    message.rootIpaddress = object.rootIpaddress ?? "";
    message.rootIpprefix = object.rootIpprefix ?? "";
    message.rootRepeatedMac = object.rootRepeatedMac?.map((e) => e) || [];
    message.rootMemo = object.rootMemo ?? "";
    return message;
  },
};

function createBaseTestRootTwo(): TestRootTwo {
  return { id: undefined };
}

export const TestRootTwo: MessageFns<TestRootTwo> = {
  encode(message: TestRootTwo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestRootTwo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestRootTwo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestRootTwo {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: TestRootTwo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestRootTwo>, I>>(base?: I): TestRootTwo {
    return TestRootTwo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestRootTwo>, I>>(object: I): TestRootTwo {
    const message = createBaseTestRootTwo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseTestMidOne(): TestMidOne {
  return { id: undefined };
}

export const TestMidOne: MessageFns<TestMidOne> = {
  encode(message: TestMidOne, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestMidOne {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestMidOne();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestMidOne {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: TestMidOne): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestMidOne>, I>>(base?: I): TestMidOne {
    return TestMidOne.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestMidOne>, I>>(object: I): TestMidOne {
    const message = createBaseTestMidOne();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseTestLeafOne(): TestLeafOne {
  return { id: undefined };
}

export const TestLeafOne: MessageFns<TestLeafOne> = {
  encode(message: TestLeafOne, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestLeafOne {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestLeafOne();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestLeafOne {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: TestLeafOne): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestLeafOne>, I>>(base?: I): TestLeafOne {
    return TestLeafOne.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestLeafOne>, I>>(object: I): TestLeafOne {
    const message = createBaseTestLeafOne();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseTestIpPrefix(): TestIpPrefix {
  return { id: undefined };
}

export const TestIpPrefix: MessageFns<TestIpPrefix> = {
  encode(message: TestIpPrefix, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestIpPrefix {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestIpPrefix();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestIpPrefix {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: TestIpPrefix): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestIpPrefix>, I>>(base?: I): TestIpPrefix {
    return TestIpPrefix.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestIpPrefix>, I>>(object: I): TestIpPrefix {
    const message = createBaseTestIpPrefix();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseTestIpAddress(): TestIpAddress {
  return { id: undefined };
}

export const TestIpAddress: MessageFns<TestIpAddress> = {
  encode(message: TestIpAddress, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestIpAddress {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestIpAddress();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestIpAddress {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: TestIpAddress): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestIpAddress>, I>>(base?: I): TestIpAddress {
    return TestIpAddress.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestIpAddress>, I>>(object: I): TestIpAddress {
    const message = createBaseTestIpAddress();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseTestMacAddress(): TestMacAddress {
  return { id: undefined };
}

export const TestMacAddress: MessageFns<TestMacAddress> = {
  encode(message: TestMacAddress, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestMacAddress {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestMacAddress();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestMacAddress {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: TestMacAddress): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestMacAddress>, I>>(base?: I): TestMacAddress {
    return TestMacAddress.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestMacAddress>, I>>(object: I): TestMacAddress {
    const message = createBaseTestMacAddress();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseBasicCounters(): BasicCounters {
  return { bytesIn: "0", bytesOut: "0", pktsIn: "0", pktsOut: "0", errPktsIn: "0", errPktsOut: "0" };
}

export const BasicCounters: MessageFns<BasicCounters> = {
  encode(message: BasicCounters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bytesIn !== "0") {
      writer.uint32(16).uint64(message.bytesIn);
    }
    if (message.bytesOut !== "0") {
      writer.uint32(24).uint64(message.bytesOut);
    }
    if (message.pktsIn !== "0") {
      writer.uint32(32).uint64(message.pktsIn);
    }
    if (message.pktsOut !== "0") {
      writer.uint32(40).uint64(message.pktsOut);
    }
    if (message.errPktsIn !== "0") {
      writer.uint32(48).uint64(message.errPktsIn);
    }
    if (message.errPktsOut !== "0") {
      writer.uint32(56).uint64(message.errPktsOut);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BasicCounters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBasicCounters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.bytesIn = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.bytesOut = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.pktsIn = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.pktsOut = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.errPktsIn = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.errPktsOut = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BasicCounters {
    return {
      bytesIn: isSet(object.bytesIn) ? globalThis.String(object.bytesIn) : "0",
      bytesOut: isSet(object.bytesOut) ? globalThis.String(object.bytesOut) : "0",
      pktsIn: isSet(object.pktsIn) ? globalThis.String(object.pktsIn) : "0",
      pktsOut: isSet(object.pktsOut) ? globalThis.String(object.pktsOut) : "0",
      errPktsIn: isSet(object.errPktsIn) ? globalThis.String(object.errPktsIn) : "0",
      errPktsOut: isSet(object.errPktsOut) ? globalThis.String(object.errPktsOut) : "0",
    };
  },

  toJSON(message: BasicCounters): unknown {
    const obj: any = {};
    if (message.bytesIn !== "0") {
      obj.bytesIn = message.bytesIn;
    }
    if (message.bytesOut !== "0") {
      obj.bytesOut = message.bytesOut;
    }
    if (message.pktsIn !== "0") {
      obj.pktsIn = message.pktsIn;
    }
    if (message.pktsOut !== "0") {
      obj.pktsOut = message.pktsOut;
    }
    if (message.errPktsIn !== "0") {
      obj.errPktsIn = message.errPktsIn;
    }
    if (message.errPktsOut !== "0") {
      obj.errPktsOut = message.errPktsOut;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BasicCounters>, I>>(base?: I): BasicCounters {
    return BasicCounters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BasicCounters>, I>>(object: I): BasicCounters {
    const message = createBaseBasicCounters();
    message.bytesIn = object.bytesIn ?? "0";
    message.bytesOut = object.bytesOut ?? "0";
    message.pktsIn = object.pktsIn ?? "0";
    message.pktsOut = object.pktsOut ?? "0";
    message.errPktsIn = object.errPktsIn ?? "0";
    message.errPktsOut = object.errPktsOut ?? "0";
    return message;
  },
};

function createBaseBaseAssertCounts(): BaseAssertCounts {
  return { assertCountTrue: 0, assertCountFalse: 0, assertCountUnknown: 0 };
}

export const BaseAssertCounts: MessageFns<BaseAssertCounts> = {
  encode(message: BaseAssertCounts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.assertCountTrue !== 0) {
      writer.uint32(8).uint32(message.assertCountTrue);
    }
    if (message.assertCountFalse !== 0) {
      writer.uint32(16).uint32(message.assertCountFalse);
    }
    if (message.assertCountUnknown !== 0) {
      writer.uint32(24).uint32(message.assertCountUnknown);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BaseAssertCounts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBaseAssertCounts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.assertCountTrue = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.assertCountFalse = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.assertCountUnknown = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BaseAssertCounts {
    return {
      assertCountTrue: isSet(object.assertCountTrue) ? globalThis.Number(object.assertCountTrue) : 0,
      assertCountFalse: isSet(object.assertCountFalse) ? globalThis.Number(object.assertCountFalse) : 0,
      assertCountUnknown: isSet(object.assertCountUnknown) ? globalThis.Number(object.assertCountUnknown) : 0,
    };
  },

  toJSON(message: BaseAssertCounts): unknown {
    const obj: any = {};
    if (message.assertCountTrue !== 0) {
      obj.assertCountTrue = Math.round(message.assertCountTrue);
    }
    if (message.assertCountFalse !== 0) {
      obj.assertCountFalse = Math.round(message.assertCountFalse);
    }
    if (message.assertCountUnknown !== 0) {
      obj.assertCountUnknown = Math.round(message.assertCountUnknown);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BaseAssertCounts>, I>>(base?: I): BaseAssertCounts {
    return BaseAssertCounts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BaseAssertCounts>, I>>(object: I): BaseAssertCounts {
    const message = createBaseBaseAssertCounts();
    message.assertCountTrue = object.assertCountTrue ?? 0;
    message.assertCountFalse = object.assertCountFalse ?? 0;
    message.assertCountUnknown = object.assertCountUnknown ?? 0;
    return message;
  },
};

function createBaseLatchedAssertCounts(): LatchedAssertCounts {
  return { latched: undefined, unlatched: undefined };
}

export const LatchedAssertCounts: MessageFns<LatchedAssertCounts> = {
  encode(message: LatchedAssertCounts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.latched !== undefined) {
      BaseAssertCounts.encode(message.latched, writer.uint32(10).fork()).join();
    }
    if (message.unlatched !== undefined) {
      BaseAssertCounts.encode(message.unlatched, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LatchedAssertCounts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLatchedAssertCounts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.latched = BaseAssertCounts.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.unlatched = BaseAssertCounts.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LatchedAssertCounts {
    return {
      latched: isSet(object.latched) ? BaseAssertCounts.fromJSON(object.latched) : undefined,
      unlatched: isSet(object.unlatched) ? BaseAssertCounts.fromJSON(object.unlatched) : undefined,
    };
  },

  toJSON(message: LatchedAssertCounts): unknown {
    const obj: any = {};
    if (message.latched !== undefined) {
      obj.latched = BaseAssertCounts.toJSON(message.latched);
    }
    if (message.unlatched !== undefined) {
      obj.unlatched = BaseAssertCounts.toJSON(message.unlatched);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LatchedAssertCounts>, I>>(base?: I): LatchedAssertCounts {
    return LatchedAssertCounts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LatchedAssertCounts>, I>>(object: I): LatchedAssertCounts {
    const message = createBaseLatchedAssertCounts();
    message.latched = (object.latched !== undefined && object.latched !== null)
      ? BaseAssertCounts.fromPartial(object.latched)
      : undefined;
    message.unlatched = (object.unlatched !== undefined && object.unlatched !== null)
      ? BaseAssertCounts.fromPartial(object.unlatched)
      : undefined;
    return message;
  },
};

function createBaseSeverityAssertCounts(): SeverityAssertCounts {
  return { red: undefined, yellow: undefined, unspecified: undefined };
}

export const SeverityAssertCounts: MessageFns<SeverityAssertCounts> = {
  encode(message: SeverityAssertCounts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.red !== undefined) {
      LatchedAssertCounts.encode(message.red, writer.uint32(10).fork()).join();
    }
    if (message.yellow !== undefined) {
      LatchedAssertCounts.encode(message.yellow, writer.uint32(18).fork()).join();
    }
    if (message.unspecified !== undefined) {
      LatchedAssertCounts.encode(message.unspecified, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeverityAssertCounts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeverityAssertCounts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.red = LatchedAssertCounts.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.yellow = LatchedAssertCounts.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.unspecified = LatchedAssertCounts.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SeverityAssertCounts {
    return {
      red: isSet(object.red) ? LatchedAssertCounts.fromJSON(object.red) : undefined,
      yellow: isSet(object.yellow) ? LatchedAssertCounts.fromJSON(object.yellow) : undefined,
      unspecified: isSet(object.unspecified) ? LatchedAssertCounts.fromJSON(object.unspecified) : undefined,
    };
  },

  toJSON(message: SeverityAssertCounts): unknown {
    const obj: any = {};
    if (message.red !== undefined) {
      obj.red = LatchedAssertCounts.toJSON(message.red);
    }
    if (message.yellow !== undefined) {
      obj.yellow = LatchedAssertCounts.toJSON(message.yellow);
    }
    if (message.unspecified !== undefined) {
      obj.unspecified = LatchedAssertCounts.toJSON(message.unspecified);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SeverityAssertCounts>, I>>(base?: I): SeverityAssertCounts {
    return SeverityAssertCounts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeverityAssertCounts>, I>>(object: I): SeverityAssertCounts {
    const message = createBaseSeverityAssertCounts();
    message.red = (object.red !== undefined && object.red !== null)
      ? LatchedAssertCounts.fromPartial(object.red)
      : undefined;
    message.yellow = (object.yellow !== undefined && object.yellow !== null)
      ? LatchedAssertCounts.fromPartial(object.yellow)
      : undefined;
    message.unspecified = (object.unspecified !== undefined && object.unspecified !== null)
      ? LatchedAssertCounts.fromPartial(object.unspecified)
      : undefined;
    return message;
  },
};

function createBaseCategoryAssertCounts(): CategoryAssertCounts {
  return { device: undefined, port: undefined, network: undefined };
}

export const CategoryAssertCounts: MessageFns<CategoryAssertCounts> = {
  encode(message: CategoryAssertCounts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.device !== undefined) {
      SeverityAssertCounts.encode(message.device, writer.uint32(10).fork()).join();
    }
    if (message.port !== undefined) {
      SeverityAssertCounts.encode(message.port, writer.uint32(18).fork()).join();
    }
    if (message.network !== undefined) {
      SeverityAssertCounts.encode(message.network, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CategoryAssertCounts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCategoryAssertCounts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.device = SeverityAssertCounts.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.port = SeverityAssertCounts.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.network = SeverityAssertCounts.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CategoryAssertCounts {
    return {
      device: isSet(object.device) ? SeverityAssertCounts.fromJSON(object.device) : undefined,
      port: isSet(object.port) ? SeverityAssertCounts.fromJSON(object.port) : undefined,
      network: isSet(object.network) ? SeverityAssertCounts.fromJSON(object.network) : undefined,
    };
  },

  toJSON(message: CategoryAssertCounts): unknown {
    const obj: any = {};
    if (message.device !== undefined) {
      obj.device = SeverityAssertCounts.toJSON(message.device);
    }
    if (message.port !== undefined) {
      obj.port = SeverityAssertCounts.toJSON(message.port);
    }
    if (message.network !== undefined) {
      obj.network = SeverityAssertCounts.toJSON(message.network);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CategoryAssertCounts>, I>>(base?: I): CategoryAssertCounts {
    return CategoryAssertCounts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CategoryAssertCounts>, I>>(object: I): CategoryAssertCounts {
    const message = createBaseCategoryAssertCounts();
    message.device = (object.device !== undefined && object.device !== null)
      ? SeverityAssertCounts.fromPartial(object.device)
      : undefined;
    message.port = (object.port !== undefined && object.port !== null)
      ? SeverityAssertCounts.fromPartial(object.port)
      : undefined;
    message.network = (object.network !== undefined && object.network !== null)
      ? SeverityAssertCounts.fromPartial(object.network)
      : undefined;
    return message;
  },
};

function createBaseDeviceTypeAssertCounts(): DeviceTypeAssertCounts {
  return { switch: undefined, server: undefined, unspecified: undefined };
}

export const DeviceTypeAssertCounts: MessageFns<DeviceTypeAssertCounts> = {
  encode(message: DeviceTypeAssertCounts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.switch !== undefined) {
      CategoryAssertCounts.encode(message.switch, writer.uint32(10).fork()).join();
    }
    if (message.server !== undefined) {
      CategoryAssertCounts.encode(message.server, writer.uint32(18).fork()).join();
    }
    if (message.unspecified !== undefined) {
      CategoryAssertCounts.encode(message.unspecified, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceTypeAssertCounts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceTypeAssertCounts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.switch = CategoryAssertCounts.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.server = CategoryAssertCounts.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.unspecified = CategoryAssertCounts.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceTypeAssertCounts {
    return {
      switch: isSet(object.switch) ? CategoryAssertCounts.fromJSON(object.switch) : undefined,
      server: isSet(object.server) ? CategoryAssertCounts.fromJSON(object.server) : undefined,
      unspecified: isSet(object.unspecified) ? CategoryAssertCounts.fromJSON(object.unspecified) : undefined,
    };
  },

  toJSON(message: DeviceTypeAssertCounts): unknown {
    const obj: any = {};
    if (message.switch !== undefined) {
      obj.switch = CategoryAssertCounts.toJSON(message.switch);
    }
    if (message.server !== undefined) {
      obj.server = CategoryAssertCounts.toJSON(message.server);
    }
    if (message.unspecified !== undefined) {
      obj.unspecified = CategoryAssertCounts.toJSON(message.unspecified);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceTypeAssertCounts>, I>>(base?: I): DeviceTypeAssertCounts {
    return DeviceTypeAssertCounts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceTypeAssertCounts>, I>>(object: I): DeviceTypeAssertCounts {
    const message = createBaseDeviceTypeAssertCounts();
    message.switch = (object.switch !== undefined && object.switch !== null)
      ? CategoryAssertCounts.fromPartial(object.switch)
      : undefined;
    message.server = (object.server !== undefined && object.server !== null)
      ? CategoryAssertCounts.fromPartial(object.server)
      : undefined;
    message.unspecified = (object.unspecified !== undefined && object.unspecified !== null)
      ? CategoryAssertCounts.fromPartial(object.unspecified)
      : undefined;
    return message;
  },
};

function createBaseFabric(): Fabric {
  return { id: undefined, orgId: "", numDevices: 0 };
}

export const Fabric: MessageFns<Fabric> = {
  encode(message: Fabric, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.orgId !== "") {
      writer.uint32(26).string(message.orgId);
    }
    if (message.numDevices !== 0) {
      writer.uint32(32).uint32(message.numDevices);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Fabric {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabric();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.numDevices = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Fabric {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      numDevices: isSet(object.numDevices) ? globalThis.Number(object.numDevices) : 0,
    };
  },

  toJSON(message: Fabric): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.numDevices !== 0) {
      obj.numDevices = Math.round(message.numDevices);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Fabric>, I>>(base?: I): Fabric {
    return Fabric.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Fabric>, I>>(object: I): Fabric {
    const message = createBaseFabric();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.orgId = object.orgId ?? "";
    message.numDevices = object.numDevices ?? 0;
    return message;
  },
};

function createBaseFabricDevice(): FabricDevice {
  return {
    id: undefined,
    deviceId: "",
    fabricId: "",
    orgId: "",
    nodeId: "",
    plannedConfig: undefined,
    mgmtPortState: undefined,
    assertCounts: undefined,
    ipv4Routes: 0,
    ipv6Routes: 0,
    bgpPeers: 0,
  };
}

export const FabricDevice: MessageFns<FabricDevice> = {
  encode(message: FabricDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.deviceId !== "") {
      writer.uint32(18).string(message.deviceId);
    }
    if (message.fabricId !== "") {
      writer.uint32(26).string(message.fabricId);
    }
    if (message.orgId !== "") {
      writer.uint32(34).string(message.orgId);
    }
    if (message.nodeId !== "") {
      writer.uint32(42).string(message.nodeId);
    }
    if (message.plannedConfig !== undefined) {
      PlannedConfigData.encode(message.plannedConfig, writer.uint32(114).fork()).join();
    }
    if (message.mgmtPortState !== undefined) {
      ManagementState.encode(message.mgmtPortState, writer.uint32(122).fork()).join();
    }
    if (message.assertCounts !== undefined) {
      CategoryAssertCounts.encode(message.assertCounts, writer.uint32(130).fork()).join();
    }
    if (message.ipv4Routes !== 0) {
      writer.uint32(136).uint32(message.ipv4Routes);
    }
    if (message.ipv6Routes !== 0) {
      writer.uint32(144).uint32(message.ipv6Routes);
    }
    if (message.bgpPeers !== 0) {
      writer.uint32(152).uint32(message.bgpPeers);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.plannedConfig = PlannedConfigData.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.mgmtPortState = ManagementState.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.assertCounts = CategoryAssertCounts.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.ipv4Routes = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.ipv6Routes = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.bgpPeers = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricDevice {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      plannedConfig: isSet(object.plannedConfig) ? PlannedConfigData.fromJSON(object.plannedConfig) : undefined,
      mgmtPortState: isSet(object.mgmtPortState) ? ManagementState.fromJSON(object.mgmtPortState) : undefined,
      assertCounts: isSet(object.assertCounts) ? CategoryAssertCounts.fromJSON(object.assertCounts) : undefined,
      ipv4Routes: isSet(object.ipv4Routes) ? globalThis.Number(object.ipv4Routes) : 0,
      ipv6Routes: isSet(object.ipv6Routes) ? globalThis.Number(object.ipv6Routes) : 0,
      bgpPeers: isSet(object.bgpPeers) ? globalThis.Number(object.bgpPeers) : 0,
    };
  },

  toJSON(message: FabricDevice): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.plannedConfig !== undefined) {
      obj.plannedConfig = PlannedConfigData.toJSON(message.plannedConfig);
    }
    if (message.mgmtPortState !== undefined) {
      obj.mgmtPortState = ManagementState.toJSON(message.mgmtPortState);
    }
    if (message.assertCounts !== undefined) {
      obj.assertCounts = CategoryAssertCounts.toJSON(message.assertCounts);
    }
    if (message.ipv4Routes !== 0) {
      obj.ipv4Routes = Math.round(message.ipv4Routes);
    }
    if (message.ipv6Routes !== 0) {
      obj.ipv6Routes = Math.round(message.ipv6Routes);
    }
    if (message.bgpPeers !== 0) {
      obj.bgpPeers = Math.round(message.bgpPeers);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricDevice>, I>>(base?: I): FabricDevice {
    return FabricDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricDevice>, I>>(object: I): FabricDevice {
    const message = createBaseFabricDevice();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.deviceId = object.deviceId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.orgId = object.orgId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.plannedConfig = (object.plannedConfig !== undefined && object.plannedConfig !== null)
      ? PlannedConfigData.fromPartial(object.plannedConfig)
      : undefined;
    message.mgmtPortState = (object.mgmtPortState !== undefined && object.mgmtPortState !== null)
      ? ManagementState.fromPartial(object.mgmtPortState)
      : undefined;
    message.assertCounts = (object.assertCounts !== undefined && object.assertCounts !== null)
      ? CategoryAssertCounts.fromPartial(object.assertCounts)
      : undefined;
    message.ipv4Routes = object.ipv4Routes ?? 0;
    message.ipv6Routes = object.ipv6Routes ?? 0;
    message.bgpPeers = object.bgpPeers ?? 0;
    return message;
  },
};

function createBaseBorderPort(): BorderPort {
  return {
    id: undefined,
    isDci: false,
    isBgpNorthbound: false,
    isBgpMultisiteNorthbound: false,
    isDefaultGateway: false,
  };
}

export const BorderPort: MessageFns<BorderPort> = {
  encode(message: BorderPort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.isDci !== false) {
      writer.uint32(24).bool(message.isDci);
    }
    if (message.isBgpNorthbound !== false) {
      writer.uint32(32).bool(message.isBgpNorthbound);
    }
    if (message.isBgpMultisiteNorthbound !== false) {
      writer.uint32(40).bool(message.isBgpMultisiteNorthbound);
    }
    if (message.isDefaultGateway !== false) {
      writer.uint32(48).bool(message.isDefaultGateway);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BorderPort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBorderPort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isDci = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isBgpNorthbound = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isBgpMultisiteNorthbound = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isDefaultGateway = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BorderPort {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      isDci: isSet(object.isDci) ? globalThis.Boolean(object.isDci) : false,
      isBgpNorthbound: isSet(object.isBgpNorthbound) ? globalThis.Boolean(object.isBgpNorthbound) : false,
      isBgpMultisiteNorthbound: isSet(object.isBgpMultisiteNorthbound)
        ? globalThis.Boolean(object.isBgpMultisiteNorthbound)
        : false,
      isDefaultGateway: isSet(object.isDefaultGateway) ? globalThis.Boolean(object.isDefaultGateway) : false,
    };
  },

  toJSON(message: BorderPort): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.isDci !== false) {
      obj.isDci = message.isDci;
    }
    if (message.isBgpNorthbound !== false) {
      obj.isBgpNorthbound = message.isBgpNorthbound;
    }
    if (message.isBgpMultisiteNorthbound !== false) {
      obj.isBgpMultisiteNorthbound = message.isBgpMultisiteNorthbound;
    }
    if (message.isDefaultGateway !== false) {
      obj.isDefaultGateway = message.isDefaultGateway;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BorderPort>, I>>(base?: I): BorderPort {
    return BorderPort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BorderPort>, I>>(object: I): BorderPort {
    const message = createBaseBorderPort();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.isDci = object.isDci ?? false;
    message.isBgpNorthbound = object.isBgpNorthbound ?? false;
    message.isBgpMultisiteNorthbound = object.isBgpMultisiteNorthbound ?? false;
    message.isDefaultGateway = object.isDefaultGateway ?? false;
    return message;
  },
};

function createBaseFabricConfigNotification(): FabricConfigNotification {
  return {
    id: undefined,
    configFp: "",
    fabricId: "",
    sequence: "0",
    releaseTag: "",
    targetTag: "",
    holddownFp: "",
    manifestAuxFp: "",
  };
}

export const FabricConfigNotification: MessageFns<FabricConfigNotification> = {
  encode(message: FabricConfigNotification, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.configFp !== "") {
      writer.uint32(18).string(message.configFp);
    }
    if (message.fabricId !== "") {
      writer.uint32(26).string(message.fabricId);
    }
    if (message.sequence !== "0") {
      writer.uint32(32).int64(message.sequence);
    }
    if (message.releaseTag !== "") {
      writer.uint32(42).string(message.releaseTag);
    }
    if (message.targetTag !== "") {
      writer.uint32(50).string(message.targetTag);
    }
    if (message.holddownFp !== "") {
      writer.uint32(58).string(message.holddownFp);
    }
    if (message.manifestAuxFp !== "") {
      writer.uint32(66).string(message.manifestAuxFp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricConfigNotification {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricConfigNotification();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.configFp = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.sequence = reader.int64().toString();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.releaseTag = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.targetTag = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.holddownFp = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.manifestAuxFp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricConfigNotification {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      configFp: isSet(object.configFp) ? globalThis.String(object.configFp) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      sequence: isSet(object.sequence) ? globalThis.String(object.sequence) : "0",
      releaseTag: isSet(object.releaseTag) ? globalThis.String(object.releaseTag) : "",
      targetTag: isSet(object.targetTag) ? globalThis.String(object.targetTag) : "",
      holddownFp: isSet(object.holddownFp) ? globalThis.String(object.holddownFp) : "",
      manifestAuxFp: isSet(object.manifestAuxFp) ? globalThis.String(object.manifestAuxFp) : "",
    };
  },

  toJSON(message: FabricConfigNotification): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.configFp !== "") {
      obj.configFp = message.configFp;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.sequence !== "0") {
      obj.sequence = message.sequence;
    }
    if (message.releaseTag !== "") {
      obj.releaseTag = message.releaseTag;
    }
    if (message.targetTag !== "") {
      obj.targetTag = message.targetTag;
    }
    if (message.holddownFp !== "") {
      obj.holddownFp = message.holddownFp;
    }
    if (message.manifestAuxFp !== "") {
      obj.manifestAuxFp = message.manifestAuxFp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricConfigNotification>, I>>(base?: I): FabricConfigNotification {
    return FabricConfigNotification.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricConfigNotification>, I>>(object: I): FabricConfigNotification {
    const message = createBaseFabricConfigNotification();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.configFp = object.configFp ?? "";
    message.fabricId = object.fabricId ?? "";
    message.sequence = object.sequence ?? "0";
    message.releaseTag = object.releaseTag ?? "";
    message.targetTag = object.targetTag ?? "";
    message.holddownFp = object.holddownFp ?? "";
    message.manifestAuxFp = object.manifestAuxFp ?? "";
    return message;
  },
};

function createBaseFabricTransaction(): FabricTransaction {
  return { id: undefined, changedAt: undefined, committed: false, orgId: "" };
}

export const FabricTransaction: MessageFns<FabricTransaction> = {
  encode(message: FabricTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.changedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.changedAt), writer.uint32(18).fork()).join();
    }
    if (message.committed !== false) {
      writer.uint32(24).bool(message.committed);
    }
    if (message.orgId !== "") {
      writer.uint32(34).string(message.orgId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.changedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.committed = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricTransaction {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      changedAt: isSet(object.changedAt) ? fromJsonTimestamp(object.changedAt) : undefined,
      committed: isSet(object.committed) ? globalThis.Boolean(object.committed) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
    };
  },

  toJSON(message: FabricTransaction): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.changedAt !== undefined) {
      obj.changedAt = message.changedAt.toISOString();
    }
    if (message.committed !== false) {
      obj.committed = message.committed;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricTransaction>, I>>(base?: I): FabricTransaction {
    return FabricTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricTransaction>, I>>(object: I): FabricTransaction {
    const message = createBaseFabricTransaction();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.changedAt = object.changedAt ?? undefined;
    message.committed = object.committed ?? false;
    message.orgId = object.orgId ?? "";
    return message;
  },
};

function createBaseStandbyAssignment(): StandbyAssignment {
  return { standbyInstance: "", syncFromInstance: "", standbyInstanceId: "", promoteStandby: false };
}

export const StandbyAssignment: MessageFns<StandbyAssignment> = {
  encode(message: StandbyAssignment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.standbyInstance !== "") {
      writer.uint32(10).string(message.standbyInstance);
    }
    if (message.syncFromInstance !== "") {
      writer.uint32(18).string(message.syncFromInstance);
    }
    if (message.standbyInstanceId !== "") {
      writer.uint32(26).string(message.standbyInstanceId);
    }
    if (message.promoteStandby !== false) {
      writer.uint32(32).bool(message.promoteStandby);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StandbyAssignment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStandbyAssignment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.standbyInstance = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.syncFromInstance = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.standbyInstanceId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.promoteStandby = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StandbyAssignment {
    return {
      standbyInstance: isSet(object.standbyInstance) ? globalThis.String(object.standbyInstance) : "",
      syncFromInstance: isSet(object.syncFromInstance) ? globalThis.String(object.syncFromInstance) : "",
      standbyInstanceId: isSet(object.standbyInstanceId) ? globalThis.String(object.standbyInstanceId) : "",
      promoteStandby: isSet(object.promoteStandby) ? globalThis.Boolean(object.promoteStandby) : false,
    };
  },

  toJSON(message: StandbyAssignment): unknown {
    const obj: any = {};
    if (message.standbyInstance !== "") {
      obj.standbyInstance = message.standbyInstance;
    }
    if (message.syncFromInstance !== "") {
      obj.syncFromInstance = message.syncFromInstance;
    }
    if (message.standbyInstanceId !== "") {
      obj.standbyInstanceId = message.standbyInstanceId;
    }
    if (message.promoteStandby !== false) {
      obj.promoteStandby = message.promoteStandby;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StandbyAssignment>, I>>(base?: I): StandbyAssignment {
    return StandbyAssignment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StandbyAssignment>, I>>(object: I): StandbyAssignment {
    const message = createBaseStandbyAssignment();
    message.standbyInstance = object.standbyInstance ?? "";
    message.syncFromInstance = object.syncFromInstance ?? "";
    message.standbyInstanceId = object.standbyInstanceId ?? "";
    message.promoteStandby = object.promoteStandby ?? false;
    return message;
  },
};

function createBaseApplication(): Application {
  return { id: undefined };
}

export const Application: MessageFns<Application> = {
  encode(message: Application, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Application {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApplication();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Application {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: Application): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Application>, I>>(base?: I): Application {
    return Application.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Application>, I>>(object: I): Application {
    const message = createBaseApplication();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseResourceAssignment(): ResourceAssignment {
  return {
    id: undefined,
    resourceType: 0,
    orgId: "",
    active: "",
    activeDemote: "",
    standby: [],
    standbyPromote: "",
    sourceUrl: "",
    revision: 0,
    updatedAt: undefined,
    boostFactor: 0,
    isStandbyCell: false,
  };
}

export const ResourceAssignment: MessageFns<ResourceAssignment> = {
  encode(message: ResourceAssignment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.resourceType !== 0) {
      writer.uint32(16).int32(message.resourceType);
    }
    if (message.orgId !== "") {
      writer.uint32(26).string(message.orgId);
    }
    if (message.active !== "") {
      writer.uint32(34).string(message.active);
    }
    if (message.activeDemote !== "") {
      writer.uint32(42).string(message.activeDemote);
    }
    for (const v of message.standby) {
      writer.uint32(50).string(v!);
    }
    if (message.standbyPromote !== "") {
      writer.uint32(58).string(message.standbyPromote);
    }
    if (message.sourceUrl !== "") {
      writer.uint32(66).string(message.sourceUrl);
    }
    if (message.revision !== 0) {
      writer.uint32(72).uint32(message.revision);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(82).fork()).join();
    }
    if (message.boostFactor !== 0) {
      writer.uint32(93).float(message.boostFactor);
    }
    if (message.isStandbyCell !== false) {
      writer.uint32(96).bool(message.isStandbyCell);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResourceAssignment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResourceAssignment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.resourceType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.active = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.activeDemote = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.standby.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.standbyPromote = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.sourceUrl = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.revision = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.boostFactor = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.isStandbyCell = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResourceAssignment {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      resourceType: isSet(object.resourceType) ? resourceTypeFromJSON(object.resourceType) : 0,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      active: isSet(object.active) ? globalThis.String(object.active) : "",
      activeDemote: isSet(object.activeDemote) ? globalThis.String(object.activeDemote) : "",
      standby: globalThis.Array.isArray(object?.standby) ? object.standby.map((e: any) => globalThis.String(e)) : [],
      standbyPromote: isSet(object.standbyPromote) ? globalThis.String(object.standbyPromote) : "",
      sourceUrl: isSet(object.sourceUrl) ? globalThis.String(object.sourceUrl) : "",
      revision: isSet(object.revision) ? globalThis.Number(object.revision) : 0,
      updatedAt: isSet(object.updatedAt) ? fromJsonTimestamp(object.updatedAt) : undefined,
      boostFactor: isSet(object.boostFactor) ? globalThis.Number(object.boostFactor) : 0,
      isStandbyCell: isSet(object.isStandbyCell) ? globalThis.Boolean(object.isStandbyCell) : false,
    };
  },

  toJSON(message: ResourceAssignment): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.resourceType !== 0) {
      obj.resourceType = resourceTypeToJSON(message.resourceType);
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.active !== "") {
      obj.active = message.active;
    }
    if (message.activeDemote !== "") {
      obj.activeDemote = message.activeDemote;
    }
    if (message.standby?.length) {
      obj.standby = message.standby;
    }
    if (message.standbyPromote !== "") {
      obj.standbyPromote = message.standbyPromote;
    }
    if (message.sourceUrl !== "") {
      obj.sourceUrl = message.sourceUrl;
    }
    if (message.revision !== 0) {
      obj.revision = Math.round(message.revision);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.boostFactor !== 0) {
      obj.boostFactor = message.boostFactor;
    }
    if (message.isStandbyCell !== false) {
      obj.isStandbyCell = message.isStandbyCell;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResourceAssignment>, I>>(base?: I): ResourceAssignment {
    return ResourceAssignment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResourceAssignment>, I>>(object: I): ResourceAssignment {
    const message = createBaseResourceAssignment();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.resourceType = object.resourceType ?? 0;
    message.orgId = object.orgId ?? "";
    message.active = object.active ?? "";
    message.activeDemote = object.activeDemote ?? "";
    message.standby = object.standby?.map((e) => e) || [];
    message.standbyPromote = object.standbyPromote ?? "";
    message.sourceUrl = object.sourceUrl ?? "";
    message.revision = object.revision ?? 0;
    message.updatedAt = object.updatedAt ?? undefined;
    message.boostFactor = object.boostFactor ?? 0;
    message.isStandbyCell = object.isStandbyCell ?? false;
    return message;
  },
};

function createBaseAssignmentStatus(): AssignmentStatus {
  return { id: undefined, assignmentState: 0, instanceId: "", revision: 0, orgId: "", resourceType: 0, fabricType: 0 };
}

export const AssignmentStatus: MessageFns<AssignmentStatus> = {
  encode(message: AssignmentStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.assignmentState !== 0) {
      writer.uint32(16).int32(message.assignmentState);
    }
    if (message.instanceId !== "") {
      writer.uint32(26).string(message.instanceId);
    }
    if (message.revision !== 0) {
      writer.uint32(32).uint32(message.revision);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.resourceType !== 0) {
      writer.uint32(48).int32(message.resourceType);
    }
    if (message.fabricType !== 0) {
      writer.uint32(56).int32(message.fabricType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignmentStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignmentStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.assignmentState = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.instanceId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.revision = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.resourceType = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.fabricType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssignmentStatus {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      assignmentState: isSet(object.assignmentState) ? assignmentStateFromJSON(object.assignmentState) : 0,
      instanceId: isSet(object.instanceId) ? globalThis.String(object.instanceId) : "",
      revision: isSet(object.revision) ? globalThis.Number(object.revision) : 0,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      resourceType: isSet(object.resourceType) ? resourceTypeFromJSON(object.resourceType) : 0,
      fabricType: isSet(object.fabricType) ? fabricTypeFromJSON(object.fabricType) : 0,
    };
  },

  toJSON(message: AssignmentStatus): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.assignmentState !== 0) {
      obj.assignmentState = assignmentStateToJSON(message.assignmentState);
    }
    if (message.instanceId !== "") {
      obj.instanceId = message.instanceId;
    }
    if (message.revision !== 0) {
      obj.revision = Math.round(message.revision);
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.resourceType !== 0) {
      obj.resourceType = resourceTypeToJSON(message.resourceType);
    }
    if (message.fabricType !== 0) {
      obj.fabricType = fabricTypeToJSON(message.fabricType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignmentStatus>, I>>(base?: I): AssignmentStatus {
    return AssignmentStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignmentStatus>, I>>(object: I): AssignmentStatus {
    const message = createBaseAssignmentStatus();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.assignmentState = object.assignmentState ?? 0;
    message.instanceId = object.instanceId ?? "";
    message.revision = object.revision ?? 0;
    message.orgId = object.orgId ?? "";
    message.resourceType = object.resourceType ?? 0;
    message.fabricType = object.fabricType ?? 0;
    return message;
  },
};

function createBaseFabricMemoryUsage(): FabricMemoryUsage {
  return { id: undefined };
}

export const FabricMemoryUsage: MessageFns<FabricMemoryUsage> = {
  encode(message: FabricMemoryUsage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricMemoryUsage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricMemoryUsage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricMemoryUsage {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: FabricMemoryUsage): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricMemoryUsage>, I>>(base?: I): FabricMemoryUsage {
    return FabricMemoryUsage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricMemoryUsage>, I>>(object: I): FabricMemoryUsage {
    const message = createBaseFabricMemoryUsage();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseTypeMemoryUsage(): TypeMemoryUsage {
  return { id: undefined, bytes: "0" };
}

export const TypeMemoryUsage: MessageFns<TypeMemoryUsage> = {
  encode(message: TypeMemoryUsage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.bytes !== "0") {
      writer.uint32(16).uint64(message.bytes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TypeMemoryUsage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTypeMemoryUsage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.bytes = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TypeMemoryUsage {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      bytes: isSet(object.bytes) ? globalThis.String(object.bytes) : "0",
    };
  },

  toJSON(message: TypeMemoryUsage): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.bytes !== "0") {
      obj.bytes = message.bytes;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TypeMemoryUsage>, I>>(base?: I): TypeMemoryUsage {
    return TypeMemoryUsage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TypeMemoryUsage>, I>>(object: I): TypeMemoryUsage {
    const message = createBaseTypeMemoryUsage();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.bytes = object.bytes ?? "0";
    return message;
  },
};

function createBaseFabricConfig(): FabricConfig {
  return {
    id: undefined,
    name: "",
    description: "",
    fabricId: "",
    adminState: 0,
    topology: 0,
    type: 0,
    modifiedAt: undefined,
    orgId: "",
    tags: [],
    assignmentRevision: 0,
    location: "",
    level: 0,
    interconnects: [],
    migrationStatus: "",
    multisiteConfigs: [],
    runningImageTag: "",
  };
}

export const FabricConfig: MessageFns<FabricConfig> = {
  encode(message: FabricConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.fabricId !== "") {
      writer.uint32(34).string(message.fabricId);
    }
    if (message.adminState !== 0) {
      writer.uint32(40).int32(message.adminState);
    }
    if (message.topology !== 0) {
      writer.uint32(48).int32(message.topology);
    }
    if (message.type !== 0) {
      writer.uint32(56).int32(message.type);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(98).fork()).join();
    }
    if (message.orgId !== "") {
      writer.uint32(106).string(message.orgId);
    }
    for (const v of message.tags) {
      writer.uint32(114).string(v!);
    }
    if (message.assignmentRevision !== 0) {
      writer.uint32(120).uint32(message.assignmentRevision);
    }
    if (message.location !== "") {
      writer.uint32(130).string(message.location);
    }
    if (message.level !== 0) {
      writer.uint32(136).int32(message.level);
    }
    for (const v of message.interconnects) {
      InterconnectInfo.encode(v!, writer.uint32(154).fork()).join();
    }
    if (message.migrationStatus !== "") {
      writer.uint32(162).string(message.migrationStatus);
    }
    for (const v of message.multisiteConfigs) {
      MultisiteInfo.encode(v!, writer.uint32(170).fork()).join();
    }
    if (message.runningImageTag !== "") {
      writer.uint32(178).string(message.runningImageTag);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.adminState = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.topology = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.assignmentRevision = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.level = reader.int32() as any;
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.interconnects.push(InterconnectInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.migrationStatus = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.multisiteConfigs.push(MultisiteInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.runningImageTag = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricConfig {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      adminState: isSet(object.adminState) ? adminStateFromJSON(object.adminState) : 0,
      topology: isSet(object.topology) ? fabricTopologyFromJSON(object.topology) : 0,
      type: isSet(object.type) ? fabricTypeFromJSON(object.type) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
      assignmentRevision: isSet(object.assignmentRevision) ? globalThis.Number(object.assignmentRevision) : 0,
      location: isSet(object.location) ? globalThis.String(object.location) : "",
      level: isSet(object.level) ? entitlementLevelFromJSON(object.level) : 0,
      interconnects: globalThis.Array.isArray(object?.interconnects)
        ? object.interconnects.map((e: any) => InterconnectInfo.fromJSON(e))
        : [],
      migrationStatus: isSet(object.migrationStatus) ? globalThis.String(object.migrationStatus) : "",
      multisiteConfigs: globalThis.Array.isArray(object?.multisiteConfigs)
        ? object.multisiteConfigs.map((e: any) => MultisiteInfo.fromJSON(e))
        : [],
      runningImageTag: isSet(object.runningImageTag) ? globalThis.String(object.runningImageTag) : "",
    };
  },

  toJSON(message: FabricConfig): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.adminState !== 0) {
      obj.adminState = adminStateToJSON(message.adminState);
    }
    if (message.topology !== 0) {
      obj.topology = fabricTopologyToJSON(message.topology);
    }
    if (message.type !== 0) {
      obj.type = fabricTypeToJSON(message.type);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    if (message.assignmentRevision !== 0) {
      obj.assignmentRevision = Math.round(message.assignmentRevision);
    }
    if (message.location !== "") {
      obj.location = message.location;
    }
    if (message.level !== 0) {
      obj.level = entitlementLevelToJSON(message.level);
    }
    if (message.interconnects?.length) {
      obj.interconnects = message.interconnects.map((e) => InterconnectInfo.toJSON(e));
    }
    if (message.migrationStatus !== "") {
      obj.migrationStatus = message.migrationStatus;
    }
    if (message.multisiteConfigs?.length) {
      obj.multisiteConfigs = message.multisiteConfigs.map((e) => MultisiteInfo.toJSON(e));
    }
    if (message.runningImageTag !== "") {
      obj.runningImageTag = message.runningImageTag;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricConfig>, I>>(base?: I): FabricConfig {
    return FabricConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricConfig>, I>>(object: I): FabricConfig {
    const message = createBaseFabricConfig();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.fabricId = object.fabricId ?? "";
    message.adminState = object.adminState ?? 0;
    message.topology = object.topology ?? 0;
    message.type = object.type ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.orgId = object.orgId ?? "";
    message.tags = object.tags?.map((e) => e) || [];
    message.assignmentRevision = object.assignmentRevision ?? 0;
    message.location = object.location ?? "";
    message.level = object.level ?? 0;
    message.interconnects = object.interconnects?.map((e) => InterconnectInfo.fromPartial(e)) || [];
    message.migrationStatus = object.migrationStatus ?? "";
    message.multisiteConfigs = object.multisiteConfigs?.map((e) => MultisiteInfo.fromPartial(e)) || [];
    message.runningImageTag = object.runningImageTag ?? "";
    return message;
  },
};

function createBaseInterconnectInfo(): InterconnectInfo {
  return { id: "", revision: "0" };
}

export const InterconnectInfo: MessageFns<InterconnectInfo> = {
  encode(message: InterconnectInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.revision !== "0") {
      writer.uint32(16).int64(message.revision);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InterconnectInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterconnectInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.revision = reader.int64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InterconnectInfo {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      revision: isSet(object.revision) ? globalThis.String(object.revision) : "0",
    };
  },

  toJSON(message: InterconnectInfo): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.revision !== "0") {
      obj.revision = message.revision;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InterconnectInfo>, I>>(base?: I): InterconnectInfo {
    return InterconnectInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InterconnectInfo>, I>>(object: I): InterconnectInfo {
    const message = createBaseInterconnectInfo();
    message.id = object.id ?? "";
    message.revision = object.revision ?? "0";
    return message;
  },
};

function createBaseMultisiteInfo(): MultisiteInfo {
  return { multisiteId: "", fabrics: [], multisiteVnis: [] };
}

export const MultisiteInfo: MessageFns<MultisiteInfo> = {
  encode(message: MultisiteInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.multisiteId !== "") {
      writer.uint32(10).string(message.multisiteId);
    }
    for (const v of message.fabrics) {
      MultisiteFabricInfo.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.multisiteVnis) {
      MultisiteVni.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultisiteInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultisiteInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.multisiteId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabrics.push(MultisiteFabricInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.multisiteVnis.push(MultisiteVni.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MultisiteInfo {
    return {
      multisiteId: isSet(object.multisiteId) ? globalThis.String(object.multisiteId) : "",
      fabrics: globalThis.Array.isArray(object?.fabrics)
        ? object.fabrics.map((e: any) => MultisiteFabricInfo.fromJSON(e))
        : [],
      multisiteVnis: globalThis.Array.isArray(object?.multisiteVnis)
        ? object.multisiteVnis.map((e: any) => MultisiteVni.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MultisiteInfo): unknown {
    const obj: any = {};
    if (message.multisiteId !== "") {
      obj.multisiteId = message.multisiteId;
    }
    if (message.fabrics?.length) {
      obj.fabrics = message.fabrics.map((e) => MultisiteFabricInfo.toJSON(e));
    }
    if (message.multisiteVnis?.length) {
      obj.multisiteVnis = message.multisiteVnis.map((e) => MultisiteVni.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MultisiteInfo>, I>>(base?: I): MultisiteInfo {
    return MultisiteInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultisiteInfo>, I>>(object: I): MultisiteInfo {
    const message = createBaseMultisiteInfo();
    message.multisiteId = object.multisiteId ?? "";
    message.fabrics = object.fabrics?.map((e) => MultisiteFabricInfo.fromPartial(e)) || [];
    message.multisiteVnis = object.multisiteVnis?.map((e) => MultisiteVni.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMultisiteFabricInfo(): MultisiteFabricInfo {
  return { fabricId: "", virtualIp: "", asn: 0, enabled: false };
}

export const MultisiteFabricInfo: MessageFns<MultisiteFabricInfo> = {
  encode(message: MultisiteFabricInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.virtualIp !== "") {
      writer.uint32(18).string(message.virtualIp);
    }
    if (message.asn !== 0) {
      writer.uint32(24).uint32(message.asn);
    }
    if (message.enabled !== false) {
      writer.uint32(32).bool(message.enabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultisiteFabricInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultisiteFabricInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.virtualIp = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.asn = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MultisiteFabricInfo {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      virtualIp: isSet(object.virtualIp) ? globalThis.String(object.virtualIp) : "",
      asn: isSet(object.asn) ? globalThis.Number(object.asn) : 0,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
    };
  },

  toJSON(message: MultisiteFabricInfo): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.virtualIp !== "") {
      obj.virtualIp = message.virtualIp;
    }
    if (message.asn !== 0) {
      obj.asn = Math.round(message.asn);
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MultisiteFabricInfo>, I>>(base?: I): MultisiteFabricInfo {
    return MultisiteFabricInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultisiteFabricInfo>, I>>(object: I): MultisiteFabricInfo {
    const message = createBaseMultisiteFabricInfo();
    message.fabricId = object.fabricId ?? "";
    message.virtualIp = object.virtualIp ?? "";
    message.asn = object.asn ?? 0;
    message.enabled = object.enabled ?? false;
    return message;
  },
};

function createBaseMultisiteVni(): MultisiteVni {
  return { vni: 0, isL3: false, enabled: false, vrfs: [] };
}

export const MultisiteVni: MessageFns<MultisiteVni> = {
  encode(message: MultisiteVni, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vni !== 0) {
      writer.uint32(8).uint32(message.vni);
    }
    if (message.isL3 !== false) {
      writer.uint32(16).bool(message.isL3);
    }
    if (message.enabled !== false) {
      writer.uint32(24).bool(message.enabled);
    }
    for (const v of message.vrfs) {
      MultisiteVrf.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultisiteVni {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultisiteVni();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.isL3 = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.vrfs.push(MultisiteVrf.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MultisiteVni {
    return {
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      isL3: isSet(object.isL3) ? globalThis.Boolean(object.isL3) : false,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      vrfs: globalThis.Array.isArray(object?.vrfs) ? object.vrfs.map((e: any) => MultisiteVrf.fromJSON(e)) : [],
    };
  },

  toJSON(message: MultisiteVni): unknown {
    const obj: any = {};
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.isL3 !== false) {
      obj.isL3 = message.isL3;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.vrfs?.length) {
      obj.vrfs = message.vrfs.map((e) => MultisiteVrf.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MultisiteVni>, I>>(base?: I): MultisiteVni {
    return MultisiteVni.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultisiteVni>, I>>(object: I): MultisiteVni {
    const message = createBaseMultisiteVni();
    message.vni = object.vni ?? 0;
    message.isL3 = object.isL3 ?? false;
    message.enabled = object.enabled ?? false;
    message.vrfs = object.vrfs?.map((e) => MultisiteVrf.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMultisiteVrf(): MultisiteVrf {
  return { name: "", vrfVni: 0, normalizedVni: 0, enabled: false };
}

export const MultisiteVrf: MessageFns<MultisiteVrf> = {
  encode(message: MultisiteVrf, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.vrfVni !== 0) {
      writer.uint32(16).uint32(message.vrfVni);
    }
    if (message.normalizedVni !== 0) {
      writer.uint32(24).uint32(message.normalizedVni);
    }
    if (message.enabled !== false) {
      writer.uint32(32).bool(message.enabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultisiteVrf {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultisiteVrf();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.vrfVni = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.normalizedVni = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MultisiteVrf {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      vrfVni: isSet(object.vrfVni) ? globalThis.Number(object.vrfVni) : 0,
      normalizedVni: isSet(object.normalizedVni) ? globalThis.Number(object.normalizedVni) : 0,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
    };
  },

  toJSON(message: MultisiteVrf): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.vrfVni !== 0) {
      obj.vrfVni = Math.round(message.vrfVni);
    }
    if (message.normalizedVni !== 0) {
      obj.normalizedVni = Math.round(message.normalizedVni);
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MultisiteVrf>, I>>(base?: I): MultisiteVrf {
    return MultisiteVrf.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultisiteVrf>, I>>(object: I): MultisiteVrf {
    const message = createBaseMultisiteVrf();
    message.name = object.name ?? "";
    message.vrfVni = object.vrfVni ?? 0;
    message.normalizedVni = object.normalizedVni ?? 0;
    message.enabled = object.enabled ?? false;
    return message;
  },
};

function createBaseFabricInterconnectConfig(): FabricInterconnectConfig {
  return { id: undefined, interconnect: undefined, latestRevision: "0" };
}

export const FabricInterconnectConfig: MessageFns<FabricInterconnectConfig> = {
  encode(message: FabricInterconnectConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.interconnect !== undefined) {
      InterconnectInfo.encode(message.interconnect, writer.uint32(18).fork()).join();
    }
    if (message.latestRevision !== "0") {
      writer.uint32(24).int64(message.latestRevision);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricInterconnectConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricInterconnectConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.interconnect = InterconnectInfo.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latestRevision = reader.int64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricInterconnectConfig {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      interconnect: isSet(object.interconnect) ? InterconnectInfo.fromJSON(object.interconnect) : undefined,
      latestRevision: isSet(object.latestRevision) ? globalThis.String(object.latestRevision) : "0",
    };
  },

  toJSON(message: FabricInterconnectConfig): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.interconnect !== undefined) {
      obj.interconnect = InterconnectInfo.toJSON(message.interconnect);
    }
    if (message.latestRevision !== "0") {
      obj.latestRevision = message.latestRevision;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricInterconnectConfig>, I>>(base?: I): FabricInterconnectConfig {
    return FabricInterconnectConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricInterconnectConfig>, I>>(object: I): FabricInterconnectConfig {
    const message = createBaseFabricInterconnectConfig();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.interconnect = (object.interconnect !== undefined && object.interconnect !== null)
      ? InterconnectInfo.fromPartial(object.interconnect)
      : undefined;
    message.latestRevision = object.latestRevision ?? "0";
    return message;
  },
};

function createBaseFabricConfigEvent(): FabricConfigEvent {
  return { id: undefined, event: 0, nodeId: "", deviceId: "" };
}

export const FabricConfigEvent: MessageFns<FabricConfigEvent> = {
  encode(message: FabricConfigEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.event !== 0) {
      writer.uint32(16).int32(message.event);
    }
    if (message.nodeId !== "") {
      writer.uint32(26).string(message.nodeId);
    }
    if (message.deviceId !== "") {
      writer.uint32(34).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricConfigEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricConfigEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.event = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricConfigEvent {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      event: isSet(object.event) ? fabricEventFromJSON(object.event) : 0,
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
    };
  },

  toJSON(message: FabricConfigEvent): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.event !== 0) {
      obj.event = fabricEventToJSON(message.event);
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricConfigEvent>, I>>(base?: I): FabricConfigEvent {
    return FabricConfigEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricConfigEvent>, I>>(object: I): FabricConfigEvent {
    const message = createBaseFabricConfigEvent();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.event = object.event ?? 0;
    message.nodeId = object.nodeId ?? "";
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseDevice(): Device {
  return {
    id: undefined,
    info: undefined,
    fabricId: "",
    firstSeen: undefined,
    lastSeen: undefined,
    commonPortSpeed: "0",
  };
}

export const Device: MessageFns<Device> = {
  encode(message: Device, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.info !== undefined) {
      DeviceInfo.encode(message.info, writer.uint32(26).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(34).string(message.fabricId);
    }
    if (message.firstSeen !== undefined) {
      Timestamp.encode(toTimestamp(message.firstSeen), writer.uint32(42).fork()).join();
    }
    if (message.lastSeen !== undefined) {
      Timestamp.encode(toTimestamp(message.lastSeen), writer.uint32(50).fork()).join();
    }
    if (message.commonPortSpeed !== "0") {
      writer.uint32(56).uint64(message.commonPortSpeed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Device {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.info = DeviceInfo.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.firstSeen = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.lastSeen = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.commonPortSpeed = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Device {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      info: isSet(object.info) ? DeviceInfo.fromJSON(object.info) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      firstSeen: isSet(object.firstSeen) ? fromJsonTimestamp(object.firstSeen) : undefined,
      lastSeen: isSet(object.lastSeen) ? fromJsonTimestamp(object.lastSeen) : undefined,
      commonPortSpeed: isSet(object.commonPortSpeed) ? globalThis.String(object.commonPortSpeed) : "0",
    };
  },

  toJSON(message: Device): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.info !== undefined) {
      obj.info = DeviceInfo.toJSON(message.info);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.firstSeen !== undefined) {
      obj.firstSeen = message.firstSeen.toISOString();
    }
    if (message.lastSeen !== undefined) {
      obj.lastSeen = message.lastSeen.toISOString();
    }
    if (message.commonPortSpeed !== "0") {
      obj.commonPortSpeed = message.commonPortSpeed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Device>, I>>(base?: I): Device {
    return Device.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Device>, I>>(object: I): Device {
    const message = createBaseDevice();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.info = (object.info !== undefined && object.info !== null)
      ? DeviceInfo.fromPartial(object.info)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.firstSeen = object.firstSeen ?? undefined;
    message.lastSeen = object.lastSeen ?? undefined;
    message.commonPortSpeed = object.commonPortSpeed ?? "0";
    return message;
  },
};

function createBaseDeviceConnection(): DeviceConnection {
  return {
    id: undefined,
    wsConnected: 0,
    wsLastConnectedAt: undefined,
    wsLastDisconnectedAt: undefined,
    wsMustConnectBy: undefined,
    upliftLimitReached: false,
  };
}

export const DeviceConnection: MessageFns<DeviceConnection> = {
  encode(message: DeviceConnection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.wsConnected !== 0) {
      writer.uint32(32).uint32(message.wsConnected);
    }
    if (message.wsLastConnectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.wsLastConnectedAt), writer.uint32(42).fork()).join();
    }
    if (message.wsLastDisconnectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.wsLastDisconnectedAt), writer.uint32(50).fork()).join();
    }
    if (message.wsMustConnectBy !== undefined) {
      Timestamp.encode(toTimestamp(message.wsMustConnectBy), writer.uint32(58).fork()).join();
    }
    if (message.upliftLimitReached !== false) {
      writer.uint32(64).bool(message.upliftLimitReached);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceConnection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceConnection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.wsConnected = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.wsLastConnectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.wsLastDisconnectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.wsMustConnectBy = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.upliftLimitReached = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceConnection {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      wsConnected: isSet(object.wsConnected) ? globalThis.Number(object.wsConnected) : 0,
      wsLastConnectedAt: isSet(object.wsLastConnectedAt) ? fromJsonTimestamp(object.wsLastConnectedAt) : undefined,
      wsLastDisconnectedAt: isSet(object.wsLastDisconnectedAt)
        ? fromJsonTimestamp(object.wsLastDisconnectedAt)
        : undefined,
      wsMustConnectBy: isSet(object.wsMustConnectBy) ? fromJsonTimestamp(object.wsMustConnectBy) : undefined,
      upliftLimitReached: isSet(object.upliftLimitReached) ? globalThis.Boolean(object.upliftLimitReached) : false,
    };
  },

  toJSON(message: DeviceConnection): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.wsConnected !== 0) {
      obj.wsConnected = Math.round(message.wsConnected);
    }
    if (message.wsLastConnectedAt !== undefined) {
      obj.wsLastConnectedAt = message.wsLastConnectedAt.toISOString();
    }
    if (message.wsLastDisconnectedAt !== undefined) {
      obj.wsLastDisconnectedAt = message.wsLastDisconnectedAt.toISOString();
    }
    if (message.wsMustConnectBy !== undefined) {
      obj.wsMustConnectBy = message.wsMustConnectBy.toISOString();
    }
    if (message.upliftLimitReached !== false) {
      obj.upliftLimitReached = message.upliftLimitReached;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceConnection>, I>>(base?: I): DeviceConnection {
    return DeviceConnection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceConnection>, I>>(object: I): DeviceConnection {
    const message = createBaseDeviceConnection();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.wsConnected = object.wsConnected ?? 0;
    message.wsLastConnectedAt = object.wsLastConnectedAt ?? undefined;
    message.wsLastDisconnectedAt = object.wsLastDisconnectedAt ?? undefined;
    message.wsMustConnectBy = object.wsMustConnectBy ?? undefined;
    message.upliftLimitReached = object.upliftLimitReached ?? false;
    return message;
  },
};

function createBasePlannedConfigData(): PlannedConfigData {
  return { currentConfigFp: "", plannedConfigFp: "", plannedConfigUpdatedAt: undefined, plannedConfigPhase: 0 };
}

export const PlannedConfigData: MessageFns<PlannedConfigData> = {
  encode(message: PlannedConfigData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.currentConfigFp !== "") {
      writer.uint32(18).string(message.currentConfigFp);
    }
    if (message.plannedConfigFp !== "") {
      writer.uint32(26).string(message.plannedConfigFp);
    }
    if (message.plannedConfigUpdatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.plannedConfigUpdatedAt), writer.uint32(34).fork()).join();
    }
    if (message.plannedConfigPhase !== 0) {
      writer.uint32(40).int32(message.plannedConfigPhase);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlannedConfigData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlannedConfigData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.currentConfigFp = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.plannedConfigFp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.plannedConfigUpdatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.plannedConfigPhase = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlannedConfigData {
    return {
      currentConfigFp: isSet(object.currentConfigFp) ? globalThis.String(object.currentConfigFp) : "",
      plannedConfigFp: isSet(object.plannedConfigFp) ? globalThis.String(object.plannedConfigFp) : "",
      plannedConfigUpdatedAt: isSet(object.plannedConfigUpdatedAt)
        ? fromJsonTimestamp(object.plannedConfigUpdatedAt)
        : undefined,
      plannedConfigPhase: isSet(object.plannedConfigPhase) ? plannedConfigPhaseFromJSON(object.plannedConfigPhase) : 0,
    };
  },

  toJSON(message: PlannedConfigData): unknown {
    const obj: any = {};
    if (message.currentConfigFp !== "") {
      obj.currentConfigFp = message.currentConfigFp;
    }
    if (message.plannedConfigFp !== "") {
      obj.plannedConfigFp = message.plannedConfigFp;
    }
    if (message.plannedConfigUpdatedAt !== undefined) {
      obj.plannedConfigUpdatedAt = message.plannedConfigUpdatedAt.toISOString();
    }
    if (message.plannedConfigPhase !== 0) {
      obj.plannedConfigPhase = plannedConfigPhaseToJSON(message.plannedConfigPhase);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlannedConfigData>, I>>(base?: I): PlannedConfigData {
    return PlannedConfigData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlannedConfigData>, I>>(object: I): PlannedConfigData {
    const message = createBasePlannedConfigData();
    message.currentConfigFp = object.currentConfigFp ?? "";
    message.plannedConfigFp = object.plannedConfigFp ?? "";
    message.plannedConfigUpdatedAt = object.plannedConfigUpdatedAt ?? undefined;
    message.plannedConfigPhase = object.plannedConfigPhase ?? 0;
    return message;
  },
};

function createBasePlannedConfig(): PlannedConfig {
  return { id: undefined, plannedConfig: undefined };
}

export const PlannedConfig: MessageFns<PlannedConfig> = {
  encode(message: PlannedConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.plannedConfig !== undefined) {
      PlannedConfigData.encode(message.plannedConfig, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlannedConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlannedConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.plannedConfig = PlannedConfigData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlannedConfig {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      plannedConfig: isSet(object.plannedConfig) ? PlannedConfigData.fromJSON(object.plannedConfig) : undefined,
    };
  },

  toJSON(message: PlannedConfig): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.plannedConfig !== undefined) {
      obj.plannedConfig = PlannedConfigData.toJSON(message.plannedConfig);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlannedConfig>, I>>(base?: I): PlannedConfig {
    return PlannedConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlannedConfig>, I>>(object: I): PlannedConfig {
    const message = createBasePlannedConfig();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.plannedConfig = (object.plannedConfig !== undefined && object.plannedConfig !== null)
      ? PlannedConfigData.fromPartial(object.plannedConfig)
      : undefined;
    return message;
  },
};

function createBaseDeviceInfo(): DeviceInfo {
  return {
    model: "",
    psuNum: "",
    revision: "",
    serial: "",
    name: "",
    lldpLocId: "",
    sonicVersion: "",
    agentsVersion: "",
    monitored: false,
    osType: 0,
    nxosNoLldp: false,
    nxosNoGrpc: false,
  };
}

export const DeviceInfo: MessageFns<DeviceInfo> = {
  encode(message: DeviceInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.model !== "") {
      writer.uint32(26).string(message.model);
    }
    if (message.psuNum !== "") {
      writer.uint32(34).string(message.psuNum);
    }
    if (message.revision !== "") {
      writer.uint32(42).string(message.revision);
    }
    if (message.serial !== "") {
      writer.uint32(50).string(message.serial);
    }
    if (message.name !== "") {
      writer.uint32(58).string(message.name);
    }
    if (message.lldpLocId !== "") {
      writer.uint32(66).string(message.lldpLocId);
    }
    if (message.sonicVersion !== "") {
      writer.uint32(74).string(message.sonicVersion);
    }
    if (message.agentsVersion !== "") {
      writer.uint32(82).string(message.agentsVersion);
    }
    if (message.monitored !== false) {
      writer.uint32(88).bool(message.monitored);
    }
    if (message.osType !== 0) {
      writer.uint32(96).int32(message.osType);
    }
    if (message.nxosNoLldp !== false) {
      writer.uint32(104).bool(message.nxosNoLldp);
    }
    if (message.nxosNoGrpc !== false) {
      writer.uint32(112).bool(message.nxosNoGrpc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.psuNum = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.revision = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.lldpLocId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.sonicVersion = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.agentsVersion = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.monitored = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.osType = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.nxosNoLldp = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.nxosNoGrpc = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceInfo {
    return {
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      psuNum: isSet(object.psuNum) ? globalThis.String(object.psuNum) : "",
      revision: isSet(object.revision) ? globalThis.String(object.revision) : "",
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      lldpLocId: isSet(object.lldpLocId) ? globalThis.String(object.lldpLocId) : "",
      sonicVersion: isSet(object.sonicVersion) ? globalThis.String(object.sonicVersion) : "",
      agentsVersion: isSet(object.agentsVersion) ? globalThis.String(object.agentsVersion) : "",
      monitored: isSet(object.monitored) ? globalThis.Boolean(object.monitored) : false,
      osType: isSet(object.osType) ? osTypeFromJSON(object.osType) : 0,
      nxosNoLldp: isSet(object.nxosNoLldp) ? globalThis.Boolean(object.nxosNoLldp) : false,
      nxosNoGrpc: isSet(object.nxosNoGrpc) ? globalThis.Boolean(object.nxosNoGrpc) : false,
    };
  },

  toJSON(message: DeviceInfo): unknown {
    const obj: any = {};
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.psuNum !== "") {
      obj.psuNum = message.psuNum;
    }
    if (message.revision !== "") {
      obj.revision = message.revision;
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.lldpLocId !== "") {
      obj.lldpLocId = message.lldpLocId;
    }
    if (message.sonicVersion !== "") {
      obj.sonicVersion = message.sonicVersion;
    }
    if (message.agentsVersion !== "") {
      obj.agentsVersion = message.agentsVersion;
    }
    if (message.monitored !== false) {
      obj.monitored = message.monitored;
    }
    if (message.osType !== 0) {
      obj.osType = osTypeToJSON(message.osType);
    }
    if (message.nxosNoLldp !== false) {
      obj.nxosNoLldp = message.nxosNoLldp;
    }
    if (message.nxosNoGrpc !== false) {
      obj.nxosNoGrpc = message.nxosNoGrpc;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceInfo>, I>>(base?: I): DeviceInfo {
    return DeviceInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceInfo>, I>>(object: I): DeviceInfo {
    const message = createBaseDeviceInfo();
    message.model = object.model ?? "";
    message.psuNum = object.psuNum ?? "";
    message.revision = object.revision ?? "";
    message.serial = object.serial ?? "";
    message.name = object.name ?? "";
    message.lldpLocId = object.lldpLocId ?? "";
    message.sonicVersion = object.sonicVersion ?? "";
    message.agentsVersion = object.agentsVersion ?? "";
    message.monitored = object.monitored ?? false;
    message.osType = object.osType ?? 0;
    message.nxosNoLldp = object.nxosNoLldp ?? false;
    message.nxosNoGrpc = object.nxosNoGrpc ?? false;
    return message;
  },
};

function createBaseFirmwareVersion(): FirmwareVersion {
  return {
    id: undefined,
    biosVersion: "",
    aikidoVersion: "",
    tamVersion: "",
    cpldlVersion: "",
    cpldgVersion: "",
    cpldrVersion: "",
    ssdVersion: "",
    iofpgaVersion: "",
  };
}

export const FirmwareVersion: MessageFns<FirmwareVersion> = {
  encode(message: FirmwareVersion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.biosVersion !== "") {
      writer.uint32(18).string(message.biosVersion);
    }
    if (message.aikidoVersion !== "") {
      writer.uint32(26).string(message.aikidoVersion);
    }
    if (message.tamVersion !== "") {
      writer.uint32(34).string(message.tamVersion);
    }
    if (message.cpldlVersion !== "") {
      writer.uint32(42).string(message.cpldlVersion);
    }
    if (message.cpldgVersion !== "") {
      writer.uint32(50).string(message.cpldgVersion);
    }
    if (message.cpldrVersion !== "") {
      writer.uint32(58).string(message.cpldrVersion);
    }
    if (message.ssdVersion !== "") {
      writer.uint32(66).string(message.ssdVersion);
    }
    if (message.iofpgaVersion !== "") {
      writer.uint32(74).string(message.iofpgaVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FirmwareVersion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFirmwareVersion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.biosVersion = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.aikidoVersion = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tamVersion = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.cpldlVersion = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.cpldgVersion = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.cpldrVersion = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.ssdVersion = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.iofpgaVersion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FirmwareVersion {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      biosVersion: isSet(object.biosVersion) ? globalThis.String(object.biosVersion) : "",
      aikidoVersion: isSet(object.aikidoVersion) ? globalThis.String(object.aikidoVersion) : "",
      tamVersion: isSet(object.tamVersion) ? globalThis.String(object.tamVersion) : "",
      cpldlVersion: isSet(object.cpldlVersion) ? globalThis.String(object.cpldlVersion) : "",
      cpldgVersion: isSet(object.cpldgVersion) ? globalThis.String(object.cpldgVersion) : "",
      cpldrVersion: isSet(object.cpldrVersion) ? globalThis.String(object.cpldrVersion) : "",
      ssdVersion: isSet(object.ssdVersion) ? globalThis.String(object.ssdVersion) : "",
      iofpgaVersion: isSet(object.iofpgaVersion) ? globalThis.String(object.iofpgaVersion) : "",
    };
  },

  toJSON(message: FirmwareVersion): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.biosVersion !== "") {
      obj.biosVersion = message.biosVersion;
    }
    if (message.aikidoVersion !== "") {
      obj.aikidoVersion = message.aikidoVersion;
    }
    if (message.tamVersion !== "") {
      obj.tamVersion = message.tamVersion;
    }
    if (message.cpldlVersion !== "") {
      obj.cpldlVersion = message.cpldlVersion;
    }
    if (message.cpldgVersion !== "") {
      obj.cpldgVersion = message.cpldgVersion;
    }
    if (message.cpldrVersion !== "") {
      obj.cpldrVersion = message.cpldrVersion;
    }
    if (message.ssdVersion !== "") {
      obj.ssdVersion = message.ssdVersion;
    }
    if (message.iofpgaVersion !== "") {
      obj.iofpgaVersion = message.iofpgaVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FirmwareVersion>, I>>(base?: I): FirmwareVersion {
    return FirmwareVersion.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FirmwareVersion>, I>>(object: I): FirmwareVersion {
    const message = createBaseFirmwareVersion();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.biosVersion = object.biosVersion ?? "";
    message.aikidoVersion = object.aikidoVersion ?? "";
    message.tamVersion = object.tamVersion ?? "";
    message.cpldlVersion = object.cpldlVersion ?? "";
    message.cpldgVersion = object.cpldgVersion ?? "";
    message.cpldrVersion = object.cpldrVersion ?? "";
    message.ssdVersion = object.ssdVersion ?? "";
    message.iofpgaVersion = object.iofpgaVersion ?? "";
    return message;
  },
};

function createBaseNodeConfig(): NodeConfig {
  return {
    id: undefined,
    nodeId: "",
    fabricId: "",
    deviceId: "",
    name: "",
    type: 0,
    adminState: 0,
    description: "",
    serialNumber: "",
    modelName: "",
    role: 0,
    osType: 0,
    modifiedAt: undefined,
    tags: [],
    orgId: "",
    configFp: "",
    bound: false,
    claimedAt: undefined,
    activeGpuSlots: [],
    activeGpuBitmap: 0,
    monitored: false,
    releaseTag: "",
    targetTag: "",
    holddownFp: "",
    manifestAuxFp: "",
  };
}

export const NodeConfig: MessageFns<NodeConfig> = {
  encode(message: NodeConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.fabricId !== "") {
      writer.uint32(26).string(message.fabricId);
    }
    if (message.deviceId !== "") {
      writer.uint32(34).string(message.deviceId);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.type !== 0) {
      writer.uint32(48).int32(message.type);
    }
    if (message.adminState !== 0) {
      writer.uint32(56).int32(message.adminState);
    }
    if (message.description !== "") {
      writer.uint32(66).string(message.description);
    }
    if (message.serialNumber !== "") {
      writer.uint32(74).string(message.serialNumber);
    }
    if (message.modelName !== "") {
      writer.uint32(82).string(message.modelName);
    }
    if (message.role !== 0) {
      writer.uint32(96).int32(message.role);
    }
    if (message.osType !== 0) {
      writer.uint32(104).int32(message.osType);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(114).fork()).join();
    }
    for (const v of message.tags) {
      writer.uint32(122).string(v!);
    }
    if (message.orgId !== "") {
      writer.uint32(130).string(message.orgId);
    }
    if (message.configFp !== "") {
      writer.uint32(138).string(message.configFp);
    }
    if (message.bound !== false) {
      writer.uint32(144).bool(message.bound);
    }
    if (message.claimedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.claimedAt), writer.uint32(154).fork()).join();
    }
    writer.uint32(162).fork();
    for (const v of message.activeGpuSlots) {
      writer.uint32(v);
    }
    writer.join();
    if (message.activeGpuBitmap !== 0) {
      writer.uint32(168).uint32(message.activeGpuBitmap);
    }
    if (message.monitored !== false) {
      writer.uint32(176).bool(message.monitored);
    }
    if (message.releaseTag !== "") {
      writer.uint32(186).string(message.releaseTag);
    }
    if (message.targetTag !== "") {
      writer.uint32(194).string(message.targetTag);
    }
    if (message.holddownFp !== "") {
      writer.uint32(202).string(message.holddownFp);
    }
    if (message.manifestAuxFp !== "") {
      writer.uint32(210).string(message.manifestAuxFp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNodeConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.adminState = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.osType = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.configFp = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.bound = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.claimedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag === 160) {
            message.activeGpuSlots.push(reader.uint32());

            continue;
          }

          if (tag === 162) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.activeGpuSlots.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.activeGpuBitmap = reader.uint32();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.monitored = reader.bool();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.releaseTag = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.targetTag = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.holddownFp = reader.string();
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.manifestAuxFp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NodeConfig {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      type: isSet(object.type) ? nodeTypeFromJSON(object.type) : 0,
      adminState: isSet(object.adminState) ? adminStateFromJSON(object.adminState) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      role: isSet(object.role) ? nodeRoleFromJSON(object.role) : 0,
      osType: isSet(object.osType) ? osTypeFromJSON(object.osType) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      configFp: isSet(object.configFp) ? globalThis.String(object.configFp) : "",
      bound: isSet(object.bound) ? globalThis.Boolean(object.bound) : false,
      claimedAt: isSet(object.claimedAt) ? fromJsonTimestamp(object.claimedAt) : undefined,
      activeGpuSlots: globalThis.Array.isArray(object?.activeGpuSlots)
        ? object.activeGpuSlots.map((e: any) => globalThis.Number(e))
        : [],
      activeGpuBitmap: isSet(object.activeGpuBitmap) ? globalThis.Number(object.activeGpuBitmap) : 0,
      monitored: isSet(object.monitored) ? globalThis.Boolean(object.monitored) : false,
      releaseTag: isSet(object.releaseTag) ? globalThis.String(object.releaseTag) : "",
      targetTag: isSet(object.targetTag) ? globalThis.String(object.targetTag) : "",
      holddownFp: isSet(object.holddownFp) ? globalThis.String(object.holddownFp) : "",
      manifestAuxFp: isSet(object.manifestAuxFp) ? globalThis.String(object.manifestAuxFp) : "",
    };
  },

  toJSON(message: NodeConfig): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.type !== 0) {
      obj.type = nodeTypeToJSON(message.type);
    }
    if (message.adminState !== 0) {
      obj.adminState = adminStateToJSON(message.adminState);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.role !== 0) {
      obj.role = nodeRoleToJSON(message.role);
    }
    if (message.osType !== 0) {
      obj.osType = osTypeToJSON(message.osType);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.configFp !== "") {
      obj.configFp = message.configFp;
    }
    if (message.bound !== false) {
      obj.bound = message.bound;
    }
    if (message.claimedAt !== undefined) {
      obj.claimedAt = message.claimedAt.toISOString();
    }
    if (message.activeGpuSlots?.length) {
      obj.activeGpuSlots = message.activeGpuSlots.map((e) => Math.round(e));
    }
    if (message.activeGpuBitmap !== 0) {
      obj.activeGpuBitmap = Math.round(message.activeGpuBitmap);
    }
    if (message.monitored !== false) {
      obj.monitored = message.monitored;
    }
    if (message.releaseTag !== "") {
      obj.releaseTag = message.releaseTag;
    }
    if (message.targetTag !== "") {
      obj.targetTag = message.targetTag;
    }
    if (message.holddownFp !== "") {
      obj.holddownFp = message.holddownFp;
    }
    if (message.manifestAuxFp !== "") {
      obj.manifestAuxFp = message.manifestAuxFp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodeConfig>, I>>(base?: I): NodeConfig {
    return NodeConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeConfig>, I>>(object: I): NodeConfig {
    const message = createBaseNodeConfig();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.nodeId = object.nodeId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.deviceId = object.deviceId ?? "";
    message.name = object.name ?? "";
    message.type = object.type ?? 0;
    message.adminState = object.adminState ?? 0;
    message.description = object.description ?? "";
    message.serialNumber = object.serialNumber ?? "";
    message.modelName = object.modelName ?? "";
    message.role = object.role ?? 0;
    message.osType = object.osType ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.tags = object.tags?.map((e) => e) || [];
    message.orgId = object.orgId ?? "";
    message.configFp = object.configFp ?? "";
    message.bound = object.bound ?? false;
    message.claimedAt = object.claimedAt ?? undefined;
    message.activeGpuSlots = object.activeGpuSlots?.map((e) => e) || [];
    message.activeGpuBitmap = object.activeGpuBitmap ?? 0;
    message.monitored = object.monitored ?? false;
    message.releaseTag = object.releaseTag ?? "";
    message.targetTag = object.targetTag ?? "";
    message.holddownFp = object.holddownFp ?? "";
    message.manifestAuxFp = object.manifestAuxFp ?? "";
    return message;
  },
};

function createBaseFan(): Fan {
  return {
    id: undefined,
    speed: 0,
    name: "",
    deprecatedDirection: "",
    status: 0,
    ledStatus: 0,
    drawer: "",
    collectedAt: undefined,
    direction: 0,
    serial: "",
    model: "",
  };
}

export const Fan: MessageFns<Fan> = {
  encode(message: Fan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.speed !== 0) {
      writer.uint32(24).uint32(message.speed);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.deprecatedDirection !== "") {
      writer.uint32(42).string(message.deprecatedDirection);
    }
    if (message.status !== 0) {
      writer.uint32(48).int32(message.status);
    }
    if (message.ledStatus !== 0) {
      writer.uint32(56).int32(message.ledStatus);
    }
    if (message.drawer !== "") {
      writer.uint32(66).string(message.drawer);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(74).fork()).join();
    }
    if (message.direction !== 0) {
      writer.uint32(80).int32(message.direction);
    }
    if (message.serial !== "") {
      writer.uint32(90).string(message.serial);
    }
    if (message.model !== "") {
      writer.uint32(98).string(message.model);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Fan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.speed = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.deprecatedDirection = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.ledStatus = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.drawer = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.direction = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.model = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Fan {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      speed: isSet(object.speed) ? globalThis.Number(object.speed) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      deprecatedDirection: isSet(object.deprecatedDirection) ? globalThis.String(object.deprecatedDirection) : "",
      status: isSet(object.status) ? envStatusFromJSON(object.status) : 0,
      ledStatus: isSet(object.ledStatus) ? envLedStatusFromJSON(object.ledStatus) : 0,
      drawer: isSet(object.drawer) ? globalThis.String(object.drawer) : "",
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      direction: isSet(object.direction) ? fanDirectionFromJSON(object.direction) : 0,
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      model: isSet(object.model) ? globalThis.String(object.model) : "",
    };
  },

  toJSON(message: Fan): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.speed !== 0) {
      obj.speed = Math.round(message.speed);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.deprecatedDirection !== "") {
      obj.deprecatedDirection = message.deprecatedDirection;
    }
    if (message.status !== 0) {
      obj.status = envStatusToJSON(message.status);
    }
    if (message.ledStatus !== 0) {
      obj.ledStatus = envLedStatusToJSON(message.ledStatus);
    }
    if (message.drawer !== "") {
      obj.drawer = message.drawer;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.direction !== 0) {
      obj.direction = fanDirectionToJSON(message.direction);
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Fan>, I>>(base?: I): Fan {
    return Fan.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Fan>, I>>(object: I): Fan {
    const message = createBaseFan();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.speed = object.speed ?? 0;
    message.name = object.name ?? "";
    message.deprecatedDirection = object.deprecatedDirection ?? "";
    message.status = object.status ?? 0;
    message.ledStatus = object.ledStatus ?? 0;
    message.drawer = object.drawer ?? "";
    message.collectedAt = object.collectedAt ?? undefined;
    message.direction = object.direction ?? 0;
    message.serial = object.serial ?? "";
    message.model = object.model ?? "";
    return message;
  },
};

function createBaseProcTable(): ProcTable {
  return { id: undefined, processes: [], collectedAt: undefined };
}

export const ProcTable: MessageFns<ProcTable> = {
  encode(message: ProcTable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    for (const v of message.processes) {
      Process.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProcTable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcTable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.processes.push(Process.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProcTable {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      processes: globalThis.Array.isArray(object?.processes)
        ? object.processes.map((e: any) => Process.fromJSON(e))
        : [],
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: ProcTable): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.processes?.length) {
      obj.processes = message.processes.map((e) => Process.toJSON(e));
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProcTable>, I>>(base?: I): ProcTable {
    return ProcTable.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProcTable>, I>>(object: I): ProcTable {
    const message = createBaseProcTable();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.processes = object.processes?.map((e) => Process.fromPartial(e)) || [];
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseProcess(): Process {
  return { cpuPercent: 0, memPercent: 0, cmd: "", cpuTimeS: "0" };
}

export const Process: MessageFns<Process> = {
  encode(message: Process, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cpuPercent !== 0) {
      writer.uint32(21).float(message.cpuPercent);
    }
    if (message.memPercent !== 0) {
      writer.uint32(29).float(message.memPercent);
    }
    if (message.cmd !== "") {
      writer.uint32(34).string(message.cmd);
    }
    if (message.cpuTimeS !== "0") {
      writer.uint32(40).uint64(message.cpuTimeS);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Process {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcess();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.cpuPercent = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.memPercent = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.cmd = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.cpuTimeS = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Process {
    return {
      cpuPercent: isSet(object.cpuPercent) ? globalThis.Number(object.cpuPercent) : 0,
      memPercent: isSet(object.memPercent) ? globalThis.Number(object.memPercent) : 0,
      cmd: isSet(object.cmd) ? globalThis.String(object.cmd) : "",
      cpuTimeS: isSet(object.cpuTimeS) ? globalThis.String(object.cpuTimeS) : "0",
    };
  },

  toJSON(message: Process): unknown {
    const obj: any = {};
    if (message.cpuPercent !== 0) {
      obj.cpuPercent = message.cpuPercent;
    }
    if (message.memPercent !== 0) {
      obj.memPercent = message.memPercent;
    }
    if (message.cmd !== "") {
      obj.cmd = message.cmd;
    }
    if (message.cpuTimeS !== "0") {
      obj.cpuTimeS = message.cpuTimeS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Process>, I>>(base?: I): Process {
    return Process.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Process>, I>>(object: I): Process {
    const message = createBaseProcess();
    message.cpuPercent = object.cpuPercent ?? 0;
    message.memPercent = object.memPercent ?? 0;
    message.cmd = object.cmd ?? "";
    message.cpuTimeS = object.cpuTimeS ?? "0";
    return message;
  },
};

function createBasePsu(): Psu {
  return {
    id: undefined,
    watts: 0,
    fanSpeed: 0,
    name: "",
    status: 0,
    ledStatus: 0,
    model: "",
    serial: "",
    voltage: 0,
    current: 0,
  };
}

export const Psu: MessageFns<Psu> = {
  encode(message: Psu, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.watts !== 0) {
      writer.uint32(24).uint32(message.watts);
    }
    if (message.fanSpeed !== 0) {
      writer.uint32(32).uint32(message.fanSpeed);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.status !== 0) {
      writer.uint32(48).int32(message.status);
    }
    if (message.ledStatus !== 0) {
      writer.uint32(56).int32(message.ledStatus);
    }
    if (message.model !== "") {
      writer.uint32(66).string(message.model);
    }
    if (message.serial !== "") {
      writer.uint32(74).string(message.serial);
    }
    if (message.voltage !== 0) {
      writer.uint32(85).float(message.voltage);
    }
    if (message.current !== 0) {
      writer.uint32(93).float(message.current);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Psu {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePsu();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.watts = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.fanSpeed = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.ledStatus = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.voltage = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.current = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Psu {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      watts: isSet(object.watts) ? globalThis.Number(object.watts) : 0,
      fanSpeed: isSet(object.fanSpeed) ? globalThis.Number(object.fanSpeed) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      status: isSet(object.status) ? envStatusFromJSON(object.status) : 0,
      ledStatus: isSet(object.ledStatus) ? envLedStatusFromJSON(object.ledStatus) : 0,
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      voltage: isSet(object.voltage) ? globalThis.Number(object.voltage) : 0,
      current: isSet(object.current) ? globalThis.Number(object.current) : 0,
    };
  },

  toJSON(message: Psu): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.watts !== 0) {
      obj.watts = Math.round(message.watts);
    }
    if (message.fanSpeed !== 0) {
      obj.fanSpeed = Math.round(message.fanSpeed);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.status !== 0) {
      obj.status = envStatusToJSON(message.status);
    }
    if (message.ledStatus !== 0) {
      obj.ledStatus = envLedStatusToJSON(message.ledStatus);
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.voltage !== 0) {
      obj.voltage = message.voltage;
    }
    if (message.current !== 0) {
      obj.current = message.current;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Psu>, I>>(base?: I): Psu {
    return Psu.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Psu>, I>>(object: I): Psu {
    const message = createBasePsu();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.watts = object.watts ?? 0;
    message.fanSpeed = object.fanSpeed ?? 0;
    message.name = object.name ?? "";
    message.status = object.status ?? 0;
    message.ledStatus = object.ledStatus ?? 0;
    message.model = object.model ?? "";
    message.serial = object.serial ?? "";
    message.voltage = object.voltage ?? 0;
    message.current = object.current ?? 0;
    return message;
  },
};

function createBaseTempSensor(): TempSensor {
  return { id: undefined, degC: 0, degCelsius: 0, highThreshold: 0, lowThreshold: 0, category: 0 };
}

export const TempSensor: MessageFns<TempSensor> = {
  encode(message: TempSensor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.degC !== 0) {
      writer.uint32(24).uint32(message.degC);
    }
    if (message.degCelsius !== 0) {
      writer.uint32(32).int32(message.degCelsius);
    }
    if (message.highThreshold !== 0) {
      writer.uint32(40).uint32(message.highThreshold);
    }
    if (message.lowThreshold !== 0) {
      writer.uint32(48).int32(message.lowThreshold);
    }
    if (message.category !== 0) {
      writer.uint32(56).int32(message.category);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TempSensor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTempSensor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.degC = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.degCelsius = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.highThreshold = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.lowThreshold = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TempSensor {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      degC: isSet(object.degC) ? globalThis.Number(object.degC) : 0,
      degCelsius: isSet(object.degCelsius) ? globalThis.Number(object.degCelsius) : 0,
      highThreshold: isSet(object.highThreshold) ? globalThis.Number(object.highThreshold) : 0,
      lowThreshold: isSet(object.lowThreshold) ? globalThis.Number(object.lowThreshold) : 0,
      category: isSet(object.category) ? temperatureSensorCategoryFromJSON(object.category) : 0,
    };
  },

  toJSON(message: TempSensor): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.degC !== 0) {
      obj.degC = Math.round(message.degC);
    }
    if (message.degCelsius !== 0) {
      obj.degCelsius = Math.round(message.degCelsius);
    }
    if (message.highThreshold !== 0) {
      obj.highThreshold = Math.round(message.highThreshold);
    }
    if (message.lowThreshold !== 0) {
      obj.lowThreshold = Math.round(message.lowThreshold);
    }
    if (message.category !== 0) {
      obj.category = temperatureSensorCategoryToJSON(message.category);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TempSensor>, I>>(base?: I): TempSensor {
    return TempSensor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TempSensor>, I>>(object: I): TempSensor {
    const message = createBaseTempSensor();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.degC = object.degC ?? 0;
    message.degCelsius = object.degCelsius ?? 0;
    message.highThreshold = object.highThreshold ?? 0;
    message.lowThreshold = object.lowThreshold ?? 0;
    message.category = object.category ?? 0;
    return message;
  },
};

function createBaseProxyStats(): ProxyStats {
  return {
    id: undefined,
    reqCount: "0",
    reqErrors: "0",
    respCount: "0",
    respErrors: "0",
    minRtt: 0,
    maxRtt: 0,
    meanRtt: 0,
    medianRtt: 0,
  };
}

export const ProxyStats: MessageFns<ProxyStats> = {
  encode(message: ProxyStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.reqCount !== "0") {
      writer.uint32(24).uint64(message.reqCount);
    }
    if (message.reqErrors !== "0") {
      writer.uint32(32).uint64(message.reqErrors);
    }
    if (message.respCount !== "0") {
      writer.uint32(40).uint64(message.respCount);
    }
    if (message.respErrors !== "0") {
      writer.uint32(48).uint64(message.respErrors);
    }
    if (message.minRtt !== 0) {
      writer.uint32(56).uint32(message.minRtt);
    }
    if (message.maxRtt !== 0) {
      writer.uint32(64).uint32(message.maxRtt);
    }
    if (message.meanRtt !== 0) {
      writer.uint32(72).uint32(message.meanRtt);
    }
    if (message.medianRtt !== 0) {
      writer.uint32(80).uint32(message.medianRtt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProxyStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProxyStats();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.reqCount = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.reqErrors = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.respCount = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.respErrors = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.minRtt = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.maxRtt = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.meanRtt = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.medianRtt = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProxyStats {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      reqCount: isSet(object.reqCount) ? globalThis.String(object.reqCount) : "0",
      reqErrors: isSet(object.reqErrors) ? globalThis.String(object.reqErrors) : "0",
      respCount: isSet(object.respCount) ? globalThis.String(object.respCount) : "0",
      respErrors: isSet(object.respErrors) ? globalThis.String(object.respErrors) : "0",
      minRtt: isSet(object.minRtt) ? globalThis.Number(object.minRtt) : 0,
      maxRtt: isSet(object.maxRtt) ? globalThis.Number(object.maxRtt) : 0,
      meanRtt: isSet(object.meanRtt) ? globalThis.Number(object.meanRtt) : 0,
      medianRtt: isSet(object.medianRtt) ? globalThis.Number(object.medianRtt) : 0,
    };
  },

  toJSON(message: ProxyStats): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.reqCount !== "0") {
      obj.reqCount = message.reqCount;
    }
    if (message.reqErrors !== "0") {
      obj.reqErrors = message.reqErrors;
    }
    if (message.respCount !== "0") {
      obj.respCount = message.respCount;
    }
    if (message.respErrors !== "0") {
      obj.respErrors = message.respErrors;
    }
    if (message.minRtt !== 0) {
      obj.minRtt = Math.round(message.minRtt);
    }
    if (message.maxRtt !== 0) {
      obj.maxRtt = Math.round(message.maxRtt);
    }
    if (message.meanRtt !== 0) {
      obj.meanRtt = Math.round(message.meanRtt);
    }
    if (message.medianRtt !== 0) {
      obj.medianRtt = Math.round(message.medianRtt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProxyStats>, I>>(base?: I): ProxyStats {
    return ProxyStats.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProxyStats>, I>>(object: I): ProxyStats {
    const message = createBaseProxyStats();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.reqCount = object.reqCount ?? "0";
    message.reqErrors = object.reqErrors ?? "0";
    message.respCount = object.respCount ?? "0";
    message.respErrors = object.respErrors ?? "0";
    message.minRtt = object.minRtt ?? 0;
    message.maxRtt = object.maxRtt ?? 0;
    message.meanRtt = object.meanRtt ?? 0;
    message.medianRtt = object.medianRtt ?? 0;
    return message;
  },
};

function createBaseUnderlayInfo(): UnderlayInfo {
  return { id: undefined, proxySessionInfo: undefined, gatewayInfo: undefined };
}

export const UnderlayInfo: MessageFns<UnderlayInfo> = {
  encode(message: UnderlayInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.proxySessionInfo !== undefined) {
      ProxySessionInfo.encode(message.proxySessionInfo, writer.uint32(26).fork()).join();
    }
    if (message.gatewayInfo !== undefined) {
      GatewayInfo.encode(message.gatewayInfo, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnderlayInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnderlayInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.proxySessionInfo = ProxySessionInfo.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.gatewayInfo = GatewayInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnderlayInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      proxySessionInfo: isSet(object.proxySessionInfo) ? ProxySessionInfo.fromJSON(object.proxySessionInfo) : undefined,
      gatewayInfo: isSet(object.gatewayInfo) ? GatewayInfo.fromJSON(object.gatewayInfo) : undefined,
    };
  },

  toJSON(message: UnderlayInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.proxySessionInfo !== undefined) {
      obj.proxySessionInfo = ProxySessionInfo.toJSON(message.proxySessionInfo);
    }
    if (message.gatewayInfo !== undefined) {
      obj.gatewayInfo = GatewayInfo.toJSON(message.gatewayInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnderlayInfo>, I>>(base?: I): UnderlayInfo {
    return UnderlayInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnderlayInfo>, I>>(object: I): UnderlayInfo {
    const message = createBaseUnderlayInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.proxySessionInfo = (object.proxySessionInfo !== undefined && object.proxySessionInfo !== null)
      ? ProxySessionInfo.fromPartial(object.proxySessionInfo)
      : undefined;
    message.gatewayInfo = (object.gatewayInfo !== undefined && object.gatewayInfo !== null)
      ? GatewayInfo.fromPartial(object.gatewayInfo)
      : undefined;
    return message;
  },
};

function createBaseProxySessionInfo(): ProxySessionInfo {
  return { proxyAuthState: 0, certChain: [], initiatedAt: undefined, validUntil: undefined };
}

export const ProxySessionInfo: MessageFns<ProxySessionInfo> = {
  encode(message: ProxySessionInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.proxyAuthState !== 0) {
      writer.uint32(8).int32(message.proxyAuthState);
    }
    for (const v of message.certChain) {
      writer.uint32(18).string(v!);
    }
    if (message.initiatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.initiatedAt), writer.uint32(26).fork()).join();
    }
    if (message.validUntil !== undefined) {
      Timestamp.encode(toTimestamp(message.validUntil), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProxySessionInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProxySessionInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.proxyAuthState = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.certChain.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.initiatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.validUntil = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProxySessionInfo {
    return {
      proxyAuthState: isSet(object.proxyAuthState) ? proxyAuthStateFromJSON(object.proxyAuthState) : 0,
      certChain: globalThis.Array.isArray(object?.certChain)
        ? object.certChain.map((e: any) => globalThis.String(e))
        : [],
      initiatedAt: isSet(object.initiatedAt) ? fromJsonTimestamp(object.initiatedAt) : undefined,
      validUntil: isSet(object.validUntil) ? fromJsonTimestamp(object.validUntil) : undefined,
    };
  },

  toJSON(message: ProxySessionInfo): unknown {
    const obj: any = {};
    if (message.proxyAuthState !== 0) {
      obj.proxyAuthState = proxyAuthStateToJSON(message.proxyAuthState);
    }
    if (message.certChain?.length) {
      obj.certChain = message.certChain;
    }
    if (message.initiatedAt !== undefined) {
      obj.initiatedAt = message.initiatedAt.toISOString();
    }
    if (message.validUntil !== undefined) {
      obj.validUntil = message.validUntil.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProxySessionInfo>, I>>(base?: I): ProxySessionInfo {
    return ProxySessionInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProxySessionInfo>, I>>(object: I): ProxySessionInfo {
    const message = createBaseProxySessionInfo();
    message.proxyAuthState = object.proxyAuthState ?? 0;
    message.certChain = object.certChain?.map((e) => e) || [];
    message.initiatedAt = object.initiatedAt ?? undefined;
    message.validUntil = object.validUntil ?? undefined;
    return message;
  },
};

function createBaseProxyConnectionState(): ProxyConnectionState {
  return {
    id: undefined,
    sourcePort: 0,
    destPort: 0,
    sourceIp: "",
    destIp: "",
    outerTlsConnectionState: 0,
    outerTlsSessionState: 0,
    outerTlsErr: "",
    innerTlsConnectionState: 0,
    innerTlsErr: "",
    outerTlsLeafCert: "",
    outerTlsIntermediateCerts: [],
    outerTlsRootCerts: [],
    outerTlsVerifyErr: 0,
    outerTlsVerifyErrString: "",
    proxyUrl: "",
    source: "",
    fabricPath: "",
    initiatedAt: undefined,
    collectedAt: undefined,
  };
}

export const ProxyConnectionState: MessageFns<ProxyConnectionState> = {
  encode(message: ProxyConnectionState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.sourcePort !== 0) {
      writer.uint32(24).uint32(message.sourcePort);
    }
    if (message.destPort !== 0) {
      writer.uint32(32).uint32(message.destPort);
    }
    if (message.sourceIp !== "") {
      writer.uint32(42).string(message.sourceIp);
    }
    if (message.destIp !== "") {
      writer.uint32(50).string(message.destIp);
    }
    if (message.outerTlsConnectionState !== 0) {
      writer.uint32(56).int32(message.outerTlsConnectionState);
    }
    if (message.outerTlsSessionState !== 0) {
      writer.uint32(64).int32(message.outerTlsSessionState);
    }
    if (message.outerTlsErr !== "") {
      writer.uint32(74).string(message.outerTlsErr);
    }
    if (message.innerTlsConnectionState !== 0) {
      writer.uint32(80).int32(message.innerTlsConnectionState);
    }
    if (message.innerTlsErr !== "") {
      writer.uint32(90).string(message.innerTlsErr);
    }
    if (message.outerTlsLeafCert !== "") {
      writer.uint32(98).string(message.outerTlsLeafCert);
    }
    for (const v of message.outerTlsIntermediateCerts) {
      writer.uint32(106).string(v!);
    }
    for (const v of message.outerTlsRootCerts) {
      writer.uint32(114).string(v!);
    }
    if (message.outerTlsVerifyErr !== 0) {
      writer.uint32(144).int32(message.outerTlsVerifyErr);
    }
    if (message.outerTlsVerifyErrString !== "") {
      writer.uint32(154).string(message.outerTlsVerifyErrString);
    }
    if (message.proxyUrl !== "") {
      writer.uint32(138).string(message.proxyUrl);
    }
    if (message.source !== "") {
      writer.uint32(162).string(message.source);
    }
    if (message.fabricPath !== "") {
      writer.uint32(170).string(message.fabricPath);
    }
    if (message.initiatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.initiatedAt), writer.uint32(122).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(130).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProxyConnectionState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProxyConnectionState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.sourcePort = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.destPort = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sourceIp = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.destIp = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.outerTlsConnectionState = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.outerTlsSessionState = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.outerTlsErr = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.innerTlsConnectionState = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.innerTlsErr = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.outerTlsLeafCert = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.outerTlsIntermediateCerts.push(reader.string());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.outerTlsRootCerts.push(reader.string());
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.outerTlsVerifyErr = reader.int32() as any;
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.outerTlsVerifyErrString = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.proxyUrl = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.source = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.fabricPath = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.initiatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProxyConnectionState {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      sourcePort: isSet(object.sourcePort) ? globalThis.Number(object.sourcePort) : 0,
      destPort: isSet(object.destPort) ? globalThis.Number(object.destPort) : 0,
      sourceIp: isSet(object.sourceIp) ? globalThis.String(object.sourceIp) : "",
      destIp: isSet(object.destIp) ? globalThis.String(object.destIp) : "",
      outerTlsConnectionState: isSet(object.outerTlsConnectionState)
        ? tlsConnectionStateFromJSON(object.outerTlsConnectionState)
        : 0,
      outerTlsSessionState: isSet(object.outerTlsSessionState)
        ? tlsSessionStateFromJSON(object.outerTlsSessionState)
        : 0,
      outerTlsErr: isSet(object.outerTlsErr) ? globalThis.String(object.outerTlsErr) : "",
      innerTlsConnectionState: isSet(object.innerTlsConnectionState)
        ? tlsConnectionStateFromJSON(object.innerTlsConnectionState)
        : 0,
      innerTlsErr: isSet(object.innerTlsErr) ? globalThis.String(object.innerTlsErr) : "",
      outerTlsLeafCert: isSet(object.outerTlsLeafCert) ? globalThis.String(object.outerTlsLeafCert) : "",
      outerTlsIntermediateCerts: globalThis.Array.isArray(object?.outerTlsIntermediateCerts)
        ? object.outerTlsIntermediateCerts.map((e: any) => globalThis.String(e))
        : [],
      outerTlsRootCerts: globalThis.Array.isArray(object?.outerTlsRootCerts)
        ? object.outerTlsRootCerts.map((e: any) => globalThis.String(e))
        : [],
      outerTlsVerifyErr: isSet(object.outerTlsVerifyErr) ? tLSVerifyErrorFromJSON(object.outerTlsVerifyErr) : 0,
      outerTlsVerifyErrString: isSet(object.outerTlsVerifyErrString)
        ? globalThis.String(object.outerTlsVerifyErrString)
        : "",
      proxyUrl: isSet(object.proxyUrl) ? globalThis.String(object.proxyUrl) : "",
      source: isSet(object.source) ? globalThis.String(object.source) : "",
      fabricPath: isSet(object.fabricPath) ? globalThis.String(object.fabricPath) : "",
      initiatedAt: isSet(object.initiatedAt) ? fromJsonTimestamp(object.initiatedAt) : undefined,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: ProxyConnectionState): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.sourcePort !== 0) {
      obj.sourcePort = Math.round(message.sourcePort);
    }
    if (message.destPort !== 0) {
      obj.destPort = Math.round(message.destPort);
    }
    if (message.sourceIp !== "") {
      obj.sourceIp = message.sourceIp;
    }
    if (message.destIp !== "") {
      obj.destIp = message.destIp;
    }
    if (message.outerTlsConnectionState !== 0) {
      obj.outerTlsConnectionState = tlsConnectionStateToJSON(message.outerTlsConnectionState);
    }
    if (message.outerTlsSessionState !== 0) {
      obj.outerTlsSessionState = tlsSessionStateToJSON(message.outerTlsSessionState);
    }
    if (message.outerTlsErr !== "") {
      obj.outerTlsErr = message.outerTlsErr;
    }
    if (message.innerTlsConnectionState !== 0) {
      obj.innerTlsConnectionState = tlsConnectionStateToJSON(message.innerTlsConnectionState);
    }
    if (message.innerTlsErr !== "") {
      obj.innerTlsErr = message.innerTlsErr;
    }
    if (message.outerTlsLeafCert !== "") {
      obj.outerTlsLeafCert = message.outerTlsLeafCert;
    }
    if (message.outerTlsIntermediateCerts?.length) {
      obj.outerTlsIntermediateCerts = message.outerTlsIntermediateCerts;
    }
    if (message.outerTlsRootCerts?.length) {
      obj.outerTlsRootCerts = message.outerTlsRootCerts;
    }
    if (message.outerTlsVerifyErr !== 0) {
      obj.outerTlsVerifyErr = tLSVerifyErrorToJSON(message.outerTlsVerifyErr);
    }
    if (message.outerTlsVerifyErrString !== "") {
      obj.outerTlsVerifyErrString = message.outerTlsVerifyErrString;
    }
    if (message.proxyUrl !== "") {
      obj.proxyUrl = message.proxyUrl;
    }
    if (message.source !== "") {
      obj.source = message.source;
    }
    if (message.fabricPath !== "") {
      obj.fabricPath = message.fabricPath;
    }
    if (message.initiatedAt !== undefined) {
      obj.initiatedAt = message.initiatedAt.toISOString();
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProxyConnectionState>, I>>(base?: I): ProxyConnectionState {
    return ProxyConnectionState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProxyConnectionState>, I>>(object: I): ProxyConnectionState {
    const message = createBaseProxyConnectionState();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.sourcePort = object.sourcePort ?? 0;
    message.destPort = object.destPort ?? 0;
    message.sourceIp = object.sourceIp ?? "";
    message.destIp = object.destIp ?? "";
    message.outerTlsConnectionState = object.outerTlsConnectionState ?? 0;
    message.outerTlsSessionState = object.outerTlsSessionState ?? 0;
    message.outerTlsErr = object.outerTlsErr ?? "";
    message.innerTlsConnectionState = object.innerTlsConnectionState ?? 0;
    message.innerTlsErr = object.innerTlsErr ?? "";
    message.outerTlsLeafCert = object.outerTlsLeafCert ?? "";
    message.outerTlsIntermediateCerts = object.outerTlsIntermediateCerts?.map((e) => e) || [];
    message.outerTlsRootCerts = object.outerTlsRootCerts?.map((e) => e) || [];
    message.outerTlsVerifyErr = object.outerTlsVerifyErr ?? 0;
    message.outerTlsVerifyErrString = object.outerTlsVerifyErrString ?? "";
    message.proxyUrl = object.proxyUrl ?? "";
    message.source = object.source ?? "";
    message.fabricPath = object.fabricPath ?? "";
    message.initiatedAt = object.initiatedAt ?? undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseProxyConnectionStats(): ProxyConnectionStats {
  return { id: undefined, bytesIn: "0", bytesOut: "0", inBitsps: 0, outBitsps: 0, collectedAt: undefined };
}

export const ProxyConnectionStats: MessageFns<ProxyConnectionStats> = {
  encode(message: ProxyConnectionStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.bytesIn !== "0") {
      writer.uint32(24).uint64(message.bytesIn);
    }
    if (message.bytesOut !== "0") {
      writer.uint32(32).uint64(message.bytesOut);
    }
    if (message.inBitsps !== 0) {
      writer.uint32(45).float(message.inBitsps);
    }
    if (message.outBitsps !== 0) {
      writer.uint32(53).float(message.outBitsps);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProxyConnectionStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProxyConnectionStats();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.bytesIn = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.bytesOut = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.inBitsps = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.outBitsps = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProxyConnectionStats {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      bytesIn: isSet(object.bytesIn) ? globalThis.String(object.bytesIn) : "0",
      bytesOut: isSet(object.bytesOut) ? globalThis.String(object.bytesOut) : "0",
      inBitsps: isSet(object.inBitsps) ? globalThis.Number(object.inBitsps) : 0,
      outBitsps: isSet(object.outBitsps) ? globalThis.Number(object.outBitsps) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: ProxyConnectionStats): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.bytesIn !== "0") {
      obj.bytesIn = message.bytesIn;
    }
    if (message.bytesOut !== "0") {
      obj.bytesOut = message.bytesOut;
    }
    if (message.inBitsps !== 0) {
      obj.inBitsps = message.inBitsps;
    }
    if (message.outBitsps !== 0) {
      obj.outBitsps = message.outBitsps;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProxyConnectionStats>, I>>(base?: I): ProxyConnectionStats {
    return ProxyConnectionStats.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProxyConnectionStats>, I>>(object: I): ProxyConnectionStats {
    const message = createBaseProxyConnectionStats();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.bytesIn = object.bytesIn ?? "0";
    message.bytesOut = object.bytesOut ?? "0";
    message.inBitsps = object.inBitsps ?? 0;
    message.outBitsps = object.outBitsps ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseGatewayInfo(): GatewayInfo {
  return { isGateway: false };
}

export const GatewayInfo: MessageFns<GatewayInfo> = {
  encode(message: GatewayInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isGateway !== false) {
      writer.uint32(8).bool(message.isGateway);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GatewayInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGatewayInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isGateway = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GatewayInfo {
    return { isGateway: isSet(object.isGateway) ? globalThis.Boolean(object.isGateway) : false };
  },

  toJSON(message: GatewayInfo): unknown {
    const obj: any = {};
    if (message.isGateway !== false) {
      obj.isGateway = message.isGateway;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GatewayInfo>, I>>(base?: I): GatewayInfo {
    return GatewayInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GatewayInfo>, I>>(object: I): GatewayInfo {
    const message = createBaseGatewayInfo();
    message.isGateway = object.isGateway ?? false;
    return message;
  },
};

function createBaseLineCard(): LineCard {
  return { id: undefined };
}

export const LineCard: MessageFns<LineCard> = {
  encode(message: LineCard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LineCard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLineCard();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LineCard {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: LineCard): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LineCard>, I>>(base?: I): LineCard {
    return LineCard.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LineCard>, I>>(object: I): LineCard {
    const message = createBaseLineCard();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseBreakout(): Breakout {
  return { id: undefined, state: undefined };
}

export const Breakout: MessageFns<Breakout> = {
  encode(message: Breakout, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.state !== undefined) {
      PortState.encode(message.state, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Breakout {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBreakout();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.state = PortState.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Breakout {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      state: isSet(object.state) ? PortState.fromJSON(object.state) : undefined,
    };
  },

  toJSON(message: Breakout): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.state !== undefined) {
      obj.state = PortState.toJSON(message.state);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Breakout>, I>>(base?: I): Breakout {
    return Breakout.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Breakout>, I>>(object: I): Breakout {
    const message = createBaseBreakout();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.state = (object.state !== undefined && object.state !== null)
      ? PortState.fromPartial(object.state)
      : undefined;
    return message;
  },
};

function createBaseDacQsfp(): DacQsfp {
  return { id: undefined, counters: undefined };
}

export const DacQsfp: MessageFns<DacQsfp> = {
  encode(message: DacQsfp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.counters !== undefined) {
      DacCounters.encode(message.counters, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DacQsfp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDacQsfp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.counters = DacCounters.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DacQsfp {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      counters: isSet(object.counters) ? DacCounters.fromJSON(object.counters) : undefined,
    };
  },

  toJSON(message: DacQsfp): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.counters !== undefined) {
      obj.counters = DacCounters.toJSON(message.counters);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DacQsfp>, I>>(base?: I): DacQsfp {
    return DacQsfp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DacQsfp>, I>>(object: I): DacQsfp {
    const message = createBaseDacQsfp();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.counters = (object.counters !== undefined && object.counters !== null)
      ? DacCounters.fromPartial(object.counters)
      : undefined;
    return message;
  },
};

function createBaseDacCounters(): DacCounters {
  return { inOctets: "0" };
}

export const DacCounters: MessageFns<DacCounters> = {
  encode(message: DacCounters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.inOctets !== "0") {
      writer.uint32(16).uint64(message.inOctets);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DacCounters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDacCounters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.inOctets = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DacCounters {
    return { inOctets: isSet(object["in-octets"]) ? globalThis.String(object["in-octets"]) : "0" };
  },

  toJSON(message: DacCounters): unknown {
    const obj: any = {};
    if (message.inOctets !== "0") {
      obj["in-octets"] = message.inOctets;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DacCounters>, I>>(base?: I): DacCounters {
    return DacCounters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DacCounters>, I>>(object: I): DacCounters {
    const message = createBaseDacCounters();
    message.inOctets = object.inOctets ?? "0";
    return message;
  },
};

function createBaseFiberQsfp(): FiberQsfp {
  return { id: undefined, counters: undefined };
}

export const FiberQsfp: MessageFns<FiberQsfp> = {
  encode(message: FiberQsfp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.counters !== undefined) {
      FiberCounters.encode(message.counters, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FiberQsfp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFiberQsfp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.counters = FiberCounters.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FiberQsfp {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      counters: isSet(object.counters) ? FiberCounters.fromJSON(object.counters) : undefined,
    };
  },

  toJSON(message: FiberQsfp): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.counters !== undefined) {
      obj.counters = FiberCounters.toJSON(message.counters);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FiberQsfp>, I>>(base?: I): FiberQsfp {
    return FiberQsfp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FiberQsfp>, I>>(object: I): FiberQsfp {
    const message = createBaseFiberQsfp();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.counters = (object.counters !== undefined && object.counters !== null)
      ? FiberCounters.fromPartial(object.counters)
      : undefined;
    return message;
  },
};

function createBaseFiberCounters(): FiberCounters {
  return { inOctets: "0" };
}

export const FiberCounters: MessageFns<FiberCounters> = {
  encode(message: FiberCounters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.inOctets !== "0") {
      writer.uint32(16).uint64(message.inOctets);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FiberCounters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFiberCounters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.inOctets = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FiberCounters {
    return { inOctets: isSet(object["in-octets"]) ? globalThis.String(object["in-octets"]) : "0" };
  },

  toJSON(message: FiberCounters): unknown {
    const obj: any = {};
    if (message.inOctets !== "0") {
      obj["in-octets"] = message.inOctets;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FiberCounters>, I>>(base?: I): FiberCounters {
    return FiberCounters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FiberCounters>, I>>(object: I): FiberCounters {
    const message = createBaseFiberCounters();
    message.inOctets = object.inOctets ?? "0";
    return message;
  },
};

function createBasePortConfig(): PortConfig {
  return { id: undefined, config: undefined };
}

export const PortConfig: MessageFns<PortConfig> = {
  encode(message: PortConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      PortConfigDetails.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = PortConfigDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortConfig {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? PortConfigDetails.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: PortConfig): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = PortConfigDetails.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortConfig>, I>>(base?: I): PortConfig {
    return PortConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortConfig>, I>>(object: I): PortConfig {
    const message = createBasePortConfig();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? PortConfigDetails.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBasePortConfigDetails(): PortConfigDetails {
  return {
    portName: "",
    portIndex: 0,
    portRole: 0,
    adminState: 0,
    mtu: 0,
    deviceId: "",
    targetDeviceId: "",
    targetPortName: "",
    modifiedAt: undefined,
    breakOut: false,
    portAliasName: "",
  };
}

export const PortConfigDetails: MessageFns<PortConfigDetails> = {
  encode(message: PortConfigDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.portName !== "") {
      writer.uint32(10).string(message.portName);
    }
    if (message.portIndex !== 0) {
      writer.uint32(16).int32(message.portIndex);
    }
    if (message.portRole !== 0) {
      writer.uint32(24).int32(message.portRole);
    }
    if (message.adminState !== 0) {
      writer.uint32(32).int32(message.adminState);
    }
    if (message.mtu !== 0) {
      writer.uint32(40).uint32(message.mtu);
    }
    if (message.deviceId !== "") {
      writer.uint32(50).string(message.deviceId);
    }
    if (message.targetDeviceId !== "") {
      writer.uint32(58).string(message.targetDeviceId);
    }
    if (message.targetPortName !== "") {
      writer.uint32(66).string(message.targetPortName);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(74).fork()).join();
    }
    if (message.breakOut !== false) {
      writer.uint32(80).bool(message.breakOut);
    }
    if (message.portAliasName !== "") {
      writer.uint32(90).string(message.portAliasName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortConfigDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortConfigDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.portIndex = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.portRole = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.adminState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.mtu = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.targetDeviceId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.targetPortName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.breakOut = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.portAliasName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortConfigDetails {
    return {
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      portIndex: isSet(object.portIndex) ? globalThis.Number(object.portIndex) : 0,
      portRole: isSet(object.portRole) ? portRoleFromJSON(object.portRole) : 0,
      adminState: isSet(object.adminState) ? adminStateFromJSON(object.adminState) : 0,
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      targetDeviceId: isSet(object.targetDeviceId) ? globalThis.String(object.targetDeviceId) : "",
      targetPortName: isSet(object.targetPortName) ? globalThis.String(object.targetPortName) : "",
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      breakOut: isSet(object.breakOut) ? globalThis.Boolean(object.breakOut) : false,
      portAliasName: isSet(object.portAliasName) ? globalThis.String(object.portAliasName) : "",
    };
  },

  toJSON(message: PortConfigDetails): unknown {
    const obj: any = {};
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.portIndex !== 0) {
      obj.portIndex = Math.round(message.portIndex);
    }
    if (message.portRole !== 0) {
      obj.portRole = portRoleToJSON(message.portRole);
    }
    if (message.adminState !== 0) {
      obj.adminState = adminStateToJSON(message.adminState);
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.targetDeviceId !== "") {
      obj.targetDeviceId = message.targetDeviceId;
    }
    if (message.targetPortName !== "") {
      obj.targetPortName = message.targetPortName;
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.breakOut !== false) {
      obj.breakOut = message.breakOut;
    }
    if (message.portAliasName !== "") {
      obj.portAliasName = message.portAliasName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortConfigDetails>, I>>(base?: I): PortConfigDetails {
    return PortConfigDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortConfigDetails>, I>>(object: I): PortConfigDetails {
    const message = createBasePortConfigDetails();
    message.portName = object.portName ?? "";
    message.portIndex = object.portIndex ?? 0;
    message.portRole = object.portRole ?? 0;
    message.adminState = object.adminState ?? 0;
    message.mtu = object.mtu ?? 0;
    message.deviceId = object.deviceId ?? "";
    message.targetDeviceId = object.targetDeviceId ?? "";
    message.targetPortName = object.targetPortName ?? "";
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.breakOut = object.breakOut ?? false;
    message.portAliasName = object.portAliasName ?? "";
    return message;
  },
};

function createBasePort(): Port {
  return { id: undefined };
}

export const Port: MessageFns<Port> = {
  encode(message: Port, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Port {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Port {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: Port): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Port>, I>>(base?: I): Port {
    return Port.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Port>, I>>(object: I): Port {
    const message = createBasePort();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseSubInterface(): SubInterface {
  return { id: undefined, details: undefined };
}

export const SubInterface: MessageFns<SubInterface> = {
  encode(message: SubInterface, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.details !== undefined) {
      SubInterfaceDetails.encode(message.details, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubInterface {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubInterface();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.details = SubInterfaceDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubInterface {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      details: isSet(object.details) ? SubInterfaceDetails.fromJSON(object.details) : undefined,
    };
  },

  toJSON(message: SubInterface): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.details !== undefined) {
      obj.details = SubInterfaceDetails.toJSON(message.details);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubInterface>, I>>(base?: I): SubInterface {
    return SubInterface.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubInterface>, I>>(object: I): SubInterface {
    const message = createBaseSubInterface();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.details = (object.details !== undefined && object.details !== null)
      ? SubInterfaceDetails.fromPartial(object.details)
      : undefined;
    return message;
  },
};

function createBaseSubInterfaceDetails(): SubInterfaceDetails {
  return {
    subInterfaceName: "",
    portName: "",
    adminState: 0,
    operState: 0,
    mtu: 0,
    macAddr: "",
    vlan: 0,
    collectedAt: undefined,
  };
}

export const SubInterfaceDetails: MessageFns<SubInterfaceDetails> = {
  encode(message: SubInterfaceDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.subInterfaceName !== "") {
      writer.uint32(10).string(message.subInterfaceName);
    }
    if (message.portName !== "") {
      writer.uint32(18).string(message.portName);
    }
    if (message.adminState !== 0) {
      writer.uint32(24).int32(message.adminState);
    }
    if (message.operState !== 0) {
      writer.uint32(32).int32(message.operState);
    }
    if (message.mtu !== 0) {
      writer.uint32(40).int32(message.mtu);
    }
    if (message.macAddr !== "") {
      writer.uint32(50).string(message.macAddr);
    }
    if (message.vlan !== 0) {
      writer.uint32(56).int32(message.vlan);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubInterfaceDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubInterfaceDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.subInterfaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.adminState = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.operState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.mtu = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.macAddr = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.vlan = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubInterfaceDetails {
    return {
      subInterfaceName: isSet(object.subInterfaceName) ? globalThis.String(object.subInterfaceName) : "",
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      adminState: isSet(object.adminState) ? adminStateFromJSON(object.adminState) : 0,
      operState: isSet(object.operState) ? operStateFromJSON(object.operState) : 0,
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      macAddr: isSet(object.macAddr) ? globalThis.String(object.macAddr) : "",
      vlan: isSet(object.vlan) ? globalThis.Number(object.vlan) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: SubInterfaceDetails): unknown {
    const obj: any = {};
    if (message.subInterfaceName !== "") {
      obj.subInterfaceName = message.subInterfaceName;
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.adminState !== 0) {
      obj.adminState = adminStateToJSON(message.adminState);
    }
    if (message.operState !== 0) {
      obj.operState = operStateToJSON(message.operState);
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.macAddr !== "") {
      obj.macAddr = message.macAddr;
    }
    if (message.vlan !== 0) {
      obj.vlan = Math.round(message.vlan);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubInterfaceDetails>, I>>(base?: I): SubInterfaceDetails {
    return SubInterfaceDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubInterfaceDetails>, I>>(object: I): SubInterfaceDetails {
    const message = createBaseSubInterfaceDetails();
    message.subInterfaceName = object.subInterfaceName ?? "";
    message.portName = object.portName ?? "";
    message.adminState = object.adminState ?? 0;
    message.operState = object.operState ?? 0;
    message.mtu = object.mtu ?? 0;
    message.macAddr = object.macAddr ?? "";
    message.vlan = object.vlan ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBasePortCounters(): PortCounters {
  return {
    id: undefined,
    inOctets: "0",
    inPkts: "0",
    inUnicastPkts: "0",
    inBroadcastPkts: "0",
    inMulticastPkts: "0",
    inDiscards: "0",
    inErrors: "0",
    inUnknownProtos: "0",
    inFcsErrors: "0",
    outOctets: "0",
    outPkts: "0",
    outUnicastPkts: "0",
    outBroadcastPkts: "0",
    outMulticastPkts: "0",
    outDiscards: "0",
    outErrors: "0",
    carrierTransitions: "0",
    inPfc0Pkts: "0",
    outPfc0Pkts: "0",
    inPfc1Pkts: "0",
    outPfc1Pkts: "0",
    inPfc2Pkts: "0",
    outPfc2Pkts: "0",
    inPfc3Pkts: "0",
    outPfc3Pkts: "0",
    inPfc4Pkts: "0",
    outPfc4Pkts: "0",
    inPfc5Pkts: "0",
    outPfc5Pkts: "0",
    inPfc6Pkts: "0",
    outPfc6Pkts: "0",
    inPfc7Pkts: "0",
    outPfc7Pkts: "0",
    inBitsps: 0,
    outBitsps: 0,
    inPps: 0,
    outPps: 0,
    inUnicastPps: 0,
    outUnicastPps: 0,
    inPfcPps: 0,
    outPfcPps: 0,
    lastClear: undefined,
    collectedAt: undefined,
    portAlias: "",
  };
}

export const PortCounters: MessageFns<PortCounters> = {
  encode(message: PortCounters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.inOctets !== "0") {
      writer.uint32(16).uint64(message.inOctets);
    }
    if (message.inPkts !== "0") {
      writer.uint32(24).uint64(message.inPkts);
    }
    if (message.inUnicastPkts !== "0") {
      writer.uint32(32).uint64(message.inUnicastPkts);
    }
    if (message.inBroadcastPkts !== "0") {
      writer.uint32(160).uint64(message.inBroadcastPkts);
    }
    if (message.inMulticastPkts !== "0") {
      writer.uint32(40).uint64(message.inMulticastPkts);
    }
    if (message.inDiscards !== "0") {
      writer.uint32(48).uint64(message.inDiscards);
    }
    if (message.inErrors !== "0") {
      writer.uint32(56).uint64(message.inErrors);
    }
    if (message.inUnknownProtos !== "0") {
      writer.uint32(64).uint64(message.inUnknownProtos);
    }
    if (message.inFcsErrors !== "0") {
      writer.uint32(72).uint64(message.inFcsErrors);
    }
    if (message.outOctets !== "0") {
      writer.uint32(80).uint64(message.outOctets);
    }
    if (message.outPkts !== "0") {
      writer.uint32(88).uint64(message.outPkts);
    }
    if (message.outUnicastPkts !== "0") {
      writer.uint32(96).uint64(message.outUnicastPkts);
    }
    if (message.outBroadcastPkts !== "0") {
      writer.uint32(112).uint64(message.outBroadcastPkts);
    }
    if (message.outMulticastPkts !== "0") {
      writer.uint32(120).uint64(message.outMulticastPkts);
    }
    if (message.outDiscards !== "0") {
      writer.uint32(128).uint64(message.outDiscards);
    }
    if (message.outErrors !== "0") {
      writer.uint32(136).uint64(message.outErrors);
    }
    if (message.carrierTransitions !== "0") {
      writer.uint32(144).uint64(message.carrierTransitions);
    }
    if (message.inPfc0Pkts !== "0") {
      writer.uint32(176).uint64(message.inPfc0Pkts);
    }
    if (message.outPfc0Pkts !== "0") {
      writer.uint32(184).uint64(message.outPfc0Pkts);
    }
    if (message.inPfc1Pkts !== "0") {
      writer.uint32(192).uint64(message.inPfc1Pkts);
    }
    if (message.outPfc1Pkts !== "0") {
      writer.uint32(200).uint64(message.outPfc1Pkts);
    }
    if (message.inPfc2Pkts !== "0") {
      writer.uint32(208).uint64(message.inPfc2Pkts);
    }
    if (message.outPfc2Pkts !== "0") {
      writer.uint32(216).uint64(message.outPfc2Pkts);
    }
    if (message.inPfc3Pkts !== "0") {
      writer.uint32(224).uint64(message.inPfc3Pkts);
    }
    if (message.outPfc3Pkts !== "0") {
      writer.uint32(232).uint64(message.outPfc3Pkts);
    }
    if (message.inPfc4Pkts !== "0") {
      writer.uint32(240).uint64(message.inPfc4Pkts);
    }
    if (message.outPfc4Pkts !== "0") {
      writer.uint32(248).uint64(message.outPfc4Pkts);
    }
    if (message.inPfc5Pkts !== "0") {
      writer.uint32(256).uint64(message.inPfc5Pkts);
    }
    if (message.outPfc5Pkts !== "0") {
      writer.uint32(264).uint64(message.outPfc5Pkts);
    }
    if (message.inPfc6Pkts !== "0") {
      writer.uint32(272).uint64(message.inPfc6Pkts);
    }
    if (message.outPfc6Pkts !== "0") {
      writer.uint32(280).uint64(message.outPfc6Pkts);
    }
    if (message.inPfc7Pkts !== "0") {
      writer.uint32(288).uint64(message.inPfc7Pkts);
    }
    if (message.outPfc7Pkts !== "0") {
      writer.uint32(296).uint64(message.outPfc7Pkts);
    }
    if (message.inBitsps !== 0) {
      writer.uint32(309).float(message.inBitsps);
    }
    if (message.outBitsps !== 0) {
      writer.uint32(317).float(message.outBitsps);
    }
    if (message.inPps !== 0) {
      writer.uint32(325).float(message.inPps);
    }
    if (message.outPps !== 0) {
      writer.uint32(333).float(message.outPps);
    }
    if (message.inUnicastPps !== 0) {
      writer.uint32(341).float(message.inUnicastPps);
    }
    if (message.outUnicastPps !== 0) {
      writer.uint32(349).float(message.outUnicastPps);
    }
    if (message.inPfcPps !== 0) {
      writer.uint32(357).float(message.inPfcPps);
    }
    if (message.outPfcPps !== 0) {
      writer.uint32(365).float(message.outPfcPps);
    }
    if (message.lastClear !== undefined) {
      Timestamp.encode(toTimestamp(message.lastClear), writer.uint32(154).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(170).fork()).join();
    }
    if (message.portAlias !== "") {
      writer.uint32(370).string(message.portAlias);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortCounters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortCounters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.inOctets = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.inPkts = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.inUnicastPkts = reader.uint64().toString();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.inBroadcastPkts = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.inMulticastPkts = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.inDiscards = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.inErrors = reader.uint64().toString();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.inUnknownProtos = reader.uint64().toString();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.inFcsErrors = reader.uint64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.outOctets = reader.uint64().toString();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.outPkts = reader.uint64().toString();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.outUnicastPkts = reader.uint64().toString();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.outBroadcastPkts = reader.uint64().toString();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.outMulticastPkts = reader.uint64().toString();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.outDiscards = reader.uint64().toString();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.outErrors = reader.uint64().toString();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.carrierTransitions = reader.uint64().toString();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.inPfc0Pkts = reader.uint64().toString();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.outPfc0Pkts = reader.uint64().toString();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.inPfc1Pkts = reader.uint64().toString();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.outPfc1Pkts = reader.uint64().toString();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.inPfc2Pkts = reader.uint64().toString();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.outPfc2Pkts = reader.uint64().toString();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.inPfc3Pkts = reader.uint64().toString();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.outPfc3Pkts = reader.uint64().toString();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.inPfc4Pkts = reader.uint64().toString();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.outPfc4Pkts = reader.uint64().toString();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.inPfc5Pkts = reader.uint64().toString();
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.outPfc5Pkts = reader.uint64().toString();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.inPfc6Pkts = reader.uint64().toString();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.outPfc6Pkts = reader.uint64().toString();
          continue;
        }
        case 36: {
          if (tag !== 288) {
            break;
          }

          message.inPfc7Pkts = reader.uint64().toString();
          continue;
        }
        case 37: {
          if (tag !== 296) {
            break;
          }

          message.outPfc7Pkts = reader.uint64().toString();
          continue;
        }
        case 38: {
          if (tag !== 309) {
            break;
          }

          message.inBitsps = reader.float();
          continue;
        }
        case 39: {
          if (tag !== 317) {
            break;
          }

          message.outBitsps = reader.float();
          continue;
        }
        case 40: {
          if (tag !== 325) {
            break;
          }

          message.inPps = reader.float();
          continue;
        }
        case 41: {
          if (tag !== 333) {
            break;
          }

          message.outPps = reader.float();
          continue;
        }
        case 42: {
          if (tag !== 341) {
            break;
          }

          message.inUnicastPps = reader.float();
          continue;
        }
        case 43: {
          if (tag !== 349) {
            break;
          }

          message.outUnicastPps = reader.float();
          continue;
        }
        case 44: {
          if (tag !== 357) {
            break;
          }

          message.inPfcPps = reader.float();
          continue;
        }
        case 45: {
          if (tag !== 365) {
            break;
          }

          message.outPfcPps = reader.float();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.lastClear = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 46: {
          if (tag !== 370) {
            break;
          }

          message.portAlias = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortCounters {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      inOctets: isSet(object["in-octets"]) ? globalThis.String(object["in-octets"]) : "0",
      inPkts: isSet(object["in-pkts"]) ? globalThis.String(object["in-pkts"]) : "0",
      inUnicastPkts: isSet(object["in-unicast-pkts"]) ? globalThis.String(object["in-unicast-pkts"]) : "0",
      inBroadcastPkts: isSet(object["in-broadcast-pkts"]) ? globalThis.String(object["in-broadcast-pkts"]) : "0",
      inMulticastPkts: isSet(object["in-multicast-pkts"]) ? globalThis.String(object["in-multicast-pkts"]) : "0",
      inDiscards: isSet(object["in-discards"]) ? globalThis.String(object["in-discards"]) : "0",
      inErrors: isSet(object["in-errors"]) ? globalThis.String(object["in-errors"]) : "0",
      inUnknownProtos: isSet(object["in-unknown-protos"]) ? globalThis.String(object["in-unknown-protos"]) : "0",
      inFcsErrors: isSet(object["in-fcs-errors"]) ? globalThis.String(object["in-fcs-errors"]) : "0",
      outOctets: isSet(object["out-octets"]) ? globalThis.String(object["out-octets"]) : "0",
      outPkts: isSet(object["out-pkts"]) ? globalThis.String(object["out-pkts"]) : "0",
      outUnicastPkts: isSet(object["out-unicast-pkts"]) ? globalThis.String(object["out-unicast-pkts"]) : "0",
      outBroadcastPkts: isSet(object["out-broadcast-pkts"]) ? globalThis.String(object["out-broadcast-pkts"]) : "0",
      outMulticastPkts: isSet(object["out-multicast-pkts"]) ? globalThis.String(object["out-multicast-pkts"]) : "0",
      outDiscards: isSet(object["out-discards"]) ? globalThis.String(object["out-discards"]) : "0",
      outErrors: isSet(object["out-errors"]) ? globalThis.String(object["out-errors"]) : "0",
      carrierTransitions: isSet(object["carrier-transitions"]) ? globalThis.String(object["carrier-transitions"]) : "0",
      inPfc0Pkts: isSet(object["in-pfc0-pkts"]) ? globalThis.String(object["in-pfc0-pkts"]) : "0",
      outPfc0Pkts: isSet(object["out-pfc0-pkts"]) ? globalThis.String(object["out-pfc0-pkts"]) : "0",
      inPfc1Pkts: isSet(object["in-pfc1-pkts"]) ? globalThis.String(object["in-pfc1-pkts"]) : "0",
      outPfc1Pkts: isSet(object["out-pfc1-pkts"]) ? globalThis.String(object["out-pfc1-pkts"]) : "0",
      inPfc2Pkts: isSet(object["in-pfc2-pkts"]) ? globalThis.String(object["in-pfc2-pkts"]) : "0",
      outPfc2Pkts: isSet(object["out-pfc2-pkts"]) ? globalThis.String(object["out-pfc2-pkts"]) : "0",
      inPfc3Pkts: isSet(object["in-pfc3-pkts"]) ? globalThis.String(object["in-pfc3-pkts"]) : "0",
      outPfc3Pkts: isSet(object["out-pfc3-pkts"]) ? globalThis.String(object["out-pfc3-pkts"]) : "0",
      inPfc4Pkts: isSet(object["in-pfc4-pkts"]) ? globalThis.String(object["in-pfc4-pkts"]) : "0",
      outPfc4Pkts: isSet(object["out-pfc4-pkts"]) ? globalThis.String(object["out-pfc4-pkts"]) : "0",
      inPfc5Pkts: isSet(object["in-pfc5-pkts"]) ? globalThis.String(object["in-pfc5-pkts"]) : "0",
      outPfc5Pkts: isSet(object["out-pfc5-pkts"]) ? globalThis.String(object["out-pfc5-pkts"]) : "0",
      inPfc6Pkts: isSet(object["in-pfc6-pkts"]) ? globalThis.String(object["in-pfc6-pkts"]) : "0",
      outPfc6Pkts: isSet(object["out-pfc6-pkts"]) ? globalThis.String(object["out-pfc6-pkts"]) : "0",
      inPfc7Pkts: isSet(object["in-pfc7-pkts"]) ? globalThis.String(object["in-pfc7-pkts"]) : "0",
      outPfc7Pkts: isSet(object["out-pfc7-pkts"]) ? globalThis.String(object["out-pfc7-pkts"]) : "0",
      inBitsps: isSet(object["in-bps"]) ? globalThis.Number(object["in-bps"]) : 0,
      outBitsps: isSet(object["out-bps"]) ? globalThis.Number(object["out-bps"]) : 0,
      inPps: isSet(object["in-pps"]) ? globalThis.Number(object["in-pps"]) : 0,
      outPps: isSet(object["out-pps"]) ? globalThis.Number(object["out-pps"]) : 0,
      inUnicastPps: isSet(object["in-unicast-pps"]) ? globalThis.Number(object["in-unicast-pps"]) : 0,
      outUnicastPps: isSet(object["out-unicast-pps"]) ? globalThis.Number(object["out-unicast-pps"]) : 0,
      inPfcPps: isSet(object["in-pfc-pps"]) ? globalThis.Number(object["in-pfc-pps"]) : 0,
      outPfcPps: isSet(object["out-pfc-pps"]) ? globalThis.Number(object["out-pfc-pps"]) : 0,
      lastClear: isSet(object["last-clear"]) ? fromJsonTimestamp(object["last-clear"]) : undefined,
      collectedAt: isSet(object["collected-at"]) ? fromJsonTimestamp(object["collected-at"]) : undefined,
      portAlias: isSet(object.portAlias) ? globalThis.String(object.portAlias) : "",
    };
  },

  toJSON(message: PortCounters): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.inOctets !== "0") {
      obj["in-octets"] = message.inOctets;
    }
    if (message.inPkts !== "0") {
      obj["in-pkts"] = message.inPkts;
    }
    if (message.inUnicastPkts !== "0") {
      obj["in-unicast-pkts"] = message.inUnicastPkts;
    }
    if (message.inBroadcastPkts !== "0") {
      obj["in-broadcast-pkts"] = message.inBroadcastPkts;
    }
    if (message.inMulticastPkts !== "0") {
      obj["in-multicast-pkts"] = message.inMulticastPkts;
    }
    if (message.inDiscards !== "0") {
      obj["in-discards"] = message.inDiscards;
    }
    if (message.inErrors !== "0") {
      obj["in-errors"] = message.inErrors;
    }
    if (message.inUnknownProtos !== "0") {
      obj["in-unknown-protos"] = message.inUnknownProtos;
    }
    if (message.inFcsErrors !== "0") {
      obj["in-fcs-errors"] = message.inFcsErrors;
    }
    if (message.outOctets !== "0") {
      obj["out-octets"] = message.outOctets;
    }
    if (message.outPkts !== "0") {
      obj["out-pkts"] = message.outPkts;
    }
    if (message.outUnicastPkts !== "0") {
      obj["out-unicast-pkts"] = message.outUnicastPkts;
    }
    if (message.outBroadcastPkts !== "0") {
      obj["out-broadcast-pkts"] = message.outBroadcastPkts;
    }
    if (message.outMulticastPkts !== "0") {
      obj["out-multicast-pkts"] = message.outMulticastPkts;
    }
    if (message.outDiscards !== "0") {
      obj["out-discards"] = message.outDiscards;
    }
    if (message.outErrors !== "0") {
      obj["out-errors"] = message.outErrors;
    }
    if (message.carrierTransitions !== "0") {
      obj["carrier-transitions"] = message.carrierTransitions;
    }
    if (message.inPfc0Pkts !== "0") {
      obj["in-pfc0-pkts"] = message.inPfc0Pkts;
    }
    if (message.outPfc0Pkts !== "0") {
      obj["out-pfc0-pkts"] = message.outPfc0Pkts;
    }
    if (message.inPfc1Pkts !== "0") {
      obj["in-pfc1-pkts"] = message.inPfc1Pkts;
    }
    if (message.outPfc1Pkts !== "0") {
      obj["out-pfc1-pkts"] = message.outPfc1Pkts;
    }
    if (message.inPfc2Pkts !== "0") {
      obj["in-pfc2-pkts"] = message.inPfc2Pkts;
    }
    if (message.outPfc2Pkts !== "0") {
      obj["out-pfc2-pkts"] = message.outPfc2Pkts;
    }
    if (message.inPfc3Pkts !== "0") {
      obj["in-pfc3-pkts"] = message.inPfc3Pkts;
    }
    if (message.outPfc3Pkts !== "0") {
      obj["out-pfc3-pkts"] = message.outPfc3Pkts;
    }
    if (message.inPfc4Pkts !== "0") {
      obj["in-pfc4-pkts"] = message.inPfc4Pkts;
    }
    if (message.outPfc4Pkts !== "0") {
      obj["out-pfc4-pkts"] = message.outPfc4Pkts;
    }
    if (message.inPfc5Pkts !== "0") {
      obj["in-pfc5-pkts"] = message.inPfc5Pkts;
    }
    if (message.outPfc5Pkts !== "0") {
      obj["out-pfc5-pkts"] = message.outPfc5Pkts;
    }
    if (message.inPfc6Pkts !== "0") {
      obj["in-pfc6-pkts"] = message.inPfc6Pkts;
    }
    if (message.outPfc6Pkts !== "0") {
      obj["out-pfc6-pkts"] = message.outPfc6Pkts;
    }
    if (message.inPfc7Pkts !== "0") {
      obj["in-pfc7-pkts"] = message.inPfc7Pkts;
    }
    if (message.outPfc7Pkts !== "0") {
      obj["out-pfc7-pkts"] = message.outPfc7Pkts;
    }
    if (message.inBitsps !== 0) {
      obj["in-bps"] = message.inBitsps;
    }
    if (message.outBitsps !== 0) {
      obj["out-bps"] = message.outBitsps;
    }
    if (message.inPps !== 0) {
      obj["in-pps"] = message.inPps;
    }
    if (message.outPps !== 0) {
      obj["out-pps"] = message.outPps;
    }
    if (message.inUnicastPps !== 0) {
      obj["in-unicast-pps"] = message.inUnicastPps;
    }
    if (message.outUnicastPps !== 0) {
      obj["out-unicast-pps"] = message.outUnicastPps;
    }
    if (message.inPfcPps !== 0) {
      obj["in-pfc-pps"] = message.inPfcPps;
    }
    if (message.outPfcPps !== 0) {
      obj["out-pfc-pps"] = message.outPfcPps;
    }
    if (message.lastClear !== undefined) {
      obj["last-clear"] = message.lastClear.toISOString();
    }
    if (message.collectedAt !== undefined) {
      obj["collected-at"] = message.collectedAt.toISOString();
    }
    if (message.portAlias !== "") {
      obj.portAlias = message.portAlias;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortCounters>, I>>(base?: I): PortCounters {
    return PortCounters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortCounters>, I>>(object: I): PortCounters {
    const message = createBasePortCounters();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.inOctets = object.inOctets ?? "0";
    message.inPkts = object.inPkts ?? "0";
    message.inUnicastPkts = object.inUnicastPkts ?? "0";
    message.inBroadcastPkts = object.inBroadcastPkts ?? "0";
    message.inMulticastPkts = object.inMulticastPkts ?? "0";
    message.inDiscards = object.inDiscards ?? "0";
    message.inErrors = object.inErrors ?? "0";
    message.inUnknownProtos = object.inUnknownProtos ?? "0";
    message.inFcsErrors = object.inFcsErrors ?? "0";
    message.outOctets = object.outOctets ?? "0";
    message.outPkts = object.outPkts ?? "0";
    message.outUnicastPkts = object.outUnicastPkts ?? "0";
    message.outBroadcastPkts = object.outBroadcastPkts ?? "0";
    message.outMulticastPkts = object.outMulticastPkts ?? "0";
    message.outDiscards = object.outDiscards ?? "0";
    message.outErrors = object.outErrors ?? "0";
    message.carrierTransitions = object.carrierTransitions ?? "0";
    message.inPfc0Pkts = object.inPfc0Pkts ?? "0";
    message.outPfc0Pkts = object.outPfc0Pkts ?? "0";
    message.inPfc1Pkts = object.inPfc1Pkts ?? "0";
    message.outPfc1Pkts = object.outPfc1Pkts ?? "0";
    message.inPfc2Pkts = object.inPfc2Pkts ?? "0";
    message.outPfc2Pkts = object.outPfc2Pkts ?? "0";
    message.inPfc3Pkts = object.inPfc3Pkts ?? "0";
    message.outPfc3Pkts = object.outPfc3Pkts ?? "0";
    message.inPfc4Pkts = object.inPfc4Pkts ?? "0";
    message.outPfc4Pkts = object.outPfc4Pkts ?? "0";
    message.inPfc5Pkts = object.inPfc5Pkts ?? "0";
    message.outPfc5Pkts = object.outPfc5Pkts ?? "0";
    message.inPfc6Pkts = object.inPfc6Pkts ?? "0";
    message.outPfc6Pkts = object.outPfc6Pkts ?? "0";
    message.inPfc7Pkts = object.inPfc7Pkts ?? "0";
    message.outPfc7Pkts = object.outPfc7Pkts ?? "0";
    message.inBitsps = object.inBitsps ?? 0;
    message.outBitsps = object.outBitsps ?? 0;
    message.inPps = object.inPps ?? 0;
    message.outPps = object.outPps ?? 0;
    message.inUnicastPps = object.inUnicastPps ?? 0;
    message.outUnicastPps = object.outUnicastPps ?? 0;
    message.inPfcPps = object.inPfcPps ?? 0;
    message.outPfcPps = object.outPfcPps ?? 0;
    message.lastClear = object.lastClear ?? undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    message.portAlias = object.portAlias ?? "";
    return message;
  },
};

function createBaseIpmSessionId(): IpmSessionId {
  return { id: undefined };
}

export const IpmSessionId: MessageFns<IpmSessionId> = {
  encode(message: IpmSessionId, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpmSessionId {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpmSessionId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpmSessionId {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: IpmSessionId): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpmSessionId>, I>>(base?: I): IpmSessionId {
    return IpmSessionId.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpmSessionId>, I>>(object: I): IpmSessionId {
    const message = createBaseIpmSessionId();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseIpmSessionParameters(): IpmSessionParameters {
  return { description: "", srcAddr: "", dstAddr: "", vrf: "", flowLabel: 0, dscp: 0, confSessionId: "" };
}

export const IpmSessionParameters: MessageFns<IpmSessionParameters> = {
  encode(message: IpmSessionParameters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.srcAddr !== "") {
      writer.uint32(26).string(message.srcAddr);
    }
    if (message.dstAddr !== "") {
      writer.uint32(34).string(message.dstAddr);
    }
    if (message.vrf !== "") {
      writer.uint32(42).string(message.vrf);
    }
    if (message.flowLabel !== 0) {
      writer.uint32(48).uint32(message.flowLabel);
    }
    if (message.dscp !== 0) {
      writer.uint32(56).uint32(message.dscp);
    }
    if (message.confSessionId !== "") {
      writer.uint32(66).string(message.confSessionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpmSessionParameters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpmSessionParameters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.srcAddr = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dstAddr = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.vrf = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.flowLabel = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.dscp = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.confSessionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpmSessionParameters {
    return {
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      srcAddr: isSet(object.srcAddr) ? globalThis.String(object.srcAddr) : "",
      dstAddr: isSet(object.dstAddr) ? globalThis.String(object.dstAddr) : "",
      vrf: isSet(object.vrf) ? globalThis.String(object.vrf) : "",
      flowLabel: isSet(object.flowLabel) ? globalThis.Number(object.flowLabel) : 0,
      dscp: isSet(object.dscp) ? globalThis.Number(object.dscp) : 0,
      confSessionId: isSet(object.confSessionId) ? globalThis.String(object.confSessionId) : "",
    };
  },

  toJSON(message: IpmSessionParameters): unknown {
    const obj: any = {};
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.srcAddr !== "") {
      obj.srcAddr = message.srcAddr;
    }
    if (message.dstAddr !== "") {
      obj.dstAddr = message.dstAddr;
    }
    if (message.vrf !== "") {
      obj.vrf = message.vrf;
    }
    if (message.flowLabel !== 0) {
      obj.flowLabel = Math.round(message.flowLabel);
    }
    if (message.dscp !== 0) {
      obj.dscp = Math.round(message.dscp);
    }
    if (message.confSessionId !== "") {
      obj.confSessionId = message.confSessionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpmSessionParameters>, I>>(base?: I): IpmSessionParameters {
    return IpmSessionParameters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpmSessionParameters>, I>>(object: I): IpmSessionParameters {
    const message = createBaseIpmSessionParameters();
    message.description = object.description ?? "";
    message.srcAddr = object.srcAddr ?? "";
    message.dstAddr = object.dstAddr ?? "";
    message.vrf = object.vrf ?? "";
    message.flowLabel = object.flowLabel ?? 0;
    message.dscp = object.dscp ?? 0;
    message.confSessionId = object.confSessionId ?? "";
    return message;
  },
};

function createBaseIpmRawLatencyCounters(): IpmRawLatencyCounters {
  return {
    id: undefined,
    rxBin0: "0",
    rxBin1: "0",
    rxBin2: "0",
    rxBin3: "0",
    rxBin4: "0",
    rxBin5: "0",
    rxBin6: "0",
    rxBin7: "0",
    rxBin8: "0",
    rxBin9: "0",
    rxBin10: "0",
    rxBin11: "0",
    rxBin12: "0",
    rxBin13: "0",
    rxBin14: "0",
    rxBin15: "0",
    rxBin16: "0",
    rxBin17: "0",
    rxBin18: "0",
    rxBin19: "0",
    rxBin20: "0",
    rxBin21: "0",
    rxBin22: "0",
    rxBin23: "0",
    rxBin24: "0",
    rxBin25: "0",
    rxBin26: "0",
    rxBin27: "0",
    maxBin0: "0",
    maxBin1: "0",
    maxBin2: "0",
    maxBin3: "0",
    maxBin4: "0",
    maxBin5: "0",
    maxBin6: "0",
    maxBin7: "0",
    maxBin8: "0",
    maxBin9: "0",
    maxBin10: "0",
    maxBin11: "0",
    maxBin12: "0",
    maxBin13: "0",
    maxBin14: "0",
    maxBin15: "0",
    maxBin16: "0",
    maxBin17: "0",
    maxBin18: "0",
    maxBin19: "0",
    maxBin20: "0",
    maxBin21: "0",
    maxBin22: "0",
    maxBin23: "0",
    maxBin24: "0",
    maxBin25: "0",
    maxBin26: "0",
    maxBin27: "0",
    ipmParams: undefined,
    collectedAt: undefined,
  };
}

export const IpmRawLatencyCounters: MessageFns<IpmRawLatencyCounters> = {
  encode(message: IpmRawLatencyCounters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.rxBin0 !== "0") {
      writer.uint32(16).uint64(message.rxBin0);
    }
    if (message.rxBin1 !== "0") {
      writer.uint32(24).uint64(message.rxBin1);
    }
    if (message.rxBin2 !== "0") {
      writer.uint32(32).uint64(message.rxBin2);
    }
    if (message.rxBin3 !== "0") {
      writer.uint32(40).uint64(message.rxBin3);
    }
    if (message.rxBin4 !== "0") {
      writer.uint32(48).uint64(message.rxBin4);
    }
    if (message.rxBin5 !== "0") {
      writer.uint32(56).uint64(message.rxBin5);
    }
    if (message.rxBin6 !== "0") {
      writer.uint32(64).uint64(message.rxBin6);
    }
    if (message.rxBin7 !== "0") {
      writer.uint32(72).uint64(message.rxBin7);
    }
    if (message.rxBin8 !== "0") {
      writer.uint32(80).uint64(message.rxBin8);
    }
    if (message.rxBin9 !== "0") {
      writer.uint32(88).uint64(message.rxBin9);
    }
    if (message.rxBin10 !== "0") {
      writer.uint32(96).uint64(message.rxBin10);
    }
    if (message.rxBin11 !== "0") {
      writer.uint32(104).uint64(message.rxBin11);
    }
    if (message.rxBin12 !== "0") {
      writer.uint32(112).uint64(message.rxBin12);
    }
    if (message.rxBin13 !== "0") {
      writer.uint32(120).uint64(message.rxBin13);
    }
    if (message.rxBin14 !== "0") {
      writer.uint32(128).uint64(message.rxBin14);
    }
    if (message.rxBin15 !== "0") {
      writer.uint32(136).uint64(message.rxBin15);
    }
    if (message.rxBin16 !== "0") {
      writer.uint32(144).uint64(message.rxBin16);
    }
    if (message.rxBin17 !== "0") {
      writer.uint32(152).uint64(message.rxBin17);
    }
    if (message.rxBin18 !== "0") {
      writer.uint32(160).uint64(message.rxBin18);
    }
    if (message.rxBin19 !== "0") {
      writer.uint32(168).uint64(message.rxBin19);
    }
    if (message.rxBin20 !== "0") {
      writer.uint32(176).uint64(message.rxBin20);
    }
    if (message.rxBin21 !== "0") {
      writer.uint32(184).uint64(message.rxBin21);
    }
    if (message.rxBin22 !== "0") {
      writer.uint32(192).uint64(message.rxBin22);
    }
    if (message.rxBin23 !== "0") {
      writer.uint32(200).uint64(message.rxBin23);
    }
    if (message.rxBin24 !== "0") {
      writer.uint32(208).uint64(message.rxBin24);
    }
    if (message.rxBin25 !== "0") {
      writer.uint32(216).uint64(message.rxBin25);
    }
    if (message.rxBin26 !== "0") {
      writer.uint32(224).uint64(message.rxBin26);
    }
    if (message.rxBin27 !== "0") {
      writer.uint32(232).uint64(message.rxBin27);
    }
    if (message.maxBin0 !== "0") {
      writer.uint32(240).uint64(message.maxBin0);
    }
    if (message.maxBin1 !== "0") {
      writer.uint32(248).uint64(message.maxBin1);
    }
    if (message.maxBin2 !== "0") {
      writer.uint32(256).uint64(message.maxBin2);
    }
    if (message.maxBin3 !== "0") {
      writer.uint32(264).uint64(message.maxBin3);
    }
    if (message.maxBin4 !== "0") {
      writer.uint32(272).uint64(message.maxBin4);
    }
    if (message.maxBin5 !== "0") {
      writer.uint32(280).uint64(message.maxBin5);
    }
    if (message.maxBin6 !== "0") {
      writer.uint32(288).uint64(message.maxBin6);
    }
    if (message.maxBin7 !== "0") {
      writer.uint32(296).uint64(message.maxBin7);
    }
    if (message.maxBin8 !== "0") {
      writer.uint32(304).uint64(message.maxBin8);
    }
    if (message.maxBin9 !== "0") {
      writer.uint32(312).uint64(message.maxBin9);
    }
    if (message.maxBin10 !== "0") {
      writer.uint32(320).uint64(message.maxBin10);
    }
    if (message.maxBin11 !== "0") {
      writer.uint32(328).uint64(message.maxBin11);
    }
    if (message.maxBin12 !== "0") {
      writer.uint32(336).uint64(message.maxBin12);
    }
    if (message.maxBin13 !== "0") {
      writer.uint32(344).uint64(message.maxBin13);
    }
    if (message.maxBin14 !== "0") {
      writer.uint32(352).uint64(message.maxBin14);
    }
    if (message.maxBin15 !== "0") {
      writer.uint32(360).uint64(message.maxBin15);
    }
    if (message.maxBin16 !== "0") {
      writer.uint32(368).uint64(message.maxBin16);
    }
    if (message.maxBin17 !== "0") {
      writer.uint32(376).uint64(message.maxBin17);
    }
    if (message.maxBin18 !== "0") {
      writer.uint32(384).uint64(message.maxBin18);
    }
    if (message.maxBin19 !== "0") {
      writer.uint32(392).uint64(message.maxBin19);
    }
    if (message.maxBin20 !== "0") {
      writer.uint32(400).uint64(message.maxBin20);
    }
    if (message.maxBin21 !== "0") {
      writer.uint32(408).uint64(message.maxBin21);
    }
    if (message.maxBin22 !== "0") {
      writer.uint32(416).uint64(message.maxBin22);
    }
    if (message.maxBin23 !== "0") {
      writer.uint32(424).uint64(message.maxBin23);
    }
    if (message.maxBin24 !== "0") {
      writer.uint32(432).uint64(message.maxBin24);
    }
    if (message.maxBin25 !== "0") {
      writer.uint32(440).uint64(message.maxBin25);
    }
    if (message.maxBin26 !== "0") {
      writer.uint32(448).uint64(message.maxBin26);
    }
    if (message.maxBin27 !== "0") {
      writer.uint32(456).uint64(message.maxBin27);
    }
    if (message.ipmParams !== undefined) {
      IpmSessionParameters.encode(message.ipmParams, writer.uint32(466).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(474).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpmRawLatencyCounters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpmRawLatencyCounters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.rxBin0 = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.rxBin1 = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.rxBin2 = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.rxBin3 = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.rxBin4 = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.rxBin5 = reader.uint64().toString();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.rxBin6 = reader.uint64().toString();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.rxBin7 = reader.uint64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.rxBin8 = reader.uint64().toString();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.rxBin9 = reader.uint64().toString();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.rxBin10 = reader.uint64().toString();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.rxBin11 = reader.uint64().toString();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.rxBin12 = reader.uint64().toString();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.rxBin13 = reader.uint64().toString();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.rxBin14 = reader.uint64().toString();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.rxBin15 = reader.uint64().toString();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.rxBin16 = reader.uint64().toString();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.rxBin17 = reader.uint64().toString();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.rxBin18 = reader.uint64().toString();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.rxBin19 = reader.uint64().toString();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.rxBin20 = reader.uint64().toString();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.rxBin21 = reader.uint64().toString();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.rxBin22 = reader.uint64().toString();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.rxBin23 = reader.uint64().toString();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.rxBin24 = reader.uint64().toString();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.rxBin25 = reader.uint64().toString();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.rxBin26 = reader.uint64().toString();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.rxBin27 = reader.uint64().toString();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.maxBin0 = reader.uint64().toString();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.maxBin1 = reader.uint64().toString();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.maxBin2 = reader.uint64().toString();
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.maxBin3 = reader.uint64().toString();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.maxBin4 = reader.uint64().toString();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.maxBin5 = reader.uint64().toString();
          continue;
        }
        case 36: {
          if (tag !== 288) {
            break;
          }

          message.maxBin6 = reader.uint64().toString();
          continue;
        }
        case 37: {
          if (tag !== 296) {
            break;
          }

          message.maxBin7 = reader.uint64().toString();
          continue;
        }
        case 38: {
          if (tag !== 304) {
            break;
          }

          message.maxBin8 = reader.uint64().toString();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.maxBin9 = reader.uint64().toString();
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.maxBin10 = reader.uint64().toString();
          continue;
        }
        case 41: {
          if (tag !== 328) {
            break;
          }

          message.maxBin11 = reader.uint64().toString();
          continue;
        }
        case 42: {
          if (tag !== 336) {
            break;
          }

          message.maxBin12 = reader.uint64().toString();
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.maxBin13 = reader.uint64().toString();
          continue;
        }
        case 44: {
          if (tag !== 352) {
            break;
          }

          message.maxBin14 = reader.uint64().toString();
          continue;
        }
        case 45: {
          if (tag !== 360) {
            break;
          }

          message.maxBin15 = reader.uint64().toString();
          continue;
        }
        case 46: {
          if (tag !== 368) {
            break;
          }

          message.maxBin16 = reader.uint64().toString();
          continue;
        }
        case 47: {
          if (tag !== 376) {
            break;
          }

          message.maxBin17 = reader.uint64().toString();
          continue;
        }
        case 48: {
          if (tag !== 384) {
            break;
          }

          message.maxBin18 = reader.uint64().toString();
          continue;
        }
        case 49: {
          if (tag !== 392) {
            break;
          }

          message.maxBin19 = reader.uint64().toString();
          continue;
        }
        case 50: {
          if (tag !== 400) {
            break;
          }

          message.maxBin20 = reader.uint64().toString();
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.maxBin21 = reader.uint64().toString();
          continue;
        }
        case 52: {
          if (tag !== 416) {
            break;
          }

          message.maxBin22 = reader.uint64().toString();
          continue;
        }
        case 53: {
          if (tag !== 424) {
            break;
          }

          message.maxBin23 = reader.uint64().toString();
          continue;
        }
        case 54: {
          if (tag !== 432) {
            break;
          }

          message.maxBin24 = reader.uint64().toString();
          continue;
        }
        case 55: {
          if (tag !== 440) {
            break;
          }

          message.maxBin25 = reader.uint64().toString();
          continue;
        }
        case 56: {
          if (tag !== 448) {
            break;
          }

          message.maxBin26 = reader.uint64().toString();
          continue;
        }
        case 57: {
          if (tag !== 456) {
            break;
          }

          message.maxBin27 = reader.uint64().toString();
          continue;
        }
        case 58: {
          if (tag !== 466) {
            break;
          }

          message.ipmParams = IpmSessionParameters.decode(reader, reader.uint32());
          continue;
        }
        case 59: {
          if (tag !== 474) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpmRawLatencyCounters {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      rxBin0: isSet(object.rx_bin0) ? globalThis.String(object.rx_bin0) : "0",
      rxBin1: isSet(object.rx_bin1) ? globalThis.String(object.rx_bin1) : "0",
      rxBin2: isSet(object.rx_bin2) ? globalThis.String(object.rx_bin2) : "0",
      rxBin3: isSet(object.rx_bin3) ? globalThis.String(object.rx_bin3) : "0",
      rxBin4: isSet(object.rx_bin4) ? globalThis.String(object.rx_bin4) : "0",
      rxBin5: isSet(object.rx_bin5) ? globalThis.String(object.rx_bin5) : "0",
      rxBin6: isSet(object.rx_bin6) ? globalThis.String(object.rx_bin6) : "0",
      rxBin7: isSet(object.rx_bin7) ? globalThis.String(object.rx_bin7) : "0",
      rxBin8: isSet(object.rx_bin8) ? globalThis.String(object.rx_bin8) : "0",
      rxBin9: isSet(object.rx_bin9) ? globalThis.String(object.rx_bin9) : "0",
      rxBin10: isSet(object.rx_bin10) ? globalThis.String(object.rx_bin10) : "0",
      rxBin11: isSet(object.rx_bin11) ? globalThis.String(object.rx_bin11) : "0",
      rxBin12: isSet(object.rx_bin12) ? globalThis.String(object.rx_bin12) : "0",
      rxBin13: isSet(object.rx_bin13) ? globalThis.String(object.rx_bin13) : "0",
      rxBin14: isSet(object.rx_bin14) ? globalThis.String(object.rx_bin14) : "0",
      rxBin15: isSet(object.rx_bin15) ? globalThis.String(object.rx_bin15) : "0",
      rxBin16: isSet(object.rx_bin16) ? globalThis.String(object.rx_bin16) : "0",
      rxBin17: isSet(object.rx_bin17) ? globalThis.String(object.rx_bin17) : "0",
      rxBin18: isSet(object.rx_bin18) ? globalThis.String(object.rx_bin18) : "0",
      rxBin19: isSet(object.rx_bin19) ? globalThis.String(object.rx_bin19) : "0",
      rxBin20: isSet(object.rx_bin20) ? globalThis.String(object.rx_bin20) : "0",
      rxBin21: isSet(object.rx_bin21) ? globalThis.String(object.rx_bin21) : "0",
      rxBin22: isSet(object.rx_bin22) ? globalThis.String(object.rx_bin22) : "0",
      rxBin23: isSet(object.rx_bin23) ? globalThis.String(object.rx_bin23) : "0",
      rxBin24: isSet(object.rx_bin24) ? globalThis.String(object.rx_bin24) : "0",
      rxBin25: isSet(object.rx_bin25) ? globalThis.String(object.rx_bin25) : "0",
      rxBin26: isSet(object.rx_bin26) ? globalThis.String(object.rx_bin26) : "0",
      rxBin27: isSet(object.rx_bin27) ? globalThis.String(object.rx_bin27) : "0",
      maxBin0: isSet(object.max_bin0) ? globalThis.String(object.max_bin0) : "0",
      maxBin1: isSet(object.max_bin1) ? globalThis.String(object.max_bin1) : "0",
      maxBin2: isSet(object.max_bin2) ? globalThis.String(object.max_bin2) : "0",
      maxBin3: isSet(object.max_bin3) ? globalThis.String(object.max_bin3) : "0",
      maxBin4: isSet(object.max_bin4) ? globalThis.String(object.max_bin4) : "0",
      maxBin5: isSet(object.max_bin5) ? globalThis.String(object.max_bin5) : "0",
      maxBin6: isSet(object.max_bin6) ? globalThis.String(object.max_bin6) : "0",
      maxBin7: isSet(object.max_bin7) ? globalThis.String(object.max_bin7) : "0",
      maxBin8: isSet(object.max_bin8) ? globalThis.String(object.max_bin8) : "0",
      maxBin9: isSet(object.max_bin9) ? globalThis.String(object.max_bin9) : "0",
      maxBin10: isSet(object.max_bin10) ? globalThis.String(object.max_bin10) : "0",
      maxBin11: isSet(object.max_bin11) ? globalThis.String(object.max_bin11) : "0",
      maxBin12: isSet(object.max_bin12) ? globalThis.String(object.max_bin12) : "0",
      maxBin13: isSet(object.max_bin13) ? globalThis.String(object.max_bin13) : "0",
      maxBin14: isSet(object.max_bin14) ? globalThis.String(object.max_bin14) : "0",
      maxBin15: isSet(object.max_bin15) ? globalThis.String(object.max_bin15) : "0",
      maxBin16: isSet(object.max_bin16) ? globalThis.String(object.max_bin16) : "0",
      maxBin17: isSet(object.max_bin17) ? globalThis.String(object.max_bin17) : "0",
      maxBin18: isSet(object.max_bin18) ? globalThis.String(object.max_bin18) : "0",
      maxBin19: isSet(object.max_bin19) ? globalThis.String(object.max_bin19) : "0",
      maxBin20: isSet(object.max_bin20) ? globalThis.String(object.max_bin20) : "0",
      maxBin21: isSet(object.max_bin21) ? globalThis.String(object.max_bin21) : "0",
      maxBin22: isSet(object.max_bin22) ? globalThis.String(object.max_bin22) : "0",
      maxBin23: isSet(object.max_bin23) ? globalThis.String(object.max_bin23) : "0",
      maxBin24: isSet(object.max_bin24) ? globalThis.String(object.max_bin24) : "0",
      maxBin25: isSet(object.max_bin25) ? globalThis.String(object.max_bin25) : "0",
      maxBin26: isSet(object.max_bin26) ? globalThis.String(object.max_bin26) : "0",
      maxBin27: isSet(object.max_bin27) ? globalThis.String(object.max_bin27) : "0",
      ipmParams: isSet(object.ipmParams) ? IpmSessionParameters.fromJSON(object.ipmParams) : undefined,
      collectedAt: isSet(object["collected-at"]) ? fromJsonTimestamp(object["collected-at"]) : undefined,
    };
  },

  toJSON(message: IpmRawLatencyCounters): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.rxBin0 !== "0") {
      obj.rx_bin0 = message.rxBin0;
    }
    if (message.rxBin1 !== "0") {
      obj.rx_bin1 = message.rxBin1;
    }
    if (message.rxBin2 !== "0") {
      obj.rx_bin2 = message.rxBin2;
    }
    if (message.rxBin3 !== "0") {
      obj.rx_bin3 = message.rxBin3;
    }
    if (message.rxBin4 !== "0") {
      obj.rx_bin4 = message.rxBin4;
    }
    if (message.rxBin5 !== "0") {
      obj.rx_bin5 = message.rxBin5;
    }
    if (message.rxBin6 !== "0") {
      obj.rx_bin6 = message.rxBin6;
    }
    if (message.rxBin7 !== "0") {
      obj.rx_bin7 = message.rxBin7;
    }
    if (message.rxBin8 !== "0") {
      obj.rx_bin8 = message.rxBin8;
    }
    if (message.rxBin9 !== "0") {
      obj.rx_bin9 = message.rxBin9;
    }
    if (message.rxBin10 !== "0") {
      obj.rx_bin10 = message.rxBin10;
    }
    if (message.rxBin11 !== "0") {
      obj.rx_bin11 = message.rxBin11;
    }
    if (message.rxBin12 !== "0") {
      obj.rx_bin12 = message.rxBin12;
    }
    if (message.rxBin13 !== "0") {
      obj.rx_bin13 = message.rxBin13;
    }
    if (message.rxBin14 !== "0") {
      obj.rx_bin14 = message.rxBin14;
    }
    if (message.rxBin15 !== "0") {
      obj.rx_bin15 = message.rxBin15;
    }
    if (message.rxBin16 !== "0") {
      obj.rx_bin16 = message.rxBin16;
    }
    if (message.rxBin17 !== "0") {
      obj.rx_bin17 = message.rxBin17;
    }
    if (message.rxBin18 !== "0") {
      obj.rx_bin18 = message.rxBin18;
    }
    if (message.rxBin19 !== "0") {
      obj.rx_bin19 = message.rxBin19;
    }
    if (message.rxBin20 !== "0") {
      obj.rx_bin20 = message.rxBin20;
    }
    if (message.rxBin21 !== "0") {
      obj.rx_bin21 = message.rxBin21;
    }
    if (message.rxBin22 !== "0") {
      obj.rx_bin22 = message.rxBin22;
    }
    if (message.rxBin23 !== "0") {
      obj.rx_bin23 = message.rxBin23;
    }
    if (message.rxBin24 !== "0") {
      obj.rx_bin24 = message.rxBin24;
    }
    if (message.rxBin25 !== "0") {
      obj.rx_bin25 = message.rxBin25;
    }
    if (message.rxBin26 !== "0") {
      obj.rx_bin26 = message.rxBin26;
    }
    if (message.rxBin27 !== "0") {
      obj.rx_bin27 = message.rxBin27;
    }
    if (message.maxBin0 !== "0") {
      obj.max_bin0 = message.maxBin0;
    }
    if (message.maxBin1 !== "0") {
      obj.max_bin1 = message.maxBin1;
    }
    if (message.maxBin2 !== "0") {
      obj.max_bin2 = message.maxBin2;
    }
    if (message.maxBin3 !== "0") {
      obj.max_bin3 = message.maxBin3;
    }
    if (message.maxBin4 !== "0") {
      obj.max_bin4 = message.maxBin4;
    }
    if (message.maxBin5 !== "0") {
      obj.max_bin5 = message.maxBin5;
    }
    if (message.maxBin6 !== "0") {
      obj.max_bin6 = message.maxBin6;
    }
    if (message.maxBin7 !== "0") {
      obj.max_bin7 = message.maxBin7;
    }
    if (message.maxBin8 !== "0") {
      obj.max_bin8 = message.maxBin8;
    }
    if (message.maxBin9 !== "0") {
      obj.max_bin9 = message.maxBin9;
    }
    if (message.maxBin10 !== "0") {
      obj.max_bin10 = message.maxBin10;
    }
    if (message.maxBin11 !== "0") {
      obj.max_bin11 = message.maxBin11;
    }
    if (message.maxBin12 !== "0") {
      obj.max_bin12 = message.maxBin12;
    }
    if (message.maxBin13 !== "0") {
      obj.max_bin13 = message.maxBin13;
    }
    if (message.maxBin14 !== "0") {
      obj.max_bin14 = message.maxBin14;
    }
    if (message.maxBin15 !== "0") {
      obj.max_bin15 = message.maxBin15;
    }
    if (message.maxBin16 !== "0") {
      obj.max_bin16 = message.maxBin16;
    }
    if (message.maxBin17 !== "0") {
      obj.max_bin17 = message.maxBin17;
    }
    if (message.maxBin18 !== "0") {
      obj.max_bin18 = message.maxBin18;
    }
    if (message.maxBin19 !== "0") {
      obj.max_bin19 = message.maxBin19;
    }
    if (message.maxBin20 !== "0") {
      obj.max_bin20 = message.maxBin20;
    }
    if (message.maxBin21 !== "0") {
      obj.max_bin21 = message.maxBin21;
    }
    if (message.maxBin22 !== "0") {
      obj.max_bin22 = message.maxBin22;
    }
    if (message.maxBin23 !== "0") {
      obj.max_bin23 = message.maxBin23;
    }
    if (message.maxBin24 !== "0") {
      obj.max_bin24 = message.maxBin24;
    }
    if (message.maxBin25 !== "0") {
      obj.max_bin25 = message.maxBin25;
    }
    if (message.maxBin26 !== "0") {
      obj.max_bin26 = message.maxBin26;
    }
    if (message.maxBin27 !== "0") {
      obj.max_bin27 = message.maxBin27;
    }
    if (message.ipmParams !== undefined) {
      obj.ipmParams = IpmSessionParameters.toJSON(message.ipmParams);
    }
    if (message.collectedAt !== undefined) {
      obj["collected-at"] = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpmRawLatencyCounters>, I>>(base?: I): IpmRawLatencyCounters {
    return IpmRawLatencyCounters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpmRawLatencyCounters>, I>>(object: I): IpmRawLatencyCounters {
    const message = createBaseIpmRawLatencyCounters();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.rxBin0 = object.rxBin0 ?? "0";
    message.rxBin1 = object.rxBin1 ?? "0";
    message.rxBin2 = object.rxBin2 ?? "0";
    message.rxBin3 = object.rxBin3 ?? "0";
    message.rxBin4 = object.rxBin4 ?? "0";
    message.rxBin5 = object.rxBin5 ?? "0";
    message.rxBin6 = object.rxBin6 ?? "0";
    message.rxBin7 = object.rxBin7 ?? "0";
    message.rxBin8 = object.rxBin8 ?? "0";
    message.rxBin9 = object.rxBin9 ?? "0";
    message.rxBin10 = object.rxBin10 ?? "0";
    message.rxBin11 = object.rxBin11 ?? "0";
    message.rxBin12 = object.rxBin12 ?? "0";
    message.rxBin13 = object.rxBin13 ?? "0";
    message.rxBin14 = object.rxBin14 ?? "0";
    message.rxBin15 = object.rxBin15 ?? "0";
    message.rxBin16 = object.rxBin16 ?? "0";
    message.rxBin17 = object.rxBin17 ?? "0";
    message.rxBin18 = object.rxBin18 ?? "0";
    message.rxBin19 = object.rxBin19 ?? "0";
    message.rxBin20 = object.rxBin20 ?? "0";
    message.rxBin21 = object.rxBin21 ?? "0";
    message.rxBin22 = object.rxBin22 ?? "0";
    message.rxBin23 = object.rxBin23 ?? "0";
    message.rxBin24 = object.rxBin24 ?? "0";
    message.rxBin25 = object.rxBin25 ?? "0";
    message.rxBin26 = object.rxBin26 ?? "0";
    message.rxBin27 = object.rxBin27 ?? "0";
    message.maxBin0 = object.maxBin0 ?? "0";
    message.maxBin1 = object.maxBin1 ?? "0";
    message.maxBin2 = object.maxBin2 ?? "0";
    message.maxBin3 = object.maxBin3 ?? "0";
    message.maxBin4 = object.maxBin4 ?? "0";
    message.maxBin5 = object.maxBin5 ?? "0";
    message.maxBin6 = object.maxBin6 ?? "0";
    message.maxBin7 = object.maxBin7 ?? "0";
    message.maxBin8 = object.maxBin8 ?? "0";
    message.maxBin9 = object.maxBin9 ?? "0";
    message.maxBin10 = object.maxBin10 ?? "0";
    message.maxBin11 = object.maxBin11 ?? "0";
    message.maxBin12 = object.maxBin12 ?? "0";
    message.maxBin13 = object.maxBin13 ?? "0";
    message.maxBin14 = object.maxBin14 ?? "0";
    message.maxBin15 = object.maxBin15 ?? "0";
    message.maxBin16 = object.maxBin16 ?? "0";
    message.maxBin17 = object.maxBin17 ?? "0";
    message.maxBin18 = object.maxBin18 ?? "0";
    message.maxBin19 = object.maxBin19 ?? "0";
    message.maxBin20 = object.maxBin20 ?? "0";
    message.maxBin21 = object.maxBin21 ?? "0";
    message.maxBin22 = object.maxBin22 ?? "0";
    message.maxBin23 = object.maxBin23 ?? "0";
    message.maxBin24 = object.maxBin24 ?? "0";
    message.maxBin25 = object.maxBin25 ?? "0";
    message.maxBin26 = object.maxBin26 ?? "0";
    message.maxBin27 = object.maxBin27 ?? "0";
    message.ipmParams = (object.ipmParams !== undefined && object.ipmParams !== null)
      ? IpmSessionParameters.fromPartial(object.ipmParams)
      : undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseIpmProcLatencyCounters(): IpmProcLatencyCounters {
  return {
    id: undefined,
    exceedingSuspicious: 0,
    exceedingCritical: 0,
    ipmParams: undefined,
    collectedAt: undefined,
    exceedingSuspiciousEma: 0,
    exceedingCriticalEma: 0,
    rxBin0Ema: 0,
    rxBin1Ema: 0,
    rxBin2Ema: 0,
    rxBin3Ema: 0,
    rxBin4Ema: 0,
    rxBin5Ema: 0,
    rxBin6Ema: 0,
    rxBin7Ema: 0,
    rxBin8Ema: 0,
    rxBin9Ema: 0,
    rxBin10Ema: 0,
    rxBin11Ema: 0,
    rxBin12Ema: 0,
    rxBin13Ema: 0,
    rxBin14Ema: 0,
    rxBin15Ema: 0,
    rxBin16Ema: 0,
    rxBin17Ema: 0,
    rxBin18Ema: 0,
    rxBin19Ema: 0,
    rxBin20Ema: 0,
    rxBin21Ema: 0,
    rxBin22Ema: 0,
    rxBin23Ema: 0,
    rxBin24Ema: 0,
    rxBin25Ema: 0,
    rxBin26Ema: 0,
    rxBin27Ema: 0,
    suspiciousThreshold: 0,
    criticalThreshold: 0,
    suspiciousLatency: false,
    criticalLatency: false,
    suspiciousThresholdPercentage: 0,
    criticalThresholdPercentage: 0,
  };
}

export const IpmProcLatencyCounters: MessageFns<IpmProcLatencyCounters> = {
  encode(message: IpmProcLatencyCounters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.exceedingSuspicious !== 0) {
      writer.uint32(21).float(message.exceedingSuspicious);
    }
    if (message.exceedingCritical !== 0) {
      writer.uint32(29).float(message.exceedingCritical);
    }
    if (message.ipmParams !== undefined) {
      IpmSessionParameters.encode(message.ipmParams, writer.uint32(34).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(42).fork()).join();
    }
    if (message.exceedingSuspiciousEma !== 0) {
      writer.uint32(53).float(message.exceedingSuspiciousEma);
    }
    if (message.exceedingCriticalEma !== 0) {
      writer.uint32(61).float(message.exceedingCriticalEma);
    }
    if (message.rxBin0Ema !== 0) {
      writer.uint32(69).float(message.rxBin0Ema);
    }
    if (message.rxBin1Ema !== 0) {
      writer.uint32(77).float(message.rxBin1Ema);
    }
    if (message.rxBin2Ema !== 0) {
      writer.uint32(85).float(message.rxBin2Ema);
    }
    if (message.rxBin3Ema !== 0) {
      writer.uint32(93).float(message.rxBin3Ema);
    }
    if (message.rxBin4Ema !== 0) {
      writer.uint32(101).float(message.rxBin4Ema);
    }
    if (message.rxBin5Ema !== 0) {
      writer.uint32(109).float(message.rxBin5Ema);
    }
    if (message.rxBin6Ema !== 0) {
      writer.uint32(117).float(message.rxBin6Ema);
    }
    if (message.rxBin7Ema !== 0) {
      writer.uint32(125).float(message.rxBin7Ema);
    }
    if (message.rxBin8Ema !== 0) {
      writer.uint32(133).float(message.rxBin8Ema);
    }
    if (message.rxBin9Ema !== 0) {
      writer.uint32(141).float(message.rxBin9Ema);
    }
    if (message.rxBin10Ema !== 0) {
      writer.uint32(149).float(message.rxBin10Ema);
    }
    if (message.rxBin11Ema !== 0) {
      writer.uint32(157).float(message.rxBin11Ema);
    }
    if (message.rxBin12Ema !== 0) {
      writer.uint32(165).float(message.rxBin12Ema);
    }
    if (message.rxBin13Ema !== 0) {
      writer.uint32(173).float(message.rxBin13Ema);
    }
    if (message.rxBin14Ema !== 0) {
      writer.uint32(181).float(message.rxBin14Ema);
    }
    if (message.rxBin15Ema !== 0) {
      writer.uint32(189).float(message.rxBin15Ema);
    }
    if (message.rxBin16Ema !== 0) {
      writer.uint32(197).float(message.rxBin16Ema);
    }
    if (message.rxBin17Ema !== 0) {
      writer.uint32(205).float(message.rxBin17Ema);
    }
    if (message.rxBin18Ema !== 0) {
      writer.uint32(213).float(message.rxBin18Ema);
    }
    if (message.rxBin19Ema !== 0) {
      writer.uint32(221).float(message.rxBin19Ema);
    }
    if (message.rxBin20Ema !== 0) {
      writer.uint32(229).float(message.rxBin20Ema);
    }
    if (message.rxBin21Ema !== 0) {
      writer.uint32(237).float(message.rxBin21Ema);
    }
    if (message.rxBin22Ema !== 0) {
      writer.uint32(245).float(message.rxBin22Ema);
    }
    if (message.rxBin23Ema !== 0) {
      writer.uint32(253).float(message.rxBin23Ema);
    }
    if (message.rxBin24Ema !== 0) {
      writer.uint32(261).float(message.rxBin24Ema);
    }
    if (message.rxBin25Ema !== 0) {
      writer.uint32(269).float(message.rxBin25Ema);
    }
    if (message.rxBin26Ema !== 0) {
      writer.uint32(277).float(message.rxBin26Ema);
    }
    if (message.rxBin27Ema !== 0) {
      writer.uint32(285).float(message.rxBin27Ema);
    }
    if (message.suspiciousThreshold !== 0) {
      writer.uint32(293).float(message.suspiciousThreshold);
    }
    if (message.criticalThreshold !== 0) {
      writer.uint32(301).float(message.criticalThreshold);
    }
    if (message.suspiciousLatency !== false) {
      writer.uint32(304).bool(message.suspiciousLatency);
    }
    if (message.criticalLatency !== false) {
      writer.uint32(312).bool(message.criticalLatency);
    }
    if (message.suspiciousThresholdPercentage !== 0) {
      writer.uint32(325).float(message.suspiciousThresholdPercentage);
    }
    if (message.criticalThresholdPercentage !== 0) {
      writer.uint32(333).float(message.criticalThresholdPercentage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpmProcLatencyCounters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpmProcLatencyCounters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.exceedingSuspicious = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.exceedingCritical = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ipmParams = IpmSessionParameters.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.exceedingSuspiciousEma = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.exceedingCriticalEma = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.rxBin0Ema = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.rxBin1Ema = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.rxBin2Ema = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.rxBin3Ema = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 101) {
            break;
          }

          message.rxBin4Ema = reader.float();
          continue;
        }
        case 13: {
          if (tag !== 109) {
            break;
          }

          message.rxBin5Ema = reader.float();
          continue;
        }
        case 14: {
          if (tag !== 117) {
            break;
          }

          message.rxBin6Ema = reader.float();
          continue;
        }
        case 15: {
          if (tag !== 125) {
            break;
          }

          message.rxBin7Ema = reader.float();
          continue;
        }
        case 16: {
          if (tag !== 133) {
            break;
          }

          message.rxBin8Ema = reader.float();
          continue;
        }
        case 17: {
          if (tag !== 141) {
            break;
          }

          message.rxBin9Ema = reader.float();
          continue;
        }
        case 18: {
          if (tag !== 149) {
            break;
          }

          message.rxBin10Ema = reader.float();
          continue;
        }
        case 19: {
          if (tag !== 157) {
            break;
          }

          message.rxBin11Ema = reader.float();
          continue;
        }
        case 20: {
          if (tag !== 165) {
            break;
          }

          message.rxBin12Ema = reader.float();
          continue;
        }
        case 21: {
          if (tag !== 173) {
            break;
          }

          message.rxBin13Ema = reader.float();
          continue;
        }
        case 22: {
          if (tag !== 181) {
            break;
          }

          message.rxBin14Ema = reader.float();
          continue;
        }
        case 23: {
          if (tag !== 189) {
            break;
          }

          message.rxBin15Ema = reader.float();
          continue;
        }
        case 24: {
          if (tag !== 197) {
            break;
          }

          message.rxBin16Ema = reader.float();
          continue;
        }
        case 25: {
          if (tag !== 205) {
            break;
          }

          message.rxBin17Ema = reader.float();
          continue;
        }
        case 26: {
          if (tag !== 213) {
            break;
          }

          message.rxBin18Ema = reader.float();
          continue;
        }
        case 27: {
          if (tag !== 221) {
            break;
          }

          message.rxBin19Ema = reader.float();
          continue;
        }
        case 28: {
          if (tag !== 229) {
            break;
          }

          message.rxBin20Ema = reader.float();
          continue;
        }
        case 29: {
          if (tag !== 237) {
            break;
          }

          message.rxBin21Ema = reader.float();
          continue;
        }
        case 30: {
          if (tag !== 245) {
            break;
          }

          message.rxBin22Ema = reader.float();
          continue;
        }
        case 31: {
          if (tag !== 253) {
            break;
          }

          message.rxBin23Ema = reader.float();
          continue;
        }
        case 32: {
          if (tag !== 261) {
            break;
          }

          message.rxBin24Ema = reader.float();
          continue;
        }
        case 33: {
          if (tag !== 269) {
            break;
          }

          message.rxBin25Ema = reader.float();
          continue;
        }
        case 34: {
          if (tag !== 277) {
            break;
          }

          message.rxBin26Ema = reader.float();
          continue;
        }
        case 35: {
          if (tag !== 285) {
            break;
          }

          message.rxBin27Ema = reader.float();
          continue;
        }
        case 36: {
          if (tag !== 293) {
            break;
          }

          message.suspiciousThreshold = reader.float();
          continue;
        }
        case 37: {
          if (tag !== 301) {
            break;
          }

          message.criticalThreshold = reader.float();
          continue;
        }
        case 38: {
          if (tag !== 304) {
            break;
          }

          message.suspiciousLatency = reader.bool();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.criticalLatency = reader.bool();
          continue;
        }
        case 40: {
          if (tag !== 325) {
            break;
          }

          message.suspiciousThresholdPercentage = reader.float();
          continue;
        }
        case 41: {
          if (tag !== 333) {
            break;
          }

          message.criticalThresholdPercentage = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpmProcLatencyCounters {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      exceedingSuspicious: isSet(object.exceeding_suspicious) ? globalThis.Number(object.exceeding_suspicious) : 0,
      exceedingCritical: isSet(object.exceeding_critical) ? globalThis.Number(object.exceeding_critical) : 0,
      ipmParams: isSet(object.ipmParams) ? IpmSessionParameters.fromJSON(object.ipmParams) : undefined,
      collectedAt: isSet(object["collected-at"]) ? fromJsonTimestamp(object["collected-at"]) : undefined,
      exceedingSuspiciousEma: isSet(object.exceeding_suspicious_ema)
        ? globalThis.Number(object.exceeding_suspicious_ema)
        : 0,
      exceedingCriticalEma: isSet(object.exceeding_critical_ema) ? globalThis.Number(object.exceeding_critical_ema) : 0,
      rxBin0Ema: isSet(object.rx_bin0_ema) ? globalThis.Number(object.rx_bin0_ema) : 0,
      rxBin1Ema: isSet(object.rx_bin1_ema) ? globalThis.Number(object.rx_bin1_ema) : 0,
      rxBin2Ema: isSet(object.rx_bin2_ema) ? globalThis.Number(object.rx_bin2_ema) : 0,
      rxBin3Ema: isSet(object.rx_bin3_ema) ? globalThis.Number(object.rx_bin3_ema) : 0,
      rxBin4Ema: isSet(object.rx_bin4_ema) ? globalThis.Number(object.rx_bin4_ema) : 0,
      rxBin5Ema: isSet(object.rx_bin5_ema) ? globalThis.Number(object.rx_bin5_ema) : 0,
      rxBin6Ema: isSet(object.rx_bin6_ema) ? globalThis.Number(object.rx_bin6_ema) : 0,
      rxBin7Ema: isSet(object.rx_bin7_ema) ? globalThis.Number(object.rx_bin7_ema) : 0,
      rxBin8Ema: isSet(object.rx_bin8_ema) ? globalThis.Number(object.rx_bin8_ema) : 0,
      rxBin9Ema: isSet(object.rx_bin9_ema) ? globalThis.Number(object.rx_bin9_ema) : 0,
      rxBin10Ema: isSet(object.rx_bin10_ema) ? globalThis.Number(object.rx_bin10_ema) : 0,
      rxBin11Ema: isSet(object.rx_bin11_ema) ? globalThis.Number(object.rx_bin11_ema) : 0,
      rxBin12Ema: isSet(object.rx_bin12_ema) ? globalThis.Number(object.rx_bin12_ema) : 0,
      rxBin13Ema: isSet(object.rx_bin13_ema) ? globalThis.Number(object.rx_bin13_ema) : 0,
      rxBin14Ema: isSet(object.rx_bin14_ema) ? globalThis.Number(object.rx_bin14_ema) : 0,
      rxBin15Ema: isSet(object.rx_bin15_ema) ? globalThis.Number(object.rx_bin15_ema) : 0,
      rxBin16Ema: isSet(object.rx_bin16_ema) ? globalThis.Number(object.rx_bin16_ema) : 0,
      rxBin17Ema: isSet(object.rx_bin17_ema) ? globalThis.Number(object.rx_bin17_ema) : 0,
      rxBin18Ema: isSet(object.rx_bin18_ema) ? globalThis.Number(object.rx_bin18_ema) : 0,
      rxBin19Ema: isSet(object.rx_bin19_ema) ? globalThis.Number(object.rx_bin19_ema) : 0,
      rxBin20Ema: isSet(object.rx_bin20_ema) ? globalThis.Number(object.rx_bin20_ema) : 0,
      rxBin21Ema: isSet(object.rx_bin21_ema) ? globalThis.Number(object.rx_bin21_ema) : 0,
      rxBin22Ema: isSet(object.rx_bin22_ema) ? globalThis.Number(object.rx_bin22_ema) : 0,
      rxBin23Ema: isSet(object.rx_bin23_ema) ? globalThis.Number(object.rx_bin23_ema) : 0,
      rxBin24Ema: isSet(object.rx_bin24_ema) ? globalThis.Number(object.rx_bin24_ema) : 0,
      rxBin25Ema: isSet(object.rx_bin25_ema) ? globalThis.Number(object.rx_bin25_ema) : 0,
      rxBin26Ema: isSet(object.rx_bin26_ema) ? globalThis.Number(object.rx_bin26_ema) : 0,
      rxBin27Ema: isSet(object.rx_bin27_ema) ? globalThis.Number(object.rx_bin27_ema) : 0,
      suspiciousThreshold: isSet(object.suspicious_threshold) ? globalThis.Number(object.suspicious_threshold) : 0,
      criticalThreshold: isSet(object.critical_threshold) ? globalThis.Number(object.critical_threshold) : 0,
      suspiciousLatency: isSet(object.suspicious_latency) ? globalThis.Boolean(object.suspicious_latency) : false,
      criticalLatency: isSet(object.critical_latency) ? globalThis.Boolean(object.critical_latency) : false,
      suspiciousThresholdPercentage: isSet(object.suspicious_threshold_percentage)
        ? globalThis.Number(object.suspicious_threshold_percentage)
        : 0,
      criticalThresholdPercentage: isSet(object.critical_threshold_percentage)
        ? globalThis.Number(object.critical_threshold_percentage)
        : 0,
    };
  },

  toJSON(message: IpmProcLatencyCounters): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.exceedingSuspicious !== 0) {
      obj.exceeding_suspicious = message.exceedingSuspicious;
    }
    if (message.exceedingCritical !== 0) {
      obj.exceeding_critical = message.exceedingCritical;
    }
    if (message.ipmParams !== undefined) {
      obj.ipmParams = IpmSessionParameters.toJSON(message.ipmParams);
    }
    if (message.collectedAt !== undefined) {
      obj["collected-at"] = message.collectedAt.toISOString();
    }
    if (message.exceedingSuspiciousEma !== 0) {
      obj.exceeding_suspicious_ema = message.exceedingSuspiciousEma;
    }
    if (message.exceedingCriticalEma !== 0) {
      obj.exceeding_critical_ema = message.exceedingCriticalEma;
    }
    if (message.rxBin0Ema !== 0) {
      obj.rx_bin0_ema = message.rxBin0Ema;
    }
    if (message.rxBin1Ema !== 0) {
      obj.rx_bin1_ema = message.rxBin1Ema;
    }
    if (message.rxBin2Ema !== 0) {
      obj.rx_bin2_ema = message.rxBin2Ema;
    }
    if (message.rxBin3Ema !== 0) {
      obj.rx_bin3_ema = message.rxBin3Ema;
    }
    if (message.rxBin4Ema !== 0) {
      obj.rx_bin4_ema = message.rxBin4Ema;
    }
    if (message.rxBin5Ema !== 0) {
      obj.rx_bin5_ema = message.rxBin5Ema;
    }
    if (message.rxBin6Ema !== 0) {
      obj.rx_bin6_ema = message.rxBin6Ema;
    }
    if (message.rxBin7Ema !== 0) {
      obj.rx_bin7_ema = message.rxBin7Ema;
    }
    if (message.rxBin8Ema !== 0) {
      obj.rx_bin8_ema = message.rxBin8Ema;
    }
    if (message.rxBin9Ema !== 0) {
      obj.rx_bin9_ema = message.rxBin9Ema;
    }
    if (message.rxBin10Ema !== 0) {
      obj.rx_bin10_ema = message.rxBin10Ema;
    }
    if (message.rxBin11Ema !== 0) {
      obj.rx_bin11_ema = message.rxBin11Ema;
    }
    if (message.rxBin12Ema !== 0) {
      obj.rx_bin12_ema = message.rxBin12Ema;
    }
    if (message.rxBin13Ema !== 0) {
      obj.rx_bin13_ema = message.rxBin13Ema;
    }
    if (message.rxBin14Ema !== 0) {
      obj.rx_bin14_ema = message.rxBin14Ema;
    }
    if (message.rxBin15Ema !== 0) {
      obj.rx_bin15_ema = message.rxBin15Ema;
    }
    if (message.rxBin16Ema !== 0) {
      obj.rx_bin16_ema = message.rxBin16Ema;
    }
    if (message.rxBin17Ema !== 0) {
      obj.rx_bin17_ema = message.rxBin17Ema;
    }
    if (message.rxBin18Ema !== 0) {
      obj.rx_bin18_ema = message.rxBin18Ema;
    }
    if (message.rxBin19Ema !== 0) {
      obj.rx_bin19_ema = message.rxBin19Ema;
    }
    if (message.rxBin20Ema !== 0) {
      obj.rx_bin20_ema = message.rxBin20Ema;
    }
    if (message.rxBin21Ema !== 0) {
      obj.rx_bin21_ema = message.rxBin21Ema;
    }
    if (message.rxBin22Ema !== 0) {
      obj.rx_bin22_ema = message.rxBin22Ema;
    }
    if (message.rxBin23Ema !== 0) {
      obj.rx_bin23_ema = message.rxBin23Ema;
    }
    if (message.rxBin24Ema !== 0) {
      obj.rx_bin24_ema = message.rxBin24Ema;
    }
    if (message.rxBin25Ema !== 0) {
      obj.rx_bin25_ema = message.rxBin25Ema;
    }
    if (message.rxBin26Ema !== 0) {
      obj.rx_bin26_ema = message.rxBin26Ema;
    }
    if (message.rxBin27Ema !== 0) {
      obj.rx_bin27_ema = message.rxBin27Ema;
    }
    if (message.suspiciousThreshold !== 0) {
      obj.suspicious_threshold = message.suspiciousThreshold;
    }
    if (message.criticalThreshold !== 0) {
      obj.critical_threshold = message.criticalThreshold;
    }
    if (message.suspiciousLatency !== false) {
      obj.suspicious_latency = message.suspiciousLatency;
    }
    if (message.criticalLatency !== false) {
      obj.critical_latency = message.criticalLatency;
    }
    if (message.suspiciousThresholdPercentage !== 0) {
      obj.suspicious_threshold_percentage = message.suspiciousThresholdPercentage;
    }
    if (message.criticalThresholdPercentage !== 0) {
      obj.critical_threshold_percentage = message.criticalThresholdPercentage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpmProcLatencyCounters>, I>>(base?: I): IpmProcLatencyCounters {
    return IpmProcLatencyCounters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpmProcLatencyCounters>, I>>(object: I): IpmProcLatencyCounters {
    const message = createBaseIpmProcLatencyCounters();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.exceedingSuspicious = object.exceedingSuspicious ?? 0;
    message.exceedingCritical = object.exceedingCritical ?? 0;
    message.ipmParams = (object.ipmParams !== undefined && object.ipmParams !== null)
      ? IpmSessionParameters.fromPartial(object.ipmParams)
      : undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    message.exceedingSuspiciousEma = object.exceedingSuspiciousEma ?? 0;
    message.exceedingCriticalEma = object.exceedingCriticalEma ?? 0;
    message.rxBin0Ema = object.rxBin0Ema ?? 0;
    message.rxBin1Ema = object.rxBin1Ema ?? 0;
    message.rxBin2Ema = object.rxBin2Ema ?? 0;
    message.rxBin3Ema = object.rxBin3Ema ?? 0;
    message.rxBin4Ema = object.rxBin4Ema ?? 0;
    message.rxBin5Ema = object.rxBin5Ema ?? 0;
    message.rxBin6Ema = object.rxBin6Ema ?? 0;
    message.rxBin7Ema = object.rxBin7Ema ?? 0;
    message.rxBin8Ema = object.rxBin8Ema ?? 0;
    message.rxBin9Ema = object.rxBin9Ema ?? 0;
    message.rxBin10Ema = object.rxBin10Ema ?? 0;
    message.rxBin11Ema = object.rxBin11Ema ?? 0;
    message.rxBin12Ema = object.rxBin12Ema ?? 0;
    message.rxBin13Ema = object.rxBin13Ema ?? 0;
    message.rxBin14Ema = object.rxBin14Ema ?? 0;
    message.rxBin15Ema = object.rxBin15Ema ?? 0;
    message.rxBin16Ema = object.rxBin16Ema ?? 0;
    message.rxBin17Ema = object.rxBin17Ema ?? 0;
    message.rxBin18Ema = object.rxBin18Ema ?? 0;
    message.rxBin19Ema = object.rxBin19Ema ?? 0;
    message.rxBin20Ema = object.rxBin20Ema ?? 0;
    message.rxBin21Ema = object.rxBin21Ema ?? 0;
    message.rxBin22Ema = object.rxBin22Ema ?? 0;
    message.rxBin23Ema = object.rxBin23Ema ?? 0;
    message.rxBin24Ema = object.rxBin24Ema ?? 0;
    message.rxBin25Ema = object.rxBin25Ema ?? 0;
    message.rxBin26Ema = object.rxBin26Ema ?? 0;
    message.rxBin27Ema = object.rxBin27Ema ?? 0;
    message.suspiciousThreshold = object.suspiciousThreshold ?? 0;
    message.criticalThreshold = object.criticalThreshold ?? 0;
    message.suspiciousLatency = object.suspiciousLatency ?? false;
    message.criticalLatency = object.criticalLatency ?? false;
    message.suspiciousThresholdPercentage = object.suspiciousThresholdPercentage ?? 0;
    message.criticalThresholdPercentage = object.criticalThresholdPercentage ?? 0;
    return message;
  },
};

function createBaseIpmProcLossCounters(): IpmProcLossCounters {
  return {
    id: undefined,
    transmittedPackets: "0",
    receivedPackets: "0",
    loss: "0",
    pLoss: 0,
    ipmParams: undefined,
    collectedAt: undefined,
    pLossEma: 0,
    alternateMarkingInterval: 0,
  };
}

export const IpmProcLossCounters: MessageFns<IpmProcLossCounters> = {
  encode(message: IpmProcLossCounters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.transmittedPackets !== "0") {
      writer.uint32(24).uint64(message.transmittedPackets);
    }
    if (message.receivedPackets !== "0") {
      writer.uint32(32).uint64(message.receivedPackets);
    }
    if (message.loss !== "0") {
      writer.uint32(40).uint64(message.loss);
    }
    if (message.pLoss !== 0) {
      writer.uint32(53).float(message.pLoss);
    }
    if (message.ipmParams !== undefined) {
      IpmSessionParameters.encode(message.ipmParams, writer.uint32(58).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(66).fork()).join();
    }
    if (message.pLossEma !== 0) {
      writer.uint32(77).float(message.pLossEma);
    }
    if (message.alternateMarkingInterval !== 0) {
      writer.uint32(80).uint32(message.alternateMarkingInterval);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpmProcLossCounters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpmProcLossCounters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.transmittedPackets = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.receivedPackets = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.loss = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.pLoss = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ipmParams = IpmSessionParameters.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.pLossEma = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.alternateMarkingInterval = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpmProcLossCounters {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      transmittedPackets: isSet(object.transmitted_packets) ? globalThis.String(object.transmitted_packets) : "0",
      receivedPackets: isSet(object.received_packets) ? globalThis.String(object.received_packets) : "0",
      loss: isSet(object.loss) ? globalThis.String(object.loss) : "0",
      pLoss: isSet(object.p_loss) ? globalThis.Number(object.p_loss) : 0,
      ipmParams: isSet(object.ipmParams) ? IpmSessionParameters.fromJSON(object.ipmParams) : undefined,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      pLossEma: isSet(object.p_loss_ema) ? globalThis.Number(object.p_loss_ema) : 0,
      alternateMarkingInterval: isSet(object.alternate_marking_interval)
        ? globalThis.Number(object.alternate_marking_interval)
        : 0,
    };
  },

  toJSON(message: IpmProcLossCounters): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.transmittedPackets !== "0") {
      obj.transmitted_packets = message.transmittedPackets;
    }
    if (message.receivedPackets !== "0") {
      obj.received_packets = message.receivedPackets;
    }
    if (message.loss !== "0") {
      obj.loss = message.loss;
    }
    if (message.pLoss !== 0) {
      obj.p_loss = message.pLoss;
    }
    if (message.ipmParams !== undefined) {
      obj.ipmParams = IpmSessionParameters.toJSON(message.ipmParams);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.pLossEma !== 0) {
      obj.p_loss_ema = message.pLossEma;
    }
    if (message.alternateMarkingInterval !== 0) {
      obj.alternate_marking_interval = Math.round(message.alternateMarkingInterval);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpmProcLossCounters>, I>>(base?: I): IpmProcLossCounters {
    return IpmProcLossCounters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpmProcLossCounters>, I>>(object: I): IpmProcLossCounters {
    const message = createBaseIpmProcLossCounters();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.transmittedPackets = object.transmittedPackets ?? "0";
    message.receivedPackets = object.receivedPackets ?? "0";
    message.loss = object.loss ?? "0";
    message.pLoss = object.pLoss ?? 0;
    message.ipmParams = (object.ipmParams !== undefined && object.ipmParams !== null)
      ? IpmSessionParameters.fromPartial(object.ipmParams)
      : undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    message.pLossEma = object.pLossEma ?? 0;
    message.alternateMarkingInterval = object.alternateMarkingInterval ?? 0;
    return message;
  },
};

function createBaseIpmLivenessCounters(): IpmLivenessCounters {
  return { id: undefined, state: 0, livenessTimer: 0, ipmParams: undefined, collectedAt: undefined };
}

export const IpmLivenessCounters: MessageFns<IpmLivenessCounters> = {
  encode(message: IpmLivenessCounters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.state !== 0) {
      writer.uint32(16).int32(message.state);
    }
    if (message.livenessTimer !== 0) {
      writer.uint32(24).uint32(message.livenessTimer);
    }
    if (message.ipmParams !== undefined) {
      IpmSessionParameters.encode(message.ipmParams, writer.uint32(34).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpmLivenessCounters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpmLivenessCounters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.livenessTimer = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ipmParams = IpmSessionParameters.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpmLivenessCounters {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      state: isSet(object.state) ? livenessStatusFromJSON(object.state) : 0,
      livenessTimer: isSet(object.liveness_timer) ? globalThis.Number(object.liveness_timer) : 0,
      ipmParams: isSet(object.ipmParams) ? IpmSessionParameters.fromJSON(object.ipmParams) : undefined,
      collectedAt: isSet(object["collected-at"]) ? fromJsonTimestamp(object["collected-at"]) : undefined,
    };
  },

  toJSON(message: IpmLivenessCounters): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.state !== 0) {
      obj.state = livenessStatusToJSON(message.state);
    }
    if (message.livenessTimer !== 0) {
      obj.liveness_timer = Math.round(message.livenessTimer);
    }
    if (message.ipmParams !== undefined) {
      obj.ipmParams = IpmSessionParameters.toJSON(message.ipmParams);
    }
    if (message.collectedAt !== undefined) {
      obj["collected-at"] = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpmLivenessCounters>, I>>(base?: I): IpmLivenessCounters {
    return IpmLivenessCounters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpmLivenessCounters>, I>>(object: I): IpmLivenessCounters {
    const message = createBaseIpmLivenessCounters();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.state = object.state ?? 0;
    message.livenessTimer = object.livenessTimer ?? 0;
    message.ipmParams = (object.ipmParams !== undefined && object.ipmParams !== null)
      ? IpmSessionParameters.fromPartial(object.ipmParams)
      : undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseIpmProcJitterCounters(): IpmProcJitterCounters {
  return {
    id: undefined,
    latPercentile0: 0,
    latPercentile5: 0,
    latPercentile10: 0,
    latPercentile25: 0,
    latPercentile50: 0,
    latPercentile75: 0,
    latPercentile90: 0,
    latPercentile95: 0,
    latPercentile100: 0,
    jitter50: 0,
    jitter80: 0,
    jitter90: 0,
    jitter100: 0,
    jitter50Ema: 0,
    jitter80Ema: 0,
    jitter90Ema: 0,
    jitter100Ema: 0,
    ipmParams: undefined,
    collectedAt: undefined,
  };
}

export const IpmProcJitterCounters: MessageFns<IpmProcJitterCounters> = {
  encode(message: IpmProcJitterCounters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.latPercentile0 !== 0) {
      writer.uint32(45).float(message.latPercentile0);
    }
    if (message.latPercentile5 !== 0) {
      writer.uint32(53).float(message.latPercentile5);
    }
    if (message.latPercentile10 !== 0) {
      writer.uint32(61).float(message.latPercentile10);
    }
    if (message.latPercentile25 !== 0) {
      writer.uint32(69).float(message.latPercentile25);
    }
    if (message.latPercentile50 !== 0) {
      writer.uint32(77).float(message.latPercentile50);
    }
    if (message.latPercentile75 !== 0) {
      writer.uint32(85).float(message.latPercentile75);
    }
    if (message.latPercentile90 !== 0) {
      writer.uint32(93).float(message.latPercentile90);
    }
    if (message.latPercentile95 !== 0) {
      writer.uint32(101).float(message.latPercentile95);
    }
    if (message.latPercentile100 !== 0) {
      writer.uint32(109).float(message.latPercentile100);
    }
    if (message.jitter50 !== 0) {
      writer.uint32(189).float(message.jitter50);
    }
    if (message.jitter80 !== 0) {
      writer.uint32(197).float(message.jitter80);
    }
    if (message.jitter90 !== 0) {
      writer.uint32(205).float(message.jitter90);
    }
    if (message.jitter100 !== 0) {
      writer.uint32(213).float(message.jitter100);
    }
    if (message.jitter50Ema !== 0) {
      writer.uint32(221).float(message.jitter50Ema);
    }
    if (message.jitter80Ema !== 0) {
      writer.uint32(229).float(message.jitter80Ema);
    }
    if (message.jitter90Ema !== 0) {
      writer.uint32(237).float(message.jitter90Ema);
    }
    if (message.jitter100Ema !== 0) {
      writer.uint32(245).float(message.jitter100Ema);
    }
    if (message.ipmParams !== undefined) {
      IpmSessionParameters.encode(message.ipmParams, writer.uint32(250).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(258).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpmProcJitterCounters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpmProcJitterCounters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.latPercentile0 = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.latPercentile5 = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.latPercentile10 = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.latPercentile25 = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.latPercentile50 = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.latPercentile75 = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.latPercentile90 = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 101) {
            break;
          }

          message.latPercentile95 = reader.float();
          continue;
        }
        case 13: {
          if (tag !== 109) {
            break;
          }

          message.latPercentile100 = reader.float();
          continue;
        }
        case 23: {
          if (tag !== 189) {
            break;
          }

          message.jitter50 = reader.float();
          continue;
        }
        case 24: {
          if (tag !== 197) {
            break;
          }

          message.jitter80 = reader.float();
          continue;
        }
        case 25: {
          if (tag !== 205) {
            break;
          }

          message.jitter90 = reader.float();
          continue;
        }
        case 26: {
          if (tag !== 213) {
            break;
          }

          message.jitter100 = reader.float();
          continue;
        }
        case 27: {
          if (tag !== 221) {
            break;
          }

          message.jitter50Ema = reader.float();
          continue;
        }
        case 28: {
          if (tag !== 229) {
            break;
          }

          message.jitter80Ema = reader.float();
          continue;
        }
        case 29: {
          if (tag !== 237) {
            break;
          }

          message.jitter90Ema = reader.float();
          continue;
        }
        case 30: {
          if (tag !== 245) {
            break;
          }

          message.jitter100Ema = reader.float();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.ipmParams = IpmSessionParameters.decode(reader, reader.uint32());
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpmProcJitterCounters {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      latPercentile0: isSet(object.lat_percentile0) ? globalThis.Number(object.lat_percentile0) : 0,
      latPercentile5: isSet(object.lat_percentile5) ? globalThis.Number(object.lat_percentile5) : 0,
      latPercentile10: isSet(object.lat_percentile10) ? globalThis.Number(object.lat_percentile10) : 0,
      latPercentile25: isSet(object.lat_percentile25) ? globalThis.Number(object.lat_percentile25) : 0,
      latPercentile50: isSet(object.lat_percentile50) ? globalThis.Number(object.lat_percentile50) : 0,
      latPercentile75: isSet(object.lat_percentile75) ? globalThis.Number(object.lat_percentile75) : 0,
      latPercentile90: isSet(object.lat_percentile90) ? globalThis.Number(object.lat_percentile90) : 0,
      latPercentile95: isSet(object.lat_percentile95) ? globalThis.Number(object.lat_percentile95) : 0,
      latPercentile100: isSet(object.lat_percentile100) ? globalThis.Number(object.lat_percentile100) : 0,
      jitter50: isSet(object.jitter50) ? globalThis.Number(object.jitter50) : 0,
      jitter80: isSet(object.jitter80) ? globalThis.Number(object.jitter80) : 0,
      jitter90: isSet(object.jitter90) ? globalThis.Number(object.jitter90) : 0,
      jitter100: isSet(object.jitter100) ? globalThis.Number(object.jitter100) : 0,
      jitter50Ema: isSet(object.jitter50_ema) ? globalThis.Number(object.jitter50_ema) : 0,
      jitter80Ema: isSet(object.jitter80_ema) ? globalThis.Number(object.jitter80_ema) : 0,
      jitter90Ema: isSet(object.jitter90_ema) ? globalThis.Number(object.jitter90_ema) : 0,
      jitter100Ema: isSet(object.jitter100_ema) ? globalThis.Number(object.jitter100_ema) : 0,
      ipmParams: isSet(object.ipmParams) ? IpmSessionParameters.fromJSON(object.ipmParams) : undefined,
      collectedAt: isSet(object["collected-at"]) ? fromJsonTimestamp(object["collected-at"]) : undefined,
    };
  },

  toJSON(message: IpmProcJitterCounters): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.latPercentile0 !== 0) {
      obj.lat_percentile0 = message.latPercentile0;
    }
    if (message.latPercentile5 !== 0) {
      obj.lat_percentile5 = message.latPercentile5;
    }
    if (message.latPercentile10 !== 0) {
      obj.lat_percentile10 = message.latPercentile10;
    }
    if (message.latPercentile25 !== 0) {
      obj.lat_percentile25 = message.latPercentile25;
    }
    if (message.latPercentile50 !== 0) {
      obj.lat_percentile50 = message.latPercentile50;
    }
    if (message.latPercentile75 !== 0) {
      obj.lat_percentile75 = message.latPercentile75;
    }
    if (message.latPercentile90 !== 0) {
      obj.lat_percentile90 = message.latPercentile90;
    }
    if (message.latPercentile95 !== 0) {
      obj.lat_percentile95 = message.latPercentile95;
    }
    if (message.latPercentile100 !== 0) {
      obj.lat_percentile100 = message.latPercentile100;
    }
    if (message.jitter50 !== 0) {
      obj.jitter50 = message.jitter50;
    }
    if (message.jitter80 !== 0) {
      obj.jitter80 = message.jitter80;
    }
    if (message.jitter90 !== 0) {
      obj.jitter90 = message.jitter90;
    }
    if (message.jitter100 !== 0) {
      obj.jitter100 = message.jitter100;
    }
    if (message.jitter50Ema !== 0) {
      obj.jitter50_ema = message.jitter50Ema;
    }
    if (message.jitter80Ema !== 0) {
      obj.jitter80_ema = message.jitter80Ema;
    }
    if (message.jitter90Ema !== 0) {
      obj.jitter90_ema = message.jitter90Ema;
    }
    if (message.jitter100Ema !== 0) {
      obj.jitter100_ema = message.jitter100Ema;
    }
    if (message.ipmParams !== undefined) {
      obj.ipmParams = IpmSessionParameters.toJSON(message.ipmParams);
    }
    if (message.collectedAt !== undefined) {
      obj["collected-at"] = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpmProcJitterCounters>, I>>(base?: I): IpmProcJitterCounters {
    return IpmProcJitterCounters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpmProcJitterCounters>, I>>(object: I): IpmProcJitterCounters {
    const message = createBaseIpmProcJitterCounters();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.latPercentile0 = object.latPercentile0 ?? 0;
    message.latPercentile5 = object.latPercentile5 ?? 0;
    message.latPercentile10 = object.latPercentile10 ?? 0;
    message.latPercentile25 = object.latPercentile25 ?? 0;
    message.latPercentile50 = object.latPercentile50 ?? 0;
    message.latPercentile75 = object.latPercentile75 ?? 0;
    message.latPercentile90 = object.latPercentile90 ?? 0;
    message.latPercentile95 = object.latPercentile95 ?? 0;
    message.latPercentile100 = object.latPercentile100 ?? 0;
    message.jitter50 = object.jitter50 ?? 0;
    message.jitter80 = object.jitter80 ?? 0;
    message.jitter90 = object.jitter90 ?? 0;
    message.jitter100 = object.jitter100 ?? 0;
    message.jitter50Ema = object.jitter50Ema ?? 0;
    message.jitter80Ema = object.jitter80Ema ?? 0;
    message.jitter90Ema = object.jitter90Ema ?? 0;
    message.jitter100Ema = object.jitter100Ema ?? 0;
    message.ipmParams = (object.ipmParams !== undefined && object.ipmParams !== null)
      ? IpmSessionParameters.fromPartial(object.ipmParams)
      : undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBasePortVlanInfo(): PortVlanInfo {
  return { id: undefined, vlan: 0, taggingMode: 0, collectedAt: undefined };
}

export const PortVlanInfo: MessageFns<PortVlanInfo> = {
  encode(message: PortVlanInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.vlan !== 0) {
      writer.uint32(24).uint32(message.vlan);
    }
    if (message.taggingMode !== 0) {
      writer.uint32(32).int32(message.taggingMode);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortVlanInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortVlanInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vlan = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.taggingMode = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortVlanInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vlan: isSet(object.vlan) ? globalThis.Number(object.vlan) : 0,
      taggingMode: isSet(object.taggingMode) ? vlanTaggingModeFromJSON(object.taggingMode) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: PortVlanInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vlan !== 0) {
      obj.vlan = Math.round(message.vlan);
    }
    if (message.taggingMode !== 0) {
      obj.taggingMode = vlanTaggingModeToJSON(message.taggingMode);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortVlanInfo>, I>>(base?: I): PortVlanInfo {
    return PortVlanInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortVlanInfo>, I>>(object: I): PortVlanInfo {
    const message = createBasePortVlanInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vlan = object.vlan ?? 0;
    message.taggingMode = object.taggingMode ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseVlanCounters(): VlanCounters {
  return {
    id: undefined,
    bytesIn: "0",
    bytesOut: "0",
    pktsIn: "0",
    pktsOut: "0",
    errIn: "0",
    errOut: "0",
    errPktsIn: "0",
    errPktsOut: "0",
    collectedAt: undefined,
    anyPortUp: false,
  };
}

export const VlanCounters: MessageFns<VlanCounters> = {
  encode(message: VlanCounters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.bytesIn !== "0") {
      writer.uint32(24).uint64(message.bytesIn);
    }
    if (message.bytesOut !== "0") {
      writer.uint32(32).uint64(message.bytesOut);
    }
    if (message.pktsIn !== "0") {
      writer.uint32(40).uint64(message.pktsIn);
    }
    if (message.pktsOut !== "0") {
      writer.uint32(48).uint64(message.pktsOut);
    }
    if (message.errIn !== "0") {
      writer.uint32(56).uint64(message.errIn);
    }
    if (message.errOut !== "0") {
      writer.uint32(64).uint64(message.errOut);
    }
    if (message.errPktsIn !== "0") {
      writer.uint32(72).uint64(message.errPktsIn);
    }
    if (message.errPktsOut !== "0") {
      writer.uint32(80).uint64(message.errPktsOut);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(90).fork()).join();
    }
    if (message.anyPortUp !== false) {
      writer.uint32(96).bool(message.anyPortUp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VlanCounters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVlanCounters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.bytesIn = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.bytesOut = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.pktsIn = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.pktsOut = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.errIn = reader.uint64().toString();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.errOut = reader.uint64().toString();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.errPktsIn = reader.uint64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.errPktsOut = reader.uint64().toString();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.anyPortUp = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VlanCounters {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      bytesIn: isSet(object.bytesIn) ? globalThis.String(object.bytesIn) : "0",
      bytesOut: isSet(object.bytesOut) ? globalThis.String(object.bytesOut) : "0",
      pktsIn: isSet(object.pktsIn) ? globalThis.String(object.pktsIn) : "0",
      pktsOut: isSet(object.pktsOut) ? globalThis.String(object.pktsOut) : "0",
      errIn: isSet(object.errIn) ? globalThis.String(object.errIn) : "0",
      errOut: isSet(object.errOut) ? globalThis.String(object.errOut) : "0",
      errPktsIn: isSet(object.errPktsIn) ? globalThis.String(object.errPktsIn) : "0",
      errPktsOut: isSet(object.errPktsOut) ? globalThis.String(object.errPktsOut) : "0",
      collectedAt: isSet(object["collected-at"]) ? fromJsonTimestamp(object["collected-at"]) : undefined,
      anyPortUp: isSet(object.anyPortUp) ? globalThis.Boolean(object.anyPortUp) : false,
    };
  },

  toJSON(message: VlanCounters): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.bytesIn !== "0") {
      obj.bytesIn = message.bytesIn;
    }
    if (message.bytesOut !== "0") {
      obj.bytesOut = message.bytesOut;
    }
    if (message.pktsIn !== "0") {
      obj.pktsIn = message.pktsIn;
    }
    if (message.pktsOut !== "0") {
      obj.pktsOut = message.pktsOut;
    }
    if (message.errIn !== "0") {
      obj.errIn = message.errIn;
    }
    if (message.errOut !== "0") {
      obj.errOut = message.errOut;
    }
    if (message.errPktsIn !== "0") {
      obj.errPktsIn = message.errPktsIn;
    }
    if (message.errPktsOut !== "0") {
      obj.errPktsOut = message.errPktsOut;
    }
    if (message.collectedAt !== undefined) {
      obj["collected-at"] = message.collectedAt.toISOString();
    }
    if (message.anyPortUp !== false) {
      obj.anyPortUp = message.anyPortUp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VlanCounters>, I>>(base?: I): VlanCounters {
    return VlanCounters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VlanCounters>, I>>(object: I): VlanCounters {
    const message = createBaseVlanCounters();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.bytesIn = object.bytesIn ?? "0";
    message.bytesOut = object.bytesOut ?? "0";
    message.pktsIn = object.pktsIn ?? "0";
    message.pktsOut = object.pktsOut ?? "0";
    message.errIn = object.errIn ?? "0";
    message.errOut = object.errOut ?? "0";
    message.errPktsIn = object.errPktsIn ?? "0";
    message.errPktsOut = object.errPktsOut ?? "0";
    message.collectedAt = object.collectedAt ?? undefined;
    message.anyPortUp = object.anyPortUp ?? false;
    return message;
  },
};

function createBaseRoutedInterfaceCounters(): RoutedInterfaceCounters {
  return {
    id: undefined,
    bytesIn: "0",
    bytesOut: "0",
    pktsIn: "0",
    pktsOut: "0",
    errIn: "0",
    errOut: "0",
    errPktsIn: "0",
    errPktsOut: "0",
    collectedAt: undefined,
  };
}

export const RoutedInterfaceCounters: MessageFns<RoutedInterfaceCounters> = {
  encode(message: RoutedInterfaceCounters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.bytesIn !== "0") {
      writer.uint32(24).uint64(message.bytesIn);
    }
    if (message.bytesOut !== "0") {
      writer.uint32(32).uint64(message.bytesOut);
    }
    if (message.pktsIn !== "0") {
      writer.uint32(40).uint64(message.pktsIn);
    }
    if (message.pktsOut !== "0") {
      writer.uint32(48).uint64(message.pktsOut);
    }
    if (message.errIn !== "0") {
      writer.uint32(56).uint64(message.errIn);
    }
    if (message.errOut !== "0") {
      writer.uint32(64).uint64(message.errOut);
    }
    if (message.errPktsIn !== "0") {
      writer.uint32(72).uint64(message.errPktsIn);
    }
    if (message.errPktsOut !== "0") {
      writer.uint32(80).uint64(message.errPktsOut);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoutedInterfaceCounters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoutedInterfaceCounters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.bytesIn = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.bytesOut = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.pktsIn = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.pktsOut = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.errIn = reader.uint64().toString();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.errOut = reader.uint64().toString();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.errPktsIn = reader.uint64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.errPktsOut = reader.uint64().toString();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoutedInterfaceCounters {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      bytesIn: isSet(object.bytesIn) ? globalThis.String(object.bytesIn) : "0",
      bytesOut: isSet(object.bytesOut) ? globalThis.String(object.bytesOut) : "0",
      pktsIn: isSet(object.pktsIn) ? globalThis.String(object.pktsIn) : "0",
      pktsOut: isSet(object.pktsOut) ? globalThis.String(object.pktsOut) : "0",
      errIn: isSet(object.errIn) ? globalThis.String(object.errIn) : "0",
      errOut: isSet(object.errOut) ? globalThis.String(object.errOut) : "0",
      errPktsIn: isSet(object.errPktsIn) ? globalThis.String(object.errPktsIn) : "0",
      errPktsOut: isSet(object.errPktsOut) ? globalThis.String(object.errPktsOut) : "0",
      collectedAt: isSet(object["collected-at"]) ? fromJsonTimestamp(object["collected-at"]) : undefined,
    };
  },

  toJSON(message: RoutedInterfaceCounters): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.bytesIn !== "0") {
      obj.bytesIn = message.bytesIn;
    }
    if (message.bytesOut !== "0") {
      obj.bytesOut = message.bytesOut;
    }
    if (message.pktsIn !== "0") {
      obj.pktsIn = message.pktsIn;
    }
    if (message.pktsOut !== "0") {
      obj.pktsOut = message.pktsOut;
    }
    if (message.errIn !== "0") {
      obj.errIn = message.errIn;
    }
    if (message.errOut !== "0") {
      obj.errOut = message.errOut;
    }
    if (message.errPktsIn !== "0") {
      obj.errPktsIn = message.errPktsIn;
    }
    if (message.errPktsOut !== "0") {
      obj.errPktsOut = message.errPktsOut;
    }
    if (message.collectedAt !== undefined) {
      obj["collected-at"] = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RoutedInterfaceCounters>, I>>(base?: I): RoutedInterfaceCounters {
    return RoutedInterfaceCounters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoutedInterfaceCounters>, I>>(object: I): RoutedInterfaceCounters {
    const message = createBaseRoutedInterfaceCounters();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.bytesIn = object.bytesIn ?? "0";
    message.bytesOut = object.bytesOut ?? "0";
    message.pktsIn = object.pktsIn ?? "0";
    message.pktsOut = object.pktsOut ?? "0";
    message.errIn = object.errIn ?? "0";
    message.errOut = object.errOut ?? "0";
    message.errPktsIn = object.errPktsIn ?? "0";
    message.errPktsOut = object.errPktsOut ?? "0";
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseL2Fdb(): L2Fdb {
  return { id: undefined, l2entries: [] };
}

export const L2Fdb: MessageFns<L2Fdb> = {
  encode(message: L2Fdb, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    for (const v of message.l2entries) {
      L2FdbEntry.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): L2Fdb {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseL2Fdb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.l2entries.push(L2FdbEntry.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): L2Fdb {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      l2entries: globalThis.Array.isArray(object?.l2entries)
        ? object.l2entries.map((e: any) => L2FdbEntry.fromJSON(e))
        : [],
    };
  },

  toJSON(message: L2Fdb): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.l2entries?.length) {
      obj.l2entries = message.l2entries.map((e) => L2FdbEntry.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<L2Fdb>, I>>(base?: I): L2Fdb {
    return L2Fdb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<L2Fdb>, I>>(object: I): L2Fdb {
    const message = createBaseL2Fdb();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.l2entries = object.l2entries?.map((e) => L2FdbEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseL2FdbSingleVlan(): L2FdbSingleVlan {
  return { id: undefined };
}

export const L2FdbSingleVlan: MessageFns<L2FdbSingleVlan> = {
  encode(message: L2FdbSingleVlan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): L2FdbSingleVlan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseL2FdbSingleVlan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): L2FdbSingleVlan {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: L2FdbSingleVlan): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<L2FdbSingleVlan>, I>>(base?: I): L2FdbSingleVlan {
    return L2FdbSingleVlan.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<L2FdbSingleVlan>, I>>(object: I): L2FdbSingleVlan {
    const message = createBaseL2FdbSingleVlan();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseVniMacCounts(): VniMacCounts {
  return { id: undefined, l2Count: 0 };
}

export const VniMacCounts: MessageFns<VniMacCounts> = {
  encode(message: VniMacCounts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.l2Count !== 0) {
      writer.uint32(24).uint32(message.l2Count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VniMacCounts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVniMacCounts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.l2Count = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VniMacCounts {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      l2Count: isSet(object.l2Count) ? globalThis.Number(object.l2Count) : 0,
    };
  },

  toJSON(message: VniMacCounts): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.l2Count !== 0) {
      obj.l2Count = Math.round(message.l2Count);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VniMacCounts>, I>>(base?: I): VniMacCounts {
    return VniMacCounts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VniMacCounts>, I>>(object: I): VniMacCounts {
    const message = createBaseVniMacCounts();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.l2Count = object.l2Count ?? 0;
    return message;
  },
};

function createBaseVrfEndpointCounts(): VrfEndpointCounts {
  return { id: undefined, ipv4Count: 0, ipv6Count: 0 };
}

export const VrfEndpointCounts: MessageFns<VrfEndpointCounts> = {
  encode(message: VrfEndpointCounts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.ipv4Count !== 0) {
      writer.uint32(24).uint32(message.ipv4Count);
    }
    if (message.ipv6Count !== 0) {
      writer.uint32(32).uint32(message.ipv6Count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VrfEndpointCounts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVrfEndpointCounts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.ipv4Count = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.ipv6Count = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VrfEndpointCounts {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      ipv4Count: isSet(object.ipv4Count) ? globalThis.Number(object.ipv4Count) : 0,
      ipv6Count: isSet(object.ipv6Count) ? globalThis.Number(object.ipv6Count) : 0,
    };
  },

  toJSON(message: VrfEndpointCounts): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.ipv4Count !== 0) {
      obj.ipv4Count = Math.round(message.ipv4Count);
    }
    if (message.ipv6Count !== 0) {
      obj.ipv6Count = Math.round(message.ipv6Count);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VrfEndpointCounts>, I>>(base?: I): VrfEndpointCounts {
    return VrfEndpointCounts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VrfEndpointCounts>, I>>(object: I): VrfEndpointCounts {
    const message = createBaseVrfEndpointCounts();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.ipv4Count = object.ipv4Count ?? 0;
    message.ipv6Count = object.ipv6Count ?? 0;
    return message;
  },
};

function createBaseL2FdbSingle(): L2FdbSingle {
  return { id: undefined, l2entry: undefined };
}

export const L2FdbSingle: MessageFns<L2FdbSingle> = {
  encode(message: L2FdbSingle, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.l2entry !== undefined) {
      L2Entry.encode(message.l2entry, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): L2FdbSingle {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseL2FdbSingle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.l2entry = L2Entry.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): L2FdbSingle {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      l2entry: isSet(object.l2entry) ? L2Entry.fromJSON(object.l2entry) : undefined,
    };
  },

  toJSON(message: L2FdbSingle): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.l2entry !== undefined) {
      obj.l2entry = L2Entry.toJSON(message.l2entry);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<L2FdbSingle>, I>>(base?: I): L2FdbSingle {
    return L2FdbSingle.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<L2FdbSingle>, I>>(object: I): L2FdbSingle {
    const message = createBaseL2FdbSingle();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.l2entry = (object.l2entry !== undefined && object.l2entry !== null)
      ? L2Entry.fromPartial(object.l2entry)
      : undefined;
    return message;
  },
};

function createBaseL2FdbEntry(): L2FdbEntry {
  return {
    macAddress: "",
    vlanId: 0,
    portRef: "",
    staticEntry: false,
    vni: 0,
    entryDiscoveredAt: undefined,
    entryType: 0,
  };
}

export const L2FdbEntry: MessageFns<L2FdbEntry> = {
  encode(message: L2FdbEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.macAddress !== "") {
      writer.uint32(18).string(message.macAddress);
    }
    if (message.vlanId !== 0) {
      writer.uint32(24).uint32(message.vlanId);
    }
    if (message.portRef !== "") {
      writer.uint32(34).string(message.portRef);
    }
    if (message.staticEntry !== false) {
      writer.uint32(40).bool(message.staticEntry);
    }
    if (message.vni !== 0) {
      writer.uint32(48).uint32(message.vni);
    }
    if (message.entryDiscoveredAt !== undefined) {
      Timestamp.encode(toTimestamp(message.entryDiscoveredAt), writer.uint32(58).fork()).join();
    }
    if (message.entryType !== 0) {
      writer.uint32(64).int32(message.entryType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): L2FdbEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseL2FdbEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.macAddress = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.portRef = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.staticEntry = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.entryDiscoveredAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.entryType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): L2FdbEntry {
    return {
      macAddress: isSet(object.macAddress) ? globalThis.String(object.macAddress) : "",
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      portRef: isSet(object.portRef) ? globalThis.String(object.portRef) : "",
      staticEntry: isSet(object.staticEntry) ? globalThis.Boolean(object.staticEntry) : false,
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      entryDiscoveredAt: isSet(object.entryDiscoveredAt) ? fromJsonTimestamp(object.entryDiscoveredAt) : undefined,
      entryType: isSet(object.entryType) ? l2FdbEntryTypeFromJSON(object.entryType) : 0,
    };
  },

  toJSON(message: L2FdbEntry): unknown {
    const obj: any = {};
    if (message.macAddress !== "") {
      obj.macAddress = message.macAddress;
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.portRef !== "") {
      obj.portRef = message.portRef;
    }
    if (message.staticEntry !== false) {
      obj.staticEntry = message.staticEntry;
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.entryDiscoveredAt !== undefined) {
      obj.entryDiscoveredAt = message.entryDiscoveredAt.toISOString();
    }
    if (message.entryType !== 0) {
      obj.entryType = l2FdbEntryTypeToJSON(message.entryType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<L2FdbEntry>, I>>(base?: I): L2FdbEntry {
    return L2FdbEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<L2FdbEntry>, I>>(object: I): L2FdbEntry {
    const message = createBaseL2FdbEntry();
    message.macAddress = object.macAddress ?? "";
    message.vlanId = object.vlanId ?? 0;
    message.portRef = object.portRef ?? "";
    message.staticEntry = object.staticEntry ?? false;
    message.vni = object.vni ?? 0;
    message.entryDiscoveredAt = object.entryDiscoveredAt ?? undefined;
    message.entryType = object.entryType ?? 0;
    return message;
  },
};

function createBaseL2FdbBucketed(): L2FdbBucketed {
  return { id: undefined, l2entries: [] };
}

export const L2FdbBucketed: MessageFns<L2FdbBucketed> = {
  encode(message: L2FdbBucketed, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    for (const v of message.l2entries) {
      L2Entry.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): L2FdbBucketed {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseL2FdbBucketed();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.l2entries.push(L2Entry.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): L2FdbBucketed {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      l2entries: globalThis.Array.isArray(object?.l2entries)
        ? object.l2entries.map((e: any) => L2Entry.fromJSON(e))
        : [],
    };
  },

  toJSON(message: L2FdbBucketed): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.l2entries?.length) {
      obj.l2entries = message.l2entries.map((e) => L2Entry.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<L2FdbBucketed>, I>>(base?: I): L2FdbBucketed {
    return L2FdbBucketed.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<L2FdbBucketed>, I>>(object: I): L2FdbBucketed {
    const message = createBaseL2FdbBucketed();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.l2entries = object.l2entries?.map((e) => L2Entry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseL2Entry(): L2Entry {
  return {
    macAddress: 0,
    vlanId: 0,
    vni: 0,
    entryType: 0,
    entryDiscoveredAt: undefined,
    portRef: "",
    locatorType: 0,
    remoteVtep: "",
    remoteEsi: "",
    fabricLocation: 0,
    remoteFabricId: "",
  };
}

export const L2Entry: MessageFns<L2Entry> = {
  encode(message: L2Entry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.macAddress !== 0) {
      writer.uint32(16).uint32(message.macAddress);
    }
    if (message.vlanId !== 0) {
      writer.uint32(24).uint32(message.vlanId);
    }
    if (message.vni !== 0) {
      writer.uint32(32).uint32(message.vni);
    }
    if (message.entryType !== 0) {
      writer.uint32(40).int32(message.entryType);
    }
    if (message.entryDiscoveredAt !== undefined) {
      Timestamp.encode(toTimestamp(message.entryDiscoveredAt), writer.uint32(50).fork()).join();
    }
    if (message.portRef !== "") {
      writer.uint32(58).string(message.portRef);
    }
    if (message.locatorType !== 0) {
      writer.uint32(64).int32(message.locatorType);
    }
    if (message.remoteVtep !== "") {
      writer.uint32(74).string(message.remoteVtep);
    }
    if (message.remoteEsi !== "") {
      writer.uint32(82).string(message.remoteEsi);
    }
    if (message.fabricLocation !== 0) {
      writer.uint32(88).int32(message.fabricLocation);
    }
    if (message.remoteFabricId !== "") {
      writer.uint32(98).string(message.remoteFabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): L2Entry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseL2Entry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.macAddress = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.entryType = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.entryDiscoveredAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.portRef = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.locatorType = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.remoteVtep = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.remoteEsi = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.fabricLocation = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.remoteFabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): L2Entry {
    return {
      macAddress: isSet(object.macAddress) ? globalThis.Number(object.macAddress) : 0,
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      entryType: isSet(object.entryType) ? l2FdbEntryTypeFromJSON(object.entryType) : 0,
      entryDiscoveredAt: isSet(object.entryDiscoveredAt) ? fromJsonTimestamp(object.entryDiscoveredAt) : undefined,
      portRef: isSet(object.portRef) ? globalThis.String(object.portRef) : "",
      locatorType: isSet(object.locatorType) ? l2FdbEntryLocatorTypeFromJSON(object.locatorType) : 0,
      remoteVtep: isSet(object.remoteVtep) ? globalThis.String(object.remoteVtep) : "",
      remoteEsi: isSet(object.remoteEsi) ? globalThis.String(object.remoteEsi) : "",
      fabricLocation: isSet(object.fabricLocation) ? l2FdbRemoteEntryLocationFromJSON(object.fabricLocation) : 0,
      remoteFabricId: isSet(object.remoteFabricId) ? globalThis.String(object.remoteFabricId) : "",
    };
  },

  toJSON(message: L2Entry): unknown {
    const obj: any = {};
    if (message.macAddress !== 0) {
      obj.macAddress = Math.round(message.macAddress);
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.entryType !== 0) {
      obj.entryType = l2FdbEntryTypeToJSON(message.entryType);
    }
    if (message.entryDiscoveredAt !== undefined) {
      obj.entryDiscoveredAt = message.entryDiscoveredAt.toISOString();
    }
    if (message.portRef !== "") {
      obj.portRef = message.portRef;
    }
    if (message.locatorType !== 0) {
      obj.locatorType = l2FdbEntryLocatorTypeToJSON(message.locatorType);
    }
    if (message.remoteVtep !== "") {
      obj.remoteVtep = message.remoteVtep;
    }
    if (message.remoteEsi !== "") {
      obj.remoteEsi = message.remoteEsi;
    }
    if (message.fabricLocation !== 0) {
      obj.fabricLocation = l2FdbRemoteEntryLocationToJSON(message.fabricLocation);
    }
    if (message.remoteFabricId !== "") {
      obj.remoteFabricId = message.remoteFabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<L2Entry>, I>>(base?: I): L2Entry {
    return L2Entry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<L2Entry>, I>>(object: I): L2Entry {
    const message = createBaseL2Entry();
    message.macAddress = object.macAddress ?? 0;
    message.vlanId = object.vlanId ?? 0;
    message.vni = object.vni ?? 0;
    message.entryType = object.entryType ?? 0;
    message.entryDiscoveredAt = object.entryDiscoveredAt ?? undefined;
    message.portRef = object.portRef ?? "";
    message.locatorType = object.locatorType ?? 0;
    message.remoteVtep = object.remoteVtep ?? "";
    message.remoteEsi = object.remoteEsi ?? "";
    message.fabricLocation = object.fabricLocation ?? 0;
    message.remoteFabricId = object.remoteFabricId ?? "";
    return message;
  },
};

function createBaseL2FdbBucketedMultisite(): L2FdbBucketedMultisite {
  return { id: undefined, l2entries: [] };
}

export const L2FdbBucketedMultisite: MessageFns<L2FdbBucketedMultisite> = {
  encode(message: L2FdbBucketedMultisite, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    for (const v of message.l2entries) {
      L2EntryMultisite.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): L2FdbBucketedMultisite {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseL2FdbBucketedMultisite();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.l2entries.push(L2EntryMultisite.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): L2FdbBucketedMultisite {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      l2entries: globalThis.Array.isArray(object?.l2entries)
        ? object.l2entries.map((e: any) => L2EntryMultisite.fromJSON(e))
        : [],
    };
  },

  toJSON(message: L2FdbBucketedMultisite): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.l2entries?.length) {
      obj.l2entries = message.l2entries.map((e) => L2EntryMultisite.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<L2FdbBucketedMultisite>, I>>(base?: I): L2FdbBucketedMultisite {
    return L2FdbBucketedMultisite.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<L2FdbBucketedMultisite>, I>>(object: I): L2FdbBucketedMultisite {
    const message = createBaseL2FdbBucketedMultisite();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.l2entries = object.l2entries?.map((e) => L2EntryMultisite.fromPartial(e)) || [];
    return message;
  },
};

function createBaseL2EntryMultisite(): L2EntryMultisite {
  return { macAddress: 0, fabricLocation: 0, remoteFabricId: "" };
}

export const L2EntryMultisite: MessageFns<L2EntryMultisite> = {
  encode(message: L2EntryMultisite, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.macAddress !== 0) {
      writer.uint32(8).uint32(message.macAddress);
    }
    if (message.fabricLocation !== 0) {
      writer.uint32(16).int32(message.fabricLocation);
    }
    if (message.remoteFabricId !== "") {
      writer.uint32(26).string(message.remoteFabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): L2EntryMultisite {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseL2EntryMultisite();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.macAddress = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.fabricLocation = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.remoteFabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): L2EntryMultisite {
    return {
      macAddress: isSet(object.macAddress) ? globalThis.Number(object.macAddress) : 0,
      fabricLocation: isSet(object.fabricLocation) ? l2FdbRemoteEntryLocationFromJSON(object.fabricLocation) : 0,
      remoteFabricId: isSet(object.remoteFabricId) ? globalThis.String(object.remoteFabricId) : "",
    };
  },

  toJSON(message: L2EntryMultisite): unknown {
    const obj: any = {};
    if (message.macAddress !== 0) {
      obj.macAddress = Math.round(message.macAddress);
    }
    if (message.fabricLocation !== 0) {
      obj.fabricLocation = l2FdbRemoteEntryLocationToJSON(message.fabricLocation);
    }
    if (message.remoteFabricId !== "") {
      obj.remoteFabricId = message.remoteFabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<L2EntryMultisite>, I>>(base?: I): L2EntryMultisite {
    return L2EntryMultisite.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<L2EntryMultisite>, I>>(object: I): L2EntryMultisite {
    const message = createBaseL2EntryMultisite();
    message.macAddress = object.macAddress ?? 0;
    message.fabricLocation = object.fabricLocation ?? 0;
    message.remoteFabricId = object.remoteFabricId ?? "";
    return message;
  },
};

function createBaseVxlanTunnel(): VxlanTunnel {
  return { id: undefined, sourceIp: "", collectedAt: undefined };
}

export const VxlanTunnel: MessageFns<VxlanTunnel> = {
  encode(message: VxlanTunnel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.sourceIp !== "") {
      writer.uint32(26).string(message.sourceIp);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VxlanTunnel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVxlanTunnel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sourceIp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VxlanTunnel {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      sourceIp: isSet(object.sourceIp) ? globalThis.String(object.sourceIp) : "",
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: VxlanTunnel): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.sourceIp !== "") {
      obj.sourceIp = message.sourceIp;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VxlanTunnel>, I>>(base?: I): VxlanTunnel {
    return VxlanTunnel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VxlanTunnel>, I>>(object: I): VxlanTunnel {
    const message = createBaseVxlanTunnel();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.sourceIp = object.sourceIp ?? "";
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseVxlanTunnelMapping(): VxlanTunnelMapping {
  return { id: undefined, vni: 0, vlanId: 0, collectedAt: undefined };
}

export const VxlanTunnelMapping: MessageFns<VxlanTunnelMapping> = {
  encode(message: VxlanTunnelMapping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.vni !== 0) {
      writer.uint32(24).uint32(message.vni);
    }
    if (message.vlanId !== 0) {
      writer.uint32(32).uint32(message.vlanId);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VxlanTunnelMapping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVxlanTunnelMapping();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VxlanTunnelMapping {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: VxlanTunnelMapping): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VxlanTunnelMapping>, I>>(base?: I): VxlanTunnelMapping {
    return VxlanTunnelMapping.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VxlanTunnelMapping>, I>>(object: I): VxlanTunnelMapping {
    const message = createBaseVxlanTunnelMapping();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vni = object.vni ?? 0;
    message.vlanId = object.vlanId ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseVxlanRemoteVtepMapping(): VxlanRemoteVtepMapping {
  return { id: undefined, vlanId: 0, vni: 0, sourceVtep: "", collectedAt: undefined };
}

export const VxlanRemoteVtepMapping: MessageFns<VxlanRemoteVtepMapping> = {
  encode(message: VxlanRemoteVtepMapping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.vlanId !== 0) {
      writer.uint32(24).uint32(message.vlanId);
    }
    if (message.vni !== 0) {
      writer.uint32(32).uint32(message.vni);
    }
    if (message.sourceVtep !== "") {
      writer.uint32(42).string(message.sourceVtep);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VxlanRemoteVtepMapping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVxlanRemoteVtepMapping();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sourceVtep = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VxlanRemoteVtepMapping {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      sourceVtep: isSet(object.sourceVtep) ? globalThis.String(object.sourceVtep) : "",
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: VxlanRemoteVtepMapping): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.sourceVtep !== "") {
      obj.sourceVtep = message.sourceVtep;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VxlanRemoteVtepMapping>, I>>(base?: I): VxlanRemoteVtepMapping {
    return VxlanRemoteVtepMapping.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VxlanRemoteVtepMapping>, I>>(object: I): VxlanRemoteVtepMapping {
    const message = createBaseVxlanRemoteVtepMapping();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vlanId = object.vlanId ?? 0;
    message.vni = object.vni ?? 0;
    message.sourceVtep = object.sourceVtep ?? "";
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseSpyglassSshSessionEntry(): SpyglassSshSessionEntry {
  return { id: undefined, tcpPort: 0, deviceId: "" };
}

export const SpyglassSshSessionEntry: MessageFns<SpyglassSshSessionEntry> = {
  encode(message: SpyglassSshSessionEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.tcpPort !== 0) {
      writer.uint32(24).uint32(message.tcpPort);
    }
    if (message.deviceId !== "") {
      writer.uint32(34).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpyglassSshSessionEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpyglassSshSessionEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.tcpPort = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpyglassSshSessionEntry {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      tcpPort: isSet(object.tcpPort) ? globalThis.Number(object.tcpPort) : 0,
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
    };
  },

  toJSON(message: SpyglassSshSessionEntry): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.tcpPort !== 0) {
      obj.tcpPort = Math.round(message.tcpPort);
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpyglassSshSessionEntry>, I>>(base?: I): SpyglassSshSessionEntry {
    return SpyglassSshSessionEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpyglassSshSessionEntry>, I>>(object: I): SpyglassSshSessionEntry {
    const message = createBaseSpyglassSshSessionEntry();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.tcpPort = object.tcpPort ?? 0;
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseSpyglassBrokerEntry(): SpyglassBrokerEntry {
  return {
    id: undefined,
    deviceId: "",
    connectedInternal: false,
    connectedExternal: false,
    pktsIntToExt: "0",
    pktsExtToInt: "0",
    internalConnectionCreated: undefined,
    externalConnectionCreated: undefined,
  };
}

export const SpyglassBrokerEntry: MessageFns<SpyglassBrokerEntry> = {
  encode(message: SpyglassBrokerEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    if (message.connectedInternal !== false) {
      writer.uint32(32).bool(message.connectedInternal);
    }
    if (message.connectedExternal !== false) {
      writer.uint32(40).bool(message.connectedExternal);
    }
    if (message.pktsIntToExt !== "0") {
      writer.uint32(48).uint64(message.pktsIntToExt);
    }
    if (message.pktsExtToInt !== "0") {
      writer.uint32(56).uint64(message.pktsExtToInt);
    }
    if (message.internalConnectionCreated !== undefined) {
      Timestamp.encode(toTimestamp(message.internalConnectionCreated), writer.uint32(66).fork()).join();
    }
    if (message.externalConnectionCreated !== undefined) {
      Timestamp.encode(toTimestamp(message.externalConnectionCreated), writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpyglassBrokerEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpyglassBrokerEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.connectedInternal = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.connectedExternal = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.pktsIntToExt = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.pktsExtToInt = reader.uint64().toString();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.internalConnectionCreated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.externalConnectionCreated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpyglassBrokerEntry {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      connectedInternal: isSet(object.connectedInternal) ? globalThis.Boolean(object.connectedInternal) : false,
      connectedExternal: isSet(object.connectedExternal) ? globalThis.Boolean(object.connectedExternal) : false,
      pktsIntToExt: isSet(object.pktsIntToExt) ? globalThis.String(object.pktsIntToExt) : "0",
      pktsExtToInt: isSet(object.pktsExtToInt) ? globalThis.String(object.pktsExtToInt) : "0",
      internalConnectionCreated: isSet(object.internalConnectionCreated)
        ? fromJsonTimestamp(object.internalConnectionCreated)
        : undefined,
      externalConnectionCreated: isSet(object.externalConnectionCreated)
        ? fromJsonTimestamp(object.externalConnectionCreated)
        : undefined,
    };
  },

  toJSON(message: SpyglassBrokerEntry): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.connectedInternal !== false) {
      obj.connectedInternal = message.connectedInternal;
    }
    if (message.connectedExternal !== false) {
      obj.connectedExternal = message.connectedExternal;
    }
    if (message.pktsIntToExt !== "0") {
      obj.pktsIntToExt = message.pktsIntToExt;
    }
    if (message.pktsExtToInt !== "0") {
      obj.pktsExtToInt = message.pktsExtToInt;
    }
    if (message.internalConnectionCreated !== undefined) {
      obj.internalConnectionCreated = message.internalConnectionCreated.toISOString();
    }
    if (message.externalConnectionCreated !== undefined) {
      obj.externalConnectionCreated = message.externalConnectionCreated.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpyglassBrokerEntry>, I>>(base?: I): SpyglassBrokerEntry {
    return SpyglassBrokerEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpyglassBrokerEntry>, I>>(object: I): SpyglassBrokerEntry {
    const message = createBaseSpyglassBrokerEntry();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.deviceId = object.deviceId ?? "";
    message.connectedInternal = object.connectedInternal ?? false;
    message.connectedExternal = object.connectedExternal ?? false;
    message.pktsIntToExt = object.pktsIntToExt ?? "0";
    message.pktsExtToInt = object.pktsExtToInt ?? "0";
    message.internalConnectionCreated = object.internalConnectionCreated ?? undefined;
    message.externalConnectionCreated = object.externalConnectionCreated ?? undefined;
    return message;
  },
};

function createBaseAuthorizedUserEntry(): AuthorizedUserEntry {
  return { id: undefined, user: "", orgId: "" };
}

export const AuthorizedUserEntry: MessageFns<AuthorizedUserEntry> = {
  encode(message: AuthorizedUserEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.user !== "") {
      writer.uint32(26).string(message.user);
    }
    if (message.orgId !== "") {
      writer.uint32(34).string(message.orgId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AuthorizedUserEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAuthorizedUserEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.user = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AuthorizedUserEntry {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      user: isSet(object.user) ? globalThis.String(object.user) : "",
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
    };
  },

  toJSON(message: AuthorizedUserEntry): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.user !== "") {
      obj.user = message.user;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AuthorizedUserEntry>, I>>(base?: I): AuthorizedUserEntry {
    return AuthorizedUserEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AuthorizedUserEntry>, I>>(object: I): AuthorizedUserEntry {
    const message = createBaseAuthorizedUserEntry();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.user = object.user ?? "";
    message.orgId = object.orgId ?? "";
    return message;
  },
};

function createBaseDelegatedReadOnlyUserEntry(): DelegatedReadOnlyUserEntry {
  return { id: undefined, user: "", orgId: "" };
}

export const DelegatedReadOnlyUserEntry: MessageFns<DelegatedReadOnlyUserEntry> = {
  encode(message: DelegatedReadOnlyUserEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.user !== "") {
      writer.uint32(26).string(message.user);
    }
    if (message.orgId !== "") {
      writer.uint32(34).string(message.orgId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelegatedReadOnlyUserEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDelegatedReadOnlyUserEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.user = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DelegatedReadOnlyUserEntry {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      user: isSet(object.user) ? globalThis.String(object.user) : "",
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
    };
  },

  toJSON(message: DelegatedReadOnlyUserEntry): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.user !== "") {
      obj.user = message.user;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelegatedReadOnlyUserEntry>, I>>(base?: I): DelegatedReadOnlyUserEntry {
    return DelegatedReadOnlyUserEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelegatedReadOnlyUserEntry>, I>>(object: I): DelegatedReadOnlyUserEntry {
    const message = createBaseDelegatedReadOnlyUserEntry();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.user = object.user ?? "";
    message.orgId = object.orgId ?? "";
    return message;
  },
};

function createBaseTestPlaceHolder1Secret(): TestPlaceHolder1Secret {
  return { id: undefined };
}

export const TestPlaceHolder1Secret: MessageFns<TestPlaceHolder1Secret> = {
  encode(message: TestPlaceHolder1Secret, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestPlaceHolder1Secret {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestPlaceHolder1Secret();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestPlaceHolder1Secret {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: TestPlaceHolder1Secret): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestPlaceHolder1Secret>, I>>(base?: I): TestPlaceHolder1Secret {
    return TestPlaceHolder1Secret.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestPlaceHolder1Secret>, I>>(object: I): TestPlaceHolder1Secret {
    const message = createBaseTestPlaceHolder1Secret();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseSpyglassDevice(): SpyglassDevice {
  return { id: undefined, connectedAt: undefined, listenerCount: 0 };
}

export const SpyglassDevice: MessageFns<SpyglassDevice> = {
  encode(message: SpyglassDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.connectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.connectedAt), writer.uint32(26).fork()).join();
    }
    if (message.listenerCount !== 0) {
      writer.uint32(32).uint32(message.listenerCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpyglassDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpyglassDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.connectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.listenerCount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpyglassDevice {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      connectedAt: isSet(object.connectedAt) ? fromJsonTimestamp(object.connectedAt) : undefined,
      listenerCount: isSet(object.listenerCount) ? globalThis.Number(object.listenerCount) : 0,
    };
  },

  toJSON(message: SpyglassDevice): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.connectedAt !== undefined) {
      obj.connectedAt = message.connectedAt.toISOString();
    }
    if (message.listenerCount !== 0) {
      obj.listenerCount = Math.round(message.listenerCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpyglassDevice>, I>>(base?: I): SpyglassDevice {
    return SpyglassDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpyglassDevice>, I>>(object: I): SpyglassDevice {
    const message = createBaseSpyglassDevice();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.connectedAt = object.connectedAt ?? undefined;
    message.listenerCount = object.listenerCount ?? 0;
    return message;
  },
};

function createBaseSpyglassTcpListener(): SpyglassTcpListener {
  return {
    id: undefined,
    createdAt: undefined,
    currentSessionCount: 0,
    totalSessionCount: 0,
    maxConcurrentSessions: 0,
    failedConnectionCount: 0,
  };
}

export const SpyglassTcpListener: MessageFns<SpyglassTcpListener> = {
  encode(message: SpyglassTcpListener, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.currentSessionCount !== 0) {
      writer.uint32(32).uint32(message.currentSessionCount);
    }
    if (message.totalSessionCount !== 0) {
      writer.uint32(40).uint32(message.totalSessionCount);
    }
    if (message.maxConcurrentSessions !== 0) {
      writer.uint32(48).uint32(message.maxConcurrentSessions);
    }
    if (message.failedConnectionCount !== 0) {
      writer.uint32(56).uint32(message.failedConnectionCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpyglassTcpListener {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpyglassTcpListener();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.currentSessionCount = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.totalSessionCount = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.maxConcurrentSessions = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.failedConnectionCount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpyglassTcpListener {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      currentSessionCount: isSet(object.currentSessionCount) ? globalThis.Number(object.currentSessionCount) : 0,
      totalSessionCount: isSet(object.totalSessionCount) ? globalThis.Number(object.totalSessionCount) : 0,
      maxConcurrentSessions: isSet(object.maxConcurrentSessions) ? globalThis.Number(object.maxConcurrentSessions) : 0,
      failedConnectionCount: isSet(object.failedConnectionCount) ? globalThis.Number(object.failedConnectionCount) : 0,
    };
  },

  toJSON(message: SpyglassTcpListener): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.currentSessionCount !== 0) {
      obj.currentSessionCount = Math.round(message.currentSessionCount);
    }
    if (message.totalSessionCount !== 0) {
      obj.totalSessionCount = Math.round(message.totalSessionCount);
    }
    if (message.maxConcurrentSessions !== 0) {
      obj.maxConcurrentSessions = Math.round(message.maxConcurrentSessions);
    }
    if (message.failedConnectionCount !== 0) {
      obj.failedConnectionCount = Math.round(message.failedConnectionCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpyglassTcpListener>, I>>(base?: I): SpyglassTcpListener {
    return SpyglassTcpListener.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpyglassTcpListener>, I>>(object: I): SpyglassTcpListener {
    const message = createBaseSpyglassTcpListener();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.currentSessionCount = object.currentSessionCount ?? 0;
    message.totalSessionCount = object.totalSessionCount ?? 0;
    message.maxConcurrentSessions = object.maxConcurrentSessions ?? 0;
    message.failedConnectionCount = object.failedConnectionCount ?? 0;
    return message;
  },
};

function createBaseSpyglassTcpSession(): SpyglassTcpSession {
  return { id: undefined, created: undefined };
}

export const SpyglassTcpSession: MessageFns<SpyglassTcpSession> = {
  encode(message: SpyglassTcpSession, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.created !== undefined) {
      Timestamp.encode(toTimestamp(message.created), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpyglassTcpSession {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpyglassTcpSession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.created = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpyglassTcpSession {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      created: isSet(object.created) ? fromJsonTimestamp(object.created) : undefined,
    };
  },

  toJSON(message: SpyglassTcpSession): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.created !== undefined) {
      obj.created = message.created.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpyglassTcpSession>, I>>(base?: I): SpyglassTcpSession {
    return SpyglassTcpSession.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpyglassTcpSession>, I>>(object: I): SpyglassTcpSession {
    const message = createBaseSpyglassTcpSession();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.created = object.created ?? undefined;
    return message;
  },
};

function createBaseSpyglassGingerEntry(): SpyglassGingerEntry {
  return { id: undefined, deviceId: "", tcpPort: 0, status: 0, connectionCreated: undefined };
}

export const SpyglassGingerEntry: MessageFns<SpyglassGingerEntry> = {
  encode(message: SpyglassGingerEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    if (message.tcpPort !== 0) {
      writer.uint32(32).uint32(message.tcpPort);
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status);
    }
    if (message.connectionCreated !== undefined) {
      Timestamp.encode(toTimestamp(message.connectionCreated), writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpyglassGingerEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpyglassGingerEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.tcpPort = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.connectionCreated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpyglassGingerEntry {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      tcpPort: isSet(object.tcpPort) ? globalThis.Number(object.tcpPort) : 0,
      status: isSet(object.status) ? spyglassSessionStatusFromJSON(object.status) : 0,
      connectionCreated: isSet(object.connectionCreated) ? fromJsonTimestamp(object.connectionCreated) : undefined,
    };
  },

  toJSON(message: SpyglassGingerEntry): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.tcpPort !== 0) {
      obj.tcpPort = Math.round(message.tcpPort);
    }
    if (message.status !== 0) {
      obj.status = spyglassSessionStatusToJSON(message.status);
    }
    if (message.connectionCreated !== undefined) {
      obj.connectionCreated = message.connectionCreated.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpyglassGingerEntry>, I>>(base?: I): SpyglassGingerEntry {
    return SpyglassGingerEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpyglassGingerEntry>, I>>(object: I): SpyglassGingerEntry {
    const message = createBaseSpyglassGingerEntry();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.deviceId = object.deviceId ?? "";
    message.tcpPort = object.tcpPort ?? 0;
    message.status = object.status ?? 0;
    message.connectionCreated = object.connectionCreated ?? undefined;
    return message;
  },
};

function createBaseRemedyActionFixConnection(): RemedyActionFixConnection {
  return { moveFrom: "", moveTo: "", connectFrom: "", connectTo: "" };
}

export const RemedyActionFixConnection: MessageFns<RemedyActionFixConnection> = {
  encode(message: RemedyActionFixConnection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.moveFrom !== "") {
      writer.uint32(18).string(message.moveFrom);
    }
    if (message.moveTo !== "") {
      writer.uint32(26).string(message.moveTo);
    }
    if (message.connectFrom !== "") {
      writer.uint32(34).string(message.connectFrom);
    }
    if (message.connectTo !== "") {
      writer.uint32(42).string(message.connectTo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemedyActionFixConnection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemedyActionFixConnection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.moveFrom = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.moveTo = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.connectFrom = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.connectTo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemedyActionFixConnection {
    return {
      moveFrom: isSet(object.moveFrom) ? globalThis.String(object.moveFrom) : "",
      moveTo: isSet(object.moveTo) ? globalThis.String(object.moveTo) : "",
      connectFrom: isSet(object.connectFrom) ? globalThis.String(object.connectFrom) : "",
      connectTo: isSet(object.connectTo) ? globalThis.String(object.connectTo) : "",
    };
  },

  toJSON(message: RemedyActionFixConnection): unknown {
    const obj: any = {};
    if (message.moveFrom !== "") {
      obj.moveFrom = message.moveFrom;
    }
    if (message.moveTo !== "") {
      obj.moveTo = message.moveTo;
    }
    if (message.connectFrom !== "") {
      obj.connectFrom = message.connectFrom;
    }
    if (message.connectTo !== "") {
      obj.connectTo = message.connectTo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemedyActionFixConnection>, I>>(base?: I): RemedyActionFixConnection {
    return RemedyActionFixConnection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemedyActionFixConnection>, I>>(object: I): RemedyActionFixConnection {
    const message = createBaseRemedyActionFixConnection();
    message.moveFrom = object.moveFrom ?? "";
    message.moveTo = object.moveTo ?? "";
    message.connectFrom = object.connectFrom ?? "";
    message.connectTo = object.connectTo ?? "";
    return message;
  },
};

function createBaseRemedyActionAddMissingConnection(): RemedyActionAddMissingConnection {
  return { connectFrom: "", connectTo: "" };
}

export const RemedyActionAddMissingConnection: MessageFns<RemedyActionAddMissingConnection> = {
  encode(message: RemedyActionAddMissingConnection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.connectFrom !== "") {
      writer.uint32(18).string(message.connectFrom);
    }
    if (message.connectTo !== "") {
      writer.uint32(26).string(message.connectTo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemedyActionAddMissingConnection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemedyActionAddMissingConnection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.connectFrom = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.connectTo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemedyActionAddMissingConnection {
    return {
      connectFrom: isSet(object.connectFrom) ? globalThis.String(object.connectFrom) : "",
      connectTo: isSet(object.connectTo) ? globalThis.String(object.connectTo) : "",
    };
  },

  toJSON(message: RemedyActionAddMissingConnection): unknown {
    const obj: any = {};
    if (message.connectFrom !== "") {
      obj.connectFrom = message.connectFrom;
    }
    if (message.connectTo !== "") {
      obj.connectTo = message.connectTo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemedyActionAddMissingConnection>, I>>(
    base?: I,
  ): RemedyActionAddMissingConnection {
    return RemedyActionAddMissingConnection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemedyActionAddMissingConnection>, I>>(
    object: I,
  ): RemedyActionAddMissingConnection {
    const message = createBaseRemedyActionAddMissingConnection();
    message.connectFrom = object.connectFrom ?? "";
    message.connectTo = object.connectTo ?? "";
    return message;
  },
};

function createBaseRemedyActionRemoveUnexpectedConnection(): RemedyActionRemoveUnexpectedConnection {
  return { disconnectFrom: "", disconnectTo: "" };
}

export const RemedyActionRemoveUnexpectedConnection: MessageFns<RemedyActionRemoveUnexpectedConnection> = {
  encode(message: RemedyActionRemoveUnexpectedConnection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.disconnectFrom !== "") {
      writer.uint32(18).string(message.disconnectFrom);
    }
    if (message.disconnectTo !== "") {
      writer.uint32(26).string(message.disconnectTo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemedyActionRemoveUnexpectedConnection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemedyActionRemoveUnexpectedConnection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.disconnectFrom = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.disconnectTo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemedyActionRemoveUnexpectedConnection {
    return {
      disconnectFrom: isSet(object.disconnectFrom) ? globalThis.String(object.disconnectFrom) : "",
      disconnectTo: isSet(object.disconnectTo) ? globalThis.String(object.disconnectTo) : "",
    };
  },

  toJSON(message: RemedyActionRemoveUnexpectedConnection): unknown {
    const obj: any = {};
    if (message.disconnectFrom !== "") {
      obj.disconnectFrom = message.disconnectFrom;
    }
    if (message.disconnectTo !== "") {
      obj.disconnectTo = message.disconnectTo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemedyActionRemoveUnexpectedConnection>, I>>(
    base?: I,
  ): RemedyActionRemoveUnexpectedConnection {
    return RemedyActionRemoveUnexpectedConnection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemedyActionRemoveUnexpectedConnection>, I>>(
    object: I,
  ): RemedyActionRemoveUnexpectedConnection {
    const message = createBaseRemedyActionRemoveUnexpectedConnection();
    message.disconnectFrom = object.disconnectFrom ?? "";
    message.disconnectTo = object.disconnectTo ?? "";
    return message;
  },
};

function createBaseRemedyAction(): RemedyAction {
  return {
    id: undefined,
    relatedAsserts: [],
    actionType: 0,
    fixConnection: undefined,
    addConnection: undefined,
    removeConnection: undefined,
  };
}

export const RemedyAction: MessageFns<RemedyAction> = {
  encode(message: RemedyAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    for (const v of message.relatedAsserts) {
      PathId.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.actionType !== 0) {
      writer.uint32(32).int32(message.actionType);
    }
    if (message.fixConnection !== undefined) {
      RemedyActionFixConnection.encode(message.fixConnection, writer.uint32(42).fork()).join();
    }
    if (message.addConnection !== undefined) {
      RemedyActionAddMissingConnection.encode(message.addConnection, writer.uint32(50).fork()).join();
    }
    if (message.removeConnection !== undefined) {
      RemedyActionRemoveUnexpectedConnection.encode(message.removeConnection, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemedyAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemedyAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.relatedAsserts.push(PathId.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.actionType = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fixConnection = RemedyActionFixConnection.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.addConnection = RemedyActionAddMissingConnection.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.removeConnection = RemedyActionRemoveUnexpectedConnection.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemedyAction {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      relatedAsserts: globalThis.Array.isArray(object?.relatedAsserts)
        ? object.relatedAsserts.map((e: any) => PathId.fromJSON(e))
        : [],
      actionType: isSet(object.actionType) ? remedyActionCodeFromJSON(object.actionType) : 0,
      fixConnection: isSet(object.fixConnection) ? RemedyActionFixConnection.fromJSON(object.fixConnection) : undefined,
      addConnection: isSet(object.addConnection)
        ? RemedyActionAddMissingConnection.fromJSON(object.addConnection)
        : undefined,
      removeConnection: isSet(object.removeConnection)
        ? RemedyActionRemoveUnexpectedConnection.fromJSON(object.removeConnection)
        : undefined,
    };
  },

  toJSON(message: RemedyAction): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.relatedAsserts?.length) {
      obj.relatedAsserts = message.relatedAsserts.map((e) => PathId.toJSON(e));
    }
    if (message.actionType !== 0) {
      obj.actionType = remedyActionCodeToJSON(message.actionType);
    }
    if (message.fixConnection !== undefined) {
      obj.fixConnection = RemedyActionFixConnection.toJSON(message.fixConnection);
    }
    if (message.addConnection !== undefined) {
      obj.addConnection = RemedyActionAddMissingConnection.toJSON(message.addConnection);
    }
    if (message.removeConnection !== undefined) {
      obj.removeConnection = RemedyActionRemoveUnexpectedConnection.toJSON(message.removeConnection);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemedyAction>, I>>(base?: I): RemedyAction {
    return RemedyAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemedyAction>, I>>(object: I): RemedyAction {
    const message = createBaseRemedyAction();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.relatedAsserts = object.relatedAsserts?.map((e) => PathId.fromPartial(e)) || [];
    message.actionType = object.actionType ?? 0;
    message.fixConnection = (object.fixConnection !== undefined && object.fixConnection !== null)
      ? RemedyActionFixConnection.fromPartial(object.fixConnection)
      : undefined;
    message.addConnection = (object.addConnection !== undefined && object.addConnection !== null)
      ? RemedyActionAddMissingConnection.fromPartial(object.addConnection)
      : undefined;
    message.removeConnection = (object.removeConnection !== undefined && object.removeConnection !== null)
      ? RemedyActionRemoveUnexpectedConnection.fromPartial(object.removeConnection)
      : undefined;
    return message;
  },
};

function createBaseRemoteSysCapability(): RemoteSysCapability {
  return { sysCapability: 0, enabled: false };
}

export const RemoteSysCapability: MessageFns<RemoteSysCapability> = {
  encode(message: RemoteSysCapability, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sysCapability !== 0) {
      writer.uint32(8).int32(message.sysCapability);
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteSysCapability {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteSysCapability();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sysCapability = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoteSysCapability {
    return {
      sysCapability: isSet(object.sysCapability) ? lLDPSysCapabilityTypeFromJSON(object.sysCapability) : 0,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
    };
  },

  toJSON(message: RemoteSysCapability): unknown {
    const obj: any = {};
    if (message.sysCapability !== 0) {
      obj.sysCapability = lLDPSysCapabilityTypeToJSON(message.sysCapability);
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoteSysCapability>, I>>(base?: I): RemoteSysCapability {
    return RemoteSysCapability.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteSysCapability>, I>>(object: I): RemoteSysCapability {
    const message = createBaseRemoteSysCapability();
    message.sysCapability = object.sysCapability ?? 0;
    message.enabled = object.enabled ?? false;
    return message;
  },
};

function createBaseAdvertisedAutoNegotiation(): AdvertisedAutoNegotiation {
  return { type: "", hd: false, fd: false };
}

export const AdvertisedAutoNegotiation: MessageFns<AdvertisedAutoNegotiation> = {
  encode(message: AdvertisedAutoNegotiation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.hd !== false) {
      writer.uint32(16).bool(message.hd);
    }
    if (message.fd !== false) {
      writer.uint32(24).bool(message.fd);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdvertisedAutoNegotiation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdvertisedAutoNegotiation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.hd = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fd = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdvertisedAutoNegotiation {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      hd: isSet(object.hd) ? globalThis.Boolean(object.hd) : false,
      fd: isSet(object.fd) ? globalThis.Boolean(object.fd) : false,
    };
  },

  toJSON(message: AdvertisedAutoNegotiation): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.hd !== false) {
      obj.hd = message.hd;
    }
    if (message.fd !== false) {
      obj.fd = message.fd;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdvertisedAutoNegotiation>, I>>(base?: I): AdvertisedAutoNegotiation {
    return AdvertisedAutoNegotiation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdvertisedAutoNegotiation>, I>>(object: I): AdvertisedAutoNegotiation {
    const message = createBaseAdvertisedAutoNegotiation();
    message.type = object.type ?? "";
    message.hd = object.hd ?? false;
    message.fd = object.fd ?? false;
    return message;
  },
};

function createBaseRemotePortAutoNegotiation(): RemotePortAutoNegotiation {
  return { supported: false, enabled: false, current: "", advertised: [] };
}

export const RemotePortAutoNegotiation: MessageFns<RemotePortAutoNegotiation> = {
  encode(message: RemotePortAutoNegotiation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.supported !== false) {
      writer.uint32(8).bool(message.supported);
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    if (message.current !== "") {
      writer.uint32(26).string(message.current);
    }
    for (const v of message.advertised) {
      AdvertisedAutoNegotiation.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemotePortAutoNegotiation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemotePortAutoNegotiation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.supported = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.current = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.advertised.push(AdvertisedAutoNegotiation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemotePortAutoNegotiation {
    return {
      supported: isSet(object.supported) ? globalThis.Boolean(object.supported) : false,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      current: isSet(object.current) ? globalThis.String(object.current) : "",
      advertised: globalThis.Array.isArray(object?.advertised)
        ? object.advertised.map((e: any) => AdvertisedAutoNegotiation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RemotePortAutoNegotiation): unknown {
    const obj: any = {};
    if (message.supported !== false) {
      obj.supported = message.supported;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.current !== "") {
      obj.current = message.current;
    }
    if (message.advertised?.length) {
      obj.advertised = message.advertised.map((e) => AdvertisedAutoNegotiation.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemotePortAutoNegotiation>, I>>(base?: I): RemotePortAutoNegotiation {
    return RemotePortAutoNegotiation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemotePortAutoNegotiation>, I>>(object: I): RemotePortAutoNegotiation {
    const message = createBaseRemotePortAutoNegotiation();
    message.supported = object.supported ?? false;
    message.enabled = object.enabled ?? false;
    message.current = object.current ?? "";
    message.advertised = object.advertised?.map((e) => AdvertisedAutoNegotiation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBmcDiscovery(): BmcDiscovery {
  return { bmcId: 0 };
}

export const BmcDiscovery: MessageFns<BmcDiscovery> = {
  encode(message: BmcDiscovery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bmcId !== 0) {
      writer.uint32(8).uint32(message.bmcId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BmcDiscovery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBmcDiscovery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.bmcId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BmcDiscovery {
    return { bmcId: isSet(object.bmcId) ? globalThis.Number(object.bmcId) : 0 };
  },

  toJSON(message: BmcDiscovery): unknown {
    const obj: any = {};
    if (message.bmcId !== 0) {
      obj.bmcId = Math.round(message.bmcId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BmcDiscovery>, I>>(base?: I): BmcDiscovery {
    return BmcDiscovery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BmcDiscovery>, I>>(object: I): BmcDiscovery {
    const message = createBaseBmcDiscovery();
    message.bmcId = object.bmcId ?? 0;
    return message;
  },
};

function createBaseExtendedDiscovery(): ExtendedDiscovery {
  return { bmcDiscovery: [] };
}

export const ExtendedDiscovery: MessageFns<ExtendedDiscovery> = {
  encode(message: ExtendedDiscovery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.bmcDiscovery) {
      BmcDiscovery.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExtendedDiscovery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExtendedDiscovery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.bmcDiscovery.push(BmcDiscovery.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExtendedDiscovery {
    return {
      bmcDiscovery: globalThis.Array.isArray(object?.bmcDiscovery)
        ? object.bmcDiscovery.map((e: any) => BmcDiscovery.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ExtendedDiscovery): unknown {
    const obj: any = {};
    if (message.bmcDiscovery?.length) {
      obj.bmcDiscovery = message.bmcDiscovery.map((e) => BmcDiscovery.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExtendedDiscovery>, I>>(base?: I): ExtendedDiscovery {
    return ExtendedDiscovery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExtendedDiscovery>, I>>(object: I): ExtendedDiscovery {
    const message = createBaseExtendedDiscovery();
    message.bmcDiscovery = object.bmcDiscovery?.map((e) => BmcDiscovery.fromPartial(e)) || [];
    return message;
  },
};

function createBasePortNeighbor(): PortNeighbor {
  return {
    id: undefined,
    remotePortDesc: "",
    remotePortId: "",
    remoteSysDescription: "",
    remoteSysName: "",
    remoteManagementAddrIpv4: "",
    remoteManagementAddrIpv6: "",
    remoteDeviceId: "",
    remoteIndex: 0,
    remotePortIdSubtype: 0,
    remoteDeviceIdSubtype: 0,
    remoteTimeMark: "0",
    deprecatedRemoteSysCap: [],
    collectedAt: undefined,
    localPort: "",
    neighborType: 0,
    remotePortTtl: 0,
    remotePortAutoNegotiation: undefined,
    RemoteSysCapabilityRepeater: false,
    RemoteSysCapabilityBridge: false,
    RemoteSysCapabilityWlan: false,
    RemoteSysCapabilityRouter: false,
    RemoteSysCapabilityTelephone: false,
    RemoteSysCapabilityDocsisCableDevice: false,
    RemoteSysCapabilityStation: false,
    portAlias: "",
    meType: 0,
    serverInfo: undefined,
    extendedDiscovery: undefined,
  };
}

export const PortNeighbor: MessageFns<PortNeighbor> = {
  encode(message: PortNeighbor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.remotePortDesc !== "") {
      writer.uint32(18).string(message.remotePortDesc);
    }
    if (message.remotePortId !== "") {
      writer.uint32(26).string(message.remotePortId);
    }
    if (message.remoteSysDescription !== "") {
      writer.uint32(34).string(message.remoteSysDescription);
    }
    if (message.remoteSysName !== "") {
      writer.uint32(42).string(message.remoteSysName);
    }
    if (message.remoteManagementAddrIpv4 !== "") {
      writer.uint32(50).string(message.remoteManagementAddrIpv4);
    }
    if (message.remoteManagementAddrIpv6 !== "") {
      writer.uint32(58).string(message.remoteManagementAddrIpv6);
    }
    if (message.remoteDeviceId !== "") {
      writer.uint32(74).string(message.remoteDeviceId);
    }
    if (message.remoteIndex !== 0) {
      writer.uint32(80).uint32(message.remoteIndex);
    }
    if (message.remotePortIdSubtype !== 0) {
      writer.uint32(88).int32(message.remotePortIdSubtype);
    }
    if (message.remoteDeviceIdSubtype !== 0) {
      writer.uint32(96).int32(message.remoteDeviceIdSubtype);
    }
    if (message.remoteTimeMark !== "0") {
      writer.uint32(104).uint64(message.remoteTimeMark);
    }
    for (const v of message.deprecatedRemoteSysCap) {
      RemoteSysCapability.encode(v!, writer.uint32(114).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(122).fork()).join();
    }
    if (message.localPort !== "") {
      writer.uint32(130).string(message.localPort);
    }
    if (message.neighborType !== 0) {
      writer.uint32(136).int32(message.neighborType);
    }
    if (message.remotePortTtl !== 0) {
      writer.uint32(144).int32(message.remotePortTtl);
    }
    if (message.remotePortAutoNegotiation !== undefined) {
      RemotePortAutoNegotiation.encode(message.remotePortAutoNegotiation, writer.uint32(154).fork()).join();
    }
    if (message.RemoteSysCapabilityRepeater !== false) {
      writer.uint32(160).bool(message.RemoteSysCapabilityRepeater);
    }
    if (message.RemoteSysCapabilityBridge !== false) {
      writer.uint32(168).bool(message.RemoteSysCapabilityBridge);
    }
    if (message.RemoteSysCapabilityWlan !== false) {
      writer.uint32(176).bool(message.RemoteSysCapabilityWlan);
    }
    if (message.RemoteSysCapabilityRouter !== false) {
      writer.uint32(184).bool(message.RemoteSysCapabilityRouter);
    }
    if (message.RemoteSysCapabilityTelephone !== false) {
      writer.uint32(192).bool(message.RemoteSysCapabilityTelephone);
    }
    if (message.RemoteSysCapabilityDocsisCableDevice !== false) {
      writer.uint32(200).bool(message.RemoteSysCapabilityDocsisCableDevice);
    }
    if (message.RemoteSysCapabilityStation !== false) {
      writer.uint32(208).bool(message.RemoteSysCapabilityStation);
    }
    if (message.portAlias !== "") {
      writer.uint32(218).string(message.portAlias);
    }
    if (message.meType !== 0) {
      writer.uint32(224).int32(message.meType);
    }
    if (message.serverInfo !== undefined) {
      ManagedEndpointServerInfo.encode(message.serverInfo, writer.uint32(234).fork()).join();
    }
    if (message.extendedDiscovery !== undefined) {
      ExtendedDiscovery.encode(message.extendedDiscovery, writer.uint32(242).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortNeighbor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortNeighbor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.remotePortDesc = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.remotePortId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.remoteSysDescription = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.remoteSysName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.remoteManagementAddrIpv4 = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.remoteManagementAddrIpv6 = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.remoteDeviceId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.remoteIndex = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.remotePortIdSubtype = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.remoteDeviceIdSubtype = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.remoteTimeMark = reader.uint64().toString();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.deprecatedRemoteSysCap.push(RemoteSysCapability.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.localPort = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.neighborType = reader.int32() as any;
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.remotePortTtl = reader.int32();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.remotePortAutoNegotiation = RemotePortAutoNegotiation.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.RemoteSysCapabilityRepeater = reader.bool();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.RemoteSysCapabilityBridge = reader.bool();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.RemoteSysCapabilityWlan = reader.bool();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.RemoteSysCapabilityRouter = reader.bool();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.RemoteSysCapabilityTelephone = reader.bool();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.RemoteSysCapabilityDocsisCableDevice = reader.bool();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.RemoteSysCapabilityStation = reader.bool();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.portAlias = reader.string();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.meType = reader.int32() as any;
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.serverInfo = ManagedEndpointServerInfo.decode(reader, reader.uint32());
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.extendedDiscovery = ExtendedDiscovery.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortNeighbor {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      remotePortDesc: isSet(object.remotePortDesc) ? globalThis.String(object.remotePortDesc) : "",
      remotePortId: isSet(object.remotePortId) ? globalThis.String(object.remotePortId) : "",
      remoteSysDescription: isSet(object.remoteSysDescription) ? globalThis.String(object.remoteSysDescription) : "",
      remoteSysName: isSet(object.remoteSysName) ? globalThis.String(object.remoteSysName) : "",
      remoteManagementAddrIpv4: isSet(object.remoteManagementAddrIpv4)
        ? globalThis.String(object.remoteManagementAddrIpv4)
        : "",
      remoteManagementAddrIpv6: isSet(object.remoteManagementAddrIpv6)
        ? globalThis.String(object.remoteManagementAddrIpv6)
        : "",
      remoteDeviceId: isSet(object.remoteDeviceId) ? globalThis.String(object.remoteDeviceId) : "",
      remoteIndex: isSet(object.remoteIndex) ? globalThis.Number(object.remoteIndex) : 0,
      remotePortIdSubtype: isSet(object.remotePortIdSubtype)
        ? lLDPRemoteDeviceHostSubTypeFromJSON(object.remotePortIdSubtype)
        : 0,
      remoteDeviceIdSubtype: isSet(object.remoteDeviceIdSubtype)
        ? lLDPRemoteDeviceHostSubTypeFromJSON(object.remoteDeviceIdSubtype)
        : 0,
      remoteTimeMark: isSet(object.remoteTimeMark) ? globalThis.String(object.remoteTimeMark) : "0",
      deprecatedRemoteSysCap: globalThis.Array.isArray(object?.deprecatedRemoteSysCap)
        ? object.deprecatedRemoteSysCap.map((e: any) => RemoteSysCapability.fromJSON(e))
        : [],
      collectedAt: isSet(object["collected-at"]) ? fromJsonTimestamp(object["collected-at"]) : undefined,
      localPort: isSet(object.localPort) ? globalThis.String(object.localPort) : "",
      neighborType: isSet(object.neighborType) ? neighborTypeFromJSON(object.neighborType) : 0,
      remotePortTtl: isSet(object.remotePortTtl) ? globalThis.Number(object.remotePortTtl) : 0,
      remotePortAutoNegotiation: isSet(object.remotePortAutoNegotiation)
        ? RemotePortAutoNegotiation.fromJSON(object.remotePortAutoNegotiation)
        : undefined,
      RemoteSysCapabilityRepeater: isSet(object.RemoteSysCapabilityRepeater)
        ? globalThis.Boolean(object.RemoteSysCapabilityRepeater)
        : false,
      RemoteSysCapabilityBridge: isSet(object.RemoteSysCapabilityBridge)
        ? globalThis.Boolean(object.RemoteSysCapabilityBridge)
        : false,
      RemoteSysCapabilityWlan: isSet(object.RemoteSysCapabilityWlan)
        ? globalThis.Boolean(object.RemoteSysCapabilityWlan)
        : false,
      RemoteSysCapabilityRouter: isSet(object.RemoteSysCapabilityRouter)
        ? globalThis.Boolean(object.RemoteSysCapabilityRouter)
        : false,
      RemoteSysCapabilityTelephone: isSet(object.RemoteSysCapabilityTelephone)
        ? globalThis.Boolean(object.RemoteSysCapabilityTelephone)
        : false,
      RemoteSysCapabilityDocsisCableDevice: isSet(object.RemoteSysCapabilityDocsisCableDevice)
        ? globalThis.Boolean(object.RemoteSysCapabilityDocsisCableDevice)
        : false,
      RemoteSysCapabilityStation: isSet(object.RemoteSysCapabilityStation)
        ? globalThis.Boolean(object.RemoteSysCapabilityStation)
        : false,
      portAlias: isSet(object.portAlias) ? globalThis.String(object.portAlias) : "",
      meType: isSet(object.meType) ? managedEndpointTypeFromJSON(object.meType) : 0,
      serverInfo: isSet(object.serverInfo) ? ManagedEndpointServerInfo.fromJSON(object.serverInfo) : undefined,
      extendedDiscovery: isSet(object.extendedDiscovery)
        ? ExtendedDiscovery.fromJSON(object.extendedDiscovery)
        : undefined,
    };
  },

  toJSON(message: PortNeighbor): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.remotePortDesc !== "") {
      obj.remotePortDesc = message.remotePortDesc;
    }
    if (message.remotePortId !== "") {
      obj.remotePortId = message.remotePortId;
    }
    if (message.remoteSysDescription !== "") {
      obj.remoteSysDescription = message.remoteSysDescription;
    }
    if (message.remoteSysName !== "") {
      obj.remoteSysName = message.remoteSysName;
    }
    if (message.remoteManagementAddrIpv4 !== "") {
      obj.remoteManagementAddrIpv4 = message.remoteManagementAddrIpv4;
    }
    if (message.remoteManagementAddrIpv6 !== "") {
      obj.remoteManagementAddrIpv6 = message.remoteManagementAddrIpv6;
    }
    if (message.remoteDeviceId !== "") {
      obj.remoteDeviceId = message.remoteDeviceId;
    }
    if (message.remoteIndex !== 0) {
      obj.remoteIndex = Math.round(message.remoteIndex);
    }
    if (message.remotePortIdSubtype !== 0) {
      obj.remotePortIdSubtype = lLDPRemoteDeviceHostSubTypeToJSON(message.remotePortIdSubtype);
    }
    if (message.remoteDeviceIdSubtype !== 0) {
      obj.remoteDeviceIdSubtype = lLDPRemoteDeviceHostSubTypeToJSON(message.remoteDeviceIdSubtype);
    }
    if (message.remoteTimeMark !== "0") {
      obj.remoteTimeMark = message.remoteTimeMark;
    }
    if (message.deprecatedRemoteSysCap?.length) {
      obj.deprecatedRemoteSysCap = message.deprecatedRemoteSysCap.map((e) => RemoteSysCapability.toJSON(e));
    }
    if (message.collectedAt !== undefined) {
      obj["collected-at"] = message.collectedAt.toISOString();
    }
    if (message.localPort !== "") {
      obj.localPort = message.localPort;
    }
    if (message.neighborType !== 0) {
      obj.neighborType = neighborTypeToJSON(message.neighborType);
    }
    if (message.remotePortTtl !== 0) {
      obj.remotePortTtl = Math.round(message.remotePortTtl);
    }
    if (message.remotePortAutoNegotiation !== undefined) {
      obj.remotePortAutoNegotiation = RemotePortAutoNegotiation.toJSON(message.remotePortAutoNegotiation);
    }
    if (message.RemoteSysCapabilityRepeater !== false) {
      obj.RemoteSysCapabilityRepeater = message.RemoteSysCapabilityRepeater;
    }
    if (message.RemoteSysCapabilityBridge !== false) {
      obj.RemoteSysCapabilityBridge = message.RemoteSysCapabilityBridge;
    }
    if (message.RemoteSysCapabilityWlan !== false) {
      obj.RemoteSysCapabilityWlan = message.RemoteSysCapabilityWlan;
    }
    if (message.RemoteSysCapabilityRouter !== false) {
      obj.RemoteSysCapabilityRouter = message.RemoteSysCapabilityRouter;
    }
    if (message.RemoteSysCapabilityTelephone !== false) {
      obj.RemoteSysCapabilityTelephone = message.RemoteSysCapabilityTelephone;
    }
    if (message.RemoteSysCapabilityDocsisCableDevice !== false) {
      obj.RemoteSysCapabilityDocsisCableDevice = message.RemoteSysCapabilityDocsisCableDevice;
    }
    if (message.RemoteSysCapabilityStation !== false) {
      obj.RemoteSysCapabilityStation = message.RemoteSysCapabilityStation;
    }
    if (message.portAlias !== "") {
      obj.portAlias = message.portAlias;
    }
    if (message.meType !== 0) {
      obj.meType = managedEndpointTypeToJSON(message.meType);
    }
    if (message.serverInfo !== undefined) {
      obj.serverInfo = ManagedEndpointServerInfo.toJSON(message.serverInfo);
    }
    if (message.extendedDiscovery !== undefined) {
      obj.extendedDiscovery = ExtendedDiscovery.toJSON(message.extendedDiscovery);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortNeighbor>, I>>(base?: I): PortNeighbor {
    return PortNeighbor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortNeighbor>, I>>(object: I): PortNeighbor {
    const message = createBasePortNeighbor();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.remotePortDesc = object.remotePortDesc ?? "";
    message.remotePortId = object.remotePortId ?? "";
    message.remoteSysDescription = object.remoteSysDescription ?? "";
    message.remoteSysName = object.remoteSysName ?? "";
    message.remoteManagementAddrIpv4 = object.remoteManagementAddrIpv4 ?? "";
    message.remoteManagementAddrIpv6 = object.remoteManagementAddrIpv6 ?? "";
    message.remoteDeviceId = object.remoteDeviceId ?? "";
    message.remoteIndex = object.remoteIndex ?? 0;
    message.remotePortIdSubtype = object.remotePortIdSubtype ?? 0;
    message.remoteDeviceIdSubtype = object.remoteDeviceIdSubtype ?? 0;
    message.remoteTimeMark = object.remoteTimeMark ?? "0";
    message.deprecatedRemoteSysCap = object.deprecatedRemoteSysCap?.map((e) => RemoteSysCapability.fromPartial(e)) ||
      [];
    message.collectedAt = object.collectedAt ?? undefined;
    message.localPort = object.localPort ?? "";
    message.neighborType = object.neighborType ?? 0;
    message.remotePortTtl = object.remotePortTtl ?? 0;
    message.remotePortAutoNegotiation =
      (object.remotePortAutoNegotiation !== undefined && object.remotePortAutoNegotiation !== null)
        ? RemotePortAutoNegotiation.fromPartial(object.remotePortAutoNegotiation)
        : undefined;
    message.RemoteSysCapabilityRepeater = object.RemoteSysCapabilityRepeater ?? false;
    message.RemoteSysCapabilityBridge = object.RemoteSysCapabilityBridge ?? false;
    message.RemoteSysCapabilityWlan = object.RemoteSysCapabilityWlan ?? false;
    message.RemoteSysCapabilityRouter = object.RemoteSysCapabilityRouter ?? false;
    message.RemoteSysCapabilityTelephone = object.RemoteSysCapabilityTelephone ?? false;
    message.RemoteSysCapabilityDocsisCableDevice = object.RemoteSysCapabilityDocsisCableDevice ?? false;
    message.RemoteSysCapabilityStation = object.RemoteSysCapabilityStation ?? false;
    message.portAlias = object.portAlias ?? "";
    message.meType = object.meType ?? 0;
    message.serverInfo = (object.serverInfo !== undefined && object.serverInfo !== null)
      ? ManagedEndpointServerInfo.fromPartial(object.serverInfo)
      : undefined;
    message.extendedDiscovery = (object.extendedDiscovery !== undefined && object.extendedDiscovery !== null)
      ? ExtendedDiscovery.fromPartial(object.extendedDiscovery)
      : undefined;
    return message;
  },
};

function createBasePortState(): PortState {
  return {
    adminState: 0,
    operState: 0,
    ipv4: "",
    adminDownCounter: "0",
    operDownCounter: "0",
    speed: "0",
    mtu: 0,
    fec: 0,
    collectedAt: undefined,
    portAlias: "",
    canonicalPortName: "",
    autoPortCfg: 0,
    lastUpTime: undefined,
  };
}

export const PortState: MessageFns<PortState> = {
  encode(message: PortState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.adminState !== 0) {
      writer.uint32(16).int32(message.adminState);
    }
    if (message.operState !== 0) {
      writer.uint32(24).int32(message.operState);
    }
    if (message.ipv4 !== "") {
      writer.uint32(34).string(message.ipv4);
    }
    if (message.adminDownCounter !== "0") {
      writer.uint32(48).uint64(message.adminDownCounter);
    }
    if (message.operDownCounter !== "0") {
      writer.uint32(56).uint64(message.operDownCounter);
    }
    if (message.speed !== "0") {
      writer.uint32(64).uint64(message.speed);
    }
    if (message.mtu !== 0) {
      writer.uint32(72).uint32(message.mtu);
    }
    if (message.fec !== 0) {
      writer.uint32(80).int32(message.fec);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(42).fork()).join();
    }
    if (message.portAlias !== "") {
      writer.uint32(90).string(message.portAlias);
    }
    if (message.canonicalPortName !== "") {
      writer.uint32(98).string(message.canonicalPortName);
    }
    if (message.autoPortCfg !== 0) {
      writer.uint32(104).int32(message.autoPortCfg);
    }
    if (message.lastUpTime !== undefined) {
      Timestamp.encode(toTimestamp(message.lastUpTime), writer.uint32(114).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.adminState = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.operState = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ipv4 = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.adminDownCounter = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.operDownCounter = reader.uint64().toString();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.speed = reader.uint64().toString();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.mtu = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.fec = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.portAlias = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.canonicalPortName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.autoPortCfg = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.lastUpTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortState {
    return {
      adminState: isSet(object.adminState) ? adminStateFromJSON(object.adminState) : 0,
      operState: isSet(object.operState) ? operStateFromJSON(object.operState) : 0,
      ipv4: isSet(object.ipv4) ? globalThis.String(object.ipv4) : "",
      adminDownCounter: isSet(object.adminDownCounter) ? globalThis.String(object.adminDownCounter) : "0",
      operDownCounter: isSet(object.operDownCounter) ? globalThis.String(object.operDownCounter) : "0",
      speed: isSet(object.speed) ? globalThis.String(object.speed) : "0",
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      fec: isSet(object.fec) ? fecTypeFromJSON(object.fec) : 0,
      collectedAt: isSet(object["collected-at"]) ? fromJsonTimestamp(object["collected-at"]) : undefined,
      portAlias: isSet(object.portAlias) ? globalThis.String(object.portAlias) : "",
      canonicalPortName: isSet(object.canonicalPortName) ? globalThis.String(object.canonicalPortName) : "",
      autoPortCfg: isSet(object.autoPortCfg) ? autoPortCfgStateFromJSON(object.autoPortCfg) : 0,
      lastUpTime: isSet(object.lastUpTime) ? fromJsonTimestamp(object.lastUpTime) : undefined,
    };
  },

  toJSON(message: PortState): unknown {
    const obj: any = {};
    if (message.adminState !== 0) {
      obj.adminState = adminStateToJSON(message.adminState);
    }
    if (message.operState !== 0) {
      obj.operState = operStateToJSON(message.operState);
    }
    if (message.ipv4 !== "") {
      obj.ipv4 = message.ipv4;
    }
    if (message.adminDownCounter !== "0") {
      obj.adminDownCounter = message.adminDownCounter;
    }
    if (message.operDownCounter !== "0") {
      obj.operDownCounter = message.operDownCounter;
    }
    if (message.speed !== "0") {
      obj.speed = message.speed;
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.fec !== 0) {
      obj.fec = fecTypeToJSON(message.fec);
    }
    if (message.collectedAt !== undefined) {
      obj["collected-at"] = message.collectedAt.toISOString();
    }
    if (message.portAlias !== "") {
      obj.portAlias = message.portAlias;
    }
    if (message.canonicalPortName !== "") {
      obj.canonicalPortName = message.canonicalPortName;
    }
    if (message.autoPortCfg !== 0) {
      obj.autoPortCfg = autoPortCfgStateToJSON(message.autoPortCfg);
    }
    if (message.lastUpTime !== undefined) {
      obj.lastUpTime = message.lastUpTime.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortState>, I>>(base?: I): PortState {
    return PortState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortState>, I>>(object: I): PortState {
    const message = createBasePortState();
    message.adminState = object.adminState ?? 0;
    message.operState = object.operState ?? 0;
    message.ipv4 = object.ipv4 ?? "";
    message.adminDownCounter = object.adminDownCounter ?? "0";
    message.operDownCounter = object.operDownCounter ?? "0";
    message.speed = object.speed ?? "0";
    message.mtu = object.mtu ?? 0;
    message.fec = object.fec ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.portAlias = object.portAlias ?? "";
    message.canonicalPortName = object.canonicalPortName ?? "";
    message.autoPortCfg = object.autoPortCfg ?? 0;
    message.lastUpTime = object.lastUpTime ?? undefined;
    return message;
  },
};

function createBaseVtep(): Vtep {
  return { id: undefined, bytesIn: "0", bytesOut: "0", pktsIn: "0", pktsOut: "0", collectedAt: undefined };
}

export const Vtep: MessageFns<Vtep> = {
  encode(message: Vtep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.bytesIn !== "0") {
      writer.uint32(24).uint64(message.bytesIn);
    }
    if (message.bytesOut !== "0") {
      writer.uint32(32).uint64(message.bytesOut);
    }
    if (message.pktsIn !== "0") {
      writer.uint32(40).uint64(message.pktsIn);
    }
    if (message.pktsOut !== "0") {
      writer.uint32(48).uint64(message.pktsOut);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Vtep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVtep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.bytesIn = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.bytesOut = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.pktsIn = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.pktsOut = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Vtep {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      bytesIn: isSet(object.bytesIn) ? globalThis.String(object.bytesIn) : "0",
      bytesOut: isSet(object.bytesOut) ? globalThis.String(object.bytesOut) : "0",
      pktsIn: isSet(object.pktsIn) ? globalThis.String(object.pktsIn) : "0",
      pktsOut: isSet(object.pktsOut) ? globalThis.String(object.pktsOut) : "0",
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: Vtep): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.bytesIn !== "0") {
      obj.bytesIn = message.bytesIn;
    }
    if (message.bytesOut !== "0") {
      obj.bytesOut = message.bytesOut;
    }
    if (message.pktsIn !== "0") {
      obj.pktsIn = message.pktsIn;
    }
    if (message.pktsOut !== "0") {
      obj.pktsOut = message.pktsOut;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Vtep>, I>>(base?: I): Vtep {
    return Vtep.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Vtep>, I>>(object: I): Vtep {
    const message = createBaseVtep();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.bytesIn = object.bytesIn ?? "0";
    message.bytesOut = object.bytesOut ?? "0";
    message.pktsIn = object.pktsIn ?? "0";
    message.pktsOut = object.pktsOut ?? "0";
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseRemoteVtep(): RemoteVtep {
  return { id: undefined, bytesIn: "0", bytesOut: "0", pktsIn: "0", pktsOut: "0", collectedAt: undefined };
}

export const RemoteVtep: MessageFns<RemoteVtep> = {
  encode(message: RemoteVtep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.bytesIn !== "0") {
      writer.uint32(24).uint64(message.bytesIn);
    }
    if (message.bytesOut !== "0") {
      writer.uint32(32).uint64(message.bytesOut);
    }
    if (message.pktsIn !== "0") {
      writer.uint32(40).uint64(message.pktsIn);
    }
    if (message.pktsOut !== "0") {
      writer.uint32(48).uint64(message.pktsOut);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteVtep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteVtep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.bytesIn = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.bytesOut = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.pktsIn = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.pktsOut = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoteVtep {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      bytesIn: isSet(object.bytesIn) ? globalThis.String(object.bytesIn) : "0",
      bytesOut: isSet(object.bytesOut) ? globalThis.String(object.bytesOut) : "0",
      pktsIn: isSet(object.pktsIn) ? globalThis.String(object.pktsIn) : "0",
      pktsOut: isSet(object.pktsOut) ? globalThis.String(object.pktsOut) : "0",
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: RemoteVtep): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.bytesIn !== "0") {
      obj.bytesIn = message.bytesIn;
    }
    if (message.bytesOut !== "0") {
      obj.bytesOut = message.bytesOut;
    }
    if (message.pktsIn !== "0") {
      obj.pktsIn = message.pktsIn;
    }
    if (message.pktsOut !== "0") {
      obj.pktsOut = message.pktsOut;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoteVtep>, I>>(base?: I): RemoteVtep {
    return RemoteVtep.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteVtep>, I>>(object: I): RemoteVtep {
    const message = createBaseRemoteVtep();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.bytesIn = object.bytesIn ?? "0";
    message.bytesOut = object.bytesOut ?? "0";
    message.pktsIn = object.pktsIn ?? "0";
    message.pktsOut = object.pktsOut ?? "0";
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseVniPort(): VniPort {
  return { id: undefined, counters: undefined };
}

export const VniPort: MessageFns<VniPort> = {
  encode(message: VniPort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.counters !== undefined) {
      BasicCounters.encode(message.counters, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VniPort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVniPort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.counters = BasicCounters.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VniPort {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      counters: isSet(object.counters) ? BasicCounters.fromJSON(object.counters) : undefined,
    };
  },

  toJSON(message: VniPort): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.counters !== undefined) {
      obj.counters = BasicCounters.toJSON(message.counters);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VniPort>, I>>(base?: I): VniPort {
    return VniPort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VniPort>, I>>(object: I): VniPort {
    const message = createBaseVniPort();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.counters = (object.counters !== undefined && object.counters !== null)
      ? BasicCounters.fromPartial(object.counters)
      : undefined;
    return message;
  },
};

function createBaseMac(): Mac {
  return { id: undefined, macAddress: "" };
}

export const Mac: MessageFns<Mac> = {
  encode(message: Mac, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.macAddress !== "") {
      writer.uint32(26).string(message.macAddress);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Mac {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMac();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.macAddress = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Mac {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      macAddress: isSet(object.macAddress) ? globalThis.String(object.macAddress) : "",
    };
  },

  toJSON(message: Mac): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.macAddress !== "") {
      obj.macAddress = message.macAddress;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Mac>, I>>(base?: I): Mac {
    return Mac.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Mac>, I>>(object: I): Mac {
    const message = createBaseMac();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.macAddress = object.macAddress ?? "";
    return message;
  },
};

function createBasePortVlan(): PortVlan {
  return { id: undefined, vlan: 0, deprecatedUntagged: "", taggingMode: 0, collectedAt: undefined };
}

export const PortVlan: MessageFns<PortVlan> = {
  encode(message: PortVlan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.vlan !== 0) {
      writer.uint32(24).uint32(message.vlan);
    }
    if (message.deprecatedUntagged !== "") {
      writer.uint32(34).string(message.deprecatedUntagged);
    }
    if (message.taggingMode !== 0) {
      writer.uint32(40).int32(message.taggingMode);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortVlan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortVlan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vlan = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.deprecatedUntagged = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.taggingMode = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortVlan {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vlan: isSet(object.vlan) ? globalThis.Number(object.vlan) : 0,
      deprecatedUntagged: isSet(object.deprecatedUntagged) ? globalThis.String(object.deprecatedUntagged) : "",
      taggingMode: isSet(object.taggingMode) ? vlanTaggingModeFromJSON(object.taggingMode) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: PortVlan): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vlan !== 0) {
      obj.vlan = Math.round(message.vlan);
    }
    if (message.deprecatedUntagged !== "") {
      obj.deprecatedUntagged = message.deprecatedUntagged;
    }
    if (message.taggingMode !== 0) {
      obj.taggingMode = vlanTaggingModeToJSON(message.taggingMode);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortVlan>, I>>(base?: I): PortVlan {
    return PortVlan.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortVlan>, I>>(object: I): PortVlan {
    const message = createBasePortVlan();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vlan = object.vlan ?? 0;
    message.deprecatedUntagged = object.deprecatedUntagged ?? "";
    message.taggingMode = object.taggingMode ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseVlanState(): VlanState {
  return {
    id: undefined,
    adminState: 0,
    hostIfname: "",
    macAddr: "",
    mtu: 0,
    vlanId: 0,
    vlanName: "",
    vni: 0,
    collectedAt: undefined,
  };
}

export const VlanState: MessageFns<VlanState> = {
  encode(message: VlanState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.adminState !== 0) {
      writer.uint32(24).int32(message.adminState);
    }
    if (message.hostIfname !== "") {
      writer.uint32(34).string(message.hostIfname);
    }
    if (message.macAddr !== "") {
      writer.uint32(42).string(message.macAddr);
    }
    if (message.mtu !== 0) {
      writer.uint32(48).uint32(message.mtu);
    }
    if (message.vlanId !== 0) {
      writer.uint32(56).uint32(message.vlanId);
    }
    if (message.vlanName !== "") {
      writer.uint32(66).string(message.vlanName);
    }
    if (message.vni !== 0) {
      writer.uint32(72).uint32(message.vni);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VlanState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVlanState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.adminState = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.hostIfname = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.macAddr = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.mtu = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.vlanName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VlanState {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      adminState: isSet(object.adminState) ? adminStateFromJSON(object.adminState) : 0,
      hostIfname: isSet(object.hostIfname) ? globalThis.String(object.hostIfname) : "",
      macAddr: isSet(object.macAddr) ? globalThis.String(object.macAddr) : "",
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      vlanName: isSet(object.vlanName) ? globalThis.String(object.vlanName) : "",
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: VlanState): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.adminState !== 0) {
      obj.adminState = adminStateToJSON(message.adminState);
    }
    if (message.hostIfname !== "") {
      obj.hostIfname = message.hostIfname;
    }
    if (message.macAddr !== "") {
      obj.macAddr = message.macAddr;
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.vlanName !== "") {
      obj.vlanName = message.vlanName;
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VlanState>, I>>(base?: I): VlanState {
    return VlanState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VlanState>, I>>(object: I): VlanState {
    const message = createBaseVlanState();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.adminState = object.adminState ?? 0;
    message.hostIfname = object.hostIfname ?? "";
    message.macAddr = object.macAddr ?? "";
    message.mtu = object.mtu ?? 0;
    message.vlanId = object.vlanId ?? 0;
    message.vlanName = object.vlanName ?? "";
    message.vni = object.vni ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseUnknownVlanPort(): UnknownVlanPort {
  return { id: undefined };
}

export const UnknownVlanPort: MessageFns<UnknownVlanPort> = {
  encode(message: UnknownVlanPort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnknownVlanPort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnknownVlanPort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnknownVlanPort {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: UnknownVlanPort): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnknownVlanPort>, I>>(base?: I): UnknownVlanPort {
    return UnknownVlanPort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnknownVlanPort>, I>>(object: I): UnknownVlanPort {
    const message = createBaseUnknownVlanPort();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseUnknownVlan(): UnknownVlan {
  return { id: undefined, vlanId: 0, port: "", lastRxPkt: undefined, collectedAt: undefined };
}

export const UnknownVlan: MessageFns<UnknownVlan> = {
  encode(message: UnknownVlan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.vlanId !== 0) {
      writer.uint32(32).int32(message.vlanId);
    }
    if (message.port !== "") {
      writer.uint32(42).string(message.port);
    }
    if (message.lastRxPkt !== undefined) {
      Timestamp.encode(toTimestamp(message.lastRxPkt), writer.uint32(50).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnknownVlan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnknownVlan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.vlanId = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.port = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.lastRxPkt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnknownVlan {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      port: isSet(object.port) ? globalThis.String(object.port) : "",
      lastRxPkt: isSet(object.lastRxPkt) ? fromJsonTimestamp(object.lastRxPkt) : undefined,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: UnknownVlan): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.port !== "") {
      obj.port = message.port;
    }
    if (message.lastRxPkt !== undefined) {
      obj.lastRxPkt = message.lastRxPkt.toISOString();
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnknownVlan>, I>>(base?: I): UnknownVlan {
    return UnknownVlan.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnknownVlan>, I>>(object: I): UnknownVlan {
    const message = createBaseUnknownVlan();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vlanId = object.vlanId ?? 0;
    message.port = object.port ?? "";
    message.lastRxPkt = object.lastRxPkt ?? undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseQsfpDomSensor(): QsfpDomSensor {
  return {
    id: undefined,
    laserTemperature: 0,
    voltage: 0,
    rx1power: 0,
    rx2power: 0,
    rx3power: 0,
    rx4power: 0,
    rx5power: 0,
    rx6power: 0,
    rx7power: 0,
    rx8power: 0,
    temperature: 0,
    tx1bias: 0,
    tx2bias: 0,
    tx3bias: 0,
    tx4bias: 0,
    tx5bias: 0,
    tx6bias: 0,
    tx7bias: 0,
    tx8bias: 0,
    tx1power: 0,
    tx2power: 0,
    tx3power: 0,
    tx4power: 0,
    tx5power: 0,
    tx6power: 0,
    tx7power: 0,
    tx8power: 0,
    mediaLaneCount: 0,
    collectedAt: undefined,
  };
}

export const QsfpDomSensor: MessageFns<QsfpDomSensor> = {
  encode(message: QsfpDomSensor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.laserTemperature !== 0) {
      writer.uint32(29).float(message.laserTemperature);
    }
    if (message.voltage !== 0) {
      writer.uint32(37).float(message.voltage);
    }
    if (message.rx1power !== 0) {
      writer.uint32(45).float(message.rx1power);
    }
    if (message.rx2power !== 0) {
      writer.uint32(53).float(message.rx2power);
    }
    if (message.rx3power !== 0) {
      writer.uint32(61).float(message.rx3power);
    }
    if (message.rx4power !== 0) {
      writer.uint32(69).float(message.rx4power);
    }
    if (message.rx5power !== 0) {
      writer.uint32(77).float(message.rx5power);
    }
    if (message.rx6power !== 0) {
      writer.uint32(85).float(message.rx6power);
    }
    if (message.rx7power !== 0) {
      writer.uint32(93).float(message.rx7power);
    }
    if (message.rx8power !== 0) {
      writer.uint32(101).float(message.rx8power);
    }
    if (message.temperature !== 0) {
      writer.uint32(109).float(message.temperature);
    }
    if (message.tx1bias !== 0) {
      writer.uint32(117).float(message.tx1bias);
    }
    if (message.tx2bias !== 0) {
      writer.uint32(125).float(message.tx2bias);
    }
    if (message.tx3bias !== 0) {
      writer.uint32(133).float(message.tx3bias);
    }
    if (message.tx4bias !== 0) {
      writer.uint32(141).float(message.tx4bias);
    }
    if (message.tx5bias !== 0) {
      writer.uint32(149).float(message.tx5bias);
    }
    if (message.tx6bias !== 0) {
      writer.uint32(157).float(message.tx6bias);
    }
    if (message.tx7bias !== 0) {
      writer.uint32(165).float(message.tx7bias);
    }
    if (message.tx8bias !== 0) {
      writer.uint32(173).float(message.tx8bias);
    }
    if (message.tx1power !== 0) {
      writer.uint32(181).float(message.tx1power);
    }
    if (message.tx2power !== 0) {
      writer.uint32(189).float(message.tx2power);
    }
    if (message.tx3power !== 0) {
      writer.uint32(197).float(message.tx3power);
    }
    if (message.tx4power !== 0) {
      writer.uint32(205).float(message.tx4power);
    }
    if (message.tx5power !== 0) {
      writer.uint32(213).float(message.tx5power);
    }
    if (message.tx6power !== 0) {
      writer.uint32(221).float(message.tx6power);
    }
    if (message.tx7power !== 0) {
      writer.uint32(229).float(message.tx7power);
    }
    if (message.tx8power !== 0) {
      writer.uint32(237).float(message.tx8power);
    }
    if (message.mediaLaneCount !== 0) {
      writer.uint32(240).int32(message.mediaLaneCount);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(250).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QsfpDomSensor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQsfpDomSensor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.laserTemperature = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.voltage = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.rx1power = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.rx2power = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.rx3power = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.rx4power = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.rx5power = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.rx6power = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.rx7power = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 101) {
            break;
          }

          message.rx8power = reader.float();
          continue;
        }
        case 13: {
          if (tag !== 109) {
            break;
          }

          message.temperature = reader.float();
          continue;
        }
        case 14: {
          if (tag !== 117) {
            break;
          }

          message.tx1bias = reader.float();
          continue;
        }
        case 15: {
          if (tag !== 125) {
            break;
          }

          message.tx2bias = reader.float();
          continue;
        }
        case 16: {
          if (tag !== 133) {
            break;
          }

          message.tx3bias = reader.float();
          continue;
        }
        case 17: {
          if (tag !== 141) {
            break;
          }

          message.tx4bias = reader.float();
          continue;
        }
        case 18: {
          if (tag !== 149) {
            break;
          }

          message.tx5bias = reader.float();
          continue;
        }
        case 19: {
          if (tag !== 157) {
            break;
          }

          message.tx6bias = reader.float();
          continue;
        }
        case 20: {
          if (tag !== 165) {
            break;
          }

          message.tx7bias = reader.float();
          continue;
        }
        case 21: {
          if (tag !== 173) {
            break;
          }

          message.tx8bias = reader.float();
          continue;
        }
        case 22: {
          if (tag !== 181) {
            break;
          }

          message.tx1power = reader.float();
          continue;
        }
        case 23: {
          if (tag !== 189) {
            break;
          }

          message.tx2power = reader.float();
          continue;
        }
        case 24: {
          if (tag !== 197) {
            break;
          }

          message.tx3power = reader.float();
          continue;
        }
        case 25: {
          if (tag !== 205) {
            break;
          }

          message.tx4power = reader.float();
          continue;
        }
        case 26: {
          if (tag !== 213) {
            break;
          }

          message.tx5power = reader.float();
          continue;
        }
        case 27: {
          if (tag !== 221) {
            break;
          }

          message.tx6power = reader.float();
          continue;
        }
        case 28: {
          if (tag !== 229) {
            break;
          }

          message.tx7power = reader.float();
          continue;
        }
        case 29: {
          if (tag !== 237) {
            break;
          }

          message.tx8power = reader.float();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.mediaLaneCount = reader.int32();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QsfpDomSensor {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      laserTemperature: isSet(object.laserTemperature) ? globalThis.Number(object.laserTemperature) : 0,
      voltage: isSet(object.voltage) ? globalThis.Number(object.voltage) : 0,
      rx1power: isSet(object.rx1power) ? globalThis.Number(object.rx1power) : 0,
      rx2power: isSet(object.rx2power) ? globalThis.Number(object.rx2power) : 0,
      rx3power: isSet(object.rx3power) ? globalThis.Number(object.rx3power) : 0,
      rx4power: isSet(object.rx4power) ? globalThis.Number(object.rx4power) : 0,
      rx5power: isSet(object.rx5power) ? globalThis.Number(object.rx5power) : 0,
      rx6power: isSet(object.rx6power) ? globalThis.Number(object.rx6power) : 0,
      rx7power: isSet(object.rx7power) ? globalThis.Number(object.rx7power) : 0,
      rx8power: isSet(object.rx8power) ? globalThis.Number(object.rx8power) : 0,
      temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : 0,
      tx1bias: isSet(object.tx1bias) ? globalThis.Number(object.tx1bias) : 0,
      tx2bias: isSet(object.tx2bias) ? globalThis.Number(object.tx2bias) : 0,
      tx3bias: isSet(object.tx3bias) ? globalThis.Number(object.tx3bias) : 0,
      tx4bias: isSet(object.tx4bias) ? globalThis.Number(object.tx4bias) : 0,
      tx5bias: isSet(object.tx5bias) ? globalThis.Number(object.tx5bias) : 0,
      tx6bias: isSet(object.tx6bias) ? globalThis.Number(object.tx6bias) : 0,
      tx7bias: isSet(object.tx7bias) ? globalThis.Number(object.tx7bias) : 0,
      tx8bias: isSet(object.tx8bias) ? globalThis.Number(object.tx8bias) : 0,
      tx1power: isSet(object.tx1power) ? globalThis.Number(object.tx1power) : 0,
      tx2power: isSet(object.tx2power) ? globalThis.Number(object.tx2power) : 0,
      tx3power: isSet(object.tx3power) ? globalThis.Number(object.tx3power) : 0,
      tx4power: isSet(object.tx4power) ? globalThis.Number(object.tx4power) : 0,
      tx5power: isSet(object.tx5power) ? globalThis.Number(object.tx5power) : 0,
      tx6power: isSet(object.tx6power) ? globalThis.Number(object.tx6power) : 0,
      tx7power: isSet(object.tx7power) ? globalThis.Number(object.tx7power) : 0,
      tx8power: isSet(object.tx8power) ? globalThis.Number(object.tx8power) : 0,
      mediaLaneCount: isSet(object.mediaLaneCount) ? globalThis.Number(object.mediaLaneCount) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: QsfpDomSensor): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.laserTemperature !== 0) {
      obj.laserTemperature = message.laserTemperature;
    }
    if (message.voltage !== 0) {
      obj.voltage = message.voltage;
    }
    if (message.rx1power !== 0) {
      obj.rx1power = message.rx1power;
    }
    if (message.rx2power !== 0) {
      obj.rx2power = message.rx2power;
    }
    if (message.rx3power !== 0) {
      obj.rx3power = message.rx3power;
    }
    if (message.rx4power !== 0) {
      obj.rx4power = message.rx4power;
    }
    if (message.rx5power !== 0) {
      obj.rx5power = message.rx5power;
    }
    if (message.rx6power !== 0) {
      obj.rx6power = message.rx6power;
    }
    if (message.rx7power !== 0) {
      obj.rx7power = message.rx7power;
    }
    if (message.rx8power !== 0) {
      obj.rx8power = message.rx8power;
    }
    if (message.temperature !== 0) {
      obj.temperature = message.temperature;
    }
    if (message.tx1bias !== 0) {
      obj.tx1bias = message.tx1bias;
    }
    if (message.tx2bias !== 0) {
      obj.tx2bias = message.tx2bias;
    }
    if (message.tx3bias !== 0) {
      obj.tx3bias = message.tx3bias;
    }
    if (message.tx4bias !== 0) {
      obj.tx4bias = message.tx4bias;
    }
    if (message.tx5bias !== 0) {
      obj.tx5bias = message.tx5bias;
    }
    if (message.tx6bias !== 0) {
      obj.tx6bias = message.tx6bias;
    }
    if (message.tx7bias !== 0) {
      obj.tx7bias = message.tx7bias;
    }
    if (message.tx8bias !== 0) {
      obj.tx8bias = message.tx8bias;
    }
    if (message.tx1power !== 0) {
      obj.tx1power = message.tx1power;
    }
    if (message.tx2power !== 0) {
      obj.tx2power = message.tx2power;
    }
    if (message.tx3power !== 0) {
      obj.tx3power = message.tx3power;
    }
    if (message.tx4power !== 0) {
      obj.tx4power = message.tx4power;
    }
    if (message.tx5power !== 0) {
      obj.tx5power = message.tx5power;
    }
    if (message.tx6power !== 0) {
      obj.tx6power = message.tx6power;
    }
    if (message.tx7power !== 0) {
      obj.tx7power = message.tx7power;
    }
    if (message.tx8power !== 0) {
      obj.tx8power = message.tx8power;
    }
    if (message.mediaLaneCount !== 0) {
      obj.mediaLaneCount = Math.round(message.mediaLaneCount);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QsfpDomSensor>, I>>(base?: I): QsfpDomSensor {
    return QsfpDomSensor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QsfpDomSensor>, I>>(object: I): QsfpDomSensor {
    const message = createBaseQsfpDomSensor();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.laserTemperature = object.laserTemperature ?? 0;
    message.voltage = object.voltage ?? 0;
    message.rx1power = object.rx1power ?? 0;
    message.rx2power = object.rx2power ?? 0;
    message.rx3power = object.rx3power ?? 0;
    message.rx4power = object.rx4power ?? 0;
    message.rx5power = object.rx5power ?? 0;
    message.rx6power = object.rx6power ?? 0;
    message.rx7power = object.rx7power ?? 0;
    message.rx8power = object.rx8power ?? 0;
    message.temperature = object.temperature ?? 0;
    message.tx1bias = object.tx1bias ?? 0;
    message.tx2bias = object.tx2bias ?? 0;
    message.tx3bias = object.tx3bias ?? 0;
    message.tx4bias = object.tx4bias ?? 0;
    message.tx5bias = object.tx5bias ?? 0;
    message.tx6bias = object.tx6bias ?? 0;
    message.tx7bias = object.tx7bias ?? 0;
    message.tx8bias = object.tx8bias ?? 0;
    message.tx1power = object.tx1power ?? 0;
    message.tx2power = object.tx2power ?? 0;
    message.tx3power = object.tx3power ?? 0;
    message.tx4power = object.tx4power ?? 0;
    message.tx5power = object.tx5power ?? 0;
    message.tx6power = object.tx6power ?? 0;
    message.tx7power = object.tx7power ?? 0;
    message.tx8power = object.tx8power ?? 0;
    message.mediaLaneCount = object.mediaLaneCount ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseQsfpDomThreshold(): QsfpDomThreshold {
  return {
    id: undefined,
    lasertemphighalarm: 0,
    lasertemphighwarning: 0,
    lasertemplowalarm: 0,
    lasertemplowwarning: 0,
    rxpowerhighalarm: 0,
    rxpowerhighwarning: 0,
    rxpowerlowalarm: 0,
    rxpowerlowwarning: 0,
    temphighalarm: 0,
    temphighwarning: 0,
    templowalarm: 0,
    templowwarning: 0,
    txbiashighalarm: 0,
    txbiashighwarning: 0,
    txbiaslowalarm: 0,
    txbiaslowwarning: 0,
    txpowerhighalarm: 0,
    txpowerhighwarning: 0,
    txpowerlowalarm: 0,
    txpowerlowwarning: 0,
    vcchighalarm: 0,
    vcchighwarning: 0,
    vcclowalarm: 0,
    vcclowwarning: 0,
    collectedAt: undefined,
  };
}

export const QsfpDomThreshold: MessageFns<QsfpDomThreshold> = {
  encode(message: QsfpDomThreshold, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.lasertemphighalarm !== 0) {
      writer.uint32(29).float(message.lasertemphighalarm);
    }
    if (message.lasertemphighwarning !== 0) {
      writer.uint32(37).float(message.lasertemphighwarning);
    }
    if (message.lasertemplowalarm !== 0) {
      writer.uint32(45).float(message.lasertemplowalarm);
    }
    if (message.lasertemplowwarning !== 0) {
      writer.uint32(53).float(message.lasertemplowwarning);
    }
    if (message.rxpowerhighalarm !== 0) {
      writer.uint32(61).float(message.rxpowerhighalarm);
    }
    if (message.rxpowerhighwarning !== 0) {
      writer.uint32(69).float(message.rxpowerhighwarning);
    }
    if (message.rxpowerlowalarm !== 0) {
      writer.uint32(77).float(message.rxpowerlowalarm);
    }
    if (message.rxpowerlowwarning !== 0) {
      writer.uint32(85).float(message.rxpowerlowwarning);
    }
    if (message.temphighalarm !== 0) {
      writer.uint32(93).float(message.temphighalarm);
    }
    if (message.temphighwarning !== 0) {
      writer.uint32(101).float(message.temphighwarning);
    }
    if (message.templowalarm !== 0) {
      writer.uint32(109).float(message.templowalarm);
    }
    if (message.templowwarning !== 0) {
      writer.uint32(117).float(message.templowwarning);
    }
    if (message.txbiashighalarm !== 0) {
      writer.uint32(125).float(message.txbiashighalarm);
    }
    if (message.txbiashighwarning !== 0) {
      writer.uint32(133).float(message.txbiashighwarning);
    }
    if (message.txbiaslowalarm !== 0) {
      writer.uint32(141).float(message.txbiaslowalarm);
    }
    if (message.txbiaslowwarning !== 0) {
      writer.uint32(149).float(message.txbiaslowwarning);
    }
    if (message.txpowerhighalarm !== 0) {
      writer.uint32(157).float(message.txpowerhighalarm);
    }
    if (message.txpowerhighwarning !== 0) {
      writer.uint32(165).float(message.txpowerhighwarning);
    }
    if (message.txpowerlowalarm !== 0) {
      writer.uint32(173).float(message.txpowerlowalarm);
    }
    if (message.txpowerlowwarning !== 0) {
      writer.uint32(181).float(message.txpowerlowwarning);
    }
    if (message.vcchighalarm !== 0) {
      writer.uint32(189).float(message.vcchighalarm);
    }
    if (message.vcchighwarning !== 0) {
      writer.uint32(197).float(message.vcchighwarning);
    }
    if (message.vcclowalarm !== 0) {
      writer.uint32(205).float(message.vcclowalarm);
    }
    if (message.vcclowwarning !== 0) {
      writer.uint32(213).float(message.vcclowwarning);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(218).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QsfpDomThreshold {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQsfpDomThreshold();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.lasertemphighalarm = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.lasertemphighwarning = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.lasertemplowalarm = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.lasertemplowwarning = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.rxpowerhighalarm = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.rxpowerhighwarning = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.rxpowerlowalarm = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.rxpowerlowwarning = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.temphighalarm = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 101) {
            break;
          }

          message.temphighwarning = reader.float();
          continue;
        }
        case 13: {
          if (tag !== 109) {
            break;
          }

          message.templowalarm = reader.float();
          continue;
        }
        case 14: {
          if (tag !== 117) {
            break;
          }

          message.templowwarning = reader.float();
          continue;
        }
        case 15: {
          if (tag !== 125) {
            break;
          }

          message.txbiashighalarm = reader.float();
          continue;
        }
        case 16: {
          if (tag !== 133) {
            break;
          }

          message.txbiashighwarning = reader.float();
          continue;
        }
        case 17: {
          if (tag !== 141) {
            break;
          }

          message.txbiaslowalarm = reader.float();
          continue;
        }
        case 18: {
          if (tag !== 149) {
            break;
          }

          message.txbiaslowwarning = reader.float();
          continue;
        }
        case 19: {
          if (tag !== 157) {
            break;
          }

          message.txpowerhighalarm = reader.float();
          continue;
        }
        case 20: {
          if (tag !== 165) {
            break;
          }

          message.txpowerhighwarning = reader.float();
          continue;
        }
        case 21: {
          if (tag !== 173) {
            break;
          }

          message.txpowerlowalarm = reader.float();
          continue;
        }
        case 22: {
          if (tag !== 181) {
            break;
          }

          message.txpowerlowwarning = reader.float();
          continue;
        }
        case 23: {
          if (tag !== 189) {
            break;
          }

          message.vcchighalarm = reader.float();
          continue;
        }
        case 24: {
          if (tag !== 197) {
            break;
          }

          message.vcchighwarning = reader.float();
          continue;
        }
        case 25: {
          if (tag !== 205) {
            break;
          }

          message.vcclowalarm = reader.float();
          continue;
        }
        case 26: {
          if (tag !== 213) {
            break;
          }

          message.vcclowwarning = reader.float();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QsfpDomThreshold {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      lasertemphighalarm: isSet(object.lasertemphighalarm) ? globalThis.Number(object.lasertemphighalarm) : 0,
      lasertemphighwarning: isSet(object.lasertemphighwarning) ? globalThis.Number(object.lasertemphighwarning) : 0,
      lasertemplowalarm: isSet(object.lasertemplowalarm) ? globalThis.Number(object.lasertemplowalarm) : 0,
      lasertemplowwarning: isSet(object.lasertemplowwarning) ? globalThis.Number(object.lasertemplowwarning) : 0,
      rxpowerhighalarm: isSet(object.rxpowerhighalarm) ? globalThis.Number(object.rxpowerhighalarm) : 0,
      rxpowerhighwarning: isSet(object.rxpowerhighwarning) ? globalThis.Number(object.rxpowerhighwarning) : 0,
      rxpowerlowalarm: isSet(object.rxpowerlowalarm) ? globalThis.Number(object.rxpowerlowalarm) : 0,
      rxpowerlowwarning: isSet(object.rxpowerlowwarning) ? globalThis.Number(object.rxpowerlowwarning) : 0,
      temphighalarm: isSet(object.temphighalarm) ? globalThis.Number(object.temphighalarm) : 0,
      temphighwarning: isSet(object.temphighwarning) ? globalThis.Number(object.temphighwarning) : 0,
      templowalarm: isSet(object.templowalarm) ? globalThis.Number(object.templowalarm) : 0,
      templowwarning: isSet(object.templowwarning) ? globalThis.Number(object.templowwarning) : 0,
      txbiashighalarm: isSet(object.txbiashighalarm) ? globalThis.Number(object.txbiashighalarm) : 0,
      txbiashighwarning: isSet(object.txbiashighwarning) ? globalThis.Number(object.txbiashighwarning) : 0,
      txbiaslowalarm: isSet(object.txbiaslowalarm) ? globalThis.Number(object.txbiaslowalarm) : 0,
      txbiaslowwarning: isSet(object.txbiaslowwarning) ? globalThis.Number(object.txbiaslowwarning) : 0,
      txpowerhighalarm: isSet(object.txpowerhighalarm) ? globalThis.Number(object.txpowerhighalarm) : 0,
      txpowerhighwarning: isSet(object.txpowerhighwarning) ? globalThis.Number(object.txpowerhighwarning) : 0,
      txpowerlowalarm: isSet(object.txpowerlowalarm) ? globalThis.Number(object.txpowerlowalarm) : 0,
      txpowerlowwarning: isSet(object.txpowerlowwarning) ? globalThis.Number(object.txpowerlowwarning) : 0,
      vcchighalarm: isSet(object.vcchighalarm) ? globalThis.Number(object.vcchighalarm) : 0,
      vcchighwarning: isSet(object.vcchighwarning) ? globalThis.Number(object.vcchighwarning) : 0,
      vcclowalarm: isSet(object.vcclowalarm) ? globalThis.Number(object.vcclowalarm) : 0,
      vcclowwarning: isSet(object.vcclowwarning) ? globalThis.Number(object.vcclowwarning) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: QsfpDomThreshold): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.lasertemphighalarm !== 0) {
      obj.lasertemphighalarm = message.lasertemphighalarm;
    }
    if (message.lasertemphighwarning !== 0) {
      obj.lasertemphighwarning = message.lasertemphighwarning;
    }
    if (message.lasertemplowalarm !== 0) {
      obj.lasertemplowalarm = message.lasertemplowalarm;
    }
    if (message.lasertemplowwarning !== 0) {
      obj.lasertemplowwarning = message.lasertemplowwarning;
    }
    if (message.rxpowerhighalarm !== 0) {
      obj.rxpowerhighalarm = message.rxpowerhighalarm;
    }
    if (message.rxpowerhighwarning !== 0) {
      obj.rxpowerhighwarning = message.rxpowerhighwarning;
    }
    if (message.rxpowerlowalarm !== 0) {
      obj.rxpowerlowalarm = message.rxpowerlowalarm;
    }
    if (message.rxpowerlowwarning !== 0) {
      obj.rxpowerlowwarning = message.rxpowerlowwarning;
    }
    if (message.temphighalarm !== 0) {
      obj.temphighalarm = message.temphighalarm;
    }
    if (message.temphighwarning !== 0) {
      obj.temphighwarning = message.temphighwarning;
    }
    if (message.templowalarm !== 0) {
      obj.templowalarm = message.templowalarm;
    }
    if (message.templowwarning !== 0) {
      obj.templowwarning = message.templowwarning;
    }
    if (message.txbiashighalarm !== 0) {
      obj.txbiashighalarm = message.txbiashighalarm;
    }
    if (message.txbiashighwarning !== 0) {
      obj.txbiashighwarning = message.txbiashighwarning;
    }
    if (message.txbiaslowalarm !== 0) {
      obj.txbiaslowalarm = message.txbiaslowalarm;
    }
    if (message.txbiaslowwarning !== 0) {
      obj.txbiaslowwarning = message.txbiaslowwarning;
    }
    if (message.txpowerhighalarm !== 0) {
      obj.txpowerhighalarm = message.txpowerhighalarm;
    }
    if (message.txpowerhighwarning !== 0) {
      obj.txpowerhighwarning = message.txpowerhighwarning;
    }
    if (message.txpowerlowalarm !== 0) {
      obj.txpowerlowalarm = message.txpowerlowalarm;
    }
    if (message.txpowerlowwarning !== 0) {
      obj.txpowerlowwarning = message.txpowerlowwarning;
    }
    if (message.vcchighalarm !== 0) {
      obj.vcchighalarm = message.vcchighalarm;
    }
    if (message.vcchighwarning !== 0) {
      obj.vcchighwarning = message.vcchighwarning;
    }
    if (message.vcclowalarm !== 0) {
      obj.vcclowalarm = message.vcclowalarm;
    }
    if (message.vcclowwarning !== 0) {
      obj.vcclowwarning = message.vcclowwarning;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QsfpDomThreshold>, I>>(base?: I): QsfpDomThreshold {
    return QsfpDomThreshold.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QsfpDomThreshold>, I>>(object: I): QsfpDomThreshold {
    const message = createBaseQsfpDomThreshold();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.lasertemphighalarm = object.lasertemphighalarm ?? 0;
    message.lasertemphighwarning = object.lasertemphighwarning ?? 0;
    message.lasertemplowalarm = object.lasertemplowalarm ?? 0;
    message.lasertemplowwarning = object.lasertemplowwarning ?? 0;
    message.rxpowerhighalarm = object.rxpowerhighalarm ?? 0;
    message.rxpowerhighwarning = object.rxpowerhighwarning ?? 0;
    message.rxpowerlowalarm = object.rxpowerlowalarm ?? 0;
    message.rxpowerlowwarning = object.rxpowerlowwarning ?? 0;
    message.temphighalarm = object.temphighalarm ?? 0;
    message.temphighwarning = object.temphighwarning ?? 0;
    message.templowalarm = object.templowalarm ?? 0;
    message.templowwarning = object.templowwarning ?? 0;
    message.txbiashighalarm = object.txbiashighalarm ?? 0;
    message.txbiashighwarning = object.txbiashighwarning ?? 0;
    message.txbiaslowalarm = object.txbiaslowalarm ?? 0;
    message.txbiaslowwarning = object.txbiaslowwarning ?? 0;
    message.txpowerhighalarm = object.txpowerhighalarm ?? 0;
    message.txpowerhighwarning = object.txpowerhighwarning ?? 0;
    message.txpowerlowalarm = object.txpowerlowalarm ?? 0;
    message.txpowerlowwarning = object.txpowerlowwarning ?? 0;
    message.vcchighalarm = object.vcchighalarm ?? 0;
    message.vcchighwarning = object.vcchighwarning ?? 0;
    message.vcclowalarm = object.vcclowalarm ?? 0;
    message.vcclowwarning = object.vcclowwarning ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseL2Mac(): L2Mac {
  return { id: undefined };
}

export const L2Mac: MessageFns<L2Mac> = {
  encode(message: L2Mac, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): L2Mac {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseL2Mac();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): L2Mac {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: L2Mac): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<L2Mac>, I>>(base?: I): L2Mac {
    return L2Mac.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<L2Mac>, I>>(object: I): L2Mac {
    const message = createBaseL2Mac();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseL3Table(): L3Table {
  return {
    id: undefined,
    macAddress: "",
    ifName: "",
    ipAddress: "",
    familyType: 0,
    vlan: 0,
    vni: 0,
    stale: false,
    collectedAt: undefined,
    learnedFrom: 0,
    status: 0,
    entryDiscoveredAt: undefined,
    internal: false,
    vrfName: "",
  };
}

export const L3Table: MessageFns<L3Table> = {
  encode(message: L3Table, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(34).fork()).join();
    }
    if (message.macAddress !== "") {
      writer.uint32(42).string(message.macAddress);
    }
    if (message.ifName !== "") {
      writer.uint32(50).string(message.ifName);
    }
    if (message.ipAddress !== "") {
      writer.uint32(58).string(message.ipAddress);
    }
    if (message.familyType !== 0) {
      writer.uint32(64).int32(message.familyType);
    }
    if (message.vlan !== 0) {
      writer.uint32(72).uint32(message.vlan);
    }
    if (message.vni !== 0) {
      writer.uint32(80).uint32(message.vni);
    }
    if (message.stale !== false) {
      writer.uint32(88).bool(message.stale);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(98).fork()).join();
    }
    if (message.learnedFrom !== 0) {
      writer.uint32(104).int32(message.learnedFrom);
    }
    if (message.status !== 0) {
      writer.uint32(112).int32(message.status);
    }
    if (message.entryDiscoveredAt !== undefined) {
      Timestamp.encode(toTimestamp(message.entryDiscoveredAt), writer.uint32(122).fork()).join();
    }
    if (message.internal !== false) {
      writer.uint32(128).bool(message.internal);
    }
    if (message.vrfName !== "") {
      writer.uint32(138).string(message.vrfName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): L3Table {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseL3Table();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.macAddress = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ifName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.familyType = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.vlan = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.stale = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.learnedFrom = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.entryDiscoveredAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.internal = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.vrfName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): L3Table {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      macAddress: isSet(object.macAddress) ? globalThis.String(object.macAddress) : "",
      ifName: isSet(object.ifName) ? globalThis.String(object.ifName) : "",
      ipAddress: isSet(object.ipAddress) ? globalThis.String(object.ipAddress) : "",
      familyType: isSet(object.familyType) ? ipFamilyTypeFromJSON(object.familyType) : 0,
      vlan: isSet(object.vlan) ? globalThis.Number(object.vlan) : 0,
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      stale: isSet(object.stale) ? globalThis.Boolean(object.stale) : false,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      learnedFrom: isSet(object.learnedFrom) ? l3TableEntrySourceFromJSON(object.learnedFrom) : 0,
      status: isSet(object.status) ? l3StatusFromJSON(object.status) : 0,
      entryDiscoveredAt: isSet(object.entryDiscoveredAt) ? fromJsonTimestamp(object.entryDiscoveredAt) : undefined,
      internal: isSet(object.internal) ? globalThis.Boolean(object.internal) : false,
      vrfName: isSet(object.vrfName) ? globalThis.String(object.vrfName) : "",
    };
  },

  toJSON(message: L3Table): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.macAddress !== "") {
      obj.macAddress = message.macAddress;
    }
    if (message.ifName !== "") {
      obj.ifName = message.ifName;
    }
    if (message.ipAddress !== "") {
      obj.ipAddress = message.ipAddress;
    }
    if (message.familyType !== 0) {
      obj.familyType = ipFamilyTypeToJSON(message.familyType);
    }
    if (message.vlan !== 0) {
      obj.vlan = Math.round(message.vlan);
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.stale !== false) {
      obj.stale = message.stale;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.learnedFrom !== 0) {
      obj.learnedFrom = l3TableEntrySourceToJSON(message.learnedFrom);
    }
    if (message.status !== 0) {
      obj.status = l3StatusToJSON(message.status);
    }
    if (message.entryDiscoveredAt !== undefined) {
      obj.entryDiscoveredAt = message.entryDiscoveredAt.toISOString();
    }
    if (message.internal !== false) {
      obj.internal = message.internal;
    }
    if (message.vrfName !== "") {
      obj.vrfName = message.vrfName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<L3Table>, I>>(base?: I): L3Table {
    return L3Table.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<L3Table>, I>>(object: I): L3Table {
    const message = createBaseL3Table();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.macAddress = object.macAddress ?? "";
    message.ifName = object.ifName ?? "";
    message.ipAddress = object.ipAddress ?? "";
    message.familyType = object.familyType ?? 0;
    message.vlan = object.vlan ?? 0;
    message.vni = object.vni ?? 0;
    message.stale = object.stale ?? false;
    message.collectedAt = object.collectedAt ?? undefined;
    message.learnedFrom = object.learnedFrom ?? 0;
    message.status = object.status ?? 0;
    message.entryDiscoveredAt = object.entryDiscoveredAt ?? undefined;
    message.internal = object.internal ?? false;
    message.vrfName = object.vrfName ?? "";
    return message;
  },
};

function createBaseIpPrefix(): IpPrefix {
  return { id: undefined };
}

export const IpPrefix: MessageFns<IpPrefix> = {
  encode(message: IpPrefix, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpPrefix {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpPrefix();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpPrefix {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: IpPrefix): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpPrefix>, I>>(base?: I): IpPrefix {
    return IpPrefix.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpPrefix>, I>>(object: I): IpPrefix {
    const message = createBaseIpPrefix();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseVrf(): Vrf {
  return {
    id: undefined,
    collectedAt: undefined,
    sviCount: 0,
    routedInterfaceCount: 0,
    loopbackInterfaceCount: 0,
    subInterfaceCount: 0,
  };
}

export const Vrf: MessageFns<Vrf> = {
  encode(message: Vrf, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(26).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(34).fork()).join();
    }
    if (message.sviCount !== 0) {
      writer.uint32(40).int32(message.sviCount);
    }
    if (message.routedInterfaceCount !== 0) {
      writer.uint32(48).int32(message.routedInterfaceCount);
    }
    if (message.loopbackInterfaceCount !== 0) {
      writer.uint32(56).int32(message.loopbackInterfaceCount);
    }
    if (message.subInterfaceCount !== 0) {
      writer.uint32(64).int32(message.subInterfaceCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Vrf {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVrf();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.sviCount = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.routedInterfaceCount = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.loopbackInterfaceCount = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.subInterfaceCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Vrf {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      sviCount: isSet(object.sviCount) ? globalThis.Number(object.sviCount) : 0,
      routedInterfaceCount: isSet(object.routedInterfaceCount) ? globalThis.Number(object.routedInterfaceCount) : 0,
      loopbackInterfaceCount: isSet(object.loopbackInterfaceCount)
        ? globalThis.Number(object.loopbackInterfaceCount)
        : 0,
      subInterfaceCount: isSet(object.subInterfaceCount) ? globalThis.Number(object.subInterfaceCount) : 0,
    };
  },

  toJSON(message: Vrf): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.sviCount !== 0) {
      obj.sviCount = Math.round(message.sviCount);
    }
    if (message.routedInterfaceCount !== 0) {
      obj.routedInterfaceCount = Math.round(message.routedInterfaceCount);
    }
    if (message.loopbackInterfaceCount !== 0) {
      obj.loopbackInterfaceCount = Math.round(message.loopbackInterfaceCount);
    }
    if (message.subInterfaceCount !== 0) {
      obj.subInterfaceCount = Math.round(message.subInterfaceCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Vrf>, I>>(base?: I): Vrf {
    return Vrf.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Vrf>, I>>(object: I): Vrf {
    const message = createBaseVrf();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    message.sviCount = object.sviCount ?? 0;
    message.routedInterfaceCount = object.routedInterfaceCount ?? 0;
    message.loopbackInterfaceCount = object.loopbackInterfaceCount ?? 0;
    message.subInterfaceCount = object.subInterfaceCount ?? 0;
    return message;
  },
};

function createBaseIpNextHop(): IpNextHop {
  return {
    id: undefined,
    flags: 0,
    fib: false,
    directlyConnected: false,
    ip: "",
    deprecatedAfi: "",
    interfaceIndex: 0,
    interfaceName: "",
    active: false,
    onLink: false,
    weight: 0,
    collectedAt: undefined,
    afi: 0,
    routerMac: "",
    recursive: false,
    blackHole: false,
  };
}

export const IpNextHop: MessageFns<IpNextHop> = {
  encode(message: IpNextHop, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(42).fork()).join();
    }
    if (message.flags !== 0) {
      writer.uint32(48).int32(message.flags);
    }
    if (message.fib !== false) {
      writer.uint32(56).bool(message.fib);
    }
    if (message.directlyConnected !== false) {
      writer.uint32(64).bool(message.directlyConnected);
    }
    if (message.ip !== "") {
      writer.uint32(74).string(message.ip);
    }
    if (message.deprecatedAfi !== "") {
      writer.uint32(82).string(message.deprecatedAfi);
    }
    if (message.interfaceIndex !== 0) {
      writer.uint32(88).int32(message.interfaceIndex);
    }
    if (message.interfaceName !== "") {
      writer.uint32(98).string(message.interfaceName);
    }
    if (message.active !== false) {
      writer.uint32(104).bool(message.active);
    }
    if (message.onLink !== false) {
      writer.uint32(112).bool(message.onLink);
    }
    if (message.weight !== 0) {
      writer.uint32(120).int32(message.weight);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(130).fork()).join();
    }
    if (message.afi !== 0) {
      writer.uint32(136).int32(message.afi);
    }
    if (message.routerMac !== "") {
      writer.uint32(146).string(message.routerMac);
    }
    if (message.recursive !== false) {
      writer.uint32(152).bool(message.recursive);
    }
    if (message.blackHole !== false) {
      writer.uint32(160).bool(message.blackHole);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpNextHop {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpNextHop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.flags = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.fib = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.directlyConnected = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.ip = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.deprecatedAfi = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.interfaceIndex = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.interfaceName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.onLink = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.weight = reader.int32();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.afi = reader.int32() as any;
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.routerMac = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.recursive = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.blackHole = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpNextHop {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      flags: isSet(object.flags) ? globalThis.Number(object.flags) : 0,
      fib: isSet(object.fib) ? globalThis.Boolean(object.fib) : false,
      directlyConnected: isSet(object.directlyConnected) ? globalThis.Boolean(object.directlyConnected) : false,
      ip: isSet(object.ip) ? globalThis.String(object.ip) : "",
      deprecatedAfi: isSet(object.deprecatedAfi) ? globalThis.String(object.deprecatedAfi) : "",
      interfaceIndex: isSet(object.interfaceIndex) ? globalThis.Number(object.interfaceIndex) : 0,
      interfaceName: isSet(object.interfaceName) ? globalThis.String(object.interfaceName) : "",
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      onLink: isSet(object.onLink) ? globalThis.Boolean(object.onLink) : false,
      weight: isSet(object.weight) ? globalThis.Number(object.weight) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      afi: isSet(object.afi) ? ipFamilyTypeFromJSON(object.afi) : 0,
      routerMac: isSet(object.routerMac) ? globalThis.String(object.routerMac) : "",
      recursive: isSet(object.recursive) ? globalThis.Boolean(object.recursive) : false,
      blackHole: isSet(object.blackHole) ? globalThis.Boolean(object.blackHole) : false,
    };
  },

  toJSON(message: IpNextHop): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.flags !== 0) {
      obj.flags = Math.round(message.flags);
    }
    if (message.fib !== false) {
      obj.fib = message.fib;
    }
    if (message.directlyConnected !== false) {
      obj.directlyConnected = message.directlyConnected;
    }
    if (message.ip !== "") {
      obj.ip = message.ip;
    }
    if (message.deprecatedAfi !== "") {
      obj.deprecatedAfi = message.deprecatedAfi;
    }
    if (message.interfaceIndex !== 0) {
      obj.interfaceIndex = Math.round(message.interfaceIndex);
    }
    if (message.interfaceName !== "") {
      obj.interfaceName = message.interfaceName;
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.onLink !== false) {
      obj.onLink = message.onLink;
    }
    if (message.weight !== 0) {
      obj.weight = Math.round(message.weight);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.afi !== 0) {
      obj.afi = ipFamilyTypeToJSON(message.afi);
    }
    if (message.routerMac !== "") {
      obj.routerMac = message.routerMac;
    }
    if (message.recursive !== false) {
      obj.recursive = message.recursive;
    }
    if (message.blackHole !== false) {
      obj.blackHole = message.blackHole;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpNextHop>, I>>(base?: I): IpNextHop {
    return IpNextHop.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpNextHop>, I>>(object: I): IpNextHop {
    const message = createBaseIpNextHop();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.flags = object.flags ?? 0;
    message.fib = object.fib ?? false;
    message.directlyConnected = object.directlyConnected ?? false;
    message.ip = object.ip ?? "";
    message.deprecatedAfi = object.deprecatedAfi ?? "";
    message.interfaceIndex = object.interfaceIndex ?? 0;
    message.interfaceName = object.interfaceName ?? "";
    message.active = object.active ?? false;
    message.onLink = object.onLink ?? false;
    message.weight = object.weight ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.afi = object.afi ?? 0;
    message.routerMac = object.routerMac ?? "";
    message.recursive = object.recursive ?? false;
    message.blackHole = object.blackHole ?? false;
    return message;
  },
};

function createBaseIpRouteTable(): IpRouteTable {
  return {
    id: undefined,
    prefix: "",
    prefixLen: 0,
    deprecatedProtocol: "",
    vrfId: 0,
    vrfName: "",
    selected: false,
    destSelected: false,
    distance: 0,
    metric: 0,
    installed: false,
    offloaded: false,
    table: 0,
    internalStatus: 0,
    internalFlags: 0,
    internalNextHopNum: 0,
    internalNextHopActiveNum: 0,
    nextHopGroupId: 0,
    installedNextHopGroupId: 0,
    uptime: "",
    ipFamily: 0,
    collectedAt: undefined,
    protocol: 0,
    multipleDiffNextHops: false,
    origin: 0,
    peerId: "",
    peerAsnPath: "",
    pathFrom: 0,
    selectionReason: 0,
    weight: 0,
    med: 0,
    nhIp: "",
    nhName: "",
  };
}

export const IpRouteTable: MessageFns<IpRouteTable> = {
  encode(message: IpRouteTable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(34).fork()).join();
    }
    if (message.prefix !== "") {
      writer.uint32(42).string(message.prefix);
    }
    if (message.prefixLen !== 0) {
      writer.uint32(48).uint32(message.prefixLen);
    }
    if (message.deprecatedProtocol !== "") {
      writer.uint32(58).string(message.deprecatedProtocol);
    }
    if (message.vrfId !== 0) {
      writer.uint32(64).uint32(message.vrfId);
    }
    if (message.vrfName !== "") {
      writer.uint32(74).string(message.vrfName);
    }
    if (message.selected !== false) {
      writer.uint32(80).bool(message.selected);
    }
    if (message.destSelected !== false) {
      writer.uint32(88).bool(message.destSelected);
    }
    if (message.distance !== 0) {
      writer.uint32(96).uint32(message.distance);
    }
    if (message.metric !== 0) {
      writer.uint32(104).uint32(message.metric);
    }
    if (message.installed !== false) {
      writer.uint32(112).bool(message.installed);
    }
    if (message.offloaded !== false) {
      writer.uint32(120).bool(message.offloaded);
    }
    if (message.table !== 0) {
      writer.uint32(128).uint32(message.table);
    }
    if (message.internalStatus !== 0) {
      writer.uint32(136).uint32(message.internalStatus);
    }
    if (message.internalFlags !== 0) {
      writer.uint32(144).uint32(message.internalFlags);
    }
    if (message.internalNextHopNum !== 0) {
      writer.uint32(152).uint32(message.internalNextHopNum);
    }
    if (message.internalNextHopActiveNum !== 0) {
      writer.uint32(160).uint32(message.internalNextHopActiveNum);
    }
    if (message.nextHopGroupId !== 0) {
      writer.uint32(168).uint32(message.nextHopGroupId);
    }
    if (message.installedNextHopGroupId !== 0) {
      writer.uint32(176).uint32(message.installedNextHopGroupId);
    }
    if (message.uptime !== "") {
      writer.uint32(186).string(message.uptime);
    }
    if (message.ipFamily !== 0) {
      writer.uint32(192).int32(message.ipFamily);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(202).fork()).join();
    }
    if (message.protocol !== 0) {
      writer.uint32(208).int32(message.protocol);
    }
    if (message.multipleDiffNextHops !== false) {
      writer.uint32(216).bool(message.multipleDiffNextHops);
    }
    if (message.origin !== 0) {
      writer.uint32(224).int32(message.origin);
    }
    if (message.peerId !== "") {
      writer.uint32(234).string(message.peerId);
    }
    if (message.peerAsnPath !== "") {
      writer.uint32(242).string(message.peerAsnPath);
    }
    if (message.pathFrom !== 0) {
      writer.uint32(248).int32(message.pathFrom);
    }
    if (message.selectionReason !== 0) {
      writer.uint32(256).int32(message.selectionReason);
    }
    if (message.weight !== 0) {
      writer.uint32(264).int32(message.weight);
    }
    if (message.med !== 0) {
      writer.uint32(272).int32(message.med);
    }
    if (message.nhIp !== "") {
      writer.uint32(282).string(message.nhIp);
    }
    if (message.nhName !== "") {
      writer.uint32(290).string(message.nhName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpRouteTable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpRouteTable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.prefix = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.prefixLen = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.deprecatedProtocol = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.vrfId = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.vrfName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.selected = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.destSelected = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.distance = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.metric = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.installed = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.offloaded = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.table = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.internalStatus = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.internalFlags = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.internalNextHopNum = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.internalNextHopActiveNum = reader.uint32();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.nextHopGroupId = reader.uint32();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.installedNextHopGroupId = reader.uint32();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.uptime = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.ipFamily = reader.int32() as any;
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.protocol = reader.int32() as any;
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.multipleDiffNextHops = reader.bool();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.origin = reader.int32() as any;
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.peerId = reader.string();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.peerAsnPath = reader.string();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.pathFrom = reader.int32() as any;
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.selectionReason = reader.int32() as any;
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.weight = reader.int32();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.med = reader.int32();
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.nhIp = reader.string();
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.nhName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpRouteTable {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      prefix: isSet(object.prefix) ? globalThis.String(object.prefix) : "",
      prefixLen: isSet(object.prefixLen) ? globalThis.Number(object.prefixLen) : 0,
      deprecatedProtocol: isSet(object.deprecatedProtocol) ? globalThis.String(object.deprecatedProtocol) : "",
      vrfId: isSet(object.vrfId) ? globalThis.Number(object.vrfId) : 0,
      vrfName: isSet(object.vrfName) ? globalThis.String(object.vrfName) : "",
      selected: isSet(object.selected) ? globalThis.Boolean(object.selected) : false,
      destSelected: isSet(object.destSelected) ? globalThis.Boolean(object.destSelected) : false,
      distance: isSet(object.distance) ? globalThis.Number(object.distance) : 0,
      metric: isSet(object.metric) ? globalThis.Number(object.metric) : 0,
      installed: isSet(object.installed) ? globalThis.Boolean(object.installed) : false,
      offloaded: isSet(object.offloaded) ? globalThis.Boolean(object.offloaded) : false,
      table: isSet(object.table) ? globalThis.Number(object.table) : 0,
      internalStatus: isSet(object.internalStatus) ? globalThis.Number(object.internalStatus) : 0,
      internalFlags: isSet(object.internalFlags) ? globalThis.Number(object.internalFlags) : 0,
      internalNextHopNum: isSet(object.internalNextHopNum) ? globalThis.Number(object.internalNextHopNum) : 0,
      internalNextHopActiveNum: isSet(object.internalNextHopActiveNum)
        ? globalThis.Number(object.internalNextHopActiveNum)
        : 0,
      nextHopGroupId: isSet(object.nextHopGroupId) ? globalThis.Number(object.nextHopGroupId) : 0,
      installedNextHopGroupId: isSet(object.installedNextHopGroupId)
        ? globalThis.Number(object.installedNextHopGroupId)
        : 0,
      uptime: isSet(object.uptime) ? globalThis.String(object.uptime) : "",
      ipFamily: isSet(object.ipFamily) ? ipFamilyTypeFromJSON(object.ipFamily) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      protocol: isSet(object.protocol) ? protocolTypeFromJSON(object.protocol) : 0,
      multipleDiffNextHops: isSet(object.multipleDiffNextHops)
        ? globalThis.Boolean(object.multipleDiffNextHops)
        : false,
      origin: isSet(object.origin) ? bgpRouteOriginTypeFromJSON(object.origin) : 0,
      peerId: isSet(object.peerId) ? globalThis.String(object.peerId) : "",
      peerAsnPath: isSet(object.peerAsnPath) ? globalThis.String(object.peerAsnPath) : "",
      pathFrom: isSet(object.pathFrom) ? bgpPathSourceFromJSON(object.pathFrom) : 0,
      selectionReason: isSet(object.selectionReason) ? bgpPathSelectionReasonFromJSON(object.selectionReason) : 0,
      weight: isSet(object.weight) ? globalThis.Number(object.weight) : 0,
      med: isSet(object.med) ? globalThis.Number(object.med) : 0,
      nhIp: isSet(object.nhIp) ? globalThis.String(object.nhIp) : "",
      nhName: isSet(object.nhName) ? globalThis.String(object.nhName) : "",
    };
  },

  toJSON(message: IpRouteTable): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.prefix !== "") {
      obj.prefix = message.prefix;
    }
    if (message.prefixLen !== 0) {
      obj.prefixLen = Math.round(message.prefixLen);
    }
    if (message.deprecatedProtocol !== "") {
      obj.deprecatedProtocol = message.deprecatedProtocol;
    }
    if (message.vrfId !== 0) {
      obj.vrfId = Math.round(message.vrfId);
    }
    if (message.vrfName !== "") {
      obj.vrfName = message.vrfName;
    }
    if (message.selected !== false) {
      obj.selected = message.selected;
    }
    if (message.destSelected !== false) {
      obj.destSelected = message.destSelected;
    }
    if (message.distance !== 0) {
      obj.distance = Math.round(message.distance);
    }
    if (message.metric !== 0) {
      obj.metric = Math.round(message.metric);
    }
    if (message.installed !== false) {
      obj.installed = message.installed;
    }
    if (message.offloaded !== false) {
      obj.offloaded = message.offloaded;
    }
    if (message.table !== 0) {
      obj.table = Math.round(message.table);
    }
    if (message.internalStatus !== 0) {
      obj.internalStatus = Math.round(message.internalStatus);
    }
    if (message.internalFlags !== 0) {
      obj.internalFlags = Math.round(message.internalFlags);
    }
    if (message.internalNextHopNum !== 0) {
      obj.internalNextHopNum = Math.round(message.internalNextHopNum);
    }
    if (message.internalNextHopActiveNum !== 0) {
      obj.internalNextHopActiveNum = Math.round(message.internalNextHopActiveNum);
    }
    if (message.nextHopGroupId !== 0) {
      obj.nextHopGroupId = Math.round(message.nextHopGroupId);
    }
    if (message.installedNextHopGroupId !== 0) {
      obj.installedNextHopGroupId = Math.round(message.installedNextHopGroupId);
    }
    if (message.uptime !== "") {
      obj.uptime = message.uptime;
    }
    if (message.ipFamily !== 0) {
      obj.ipFamily = ipFamilyTypeToJSON(message.ipFamily);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.protocol !== 0) {
      obj.protocol = protocolTypeToJSON(message.protocol);
    }
    if (message.multipleDiffNextHops !== false) {
      obj.multipleDiffNextHops = message.multipleDiffNextHops;
    }
    if (message.origin !== 0) {
      obj.origin = bgpRouteOriginTypeToJSON(message.origin);
    }
    if (message.peerId !== "") {
      obj.peerId = message.peerId;
    }
    if (message.peerAsnPath !== "") {
      obj.peerAsnPath = message.peerAsnPath;
    }
    if (message.pathFrom !== 0) {
      obj.pathFrom = bgpPathSourceToJSON(message.pathFrom);
    }
    if (message.selectionReason !== 0) {
      obj.selectionReason = bgpPathSelectionReasonToJSON(message.selectionReason);
    }
    if (message.weight !== 0) {
      obj.weight = Math.round(message.weight);
    }
    if (message.med !== 0) {
      obj.med = Math.round(message.med);
    }
    if (message.nhIp !== "") {
      obj.nhIp = message.nhIp;
    }
    if (message.nhName !== "") {
      obj.nhName = message.nhName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpRouteTable>, I>>(base?: I): IpRouteTable {
    return IpRouteTable.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpRouteTable>, I>>(object: I): IpRouteTable {
    const message = createBaseIpRouteTable();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.prefix = object.prefix ?? "";
    message.prefixLen = object.prefixLen ?? 0;
    message.deprecatedProtocol = object.deprecatedProtocol ?? "";
    message.vrfId = object.vrfId ?? 0;
    message.vrfName = object.vrfName ?? "";
    message.selected = object.selected ?? false;
    message.destSelected = object.destSelected ?? false;
    message.distance = object.distance ?? 0;
    message.metric = object.metric ?? 0;
    message.installed = object.installed ?? false;
    message.offloaded = object.offloaded ?? false;
    message.table = object.table ?? 0;
    message.internalStatus = object.internalStatus ?? 0;
    message.internalFlags = object.internalFlags ?? 0;
    message.internalNextHopNum = object.internalNextHopNum ?? 0;
    message.internalNextHopActiveNum = object.internalNextHopActiveNum ?? 0;
    message.nextHopGroupId = object.nextHopGroupId ?? 0;
    message.installedNextHopGroupId = object.installedNextHopGroupId ?? 0;
    message.uptime = object.uptime ?? "";
    message.ipFamily = object.ipFamily ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.protocol = object.protocol ?? 0;
    message.multipleDiffNextHops = object.multipleDiffNextHops ?? false;
    message.origin = object.origin ?? 0;
    message.peerId = object.peerId ?? "";
    message.peerAsnPath = object.peerAsnPath ?? "";
    message.pathFrom = object.pathFrom ?? 0;
    message.selectionReason = object.selectionReason ?? 0;
    message.weight = object.weight ?? 0;
    message.med = object.med ?? 0;
    message.nhIp = object.nhIp ?? "";
    message.nhName = object.nhName ?? "";
    return message;
  },
};

function createBaseVlanVniMap(): VlanVniMap {
  return { id: undefined, vni: 0, vlan: 0, collectedAt: undefined };
}

export const VlanVniMap: MessageFns<VlanVniMap> = {
  encode(message: VlanVniMap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.vni !== 0) {
      writer.uint32(24).uint32(message.vni);
    }
    if (message.vlan !== 0) {
      writer.uint32(32).uint32(message.vlan);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VlanVniMap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVlanVniMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.vlan = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VlanVniMap {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      vlan: isSet(object.vlan) ? globalThis.Number(object.vlan) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: VlanVniMap): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.vlan !== 0) {
      obj.vlan = Math.round(message.vlan);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VlanVniMap>, I>>(base?: I): VlanVniMap {
    return VlanVniMap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VlanVniMap>, I>>(object: I): VlanVniMap {
    const message = createBaseVlanVniMap();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vni = object.vni ?? 0;
    message.vlan = object.vlan ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseNetworkInterfaceSummary(): NetworkInterfaceSummary {
  return {
    id: undefined,
    vlanId: 0,
    vni: 0,
    vrfName: "",
    ipAddress: "",
    interfaceName: "",
    collectedAt: undefined,
    interfaceType: 0,
  };
}

export const NetworkInterfaceSummary: MessageFns<NetworkInterfaceSummary> = {
  encode(message: NetworkInterfaceSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.vlanId !== 0) {
      writer.uint32(24).uint32(message.vlanId);
    }
    if (message.vni !== 0) {
      writer.uint32(32).uint32(message.vni);
    }
    if (message.vrfName !== "") {
      writer.uint32(42).string(message.vrfName);
    }
    if (message.ipAddress !== "") {
      writer.uint32(50).string(message.ipAddress);
    }
    if (message.interfaceName !== "") {
      writer.uint32(58).string(message.interfaceName);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(66).fork()).join();
    }
    if (message.interfaceType !== 0) {
      writer.uint32(72).int32(message.interfaceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NetworkInterfaceSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNetworkInterfaceSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.vrfName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.interfaceName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.interfaceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NetworkInterfaceSummary {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      vrfName: isSet(object.vrfName) ? globalThis.String(object.vrfName) : "",
      ipAddress: isSet(object.ipAddress) ? globalThis.String(object.ipAddress) : "",
      interfaceName: isSet(object.interfaceName) ? globalThis.String(object.interfaceName) : "",
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      interfaceType: isSet(object.interfaceType) ? networkInterfaceTypeFromJSON(object.interfaceType) : 0,
    };
  },

  toJSON(message: NetworkInterfaceSummary): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.vrfName !== "") {
      obj.vrfName = message.vrfName;
    }
    if (message.ipAddress !== "") {
      obj.ipAddress = message.ipAddress;
    }
    if (message.interfaceName !== "") {
      obj.interfaceName = message.interfaceName;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.interfaceType !== 0) {
      obj.interfaceType = networkInterfaceTypeToJSON(message.interfaceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NetworkInterfaceSummary>, I>>(base?: I): NetworkInterfaceSummary {
    return NetworkInterfaceSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NetworkInterfaceSummary>, I>>(object: I): NetworkInterfaceSummary {
    const message = createBaseNetworkInterfaceSummary();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vlanId = object.vlanId ?? 0;
    message.vni = object.vni ?? 0;
    message.vrfName = object.vrfName ?? "";
    message.ipAddress = object.ipAddress ?? "";
    message.interfaceName = object.interfaceName ?? "";
    message.collectedAt = object.collectedAt ?? undefined;
    message.interfaceType = object.interfaceType ?? 0;
    return message;
  },
};

function createBaseManagementConfig(): ManagementConfig {
  return {
    id: undefined,
    sonic: undefined,
    proxy: undefined,
    dns: undefined,
    drake: undefined,
    ntpServers: [],
    configSource: "",
    ipv4Method: "",
    ipv6Method: "",
  };
}

export const ManagementConfig: MessageFns<ManagementConfig> = {
  encode(message: ManagementConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.sonic !== undefined) {
      SonicConfig.encode(message.sonic, writer.uint32(26).fork()).join();
    }
    if (message.proxy !== undefined) {
      ProxyConfig.encode(message.proxy, writer.uint32(34).fork()).join();
    }
    if (message.dns !== undefined) {
      DnsConfig.encode(message.dns, writer.uint32(42).fork()).join();
    }
    if (message.drake !== undefined) {
      DrakeConfig.encode(message.drake, writer.uint32(50).fork()).join();
    }
    for (const v of message.ntpServers) {
      writer.uint32(58).string(v!);
    }
    if (message.configSource !== "") {
      writer.uint32(66).string(message.configSource);
    }
    if (message.ipv4Method !== "") {
      writer.uint32(74).string(message.ipv4Method);
    }
    if (message.ipv6Method !== "") {
      writer.uint32(82).string(message.ipv6Method);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManagementConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManagementConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sonic = SonicConfig.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.proxy = ProxyConfig.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.dns = DnsConfig.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.drake = DrakeConfig.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ntpServers.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.configSource = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.ipv4Method = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ipv6Method = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManagementConfig {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      sonic: isSet(object.sonic) ? SonicConfig.fromJSON(object.sonic) : undefined,
      proxy: isSet(object.proxy) ? ProxyConfig.fromJSON(object.proxy) : undefined,
      dns: isSet(object.dns) ? DnsConfig.fromJSON(object.dns) : undefined,
      drake: isSet(object.drake) ? DrakeConfig.fromJSON(object.drake) : undefined,
      ntpServers: globalThis.Array.isArray(object?.ntpServers)
        ? object.ntpServers.map((e: any) => globalThis.String(e))
        : [],
      configSource: isSet(object.configSource) ? globalThis.String(object.configSource) : "",
      ipv4Method: isSet(object.ipv4Method) ? globalThis.String(object.ipv4Method) : "",
      ipv6Method: isSet(object.ipv6Method) ? globalThis.String(object.ipv6Method) : "",
    };
  },

  toJSON(message: ManagementConfig): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.sonic !== undefined) {
      obj.sonic = SonicConfig.toJSON(message.sonic);
    }
    if (message.proxy !== undefined) {
      obj.proxy = ProxyConfig.toJSON(message.proxy);
    }
    if (message.dns !== undefined) {
      obj.dns = DnsConfig.toJSON(message.dns);
    }
    if (message.drake !== undefined) {
      obj.drake = DrakeConfig.toJSON(message.drake);
    }
    if (message.ntpServers?.length) {
      obj.ntpServers = message.ntpServers;
    }
    if (message.configSource !== "") {
      obj.configSource = message.configSource;
    }
    if (message.ipv4Method !== "") {
      obj.ipv4Method = message.ipv4Method;
    }
    if (message.ipv6Method !== "") {
      obj.ipv6Method = message.ipv6Method;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManagementConfig>, I>>(base?: I): ManagementConfig {
    return ManagementConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManagementConfig>, I>>(object: I): ManagementConfig {
    const message = createBaseManagementConfig();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.sonic = (object.sonic !== undefined && object.sonic !== null)
      ? SonicConfig.fromPartial(object.sonic)
      : undefined;
    message.proxy = (object.proxy !== undefined && object.proxy !== null)
      ? ProxyConfig.fromPartial(object.proxy)
      : undefined;
    message.dns = (object.dns !== undefined && object.dns !== null) ? DnsConfig.fromPartial(object.dns) : undefined;
    message.drake = (object.drake !== undefined && object.drake !== null)
      ? DrakeConfig.fromPartial(object.drake)
      : undefined;
    message.ntpServers = object.ntpServers?.map((e) => e) || [];
    message.configSource = object.configSource ?? "";
    message.ipv4Method = object.ipv4Method ?? "";
    message.ipv6Method = object.ipv6Method ?? "";
    return message;
  },
};

function createBaseManagementState(): ManagementState {
  return {
    id: undefined,
    sonic: undefined,
    proxy: undefined,
    dns: undefined,
    drake: undefined,
    ntpServers: [],
    configSource: "",
    ipv4Method: "",
    ipv6Method: "",
    operationStatus: 0,
    collectedAt: undefined,
    secondaryIpv4Addr: "",
    secondaryIpv4Method: "",
    ifNameAlias: "",
  };
}

export const ManagementState: MessageFns<ManagementState> = {
  encode(message: ManagementState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.sonic !== undefined) {
      SonicConfig.encode(message.sonic, writer.uint32(26).fork()).join();
    }
    if (message.proxy !== undefined) {
      ProxyConfig.encode(message.proxy, writer.uint32(34).fork()).join();
    }
    if (message.dns !== undefined) {
      DnsConfig.encode(message.dns, writer.uint32(42).fork()).join();
    }
    if (message.drake !== undefined) {
      DrakeConfig.encode(message.drake, writer.uint32(50).fork()).join();
    }
    for (const v of message.ntpServers) {
      writer.uint32(58).string(v!);
    }
    if (message.configSource !== "") {
      writer.uint32(66).string(message.configSource);
    }
    if (message.ipv4Method !== "") {
      writer.uint32(74).string(message.ipv4Method);
    }
    if (message.ipv6Method !== "") {
      writer.uint32(82).string(message.ipv6Method);
    }
    if (message.operationStatus !== 0) {
      writer.uint32(88).int32(message.operationStatus);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(98).fork()).join();
    }
    if (message.secondaryIpv4Addr !== "") {
      writer.uint32(106).string(message.secondaryIpv4Addr);
    }
    if (message.secondaryIpv4Method !== "") {
      writer.uint32(114).string(message.secondaryIpv4Method);
    }
    if (message.ifNameAlias !== "") {
      writer.uint32(122).string(message.ifNameAlias);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManagementState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManagementState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sonic = SonicConfig.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.proxy = ProxyConfig.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.dns = DnsConfig.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.drake = DrakeConfig.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ntpServers.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.configSource = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.ipv4Method = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ipv6Method = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.operationStatus = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.secondaryIpv4Addr = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.secondaryIpv4Method = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.ifNameAlias = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManagementState {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      sonic: isSet(object.sonic) ? SonicConfig.fromJSON(object.sonic) : undefined,
      proxy: isSet(object.proxy) ? ProxyConfig.fromJSON(object.proxy) : undefined,
      dns: isSet(object.dns) ? DnsConfig.fromJSON(object.dns) : undefined,
      drake: isSet(object.drake) ? DrakeConfig.fromJSON(object.drake) : undefined,
      ntpServers: globalThis.Array.isArray(object?.ntpServers)
        ? object.ntpServers.map((e: any) => globalThis.String(e))
        : [],
      configSource: isSet(object.configSource) ? globalThis.String(object.configSource) : "",
      ipv4Method: isSet(object.ipv4Method) ? globalThis.String(object.ipv4Method) : "",
      ipv6Method: isSet(object.ipv6Method) ? globalThis.String(object.ipv6Method) : "",
      operationStatus: isSet(object.operationStatus) ? operationStatusFromJSON(object.operationStatus) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      secondaryIpv4Addr: isSet(object.secondaryIpv4Addr) ? globalThis.String(object.secondaryIpv4Addr) : "",
      secondaryIpv4Method: isSet(object.secondaryIpv4Method) ? globalThis.String(object.secondaryIpv4Method) : "",
      ifNameAlias: isSet(object.ifNameAlias) ? globalThis.String(object.ifNameAlias) : "",
    };
  },

  toJSON(message: ManagementState): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.sonic !== undefined) {
      obj.sonic = SonicConfig.toJSON(message.sonic);
    }
    if (message.proxy !== undefined) {
      obj.proxy = ProxyConfig.toJSON(message.proxy);
    }
    if (message.dns !== undefined) {
      obj.dns = DnsConfig.toJSON(message.dns);
    }
    if (message.drake !== undefined) {
      obj.drake = DrakeConfig.toJSON(message.drake);
    }
    if (message.ntpServers?.length) {
      obj.ntpServers = message.ntpServers;
    }
    if (message.configSource !== "") {
      obj.configSource = message.configSource;
    }
    if (message.ipv4Method !== "") {
      obj.ipv4Method = message.ipv4Method;
    }
    if (message.ipv6Method !== "") {
      obj.ipv6Method = message.ipv6Method;
    }
    if (message.operationStatus !== 0) {
      obj.operationStatus = operationStatusToJSON(message.operationStatus);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.secondaryIpv4Addr !== "") {
      obj.secondaryIpv4Addr = message.secondaryIpv4Addr;
    }
    if (message.secondaryIpv4Method !== "") {
      obj.secondaryIpv4Method = message.secondaryIpv4Method;
    }
    if (message.ifNameAlias !== "") {
      obj.ifNameAlias = message.ifNameAlias;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManagementState>, I>>(base?: I): ManagementState {
    return ManagementState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManagementState>, I>>(object: I): ManagementState {
    const message = createBaseManagementState();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.sonic = (object.sonic !== undefined && object.sonic !== null)
      ? SonicConfig.fromPartial(object.sonic)
      : undefined;
    message.proxy = (object.proxy !== undefined && object.proxy !== null)
      ? ProxyConfig.fromPartial(object.proxy)
      : undefined;
    message.dns = (object.dns !== undefined && object.dns !== null) ? DnsConfig.fromPartial(object.dns) : undefined;
    message.drake = (object.drake !== undefined && object.drake !== null)
      ? DrakeConfig.fromPartial(object.drake)
      : undefined;
    message.ntpServers = object.ntpServers?.map((e) => e) || [];
    message.configSource = object.configSource ?? "";
    message.ipv4Method = object.ipv4Method ?? "";
    message.ipv6Method = object.ipv6Method ?? "";
    message.operationStatus = object.operationStatus ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.secondaryIpv4Addr = object.secondaryIpv4Addr ?? "";
    message.secondaryIpv4Method = object.secondaryIpv4Method ?? "";
    message.ifNameAlias = object.ifNameAlias ?? "";
    return message;
  },
};

function createBaseBgpNeighborFamily(): BgpNeighborFamily {
  return { id: undefined };
}

export const BgpNeighborFamily: MessageFns<BgpNeighborFamily> = {
  encode(message: BgpNeighborFamily, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborFamily {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborFamily();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborFamily {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: BgpNeighborFamily): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborFamily>, I>>(base?: I): BgpNeighborFamily {
    return BgpNeighborFamily.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborFamily>, I>>(object: I): BgpNeighborFamily {
    const message = createBaseBgpNeighborFamily();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseBgpNeighborSummary(): BgpNeighborSummary {
  return {
    id: undefined,
    routerId: "",
    as: 0,
    vrfId: 0,
    vrfName: "",
    tableVersion: 0,
    ribCount: 0,
    ribMemory: 0,
    peerCount: 0,
    peerMemory: 0,
    peerGroupCount: 0,
    peerGroupMemory: 0,
    peerName: "",
    peerHostname: "",
    peerRemoteAs: 0,
    peerLocalAs: 0,
    peerTableVersion: 0,
    peerMsgRcvd: 0,
    peerMsgSent: 0,
    peerOutQ: 0,
    peerInQ: 0,
    peerUptime: "",
    peerUptimeMsec: "0",
    peerUptimeEstablishedEpoch: "0",
    peerPfxRcd: 0,
    peerPfxSnt: 0,
    peerConnectionState: 0,
    peerState: 0,
    peerConnectionsEstablished: 0,
    peerConnectionsDropped: 0,
    peerIdType: 0,
    failedPeers: 0,
    displayedPeers: 0,
    totalPeers: 0,
    dynamicPeers: 0,
    addressFamily: 0,
    multiPathRelax: false,
    peerVersion: 0,
    collectedAt: undefined,
    updateRecord: false,
    peerIsDynamic: false,
    holdTimerRemainingMs: 0,
    receivedRoutesCount: 0,
    advertisedRoutesCount: 0,
  };
}

export const BgpNeighborSummary: MessageFns<BgpNeighborSummary> = {
  encode(message: BgpNeighborSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.routerId !== "") {
      writer.uint32(26).string(message.routerId);
    }
    if (message.as !== 0) {
      writer.uint32(32).uint32(message.as);
    }
    if (message.vrfId !== 0) {
      writer.uint32(40).uint32(message.vrfId);
    }
    if (message.vrfName !== "") {
      writer.uint32(50).string(message.vrfName);
    }
    if (message.tableVersion !== 0) {
      writer.uint32(56).uint32(message.tableVersion);
    }
    if (message.ribCount !== 0) {
      writer.uint32(64).uint32(message.ribCount);
    }
    if (message.ribMemory !== 0) {
      writer.uint32(72).uint32(message.ribMemory);
    }
    if (message.peerCount !== 0) {
      writer.uint32(80).uint32(message.peerCount);
    }
    if (message.peerMemory !== 0) {
      writer.uint32(88).uint32(message.peerMemory);
    }
    if (message.peerGroupCount !== 0) {
      writer.uint32(96).uint32(message.peerGroupCount);
    }
    if (message.peerGroupMemory !== 0) {
      writer.uint32(104).uint32(message.peerGroupMemory);
    }
    if (message.peerName !== "") {
      writer.uint32(114).string(message.peerName);
    }
    if (message.peerHostname !== "") {
      writer.uint32(122).string(message.peerHostname);
    }
    if (message.peerRemoteAs !== 0) {
      writer.uint32(128).uint32(message.peerRemoteAs);
    }
    if (message.peerLocalAs !== 0) {
      writer.uint32(136).uint32(message.peerLocalAs);
    }
    if (message.peerTableVersion !== 0) {
      writer.uint32(144).uint32(message.peerTableVersion);
    }
    if (message.peerMsgRcvd !== 0) {
      writer.uint32(152).uint32(message.peerMsgRcvd);
    }
    if (message.peerMsgSent !== 0) {
      writer.uint32(160).uint32(message.peerMsgSent);
    }
    if (message.peerOutQ !== 0) {
      writer.uint32(168).uint32(message.peerOutQ);
    }
    if (message.peerInQ !== 0) {
      writer.uint32(176).uint32(message.peerInQ);
    }
    if (message.peerUptime !== "") {
      writer.uint32(186).string(message.peerUptime);
    }
    if (message.peerUptimeMsec !== "0") {
      writer.uint32(192).uint64(message.peerUptimeMsec);
    }
    if (message.peerUptimeEstablishedEpoch !== "0") {
      writer.uint32(200).uint64(message.peerUptimeEstablishedEpoch);
    }
    if (message.peerPfxRcd !== 0) {
      writer.uint32(208).uint32(message.peerPfxRcd);
    }
    if (message.peerPfxSnt !== 0) {
      writer.uint32(216).uint32(message.peerPfxSnt);
    }
    if (message.peerConnectionState !== 0) {
      writer.uint32(224).int32(message.peerConnectionState);
    }
    if (message.peerState !== 0) {
      writer.uint32(232).int32(message.peerState);
    }
    if (message.peerConnectionsEstablished !== 0) {
      writer.uint32(240).uint32(message.peerConnectionsEstablished);
    }
    if (message.peerConnectionsDropped !== 0) {
      writer.uint32(248).uint32(message.peerConnectionsDropped);
    }
    if (message.peerIdType !== 0) {
      writer.uint32(256).int32(message.peerIdType);
    }
    if (message.failedPeers !== 0) {
      writer.uint32(264).uint32(message.failedPeers);
    }
    if (message.displayedPeers !== 0) {
      writer.uint32(272).uint32(message.displayedPeers);
    }
    if (message.totalPeers !== 0) {
      writer.uint32(280).uint32(message.totalPeers);
    }
    if (message.dynamicPeers !== 0) {
      writer.uint32(288).uint32(message.dynamicPeers);
    }
    if (message.addressFamily !== 0) {
      writer.uint32(296).int32(message.addressFamily);
    }
    if (message.multiPathRelax !== false) {
      writer.uint32(304).bool(message.multiPathRelax);
    }
    if (message.peerVersion !== 0) {
      writer.uint32(312).uint32(message.peerVersion);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(322).fork()).join();
    }
    if (message.updateRecord !== false) {
      writer.uint32(328).bool(message.updateRecord);
    }
    if (message.peerIsDynamic !== false) {
      writer.uint32(336).bool(message.peerIsDynamic);
    }
    if (message.holdTimerRemainingMs !== 0) {
      writer.uint32(344).uint32(message.holdTimerRemainingMs);
    }
    if (message.receivedRoutesCount !== 0) {
      writer.uint32(352).uint32(message.receivedRoutesCount);
    }
    if (message.advertisedRoutesCount !== 0) {
      writer.uint32(360).uint32(message.advertisedRoutesCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.routerId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.as = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.vrfId = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.vrfName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.tableVersion = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.ribCount = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.ribMemory = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.peerCount = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.peerMemory = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.peerGroupCount = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.peerGroupMemory = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.peerName = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.peerHostname = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.peerRemoteAs = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.peerLocalAs = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.peerTableVersion = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.peerMsgRcvd = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.peerMsgSent = reader.uint32();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.peerOutQ = reader.uint32();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.peerInQ = reader.uint32();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.peerUptime = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.peerUptimeMsec = reader.uint64().toString();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.peerUptimeEstablishedEpoch = reader.uint64().toString();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.peerPfxRcd = reader.uint32();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.peerPfxSnt = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.peerConnectionState = reader.int32() as any;
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.peerState = reader.int32() as any;
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.peerConnectionsEstablished = reader.uint32();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.peerConnectionsDropped = reader.uint32();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.peerIdType = reader.int32() as any;
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.failedPeers = reader.uint32();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.displayedPeers = reader.uint32();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.totalPeers = reader.uint32();
          continue;
        }
        case 36: {
          if (tag !== 288) {
            break;
          }

          message.dynamicPeers = reader.uint32();
          continue;
        }
        case 37: {
          if (tag !== 296) {
            break;
          }

          message.addressFamily = reader.int32() as any;
          continue;
        }
        case 38: {
          if (tag !== 304) {
            break;
          }

          message.multiPathRelax = reader.bool();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.peerVersion = reader.uint32();
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 41: {
          if (tag !== 328) {
            break;
          }

          message.updateRecord = reader.bool();
          continue;
        }
        case 42: {
          if (tag !== 336) {
            break;
          }

          message.peerIsDynamic = reader.bool();
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.holdTimerRemainingMs = reader.uint32();
          continue;
        }
        case 44: {
          if (tag !== 352) {
            break;
          }

          message.receivedRoutesCount = reader.uint32();
          continue;
        }
        case 45: {
          if (tag !== 360) {
            break;
          }

          message.advertisedRoutesCount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborSummary {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      routerId: isSet(object.routerId) ? globalThis.String(object.routerId) : "",
      as: isSet(object.as) ? globalThis.Number(object.as) : 0,
      vrfId: isSet(object.vrfId) ? globalThis.Number(object.vrfId) : 0,
      vrfName: isSet(object.vrfName) ? globalThis.String(object.vrfName) : "",
      tableVersion: isSet(object.tableVersion) ? globalThis.Number(object.tableVersion) : 0,
      ribCount: isSet(object.ribCount) ? globalThis.Number(object.ribCount) : 0,
      ribMemory: isSet(object.ribMemory) ? globalThis.Number(object.ribMemory) : 0,
      peerCount: isSet(object.peerCount) ? globalThis.Number(object.peerCount) : 0,
      peerMemory: isSet(object.peerMemory) ? globalThis.Number(object.peerMemory) : 0,
      peerGroupCount: isSet(object.peerGroupCount) ? globalThis.Number(object.peerGroupCount) : 0,
      peerGroupMemory: isSet(object.peerGroupMemory) ? globalThis.Number(object.peerGroupMemory) : 0,
      peerName: isSet(object.peerName) ? globalThis.String(object.peerName) : "",
      peerHostname: isSet(object.peerHostname) ? globalThis.String(object.peerHostname) : "",
      peerRemoteAs: isSet(object.peerRemoteAs) ? globalThis.Number(object.peerRemoteAs) : 0,
      peerLocalAs: isSet(object.peerLocalAs) ? globalThis.Number(object.peerLocalAs) : 0,
      peerTableVersion: isSet(object.peerTableVersion) ? globalThis.Number(object.peerTableVersion) : 0,
      peerMsgRcvd: isSet(object.peerMsgRcvd) ? globalThis.Number(object.peerMsgRcvd) : 0,
      peerMsgSent: isSet(object.peerMsgSent) ? globalThis.Number(object.peerMsgSent) : 0,
      peerOutQ: isSet(object.peerOutQ) ? globalThis.Number(object.peerOutQ) : 0,
      peerInQ: isSet(object.peerInQ) ? globalThis.Number(object.peerInQ) : 0,
      peerUptime: isSet(object.peerUptime) ? globalThis.String(object.peerUptime) : "",
      peerUptimeMsec: isSet(object.peerUptimeMsec) ? globalThis.String(object.peerUptimeMsec) : "0",
      peerUptimeEstablishedEpoch: isSet(object.peerUptimeEstablishedEpoch)
        ? globalThis.String(object.peerUptimeEstablishedEpoch)
        : "0",
      peerPfxRcd: isSet(object.peerPfxRcd) ? globalThis.Number(object.peerPfxRcd) : 0,
      peerPfxSnt: isSet(object.peerPfxSnt) ? globalThis.Number(object.peerPfxSnt) : 0,
      peerConnectionState: isSet(object.peerConnectionState)
        ? bgpPeerConnectionStateFromJSON(object.peerConnectionState)
        : 0,
      peerState: isSet(object.peerState) ? bgpPeerStateFromJSON(object.peerState) : 0,
      peerConnectionsEstablished: isSet(object.peerConnectionsEstablished)
        ? globalThis.Number(object.peerConnectionsEstablished)
        : 0,
      peerConnectionsDropped: isSet(object.peerConnectionsDropped)
        ? globalThis.Number(object.peerConnectionsDropped)
        : 0,
      peerIdType: isSet(object.peerIdType) ? bgpIdTypeFromJSON(object.peerIdType) : 0,
      failedPeers: isSet(object.failedPeers) ? globalThis.Number(object.failedPeers) : 0,
      displayedPeers: isSet(object.displayedPeers) ? globalThis.Number(object.displayedPeers) : 0,
      totalPeers: isSet(object.totalPeers) ? globalThis.Number(object.totalPeers) : 0,
      dynamicPeers: isSet(object.dynamicPeers) ? globalThis.Number(object.dynamicPeers) : 0,
      addressFamily: isSet(object.addressFamily) ? bgpAddressFamilyFromJSON(object.addressFamily) : 0,
      multiPathRelax: isSet(object.multiPathRelax) ? globalThis.Boolean(object.multiPathRelax) : false,
      peerVersion: isSet(object.peerVersion) ? globalThis.Number(object.peerVersion) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      updateRecord: isSet(object.updateRecord) ? globalThis.Boolean(object.updateRecord) : false,
      peerIsDynamic: isSet(object.peerIsDynamic) ? globalThis.Boolean(object.peerIsDynamic) : false,
      holdTimerRemainingMs: isSet(object.holdTimerRemainingMs) ? globalThis.Number(object.holdTimerRemainingMs) : 0,
      receivedRoutesCount: isSet(object.receivedRoutesCount) ? globalThis.Number(object.receivedRoutesCount) : 0,
      advertisedRoutesCount: isSet(object.advertisedRoutesCount) ? globalThis.Number(object.advertisedRoutesCount) : 0,
    };
  },

  toJSON(message: BgpNeighborSummary): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.routerId !== "") {
      obj.routerId = message.routerId;
    }
    if (message.as !== 0) {
      obj.as = Math.round(message.as);
    }
    if (message.vrfId !== 0) {
      obj.vrfId = Math.round(message.vrfId);
    }
    if (message.vrfName !== "") {
      obj.vrfName = message.vrfName;
    }
    if (message.tableVersion !== 0) {
      obj.tableVersion = Math.round(message.tableVersion);
    }
    if (message.ribCount !== 0) {
      obj.ribCount = Math.round(message.ribCount);
    }
    if (message.ribMemory !== 0) {
      obj.ribMemory = Math.round(message.ribMemory);
    }
    if (message.peerCount !== 0) {
      obj.peerCount = Math.round(message.peerCount);
    }
    if (message.peerMemory !== 0) {
      obj.peerMemory = Math.round(message.peerMemory);
    }
    if (message.peerGroupCount !== 0) {
      obj.peerGroupCount = Math.round(message.peerGroupCount);
    }
    if (message.peerGroupMemory !== 0) {
      obj.peerGroupMemory = Math.round(message.peerGroupMemory);
    }
    if (message.peerName !== "") {
      obj.peerName = message.peerName;
    }
    if (message.peerHostname !== "") {
      obj.peerHostname = message.peerHostname;
    }
    if (message.peerRemoteAs !== 0) {
      obj.peerRemoteAs = Math.round(message.peerRemoteAs);
    }
    if (message.peerLocalAs !== 0) {
      obj.peerLocalAs = Math.round(message.peerLocalAs);
    }
    if (message.peerTableVersion !== 0) {
      obj.peerTableVersion = Math.round(message.peerTableVersion);
    }
    if (message.peerMsgRcvd !== 0) {
      obj.peerMsgRcvd = Math.round(message.peerMsgRcvd);
    }
    if (message.peerMsgSent !== 0) {
      obj.peerMsgSent = Math.round(message.peerMsgSent);
    }
    if (message.peerOutQ !== 0) {
      obj.peerOutQ = Math.round(message.peerOutQ);
    }
    if (message.peerInQ !== 0) {
      obj.peerInQ = Math.round(message.peerInQ);
    }
    if (message.peerUptime !== "") {
      obj.peerUptime = message.peerUptime;
    }
    if (message.peerUptimeMsec !== "0") {
      obj.peerUptimeMsec = message.peerUptimeMsec;
    }
    if (message.peerUptimeEstablishedEpoch !== "0") {
      obj.peerUptimeEstablishedEpoch = message.peerUptimeEstablishedEpoch;
    }
    if (message.peerPfxRcd !== 0) {
      obj.peerPfxRcd = Math.round(message.peerPfxRcd);
    }
    if (message.peerPfxSnt !== 0) {
      obj.peerPfxSnt = Math.round(message.peerPfxSnt);
    }
    if (message.peerConnectionState !== 0) {
      obj.peerConnectionState = bgpPeerConnectionStateToJSON(message.peerConnectionState);
    }
    if (message.peerState !== 0) {
      obj.peerState = bgpPeerStateToJSON(message.peerState);
    }
    if (message.peerConnectionsEstablished !== 0) {
      obj.peerConnectionsEstablished = Math.round(message.peerConnectionsEstablished);
    }
    if (message.peerConnectionsDropped !== 0) {
      obj.peerConnectionsDropped = Math.round(message.peerConnectionsDropped);
    }
    if (message.peerIdType !== 0) {
      obj.peerIdType = bgpIdTypeToJSON(message.peerIdType);
    }
    if (message.failedPeers !== 0) {
      obj.failedPeers = Math.round(message.failedPeers);
    }
    if (message.displayedPeers !== 0) {
      obj.displayedPeers = Math.round(message.displayedPeers);
    }
    if (message.totalPeers !== 0) {
      obj.totalPeers = Math.round(message.totalPeers);
    }
    if (message.dynamicPeers !== 0) {
      obj.dynamicPeers = Math.round(message.dynamicPeers);
    }
    if (message.addressFamily !== 0) {
      obj.addressFamily = bgpAddressFamilyToJSON(message.addressFamily);
    }
    if (message.multiPathRelax !== false) {
      obj.multiPathRelax = message.multiPathRelax;
    }
    if (message.peerVersion !== 0) {
      obj.peerVersion = Math.round(message.peerVersion);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.updateRecord !== false) {
      obj.updateRecord = message.updateRecord;
    }
    if (message.peerIsDynamic !== false) {
      obj.peerIsDynamic = message.peerIsDynamic;
    }
    if (message.holdTimerRemainingMs !== 0) {
      obj.holdTimerRemainingMs = Math.round(message.holdTimerRemainingMs);
    }
    if (message.receivedRoutesCount !== 0) {
      obj.receivedRoutesCount = Math.round(message.receivedRoutesCount);
    }
    if (message.advertisedRoutesCount !== 0) {
      obj.advertisedRoutesCount = Math.round(message.advertisedRoutesCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborSummary>, I>>(base?: I): BgpNeighborSummary {
    return BgpNeighborSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborSummary>, I>>(object: I): BgpNeighborSummary {
    const message = createBaseBgpNeighborSummary();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.routerId = object.routerId ?? "";
    message.as = object.as ?? 0;
    message.vrfId = object.vrfId ?? 0;
    message.vrfName = object.vrfName ?? "";
    message.tableVersion = object.tableVersion ?? 0;
    message.ribCount = object.ribCount ?? 0;
    message.ribMemory = object.ribMemory ?? 0;
    message.peerCount = object.peerCount ?? 0;
    message.peerMemory = object.peerMemory ?? 0;
    message.peerGroupCount = object.peerGroupCount ?? 0;
    message.peerGroupMemory = object.peerGroupMemory ?? 0;
    message.peerName = object.peerName ?? "";
    message.peerHostname = object.peerHostname ?? "";
    message.peerRemoteAs = object.peerRemoteAs ?? 0;
    message.peerLocalAs = object.peerLocalAs ?? 0;
    message.peerTableVersion = object.peerTableVersion ?? 0;
    message.peerMsgRcvd = object.peerMsgRcvd ?? 0;
    message.peerMsgSent = object.peerMsgSent ?? 0;
    message.peerOutQ = object.peerOutQ ?? 0;
    message.peerInQ = object.peerInQ ?? 0;
    message.peerUptime = object.peerUptime ?? "";
    message.peerUptimeMsec = object.peerUptimeMsec ?? "0";
    message.peerUptimeEstablishedEpoch = object.peerUptimeEstablishedEpoch ?? "0";
    message.peerPfxRcd = object.peerPfxRcd ?? 0;
    message.peerPfxSnt = object.peerPfxSnt ?? 0;
    message.peerConnectionState = object.peerConnectionState ?? 0;
    message.peerState = object.peerState ?? 0;
    message.peerConnectionsEstablished = object.peerConnectionsEstablished ?? 0;
    message.peerConnectionsDropped = object.peerConnectionsDropped ?? 0;
    message.peerIdType = object.peerIdType ?? 0;
    message.failedPeers = object.failedPeers ?? 0;
    message.displayedPeers = object.displayedPeers ?? 0;
    message.totalPeers = object.totalPeers ?? 0;
    message.dynamicPeers = object.dynamicPeers ?? 0;
    message.addressFamily = object.addressFamily ?? 0;
    message.multiPathRelax = object.multiPathRelax ?? false;
    message.peerVersion = object.peerVersion ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.updateRecord = object.updateRecord ?? false;
    message.peerIsDynamic = object.peerIsDynamic ?? false;
    message.holdTimerRemainingMs = object.holdTimerRemainingMs ?? 0;
    message.receivedRoutesCount = object.receivedRoutesCount ?? 0;
    message.advertisedRoutesCount = object.advertisedRoutesCount ?? 0;
    return message;
  },
};

function createBaseBgpNeighborAddressFamily(): BgpNeighborAddressFamily {
  return { l2VpnEvpn: undefined, ipv6Unicast: undefined, ipv4Unicast: undefined };
}

export const BgpNeighborAddressFamily: MessageFns<BgpNeighborAddressFamily> = {
  encode(message: BgpNeighborAddressFamily, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.l2VpnEvpn !== undefined) {
      BgpNeighborAddressFamilyInfo.encode(message.l2VpnEvpn, writer.uint32(10).fork()).join();
    }
    if (message.ipv6Unicast !== undefined) {
      BgpNeighborAddressFamilyInfo.encode(message.ipv6Unicast, writer.uint32(18).fork()).join();
    }
    if (message.ipv4Unicast !== undefined) {
      BgpNeighborAddressFamilyInfo.encode(message.ipv4Unicast, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborAddressFamily {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborAddressFamily();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.l2VpnEvpn = BgpNeighborAddressFamilyInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ipv6Unicast = BgpNeighborAddressFamilyInfo.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ipv4Unicast = BgpNeighborAddressFamilyInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborAddressFamily {
    return {
      l2VpnEvpn: isSet(object.l2VpnEvpn) ? BgpNeighborAddressFamilyInfo.fromJSON(object.l2VpnEvpn) : undefined,
      ipv6Unicast: isSet(object.ipv6Unicast) ? BgpNeighborAddressFamilyInfo.fromJSON(object.ipv6Unicast) : undefined,
      ipv4Unicast: isSet(object.ipv4Unicast) ? BgpNeighborAddressFamilyInfo.fromJSON(object.ipv4Unicast) : undefined,
    };
  },

  toJSON(message: BgpNeighborAddressFamily): unknown {
    const obj: any = {};
    if (message.l2VpnEvpn !== undefined) {
      obj.l2VpnEvpn = BgpNeighborAddressFamilyInfo.toJSON(message.l2VpnEvpn);
    }
    if (message.ipv6Unicast !== undefined) {
      obj.ipv6Unicast = BgpNeighborAddressFamilyInfo.toJSON(message.ipv6Unicast);
    }
    if (message.ipv4Unicast !== undefined) {
      obj.ipv4Unicast = BgpNeighborAddressFamilyInfo.toJSON(message.ipv4Unicast);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborAddressFamily>, I>>(base?: I): BgpNeighborAddressFamily {
    return BgpNeighborAddressFamily.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborAddressFamily>, I>>(object: I): BgpNeighborAddressFamily {
    const message = createBaseBgpNeighborAddressFamily();
    message.l2VpnEvpn = (object.l2VpnEvpn !== undefined && object.l2VpnEvpn !== null)
      ? BgpNeighborAddressFamilyInfo.fromPartial(object.l2VpnEvpn)
      : undefined;
    message.ipv6Unicast = (object.ipv6Unicast !== undefined && object.ipv6Unicast !== null)
      ? BgpNeighborAddressFamilyInfo.fromPartial(object.ipv6Unicast)
      : undefined;
    message.ipv4Unicast = (object.ipv4Unicast !== undefined && object.ipv4Unicast !== null)
      ? BgpNeighborAddressFamilyInfo.fromPartial(object.ipv4Unicast)
      : undefined;
    return message;
  },
};

function createBaseBgpNeighborAddressFamilyInfo(): BgpNeighborAddressFamilyInfo {
  return {
    bgpAddressFamily: 0,
    updateGroupId: 0,
    subGroupId: 0,
    packetQueueLength: 0,
    acceptedPrefixCounter: 0,
    sentPrefixCounter: 0,
    allowAsInCount: 0,
    peerGroupMember: "",
    commAttriSentToNbr: "",
    unchangedNextHopPropogatedToNbr: false,
    advertiseAllVnis: false,
    routerAlwaysNextHop: false,
    inboundPathPolicyConfig: false,
    outboundPathPolicyConfig: false,
    routeMapForIncomingAdvertisements: "",
    routeMapForOutgoingAdvertisements: "",
  };
}

export const BgpNeighborAddressFamilyInfo: MessageFns<BgpNeighborAddressFamilyInfo> = {
  encode(message: BgpNeighborAddressFamilyInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bgpAddressFamily !== 0) {
      writer.uint32(8).int32(message.bgpAddressFamily);
    }
    if (message.updateGroupId !== 0) {
      writer.uint32(16).uint32(message.updateGroupId);
    }
    if (message.subGroupId !== 0) {
      writer.uint32(24).uint32(message.subGroupId);
    }
    if (message.packetQueueLength !== 0) {
      writer.uint32(32).uint32(message.packetQueueLength);
    }
    if (message.acceptedPrefixCounter !== 0) {
      writer.uint32(40).uint32(message.acceptedPrefixCounter);
    }
    if (message.sentPrefixCounter !== 0) {
      writer.uint32(48).uint32(message.sentPrefixCounter);
    }
    if (message.allowAsInCount !== 0) {
      writer.uint32(56).uint32(message.allowAsInCount);
    }
    if (message.peerGroupMember !== "") {
      writer.uint32(74).string(message.peerGroupMember);
    }
    if (message.commAttriSentToNbr !== "") {
      writer.uint32(82).string(message.commAttriSentToNbr);
    }
    if (message.unchangedNextHopPropogatedToNbr !== false) {
      writer.uint32(88).bool(message.unchangedNextHopPropogatedToNbr);
    }
    if (message.advertiseAllVnis !== false) {
      writer.uint32(96).bool(message.advertiseAllVnis);
    }
    if (message.routerAlwaysNextHop !== false) {
      writer.uint32(104).bool(message.routerAlwaysNextHop);
    }
    if (message.inboundPathPolicyConfig !== false) {
      writer.uint32(112).bool(message.inboundPathPolicyConfig);
    }
    if (message.outboundPathPolicyConfig !== false) {
      writer.uint32(120).bool(message.outboundPathPolicyConfig);
    }
    if (message.routeMapForIncomingAdvertisements !== "") {
      writer.uint32(130).string(message.routeMapForIncomingAdvertisements);
    }
    if (message.routeMapForOutgoingAdvertisements !== "") {
      writer.uint32(138).string(message.routeMapForOutgoingAdvertisements);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborAddressFamilyInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborAddressFamilyInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.bgpAddressFamily = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.updateGroupId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.subGroupId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.packetQueueLength = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.acceptedPrefixCounter = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.sentPrefixCounter = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.allowAsInCount = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.peerGroupMember = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.commAttriSentToNbr = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.unchangedNextHopPropogatedToNbr = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.advertiseAllVnis = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.routerAlwaysNextHop = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.inboundPathPolicyConfig = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.outboundPathPolicyConfig = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.routeMapForIncomingAdvertisements = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.routeMapForOutgoingAdvertisements = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborAddressFamilyInfo {
    return {
      bgpAddressFamily: isSet(object.bgpAddressFamily) ? bgpAddressFamilyFromJSON(object.bgpAddressFamily) : 0,
      updateGroupId: isSet(object.updateGroupId) ? globalThis.Number(object.updateGroupId) : 0,
      subGroupId: isSet(object.subGroupId) ? globalThis.Number(object.subGroupId) : 0,
      packetQueueLength: isSet(object.packetQueueLength) ? globalThis.Number(object.packetQueueLength) : 0,
      acceptedPrefixCounter: isSet(object.acceptedPrefixCounter) ? globalThis.Number(object.acceptedPrefixCounter) : 0,
      sentPrefixCounter: isSet(object.sentPrefixCounter) ? globalThis.Number(object.sentPrefixCounter) : 0,
      allowAsInCount: isSet(object.allowAsInCount) ? globalThis.Number(object.allowAsInCount) : 0,
      peerGroupMember: isSet(object.peerGroupMember) ? globalThis.String(object.peerGroupMember) : "",
      commAttriSentToNbr: isSet(object.commAttriSentToNbr) ? globalThis.String(object.commAttriSentToNbr) : "",
      unchangedNextHopPropogatedToNbr: isSet(object.unchangedNextHopPropogatedToNbr)
        ? globalThis.Boolean(object.unchangedNextHopPropogatedToNbr)
        : false,
      advertiseAllVnis: isSet(object.advertiseAllVnis) ? globalThis.Boolean(object.advertiseAllVnis) : false,
      routerAlwaysNextHop: isSet(object.routerAlwaysNextHop) ? globalThis.Boolean(object.routerAlwaysNextHop) : false,
      inboundPathPolicyConfig: isSet(object.inboundPathPolicyConfig)
        ? globalThis.Boolean(object.inboundPathPolicyConfig)
        : false,
      outboundPathPolicyConfig: isSet(object.outboundPathPolicyConfig)
        ? globalThis.Boolean(object.outboundPathPolicyConfig)
        : false,
      routeMapForIncomingAdvertisements: isSet(object.routeMapForIncomingAdvertisements)
        ? globalThis.String(object.routeMapForIncomingAdvertisements)
        : "",
      routeMapForOutgoingAdvertisements: isSet(object.routeMapForOutgoingAdvertisements)
        ? globalThis.String(object.routeMapForOutgoingAdvertisements)
        : "",
    };
  },

  toJSON(message: BgpNeighborAddressFamilyInfo): unknown {
    const obj: any = {};
    if (message.bgpAddressFamily !== 0) {
      obj.bgpAddressFamily = bgpAddressFamilyToJSON(message.bgpAddressFamily);
    }
    if (message.updateGroupId !== 0) {
      obj.updateGroupId = Math.round(message.updateGroupId);
    }
    if (message.subGroupId !== 0) {
      obj.subGroupId = Math.round(message.subGroupId);
    }
    if (message.packetQueueLength !== 0) {
      obj.packetQueueLength = Math.round(message.packetQueueLength);
    }
    if (message.acceptedPrefixCounter !== 0) {
      obj.acceptedPrefixCounter = Math.round(message.acceptedPrefixCounter);
    }
    if (message.sentPrefixCounter !== 0) {
      obj.sentPrefixCounter = Math.round(message.sentPrefixCounter);
    }
    if (message.allowAsInCount !== 0) {
      obj.allowAsInCount = Math.round(message.allowAsInCount);
    }
    if (message.peerGroupMember !== "") {
      obj.peerGroupMember = message.peerGroupMember;
    }
    if (message.commAttriSentToNbr !== "") {
      obj.commAttriSentToNbr = message.commAttriSentToNbr;
    }
    if (message.unchangedNextHopPropogatedToNbr !== false) {
      obj.unchangedNextHopPropogatedToNbr = message.unchangedNextHopPropogatedToNbr;
    }
    if (message.advertiseAllVnis !== false) {
      obj.advertiseAllVnis = message.advertiseAllVnis;
    }
    if (message.routerAlwaysNextHop !== false) {
      obj.routerAlwaysNextHop = message.routerAlwaysNextHop;
    }
    if (message.inboundPathPolicyConfig !== false) {
      obj.inboundPathPolicyConfig = message.inboundPathPolicyConfig;
    }
    if (message.outboundPathPolicyConfig !== false) {
      obj.outboundPathPolicyConfig = message.outboundPathPolicyConfig;
    }
    if (message.routeMapForIncomingAdvertisements !== "") {
      obj.routeMapForIncomingAdvertisements = message.routeMapForIncomingAdvertisements;
    }
    if (message.routeMapForOutgoingAdvertisements !== "") {
      obj.routeMapForOutgoingAdvertisements = message.routeMapForOutgoingAdvertisements;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborAddressFamilyInfo>, I>>(base?: I): BgpNeighborAddressFamilyInfo {
    return BgpNeighborAddressFamilyInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborAddressFamilyInfo>, I>>(object: I): BgpNeighborAddressFamilyInfo {
    const message = createBaseBgpNeighborAddressFamilyInfo();
    message.bgpAddressFamily = object.bgpAddressFamily ?? 0;
    message.updateGroupId = object.updateGroupId ?? 0;
    message.subGroupId = object.subGroupId ?? 0;
    message.packetQueueLength = object.packetQueueLength ?? 0;
    message.acceptedPrefixCounter = object.acceptedPrefixCounter ?? 0;
    message.sentPrefixCounter = object.sentPrefixCounter ?? 0;
    message.allowAsInCount = object.allowAsInCount ?? 0;
    message.peerGroupMember = object.peerGroupMember ?? "";
    message.commAttriSentToNbr = object.commAttriSentToNbr ?? "";
    message.unchangedNextHopPropogatedToNbr = object.unchangedNextHopPropogatedToNbr ?? false;
    message.advertiseAllVnis = object.advertiseAllVnis ?? false;
    message.routerAlwaysNextHop = object.routerAlwaysNextHop ?? false;
    message.inboundPathPolicyConfig = object.inboundPathPolicyConfig ?? false;
    message.outboundPathPolicyConfig = object.outboundPathPolicyConfig ?? false;
    message.routeMapForIncomingAdvertisements = object.routeMapForIncomingAdvertisements ?? "";
    message.routeMapForOutgoingAdvertisements = object.routeMapForOutgoingAdvertisements ?? "";
    return message;
  },
};

function createBaseBgpPeerBfdInfo(): BgpPeerBfdInfo {
  return { type: "", detectMultiplier: 0, rxMinInterval: 0, txMinInterval: 0, status: 0, lastUpdate: "" };
}

export const BgpPeerBfdInfo: MessageFns<BgpPeerBfdInfo> = {
  encode(message: BgpPeerBfdInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.detectMultiplier !== 0) {
      writer.uint32(16).uint32(message.detectMultiplier);
    }
    if (message.rxMinInterval !== 0) {
      writer.uint32(24).uint32(message.rxMinInterval);
    }
    if (message.txMinInterval !== 0) {
      writer.uint32(32).uint32(message.txMinInterval);
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status);
    }
    if (message.lastUpdate !== "") {
      writer.uint32(50).string(message.lastUpdate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpPeerBfdInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpPeerBfdInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.detectMultiplier = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.rxMinInterval = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.txMinInterval = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.lastUpdate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpPeerBfdInfo {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      detectMultiplier: isSet(object.detectMultiplier) ? globalThis.Number(object.detectMultiplier) : 0,
      rxMinInterval: isSet(object.rxMinInterval) ? globalThis.Number(object.rxMinInterval) : 0,
      txMinInterval: isSet(object.txMinInterval) ? globalThis.Number(object.txMinInterval) : 0,
      status: isSet(object.status) ? bgpPeerBfdStateFromJSON(object.status) : 0,
      lastUpdate: isSet(object.lastUpdate) ? globalThis.String(object.lastUpdate) : "",
    };
  },

  toJSON(message: BgpPeerBfdInfo): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.detectMultiplier !== 0) {
      obj.detectMultiplier = Math.round(message.detectMultiplier);
    }
    if (message.rxMinInterval !== 0) {
      obj.rxMinInterval = Math.round(message.rxMinInterval);
    }
    if (message.txMinInterval !== 0) {
      obj.txMinInterval = Math.round(message.txMinInterval);
    }
    if (message.status !== 0) {
      obj.status = bgpPeerBfdStateToJSON(message.status);
    }
    if (message.lastUpdate !== "") {
      obj.lastUpdate = message.lastUpdate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpPeerBfdInfo>, I>>(base?: I): BgpPeerBfdInfo {
    return BgpPeerBfdInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpPeerBfdInfo>, I>>(object: I): BgpPeerBfdInfo {
    const message = createBaseBgpPeerBfdInfo();
    message.type = object.type ?? "";
    message.detectMultiplier = object.detectMultiplier ?? 0;
    message.rxMinInterval = object.rxMinInterval ?? 0;
    message.txMinInterval = object.txMinInterval ?? 0;
    message.status = object.status ?? 0;
    message.lastUpdate = object.lastUpdate ?? "";
    return message;
  },
};

function createBaseBgpNeighborCapabilitiesAddPathInfo(): BgpNeighborCapabilitiesAddPathInfo {
  return { rxAdvertiseAndReceived: false };
}

export const BgpNeighborCapabilitiesAddPathInfo: MessageFns<BgpNeighborCapabilitiesAddPathInfo> = {
  encode(message: BgpNeighborCapabilitiesAddPathInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rxAdvertiseAndReceived !== false) {
      writer.uint32(8).bool(message.rxAdvertiseAndReceived);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborCapabilitiesAddPathInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborCapabilitiesAddPathInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.rxAdvertiseAndReceived = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborCapabilitiesAddPathInfo {
    return {
      rxAdvertiseAndReceived: isSet(object.rxAdvertiseAndReceived)
        ? globalThis.Boolean(object.rxAdvertiseAndReceived)
        : false,
    };
  },

  toJSON(message: BgpNeighborCapabilitiesAddPathInfo): unknown {
    const obj: any = {};
    if (message.rxAdvertiseAndReceived !== false) {
      obj.rxAdvertiseAndReceived = message.rxAdvertiseAndReceived;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborCapabilitiesAddPathInfo>, I>>(
    base?: I,
  ): BgpNeighborCapabilitiesAddPathInfo {
    return BgpNeighborCapabilitiesAddPathInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborCapabilitiesAddPathInfo>, I>>(
    object: I,
  ): BgpNeighborCapabilitiesAddPathInfo {
    const message = createBaseBgpNeighborCapabilitiesAddPathInfo();
    message.rxAdvertiseAndReceived = object.rxAdvertiseAndReceived ?? false;
    return message;
  },
};

function createBaseBgpNeighborCapabilitiesAddPath(): BgpNeighborCapabilitiesAddPath {
  return { l2VpnEvpn: undefined, ipv4Unicast: undefined, ipv6Unicast: undefined };
}

export const BgpNeighborCapabilitiesAddPath: MessageFns<BgpNeighborCapabilitiesAddPath> = {
  encode(message: BgpNeighborCapabilitiesAddPath, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.l2VpnEvpn !== undefined) {
      BgpNeighborCapabilitiesAddPathInfo.encode(message.l2VpnEvpn, writer.uint32(10).fork()).join();
    }
    if (message.ipv4Unicast !== undefined) {
      BgpNeighborCapabilitiesAddPathInfo.encode(message.ipv4Unicast, writer.uint32(18).fork()).join();
    }
    if (message.ipv6Unicast !== undefined) {
      BgpNeighborCapabilitiesAddPathInfo.encode(message.ipv6Unicast, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborCapabilitiesAddPath {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborCapabilitiesAddPath();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.l2VpnEvpn = BgpNeighborCapabilitiesAddPathInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ipv4Unicast = BgpNeighborCapabilitiesAddPathInfo.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ipv6Unicast = BgpNeighborCapabilitiesAddPathInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborCapabilitiesAddPath {
    return {
      l2VpnEvpn: isSet(object.l2VpnEvpn) ? BgpNeighborCapabilitiesAddPathInfo.fromJSON(object.l2VpnEvpn) : undefined,
      ipv4Unicast: isSet(object.ipv4Unicast)
        ? BgpNeighborCapabilitiesAddPathInfo.fromJSON(object.ipv4Unicast)
        : undefined,
      ipv6Unicast: isSet(object.ipv6Unicast)
        ? BgpNeighborCapabilitiesAddPathInfo.fromJSON(object.ipv6Unicast)
        : undefined,
    };
  },

  toJSON(message: BgpNeighborCapabilitiesAddPath): unknown {
    const obj: any = {};
    if (message.l2VpnEvpn !== undefined) {
      obj.l2VpnEvpn = BgpNeighborCapabilitiesAddPathInfo.toJSON(message.l2VpnEvpn);
    }
    if (message.ipv4Unicast !== undefined) {
      obj.ipv4Unicast = BgpNeighborCapabilitiesAddPathInfo.toJSON(message.ipv4Unicast);
    }
    if (message.ipv6Unicast !== undefined) {
      obj.ipv6Unicast = BgpNeighborCapabilitiesAddPathInfo.toJSON(message.ipv6Unicast);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborCapabilitiesAddPath>, I>>(base?: I): BgpNeighborCapabilitiesAddPath {
    return BgpNeighborCapabilitiesAddPath.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborCapabilitiesAddPath>, I>>(
    object: I,
  ): BgpNeighborCapabilitiesAddPath {
    const message = createBaseBgpNeighborCapabilitiesAddPath();
    message.l2VpnEvpn = (object.l2VpnEvpn !== undefined && object.l2VpnEvpn !== null)
      ? BgpNeighborCapabilitiesAddPathInfo.fromPartial(object.l2VpnEvpn)
      : undefined;
    message.ipv4Unicast = (object.ipv4Unicast !== undefined && object.ipv4Unicast !== null)
      ? BgpNeighborCapabilitiesAddPathInfo.fromPartial(object.ipv4Unicast)
      : undefined;
    message.ipv6Unicast = (object.ipv6Unicast !== undefined && object.ipv6Unicast !== null)
      ? BgpNeighborCapabilitiesAddPathInfo.fromPartial(object.ipv6Unicast)
      : undefined;
    return message;
  },
};

function createBaseBgpNeighborCapabilitiesMultiProtocolExtensions(): BgpNeighborCapabilitiesMultiProtocolExtensions {
  return { l2VpnEvpn: undefined, ipv4Unicast: undefined, ipv6Unicast: undefined };
}

export const BgpNeighborCapabilitiesMultiProtocolExtensions: MessageFns<
  BgpNeighborCapabilitiesMultiProtocolExtensions
> = {
  encode(
    message: BgpNeighborCapabilitiesMultiProtocolExtensions,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.l2VpnEvpn !== undefined) {
      BgpNeighborCapabilitiesAddPathInfo.encode(message.l2VpnEvpn, writer.uint32(10).fork()).join();
    }
    if (message.ipv4Unicast !== undefined) {
      BgpNeighborCapabilitiesAddPathInfo.encode(message.ipv4Unicast, writer.uint32(18).fork()).join();
    }
    if (message.ipv6Unicast !== undefined) {
      BgpNeighborCapabilitiesAddPathInfo.encode(message.ipv6Unicast, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborCapabilitiesMultiProtocolExtensions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborCapabilitiesMultiProtocolExtensions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.l2VpnEvpn = BgpNeighborCapabilitiesAddPathInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ipv4Unicast = BgpNeighborCapabilitiesAddPathInfo.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ipv6Unicast = BgpNeighborCapabilitiesAddPathInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborCapabilitiesMultiProtocolExtensions {
    return {
      l2VpnEvpn: isSet(object.l2VpnEvpn) ? BgpNeighborCapabilitiesAddPathInfo.fromJSON(object.l2VpnEvpn) : undefined,
      ipv4Unicast: isSet(object.ipv4Unicast)
        ? BgpNeighborCapabilitiesAddPathInfo.fromJSON(object.ipv4Unicast)
        : undefined,
      ipv6Unicast: isSet(object.ipv6Unicast)
        ? BgpNeighborCapabilitiesAddPathInfo.fromJSON(object.ipv6Unicast)
        : undefined,
    };
  },

  toJSON(message: BgpNeighborCapabilitiesMultiProtocolExtensions): unknown {
    const obj: any = {};
    if (message.l2VpnEvpn !== undefined) {
      obj.l2VpnEvpn = BgpNeighborCapabilitiesAddPathInfo.toJSON(message.l2VpnEvpn);
    }
    if (message.ipv4Unicast !== undefined) {
      obj.ipv4Unicast = BgpNeighborCapabilitiesAddPathInfo.toJSON(message.ipv4Unicast);
    }
    if (message.ipv6Unicast !== undefined) {
      obj.ipv6Unicast = BgpNeighborCapabilitiesAddPathInfo.toJSON(message.ipv6Unicast);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborCapabilitiesMultiProtocolExtensions>, I>>(
    base?: I,
  ): BgpNeighborCapabilitiesMultiProtocolExtensions {
    return BgpNeighborCapabilitiesMultiProtocolExtensions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborCapabilitiesMultiProtocolExtensions>, I>>(
    object: I,
  ): BgpNeighborCapabilitiesMultiProtocolExtensions {
    const message = createBaseBgpNeighborCapabilitiesMultiProtocolExtensions();
    message.l2VpnEvpn = (object.l2VpnEvpn !== undefined && object.l2VpnEvpn !== null)
      ? BgpNeighborCapabilitiesAddPathInfo.fromPartial(object.l2VpnEvpn)
      : undefined;
    message.ipv4Unicast = (object.ipv4Unicast !== undefined && object.ipv4Unicast !== null)
      ? BgpNeighborCapabilitiesAddPathInfo.fromPartial(object.ipv4Unicast)
      : undefined;
    message.ipv6Unicast = (object.ipv6Unicast !== undefined && object.ipv6Unicast !== null)
      ? BgpNeighborCapabilitiesAddPathInfo.fromPartial(object.ipv6Unicast)
      : undefined;
    return message;
  },
};

function createBaseBgpNeighborCapabilitiesMultiProtocolExtensionsInfo(): BgpNeighborCapabilitiesMultiProtocolExtensionsInfo {
  return { advertisedAndReceived: false };
}

export const BgpNeighborCapabilitiesMultiProtocolExtensionsInfo: MessageFns<
  BgpNeighborCapabilitiesMultiProtocolExtensionsInfo
> = {
  encode(
    message: BgpNeighborCapabilitiesMultiProtocolExtensionsInfo,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.advertisedAndReceived !== false) {
      writer.uint32(8).bool(message.advertisedAndReceived);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborCapabilitiesMultiProtocolExtensionsInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborCapabilitiesMultiProtocolExtensionsInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.advertisedAndReceived = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborCapabilitiesMultiProtocolExtensionsInfo {
    return {
      advertisedAndReceived: isSet(object.advertisedAndReceived)
        ? globalThis.Boolean(object.advertisedAndReceived)
        : false,
    };
  },

  toJSON(message: BgpNeighborCapabilitiesMultiProtocolExtensionsInfo): unknown {
    const obj: any = {};
    if (message.advertisedAndReceived !== false) {
      obj.advertisedAndReceived = message.advertisedAndReceived;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborCapabilitiesMultiProtocolExtensionsInfo>, I>>(
    base?: I,
  ): BgpNeighborCapabilitiesMultiProtocolExtensionsInfo {
    return BgpNeighborCapabilitiesMultiProtocolExtensionsInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborCapabilitiesMultiProtocolExtensionsInfo>, I>>(
    object: I,
  ): BgpNeighborCapabilitiesMultiProtocolExtensionsInfo {
    const message = createBaseBgpNeighborCapabilitiesMultiProtocolExtensionsInfo();
    message.advertisedAndReceived = object.advertisedAndReceived ?? false;
    return message;
  },
};

function createBaseBgpNeighborCapabilitiesHostName(): BgpNeighborCapabilitiesHostName {
  return { advHostName: "", advDomainName: "", rcvHostName: "", rcvDomainName: "" };
}

export const BgpNeighborCapabilitiesHostName: MessageFns<BgpNeighborCapabilitiesHostName> = {
  encode(message: BgpNeighborCapabilitiesHostName, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.advHostName !== "") {
      writer.uint32(10).string(message.advHostName);
    }
    if (message.advDomainName !== "") {
      writer.uint32(18).string(message.advDomainName);
    }
    if (message.rcvHostName !== "") {
      writer.uint32(26).string(message.rcvHostName);
    }
    if (message.rcvDomainName !== "") {
      writer.uint32(34).string(message.rcvDomainName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborCapabilitiesHostName {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborCapabilitiesHostName();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.advHostName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.advDomainName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.rcvHostName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.rcvDomainName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborCapabilitiesHostName {
    return {
      advHostName: isSet(object.advHostName) ? globalThis.String(object.advHostName) : "",
      advDomainName: isSet(object.advDomainName) ? globalThis.String(object.advDomainName) : "",
      rcvHostName: isSet(object.rcvHostName) ? globalThis.String(object.rcvHostName) : "",
      rcvDomainName: isSet(object.rcvDomainName) ? globalThis.String(object.rcvDomainName) : "",
    };
  },

  toJSON(message: BgpNeighborCapabilitiesHostName): unknown {
    const obj: any = {};
    if (message.advHostName !== "") {
      obj.advHostName = message.advHostName;
    }
    if (message.advDomainName !== "") {
      obj.advDomainName = message.advDomainName;
    }
    if (message.rcvHostName !== "") {
      obj.rcvHostName = message.rcvHostName;
    }
    if (message.rcvDomainName !== "") {
      obj.rcvDomainName = message.rcvDomainName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborCapabilitiesHostName>, I>>(base?: I): BgpNeighborCapabilitiesHostName {
    return BgpNeighborCapabilitiesHostName.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborCapabilitiesHostName>, I>>(
    object: I,
  ): BgpNeighborCapabilitiesHostName {
    const message = createBaseBgpNeighborCapabilitiesHostName();
    message.advHostName = object.advHostName ?? "";
    message.advDomainName = object.advDomainName ?? "";
    message.rcvHostName = object.rcvHostName ?? "";
    message.rcvDomainName = object.rcvDomainName ?? "";
    return message;
  },
};

function createBaseBgpNeighborCapabilities(): BgpNeighborCapabilities {
  return {
    fourByteAs: 0,
    extendedMessage: 0,
    longLivedGracefulRestart: 0,
    routeRefresh: 0,
    enhancedRouteRefresh: 0,
    gracefulRestart: 0,
    gracefulRestartRemoteTimerMsecs: 0,
    addressFamiliesByPeer: "",
    multiprotocolExtensions: undefined,
    addPath: undefined,
    hostName: undefined,
  };
}

export const BgpNeighborCapabilities: MessageFns<BgpNeighborCapabilities> = {
  encode(message: BgpNeighborCapabilities, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fourByteAs !== 0) {
      writer.uint32(8).int32(message.fourByteAs);
    }
    if (message.extendedMessage !== 0) {
      writer.uint32(16).int32(message.extendedMessage);
    }
    if (message.longLivedGracefulRestart !== 0) {
      writer.uint32(24).int32(message.longLivedGracefulRestart);
    }
    if (message.routeRefresh !== 0) {
      writer.uint32(32).int32(message.routeRefresh);
    }
    if (message.enhancedRouteRefresh !== 0) {
      writer.uint32(40).int32(message.enhancedRouteRefresh);
    }
    if (message.gracefulRestart !== 0) {
      writer.uint32(48).int32(message.gracefulRestart);
    }
    if (message.gracefulRestartRemoteTimerMsecs !== 0) {
      writer.uint32(56).uint32(message.gracefulRestartRemoteTimerMsecs);
    }
    if (message.addressFamiliesByPeer !== "") {
      writer.uint32(66).string(message.addressFamiliesByPeer);
    }
    if (message.multiprotocolExtensions !== undefined) {
      BgpNeighborCapabilitiesMultiProtocolExtensions.encode(message.multiprotocolExtensions, writer.uint32(74).fork())
        .join();
    }
    if (message.addPath !== undefined) {
      BgpNeighborCapabilitiesAddPath.encode(message.addPath, writer.uint32(82).fork()).join();
    }
    if (message.hostName !== undefined) {
      BgpNeighborCapabilitiesHostName.encode(message.hostName, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborCapabilities {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborCapabilities();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fourByteAs = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.extendedMessage = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.longLivedGracefulRestart = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.routeRefresh = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.enhancedRouteRefresh = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.gracefulRestart = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.gracefulRestartRemoteTimerMsecs = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.addressFamiliesByPeer = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.multiprotocolExtensions = BgpNeighborCapabilitiesMultiProtocolExtensions.decode(
            reader,
            reader.uint32(),
          );
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.addPath = BgpNeighborCapabilitiesAddPath.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.hostName = BgpNeighborCapabilitiesHostName.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborCapabilities {
    return {
      fourByteAs: isSet(object.fourByteAs) ? bgpNeighborCapabilityFromJSON(object.fourByteAs) : 0,
      extendedMessage: isSet(object.extendedMessage) ? bgpNeighborCapabilityFromJSON(object.extendedMessage) : 0,
      longLivedGracefulRestart: isSet(object.longLivedGracefulRestart)
        ? bgpNeighborCapabilityFromJSON(object.longLivedGracefulRestart)
        : 0,
      routeRefresh: isSet(object.routeRefresh) ? bgpNeighborCapabilityFromJSON(object.routeRefresh) : 0,
      enhancedRouteRefresh: isSet(object.enhancedRouteRefresh)
        ? bgpNeighborCapabilityFromJSON(object.enhancedRouteRefresh)
        : 0,
      gracefulRestart: isSet(object.gracefulRestart) ? bgpNeighborCapabilityFromJSON(object.gracefulRestart) : 0,
      gracefulRestartRemoteTimerMsecs: isSet(object.gracefulRestartRemoteTimerMsecs)
        ? globalThis.Number(object.gracefulRestartRemoteTimerMsecs)
        : 0,
      addressFamiliesByPeer: isSet(object.addressFamiliesByPeer) ? globalThis.String(object.addressFamiliesByPeer) : "",
      multiprotocolExtensions: isSet(object.multiprotocolExtensions)
        ? BgpNeighborCapabilitiesMultiProtocolExtensions.fromJSON(object.multiprotocolExtensions)
        : undefined,
      addPath: isSet(object.addPath) ? BgpNeighborCapabilitiesAddPath.fromJSON(object.addPath) : undefined,
      hostName: isSet(object.hostName) ? BgpNeighborCapabilitiesHostName.fromJSON(object.hostName) : undefined,
    };
  },

  toJSON(message: BgpNeighborCapabilities): unknown {
    const obj: any = {};
    if (message.fourByteAs !== 0) {
      obj.fourByteAs = bgpNeighborCapabilityToJSON(message.fourByteAs);
    }
    if (message.extendedMessage !== 0) {
      obj.extendedMessage = bgpNeighborCapabilityToJSON(message.extendedMessage);
    }
    if (message.longLivedGracefulRestart !== 0) {
      obj.longLivedGracefulRestart = bgpNeighborCapabilityToJSON(message.longLivedGracefulRestart);
    }
    if (message.routeRefresh !== 0) {
      obj.routeRefresh = bgpNeighborCapabilityToJSON(message.routeRefresh);
    }
    if (message.enhancedRouteRefresh !== 0) {
      obj.enhancedRouteRefresh = bgpNeighborCapabilityToJSON(message.enhancedRouteRefresh);
    }
    if (message.gracefulRestart !== 0) {
      obj.gracefulRestart = bgpNeighborCapabilityToJSON(message.gracefulRestart);
    }
    if (message.gracefulRestartRemoteTimerMsecs !== 0) {
      obj.gracefulRestartRemoteTimerMsecs = Math.round(message.gracefulRestartRemoteTimerMsecs);
    }
    if (message.addressFamiliesByPeer !== "") {
      obj.addressFamiliesByPeer = message.addressFamiliesByPeer;
    }
    if (message.multiprotocolExtensions !== undefined) {
      obj.multiprotocolExtensions = BgpNeighborCapabilitiesMultiProtocolExtensions.toJSON(
        message.multiprotocolExtensions,
      );
    }
    if (message.addPath !== undefined) {
      obj.addPath = BgpNeighborCapabilitiesAddPath.toJSON(message.addPath);
    }
    if (message.hostName !== undefined) {
      obj.hostName = BgpNeighborCapabilitiesHostName.toJSON(message.hostName);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborCapabilities>, I>>(base?: I): BgpNeighborCapabilities {
    return BgpNeighborCapabilities.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborCapabilities>, I>>(object: I): BgpNeighborCapabilities {
    const message = createBaseBgpNeighborCapabilities();
    message.fourByteAs = object.fourByteAs ?? 0;
    message.extendedMessage = object.extendedMessage ?? 0;
    message.longLivedGracefulRestart = object.longLivedGracefulRestart ?? 0;
    message.routeRefresh = object.routeRefresh ?? 0;
    message.enhancedRouteRefresh = object.enhancedRouteRefresh ?? 0;
    message.gracefulRestart = object.gracefulRestart ?? 0;
    message.gracefulRestartRemoteTimerMsecs = object.gracefulRestartRemoteTimerMsecs ?? 0;
    message.addressFamiliesByPeer = object.addressFamiliesByPeer ?? "";
    message.multiprotocolExtensions =
      (object.multiprotocolExtensions !== undefined && object.multiprotocolExtensions !== null)
        ? BgpNeighborCapabilitiesMultiProtocolExtensions.fromPartial(object.multiprotocolExtensions)
        : undefined;
    message.addPath = (object.addPath !== undefined && object.addPath !== null)
      ? BgpNeighborCapabilitiesAddPath.fromPartial(object.addPath)
      : undefined;
    message.hostName = (object.hostName !== undefined && object.hostName !== null)
      ? BgpNeighborCapabilitiesHostName.fromPartial(object.hostName)
      : undefined;
    return message;
  },
};

function createBaseBgpNeighborMessageStats(): BgpNeighborMessageStats {
  return {
    depthInq: 0,
    depthOutq: 0,
    opensSent: 0,
    opensRecv: 0,
    notificationsSent: 0,
    notificationsRecv: 0,
    updatesSent: 0,
    updatesRecv: 0,
    keepalivesSent: 0,
    keepalivesRecv: 0,
    routeRefreshSent: 0,
    routeRefreshRecv: 0,
    capabilitySent: 0,
    capabilityRecv: 0,
    totalSent: 0,
    totalRecv: 0,
  };
}

export const BgpNeighborMessageStats: MessageFns<BgpNeighborMessageStats> = {
  encode(message: BgpNeighborMessageStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.depthInq !== 0) {
      writer.uint32(8).uint32(message.depthInq);
    }
    if (message.depthOutq !== 0) {
      writer.uint32(16).uint32(message.depthOutq);
    }
    if (message.opensSent !== 0) {
      writer.uint32(24).uint32(message.opensSent);
    }
    if (message.opensRecv !== 0) {
      writer.uint32(32).uint32(message.opensRecv);
    }
    if (message.notificationsSent !== 0) {
      writer.uint32(40).uint32(message.notificationsSent);
    }
    if (message.notificationsRecv !== 0) {
      writer.uint32(48).uint32(message.notificationsRecv);
    }
    if (message.updatesSent !== 0) {
      writer.uint32(56).uint32(message.updatesSent);
    }
    if (message.updatesRecv !== 0) {
      writer.uint32(64).uint32(message.updatesRecv);
    }
    if (message.keepalivesSent !== 0) {
      writer.uint32(72).uint32(message.keepalivesSent);
    }
    if (message.keepalivesRecv !== 0) {
      writer.uint32(80).uint32(message.keepalivesRecv);
    }
    if (message.routeRefreshSent !== 0) {
      writer.uint32(88).uint32(message.routeRefreshSent);
    }
    if (message.routeRefreshRecv !== 0) {
      writer.uint32(96).uint32(message.routeRefreshRecv);
    }
    if (message.capabilitySent !== 0) {
      writer.uint32(104).uint32(message.capabilitySent);
    }
    if (message.capabilityRecv !== 0) {
      writer.uint32(112).uint32(message.capabilityRecv);
    }
    if (message.totalSent !== 0) {
      writer.uint32(120).uint32(message.totalSent);
    }
    if (message.totalRecv !== 0) {
      writer.uint32(128).uint32(message.totalRecv);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborMessageStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborMessageStats();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.depthInq = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.depthOutq = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.opensSent = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.opensRecv = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.notificationsSent = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.notificationsRecv = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.updatesSent = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.updatesRecv = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.keepalivesSent = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.keepalivesRecv = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.routeRefreshSent = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.routeRefreshRecv = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.capabilitySent = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.capabilityRecv = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.totalSent = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.totalRecv = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborMessageStats {
    return {
      depthInq: isSet(object.depthInq) ? globalThis.Number(object.depthInq) : 0,
      depthOutq: isSet(object.depthOutq) ? globalThis.Number(object.depthOutq) : 0,
      opensSent: isSet(object.opensSent) ? globalThis.Number(object.opensSent) : 0,
      opensRecv: isSet(object.opensRecv) ? globalThis.Number(object.opensRecv) : 0,
      notificationsSent: isSet(object.notificationsSent) ? globalThis.Number(object.notificationsSent) : 0,
      notificationsRecv: isSet(object.notificationsRecv) ? globalThis.Number(object.notificationsRecv) : 0,
      updatesSent: isSet(object.updatesSent) ? globalThis.Number(object.updatesSent) : 0,
      updatesRecv: isSet(object.updatesRecv) ? globalThis.Number(object.updatesRecv) : 0,
      keepalivesSent: isSet(object.keepalivesSent) ? globalThis.Number(object.keepalivesSent) : 0,
      keepalivesRecv: isSet(object.keepalivesRecv) ? globalThis.Number(object.keepalivesRecv) : 0,
      routeRefreshSent: isSet(object.routeRefreshSent) ? globalThis.Number(object.routeRefreshSent) : 0,
      routeRefreshRecv: isSet(object.routeRefreshRecv) ? globalThis.Number(object.routeRefreshRecv) : 0,
      capabilitySent: isSet(object.capabilitySent) ? globalThis.Number(object.capabilitySent) : 0,
      capabilityRecv: isSet(object.capabilityRecv) ? globalThis.Number(object.capabilityRecv) : 0,
      totalSent: isSet(object.totalSent) ? globalThis.Number(object.totalSent) : 0,
      totalRecv: isSet(object.totalRecv) ? globalThis.Number(object.totalRecv) : 0,
    };
  },

  toJSON(message: BgpNeighborMessageStats): unknown {
    const obj: any = {};
    if (message.depthInq !== 0) {
      obj.depthInq = Math.round(message.depthInq);
    }
    if (message.depthOutq !== 0) {
      obj.depthOutq = Math.round(message.depthOutq);
    }
    if (message.opensSent !== 0) {
      obj.opensSent = Math.round(message.opensSent);
    }
    if (message.opensRecv !== 0) {
      obj.opensRecv = Math.round(message.opensRecv);
    }
    if (message.notificationsSent !== 0) {
      obj.notificationsSent = Math.round(message.notificationsSent);
    }
    if (message.notificationsRecv !== 0) {
      obj.notificationsRecv = Math.round(message.notificationsRecv);
    }
    if (message.updatesSent !== 0) {
      obj.updatesSent = Math.round(message.updatesSent);
    }
    if (message.updatesRecv !== 0) {
      obj.updatesRecv = Math.round(message.updatesRecv);
    }
    if (message.keepalivesSent !== 0) {
      obj.keepalivesSent = Math.round(message.keepalivesSent);
    }
    if (message.keepalivesRecv !== 0) {
      obj.keepalivesRecv = Math.round(message.keepalivesRecv);
    }
    if (message.routeRefreshSent !== 0) {
      obj.routeRefreshSent = Math.round(message.routeRefreshSent);
    }
    if (message.routeRefreshRecv !== 0) {
      obj.routeRefreshRecv = Math.round(message.routeRefreshRecv);
    }
    if (message.capabilitySent !== 0) {
      obj.capabilitySent = Math.round(message.capabilitySent);
    }
    if (message.capabilityRecv !== 0) {
      obj.capabilityRecv = Math.round(message.capabilityRecv);
    }
    if (message.totalSent !== 0) {
      obj.totalSent = Math.round(message.totalSent);
    }
    if (message.totalRecv !== 0) {
      obj.totalRecv = Math.round(message.totalRecv);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborMessageStats>, I>>(base?: I): BgpNeighborMessageStats {
    return BgpNeighborMessageStats.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborMessageStats>, I>>(object: I): BgpNeighborMessageStats {
    const message = createBaseBgpNeighborMessageStats();
    message.depthInq = object.depthInq ?? 0;
    message.depthOutq = object.depthOutq ?? 0;
    message.opensSent = object.opensSent ?? 0;
    message.opensRecv = object.opensRecv ?? 0;
    message.notificationsSent = object.notificationsSent ?? 0;
    message.notificationsRecv = object.notificationsRecv ?? 0;
    message.updatesSent = object.updatesSent ?? 0;
    message.updatesRecv = object.updatesRecv ?? 0;
    message.keepalivesSent = object.keepalivesSent ?? 0;
    message.keepalivesRecv = object.keepalivesRecv ?? 0;
    message.routeRefreshSent = object.routeRefreshSent ?? 0;
    message.routeRefreshRecv = object.routeRefreshRecv ?? 0;
    message.capabilitySent = object.capabilitySent ?? 0;
    message.capabilityRecv = object.capabilityRecv ?? 0;
    message.totalSent = object.totalSent ?? 0;
    message.totalRecv = object.totalRecv ?? 0;
    return message;
  },
};

function createBaseBgpNeighborGracefulRestartTimers(): BgpNeighborGracefulRestartTimers {
  return { configuredRestartTimer: 0, receivedRestartTimer: 0, stalePathTimer: 0 };
}

export const BgpNeighborGracefulRestartTimers: MessageFns<BgpNeighborGracefulRestartTimers> = {
  encode(message: BgpNeighborGracefulRestartTimers, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.configuredRestartTimer !== 0) {
      writer.uint32(8).uint32(message.configuredRestartTimer);
    }
    if (message.receivedRestartTimer !== 0) {
      writer.uint32(16).uint32(message.receivedRestartTimer);
    }
    if (message.stalePathTimer !== 0) {
      writer.uint32(24).uint32(message.stalePathTimer);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborGracefulRestartTimers {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborGracefulRestartTimers();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.configuredRestartTimer = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.receivedRestartTimer = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.stalePathTimer = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborGracefulRestartTimers {
    return {
      configuredRestartTimer: isSet(object.configuredRestartTimer)
        ? globalThis.Number(object.configuredRestartTimer)
        : 0,
      receivedRestartTimer: isSet(object.receivedRestartTimer) ? globalThis.Number(object.receivedRestartTimer) : 0,
      stalePathTimer: isSet(object.stalePathTimer) ? globalThis.Number(object.stalePathTimer) : 0,
    };
  },

  toJSON(message: BgpNeighborGracefulRestartTimers): unknown {
    const obj: any = {};
    if (message.configuredRestartTimer !== 0) {
      obj.configuredRestartTimer = Math.round(message.configuredRestartTimer);
    }
    if (message.receivedRestartTimer !== 0) {
      obj.receivedRestartTimer = Math.round(message.receivedRestartTimer);
    }
    if (message.stalePathTimer !== 0) {
      obj.stalePathTimer = Math.round(message.stalePathTimer);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborGracefulRestartTimers>, I>>(
    base?: I,
  ): BgpNeighborGracefulRestartTimers {
    return BgpNeighborGracefulRestartTimers.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborGracefulRestartTimers>, I>>(
    object: I,
  ): BgpNeighborGracefulRestartTimers {
    const message = createBaseBgpNeighborGracefulRestartTimers();
    message.configuredRestartTimer = object.configuredRestartTimer ?? 0;
    message.receivedRestartTimer = object.receivedRestartTimer ?? 0;
    message.stalePathTimer = object.stalePathTimer ?? 0;
    return message;
  },
};

function createBaseBgpNeighborGracefulRestartEndOfRibInfo(): BgpNeighborGracefulRestartEndOfRibInfo {
  return { l2VpnEvpn: false, ipv4Unicast: false, ipv6Unicast: false };
}

export const BgpNeighborGracefulRestartEndOfRibInfo: MessageFns<BgpNeighborGracefulRestartEndOfRibInfo> = {
  encode(message: BgpNeighborGracefulRestartEndOfRibInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.l2VpnEvpn !== false) {
      writer.uint32(8).bool(message.l2VpnEvpn);
    }
    if (message.ipv4Unicast !== false) {
      writer.uint32(16).bool(message.ipv4Unicast);
    }
    if (message.ipv6Unicast !== false) {
      writer.uint32(24).bool(message.ipv6Unicast);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborGracefulRestartEndOfRibInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborGracefulRestartEndOfRibInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.l2VpnEvpn = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.ipv4Unicast = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.ipv6Unicast = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborGracefulRestartEndOfRibInfo {
    return {
      l2VpnEvpn: isSet(object.l2VpnEvpn) ? globalThis.Boolean(object.l2VpnEvpn) : false,
      ipv4Unicast: isSet(object.ipv4Unicast) ? globalThis.Boolean(object.ipv4Unicast) : false,
      ipv6Unicast: isSet(object.ipv6Unicast) ? globalThis.Boolean(object.ipv6Unicast) : false,
    };
  },

  toJSON(message: BgpNeighborGracefulRestartEndOfRibInfo): unknown {
    const obj: any = {};
    if (message.l2VpnEvpn !== false) {
      obj.l2VpnEvpn = message.l2VpnEvpn;
    }
    if (message.ipv4Unicast !== false) {
      obj.ipv4Unicast = message.ipv4Unicast;
    }
    if (message.ipv6Unicast !== false) {
      obj.ipv6Unicast = message.ipv6Unicast;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborGracefulRestartEndOfRibInfo>, I>>(
    base?: I,
  ): BgpNeighborGracefulRestartEndOfRibInfo {
    return BgpNeighborGracefulRestartEndOfRibInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborGracefulRestartEndOfRibInfo>, I>>(
    object: I,
  ): BgpNeighborGracefulRestartEndOfRibInfo {
    const message = createBaseBgpNeighborGracefulRestartEndOfRibInfo();
    message.l2VpnEvpn = object.l2VpnEvpn ?? false;
    message.ipv4Unicast = object.ipv4Unicast ?? false;
    message.ipv6Unicast = object.ipv6Unicast ?? false;
    return message;
  },
};

function createBaseBgpNeighborGracefulRestartInfoEndOfRibStatus(): BgpNeighborGracefulRestartInfoEndOfRibStatus {
  return { fBit: false, endOfRibSend: false, endOfRibSentAfterUpdate: false, endOfRibRecv: false, timers: undefined };
}

export const BgpNeighborGracefulRestartInfoEndOfRibStatus: MessageFns<BgpNeighborGracefulRestartInfoEndOfRibStatus> = {
  encode(
    message: BgpNeighborGracefulRestartInfoEndOfRibStatus,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.fBit !== false) {
      writer.uint32(8).bool(message.fBit);
    }
    if (message.endOfRibSend !== false) {
      writer.uint32(16).bool(message.endOfRibSend);
    }
    if (message.endOfRibSentAfterUpdate !== false) {
      writer.uint32(24).bool(message.endOfRibSentAfterUpdate);
    }
    if (message.endOfRibRecv !== false) {
      writer.uint32(32).bool(message.endOfRibRecv);
    }
    if (message.timers !== undefined) {
      BgpNeighborGracefulRestartTimers.encode(message.timers, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborGracefulRestartInfoEndOfRibStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborGracefulRestartInfoEndOfRibStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fBit = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.endOfRibSend = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.endOfRibSentAfterUpdate = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.endOfRibRecv = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.timers = BgpNeighborGracefulRestartTimers.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborGracefulRestartInfoEndOfRibStatus {
    return {
      fBit: isSet(object.fBit) ? globalThis.Boolean(object.fBit) : false,
      endOfRibSend: isSet(object.endOfRibSend) ? globalThis.Boolean(object.endOfRibSend) : false,
      endOfRibSentAfterUpdate: isSet(object.endOfRibSentAfterUpdate)
        ? globalThis.Boolean(object.endOfRibSentAfterUpdate)
        : false,
      endOfRibRecv: isSet(object.endOfRibRecv) ? globalThis.Boolean(object.endOfRibRecv) : false,
      timers: isSet(object.timers) ? BgpNeighborGracefulRestartTimers.fromJSON(object.timers) : undefined,
    };
  },

  toJSON(message: BgpNeighborGracefulRestartInfoEndOfRibStatus): unknown {
    const obj: any = {};
    if (message.fBit !== false) {
      obj.fBit = message.fBit;
    }
    if (message.endOfRibSend !== false) {
      obj.endOfRibSend = message.endOfRibSend;
    }
    if (message.endOfRibSentAfterUpdate !== false) {
      obj.endOfRibSentAfterUpdate = message.endOfRibSentAfterUpdate;
    }
    if (message.endOfRibRecv !== false) {
      obj.endOfRibRecv = message.endOfRibRecv;
    }
    if (message.timers !== undefined) {
      obj.timers = BgpNeighborGracefulRestartTimers.toJSON(message.timers);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborGracefulRestartInfoEndOfRibStatus>, I>>(
    base?: I,
  ): BgpNeighborGracefulRestartInfoEndOfRibStatus {
    return BgpNeighborGracefulRestartInfoEndOfRibStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborGracefulRestartInfoEndOfRibStatus>, I>>(
    object: I,
  ): BgpNeighborGracefulRestartInfoEndOfRibStatus {
    const message = createBaseBgpNeighborGracefulRestartInfoEndOfRibStatus();
    message.fBit = object.fBit ?? false;
    message.endOfRibSend = object.endOfRibSend ?? false;
    message.endOfRibSentAfterUpdate = object.endOfRibSentAfterUpdate ?? false;
    message.endOfRibRecv = object.endOfRibRecv ?? false;
    message.timers = (object.timers !== undefined && object.timers !== null)
      ? BgpNeighborGracefulRestartTimers.fromPartial(object.timers)
      : undefined;
    return message;
  },
};

function createBaseBgpNeighborGracefulRestartInfo(): BgpNeighborGracefulRestartInfo {
  return {
    endOfRibSend: undefined,
    endOfRibRecv: undefined,
    timers: undefined,
    localGrMode: "",
    remoteGrMode: "",
    rBit: false,
    nBit: false,
    l2VpnEvpn: undefined,
    ipv4Unicast: undefined,
    ipv6Unicast: undefined,
  };
}

export const BgpNeighborGracefulRestartInfo: MessageFns<BgpNeighborGracefulRestartInfo> = {
  encode(message: BgpNeighborGracefulRestartInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.endOfRibSend !== undefined) {
      BgpNeighborGracefulRestartEndOfRibInfo.encode(message.endOfRibSend, writer.uint32(10).fork()).join();
    }
    if (message.endOfRibRecv !== undefined) {
      BgpNeighborGracefulRestartEndOfRibInfo.encode(message.endOfRibRecv, writer.uint32(18).fork()).join();
    }
    if (message.timers !== undefined) {
      BgpNeighborGracefulRestartTimers.encode(message.timers, writer.uint32(26).fork()).join();
    }
    if (message.localGrMode !== "") {
      writer.uint32(34).string(message.localGrMode);
    }
    if (message.remoteGrMode !== "") {
      writer.uint32(42).string(message.remoteGrMode);
    }
    if (message.rBit !== false) {
      writer.uint32(48).bool(message.rBit);
    }
    if (message.nBit !== false) {
      writer.uint32(56).bool(message.nBit);
    }
    if (message.l2VpnEvpn !== undefined) {
      BgpNeighborGracefulRestartInfoEndOfRibStatus.encode(message.l2VpnEvpn, writer.uint32(66).fork()).join();
    }
    if (message.ipv4Unicast !== undefined) {
      BgpNeighborGracefulRestartInfoEndOfRibStatus.encode(message.ipv4Unicast, writer.uint32(74).fork()).join();
    }
    if (message.ipv6Unicast !== undefined) {
      BgpNeighborGracefulRestartInfoEndOfRibStatus.encode(message.ipv6Unicast, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborGracefulRestartInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborGracefulRestartInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.endOfRibSend = BgpNeighborGracefulRestartEndOfRibInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.endOfRibRecv = BgpNeighborGracefulRestartEndOfRibInfo.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.timers = BgpNeighborGracefulRestartTimers.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.localGrMode = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.remoteGrMode = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.rBit = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.nBit = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.l2VpnEvpn = BgpNeighborGracefulRestartInfoEndOfRibStatus.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.ipv4Unicast = BgpNeighborGracefulRestartInfoEndOfRibStatus.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ipv6Unicast = BgpNeighborGracefulRestartInfoEndOfRibStatus.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborGracefulRestartInfo {
    return {
      endOfRibSend: isSet(object.endOfRibSend)
        ? BgpNeighborGracefulRestartEndOfRibInfo.fromJSON(object.endOfRibSend)
        : undefined,
      endOfRibRecv: isSet(object.endOfRibRecv)
        ? BgpNeighborGracefulRestartEndOfRibInfo.fromJSON(object.endOfRibRecv)
        : undefined,
      timers: isSet(object.timers) ? BgpNeighborGracefulRestartTimers.fromJSON(object.timers) : undefined,
      localGrMode: isSet(object.localGrMode) ? globalThis.String(object.localGrMode) : "",
      remoteGrMode: isSet(object.remoteGrMode) ? globalThis.String(object.remoteGrMode) : "",
      rBit: isSet(object.rBit) ? globalThis.Boolean(object.rBit) : false,
      nBit: isSet(object.nBit) ? globalThis.Boolean(object.nBit) : false,
      l2VpnEvpn: isSet(object.l2VpnEvpn)
        ? BgpNeighborGracefulRestartInfoEndOfRibStatus.fromJSON(object.l2VpnEvpn)
        : undefined,
      ipv4Unicast: isSet(object.ipv4Unicast)
        ? BgpNeighborGracefulRestartInfoEndOfRibStatus.fromJSON(object.ipv4Unicast)
        : undefined,
      ipv6Unicast: isSet(object.ipv6Unicast)
        ? BgpNeighborGracefulRestartInfoEndOfRibStatus.fromJSON(object.ipv6Unicast)
        : undefined,
    };
  },

  toJSON(message: BgpNeighborGracefulRestartInfo): unknown {
    const obj: any = {};
    if (message.endOfRibSend !== undefined) {
      obj.endOfRibSend = BgpNeighborGracefulRestartEndOfRibInfo.toJSON(message.endOfRibSend);
    }
    if (message.endOfRibRecv !== undefined) {
      obj.endOfRibRecv = BgpNeighborGracefulRestartEndOfRibInfo.toJSON(message.endOfRibRecv);
    }
    if (message.timers !== undefined) {
      obj.timers = BgpNeighborGracefulRestartTimers.toJSON(message.timers);
    }
    if (message.localGrMode !== "") {
      obj.localGrMode = message.localGrMode;
    }
    if (message.remoteGrMode !== "") {
      obj.remoteGrMode = message.remoteGrMode;
    }
    if (message.rBit !== false) {
      obj.rBit = message.rBit;
    }
    if (message.nBit !== false) {
      obj.nBit = message.nBit;
    }
    if (message.l2VpnEvpn !== undefined) {
      obj.l2VpnEvpn = BgpNeighborGracefulRestartInfoEndOfRibStatus.toJSON(message.l2VpnEvpn);
    }
    if (message.ipv4Unicast !== undefined) {
      obj.ipv4Unicast = BgpNeighborGracefulRestartInfoEndOfRibStatus.toJSON(message.ipv4Unicast);
    }
    if (message.ipv6Unicast !== undefined) {
      obj.ipv6Unicast = BgpNeighborGracefulRestartInfoEndOfRibStatus.toJSON(message.ipv6Unicast);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborGracefulRestartInfo>, I>>(base?: I): BgpNeighborGracefulRestartInfo {
    return BgpNeighborGracefulRestartInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborGracefulRestartInfo>, I>>(
    object: I,
  ): BgpNeighborGracefulRestartInfo {
    const message = createBaseBgpNeighborGracefulRestartInfo();
    message.endOfRibSend = (object.endOfRibSend !== undefined && object.endOfRibSend !== null)
      ? BgpNeighborGracefulRestartEndOfRibInfo.fromPartial(object.endOfRibSend)
      : undefined;
    message.endOfRibRecv = (object.endOfRibRecv !== undefined && object.endOfRibRecv !== null)
      ? BgpNeighborGracefulRestartEndOfRibInfo.fromPartial(object.endOfRibRecv)
      : undefined;
    message.timers = (object.timers !== undefined && object.timers !== null)
      ? BgpNeighborGracefulRestartTimers.fromPartial(object.timers)
      : undefined;
    message.localGrMode = object.localGrMode ?? "";
    message.remoteGrMode = object.remoteGrMode ?? "";
    message.rBit = object.rBit ?? false;
    message.nBit = object.nBit ?? false;
    message.l2VpnEvpn = (object.l2VpnEvpn !== undefined && object.l2VpnEvpn !== null)
      ? BgpNeighborGracefulRestartInfoEndOfRibStatus.fromPartial(object.l2VpnEvpn)
      : undefined;
    message.ipv4Unicast = (object.ipv4Unicast !== undefined && object.ipv4Unicast !== null)
      ? BgpNeighborGracefulRestartInfoEndOfRibStatus.fromPartial(object.ipv4Unicast)
      : undefined;
    message.ipv6Unicast = (object.ipv6Unicast !== undefined && object.ipv6Unicast !== null)
      ? BgpNeighborGracefulRestartInfoEndOfRibStatus.fromPartial(object.ipv6Unicast)
      : undefined;
    return message;
  },
};

function createBaseBgpNeighborInfo(): BgpNeighborInfo {
  return {
    id: undefined,
    vrfId: 0,
    vrfName: "",
    remoteAs: 0,
    localAs: 0,
    nbrExternalLink: false,
    localRole: 0,
    remoteRole: 0,
    hostname: "",
    bgpVersion: 0,
    remoteRouterId: "",
    localRouterId: "",
    bgpState: 0,
    bgpTimerUpMsec: 0,
    bgpTimerUpString: "",
    bgpTimerUpEstablishedEpoch: 0,
    bgpTimerLastRead: 0,
    bgpTimerLastWrite: 0,
    bgpInUpdateElapsedTimeMsecs: 0,
    bgpTimerConfiguredHoldTimeMsecs: 0,
    bgpTimerConfiguredKeepAliveIntervalMsecs: 0,
    bgpTimerHoldTimeMsecs: 0,
    bgpTimerKeepAliveIntervalMsecs: 0,
    extendedOptionalParametersLength: false,
    connectionsEstablished: 0,
    connectionsDropped: 0,
    lastResetTimerMsecs: 0,
    lastResetDueTo: "",
    lastResetCode: 0,
    externalBgpNbrMaxHopsAway: 0,
    hostLocal: "",
    portLocal: 0,
    hostForeign: "",
    portForeign: 0,
    nextHop: "",
    nextHopGlobal: "",
    nextHopLocal: "",
    bgpConnection: "",
    connectRetryTimer: 0,
    estimatedRttInMsecs: 0,
    readThread: 0,
    writeThread: 0,
    peerBfdInfo: undefined,
    addressFamilyInfo: undefined,
    minBtwnAdvertisementRunsTimerMsecs: 0,
    updateSource: "",
    messageStats: undefined,
    gracefulRestartInfo: undefined,
    neighborCapabilities: undefined,
    peerGroup: 0,
    bgpTimerConfiguredConditionalAdvertisementsSec: 0,
    peerAuthEnable: 0,
    internalBgpNbrMaxHopsAway: 0,
    nextHopInterface: "",
  };
}

export const BgpNeighborInfo: MessageFns<BgpNeighborInfo> = {
  encode(message: BgpNeighborInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.vrfId !== 0) {
      writer.uint32(24).uint32(message.vrfId);
    }
    if (message.vrfName !== "") {
      writer.uint32(34).string(message.vrfName);
    }
    if (message.remoteAs !== 0) {
      writer.uint32(40).uint32(message.remoteAs);
    }
    if (message.localAs !== 0) {
      writer.uint32(48).uint32(message.localAs);
    }
    if (message.nbrExternalLink !== false) {
      writer.uint32(56).bool(message.nbrExternalLink);
    }
    if (message.localRole !== 0) {
      writer.uint32(64).int32(message.localRole);
    }
    if (message.remoteRole !== 0) {
      writer.uint32(72).int32(message.remoteRole);
    }
    if (message.hostname !== "") {
      writer.uint32(82).string(message.hostname);
    }
    if (message.bgpVersion !== 0) {
      writer.uint32(88).uint32(message.bgpVersion);
    }
    if (message.remoteRouterId !== "") {
      writer.uint32(98).string(message.remoteRouterId);
    }
    if (message.localRouterId !== "") {
      writer.uint32(106).string(message.localRouterId);
    }
    if (message.bgpState !== 0) {
      writer.uint32(112).int32(message.bgpState);
    }
    if (message.bgpTimerUpMsec !== 0) {
      writer.uint32(120).uint32(message.bgpTimerUpMsec);
    }
    if (message.bgpTimerUpString !== "") {
      writer.uint32(130).string(message.bgpTimerUpString);
    }
    if (message.bgpTimerUpEstablishedEpoch !== 0) {
      writer.uint32(136).uint32(message.bgpTimerUpEstablishedEpoch);
    }
    if (message.bgpTimerLastRead !== 0) {
      writer.uint32(144).uint32(message.bgpTimerLastRead);
    }
    if (message.bgpTimerLastWrite !== 0) {
      writer.uint32(152).uint32(message.bgpTimerLastWrite);
    }
    if (message.bgpInUpdateElapsedTimeMsecs !== 0) {
      writer.uint32(160).uint32(message.bgpInUpdateElapsedTimeMsecs);
    }
    if (message.bgpTimerConfiguredHoldTimeMsecs !== 0) {
      writer.uint32(168).uint32(message.bgpTimerConfiguredHoldTimeMsecs);
    }
    if (message.bgpTimerConfiguredKeepAliveIntervalMsecs !== 0) {
      writer.uint32(176).uint32(message.bgpTimerConfiguredKeepAliveIntervalMsecs);
    }
    if (message.bgpTimerHoldTimeMsecs !== 0) {
      writer.uint32(184).uint32(message.bgpTimerHoldTimeMsecs);
    }
    if (message.bgpTimerKeepAliveIntervalMsecs !== 0) {
      writer.uint32(192).uint32(message.bgpTimerKeepAliveIntervalMsecs);
    }
    if (message.extendedOptionalParametersLength !== false) {
      writer.uint32(200).bool(message.extendedOptionalParametersLength);
    }
    if (message.connectionsEstablished !== 0) {
      writer.uint32(208).uint32(message.connectionsEstablished);
    }
    if (message.connectionsDropped !== 0) {
      writer.uint32(216).uint32(message.connectionsDropped);
    }
    if (message.lastResetTimerMsecs !== 0) {
      writer.uint32(224).uint32(message.lastResetTimerMsecs);
    }
    if (message.lastResetDueTo !== "") {
      writer.uint32(234).string(message.lastResetDueTo);
    }
    if (message.lastResetCode !== 0) {
      writer.uint32(240).uint32(message.lastResetCode);
    }
    if (message.externalBgpNbrMaxHopsAway !== 0) {
      writer.uint32(248).uint32(message.externalBgpNbrMaxHopsAway);
    }
    if (message.hostLocal !== "") {
      writer.uint32(258).string(message.hostLocal);
    }
    if (message.portLocal !== 0) {
      writer.uint32(264).uint32(message.portLocal);
    }
    if (message.hostForeign !== "") {
      writer.uint32(274).string(message.hostForeign);
    }
    if (message.portForeign !== 0) {
      writer.uint32(280).uint32(message.portForeign);
    }
    if (message.nextHop !== "") {
      writer.uint32(290).string(message.nextHop);
    }
    if (message.nextHopGlobal !== "") {
      writer.uint32(298).string(message.nextHopGlobal);
    }
    if (message.nextHopLocal !== "") {
      writer.uint32(306).string(message.nextHopLocal);
    }
    if (message.bgpConnection !== "") {
      writer.uint32(314).string(message.bgpConnection);
    }
    if (message.connectRetryTimer !== 0) {
      writer.uint32(320).uint32(message.connectRetryTimer);
    }
    if (message.estimatedRttInMsecs !== 0) {
      writer.uint32(328).uint32(message.estimatedRttInMsecs);
    }
    if (message.readThread !== 0) {
      writer.uint32(336).int32(message.readThread);
    }
    if (message.writeThread !== 0) {
      writer.uint32(344).int32(message.writeThread);
    }
    if (message.peerBfdInfo !== undefined) {
      BgpPeerBfdInfo.encode(message.peerBfdInfo, writer.uint32(354).fork()).join();
    }
    if (message.addressFamilyInfo !== undefined) {
      BgpNeighborAddressFamily.encode(message.addressFamilyInfo, writer.uint32(362).fork()).join();
    }
    if (message.minBtwnAdvertisementRunsTimerMsecs !== 0) {
      writer.uint32(368).uint32(message.minBtwnAdvertisementRunsTimerMsecs);
    }
    if (message.updateSource !== "") {
      writer.uint32(378).string(message.updateSource);
    }
    if (message.messageStats !== undefined) {
      BgpNeighborMessageStats.encode(message.messageStats, writer.uint32(386).fork()).join();
    }
    if (message.gracefulRestartInfo !== undefined) {
      BgpNeighborGracefulRestartInfo.encode(message.gracefulRestartInfo, writer.uint32(394).fork()).join();
    }
    if (message.neighborCapabilities !== undefined) {
      BgpNeighborCapabilities.encode(message.neighborCapabilities, writer.uint32(402).fork()).join();
    }
    if (message.peerGroup !== 0) {
      writer.uint32(408).int32(message.peerGroup);
    }
    if (message.bgpTimerConfiguredConditionalAdvertisementsSec !== 0) {
      writer.uint32(416).uint32(message.bgpTimerConfiguredConditionalAdvertisementsSec);
    }
    if (message.peerAuthEnable !== 0) {
      writer.uint32(424).int32(message.peerAuthEnable);
    }
    if (message.internalBgpNbrMaxHopsAway !== 0) {
      writer.uint32(432).uint32(message.internalBgpNbrMaxHopsAway);
    }
    if (message.nextHopInterface !== "") {
      writer.uint32(442).string(message.nextHopInterface);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vrfId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.vrfName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.remoteAs = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.localAs = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.nbrExternalLink = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.localRole = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.remoteRole = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.hostname = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.bgpVersion = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.remoteRouterId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.localRouterId = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.bgpState = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.bgpTimerUpMsec = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.bgpTimerUpString = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.bgpTimerUpEstablishedEpoch = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.bgpTimerLastRead = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.bgpTimerLastWrite = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.bgpInUpdateElapsedTimeMsecs = reader.uint32();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.bgpTimerConfiguredHoldTimeMsecs = reader.uint32();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.bgpTimerConfiguredKeepAliveIntervalMsecs = reader.uint32();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.bgpTimerHoldTimeMsecs = reader.uint32();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.bgpTimerKeepAliveIntervalMsecs = reader.uint32();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.extendedOptionalParametersLength = reader.bool();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.connectionsEstablished = reader.uint32();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.connectionsDropped = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.lastResetTimerMsecs = reader.uint32();
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.lastResetDueTo = reader.string();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.lastResetCode = reader.uint32();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.externalBgpNbrMaxHopsAway = reader.uint32();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.hostLocal = reader.string();
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.portLocal = reader.uint32();
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.hostForeign = reader.string();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.portForeign = reader.uint32();
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.nextHop = reader.string();
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.nextHopGlobal = reader.string();
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.nextHopLocal = reader.string();
          continue;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.bgpConnection = reader.string();
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.connectRetryTimer = reader.uint32();
          continue;
        }
        case 41: {
          if (tag !== 328) {
            break;
          }

          message.estimatedRttInMsecs = reader.uint32();
          continue;
        }
        case 42: {
          if (tag !== 336) {
            break;
          }

          message.readThread = reader.int32() as any;
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.writeThread = reader.int32() as any;
          continue;
        }
        case 44: {
          if (tag !== 354) {
            break;
          }

          message.peerBfdInfo = BgpPeerBfdInfo.decode(reader, reader.uint32());
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.addressFamilyInfo = BgpNeighborAddressFamily.decode(reader, reader.uint32());
          continue;
        }
        case 46: {
          if (tag !== 368) {
            break;
          }

          message.minBtwnAdvertisementRunsTimerMsecs = reader.uint32();
          continue;
        }
        case 47: {
          if (tag !== 378) {
            break;
          }

          message.updateSource = reader.string();
          continue;
        }
        case 48: {
          if (tag !== 386) {
            break;
          }

          message.messageStats = BgpNeighborMessageStats.decode(reader, reader.uint32());
          continue;
        }
        case 49: {
          if (tag !== 394) {
            break;
          }

          message.gracefulRestartInfo = BgpNeighborGracefulRestartInfo.decode(reader, reader.uint32());
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.neighborCapabilities = BgpNeighborCapabilities.decode(reader, reader.uint32());
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.peerGroup = reader.int32() as any;
          continue;
        }
        case 52: {
          if (tag !== 416) {
            break;
          }

          message.bgpTimerConfiguredConditionalAdvertisementsSec = reader.uint32();
          continue;
        }
        case 53: {
          if (tag !== 424) {
            break;
          }

          message.peerAuthEnable = reader.int32() as any;
          continue;
        }
        case 54: {
          if (tag !== 432) {
            break;
          }

          message.internalBgpNbrMaxHopsAway = reader.uint32();
          continue;
        }
        case 55: {
          if (tag !== 442) {
            break;
          }

          message.nextHopInterface = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vrfId: isSet(object.vrfId) ? globalThis.Number(object.vrfId) : 0,
      vrfName: isSet(object.vrfName) ? globalThis.String(object.vrfName) : "",
      remoteAs: isSet(object.remoteAs) ? globalThis.Number(object.remoteAs) : 0,
      localAs: isSet(object.localAs) ? globalThis.Number(object.localAs) : 0,
      nbrExternalLink: isSet(object.nbrExternalLink) ? globalThis.Boolean(object.nbrExternalLink) : false,
      localRole: isSet(object.localRole) ? bgpNeighborRoleFromJSON(object.localRole) : 0,
      remoteRole: isSet(object.remoteRole) ? bgpNeighborRoleFromJSON(object.remoteRole) : 0,
      hostname: isSet(object.hostname) ? globalThis.String(object.hostname) : "",
      bgpVersion: isSet(object.bgpVersion) ? globalThis.Number(object.bgpVersion) : 0,
      remoteRouterId: isSet(object.remoteRouterId) ? globalThis.String(object.remoteRouterId) : "",
      localRouterId: isSet(object.localRouterId) ? globalThis.String(object.localRouterId) : "",
      bgpState: isSet(object.bgpState) ? bgpPeerConnectionStateFromJSON(object.bgpState) : 0,
      bgpTimerUpMsec: isSet(object.bgpTimerUpMsec) ? globalThis.Number(object.bgpTimerUpMsec) : 0,
      bgpTimerUpString: isSet(object.bgpTimerUpString) ? globalThis.String(object.bgpTimerUpString) : "",
      bgpTimerUpEstablishedEpoch: isSet(object.bgpTimerUpEstablishedEpoch)
        ? globalThis.Number(object.bgpTimerUpEstablishedEpoch)
        : 0,
      bgpTimerLastRead: isSet(object.bgpTimerLastRead) ? globalThis.Number(object.bgpTimerLastRead) : 0,
      bgpTimerLastWrite: isSet(object.bgpTimerLastWrite) ? globalThis.Number(object.bgpTimerLastWrite) : 0,
      bgpInUpdateElapsedTimeMsecs: isSet(object.bgpInUpdateElapsedTimeMsecs)
        ? globalThis.Number(object.bgpInUpdateElapsedTimeMsecs)
        : 0,
      bgpTimerConfiguredHoldTimeMsecs: isSet(object.bgpTimerConfiguredHoldTimeMsecs)
        ? globalThis.Number(object.bgpTimerConfiguredHoldTimeMsecs)
        : 0,
      bgpTimerConfiguredKeepAliveIntervalMsecs: isSet(object.bgpTimerConfiguredKeepAliveIntervalMsecs)
        ? globalThis.Number(object.bgpTimerConfiguredKeepAliveIntervalMsecs)
        : 0,
      bgpTimerHoldTimeMsecs: isSet(object.bgpTimerHoldTimeMsecs) ? globalThis.Number(object.bgpTimerHoldTimeMsecs) : 0,
      bgpTimerKeepAliveIntervalMsecs: isSet(object.bgpTimerKeepAliveIntervalMsecs)
        ? globalThis.Number(object.bgpTimerKeepAliveIntervalMsecs)
        : 0,
      extendedOptionalParametersLength: isSet(object.extendedOptionalParametersLength)
        ? globalThis.Boolean(object.extendedOptionalParametersLength)
        : false,
      connectionsEstablished: isSet(object.connectionsEstablished)
        ? globalThis.Number(object.connectionsEstablished)
        : 0,
      connectionsDropped: isSet(object.connectionsDropped) ? globalThis.Number(object.connectionsDropped) : 0,
      lastResetTimerMsecs: isSet(object.lastResetTimerMsecs) ? globalThis.Number(object.lastResetTimerMsecs) : 0,
      lastResetDueTo: isSet(object.lastResetDueTo) ? globalThis.String(object.lastResetDueTo) : "",
      lastResetCode: isSet(object.lastResetCode) ? globalThis.Number(object.lastResetCode) : 0,
      externalBgpNbrMaxHopsAway: isSet(object.externalBgpNbrMaxHopsAway)
        ? globalThis.Number(object.externalBgpNbrMaxHopsAway)
        : 0,
      hostLocal: isSet(object.hostLocal) ? globalThis.String(object.hostLocal) : "",
      portLocal: isSet(object.portLocal) ? globalThis.Number(object.portLocal) : 0,
      hostForeign: isSet(object.hostForeign) ? globalThis.String(object.hostForeign) : "",
      portForeign: isSet(object.portForeign) ? globalThis.Number(object.portForeign) : 0,
      nextHop: isSet(object.nextHop) ? globalThis.String(object.nextHop) : "",
      nextHopGlobal: isSet(object.nextHopGlobal) ? globalThis.String(object.nextHopGlobal) : "",
      nextHopLocal: isSet(object.nextHopLocal) ? globalThis.String(object.nextHopLocal) : "",
      bgpConnection: isSet(object.bgpConnection) ? globalThis.String(object.bgpConnection) : "",
      connectRetryTimer: isSet(object.connectRetryTimer) ? globalThis.Number(object.connectRetryTimer) : 0,
      estimatedRttInMsecs: isSet(object.estimatedRttInMsecs) ? globalThis.Number(object.estimatedRttInMsecs) : 0,
      readThread: isSet(object.readThread) ? bgpNeighborThreadStateFromJSON(object.readThread) : 0,
      writeThread: isSet(object.writeThread) ? bgpNeighborThreadStateFromJSON(object.writeThread) : 0,
      peerBfdInfo: isSet(object.peerBfdInfo) ? BgpPeerBfdInfo.fromJSON(object.peerBfdInfo) : undefined,
      addressFamilyInfo: isSet(object.addressFamilyInfo)
        ? BgpNeighborAddressFamily.fromJSON(object.addressFamilyInfo)
        : undefined,
      minBtwnAdvertisementRunsTimerMsecs: isSet(object.minBtwnAdvertisementRunsTimerMsecs)
        ? globalThis.Number(object.minBtwnAdvertisementRunsTimerMsecs)
        : 0,
      updateSource: isSet(object.updateSource) ? globalThis.String(object.updateSource) : "",
      messageStats: isSet(object.messageStats) ? BgpNeighborMessageStats.fromJSON(object.messageStats) : undefined,
      gracefulRestartInfo: isSet(object.gracefulRestartInfo)
        ? BgpNeighborGracefulRestartInfo.fromJSON(object.gracefulRestartInfo)
        : undefined,
      neighborCapabilities: isSet(object.neighborCapabilities)
        ? BgpNeighborCapabilities.fromJSON(object.neighborCapabilities)
        : undefined,
      peerGroup: isSet(object.peerGroup) ? bgpNeighborPeerGroupFromJSON(object.peerGroup) : 0,
      bgpTimerConfiguredConditionalAdvertisementsSec: isSet(object.bgpTimerConfiguredConditionalAdvertisementsSec)
        ? globalThis.Number(object.bgpTimerConfiguredConditionalAdvertisementsSec)
        : 0,
      peerAuthEnable: isSet(object.peerAuthEnable) ? bgpPeerAuthenticationStatusFromJSON(object.peerAuthEnable) : 0,
      internalBgpNbrMaxHopsAway: isSet(object.internalBgpNbrMaxHopsAway)
        ? globalThis.Number(object.internalBgpNbrMaxHopsAway)
        : 0,
      nextHopInterface: isSet(object.nextHopInterface) ? globalThis.String(object.nextHopInterface) : "",
    };
  },

  toJSON(message: BgpNeighborInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vrfId !== 0) {
      obj.vrfId = Math.round(message.vrfId);
    }
    if (message.vrfName !== "") {
      obj.vrfName = message.vrfName;
    }
    if (message.remoteAs !== 0) {
      obj.remoteAs = Math.round(message.remoteAs);
    }
    if (message.localAs !== 0) {
      obj.localAs = Math.round(message.localAs);
    }
    if (message.nbrExternalLink !== false) {
      obj.nbrExternalLink = message.nbrExternalLink;
    }
    if (message.localRole !== 0) {
      obj.localRole = bgpNeighborRoleToJSON(message.localRole);
    }
    if (message.remoteRole !== 0) {
      obj.remoteRole = bgpNeighborRoleToJSON(message.remoteRole);
    }
    if (message.hostname !== "") {
      obj.hostname = message.hostname;
    }
    if (message.bgpVersion !== 0) {
      obj.bgpVersion = Math.round(message.bgpVersion);
    }
    if (message.remoteRouterId !== "") {
      obj.remoteRouterId = message.remoteRouterId;
    }
    if (message.localRouterId !== "") {
      obj.localRouterId = message.localRouterId;
    }
    if (message.bgpState !== 0) {
      obj.bgpState = bgpPeerConnectionStateToJSON(message.bgpState);
    }
    if (message.bgpTimerUpMsec !== 0) {
      obj.bgpTimerUpMsec = Math.round(message.bgpTimerUpMsec);
    }
    if (message.bgpTimerUpString !== "") {
      obj.bgpTimerUpString = message.bgpTimerUpString;
    }
    if (message.bgpTimerUpEstablishedEpoch !== 0) {
      obj.bgpTimerUpEstablishedEpoch = Math.round(message.bgpTimerUpEstablishedEpoch);
    }
    if (message.bgpTimerLastRead !== 0) {
      obj.bgpTimerLastRead = Math.round(message.bgpTimerLastRead);
    }
    if (message.bgpTimerLastWrite !== 0) {
      obj.bgpTimerLastWrite = Math.round(message.bgpTimerLastWrite);
    }
    if (message.bgpInUpdateElapsedTimeMsecs !== 0) {
      obj.bgpInUpdateElapsedTimeMsecs = Math.round(message.bgpInUpdateElapsedTimeMsecs);
    }
    if (message.bgpTimerConfiguredHoldTimeMsecs !== 0) {
      obj.bgpTimerConfiguredHoldTimeMsecs = Math.round(message.bgpTimerConfiguredHoldTimeMsecs);
    }
    if (message.bgpTimerConfiguredKeepAliveIntervalMsecs !== 0) {
      obj.bgpTimerConfiguredKeepAliveIntervalMsecs = Math.round(message.bgpTimerConfiguredKeepAliveIntervalMsecs);
    }
    if (message.bgpTimerHoldTimeMsecs !== 0) {
      obj.bgpTimerHoldTimeMsecs = Math.round(message.bgpTimerHoldTimeMsecs);
    }
    if (message.bgpTimerKeepAliveIntervalMsecs !== 0) {
      obj.bgpTimerKeepAliveIntervalMsecs = Math.round(message.bgpTimerKeepAliveIntervalMsecs);
    }
    if (message.extendedOptionalParametersLength !== false) {
      obj.extendedOptionalParametersLength = message.extendedOptionalParametersLength;
    }
    if (message.connectionsEstablished !== 0) {
      obj.connectionsEstablished = Math.round(message.connectionsEstablished);
    }
    if (message.connectionsDropped !== 0) {
      obj.connectionsDropped = Math.round(message.connectionsDropped);
    }
    if (message.lastResetTimerMsecs !== 0) {
      obj.lastResetTimerMsecs = Math.round(message.lastResetTimerMsecs);
    }
    if (message.lastResetDueTo !== "") {
      obj.lastResetDueTo = message.lastResetDueTo;
    }
    if (message.lastResetCode !== 0) {
      obj.lastResetCode = Math.round(message.lastResetCode);
    }
    if (message.externalBgpNbrMaxHopsAway !== 0) {
      obj.externalBgpNbrMaxHopsAway = Math.round(message.externalBgpNbrMaxHopsAway);
    }
    if (message.hostLocal !== "") {
      obj.hostLocal = message.hostLocal;
    }
    if (message.portLocal !== 0) {
      obj.portLocal = Math.round(message.portLocal);
    }
    if (message.hostForeign !== "") {
      obj.hostForeign = message.hostForeign;
    }
    if (message.portForeign !== 0) {
      obj.portForeign = Math.round(message.portForeign);
    }
    if (message.nextHop !== "") {
      obj.nextHop = message.nextHop;
    }
    if (message.nextHopGlobal !== "") {
      obj.nextHopGlobal = message.nextHopGlobal;
    }
    if (message.nextHopLocal !== "") {
      obj.nextHopLocal = message.nextHopLocal;
    }
    if (message.bgpConnection !== "") {
      obj.bgpConnection = message.bgpConnection;
    }
    if (message.connectRetryTimer !== 0) {
      obj.connectRetryTimer = Math.round(message.connectRetryTimer);
    }
    if (message.estimatedRttInMsecs !== 0) {
      obj.estimatedRttInMsecs = Math.round(message.estimatedRttInMsecs);
    }
    if (message.readThread !== 0) {
      obj.readThread = bgpNeighborThreadStateToJSON(message.readThread);
    }
    if (message.writeThread !== 0) {
      obj.writeThread = bgpNeighborThreadStateToJSON(message.writeThread);
    }
    if (message.peerBfdInfo !== undefined) {
      obj.peerBfdInfo = BgpPeerBfdInfo.toJSON(message.peerBfdInfo);
    }
    if (message.addressFamilyInfo !== undefined) {
      obj.addressFamilyInfo = BgpNeighborAddressFamily.toJSON(message.addressFamilyInfo);
    }
    if (message.minBtwnAdvertisementRunsTimerMsecs !== 0) {
      obj.minBtwnAdvertisementRunsTimerMsecs = Math.round(message.minBtwnAdvertisementRunsTimerMsecs);
    }
    if (message.updateSource !== "") {
      obj.updateSource = message.updateSource;
    }
    if (message.messageStats !== undefined) {
      obj.messageStats = BgpNeighborMessageStats.toJSON(message.messageStats);
    }
    if (message.gracefulRestartInfo !== undefined) {
      obj.gracefulRestartInfo = BgpNeighborGracefulRestartInfo.toJSON(message.gracefulRestartInfo);
    }
    if (message.neighborCapabilities !== undefined) {
      obj.neighborCapabilities = BgpNeighborCapabilities.toJSON(message.neighborCapabilities);
    }
    if (message.peerGroup !== 0) {
      obj.peerGroup = bgpNeighborPeerGroupToJSON(message.peerGroup);
    }
    if (message.bgpTimerConfiguredConditionalAdvertisementsSec !== 0) {
      obj.bgpTimerConfiguredConditionalAdvertisementsSec = Math.round(
        message.bgpTimerConfiguredConditionalAdvertisementsSec,
      );
    }
    if (message.peerAuthEnable !== 0) {
      obj.peerAuthEnable = bgpPeerAuthenticationStatusToJSON(message.peerAuthEnable);
    }
    if (message.internalBgpNbrMaxHopsAway !== 0) {
      obj.internalBgpNbrMaxHopsAway = Math.round(message.internalBgpNbrMaxHopsAway);
    }
    if (message.nextHopInterface !== "") {
      obj.nextHopInterface = message.nextHopInterface;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborInfo>, I>>(base?: I): BgpNeighborInfo {
    return BgpNeighborInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborInfo>, I>>(object: I): BgpNeighborInfo {
    const message = createBaseBgpNeighborInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vrfId = object.vrfId ?? 0;
    message.vrfName = object.vrfName ?? "";
    message.remoteAs = object.remoteAs ?? 0;
    message.localAs = object.localAs ?? 0;
    message.nbrExternalLink = object.nbrExternalLink ?? false;
    message.localRole = object.localRole ?? 0;
    message.remoteRole = object.remoteRole ?? 0;
    message.hostname = object.hostname ?? "";
    message.bgpVersion = object.bgpVersion ?? 0;
    message.remoteRouterId = object.remoteRouterId ?? "";
    message.localRouterId = object.localRouterId ?? "";
    message.bgpState = object.bgpState ?? 0;
    message.bgpTimerUpMsec = object.bgpTimerUpMsec ?? 0;
    message.bgpTimerUpString = object.bgpTimerUpString ?? "";
    message.bgpTimerUpEstablishedEpoch = object.bgpTimerUpEstablishedEpoch ?? 0;
    message.bgpTimerLastRead = object.bgpTimerLastRead ?? 0;
    message.bgpTimerLastWrite = object.bgpTimerLastWrite ?? 0;
    message.bgpInUpdateElapsedTimeMsecs = object.bgpInUpdateElapsedTimeMsecs ?? 0;
    message.bgpTimerConfiguredHoldTimeMsecs = object.bgpTimerConfiguredHoldTimeMsecs ?? 0;
    message.bgpTimerConfiguredKeepAliveIntervalMsecs = object.bgpTimerConfiguredKeepAliveIntervalMsecs ?? 0;
    message.bgpTimerHoldTimeMsecs = object.bgpTimerHoldTimeMsecs ?? 0;
    message.bgpTimerKeepAliveIntervalMsecs = object.bgpTimerKeepAliveIntervalMsecs ?? 0;
    message.extendedOptionalParametersLength = object.extendedOptionalParametersLength ?? false;
    message.connectionsEstablished = object.connectionsEstablished ?? 0;
    message.connectionsDropped = object.connectionsDropped ?? 0;
    message.lastResetTimerMsecs = object.lastResetTimerMsecs ?? 0;
    message.lastResetDueTo = object.lastResetDueTo ?? "";
    message.lastResetCode = object.lastResetCode ?? 0;
    message.externalBgpNbrMaxHopsAway = object.externalBgpNbrMaxHopsAway ?? 0;
    message.hostLocal = object.hostLocal ?? "";
    message.portLocal = object.portLocal ?? 0;
    message.hostForeign = object.hostForeign ?? "";
    message.portForeign = object.portForeign ?? 0;
    message.nextHop = object.nextHop ?? "";
    message.nextHopGlobal = object.nextHopGlobal ?? "";
    message.nextHopLocal = object.nextHopLocal ?? "";
    message.bgpConnection = object.bgpConnection ?? "";
    message.connectRetryTimer = object.connectRetryTimer ?? 0;
    message.estimatedRttInMsecs = object.estimatedRttInMsecs ?? 0;
    message.readThread = object.readThread ?? 0;
    message.writeThread = object.writeThread ?? 0;
    message.peerBfdInfo = (object.peerBfdInfo !== undefined && object.peerBfdInfo !== null)
      ? BgpPeerBfdInfo.fromPartial(object.peerBfdInfo)
      : undefined;
    message.addressFamilyInfo = (object.addressFamilyInfo !== undefined && object.addressFamilyInfo !== null)
      ? BgpNeighborAddressFamily.fromPartial(object.addressFamilyInfo)
      : undefined;
    message.minBtwnAdvertisementRunsTimerMsecs = object.minBtwnAdvertisementRunsTimerMsecs ?? 0;
    message.updateSource = object.updateSource ?? "";
    message.messageStats = (object.messageStats !== undefined && object.messageStats !== null)
      ? BgpNeighborMessageStats.fromPartial(object.messageStats)
      : undefined;
    message.gracefulRestartInfo = (object.gracefulRestartInfo !== undefined && object.gracefulRestartInfo !== null)
      ? BgpNeighborGracefulRestartInfo.fromPartial(object.gracefulRestartInfo)
      : undefined;
    message.neighborCapabilities = (object.neighborCapabilities !== undefined && object.neighborCapabilities !== null)
      ? BgpNeighborCapabilities.fromPartial(object.neighborCapabilities)
      : undefined;
    message.peerGroup = object.peerGroup ?? 0;
    message.bgpTimerConfiguredConditionalAdvertisementsSec = object.bgpTimerConfiguredConditionalAdvertisementsSec ?? 0;
    message.peerAuthEnable = object.peerAuthEnable ?? 0;
    message.internalBgpNbrMaxHopsAway = object.internalBgpNbrMaxHopsAway ?? 0;
    message.nextHopInterface = object.nextHopInterface ?? "";
    return message;
  },
};

function createBaseBgpNeighborReceivedRoute(): BgpNeighborReceivedRoute {
  return {
    id: undefined,
    bgpLocalRouterId: "",
    bgpTableVersion: 0,
    localAs: 0,
    addrPrefix: "",
    prefixLen: 0,
    network: "",
    nextHop: "",
    metric: 0,
    weight: 0,
    path: "",
    valid: false,
    best: false,
    suppressed: false,
    damped: false,
    history: false,
    internal: false,
    ribFailure: false,
    stale: false,
    bgpOriginCode: "",
    origin: 0,
    receivedRoute: "",
    bgpNeighborOriginVrf: "",
    bgpNeighborOriginAddressFamily: 0,
    defaultLocPrf: 0,
    totalPrefixCounter: 0,
    filteredPrefixCounter: 0,
    collectedAt: undefined,
    locPrf: 0,
    isAsPathTruncated: false,
    community: "",
  };
}

export const BgpNeighborReceivedRoute: MessageFns<BgpNeighborReceivedRoute> = {
  encode(message: BgpNeighborReceivedRoute, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.bgpLocalRouterId !== "") {
      writer.uint32(26).string(message.bgpLocalRouterId);
    }
    if (message.bgpTableVersion !== 0) {
      writer.uint32(32).uint32(message.bgpTableVersion);
    }
    if (message.localAs !== 0) {
      writer.uint32(40).uint32(message.localAs);
    }
    if (message.addrPrefix !== "") {
      writer.uint32(50).string(message.addrPrefix);
    }
    if (message.prefixLen !== 0) {
      writer.uint32(56).uint32(message.prefixLen);
    }
    if (message.network !== "") {
      writer.uint32(66).string(message.network);
    }
    if (message.nextHop !== "") {
      writer.uint32(74).string(message.nextHop);
    }
    if (message.metric !== 0) {
      writer.uint32(80).uint32(message.metric);
    }
    if (message.weight !== 0) {
      writer.uint32(88).uint32(message.weight);
    }
    if (message.path !== "") {
      writer.uint32(98).string(message.path);
    }
    if (message.valid !== false) {
      writer.uint32(104).bool(message.valid);
    }
    if (message.best !== false) {
      writer.uint32(112).bool(message.best);
    }
    if (message.suppressed !== false) {
      writer.uint32(128).bool(message.suppressed);
    }
    if (message.damped !== false) {
      writer.uint32(136).bool(message.damped);
    }
    if (message.history !== false) {
      writer.uint32(144).bool(message.history);
    }
    if (message.internal !== false) {
      writer.uint32(152).bool(message.internal);
    }
    if (message.ribFailure !== false) {
      writer.uint32(160).bool(message.ribFailure);
    }
    if (message.stale !== false) {
      writer.uint32(168).bool(message.stale);
    }
    if (message.bgpOriginCode !== "") {
      writer.uint32(178).string(message.bgpOriginCode);
    }
    if (message.origin !== 0) {
      writer.uint32(184).int32(message.origin);
    }
    if (message.receivedRoute !== "") {
      writer.uint32(194).string(message.receivedRoute);
    }
    if (message.bgpNeighborOriginVrf !== "") {
      writer.uint32(202).string(message.bgpNeighborOriginVrf);
    }
    if (message.bgpNeighborOriginAddressFamily !== 0) {
      writer.uint32(208).int32(message.bgpNeighborOriginAddressFamily);
    }
    if (message.defaultLocPrf !== 0) {
      writer.uint32(216).uint32(message.defaultLocPrf);
    }
    if (message.totalPrefixCounter !== 0) {
      writer.uint32(224).uint32(message.totalPrefixCounter);
    }
    if (message.filteredPrefixCounter !== 0) {
      writer.uint32(232).uint32(message.filteredPrefixCounter);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(242).fork()).join();
    }
    if (message.locPrf !== 0) {
      writer.uint32(248).uint32(message.locPrf);
    }
    if (message.isAsPathTruncated !== false) {
      writer.uint32(256).bool(message.isAsPathTruncated);
    }
    if (message.community !== "") {
      writer.uint32(266).string(message.community);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborReceivedRoute {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborReceivedRoute();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.bgpLocalRouterId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.bgpTableVersion = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.localAs = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.addrPrefix = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.prefixLen = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.network = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.nextHop = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.metric = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.weight = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.path = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.valid = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.best = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.suppressed = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.damped = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.history = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.internal = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.ribFailure = reader.bool();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.stale = reader.bool();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.bgpOriginCode = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.origin = reader.int32() as any;
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.receivedRoute = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.bgpNeighborOriginVrf = reader.string();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.bgpNeighborOriginAddressFamily = reader.int32() as any;
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.defaultLocPrf = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.totalPrefixCounter = reader.uint32();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.filteredPrefixCounter = reader.uint32();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.locPrf = reader.uint32();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.isAsPathTruncated = reader.bool();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.community = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborReceivedRoute {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      bgpLocalRouterId: isSet(object.bgpLocalRouterId) ? globalThis.String(object.bgpLocalRouterId) : "",
      bgpTableVersion: isSet(object.bgpTableVersion) ? globalThis.Number(object.bgpTableVersion) : 0,
      localAs: isSet(object.localAs) ? globalThis.Number(object.localAs) : 0,
      addrPrefix: isSet(object.addrPrefix) ? globalThis.String(object.addrPrefix) : "",
      prefixLen: isSet(object.prefixLen) ? globalThis.Number(object.prefixLen) : 0,
      network: isSet(object.network) ? globalThis.String(object.network) : "",
      nextHop: isSet(object.nextHop) ? globalThis.String(object.nextHop) : "",
      metric: isSet(object.metric) ? globalThis.Number(object.metric) : 0,
      weight: isSet(object.weight) ? globalThis.Number(object.weight) : 0,
      path: isSet(object.path) ? globalThis.String(object.path) : "",
      valid: isSet(object.valid) ? globalThis.Boolean(object.valid) : false,
      best: isSet(object.best) ? globalThis.Boolean(object.best) : false,
      suppressed: isSet(object.suppressed) ? globalThis.Boolean(object.suppressed) : false,
      damped: isSet(object.damped) ? globalThis.Boolean(object.damped) : false,
      history: isSet(object.history) ? globalThis.Boolean(object.history) : false,
      internal: isSet(object.internal) ? globalThis.Boolean(object.internal) : false,
      ribFailure: isSet(object.ribFailure) ? globalThis.Boolean(object.ribFailure) : false,
      stale: isSet(object.stale) ? globalThis.Boolean(object.stale) : false,
      bgpOriginCode: isSet(object.bgpOriginCode) ? globalThis.String(object.bgpOriginCode) : "",
      origin: isSet(object.origin) ? bgpNeighborReceivedRouteOriginFromJSON(object.origin) : 0,
      receivedRoute: isSet(object.receivedRoute) ? globalThis.String(object.receivedRoute) : "",
      bgpNeighborOriginVrf: isSet(object.bgpNeighborOriginVrf) ? globalThis.String(object.bgpNeighborOriginVrf) : "",
      bgpNeighborOriginAddressFamily: isSet(object.bgpNeighborOriginAddressFamily)
        ? bgpAddressFamilyFromJSON(object.bgpNeighborOriginAddressFamily)
        : 0,
      defaultLocPrf: isSet(object.defaultLocPrf) ? globalThis.Number(object.defaultLocPrf) : 0,
      totalPrefixCounter: isSet(object.totalPrefixCounter) ? globalThis.Number(object.totalPrefixCounter) : 0,
      filteredPrefixCounter: isSet(object.filteredPrefixCounter) ? globalThis.Number(object.filteredPrefixCounter) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      locPrf: isSet(object.locPrf) ? globalThis.Number(object.locPrf) : 0,
      isAsPathTruncated: isSet(object.isAsPathTruncated) ? globalThis.Boolean(object.isAsPathTruncated) : false,
      community: isSet(object.community) ? globalThis.String(object.community) : "",
    };
  },

  toJSON(message: BgpNeighborReceivedRoute): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.bgpLocalRouterId !== "") {
      obj.bgpLocalRouterId = message.bgpLocalRouterId;
    }
    if (message.bgpTableVersion !== 0) {
      obj.bgpTableVersion = Math.round(message.bgpTableVersion);
    }
    if (message.localAs !== 0) {
      obj.localAs = Math.round(message.localAs);
    }
    if (message.addrPrefix !== "") {
      obj.addrPrefix = message.addrPrefix;
    }
    if (message.prefixLen !== 0) {
      obj.prefixLen = Math.round(message.prefixLen);
    }
    if (message.network !== "") {
      obj.network = message.network;
    }
    if (message.nextHop !== "") {
      obj.nextHop = message.nextHop;
    }
    if (message.metric !== 0) {
      obj.metric = Math.round(message.metric);
    }
    if (message.weight !== 0) {
      obj.weight = Math.round(message.weight);
    }
    if (message.path !== "") {
      obj.path = message.path;
    }
    if (message.valid !== false) {
      obj.valid = message.valid;
    }
    if (message.best !== false) {
      obj.best = message.best;
    }
    if (message.suppressed !== false) {
      obj.suppressed = message.suppressed;
    }
    if (message.damped !== false) {
      obj.damped = message.damped;
    }
    if (message.history !== false) {
      obj.history = message.history;
    }
    if (message.internal !== false) {
      obj.internal = message.internal;
    }
    if (message.ribFailure !== false) {
      obj.ribFailure = message.ribFailure;
    }
    if (message.stale !== false) {
      obj.stale = message.stale;
    }
    if (message.bgpOriginCode !== "") {
      obj.bgpOriginCode = message.bgpOriginCode;
    }
    if (message.origin !== 0) {
      obj.origin = bgpNeighborReceivedRouteOriginToJSON(message.origin);
    }
    if (message.receivedRoute !== "") {
      obj.receivedRoute = message.receivedRoute;
    }
    if (message.bgpNeighborOriginVrf !== "") {
      obj.bgpNeighborOriginVrf = message.bgpNeighborOriginVrf;
    }
    if (message.bgpNeighborOriginAddressFamily !== 0) {
      obj.bgpNeighborOriginAddressFamily = bgpAddressFamilyToJSON(message.bgpNeighborOriginAddressFamily);
    }
    if (message.defaultLocPrf !== 0) {
      obj.defaultLocPrf = Math.round(message.defaultLocPrf);
    }
    if (message.totalPrefixCounter !== 0) {
      obj.totalPrefixCounter = Math.round(message.totalPrefixCounter);
    }
    if (message.filteredPrefixCounter !== 0) {
      obj.filteredPrefixCounter = Math.round(message.filteredPrefixCounter);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.locPrf !== 0) {
      obj.locPrf = Math.round(message.locPrf);
    }
    if (message.isAsPathTruncated !== false) {
      obj.isAsPathTruncated = message.isAsPathTruncated;
    }
    if (message.community !== "") {
      obj.community = message.community;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborReceivedRoute>, I>>(base?: I): BgpNeighborReceivedRoute {
    return BgpNeighborReceivedRoute.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborReceivedRoute>, I>>(object: I): BgpNeighborReceivedRoute {
    const message = createBaseBgpNeighborReceivedRoute();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.bgpLocalRouterId = object.bgpLocalRouterId ?? "";
    message.bgpTableVersion = object.bgpTableVersion ?? 0;
    message.localAs = object.localAs ?? 0;
    message.addrPrefix = object.addrPrefix ?? "";
    message.prefixLen = object.prefixLen ?? 0;
    message.network = object.network ?? "";
    message.nextHop = object.nextHop ?? "";
    message.metric = object.metric ?? 0;
    message.weight = object.weight ?? 0;
    message.path = object.path ?? "";
    message.valid = object.valid ?? false;
    message.best = object.best ?? false;
    message.suppressed = object.suppressed ?? false;
    message.damped = object.damped ?? false;
    message.history = object.history ?? false;
    message.internal = object.internal ?? false;
    message.ribFailure = object.ribFailure ?? false;
    message.stale = object.stale ?? false;
    message.bgpOriginCode = object.bgpOriginCode ?? "";
    message.origin = object.origin ?? 0;
    message.receivedRoute = object.receivedRoute ?? "";
    message.bgpNeighborOriginVrf = object.bgpNeighborOriginVrf ?? "";
    message.bgpNeighborOriginAddressFamily = object.bgpNeighborOriginAddressFamily ?? 0;
    message.defaultLocPrf = object.defaultLocPrf ?? 0;
    message.totalPrefixCounter = object.totalPrefixCounter ?? 0;
    message.filteredPrefixCounter = object.filteredPrefixCounter ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.locPrf = object.locPrf ?? 0;
    message.isAsPathTruncated = object.isAsPathTruncated ?? false;
    message.community = object.community ?? "";
    return message;
  },
};

function createBaseBgpNeighborAdvertisedRoute(): BgpNeighborAdvertisedRoute {
  return {
    id: undefined,
    bgpLocalRouterId: "",
    bgpTableVersion: 0,
    localAs: 0,
    addrPrefix: "",
    prefixLen: 0,
    network: "",
    nextHop: "",
    metric: 0,
    weight: 0,
    path: "",
    valid: false,
    best: false,
    suppressed: false,
    damped: false,
    history: false,
    internal: false,
    ribFailure: false,
    stale: false,
    bgpOriginCode: "",
    origin: 0,
    routePrefix: "",
    bgpNeighborOriginVrf: "",
    bgpNeighborOriginAddressFamily: 0,
    defaultLocPrf: 0,
    totalPrefixCounter: 0,
    filteredPrefixCounter: 0,
    collectedAt: undefined,
    locPrf: 0,
    isAsPathTruncated: false,
    community: "",
  };
}

export const BgpNeighborAdvertisedRoute: MessageFns<BgpNeighborAdvertisedRoute> = {
  encode(message: BgpNeighborAdvertisedRoute, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.bgpLocalRouterId !== "") {
      writer.uint32(26).string(message.bgpLocalRouterId);
    }
    if (message.bgpTableVersion !== 0) {
      writer.uint32(32).uint32(message.bgpTableVersion);
    }
    if (message.localAs !== 0) {
      writer.uint32(40).uint32(message.localAs);
    }
    if (message.addrPrefix !== "") {
      writer.uint32(50).string(message.addrPrefix);
    }
    if (message.prefixLen !== 0) {
      writer.uint32(56).uint32(message.prefixLen);
    }
    if (message.network !== "") {
      writer.uint32(66).string(message.network);
    }
    if (message.nextHop !== "") {
      writer.uint32(74).string(message.nextHop);
    }
    if (message.metric !== 0) {
      writer.uint32(80).uint32(message.metric);
    }
    if (message.weight !== 0) {
      writer.uint32(88).uint32(message.weight);
    }
    if (message.path !== "") {
      writer.uint32(98).string(message.path);
    }
    if (message.valid !== false) {
      writer.uint32(104).bool(message.valid);
    }
    if (message.best !== false) {
      writer.uint32(112).bool(message.best);
    }
    if (message.suppressed !== false) {
      writer.uint32(128).bool(message.suppressed);
    }
    if (message.damped !== false) {
      writer.uint32(136).bool(message.damped);
    }
    if (message.history !== false) {
      writer.uint32(144).bool(message.history);
    }
    if (message.internal !== false) {
      writer.uint32(152).bool(message.internal);
    }
    if (message.ribFailure !== false) {
      writer.uint32(160).bool(message.ribFailure);
    }
    if (message.stale !== false) {
      writer.uint32(168).bool(message.stale);
    }
    if (message.bgpOriginCode !== "") {
      writer.uint32(178).string(message.bgpOriginCode);
    }
    if (message.origin !== 0) {
      writer.uint32(184).int32(message.origin);
    }
    if (message.routePrefix !== "") {
      writer.uint32(194).string(message.routePrefix);
    }
    if (message.bgpNeighborOriginVrf !== "") {
      writer.uint32(202).string(message.bgpNeighborOriginVrf);
    }
    if (message.bgpNeighborOriginAddressFamily !== 0) {
      writer.uint32(208).int32(message.bgpNeighborOriginAddressFamily);
    }
    if (message.defaultLocPrf !== 0) {
      writer.uint32(216).uint32(message.defaultLocPrf);
    }
    if (message.totalPrefixCounter !== 0) {
      writer.uint32(224).uint32(message.totalPrefixCounter);
    }
    if (message.filteredPrefixCounter !== 0) {
      writer.uint32(232).uint32(message.filteredPrefixCounter);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(242).fork()).join();
    }
    if (message.locPrf !== 0) {
      writer.uint32(248).uint32(message.locPrf);
    }
    if (message.isAsPathTruncated !== false) {
      writer.uint32(256).bool(message.isAsPathTruncated);
    }
    if (message.community !== "") {
      writer.uint32(266).string(message.community);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpNeighborAdvertisedRoute {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpNeighborAdvertisedRoute();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.bgpLocalRouterId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.bgpTableVersion = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.localAs = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.addrPrefix = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.prefixLen = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.network = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.nextHop = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.metric = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.weight = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.path = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.valid = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.best = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.suppressed = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.damped = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.history = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.internal = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.ribFailure = reader.bool();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.stale = reader.bool();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.bgpOriginCode = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.origin = reader.int32() as any;
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.routePrefix = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.bgpNeighborOriginVrf = reader.string();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.bgpNeighborOriginAddressFamily = reader.int32() as any;
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.defaultLocPrf = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.totalPrefixCounter = reader.uint32();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.filteredPrefixCounter = reader.uint32();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.locPrf = reader.uint32();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.isAsPathTruncated = reader.bool();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.community = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpNeighborAdvertisedRoute {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      bgpLocalRouterId: isSet(object.bgpLocalRouterId) ? globalThis.String(object.bgpLocalRouterId) : "",
      bgpTableVersion: isSet(object.bgpTableVersion) ? globalThis.Number(object.bgpTableVersion) : 0,
      localAs: isSet(object.localAs) ? globalThis.Number(object.localAs) : 0,
      addrPrefix: isSet(object.addrPrefix) ? globalThis.String(object.addrPrefix) : "",
      prefixLen: isSet(object.prefixLen) ? globalThis.Number(object.prefixLen) : 0,
      network: isSet(object.network) ? globalThis.String(object.network) : "",
      nextHop: isSet(object.nextHop) ? globalThis.String(object.nextHop) : "",
      metric: isSet(object.metric) ? globalThis.Number(object.metric) : 0,
      weight: isSet(object.weight) ? globalThis.Number(object.weight) : 0,
      path: isSet(object.path) ? globalThis.String(object.path) : "",
      valid: isSet(object.valid) ? globalThis.Boolean(object.valid) : false,
      best: isSet(object.best) ? globalThis.Boolean(object.best) : false,
      suppressed: isSet(object.suppressed) ? globalThis.Boolean(object.suppressed) : false,
      damped: isSet(object.damped) ? globalThis.Boolean(object.damped) : false,
      history: isSet(object.history) ? globalThis.Boolean(object.history) : false,
      internal: isSet(object.internal) ? globalThis.Boolean(object.internal) : false,
      ribFailure: isSet(object.ribFailure) ? globalThis.Boolean(object.ribFailure) : false,
      stale: isSet(object.stale) ? globalThis.Boolean(object.stale) : false,
      bgpOriginCode: isSet(object.bgpOriginCode) ? globalThis.String(object.bgpOriginCode) : "",
      origin: isSet(object.origin) ? bgpNeighborReceivedRouteOriginFromJSON(object.origin) : 0,
      routePrefix: isSet(object.routePrefix) ? globalThis.String(object.routePrefix) : "",
      bgpNeighborOriginVrf: isSet(object.bgpNeighborOriginVrf) ? globalThis.String(object.bgpNeighborOriginVrf) : "",
      bgpNeighborOriginAddressFamily: isSet(object.bgpNeighborOriginAddressFamily)
        ? bgpAddressFamilyFromJSON(object.bgpNeighborOriginAddressFamily)
        : 0,
      defaultLocPrf: isSet(object.defaultLocPrf) ? globalThis.Number(object.defaultLocPrf) : 0,
      totalPrefixCounter: isSet(object.totalPrefixCounter) ? globalThis.Number(object.totalPrefixCounter) : 0,
      filteredPrefixCounter: isSet(object.filteredPrefixCounter) ? globalThis.Number(object.filteredPrefixCounter) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      locPrf: isSet(object.locPrf) ? globalThis.Number(object.locPrf) : 0,
      isAsPathTruncated: isSet(object.isAsPathTruncated) ? globalThis.Boolean(object.isAsPathTruncated) : false,
      community: isSet(object.community) ? globalThis.String(object.community) : "",
    };
  },

  toJSON(message: BgpNeighborAdvertisedRoute): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.bgpLocalRouterId !== "") {
      obj.bgpLocalRouterId = message.bgpLocalRouterId;
    }
    if (message.bgpTableVersion !== 0) {
      obj.bgpTableVersion = Math.round(message.bgpTableVersion);
    }
    if (message.localAs !== 0) {
      obj.localAs = Math.round(message.localAs);
    }
    if (message.addrPrefix !== "") {
      obj.addrPrefix = message.addrPrefix;
    }
    if (message.prefixLen !== 0) {
      obj.prefixLen = Math.round(message.prefixLen);
    }
    if (message.network !== "") {
      obj.network = message.network;
    }
    if (message.nextHop !== "") {
      obj.nextHop = message.nextHop;
    }
    if (message.metric !== 0) {
      obj.metric = Math.round(message.metric);
    }
    if (message.weight !== 0) {
      obj.weight = Math.round(message.weight);
    }
    if (message.path !== "") {
      obj.path = message.path;
    }
    if (message.valid !== false) {
      obj.valid = message.valid;
    }
    if (message.best !== false) {
      obj.best = message.best;
    }
    if (message.suppressed !== false) {
      obj.suppressed = message.suppressed;
    }
    if (message.damped !== false) {
      obj.damped = message.damped;
    }
    if (message.history !== false) {
      obj.history = message.history;
    }
    if (message.internal !== false) {
      obj.internal = message.internal;
    }
    if (message.ribFailure !== false) {
      obj.ribFailure = message.ribFailure;
    }
    if (message.stale !== false) {
      obj.stale = message.stale;
    }
    if (message.bgpOriginCode !== "") {
      obj.bgpOriginCode = message.bgpOriginCode;
    }
    if (message.origin !== 0) {
      obj.origin = bgpNeighborReceivedRouteOriginToJSON(message.origin);
    }
    if (message.routePrefix !== "") {
      obj.routePrefix = message.routePrefix;
    }
    if (message.bgpNeighborOriginVrf !== "") {
      obj.bgpNeighborOriginVrf = message.bgpNeighborOriginVrf;
    }
    if (message.bgpNeighborOriginAddressFamily !== 0) {
      obj.bgpNeighborOriginAddressFamily = bgpAddressFamilyToJSON(message.bgpNeighborOriginAddressFamily);
    }
    if (message.defaultLocPrf !== 0) {
      obj.defaultLocPrf = Math.round(message.defaultLocPrf);
    }
    if (message.totalPrefixCounter !== 0) {
      obj.totalPrefixCounter = Math.round(message.totalPrefixCounter);
    }
    if (message.filteredPrefixCounter !== 0) {
      obj.filteredPrefixCounter = Math.round(message.filteredPrefixCounter);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.locPrf !== 0) {
      obj.locPrf = Math.round(message.locPrf);
    }
    if (message.isAsPathTruncated !== false) {
      obj.isAsPathTruncated = message.isAsPathTruncated;
    }
    if (message.community !== "") {
      obj.community = message.community;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpNeighborAdvertisedRoute>, I>>(base?: I): BgpNeighborAdvertisedRoute {
    return BgpNeighborAdvertisedRoute.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpNeighborAdvertisedRoute>, I>>(object: I): BgpNeighborAdvertisedRoute {
    const message = createBaseBgpNeighborAdvertisedRoute();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.bgpLocalRouterId = object.bgpLocalRouterId ?? "";
    message.bgpTableVersion = object.bgpTableVersion ?? 0;
    message.localAs = object.localAs ?? 0;
    message.addrPrefix = object.addrPrefix ?? "";
    message.prefixLen = object.prefixLen ?? 0;
    message.network = object.network ?? "";
    message.nextHop = object.nextHop ?? "";
    message.metric = object.metric ?? 0;
    message.weight = object.weight ?? 0;
    message.path = object.path ?? "";
    message.valid = object.valid ?? false;
    message.best = object.best ?? false;
    message.suppressed = object.suppressed ?? false;
    message.damped = object.damped ?? false;
    message.history = object.history ?? false;
    message.internal = object.internal ?? false;
    message.ribFailure = object.ribFailure ?? false;
    message.stale = object.stale ?? false;
    message.bgpOriginCode = object.bgpOriginCode ?? "";
    message.origin = object.origin ?? 0;
    message.routePrefix = object.routePrefix ?? "";
    message.bgpNeighborOriginVrf = object.bgpNeighborOriginVrf ?? "";
    message.bgpNeighborOriginAddressFamily = object.bgpNeighborOriginAddressFamily ?? 0;
    message.defaultLocPrf = object.defaultLocPrf ?? 0;
    message.totalPrefixCounter = object.totalPrefixCounter ?? 0;
    message.filteredPrefixCounter = object.filteredPrefixCounter ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.locPrf = object.locPrf ?? 0;
    message.isAsPathTruncated = object.isAsPathTruncated ?? false;
    message.community = object.community ?? "";
    return message;
  },
};

function createBasePortRateCounters(): PortRateCounters {
  return {
    id: undefined,
    portName: "",
    rxBps: 0,
    rxPps: 0,
    txBps: 0,
    txPps: 0,
    saiPortStatIfInNonUcastPktsLast: "0",
    saiPortStatIfInOctetsLast: "0",
    saiPortStatIfInUcastPktsLast: "0",
    saiPortStatIfOutNonUcastPktsLast: "0",
    saiPortStatIfOutOctetsLast: "0",
    saiPortStatIfOutUcastPktsLast: "0",
    collectedAt: undefined,
  };
}

export const PortRateCounters: MessageFns<PortRateCounters> = {
  encode(message: PortRateCounters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.portName !== "") {
      writer.uint32(26).string(message.portName);
    }
    if (message.rxBps !== 0) {
      writer.uint32(37).float(message.rxBps);
    }
    if (message.rxPps !== 0) {
      writer.uint32(45).float(message.rxPps);
    }
    if (message.txBps !== 0) {
      writer.uint32(53).float(message.txBps);
    }
    if (message.txPps !== 0) {
      writer.uint32(61).float(message.txPps);
    }
    if (message.saiPortStatIfInNonUcastPktsLast !== "0") {
      writer.uint32(64).uint64(message.saiPortStatIfInNonUcastPktsLast);
    }
    if (message.saiPortStatIfInOctetsLast !== "0") {
      writer.uint32(72).uint64(message.saiPortStatIfInOctetsLast);
    }
    if (message.saiPortStatIfInUcastPktsLast !== "0") {
      writer.uint32(80).uint64(message.saiPortStatIfInUcastPktsLast);
    }
    if (message.saiPortStatIfOutNonUcastPktsLast !== "0") {
      writer.uint32(88).uint64(message.saiPortStatIfOutNonUcastPktsLast);
    }
    if (message.saiPortStatIfOutOctetsLast !== "0") {
      writer.uint32(96).uint64(message.saiPortStatIfOutOctetsLast);
    }
    if (message.saiPortStatIfOutUcastPktsLast !== "0") {
      writer.uint32(104).uint64(message.saiPortStatIfOutUcastPktsLast);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(114).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortRateCounters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortRateCounters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.rxBps = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.rxPps = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.txBps = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.txPps = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.saiPortStatIfInNonUcastPktsLast = reader.uint64().toString();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.saiPortStatIfInOctetsLast = reader.uint64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.saiPortStatIfInUcastPktsLast = reader.uint64().toString();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.saiPortStatIfOutNonUcastPktsLast = reader.uint64().toString();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.saiPortStatIfOutOctetsLast = reader.uint64().toString();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.saiPortStatIfOutUcastPktsLast = reader.uint64().toString();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortRateCounters {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      rxBps: isSet(object.rxBps) ? globalThis.Number(object.rxBps) : 0,
      rxPps: isSet(object.rxPps) ? globalThis.Number(object.rxPps) : 0,
      txBps: isSet(object.txBps) ? globalThis.Number(object.txBps) : 0,
      txPps: isSet(object.txPps) ? globalThis.Number(object.txPps) : 0,
      saiPortStatIfInNonUcastPktsLast: isSet(object.saiPortStatIfInNonUcastPktsLast)
        ? globalThis.String(object.saiPortStatIfInNonUcastPktsLast)
        : "0",
      saiPortStatIfInOctetsLast: isSet(object.saiPortStatIfInOctetsLast)
        ? globalThis.String(object.saiPortStatIfInOctetsLast)
        : "0",
      saiPortStatIfInUcastPktsLast: isSet(object.saiPortStatIfInUcastPktsLast)
        ? globalThis.String(object.saiPortStatIfInUcastPktsLast)
        : "0",
      saiPortStatIfOutNonUcastPktsLast: isSet(object.saiPortStatIfOutNonUcastPktsLast)
        ? globalThis.String(object.saiPortStatIfOutNonUcastPktsLast)
        : "0",
      saiPortStatIfOutOctetsLast: isSet(object.saiPortStatIfOutOctetsLast)
        ? globalThis.String(object.saiPortStatIfOutOctetsLast)
        : "0",
      saiPortStatIfOutUcastPktsLast: isSet(object.saiPortStatIfOutUcastPktsLast)
        ? globalThis.String(object.saiPortStatIfOutUcastPktsLast)
        : "0",
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: PortRateCounters): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.rxBps !== 0) {
      obj.rxBps = message.rxBps;
    }
    if (message.rxPps !== 0) {
      obj.rxPps = message.rxPps;
    }
    if (message.txBps !== 0) {
      obj.txBps = message.txBps;
    }
    if (message.txPps !== 0) {
      obj.txPps = message.txPps;
    }
    if (message.saiPortStatIfInNonUcastPktsLast !== "0") {
      obj.saiPortStatIfInNonUcastPktsLast = message.saiPortStatIfInNonUcastPktsLast;
    }
    if (message.saiPortStatIfInOctetsLast !== "0") {
      obj.saiPortStatIfInOctetsLast = message.saiPortStatIfInOctetsLast;
    }
    if (message.saiPortStatIfInUcastPktsLast !== "0") {
      obj.saiPortStatIfInUcastPktsLast = message.saiPortStatIfInUcastPktsLast;
    }
    if (message.saiPortStatIfOutNonUcastPktsLast !== "0") {
      obj.saiPortStatIfOutNonUcastPktsLast = message.saiPortStatIfOutNonUcastPktsLast;
    }
    if (message.saiPortStatIfOutOctetsLast !== "0") {
      obj.saiPortStatIfOutOctetsLast = message.saiPortStatIfOutOctetsLast;
    }
    if (message.saiPortStatIfOutUcastPktsLast !== "0") {
      obj.saiPortStatIfOutUcastPktsLast = message.saiPortStatIfOutUcastPktsLast;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortRateCounters>, I>>(base?: I): PortRateCounters {
    return PortRateCounters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortRateCounters>, I>>(object: I): PortRateCounters {
    const message = createBasePortRateCounters();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.portName = object.portName ?? "";
    message.rxBps = object.rxBps ?? 0;
    message.rxPps = object.rxPps ?? 0;
    message.txBps = object.txBps ?? 0;
    message.txPps = object.txPps ?? 0;
    message.saiPortStatIfInNonUcastPktsLast = object.saiPortStatIfInNonUcastPktsLast ?? "0";
    message.saiPortStatIfInOctetsLast = object.saiPortStatIfInOctetsLast ?? "0";
    message.saiPortStatIfInUcastPktsLast = object.saiPortStatIfInUcastPktsLast ?? "0";
    message.saiPortStatIfOutNonUcastPktsLast = object.saiPortStatIfOutNonUcastPktsLast ?? "0";
    message.saiPortStatIfOutOctetsLast = object.saiPortStatIfOutOctetsLast ?? "0";
    message.saiPortStatIfOutUcastPktsLast = object.saiPortStatIfOutUcastPktsLast ?? "0";
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseSystemStats(): SystemStats {
  return {
    id: undefined,
    CpuUsed: 0,
    CpuIdle: 0,
    MemTotal: "0",
    MemUsed: "0",
    MemFree: "0",
    DiskTotal: "0",
    DiskUsed: "0",
    DiskFree: "0",
    collectedAt: undefined,
  };
}

export const SystemStats: MessageFns<SystemStats> = {
  encode(message: SystemStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.CpuUsed !== 0) {
      writer.uint32(29).float(message.CpuUsed);
    }
    if (message.CpuIdle !== 0) {
      writer.uint32(37).float(message.CpuIdle);
    }
    if (message.MemTotal !== "0") {
      writer.uint32(40).int64(message.MemTotal);
    }
    if (message.MemUsed !== "0") {
      writer.uint32(48).int64(message.MemUsed);
    }
    if (message.MemFree !== "0") {
      writer.uint32(56).int64(message.MemFree);
    }
    if (message.DiskTotal !== "0") {
      writer.uint32(64).int64(message.DiskTotal);
    }
    if (message.DiskUsed !== "0") {
      writer.uint32(72).int64(message.DiskUsed);
    }
    if (message.DiskFree !== "0") {
      writer.uint32(80).int64(message.DiskFree);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(154).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SystemStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSystemStats();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.CpuUsed = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.CpuIdle = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.MemTotal = reader.int64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.MemUsed = reader.int64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.MemFree = reader.int64().toString();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.DiskTotal = reader.int64().toString();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.DiskUsed = reader.int64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.DiskFree = reader.int64().toString();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SystemStats {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      CpuUsed: isSet(object.CpuUsed) ? globalThis.Number(object.CpuUsed) : 0,
      CpuIdle: isSet(object.CpuIdle) ? globalThis.Number(object.CpuIdle) : 0,
      MemTotal: isSet(object.MemTotal) ? globalThis.String(object.MemTotal) : "0",
      MemUsed: isSet(object.MemUsed) ? globalThis.String(object.MemUsed) : "0",
      MemFree: isSet(object.MemFree) ? globalThis.String(object.MemFree) : "0",
      DiskTotal: isSet(object.DiskTotal) ? globalThis.String(object.DiskTotal) : "0",
      DiskUsed: isSet(object.DiskUsed) ? globalThis.String(object.DiskUsed) : "0",
      DiskFree: isSet(object.DiskFree) ? globalThis.String(object.DiskFree) : "0",
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: SystemStats): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.CpuUsed !== 0) {
      obj.CpuUsed = message.CpuUsed;
    }
    if (message.CpuIdle !== 0) {
      obj.CpuIdle = message.CpuIdle;
    }
    if (message.MemTotal !== "0") {
      obj.MemTotal = message.MemTotal;
    }
    if (message.MemUsed !== "0") {
      obj.MemUsed = message.MemUsed;
    }
    if (message.MemFree !== "0") {
      obj.MemFree = message.MemFree;
    }
    if (message.DiskTotal !== "0") {
      obj.DiskTotal = message.DiskTotal;
    }
    if (message.DiskUsed !== "0") {
      obj.DiskUsed = message.DiskUsed;
    }
    if (message.DiskFree !== "0") {
      obj.DiskFree = message.DiskFree;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SystemStats>, I>>(base?: I): SystemStats {
    return SystemStats.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SystemStats>, I>>(object: I): SystemStats {
    const message = createBaseSystemStats();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.CpuUsed = object.CpuUsed ?? 0;
    message.CpuIdle = object.CpuIdle ?? 0;
    message.MemTotal = object.MemTotal ?? "0";
    message.MemUsed = object.MemUsed ?? "0";
    message.MemFree = object.MemFree ?? "0";
    message.DiskTotal = object.DiskTotal ?? "0";
    message.DiskUsed = object.DiskUsed ?? "0";
    message.DiskFree = object.DiskFree ?? "0";
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBasePortChannelMemberState(): PortChannelMemberState {
  return {
    id: undefined,
    name: "",
    memberInterfaceName: "",
    devAddr: "",
    ifIndex: 0,
    linkUp: false,
    linkWatchUp: false,
    actorLacpduInfoPort: 0,
    actorLacpduInfoState: 0,
    actorLacpduInfoSystem: "",
    partnerLacpduInfoPort: 0,
    partnerLacpduInfoState: 0,
    partnerLacpduInfoSystem: "",
    aggregatorId: 0,
    aggregatorSelected: false,
    selected: false,
    state: 0,
    protocol: 0,
    collectedAt: undefined,
    lacpStatus: false,
  };
}

export const PortChannelMemberState: MessageFns<PortChannelMemberState> = {
  encode(message: PortChannelMemberState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.memberInterfaceName !== "") {
      writer.uint32(34).string(message.memberInterfaceName);
    }
    if (message.devAddr !== "") {
      writer.uint32(42).string(message.devAddr);
    }
    if (message.ifIndex !== 0) {
      writer.uint32(48).int32(message.ifIndex);
    }
    if (message.linkUp !== false) {
      writer.uint32(56).bool(message.linkUp);
    }
    if (message.linkWatchUp !== false) {
      writer.uint32(64).bool(message.linkWatchUp);
    }
    if (message.actorLacpduInfoPort !== 0) {
      writer.uint32(72).int32(message.actorLacpduInfoPort);
    }
    if (message.actorLacpduInfoState !== 0) {
      writer.uint32(80).int32(message.actorLacpduInfoState);
    }
    if (message.actorLacpduInfoSystem !== "") {
      writer.uint32(90).string(message.actorLacpduInfoSystem);
    }
    if (message.partnerLacpduInfoPort !== 0) {
      writer.uint32(96).int32(message.partnerLacpduInfoPort);
    }
    if (message.partnerLacpduInfoState !== 0) {
      writer.uint32(104).int32(message.partnerLacpduInfoState);
    }
    if (message.partnerLacpduInfoSystem !== "") {
      writer.uint32(114).string(message.partnerLacpduInfoSystem);
    }
    if (message.aggregatorId !== 0) {
      writer.uint32(120).int32(message.aggregatorId);
    }
    if (message.aggregatorSelected !== false) {
      writer.uint32(128).bool(message.aggregatorSelected);
    }
    if (message.selected !== false) {
      writer.uint32(136).bool(message.selected);
    }
    if (message.state !== 0) {
      writer.uint32(144).int32(message.state);
    }
    if (message.protocol !== 0) {
      writer.uint32(152).int32(message.protocol);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(162).fork()).join();
    }
    if (message.lacpStatus !== false) {
      writer.uint32(168).bool(message.lacpStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortChannelMemberState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortChannelMemberState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.memberInterfaceName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.devAddr = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.ifIndex = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.linkUp = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.linkWatchUp = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.actorLacpduInfoPort = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.actorLacpduInfoState = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.actorLacpduInfoSystem = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.partnerLacpduInfoPort = reader.int32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.partnerLacpduInfoState = reader.int32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.partnerLacpduInfoSystem = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.aggregatorId = reader.int32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.aggregatorSelected = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.selected = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.protocol = reader.int32() as any;
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.lacpStatus = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortChannelMemberState {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      memberInterfaceName: isSet(object.memberInterfaceName) ? globalThis.String(object.memberInterfaceName) : "",
      devAddr: isSet(object.devAddr) ? globalThis.String(object.devAddr) : "",
      ifIndex: isSet(object.ifIndex) ? globalThis.Number(object.ifIndex) : 0,
      linkUp: isSet(object.linkUp) ? globalThis.Boolean(object.linkUp) : false,
      linkWatchUp: isSet(object.linkWatchUp) ? globalThis.Boolean(object.linkWatchUp) : false,
      actorLacpduInfoPort: isSet(object.actorLacpduInfoPort) ? globalThis.Number(object.actorLacpduInfoPort) : 0,
      actorLacpduInfoState: isSet(object.actorLacpduInfoState) ? globalThis.Number(object.actorLacpduInfoState) : 0,
      actorLacpduInfoSystem: isSet(object.actorLacpduInfoSystem) ? globalThis.String(object.actorLacpduInfoSystem) : "",
      partnerLacpduInfoPort: isSet(object.partnerLacpduInfoPort) ? globalThis.Number(object.partnerLacpduInfoPort) : 0,
      partnerLacpduInfoState: isSet(object.partnerLacpduInfoState)
        ? globalThis.Number(object.partnerLacpduInfoState)
        : 0,
      partnerLacpduInfoSystem: isSet(object.partnerLacpduInfoSystem)
        ? globalThis.String(object.partnerLacpduInfoSystem)
        : "",
      aggregatorId: isSet(object.aggregatorId) ? globalThis.Number(object.aggregatorId) : 0,
      aggregatorSelected: isSet(object.aggregatorSelected) ? globalThis.Boolean(object.aggregatorSelected) : false,
      selected: isSet(object.selected) ? globalThis.Boolean(object.selected) : false,
      state: isSet(object.state) ? portChannelMemberInfoStateFromJSON(object.state) : 0,
      protocol: isSet(object.protocol) ? portChannelProtocolFromJSON(object.protocol) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      lacpStatus: isSet(object.lacpStatus) ? globalThis.Boolean(object.lacpStatus) : false,
    };
  },

  toJSON(message: PortChannelMemberState): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.memberInterfaceName !== "") {
      obj.memberInterfaceName = message.memberInterfaceName;
    }
    if (message.devAddr !== "") {
      obj.devAddr = message.devAddr;
    }
    if (message.ifIndex !== 0) {
      obj.ifIndex = Math.round(message.ifIndex);
    }
    if (message.linkUp !== false) {
      obj.linkUp = message.linkUp;
    }
    if (message.linkWatchUp !== false) {
      obj.linkWatchUp = message.linkWatchUp;
    }
    if (message.actorLacpduInfoPort !== 0) {
      obj.actorLacpduInfoPort = Math.round(message.actorLacpduInfoPort);
    }
    if (message.actorLacpduInfoState !== 0) {
      obj.actorLacpduInfoState = Math.round(message.actorLacpduInfoState);
    }
    if (message.actorLacpduInfoSystem !== "") {
      obj.actorLacpduInfoSystem = message.actorLacpduInfoSystem;
    }
    if (message.partnerLacpduInfoPort !== 0) {
      obj.partnerLacpduInfoPort = Math.round(message.partnerLacpduInfoPort);
    }
    if (message.partnerLacpduInfoState !== 0) {
      obj.partnerLacpduInfoState = Math.round(message.partnerLacpduInfoState);
    }
    if (message.partnerLacpduInfoSystem !== "") {
      obj.partnerLacpduInfoSystem = message.partnerLacpduInfoSystem;
    }
    if (message.aggregatorId !== 0) {
      obj.aggregatorId = Math.round(message.aggregatorId);
    }
    if (message.aggregatorSelected !== false) {
      obj.aggregatorSelected = message.aggregatorSelected;
    }
    if (message.selected !== false) {
      obj.selected = message.selected;
    }
    if (message.state !== 0) {
      obj.state = portChannelMemberInfoStateToJSON(message.state);
    }
    if (message.protocol !== 0) {
      obj.protocol = portChannelProtocolToJSON(message.protocol);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.lacpStatus !== false) {
      obj.lacpStatus = message.lacpStatus;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortChannelMemberState>, I>>(base?: I): PortChannelMemberState {
    return PortChannelMemberState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortChannelMemberState>, I>>(object: I): PortChannelMemberState {
    const message = createBasePortChannelMemberState();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.name = object.name ?? "";
    message.memberInterfaceName = object.memberInterfaceName ?? "";
    message.devAddr = object.devAddr ?? "";
    message.ifIndex = object.ifIndex ?? 0;
    message.linkUp = object.linkUp ?? false;
    message.linkWatchUp = object.linkWatchUp ?? false;
    message.actorLacpduInfoPort = object.actorLacpduInfoPort ?? 0;
    message.actorLacpduInfoState = object.actorLacpduInfoState ?? 0;
    message.actorLacpduInfoSystem = object.actorLacpduInfoSystem ?? "";
    message.partnerLacpduInfoPort = object.partnerLacpduInfoPort ?? 0;
    message.partnerLacpduInfoState = object.partnerLacpduInfoState ?? 0;
    message.partnerLacpduInfoSystem = object.partnerLacpduInfoSystem ?? "";
    message.aggregatorId = object.aggregatorId ?? 0;
    message.aggregatorSelected = object.aggregatorSelected ?? false;
    message.selected = object.selected ?? false;
    message.state = object.state ?? 0;
    message.protocol = object.protocol ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.lacpStatus = object.lacpStatus ?? false;
    return message;
  },
};

function createBasePortChannelState(): PortChannelState {
  return {
    id: undefined,
    name: "",
    adminStatus: 0,
    mtu: 0,
    operStatus: 0,
    state: 0,
    runnerActive: false,
    runnerFallback: false,
    runnerFastRate: false,
    setupKernelTeamModeName: 0,
    setupPid: 0,
    teamDeviceIfInfoDevAddr: "",
    teamDeviceIfInfoIfIndex: 0,
    protocol: 0,
    collectedAt: undefined,
  };
}

export const PortChannelState: MessageFns<PortChannelState> = {
  encode(message: PortChannelState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.adminStatus !== 0) {
      writer.uint32(32).int32(message.adminStatus);
    }
    if (message.mtu !== 0) {
      writer.uint32(40).uint32(message.mtu);
    }
    if (message.operStatus !== 0) {
      writer.uint32(48).int32(message.operStatus);
    }
    if (message.state !== 0) {
      writer.uint32(56).int32(message.state);
    }
    if (message.runnerActive !== false) {
      writer.uint32(64).bool(message.runnerActive);
    }
    if (message.runnerFallback !== false) {
      writer.uint32(72).bool(message.runnerFallback);
    }
    if (message.runnerFastRate !== false) {
      writer.uint32(80).bool(message.runnerFastRate);
    }
    if (message.setupKernelTeamModeName !== 0) {
      writer.uint32(88).int32(message.setupKernelTeamModeName);
    }
    if (message.setupPid !== 0) {
      writer.uint32(96).int32(message.setupPid);
    }
    if (message.teamDeviceIfInfoDevAddr !== "") {
      writer.uint32(106).string(message.teamDeviceIfInfoDevAddr);
    }
    if (message.teamDeviceIfInfoIfIndex !== 0) {
      writer.uint32(112).int32(message.teamDeviceIfInfoIfIndex);
    }
    if (message.protocol !== 0) {
      writer.uint32(120).int32(message.protocol);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(130).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortChannelState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortChannelState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.adminStatus = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.mtu = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.operStatus = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.runnerActive = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.runnerFallback = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.runnerFastRate = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.setupKernelTeamModeName = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.setupPid = reader.int32();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.teamDeviceIfInfoDevAddr = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.teamDeviceIfInfoIfIndex = reader.int32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.protocol = reader.int32() as any;
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortChannelState {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      adminStatus: isSet(object.adminStatus) ? operStateFromJSON(object.adminStatus) : 0,
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      operStatus: isSet(object.operStatus) ? operStateFromJSON(object.operStatus) : 0,
      state: isSet(object.state) ? portChannelStatusFromJSON(object.state) : 0,
      runnerActive: isSet(object.runnerActive) ? globalThis.Boolean(object.runnerActive) : false,
      runnerFallback: isSet(object.runnerFallback) ? globalThis.Boolean(object.runnerFallback) : false,
      runnerFastRate: isSet(object.runnerFastRate) ? globalThis.Boolean(object.runnerFastRate) : false,
      setupKernelTeamModeName: isSet(object.setupKernelTeamModeName)
        ? portChannelKernelTeamModeFromJSON(object.setupKernelTeamModeName)
        : 0,
      setupPid: isSet(object.setupPid) ? globalThis.Number(object.setupPid) : 0,
      teamDeviceIfInfoDevAddr: isSet(object.teamDeviceIfInfoDevAddr)
        ? globalThis.String(object.teamDeviceIfInfoDevAddr)
        : "",
      teamDeviceIfInfoIfIndex: isSet(object.teamDeviceIfInfoIfIndex)
        ? globalThis.Number(object.teamDeviceIfInfoIfIndex)
        : 0,
      protocol: isSet(object.protocol) ? portChannelProtocolFromJSON(object.protocol) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: PortChannelState): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.adminStatus !== 0) {
      obj.adminStatus = operStateToJSON(message.adminStatus);
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.operStatus !== 0) {
      obj.operStatus = operStateToJSON(message.operStatus);
    }
    if (message.state !== 0) {
      obj.state = portChannelStatusToJSON(message.state);
    }
    if (message.runnerActive !== false) {
      obj.runnerActive = message.runnerActive;
    }
    if (message.runnerFallback !== false) {
      obj.runnerFallback = message.runnerFallback;
    }
    if (message.runnerFastRate !== false) {
      obj.runnerFastRate = message.runnerFastRate;
    }
    if (message.setupKernelTeamModeName !== 0) {
      obj.setupKernelTeamModeName = portChannelKernelTeamModeToJSON(message.setupKernelTeamModeName);
    }
    if (message.setupPid !== 0) {
      obj.setupPid = Math.round(message.setupPid);
    }
    if (message.teamDeviceIfInfoDevAddr !== "") {
      obj.teamDeviceIfInfoDevAddr = message.teamDeviceIfInfoDevAddr;
    }
    if (message.teamDeviceIfInfoIfIndex !== 0) {
      obj.teamDeviceIfInfoIfIndex = Math.round(message.teamDeviceIfInfoIfIndex);
    }
    if (message.protocol !== 0) {
      obj.protocol = portChannelProtocolToJSON(message.protocol);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortChannelState>, I>>(base?: I): PortChannelState {
    return PortChannelState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortChannelState>, I>>(object: I): PortChannelState {
    const message = createBasePortChannelState();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.name = object.name ?? "";
    message.adminStatus = object.adminStatus ?? 0;
    message.mtu = object.mtu ?? 0;
    message.operStatus = object.operStatus ?? 0;
    message.state = object.state ?? 0;
    message.runnerActive = object.runnerActive ?? false;
    message.runnerFallback = object.runnerFallback ?? false;
    message.runnerFastRate = object.runnerFastRate ?? false;
    message.setupKernelTeamModeName = object.setupKernelTeamModeName ?? 0;
    message.setupPid = object.setupPid ?? 0;
    message.teamDeviceIfInfoDevAddr = object.teamDeviceIfInfoDevAddr ?? "";
    message.teamDeviceIfInfoIfIndex = object.teamDeviceIfInfoIfIndex ?? 0;
    message.protocol = object.protocol ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseOrgUuid(): OrgUuid {
  return { id: undefined, labels: [] };
}

export const OrgUuid: MessageFns<OrgUuid> = {
  encode(message: OrgUuid, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    for (const v of message.labels) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgUuid {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgUuid();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgUuid {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: OrgUuid): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgUuid>, I>>(base?: I): OrgUuid {
    return OrgUuid.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgUuid>, I>>(object: I): OrgUuid {
    const message = createBaseOrgUuid();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.labels = object.labels?.map((e) => e) || [];
    return message;
  },
};

function createBaseOrgMetadata(): OrgMetadata {
  return { id: undefined, orgName: "", optInC3: false, cuiTenantId: "" };
}

export const OrgMetadata: MessageFns<OrgMetadata> = {
  encode(message: OrgMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.orgName !== "") {
      writer.uint32(26).string(message.orgName);
    }
    if (message.optInC3 !== false) {
      writer.uint32(32).bool(message.optInC3);
    }
    if (message.cuiTenantId !== "") {
      writer.uint32(42).string(message.cuiTenantId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.orgName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.optInC3 = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.cuiTenantId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgMetadata {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      orgName: isSet(object.orgName) ? globalThis.String(object.orgName) : "",
      optInC3: isSet(object.optInC3) ? globalThis.Boolean(object.optInC3) : false,
      cuiTenantId: isSet(object.cuiTenantId) ? globalThis.String(object.cuiTenantId) : "",
    };
  },

  toJSON(message: OrgMetadata): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.orgName !== "") {
      obj.orgName = message.orgName;
    }
    if (message.optInC3 !== false) {
      obj.optInC3 = message.optInC3;
    }
    if (message.cuiTenantId !== "") {
      obj.cuiTenantId = message.cuiTenantId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgMetadata>, I>>(base?: I): OrgMetadata {
    return OrgMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgMetadata>, I>>(object: I): OrgMetadata {
    const message = createBaseOrgMetadata();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.orgName = object.orgName ?? "";
    message.optInC3 = object.optInC3 ?? false;
    message.cuiTenantId = object.cuiTenantId ?? "";
    return message;
  },
};

function createBaseFabricUuid(): FabricUuid {
  return { id: undefined };
}

export const FabricUuid: MessageFns<FabricUuid> = {
  encode(message: FabricUuid, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricUuid {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricUuid();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricUuid {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: FabricUuid): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricUuid>, I>>(base?: I): FabricUuid {
    return FabricUuid.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricUuid>, I>>(object: I): FabricUuid {
    const message = createBaseFabricUuid();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseOrgToCellPairMapping(): OrgToCellPairMapping {
  return {
    id: undefined,
    orgUuid: "",
    cellPairUuid: "",
    reserved5: "",
    reserved6: "",
    generation: 0,
    orgKind: 0,
    createdBy: "",
    activeCellUuid: "",
    standbyCellUuid: "",
    activeSvcProxyHost: "",
    labels: [],
    activeSvcProxy: undefined,
    geo: 0,
    updatedTs: undefined,
  };
}

export const OrgToCellPairMapping: MessageFns<OrgToCellPairMapping> = {
  encode(message: OrgToCellPairMapping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.orgUuid !== "") {
      writer.uint32(26).string(message.orgUuid);
    }
    if (message.cellPairUuid !== "") {
      writer.uint32(34).string(message.cellPairUuid);
    }
    if (message.reserved5 !== "") {
      writer.uint32(42).string(message.reserved5);
    }
    if (message.reserved6 !== "") {
      writer.uint32(50).string(message.reserved6);
    }
    if (message.generation !== 0) {
      writer.uint32(56).int32(message.generation);
    }
    if (message.orgKind !== 0) {
      writer.uint32(64).int32(message.orgKind);
    }
    if (message.createdBy !== "") {
      writer.uint32(74).string(message.createdBy);
    }
    if (message.activeCellUuid !== "") {
      writer.uint32(82).string(message.activeCellUuid);
    }
    if (message.standbyCellUuid !== "") {
      writer.uint32(90).string(message.standbyCellUuid);
    }
    if (message.activeSvcProxyHost !== "") {
      writer.uint32(98).string(message.activeSvcProxyHost);
    }
    for (const v of message.labels) {
      writer.uint32(106).string(v!);
    }
    if (message.activeSvcProxy !== undefined) {
      HostPort.encode(message.activeSvcProxy, writer.uint32(114).fork()).join();
    }
    if (message.geo !== 0) {
      writer.uint32(120).int32(message.geo);
    }
    if (message.updatedTs !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedTs), writer.uint32(162).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgToCellPairMapping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgToCellPairMapping();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.orgUuid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.cellPairUuid = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.reserved5 = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.reserved6 = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.generation = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.orgKind = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.activeCellUuid = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.standbyCellUuid = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.activeSvcProxyHost = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.activeSvcProxy = HostPort.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.geo = reader.int32() as any;
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.updatedTs = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgToCellPairMapping {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      orgUuid: isSet(object.orgUuid) ? globalThis.String(object.orgUuid) : "",
      cellPairUuid: isSet(object.cellPairUuid) ? globalThis.String(object.cellPairUuid) : "",
      reserved5: isSet(object.reserved5) ? globalThis.String(object.reserved5) : "",
      reserved6: isSet(object.reserved6) ? globalThis.String(object.reserved6) : "",
      generation: isSet(object.generation) ? globalThis.Number(object.generation) : 0,
      orgKind: isSet(object.orgKind) ? orgKindFromJSON(object.orgKind) : 0,
      createdBy: isSet(object.createdBy) ? globalThis.String(object.createdBy) : "",
      activeCellUuid: isSet(object.activeCellUuid) ? globalThis.String(object.activeCellUuid) : "",
      standbyCellUuid: isSet(object.standbyCellUuid) ? globalThis.String(object.standbyCellUuid) : "",
      activeSvcProxyHost: isSet(object.activeSvcProxyHost) ? globalThis.String(object.activeSvcProxyHost) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      activeSvcProxy: isSet(object.activeSvcProxy) ? HostPort.fromJSON(object.activeSvcProxy) : undefined,
      geo: isSet(object.geo) ? geoFromJSON(object.geo) : 0,
      updatedTs: isSet(object.updatedTs) ? fromJsonTimestamp(object.updatedTs) : undefined,
    };
  },

  toJSON(message: OrgToCellPairMapping): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.orgUuid !== "") {
      obj.orgUuid = message.orgUuid;
    }
    if (message.cellPairUuid !== "") {
      obj.cellPairUuid = message.cellPairUuid;
    }
    if (message.reserved5 !== "") {
      obj.reserved5 = message.reserved5;
    }
    if (message.reserved6 !== "") {
      obj.reserved6 = message.reserved6;
    }
    if (message.generation !== 0) {
      obj.generation = Math.round(message.generation);
    }
    if (message.orgKind !== 0) {
      obj.orgKind = orgKindToJSON(message.orgKind);
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.activeCellUuid !== "") {
      obj.activeCellUuid = message.activeCellUuid;
    }
    if (message.standbyCellUuid !== "") {
      obj.standbyCellUuid = message.standbyCellUuid;
    }
    if (message.activeSvcProxyHost !== "") {
      obj.activeSvcProxyHost = message.activeSvcProxyHost;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.activeSvcProxy !== undefined) {
      obj.activeSvcProxy = HostPort.toJSON(message.activeSvcProxy);
    }
    if (message.geo !== 0) {
      obj.geo = geoToJSON(message.geo);
    }
    if (message.updatedTs !== undefined) {
      obj.updatedTs = message.updatedTs.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgToCellPairMapping>, I>>(base?: I): OrgToCellPairMapping {
    return OrgToCellPairMapping.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgToCellPairMapping>, I>>(object: I): OrgToCellPairMapping {
    const message = createBaseOrgToCellPairMapping();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.orgUuid = object.orgUuid ?? "";
    message.cellPairUuid = object.cellPairUuid ?? "";
    message.reserved5 = object.reserved5 ?? "";
    message.reserved6 = object.reserved6 ?? "";
    message.generation = object.generation ?? 0;
    message.orgKind = object.orgKind ?? 0;
    message.createdBy = object.createdBy ?? "";
    message.activeCellUuid = object.activeCellUuid ?? "";
    message.standbyCellUuid = object.standbyCellUuid ?? "";
    message.activeSvcProxyHost = object.activeSvcProxyHost ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.activeSvcProxy = (object.activeSvcProxy !== undefined && object.activeSvcProxy !== null)
      ? HostPort.fromPartial(object.activeSvcProxy)
      : undefined;
    message.geo = object.geo ?? 0;
    message.updatedTs = object.updatedTs ?? undefined;
    return message;
  },
};

function createBaseCellPair(): CellPair {
  return {
    id: undefined,
    cellPairUuid: "",
    cellAUuid: "",
    cellBUuid: "",
    activeCellUuid: "",
    standbyCellUuid: "",
    activeSvcProxy: undefined,
    updatedTs: undefined,
  };
}

export const CellPair: MessageFns<CellPair> = {
  encode(message: CellPair, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.cellPairUuid !== "") {
      writer.uint32(26).string(message.cellPairUuid);
    }
    if (message.cellAUuid !== "") {
      writer.uint32(34).string(message.cellAUuid);
    }
    if (message.cellBUuid !== "") {
      writer.uint32(42).string(message.cellBUuid);
    }
    if (message.activeCellUuid !== "") {
      writer.uint32(50).string(message.activeCellUuid);
    }
    if (message.standbyCellUuid !== "") {
      writer.uint32(58).string(message.standbyCellUuid);
    }
    if (message.activeSvcProxy !== undefined) {
      HostPort.encode(message.activeSvcProxy, writer.uint32(66).fork()).join();
    }
    if (message.updatedTs !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedTs), writer.uint32(162).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CellPair {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCellPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.cellPairUuid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.cellAUuid = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.cellBUuid = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.activeCellUuid = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.standbyCellUuid = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.activeSvcProxy = HostPort.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.updatedTs = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CellPair {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      cellPairUuid: isSet(object.cellPairUuid) ? globalThis.String(object.cellPairUuid) : "",
      cellAUuid: isSet(object.cellAUuid) ? globalThis.String(object.cellAUuid) : "",
      cellBUuid: isSet(object.cellBUuid) ? globalThis.String(object.cellBUuid) : "",
      activeCellUuid: isSet(object.activeCellUuid) ? globalThis.String(object.activeCellUuid) : "",
      standbyCellUuid: isSet(object.standbyCellUuid) ? globalThis.String(object.standbyCellUuid) : "",
      activeSvcProxy: isSet(object.activeSvcProxy) ? HostPort.fromJSON(object.activeSvcProxy) : undefined,
      updatedTs: isSet(object.updatedTs) ? fromJsonTimestamp(object.updatedTs) : undefined,
    };
  },

  toJSON(message: CellPair): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.cellPairUuid !== "") {
      obj.cellPairUuid = message.cellPairUuid;
    }
    if (message.cellAUuid !== "") {
      obj.cellAUuid = message.cellAUuid;
    }
    if (message.cellBUuid !== "") {
      obj.cellBUuid = message.cellBUuid;
    }
    if (message.activeCellUuid !== "") {
      obj.activeCellUuid = message.activeCellUuid;
    }
    if (message.standbyCellUuid !== "") {
      obj.standbyCellUuid = message.standbyCellUuid;
    }
    if (message.activeSvcProxy !== undefined) {
      obj.activeSvcProxy = HostPort.toJSON(message.activeSvcProxy);
    }
    if (message.updatedTs !== undefined) {
      obj.updatedTs = message.updatedTs.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CellPair>, I>>(base?: I): CellPair {
    return CellPair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CellPair>, I>>(object: I): CellPair {
    const message = createBaseCellPair();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.cellPairUuid = object.cellPairUuid ?? "";
    message.cellAUuid = object.cellAUuid ?? "";
    message.cellBUuid = object.cellBUuid ?? "";
    message.activeCellUuid = object.activeCellUuid ?? "";
    message.standbyCellUuid = object.standbyCellUuid ?? "";
    message.activeSvcProxy = (object.activeSvcProxy !== undefined && object.activeSvcProxy !== null)
      ? HostPort.fromPartial(object.activeSvcProxy)
      : undefined;
    message.updatedTs = object.updatedTs ?? undefined;
    return message;
  },
};

function createBaseHostPort(): HostPort {
  return { host: "", httpsPort: 0, grpcPort: 0, privatePort: 0 };
}

export const HostPort: MessageFns<HostPort> = {
  encode(message: HostPort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.host !== "") {
      writer.uint32(10).string(message.host);
    }
    if (message.httpsPort !== 0) {
      writer.uint32(16).uint32(message.httpsPort);
    }
    if (message.grpcPort !== 0) {
      writer.uint32(24).uint32(message.grpcPort);
    }
    if (message.privatePort !== 0) {
      writer.uint32(32).uint32(message.privatePort);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HostPort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostPort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.host = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.httpsPort = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.grpcPort = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.privatePort = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HostPort {
    return {
      host: isSet(object.host) ? globalThis.String(object.host) : "",
      httpsPort: isSet(object.httpsPort) ? globalThis.Number(object.httpsPort) : 0,
      grpcPort: isSet(object.grpcPort) ? globalThis.Number(object.grpcPort) : 0,
      privatePort: isSet(object.privatePort) ? globalThis.Number(object.privatePort) : 0,
    };
  },

  toJSON(message: HostPort): unknown {
    const obj: any = {};
    if (message.host !== "") {
      obj.host = message.host;
    }
    if (message.httpsPort !== 0) {
      obj.httpsPort = Math.round(message.httpsPort);
    }
    if (message.grpcPort !== 0) {
      obj.grpcPort = Math.round(message.grpcPort);
    }
    if (message.privatePort !== 0) {
      obj.privatePort = Math.round(message.privatePort);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HostPort>, I>>(base?: I): HostPort {
    return HostPort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HostPort>, I>>(object: I): HostPort {
    const message = createBaseHostPort();
    message.host = object.host ?? "";
    message.httpsPort = object.httpsPort ?? 0;
    message.grpcPort = object.grpcPort ?? 0;
    message.privatePort = object.privatePort ?? 0;
    return message;
  },
};

function createBaseK8sNodeInfo(): K8sNodeInfo {
  return { nodeName: "", nodeIp: "", availabilityZone: "" };
}

export const K8sNodeInfo: MessageFns<K8sNodeInfo> = {
  encode(message: K8sNodeInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeName !== "") {
      writer.uint32(10).string(message.nodeName);
    }
    if (message.nodeIp !== "") {
      writer.uint32(18).string(message.nodeIp);
    }
    if (message.availabilityZone !== "") {
      writer.uint32(26).string(message.availabilityZone);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): K8sNodeInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseK8sNodeInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeIp = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.availabilityZone = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): K8sNodeInfo {
    return {
      nodeName: isSet(object.nodeName) ? globalThis.String(object.nodeName) : "",
      nodeIp: isSet(object.nodeIp) ? globalThis.String(object.nodeIp) : "",
      availabilityZone: isSet(object.availabilityZone) ? globalThis.String(object.availabilityZone) : "",
    };
  },

  toJSON(message: K8sNodeInfo): unknown {
    const obj: any = {};
    if (message.nodeName !== "") {
      obj.nodeName = message.nodeName;
    }
    if (message.nodeIp !== "") {
      obj.nodeIp = message.nodeIp;
    }
    if (message.availabilityZone !== "") {
      obj.availabilityZone = message.availabilityZone;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<K8sNodeInfo>, I>>(base?: I): K8sNodeInfo {
    return K8sNodeInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<K8sNodeInfo>, I>>(object: I): K8sNodeInfo {
    const message = createBaseK8sNodeInfo();
    message.nodeName = object.nodeName ?? "";
    message.nodeIp = object.nodeIp ?? "";
    message.availabilityZone = object.availabilityZone ?? "";
    return message;
  },
};

function createBaseKubernetesServiceInstance(): KubernetesServiceInstance {
  return {
    id: undefined,
    podUuid: "",
    appName: 0,
    appReadiness: 0,
    instanceName: "",
    instanceId: 0,
    softwareVersion: "",
    clusterId: "",
    host: undefined,
    loadBalancedHost: undefined,
    nodeInfo: undefined,
    updatedTs: undefined,
  };
}

export const KubernetesServiceInstance: MessageFns<KubernetesServiceInstance> = {
  encode(message: KubernetesServiceInstance, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.podUuid !== "") {
      writer.uint32(26).string(message.podUuid);
    }
    if (message.appName !== 0) {
      writer.uint32(32).int32(message.appName);
    }
    if (message.appReadiness !== 0) {
      writer.uint32(40).int32(message.appReadiness);
    }
    if (message.instanceName !== "") {
      writer.uint32(50).string(message.instanceName);
    }
    if (message.instanceId !== 0) {
      writer.uint32(56).int32(message.instanceId);
    }
    if (message.softwareVersion !== "") {
      writer.uint32(82).string(message.softwareVersion);
    }
    if (message.clusterId !== "") {
      writer.uint32(90).string(message.clusterId);
    }
    if (message.host !== undefined) {
      HostPort.encode(message.host, writer.uint32(122).fork()).join();
    }
    if (message.loadBalancedHost !== undefined) {
      HostPort.encode(message.loadBalancedHost, writer.uint32(130).fork()).join();
    }
    if (message.nodeInfo !== undefined) {
      K8sNodeInfo.encode(message.nodeInfo, writer.uint32(138).fork()).join();
    }
    if (message.updatedTs !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedTs), writer.uint32(162).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KubernetesServiceInstance {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKubernetesServiceInstance();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.podUuid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.appName = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.appReadiness = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.instanceName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.instanceId = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.softwareVersion = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.clusterId = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.host = HostPort.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.loadBalancedHost = HostPort.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.nodeInfo = K8sNodeInfo.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.updatedTs = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KubernetesServiceInstance {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      podUuid: isSet(object.podUuid) ? globalThis.String(object.podUuid) : "",
      appName: isSet(object.appName) ? applicationIdentityFromJSON(object.appName) : 0,
      appReadiness: isSet(object.appReadiness) ? applicationReadinessFromJSON(object.appReadiness) : 0,
      instanceName: isSet(object.instanceName) ? globalThis.String(object.instanceName) : "",
      instanceId: isSet(object.instanceId) ? globalThis.Number(object.instanceId) : 0,
      softwareVersion: isSet(object.softwareVersion) ? globalThis.String(object.softwareVersion) : "",
      clusterId: isSet(object.clusterId) ? globalThis.String(object.clusterId) : "",
      host: isSet(object.host) ? HostPort.fromJSON(object.host) : undefined,
      loadBalancedHost: isSet(object.loadBalancedHost) ? HostPort.fromJSON(object.loadBalancedHost) : undefined,
      nodeInfo: isSet(object.nodeInfo) ? K8sNodeInfo.fromJSON(object.nodeInfo) : undefined,
      updatedTs: isSet(object.updatedTs) ? fromJsonTimestamp(object.updatedTs) : undefined,
    };
  },

  toJSON(message: KubernetesServiceInstance): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.podUuid !== "") {
      obj.podUuid = message.podUuid;
    }
    if (message.appName !== 0) {
      obj.appName = applicationIdentityToJSON(message.appName);
    }
    if (message.appReadiness !== 0) {
      obj.appReadiness = applicationReadinessToJSON(message.appReadiness);
    }
    if (message.instanceName !== "") {
      obj.instanceName = message.instanceName;
    }
    if (message.instanceId !== 0) {
      obj.instanceId = Math.round(message.instanceId);
    }
    if (message.softwareVersion !== "") {
      obj.softwareVersion = message.softwareVersion;
    }
    if (message.clusterId !== "") {
      obj.clusterId = message.clusterId;
    }
    if (message.host !== undefined) {
      obj.host = HostPort.toJSON(message.host);
    }
    if (message.loadBalancedHost !== undefined) {
      obj.loadBalancedHost = HostPort.toJSON(message.loadBalancedHost);
    }
    if (message.nodeInfo !== undefined) {
      obj.nodeInfo = K8sNodeInfo.toJSON(message.nodeInfo);
    }
    if (message.updatedTs !== undefined) {
      obj.updatedTs = message.updatedTs.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KubernetesServiceInstance>, I>>(base?: I): KubernetesServiceInstance {
    return KubernetesServiceInstance.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KubernetesServiceInstance>, I>>(object: I): KubernetesServiceInstance {
    const message = createBaseKubernetesServiceInstance();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.podUuid = object.podUuid ?? "";
    message.appName = object.appName ?? 0;
    message.appReadiness = object.appReadiness ?? 0;
    message.instanceName = object.instanceName ?? "";
    message.instanceId = object.instanceId ?? 0;
    message.softwareVersion = object.softwareVersion ?? "";
    message.clusterId = object.clusterId ?? "";
    message.host = (object.host !== undefined && object.host !== null) ? HostPort.fromPartial(object.host) : undefined;
    message.loadBalancedHost = (object.loadBalancedHost !== undefined && object.loadBalancedHost !== null)
      ? HostPort.fromPartial(object.loadBalancedHost)
      : undefined;
    message.nodeInfo = (object.nodeInfo !== undefined && object.nodeInfo !== null)
      ? K8sNodeInfo.fromPartial(object.nodeInfo)
      : undefined;
    message.updatedTs = object.updatedTs ?? undefined;
    return message;
  },
};

function createBaseQsfpInfo(): QsfpInfo {
  return {
    id: undefined,
    activeApselHostlane1: false,
    activeApselHostlane2: false,
    activeApselHostlane3: false,
    activeApselHostlane4: false,
    activeApselHostlane5: false,
    activeApselHostlane6: false,
    activeApselHostlane7: false,
    activeApselHostlane8: false,
    activeFirmware: "",
    applicationAdvertisement: "",
    cableLength: 0,
    cableType: "",
    cmisRev: 0,
    connector: "",
    domCapability: "",
    encoding: "",
    extIdentifier: "",
    extRateselectCompliance: "",
    hardwareRev: 0,
    hostElectricalInterface: "",
    hostLaneAssignmentOption: 0,
    hostLaneCount: 0,
    inactiveFirmware: "",
    isReplaceable: false,
    manufacturer: "",
    mediaInterfaceCode: "",
    mediaInterfaceTechnology: "",
    mediaLaneAssignmentOption: 0,
    mediaLaneCount: 0,
    model: "",
    nominalBitRate: 0,
    serial: "",
    specificationCompliance: "",
    supportedMaxLaserFreq: 0,
    supportedMaxTxPower: 0,
    supportedMinLaserFreq: 0,
    supportedMinTxPower: 0,
    type: "",
    vendorDate: undefined,
    vendorOui: "",
    vendorRev: "",
    transceiverModule: 0,
    pid: "",
    interfaceName: "",
    neighborType: 0,
    collectedAt: undefined,
    duplex: 0,
    advertisedAutoNegotiation: 0,
    transceiver: 0,
    phyAd: 0,
    wakeOn: "",
    advertisedFec: 0,
    advertisedPauseFrameUse: "",
    autoNegotiation: 0,
    portAlias: "",
    lot: "",
    qsfpOperStatus: undefined,
    hasAdapter: false,
    adapterInfo: undefined,
  };
}

export const QsfpInfo: MessageFns<QsfpInfo> = {
  encode(message: QsfpInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.activeApselHostlane1 !== false) {
      writer.uint32(24).bool(message.activeApselHostlane1);
    }
    if (message.activeApselHostlane2 !== false) {
      writer.uint32(32).bool(message.activeApselHostlane2);
    }
    if (message.activeApselHostlane3 !== false) {
      writer.uint32(40).bool(message.activeApselHostlane3);
    }
    if (message.activeApselHostlane4 !== false) {
      writer.uint32(48).bool(message.activeApselHostlane4);
    }
    if (message.activeApselHostlane5 !== false) {
      writer.uint32(56).bool(message.activeApselHostlane5);
    }
    if (message.activeApselHostlane6 !== false) {
      writer.uint32(64).bool(message.activeApselHostlane6);
    }
    if (message.activeApselHostlane7 !== false) {
      writer.uint32(72).bool(message.activeApselHostlane7);
    }
    if (message.activeApselHostlane8 !== false) {
      writer.uint32(80).bool(message.activeApselHostlane8);
    }
    if (message.activeFirmware !== "") {
      writer.uint32(90).string(message.activeFirmware);
    }
    if (message.applicationAdvertisement !== "") {
      writer.uint32(98).string(message.applicationAdvertisement);
    }
    if (message.cableLength !== 0) {
      writer.uint32(109).float(message.cableLength);
    }
    if (message.cableType !== "") {
      writer.uint32(114).string(message.cableType);
    }
    if (message.cmisRev !== 0) {
      writer.uint32(125).float(message.cmisRev);
    }
    if (message.connector !== "") {
      writer.uint32(130).string(message.connector);
    }
    if (message.domCapability !== "") {
      writer.uint32(138).string(message.domCapability);
    }
    if (message.encoding !== "") {
      writer.uint32(146).string(message.encoding);
    }
    if (message.extIdentifier !== "") {
      writer.uint32(154).string(message.extIdentifier);
    }
    if (message.extRateselectCompliance !== "") {
      writer.uint32(162).string(message.extRateselectCompliance);
    }
    if (message.hardwareRev !== 0) {
      writer.uint32(173).float(message.hardwareRev);
    }
    if (message.hostElectricalInterface !== "") {
      writer.uint32(178).string(message.hostElectricalInterface);
    }
    if (message.hostLaneAssignmentOption !== 0) {
      writer.uint32(184).int32(message.hostLaneAssignmentOption);
    }
    if (message.hostLaneCount !== 0) {
      writer.uint32(192).int32(message.hostLaneCount);
    }
    if (message.inactiveFirmware !== "") {
      writer.uint32(202).string(message.inactiveFirmware);
    }
    if (message.isReplaceable !== false) {
      writer.uint32(208).bool(message.isReplaceable);
    }
    if (message.manufacturer !== "") {
      writer.uint32(218).string(message.manufacturer);
    }
    if (message.mediaInterfaceCode !== "") {
      writer.uint32(226).string(message.mediaInterfaceCode);
    }
    if (message.mediaInterfaceTechnology !== "") {
      writer.uint32(234).string(message.mediaInterfaceTechnology);
    }
    if (message.mediaLaneAssignmentOption !== 0) {
      writer.uint32(240).int32(message.mediaLaneAssignmentOption);
    }
    if (message.mediaLaneCount !== 0) {
      writer.uint32(248).int32(message.mediaLaneCount);
    }
    if (message.model !== "") {
      writer.uint32(258).string(message.model);
    }
    if (message.nominalBitRate !== 0) {
      writer.uint32(269).float(message.nominalBitRate);
    }
    if (message.serial !== "") {
      writer.uint32(274).string(message.serial);
    }
    if (message.specificationCompliance !== "") {
      writer.uint32(282).string(message.specificationCompliance);
    }
    if (message.supportedMaxLaserFreq !== 0) {
      writer.uint32(293).float(message.supportedMaxLaserFreq);
    }
    if (message.supportedMaxTxPower !== 0) {
      writer.uint32(301).float(message.supportedMaxTxPower);
    }
    if (message.supportedMinLaserFreq !== 0) {
      writer.uint32(309).float(message.supportedMinLaserFreq);
    }
    if (message.supportedMinTxPower !== 0) {
      writer.uint32(317).float(message.supportedMinTxPower);
    }
    if (message.type !== "") {
      writer.uint32(322).string(message.type);
    }
    if (message.vendorDate !== undefined) {
      Timestamp.encode(toTimestamp(message.vendorDate), writer.uint32(330).fork()).join();
    }
    if (message.vendorOui !== "") {
      writer.uint32(338).string(message.vendorOui);
    }
    if (message.vendorRev !== "") {
      writer.uint32(346).string(message.vendorRev);
    }
    if (message.transceiverModule !== 0) {
      writer.uint32(352).int32(message.transceiverModule);
    }
    if (message.pid !== "") {
      writer.uint32(362).string(message.pid);
    }
    if (message.interfaceName !== "") {
      writer.uint32(370).string(message.interfaceName);
    }
    if (message.neighborType !== 0) {
      writer.uint32(376).int32(message.neighborType);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(482).fork()).join();
    }
    if (message.duplex !== 0) {
      writer.uint32(488).int32(message.duplex);
    }
    if (message.advertisedAutoNegotiation !== 0) {
      writer.uint32(496).int32(message.advertisedAutoNegotiation);
    }
    if (message.transceiver !== 0) {
      writer.uint32(504).int32(message.transceiver);
    }
    if (message.phyAd !== 0) {
      writer.uint32(512).uint32(message.phyAd);
    }
    if (message.wakeOn !== "") {
      writer.uint32(522).string(message.wakeOn);
    }
    if (message.advertisedFec !== 0) {
      writer.uint32(536).int32(message.advertisedFec);
    }
    if (message.advertisedPauseFrameUse !== "") {
      writer.uint32(546).string(message.advertisedPauseFrameUse);
    }
    if (message.autoNegotiation !== 0) {
      writer.uint32(552).int32(message.autoNegotiation);
    }
    if (message.portAlias !== "") {
      writer.uint32(562).string(message.portAlias);
    }
    if (message.lot !== "") {
      writer.uint32(570).string(message.lot);
    }
    if (message.qsfpOperStatus !== undefined) {
      QsfpOperStatus.encode(message.qsfpOperStatus, writer.uint32(578).fork()).join();
    }
    if (message.hasAdapter !== false) {
      writer.uint32(584).bool(message.hasAdapter);
    }
    if (message.adapterInfo !== undefined) {
      QsfpAdapterInfo.encode(message.adapterInfo, writer.uint32(594).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QsfpInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQsfpInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.activeApselHostlane1 = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.activeApselHostlane2 = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.activeApselHostlane3 = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.activeApselHostlane4 = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.activeApselHostlane5 = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.activeApselHostlane6 = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.activeApselHostlane7 = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.activeApselHostlane8 = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.activeFirmware = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.applicationAdvertisement = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 109) {
            break;
          }

          message.cableLength = reader.float();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.cableType = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 125) {
            break;
          }

          message.cmisRev = reader.float();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.connector = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.domCapability = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.encoding = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.extIdentifier = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.extRateselectCompliance = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 173) {
            break;
          }

          message.hardwareRev = reader.float();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.hostElectricalInterface = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.hostLaneAssignmentOption = reader.int32();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.hostLaneCount = reader.int32();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.inactiveFirmware = reader.string();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.isReplaceable = reader.bool();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.mediaInterfaceCode = reader.string();
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.mediaInterfaceTechnology = reader.string();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.mediaLaneAssignmentOption = reader.int32();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.mediaLaneCount = reader.int32();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 33: {
          if (tag !== 269) {
            break;
          }

          message.nominalBitRate = reader.float();
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.specificationCompliance = reader.string();
          continue;
        }
        case 36: {
          if (tag !== 293) {
            break;
          }

          message.supportedMaxLaserFreq = reader.float();
          continue;
        }
        case 37: {
          if (tag !== 301) {
            break;
          }

          message.supportedMaxTxPower = reader.float();
          continue;
        }
        case 38: {
          if (tag !== 309) {
            break;
          }

          message.supportedMinLaserFreq = reader.float();
          continue;
        }
        case 39: {
          if (tag !== 317) {
            break;
          }

          message.supportedMinTxPower = reader.float();
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.vendorDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.vendorOui = reader.string();
          continue;
        }
        case 43: {
          if (tag !== 346) {
            break;
          }

          message.vendorRev = reader.string();
          continue;
        }
        case 44: {
          if (tag !== 352) {
            break;
          }

          message.transceiverModule = reader.int32() as any;
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.pid = reader.string();
          continue;
        }
        case 46: {
          if (tag !== 370) {
            break;
          }

          message.interfaceName = reader.string();
          continue;
        }
        case 47: {
          if (tag !== 376) {
            break;
          }

          message.neighborType = reader.int32() as any;
          continue;
        }
        case 60: {
          if (tag !== 482) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 61: {
          if (tag !== 488) {
            break;
          }

          message.duplex = reader.int32() as any;
          continue;
        }
        case 62: {
          if (tag !== 496) {
            break;
          }

          message.advertisedAutoNegotiation = reader.int32() as any;
          continue;
        }
        case 63: {
          if (tag !== 504) {
            break;
          }

          message.transceiver = reader.int32() as any;
          continue;
        }
        case 64: {
          if (tag !== 512) {
            break;
          }

          message.phyAd = reader.uint32();
          continue;
        }
        case 65: {
          if (tag !== 522) {
            break;
          }

          message.wakeOn = reader.string();
          continue;
        }
        case 67: {
          if (tag !== 536) {
            break;
          }

          message.advertisedFec = reader.int32() as any;
          continue;
        }
        case 68: {
          if (tag !== 546) {
            break;
          }

          message.advertisedPauseFrameUse = reader.string();
          continue;
        }
        case 69: {
          if (tag !== 552) {
            break;
          }

          message.autoNegotiation = reader.int32() as any;
          continue;
        }
        case 70: {
          if (tag !== 562) {
            break;
          }

          message.portAlias = reader.string();
          continue;
        }
        case 71: {
          if (tag !== 570) {
            break;
          }

          message.lot = reader.string();
          continue;
        }
        case 72: {
          if (tag !== 578) {
            break;
          }

          message.qsfpOperStatus = QsfpOperStatus.decode(reader, reader.uint32());
          continue;
        }
        case 73: {
          if (tag !== 584) {
            break;
          }

          message.hasAdapter = reader.bool();
          continue;
        }
        case 74: {
          if (tag !== 594) {
            break;
          }

          message.adapterInfo = QsfpAdapterInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QsfpInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      activeApselHostlane1: isSet(object.activeApselHostlane1)
        ? globalThis.Boolean(object.activeApselHostlane1)
        : false,
      activeApselHostlane2: isSet(object.activeApselHostlane2)
        ? globalThis.Boolean(object.activeApselHostlane2)
        : false,
      activeApselHostlane3: isSet(object.activeApselHostlane3)
        ? globalThis.Boolean(object.activeApselHostlane3)
        : false,
      activeApselHostlane4: isSet(object.activeApselHostlane4)
        ? globalThis.Boolean(object.activeApselHostlane4)
        : false,
      activeApselHostlane5: isSet(object.activeApselHostlane5)
        ? globalThis.Boolean(object.activeApselHostlane5)
        : false,
      activeApselHostlane6: isSet(object.activeApselHostlane6)
        ? globalThis.Boolean(object.activeApselHostlane6)
        : false,
      activeApselHostlane7: isSet(object.activeApselHostlane7)
        ? globalThis.Boolean(object.activeApselHostlane7)
        : false,
      activeApselHostlane8: isSet(object.activeApselHostlane8)
        ? globalThis.Boolean(object.activeApselHostlane8)
        : false,
      activeFirmware: isSet(object.activeFirmware) ? globalThis.String(object.activeFirmware) : "",
      applicationAdvertisement: isSet(object.applicationAdvertisement)
        ? globalThis.String(object.applicationAdvertisement)
        : "",
      cableLength: isSet(object.cableLength) ? globalThis.Number(object.cableLength) : 0,
      cableType: isSet(object.cableType) ? globalThis.String(object.cableType) : "",
      cmisRev: isSet(object.cmisRev) ? globalThis.Number(object.cmisRev) : 0,
      connector: isSet(object.connector) ? globalThis.String(object.connector) : "",
      domCapability: isSet(object.domCapability) ? globalThis.String(object.domCapability) : "",
      encoding: isSet(object.encoding) ? globalThis.String(object.encoding) : "",
      extIdentifier: isSet(object.extIdentifier) ? globalThis.String(object.extIdentifier) : "",
      extRateselectCompliance: isSet(object.extRateselectCompliance)
        ? globalThis.String(object.extRateselectCompliance)
        : "",
      hardwareRev: isSet(object.hardwareRev) ? globalThis.Number(object.hardwareRev) : 0,
      hostElectricalInterface: isSet(object.hostElectricalInterface)
        ? globalThis.String(object.hostElectricalInterface)
        : "",
      hostLaneAssignmentOption: isSet(object.hostLaneAssignmentOption)
        ? globalThis.Number(object.hostLaneAssignmentOption)
        : 0,
      hostLaneCount: isSet(object.hostLaneCount) ? globalThis.Number(object.hostLaneCount) : 0,
      inactiveFirmware: isSet(object.inactiveFirmware) ? globalThis.String(object.inactiveFirmware) : "",
      isReplaceable: isSet(object.isReplaceable) ? globalThis.Boolean(object.isReplaceable) : false,
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : "",
      mediaInterfaceCode: isSet(object.mediaInterfaceCode) ? globalThis.String(object.mediaInterfaceCode) : "",
      mediaInterfaceTechnology: isSet(object.mediaInterfaceTechnology)
        ? globalThis.String(object.mediaInterfaceTechnology)
        : "",
      mediaLaneAssignmentOption: isSet(object.mediaLaneAssignmentOption)
        ? globalThis.Number(object.mediaLaneAssignmentOption)
        : 0,
      mediaLaneCount: isSet(object.mediaLaneCount) ? globalThis.Number(object.mediaLaneCount) : 0,
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      nominalBitRate: isSet(object.nominalBitRate) ? globalThis.Number(object.nominalBitRate) : 0,
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      specificationCompliance: isSet(object.specificationCompliance)
        ? globalThis.String(object.specificationCompliance)
        : "",
      supportedMaxLaserFreq: isSet(object.supportedMaxLaserFreq) ? globalThis.Number(object.supportedMaxLaserFreq) : 0,
      supportedMaxTxPower: isSet(object.supportedMaxTxPower) ? globalThis.Number(object.supportedMaxTxPower) : 0,
      supportedMinLaserFreq: isSet(object.supportedMinLaserFreq) ? globalThis.Number(object.supportedMinLaserFreq) : 0,
      supportedMinTxPower: isSet(object.supportedMinTxPower) ? globalThis.Number(object.supportedMinTxPower) : 0,
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      vendorDate: isSet(object.vendorDate) ? fromJsonTimestamp(object.vendorDate) : undefined,
      vendorOui: isSet(object.vendorOui) ? globalThis.String(object.vendorOui) : "",
      vendorRev: isSet(object.vendorRev) ? globalThis.String(object.vendorRev) : "",
      transceiverModule: isSet(object.transceiverModule) ? qsfpTransceiverModuleFromJSON(object.transceiverModule) : 0,
      pid: isSet(object.pid) ? globalThis.String(object.pid) : "",
      interfaceName: isSet(object.interfaceName) ? globalThis.String(object.interfaceName) : "",
      neighborType: isSet(object.neighborType) ? neighborTypeFromJSON(object.neighborType) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      duplex: isSet(object.duplex) ? qsfpDupexFromJSON(object.duplex) : 0,
      advertisedAutoNegotiation: isSet(object.advertisedAutoNegotiation)
        ? qsfpAdvertisedAutoNegotiationFromJSON(object.advertisedAutoNegotiation)
        : 0,
      transceiver: isSet(object.transceiver) ? qsfpTransceiverFromJSON(object.transceiver) : 0,
      phyAd: isSet(object.phyAd) ? globalThis.Number(object.phyAd) : 0,
      wakeOn: isSet(object.wakeOn) ? globalThis.String(object.wakeOn) : "",
      advertisedFec: isSet(object.advertisedFec) ? fecTypeFromJSON(object.advertisedFec) : 0,
      advertisedPauseFrameUse: isSet(object.advertisedPauseFrameUse)
        ? globalThis.String(object.advertisedPauseFrameUse)
        : "",
      autoNegotiation: isSet(object.autoNegotiation) ? qsfpAutoNegotiationFromJSON(object.autoNegotiation) : 0,
      portAlias: isSet(object.portAlias) ? globalThis.String(object.portAlias) : "",
      lot: isSet(object.lot) ? globalThis.String(object.lot) : "",
      qsfpOperStatus: isSet(object.qsfpOperStatus) ? QsfpOperStatus.fromJSON(object.qsfpOperStatus) : undefined,
      hasAdapter: isSet(object.hasAdapter) ? globalThis.Boolean(object.hasAdapter) : false,
      adapterInfo: isSet(object.adapterInfo) ? QsfpAdapterInfo.fromJSON(object.adapterInfo) : undefined,
    };
  },

  toJSON(message: QsfpInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.activeApselHostlane1 !== false) {
      obj.activeApselHostlane1 = message.activeApselHostlane1;
    }
    if (message.activeApselHostlane2 !== false) {
      obj.activeApselHostlane2 = message.activeApselHostlane2;
    }
    if (message.activeApselHostlane3 !== false) {
      obj.activeApselHostlane3 = message.activeApselHostlane3;
    }
    if (message.activeApselHostlane4 !== false) {
      obj.activeApselHostlane4 = message.activeApselHostlane4;
    }
    if (message.activeApselHostlane5 !== false) {
      obj.activeApselHostlane5 = message.activeApselHostlane5;
    }
    if (message.activeApselHostlane6 !== false) {
      obj.activeApselHostlane6 = message.activeApselHostlane6;
    }
    if (message.activeApselHostlane7 !== false) {
      obj.activeApselHostlane7 = message.activeApselHostlane7;
    }
    if (message.activeApselHostlane8 !== false) {
      obj.activeApselHostlane8 = message.activeApselHostlane8;
    }
    if (message.activeFirmware !== "") {
      obj.activeFirmware = message.activeFirmware;
    }
    if (message.applicationAdvertisement !== "") {
      obj.applicationAdvertisement = message.applicationAdvertisement;
    }
    if (message.cableLength !== 0) {
      obj.cableLength = message.cableLength;
    }
    if (message.cableType !== "") {
      obj.cableType = message.cableType;
    }
    if (message.cmisRev !== 0) {
      obj.cmisRev = message.cmisRev;
    }
    if (message.connector !== "") {
      obj.connector = message.connector;
    }
    if (message.domCapability !== "") {
      obj.domCapability = message.domCapability;
    }
    if (message.encoding !== "") {
      obj.encoding = message.encoding;
    }
    if (message.extIdentifier !== "") {
      obj.extIdentifier = message.extIdentifier;
    }
    if (message.extRateselectCompliance !== "") {
      obj.extRateselectCompliance = message.extRateselectCompliance;
    }
    if (message.hardwareRev !== 0) {
      obj.hardwareRev = message.hardwareRev;
    }
    if (message.hostElectricalInterface !== "") {
      obj.hostElectricalInterface = message.hostElectricalInterface;
    }
    if (message.hostLaneAssignmentOption !== 0) {
      obj.hostLaneAssignmentOption = Math.round(message.hostLaneAssignmentOption);
    }
    if (message.hostLaneCount !== 0) {
      obj.hostLaneCount = Math.round(message.hostLaneCount);
    }
    if (message.inactiveFirmware !== "") {
      obj.inactiveFirmware = message.inactiveFirmware;
    }
    if (message.isReplaceable !== false) {
      obj.isReplaceable = message.isReplaceable;
    }
    if (message.manufacturer !== "") {
      obj.manufacturer = message.manufacturer;
    }
    if (message.mediaInterfaceCode !== "") {
      obj.mediaInterfaceCode = message.mediaInterfaceCode;
    }
    if (message.mediaInterfaceTechnology !== "") {
      obj.mediaInterfaceTechnology = message.mediaInterfaceTechnology;
    }
    if (message.mediaLaneAssignmentOption !== 0) {
      obj.mediaLaneAssignmentOption = Math.round(message.mediaLaneAssignmentOption);
    }
    if (message.mediaLaneCount !== 0) {
      obj.mediaLaneCount = Math.round(message.mediaLaneCount);
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.nominalBitRate !== 0) {
      obj.nominalBitRate = message.nominalBitRate;
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.specificationCompliance !== "") {
      obj.specificationCompliance = message.specificationCompliance;
    }
    if (message.supportedMaxLaserFreq !== 0) {
      obj.supportedMaxLaserFreq = message.supportedMaxLaserFreq;
    }
    if (message.supportedMaxTxPower !== 0) {
      obj.supportedMaxTxPower = message.supportedMaxTxPower;
    }
    if (message.supportedMinLaserFreq !== 0) {
      obj.supportedMinLaserFreq = message.supportedMinLaserFreq;
    }
    if (message.supportedMinTxPower !== 0) {
      obj.supportedMinTxPower = message.supportedMinTxPower;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.vendorDate !== undefined) {
      obj.vendorDate = message.vendorDate.toISOString();
    }
    if (message.vendorOui !== "") {
      obj.vendorOui = message.vendorOui;
    }
    if (message.vendorRev !== "") {
      obj.vendorRev = message.vendorRev;
    }
    if (message.transceiverModule !== 0) {
      obj.transceiverModule = qsfpTransceiverModuleToJSON(message.transceiverModule);
    }
    if (message.pid !== "") {
      obj.pid = message.pid;
    }
    if (message.interfaceName !== "") {
      obj.interfaceName = message.interfaceName;
    }
    if (message.neighborType !== 0) {
      obj.neighborType = neighborTypeToJSON(message.neighborType);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.duplex !== 0) {
      obj.duplex = qsfpDupexToJSON(message.duplex);
    }
    if (message.advertisedAutoNegotiation !== 0) {
      obj.advertisedAutoNegotiation = qsfpAdvertisedAutoNegotiationToJSON(message.advertisedAutoNegotiation);
    }
    if (message.transceiver !== 0) {
      obj.transceiver = qsfpTransceiverToJSON(message.transceiver);
    }
    if (message.phyAd !== 0) {
      obj.phyAd = Math.round(message.phyAd);
    }
    if (message.wakeOn !== "") {
      obj.wakeOn = message.wakeOn;
    }
    if (message.advertisedFec !== 0) {
      obj.advertisedFec = fecTypeToJSON(message.advertisedFec);
    }
    if (message.advertisedPauseFrameUse !== "") {
      obj.advertisedPauseFrameUse = message.advertisedPauseFrameUse;
    }
    if (message.autoNegotiation !== 0) {
      obj.autoNegotiation = qsfpAutoNegotiationToJSON(message.autoNegotiation);
    }
    if (message.portAlias !== "") {
      obj.portAlias = message.portAlias;
    }
    if (message.lot !== "") {
      obj.lot = message.lot;
    }
    if (message.qsfpOperStatus !== undefined) {
      obj.qsfpOperStatus = QsfpOperStatus.toJSON(message.qsfpOperStatus);
    }
    if (message.hasAdapter !== false) {
      obj.hasAdapter = message.hasAdapter;
    }
    if (message.adapterInfo !== undefined) {
      obj.adapterInfo = QsfpAdapterInfo.toJSON(message.adapterInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QsfpInfo>, I>>(base?: I): QsfpInfo {
    return QsfpInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QsfpInfo>, I>>(object: I): QsfpInfo {
    const message = createBaseQsfpInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.activeApselHostlane1 = object.activeApselHostlane1 ?? false;
    message.activeApselHostlane2 = object.activeApselHostlane2 ?? false;
    message.activeApselHostlane3 = object.activeApselHostlane3 ?? false;
    message.activeApselHostlane4 = object.activeApselHostlane4 ?? false;
    message.activeApselHostlane5 = object.activeApselHostlane5 ?? false;
    message.activeApselHostlane6 = object.activeApselHostlane6 ?? false;
    message.activeApselHostlane7 = object.activeApselHostlane7 ?? false;
    message.activeApselHostlane8 = object.activeApselHostlane8 ?? false;
    message.activeFirmware = object.activeFirmware ?? "";
    message.applicationAdvertisement = object.applicationAdvertisement ?? "";
    message.cableLength = object.cableLength ?? 0;
    message.cableType = object.cableType ?? "";
    message.cmisRev = object.cmisRev ?? 0;
    message.connector = object.connector ?? "";
    message.domCapability = object.domCapability ?? "";
    message.encoding = object.encoding ?? "";
    message.extIdentifier = object.extIdentifier ?? "";
    message.extRateselectCompliance = object.extRateselectCompliance ?? "";
    message.hardwareRev = object.hardwareRev ?? 0;
    message.hostElectricalInterface = object.hostElectricalInterface ?? "";
    message.hostLaneAssignmentOption = object.hostLaneAssignmentOption ?? 0;
    message.hostLaneCount = object.hostLaneCount ?? 0;
    message.inactiveFirmware = object.inactiveFirmware ?? "";
    message.isReplaceable = object.isReplaceable ?? false;
    message.manufacturer = object.manufacturer ?? "";
    message.mediaInterfaceCode = object.mediaInterfaceCode ?? "";
    message.mediaInterfaceTechnology = object.mediaInterfaceTechnology ?? "";
    message.mediaLaneAssignmentOption = object.mediaLaneAssignmentOption ?? 0;
    message.mediaLaneCount = object.mediaLaneCount ?? 0;
    message.model = object.model ?? "";
    message.nominalBitRate = object.nominalBitRate ?? 0;
    message.serial = object.serial ?? "";
    message.specificationCompliance = object.specificationCompliance ?? "";
    message.supportedMaxLaserFreq = object.supportedMaxLaserFreq ?? 0;
    message.supportedMaxTxPower = object.supportedMaxTxPower ?? 0;
    message.supportedMinLaserFreq = object.supportedMinLaserFreq ?? 0;
    message.supportedMinTxPower = object.supportedMinTxPower ?? 0;
    message.type = object.type ?? "";
    message.vendorDate = object.vendorDate ?? undefined;
    message.vendorOui = object.vendorOui ?? "";
    message.vendorRev = object.vendorRev ?? "";
    message.transceiverModule = object.transceiverModule ?? 0;
    message.pid = object.pid ?? "";
    message.interfaceName = object.interfaceName ?? "";
    message.neighborType = object.neighborType ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.duplex = object.duplex ?? 0;
    message.advertisedAutoNegotiation = object.advertisedAutoNegotiation ?? 0;
    message.transceiver = object.transceiver ?? 0;
    message.phyAd = object.phyAd ?? 0;
    message.wakeOn = object.wakeOn ?? "";
    message.advertisedFec = object.advertisedFec ?? 0;
    message.advertisedPauseFrameUse = object.advertisedPauseFrameUse ?? "";
    message.autoNegotiation = object.autoNegotiation ?? 0;
    message.portAlias = object.portAlias ?? "";
    message.lot = object.lot ?? "";
    message.qsfpOperStatus = (object.qsfpOperStatus !== undefined && object.qsfpOperStatus !== null)
      ? QsfpOperStatus.fromPartial(object.qsfpOperStatus)
      : undefined;
    message.hasAdapter = object.hasAdapter ?? false;
    message.adapterInfo = (object.adapterInfo !== undefined && object.adapterInfo !== null)
      ? QsfpAdapterInfo.fromPartial(object.adapterInfo)
      : undefined;
    return message;
  },
};

function createBaseQsfpAdapterInfo(): QsfpAdapterInfo {
  return {
    manufacturer: "",
    model: "",
    serial: "",
    vendorRev: "",
    vendorOui: "",
    vendorDate: undefined,
    pid: "",
    type: "",
  };
}

export const QsfpAdapterInfo: MessageFns<QsfpAdapterInfo> = {
  encode(message: QsfpAdapterInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.manufacturer !== "") {
      writer.uint32(10).string(message.manufacturer);
    }
    if (message.model !== "") {
      writer.uint32(18).string(message.model);
    }
    if (message.serial !== "") {
      writer.uint32(26).string(message.serial);
    }
    if (message.vendorRev !== "") {
      writer.uint32(34).string(message.vendorRev);
    }
    if (message.vendorOui !== "") {
      writer.uint32(42).string(message.vendorOui);
    }
    if (message.vendorDate !== undefined) {
      Timestamp.encode(toTimestamp(message.vendorDate), writer.uint32(50).fork()).join();
    }
    if (message.pid !== "") {
      writer.uint32(58).string(message.pid);
    }
    if (message.type !== "") {
      writer.uint32(66).string(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QsfpAdapterInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQsfpAdapterInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.vendorRev = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.vendorOui = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.vendorDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.pid = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.type = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QsfpAdapterInfo {
    return {
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : "",
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      vendorRev: isSet(object.vendorRev) ? globalThis.String(object.vendorRev) : "",
      vendorOui: isSet(object.vendorOui) ? globalThis.String(object.vendorOui) : "",
      vendorDate: isSet(object.vendorDate) ? fromJsonTimestamp(object.vendorDate) : undefined,
      pid: isSet(object.pid) ? globalThis.String(object.pid) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
    };
  },

  toJSON(message: QsfpAdapterInfo): unknown {
    const obj: any = {};
    if (message.manufacturer !== "") {
      obj.manufacturer = message.manufacturer;
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.vendorRev !== "") {
      obj.vendorRev = message.vendorRev;
    }
    if (message.vendorOui !== "") {
      obj.vendorOui = message.vendorOui;
    }
    if (message.vendorDate !== undefined) {
      obj.vendorDate = message.vendorDate.toISOString();
    }
    if (message.pid !== "") {
      obj.pid = message.pid;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QsfpAdapterInfo>, I>>(base?: I): QsfpAdapterInfo {
    return QsfpAdapterInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QsfpAdapterInfo>, I>>(object: I): QsfpAdapterInfo {
    const message = createBaseQsfpAdapterInfo();
    message.manufacturer = object.manufacturer ?? "";
    message.model = object.model ?? "";
    message.serial = object.serial ?? "";
    message.vendorRev = object.vendorRev ?? "";
    message.vendorOui = object.vendorOui ?? "";
    message.vendorDate = object.vendorDate ?? undefined;
    message.pid = object.pid ?? "";
    message.type = object.type ?? "";
    return message;
  },
};

function createBaseQsfpOperStatus(): QsfpOperStatus {
  return {
    cmisState: 0,
    moduleState: 0,
    moduleFaultCause: 0,
    dp1State: 0,
    dp2State: 0,
    dp3State: 0,
    dp4State: 0,
    dp5State: 0,
    dp6State: 0,
    dp7State: 0,
    dp8State: 0,
    configStateHostlane1: 0,
    configStateHostlane2: 0,
    configStateHostlane3: 0,
    configStateHostlane4: 0,
    configStateHostlane5: 0,
    configStateHostlane6: 0,
    configStateHostlane7: 0,
    configStateHostlane8: 0,
    txLoss1: false,
    txLoss2: false,
    txLoss3: false,
    txLoss4: false,
    txLoss5: false,
    txLoss6: false,
    txLoss7: false,
    txLoss8: false,
    rxLoss1: false,
    rxLoss2: false,
    rxLoss3: false,
    rxLoss4: false,
    rxLoss5: false,
    rxLoss6: false,
    rxLoss7: false,
    rxLoss8: false,
  };
}

export const QsfpOperStatus: MessageFns<QsfpOperStatus> = {
  encode(message: QsfpOperStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cmisState !== 0) {
      writer.uint32(8).int32(message.cmisState);
    }
    if (message.moduleState !== 0) {
      writer.uint32(16).int32(message.moduleState);
    }
    if (message.moduleFaultCause !== 0) {
      writer.uint32(24).int32(message.moduleFaultCause);
    }
    if (message.dp1State !== 0) {
      writer.uint32(32).int32(message.dp1State);
    }
    if (message.dp2State !== 0) {
      writer.uint32(40).int32(message.dp2State);
    }
    if (message.dp3State !== 0) {
      writer.uint32(48).int32(message.dp3State);
    }
    if (message.dp4State !== 0) {
      writer.uint32(56).int32(message.dp4State);
    }
    if (message.dp5State !== 0) {
      writer.uint32(64).int32(message.dp5State);
    }
    if (message.dp6State !== 0) {
      writer.uint32(72).int32(message.dp6State);
    }
    if (message.dp7State !== 0) {
      writer.uint32(80).int32(message.dp7State);
    }
    if (message.dp8State !== 0) {
      writer.uint32(88).int32(message.dp8State);
    }
    if (message.configStateHostlane1 !== 0) {
      writer.uint32(96).int32(message.configStateHostlane1);
    }
    if (message.configStateHostlane2 !== 0) {
      writer.uint32(104).int32(message.configStateHostlane2);
    }
    if (message.configStateHostlane3 !== 0) {
      writer.uint32(112).int32(message.configStateHostlane3);
    }
    if (message.configStateHostlane4 !== 0) {
      writer.uint32(120).int32(message.configStateHostlane4);
    }
    if (message.configStateHostlane5 !== 0) {
      writer.uint32(128).int32(message.configStateHostlane5);
    }
    if (message.configStateHostlane6 !== 0) {
      writer.uint32(136).int32(message.configStateHostlane6);
    }
    if (message.configStateHostlane7 !== 0) {
      writer.uint32(144).int32(message.configStateHostlane7);
    }
    if (message.configStateHostlane8 !== 0) {
      writer.uint32(152).int32(message.configStateHostlane8);
    }
    if (message.txLoss1 !== false) {
      writer.uint32(160).bool(message.txLoss1);
    }
    if (message.txLoss2 !== false) {
      writer.uint32(168).bool(message.txLoss2);
    }
    if (message.txLoss3 !== false) {
      writer.uint32(176).bool(message.txLoss3);
    }
    if (message.txLoss4 !== false) {
      writer.uint32(184).bool(message.txLoss4);
    }
    if (message.txLoss5 !== false) {
      writer.uint32(192).bool(message.txLoss5);
    }
    if (message.txLoss6 !== false) {
      writer.uint32(200).bool(message.txLoss6);
    }
    if (message.txLoss7 !== false) {
      writer.uint32(208).bool(message.txLoss7);
    }
    if (message.txLoss8 !== false) {
      writer.uint32(216).bool(message.txLoss8);
    }
    if (message.rxLoss1 !== false) {
      writer.uint32(224).bool(message.rxLoss1);
    }
    if (message.rxLoss2 !== false) {
      writer.uint32(232).bool(message.rxLoss2);
    }
    if (message.rxLoss3 !== false) {
      writer.uint32(240).bool(message.rxLoss3);
    }
    if (message.rxLoss4 !== false) {
      writer.uint32(248).bool(message.rxLoss4);
    }
    if (message.rxLoss5 !== false) {
      writer.uint32(256).bool(message.rxLoss5);
    }
    if (message.rxLoss6 !== false) {
      writer.uint32(264).bool(message.rxLoss6);
    }
    if (message.rxLoss7 !== false) {
      writer.uint32(272).bool(message.rxLoss7);
    }
    if (message.rxLoss8 !== false) {
      writer.uint32(280).bool(message.rxLoss8);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QsfpOperStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQsfpOperStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.cmisState = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.moduleState = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.moduleFaultCause = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.dp1State = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.dp2State = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.dp3State = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.dp4State = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.dp5State = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.dp6State = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.dp7State = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.dp8State = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.configStateHostlane1 = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.configStateHostlane2 = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.configStateHostlane3 = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.configStateHostlane4 = reader.int32() as any;
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.configStateHostlane5 = reader.int32() as any;
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.configStateHostlane6 = reader.int32() as any;
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.configStateHostlane7 = reader.int32() as any;
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.configStateHostlane8 = reader.int32() as any;
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.txLoss1 = reader.bool();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.txLoss2 = reader.bool();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.txLoss3 = reader.bool();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.txLoss4 = reader.bool();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.txLoss5 = reader.bool();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.txLoss6 = reader.bool();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.txLoss7 = reader.bool();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.txLoss8 = reader.bool();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.rxLoss1 = reader.bool();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.rxLoss2 = reader.bool();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.rxLoss3 = reader.bool();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.rxLoss4 = reader.bool();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.rxLoss5 = reader.bool();
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.rxLoss6 = reader.bool();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.rxLoss7 = reader.bool();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.rxLoss8 = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QsfpOperStatus {
    return {
      cmisState: isSet(object.cmisState) ? qsfpCmisStateFromJSON(object.cmisState) : 0,
      moduleState: isSet(object.moduleState) ? qsfpModuleStateFromJSON(object.moduleState) : 0,
      moduleFaultCause: isSet(object.moduleFaultCause) ? qsfpModuleFaultCauseFromJSON(object.moduleFaultCause) : 0,
      dp1State: isSet(object.dp1State) ? qsfpDataPathStateFromJSON(object.dp1State) : 0,
      dp2State: isSet(object.dp2State) ? qsfpDataPathStateFromJSON(object.dp2State) : 0,
      dp3State: isSet(object.dp3State) ? qsfpDataPathStateFromJSON(object.dp3State) : 0,
      dp4State: isSet(object.dp4State) ? qsfpDataPathStateFromJSON(object.dp4State) : 0,
      dp5State: isSet(object.dp5State) ? qsfpDataPathStateFromJSON(object.dp5State) : 0,
      dp6State: isSet(object.dp6State) ? qsfpDataPathStateFromJSON(object.dp6State) : 0,
      dp7State: isSet(object.dp7State) ? qsfpDataPathStateFromJSON(object.dp7State) : 0,
      dp8State: isSet(object.dp8State) ? qsfpDataPathStateFromJSON(object.dp8State) : 0,
      configStateHostlane1: isSet(object.configStateHostlane1)
        ? qsfpConfigStateFromJSON(object.configStateHostlane1)
        : 0,
      configStateHostlane2: isSet(object.configStateHostlane2)
        ? qsfpConfigStateFromJSON(object.configStateHostlane2)
        : 0,
      configStateHostlane3: isSet(object.configStateHostlane3)
        ? qsfpConfigStateFromJSON(object.configStateHostlane3)
        : 0,
      configStateHostlane4: isSet(object.configStateHostlane4)
        ? qsfpConfigStateFromJSON(object.configStateHostlane4)
        : 0,
      configStateHostlane5: isSet(object.configStateHostlane5)
        ? qsfpConfigStateFromJSON(object.configStateHostlane5)
        : 0,
      configStateHostlane6: isSet(object.configStateHostlane6)
        ? qsfpConfigStateFromJSON(object.configStateHostlane6)
        : 0,
      configStateHostlane7: isSet(object.configStateHostlane7)
        ? qsfpConfigStateFromJSON(object.configStateHostlane7)
        : 0,
      configStateHostlane8: isSet(object.configStateHostlane8)
        ? qsfpConfigStateFromJSON(object.configStateHostlane8)
        : 0,
      txLoss1: isSet(object.txLoss1) ? globalThis.Boolean(object.txLoss1) : false,
      txLoss2: isSet(object.txLoss2) ? globalThis.Boolean(object.txLoss2) : false,
      txLoss3: isSet(object.txLoss3) ? globalThis.Boolean(object.txLoss3) : false,
      txLoss4: isSet(object.txLoss4) ? globalThis.Boolean(object.txLoss4) : false,
      txLoss5: isSet(object.txLoss5) ? globalThis.Boolean(object.txLoss5) : false,
      txLoss6: isSet(object.txLoss6) ? globalThis.Boolean(object.txLoss6) : false,
      txLoss7: isSet(object.txLoss7) ? globalThis.Boolean(object.txLoss7) : false,
      txLoss8: isSet(object.txLoss8) ? globalThis.Boolean(object.txLoss8) : false,
      rxLoss1: isSet(object.rxLoss1) ? globalThis.Boolean(object.rxLoss1) : false,
      rxLoss2: isSet(object.rxLoss2) ? globalThis.Boolean(object.rxLoss2) : false,
      rxLoss3: isSet(object.rxLoss3) ? globalThis.Boolean(object.rxLoss3) : false,
      rxLoss4: isSet(object.rxLoss4) ? globalThis.Boolean(object.rxLoss4) : false,
      rxLoss5: isSet(object.rxLoss5) ? globalThis.Boolean(object.rxLoss5) : false,
      rxLoss6: isSet(object.rxLoss6) ? globalThis.Boolean(object.rxLoss6) : false,
      rxLoss7: isSet(object.rxLoss7) ? globalThis.Boolean(object.rxLoss7) : false,
      rxLoss8: isSet(object.rxLoss8) ? globalThis.Boolean(object.rxLoss8) : false,
    };
  },

  toJSON(message: QsfpOperStatus): unknown {
    const obj: any = {};
    if (message.cmisState !== 0) {
      obj.cmisState = qsfpCmisStateToJSON(message.cmisState);
    }
    if (message.moduleState !== 0) {
      obj.moduleState = qsfpModuleStateToJSON(message.moduleState);
    }
    if (message.moduleFaultCause !== 0) {
      obj.moduleFaultCause = qsfpModuleFaultCauseToJSON(message.moduleFaultCause);
    }
    if (message.dp1State !== 0) {
      obj.dp1State = qsfpDataPathStateToJSON(message.dp1State);
    }
    if (message.dp2State !== 0) {
      obj.dp2State = qsfpDataPathStateToJSON(message.dp2State);
    }
    if (message.dp3State !== 0) {
      obj.dp3State = qsfpDataPathStateToJSON(message.dp3State);
    }
    if (message.dp4State !== 0) {
      obj.dp4State = qsfpDataPathStateToJSON(message.dp4State);
    }
    if (message.dp5State !== 0) {
      obj.dp5State = qsfpDataPathStateToJSON(message.dp5State);
    }
    if (message.dp6State !== 0) {
      obj.dp6State = qsfpDataPathStateToJSON(message.dp6State);
    }
    if (message.dp7State !== 0) {
      obj.dp7State = qsfpDataPathStateToJSON(message.dp7State);
    }
    if (message.dp8State !== 0) {
      obj.dp8State = qsfpDataPathStateToJSON(message.dp8State);
    }
    if (message.configStateHostlane1 !== 0) {
      obj.configStateHostlane1 = qsfpConfigStateToJSON(message.configStateHostlane1);
    }
    if (message.configStateHostlane2 !== 0) {
      obj.configStateHostlane2 = qsfpConfigStateToJSON(message.configStateHostlane2);
    }
    if (message.configStateHostlane3 !== 0) {
      obj.configStateHostlane3 = qsfpConfigStateToJSON(message.configStateHostlane3);
    }
    if (message.configStateHostlane4 !== 0) {
      obj.configStateHostlane4 = qsfpConfigStateToJSON(message.configStateHostlane4);
    }
    if (message.configStateHostlane5 !== 0) {
      obj.configStateHostlane5 = qsfpConfigStateToJSON(message.configStateHostlane5);
    }
    if (message.configStateHostlane6 !== 0) {
      obj.configStateHostlane6 = qsfpConfigStateToJSON(message.configStateHostlane6);
    }
    if (message.configStateHostlane7 !== 0) {
      obj.configStateHostlane7 = qsfpConfigStateToJSON(message.configStateHostlane7);
    }
    if (message.configStateHostlane8 !== 0) {
      obj.configStateHostlane8 = qsfpConfigStateToJSON(message.configStateHostlane8);
    }
    if (message.txLoss1 !== false) {
      obj.txLoss1 = message.txLoss1;
    }
    if (message.txLoss2 !== false) {
      obj.txLoss2 = message.txLoss2;
    }
    if (message.txLoss3 !== false) {
      obj.txLoss3 = message.txLoss3;
    }
    if (message.txLoss4 !== false) {
      obj.txLoss4 = message.txLoss4;
    }
    if (message.txLoss5 !== false) {
      obj.txLoss5 = message.txLoss5;
    }
    if (message.txLoss6 !== false) {
      obj.txLoss6 = message.txLoss6;
    }
    if (message.txLoss7 !== false) {
      obj.txLoss7 = message.txLoss7;
    }
    if (message.txLoss8 !== false) {
      obj.txLoss8 = message.txLoss8;
    }
    if (message.rxLoss1 !== false) {
      obj.rxLoss1 = message.rxLoss1;
    }
    if (message.rxLoss2 !== false) {
      obj.rxLoss2 = message.rxLoss2;
    }
    if (message.rxLoss3 !== false) {
      obj.rxLoss3 = message.rxLoss3;
    }
    if (message.rxLoss4 !== false) {
      obj.rxLoss4 = message.rxLoss4;
    }
    if (message.rxLoss5 !== false) {
      obj.rxLoss5 = message.rxLoss5;
    }
    if (message.rxLoss6 !== false) {
      obj.rxLoss6 = message.rxLoss6;
    }
    if (message.rxLoss7 !== false) {
      obj.rxLoss7 = message.rxLoss7;
    }
    if (message.rxLoss8 !== false) {
      obj.rxLoss8 = message.rxLoss8;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QsfpOperStatus>, I>>(base?: I): QsfpOperStatus {
    return QsfpOperStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QsfpOperStatus>, I>>(object: I): QsfpOperStatus {
    const message = createBaseQsfpOperStatus();
    message.cmisState = object.cmisState ?? 0;
    message.moduleState = object.moduleState ?? 0;
    message.moduleFaultCause = object.moduleFaultCause ?? 0;
    message.dp1State = object.dp1State ?? 0;
    message.dp2State = object.dp2State ?? 0;
    message.dp3State = object.dp3State ?? 0;
    message.dp4State = object.dp4State ?? 0;
    message.dp5State = object.dp5State ?? 0;
    message.dp6State = object.dp6State ?? 0;
    message.dp7State = object.dp7State ?? 0;
    message.dp8State = object.dp8State ?? 0;
    message.configStateHostlane1 = object.configStateHostlane1 ?? 0;
    message.configStateHostlane2 = object.configStateHostlane2 ?? 0;
    message.configStateHostlane3 = object.configStateHostlane3 ?? 0;
    message.configStateHostlane4 = object.configStateHostlane4 ?? 0;
    message.configStateHostlane5 = object.configStateHostlane5 ?? 0;
    message.configStateHostlane6 = object.configStateHostlane6 ?? 0;
    message.configStateHostlane7 = object.configStateHostlane7 ?? 0;
    message.configStateHostlane8 = object.configStateHostlane8 ?? 0;
    message.txLoss1 = object.txLoss1 ?? false;
    message.txLoss2 = object.txLoss2 ?? false;
    message.txLoss3 = object.txLoss3 ?? false;
    message.txLoss4 = object.txLoss4 ?? false;
    message.txLoss5 = object.txLoss5 ?? false;
    message.txLoss6 = object.txLoss6 ?? false;
    message.txLoss7 = object.txLoss7 ?? false;
    message.txLoss8 = object.txLoss8 ?? false;
    message.rxLoss1 = object.rxLoss1 ?? false;
    message.rxLoss2 = object.rxLoss2 ?? false;
    message.rxLoss3 = object.rxLoss3 ?? false;
    message.rxLoss4 = object.rxLoss4 ?? false;
    message.rxLoss5 = object.rxLoss5 ?? false;
    message.rxLoss6 = object.rxLoss6 ?? false;
    message.rxLoss7 = object.rxLoss7 ?? false;
    message.rxLoss8 = object.rxLoss8 ?? false;
    return message;
  },
};

function createBaseDeviceClaimData(): DeviceClaimData {
  return {
    activeDeviceClaim1: "",
    activeDeviceClaim1Expiry: undefined,
    activeDeviceClaim2: "",
    activeDeviceClaim2Expiry: undefined,
    usbClaimOperation: false,
  };
}

export const DeviceClaimData: MessageFns<DeviceClaimData> = {
  encode(message: DeviceClaimData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.activeDeviceClaim1 !== "") {
      writer.uint32(18).string(message.activeDeviceClaim1);
    }
    if (message.activeDeviceClaim1Expiry !== undefined) {
      Timestamp.encode(toTimestamp(message.activeDeviceClaim1Expiry), writer.uint32(26).fork()).join();
    }
    if (message.activeDeviceClaim2 !== "") {
      writer.uint32(34).string(message.activeDeviceClaim2);
    }
    if (message.activeDeviceClaim2Expiry !== undefined) {
      Timestamp.encode(toTimestamp(message.activeDeviceClaim2Expiry), writer.uint32(42).fork()).join();
    }
    if (message.usbClaimOperation !== false) {
      writer.uint32(48).bool(message.usbClaimOperation);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceClaimData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceClaimData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.activeDeviceClaim1 = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.activeDeviceClaim1Expiry = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.activeDeviceClaim2 = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.activeDeviceClaim2Expiry = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.usbClaimOperation = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceClaimData {
    return {
      activeDeviceClaim1: isSet(object.activeDeviceClaim1) ? globalThis.String(object.activeDeviceClaim1) : "",
      activeDeviceClaim1Expiry: isSet(object.activeDeviceClaim1Expiry)
        ? fromJsonTimestamp(object.activeDeviceClaim1Expiry)
        : undefined,
      activeDeviceClaim2: isSet(object.activeDeviceClaim2) ? globalThis.String(object.activeDeviceClaim2) : "",
      activeDeviceClaim2Expiry: isSet(object.activeDeviceClaim2Expiry)
        ? fromJsonTimestamp(object.activeDeviceClaim2Expiry)
        : undefined,
      usbClaimOperation: isSet(object.usbClaimOperation) ? globalThis.Boolean(object.usbClaimOperation) : false,
    };
  },

  toJSON(message: DeviceClaimData): unknown {
    const obj: any = {};
    if (message.activeDeviceClaim1 !== "") {
      obj.activeDeviceClaim1 = message.activeDeviceClaim1;
    }
    if (message.activeDeviceClaim1Expiry !== undefined) {
      obj.activeDeviceClaim1Expiry = message.activeDeviceClaim1Expiry.toISOString();
    }
    if (message.activeDeviceClaim2 !== "") {
      obj.activeDeviceClaim2 = message.activeDeviceClaim2;
    }
    if (message.activeDeviceClaim2Expiry !== undefined) {
      obj.activeDeviceClaim2Expiry = message.activeDeviceClaim2Expiry.toISOString();
    }
    if (message.usbClaimOperation !== false) {
      obj.usbClaimOperation = message.usbClaimOperation;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceClaimData>, I>>(base?: I): DeviceClaimData {
    return DeviceClaimData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceClaimData>, I>>(object: I): DeviceClaimData {
    const message = createBaseDeviceClaimData();
    message.activeDeviceClaim1 = object.activeDeviceClaim1 ?? "";
    message.activeDeviceClaim1Expiry = object.activeDeviceClaim1Expiry ?? undefined;
    message.activeDeviceClaim2 = object.activeDeviceClaim2 ?? "";
    message.activeDeviceClaim2Expiry = object.activeDeviceClaim2Expiry ?? undefined;
    message.usbClaimOperation = object.usbClaimOperation ?? false;
    return message;
  },
};

function createBaseDeviceClaim(): DeviceClaim {
  return {
    id: undefined,
    activeDeviceClaim1: "",
    activeDeviceClaim1Expiry: undefined,
    activeDeviceClaim2: "",
    activeDeviceClaim2Expiry: undefined,
    usbClaimOperation: false,
    collectedAt: undefined,
    deviceClaim: undefined,
  };
}

export const DeviceClaim: MessageFns<DeviceClaim> = {
  encode(message: DeviceClaim, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.activeDeviceClaim1 !== "") {
      writer.uint32(26).string(message.activeDeviceClaim1);
    }
    if (message.activeDeviceClaim1Expiry !== undefined) {
      Timestamp.encode(toTimestamp(message.activeDeviceClaim1Expiry), writer.uint32(34).fork()).join();
    }
    if (message.activeDeviceClaim2 !== "") {
      writer.uint32(42).string(message.activeDeviceClaim2);
    }
    if (message.activeDeviceClaim2Expiry !== undefined) {
      Timestamp.encode(toTimestamp(message.activeDeviceClaim2Expiry), writer.uint32(50).fork()).join();
    }
    if (message.usbClaimOperation !== false) {
      writer.uint32(56).bool(message.usbClaimOperation);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(66).fork()).join();
    }
    if (message.deviceClaim !== undefined) {
      DeviceClaimData.encode(message.deviceClaim, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceClaim {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceClaim();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.activeDeviceClaim1 = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.activeDeviceClaim1Expiry = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.activeDeviceClaim2 = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.activeDeviceClaim2Expiry = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.usbClaimOperation = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.deviceClaim = DeviceClaimData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceClaim {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      activeDeviceClaim1: isSet(object.activeDeviceClaim1) ? globalThis.String(object.activeDeviceClaim1) : "",
      activeDeviceClaim1Expiry: isSet(object.activeDeviceClaim1Expiry)
        ? fromJsonTimestamp(object.activeDeviceClaim1Expiry)
        : undefined,
      activeDeviceClaim2: isSet(object.activeDeviceClaim2) ? globalThis.String(object.activeDeviceClaim2) : "",
      activeDeviceClaim2Expiry: isSet(object.activeDeviceClaim2Expiry)
        ? fromJsonTimestamp(object.activeDeviceClaim2Expiry)
        : undefined,
      usbClaimOperation: isSet(object.usbClaimOperation) ? globalThis.Boolean(object.usbClaimOperation) : false,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      deviceClaim: isSet(object.deviceClaim) ? DeviceClaimData.fromJSON(object.deviceClaim) : undefined,
    };
  },

  toJSON(message: DeviceClaim): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.activeDeviceClaim1 !== "") {
      obj.activeDeviceClaim1 = message.activeDeviceClaim1;
    }
    if (message.activeDeviceClaim1Expiry !== undefined) {
      obj.activeDeviceClaim1Expiry = message.activeDeviceClaim1Expiry.toISOString();
    }
    if (message.activeDeviceClaim2 !== "") {
      obj.activeDeviceClaim2 = message.activeDeviceClaim2;
    }
    if (message.activeDeviceClaim2Expiry !== undefined) {
      obj.activeDeviceClaim2Expiry = message.activeDeviceClaim2Expiry.toISOString();
    }
    if (message.usbClaimOperation !== false) {
      obj.usbClaimOperation = message.usbClaimOperation;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.deviceClaim !== undefined) {
      obj.deviceClaim = DeviceClaimData.toJSON(message.deviceClaim);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceClaim>, I>>(base?: I): DeviceClaim {
    return DeviceClaim.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceClaim>, I>>(object: I): DeviceClaim {
    const message = createBaseDeviceClaim();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.activeDeviceClaim1 = object.activeDeviceClaim1 ?? "";
    message.activeDeviceClaim1Expiry = object.activeDeviceClaim1Expiry ?? undefined;
    message.activeDeviceClaim2 = object.activeDeviceClaim2 ?? "";
    message.activeDeviceClaim2Expiry = object.activeDeviceClaim2Expiry ?? undefined;
    message.usbClaimOperation = object.usbClaimOperation ?? false;
    message.collectedAt = object.collectedAt ?? undefined;
    message.deviceClaim = (object.deviceClaim !== undefined && object.deviceClaim !== null)
      ? DeviceClaimData.fromPartial(object.deviceClaim)
      : undefined;
    return message;
  },
};

function createBaseAggregatedDeviceClaim(): AggregatedDeviceClaim {
  return { id: undefined, deviceClaim: undefined, adjacencyBloomFilter: new Uint8Array(0), collectedAt: undefined };
}

export const AggregatedDeviceClaim: MessageFns<AggregatedDeviceClaim> = {
  encode(message: AggregatedDeviceClaim, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.deviceClaim !== undefined) {
      DeviceClaimData.encode(message.deviceClaim, writer.uint32(26).fork()).join();
    }
    if (message.adjacencyBloomFilter.length !== 0) {
      writer.uint32(34).bytes(message.adjacencyBloomFilter);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AggregatedDeviceClaim {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAggregatedDeviceClaim();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceClaim = DeviceClaimData.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.adjacencyBloomFilter = reader.bytes();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AggregatedDeviceClaim {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      deviceClaim: isSet(object.deviceClaim) ? DeviceClaimData.fromJSON(object.deviceClaim) : undefined,
      adjacencyBloomFilter: isSet(object.adjacencyBloomFilter)
        ? bytesFromBase64(object.adjacencyBloomFilter)
        : new Uint8Array(0),
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: AggregatedDeviceClaim): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.deviceClaim !== undefined) {
      obj.deviceClaim = DeviceClaimData.toJSON(message.deviceClaim);
    }
    if (message.adjacencyBloomFilter.length !== 0) {
      obj.adjacencyBloomFilter = base64FromBytes(message.adjacencyBloomFilter);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AggregatedDeviceClaim>, I>>(base?: I): AggregatedDeviceClaim {
    return AggregatedDeviceClaim.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AggregatedDeviceClaim>, I>>(object: I): AggregatedDeviceClaim {
    const message = createBaseAggregatedDeviceClaim();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.deviceClaim = (object.deviceClaim !== undefined && object.deviceClaim !== null)
      ? DeviceClaimData.fromPartial(object.deviceClaim)
      : undefined;
    message.adjacencyBloomFilter = object.adjacencyBloomFilter ?? new Uint8Array(0);
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseApiPathProtocol(): ApiPathProtocol {
  return { id: undefined };
}

export const ApiPathProtocol: MessageFns<ApiPathProtocol> = {
  encode(message: ApiPathProtocol, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiPathProtocol {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiPathProtocol();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiPathProtocol {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: ApiPathProtocol): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApiPathProtocol>, I>>(base?: I): ApiPathProtocol {
    return ApiPathProtocol.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApiPathProtocol>, I>>(object: I): ApiPathProtocol {
    const message = createBaseApiPathProtocol();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseApiPathMethod(): ApiPathMethod {
  return { id: undefined };
}

export const ApiPathMethod: MessageFns<ApiPathMethod> = {
  encode(message: ApiPathMethod, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiPathMethod {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiPathMethod();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiPathMethod {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: ApiPathMethod): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApiPathMethod>, I>>(base?: I): ApiPathMethod {
    return ApiPathMethod.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApiPathMethod>, I>>(object: I): ApiPathMethod {
    const message = createBaseApiPathMethod();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseApiPath(): ApiPath {
  return { id: undefined };
}

export const ApiPath: MessageFns<ApiPath> = {
  encode(message: ApiPath, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiPath {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiPath();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiPath {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: ApiPath): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApiPath>, I>>(base?: I): ApiPath {
    return ApiPath.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApiPath>, I>>(object: I): ApiPath {
    const message = createBaseApiPath();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseApiServiceMapping(): ApiServiceMapping {
  return {
    id: undefined,
    deprecatedApi: "",
    deprecatedMethod: "",
    deprecatedSvc: "",
    deprecatedRoutingPolicy: "",
    app: 0,
    routingPolicy: 0,
    noAuth: false,
    deviceAuth: false,
    restAuth: false,
    webAuth: false,
  };
}

export const ApiServiceMapping: MessageFns<ApiServiceMapping> = {
  encode(message: ApiServiceMapping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.deprecatedApi !== "") {
      writer.uint32(26).string(message.deprecatedApi);
    }
    if (message.deprecatedMethod !== "") {
      writer.uint32(34).string(message.deprecatedMethod);
    }
    if (message.deprecatedSvc !== "") {
      writer.uint32(42).string(message.deprecatedSvc);
    }
    if (message.deprecatedRoutingPolicy !== "") {
      writer.uint32(50).string(message.deprecatedRoutingPolicy);
    }
    if (message.app !== 0) {
      writer.uint32(56).int32(message.app);
    }
    if (message.routingPolicy !== 0) {
      writer.uint32(64).int32(message.routingPolicy);
    }
    if (message.noAuth !== false) {
      writer.uint32(72).bool(message.noAuth);
    }
    if (message.deviceAuth !== false) {
      writer.uint32(80).bool(message.deviceAuth);
    }
    if (message.restAuth !== false) {
      writer.uint32(88).bool(message.restAuth);
    }
    if (message.webAuth !== false) {
      writer.uint32(96).bool(message.webAuth);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiServiceMapping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiServiceMapping();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deprecatedApi = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.deprecatedMethod = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.deprecatedSvc = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.deprecatedRoutingPolicy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.app = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.routingPolicy = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.noAuth = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.deviceAuth = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.restAuth = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.webAuth = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiServiceMapping {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      deprecatedApi: isSet(object.deprecatedApi) ? globalThis.String(object.deprecatedApi) : "",
      deprecatedMethod: isSet(object.deprecatedMethod) ? globalThis.String(object.deprecatedMethod) : "",
      deprecatedSvc: isSet(object.deprecatedSvc) ? globalThis.String(object.deprecatedSvc) : "",
      deprecatedRoutingPolicy: isSet(object.deprecatedRoutingPolicy)
        ? globalThis.String(object.deprecatedRoutingPolicy)
        : "",
      app: isSet(object.app) ? applicationIdentityFromJSON(object.app) : 0,
      routingPolicy: isSet(object.routingPolicy) ? routingPolicyFromJSON(object.routingPolicy) : 0,
      noAuth: isSet(object.noAuth) ? globalThis.Boolean(object.noAuth) : false,
      deviceAuth: isSet(object.deviceAuth) ? globalThis.Boolean(object.deviceAuth) : false,
      restAuth: isSet(object.restAuth) ? globalThis.Boolean(object.restAuth) : false,
      webAuth: isSet(object.webAuth) ? globalThis.Boolean(object.webAuth) : false,
    };
  },

  toJSON(message: ApiServiceMapping): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.deprecatedApi !== "") {
      obj.deprecatedApi = message.deprecatedApi;
    }
    if (message.deprecatedMethod !== "") {
      obj.deprecatedMethod = message.deprecatedMethod;
    }
    if (message.deprecatedSvc !== "") {
      obj.deprecatedSvc = message.deprecatedSvc;
    }
    if (message.deprecatedRoutingPolicy !== "") {
      obj.deprecatedRoutingPolicy = message.deprecatedRoutingPolicy;
    }
    if (message.app !== 0) {
      obj.app = applicationIdentityToJSON(message.app);
    }
    if (message.routingPolicy !== 0) {
      obj.routingPolicy = routingPolicyToJSON(message.routingPolicy);
    }
    if (message.noAuth !== false) {
      obj.noAuth = message.noAuth;
    }
    if (message.deviceAuth !== false) {
      obj.deviceAuth = message.deviceAuth;
    }
    if (message.restAuth !== false) {
      obj.restAuth = message.restAuth;
    }
    if (message.webAuth !== false) {
      obj.webAuth = message.webAuth;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApiServiceMapping>, I>>(base?: I): ApiServiceMapping {
    return ApiServiceMapping.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApiServiceMapping>, I>>(object: I): ApiServiceMapping {
    const message = createBaseApiServiceMapping();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.deprecatedApi = object.deprecatedApi ?? "";
    message.deprecatedMethod = object.deprecatedMethod ?? "";
    message.deprecatedSvc = object.deprecatedSvc ?? "";
    message.deprecatedRoutingPolicy = object.deprecatedRoutingPolicy ?? "";
    message.app = object.app ?? 0;
    message.routingPolicy = object.routingPolicy ?? 0;
    message.noAuth = object.noAuth ?? false;
    message.deviceAuth = object.deviceAuth ?? false;
    message.restAuth = object.restAuth ?? false;
    message.webAuth = object.webAuth ?? false;
    return message;
  },
};

function createBaseTenantUuid(): TenantUuid {
  return { id: undefined };
}

export const TenantUuid: MessageFns<TenantUuid> = {
  encode(message: TenantUuid, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TenantUuid {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTenantUuid();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TenantUuid {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: TenantUuid): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TenantUuid>, I>>(base?: I): TenantUuid {
    return TenantUuid.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TenantUuid>, I>>(object: I): TenantUuid {
    const message = createBaseTenantUuid();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseUserEmail(): UserEmail {
  return {
    id: undefined,
    orgUuid: "",
    tenantUuid: "",
    userEmail: "",
    orgKind: 0,
    lastLogin: undefined,
    userRole: 0,
    provider: 0,
    invalidBeforeTs: undefined,
    userUuid: "",
  };
}

export const UserEmail: MessageFns<UserEmail> = {
  encode(message: UserEmail, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.orgUuid !== "") {
      writer.uint32(26).string(message.orgUuid);
    }
    if (message.tenantUuid !== "") {
      writer.uint32(34).string(message.tenantUuid);
    }
    if (message.userEmail !== "") {
      writer.uint32(42).string(message.userEmail);
    }
    if (message.orgKind !== 0) {
      writer.uint32(48).int32(message.orgKind);
    }
    if (message.lastLogin !== undefined) {
      Timestamp.encode(toTimestamp(message.lastLogin), writer.uint32(58).fork()).join();
    }
    if (message.userRole !== 0) {
      writer.uint32(64).int32(message.userRole);
    }
    if (message.provider !== 0) {
      writer.uint32(72).int32(message.provider);
    }
    if (message.invalidBeforeTs !== undefined) {
      Timestamp.encode(toTimestamp(message.invalidBeforeTs), writer.uint32(82).fork()).join();
    }
    if (message.userUuid !== "") {
      writer.uint32(90).string(message.userUuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserEmail {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserEmail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.orgUuid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tenantUuid = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.userEmail = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.orgKind = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.lastLogin = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.userRole = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.invalidBeforeTs = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.userUuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserEmail {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      orgUuid: isSet(object.orgUuid) ? globalThis.String(object.orgUuid) : "",
      tenantUuid: isSet(object.tenantUuid) ? globalThis.String(object.tenantUuid) : "",
      userEmail: isSet(object.userEmail) ? globalThis.String(object.userEmail) : "",
      orgKind: isSet(object.orgKind) ? orgKindFromJSON(object.orgKind) : 0,
      lastLogin: isSet(object.lastLogin) ? fromJsonTimestamp(object.lastLogin) : undefined,
      userRole: isSet(object.userRole) ? userRoleFromJSON(object.userRole) : 0,
      provider: isSet(object.provider) ? knownProviderFromJSON(object.provider) : 0,
      invalidBeforeTs: isSet(object.invalidBeforeTs) ? fromJsonTimestamp(object.invalidBeforeTs) : undefined,
      userUuid: isSet(object.userUuid) ? globalThis.String(object.userUuid) : "",
    };
  },

  toJSON(message: UserEmail): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.orgUuid !== "") {
      obj.orgUuid = message.orgUuid;
    }
    if (message.tenantUuid !== "") {
      obj.tenantUuid = message.tenantUuid;
    }
    if (message.userEmail !== "") {
      obj.userEmail = message.userEmail;
    }
    if (message.orgKind !== 0) {
      obj.orgKind = orgKindToJSON(message.orgKind);
    }
    if (message.lastLogin !== undefined) {
      obj.lastLogin = message.lastLogin.toISOString();
    }
    if (message.userRole !== 0) {
      obj.userRole = userRoleToJSON(message.userRole);
    }
    if (message.provider !== 0) {
      obj.provider = knownProviderToJSON(message.provider);
    }
    if (message.invalidBeforeTs !== undefined) {
      obj.invalidBeforeTs = message.invalidBeforeTs.toISOString();
    }
    if (message.userUuid !== "") {
      obj.userUuid = message.userUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserEmail>, I>>(base?: I): UserEmail {
    return UserEmail.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserEmail>, I>>(object: I): UserEmail {
    const message = createBaseUserEmail();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.orgUuid = object.orgUuid ?? "";
    message.tenantUuid = object.tenantUuid ?? "";
    message.userEmail = object.userEmail ?? "";
    message.orgKind = object.orgKind ?? 0;
    message.lastLogin = object.lastLogin ?? undefined;
    message.userRole = object.userRole ?? 0;
    message.provider = object.provider ?? 0;
    message.invalidBeforeTs = object.invalidBeforeTs ?? undefined;
    message.userUuid = object.userUuid ?? "";
    return message;
  },
};

function createBaseServiceInstanceHealth(): ServiceInstanceHealth {
  return {
    id: undefined,
    collectedAt: undefined,
    instanceUid: "",
    memoryTotal: "0",
    memoryFree: "0",
    cpuUserTime: 0,
    cpuSystemTime: 0,
  };
}

export const ServiceInstanceHealth: MessageFns<ServiceInstanceHealth> = {
  encode(message: ServiceInstanceHealth, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(26).fork()).join();
    }
    if (message.instanceUid !== "") {
      writer.uint32(34).string(message.instanceUid);
    }
    if (message.memoryTotal !== "0") {
      writer.uint32(40).uint64(message.memoryTotal);
    }
    if (message.memoryFree !== "0") {
      writer.uint32(48).uint64(message.memoryFree);
    }
    if (message.cpuUserTime !== 0) {
      writer.uint32(57).double(message.cpuUserTime);
    }
    if (message.cpuSystemTime !== 0) {
      writer.uint32(65).double(message.cpuSystemTime);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServiceInstanceHealth {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServiceInstanceHealth();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.instanceUid = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.memoryTotal = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.memoryFree = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.cpuUserTime = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.cpuSystemTime = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServiceInstanceHealth {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      instanceUid: isSet(object.instanceUid) ? globalThis.String(object.instanceUid) : "",
      memoryTotal: isSet(object.memoryTotal) ? globalThis.String(object.memoryTotal) : "0",
      memoryFree: isSet(object.memoryFree) ? globalThis.String(object.memoryFree) : "0",
      cpuUserTime: isSet(object.cpuUserTime) ? globalThis.Number(object.cpuUserTime) : 0,
      cpuSystemTime: isSet(object.cpuSystemTime) ? globalThis.Number(object.cpuSystemTime) : 0,
    };
  },

  toJSON(message: ServiceInstanceHealth): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.instanceUid !== "") {
      obj.instanceUid = message.instanceUid;
    }
    if (message.memoryTotal !== "0") {
      obj.memoryTotal = message.memoryTotal;
    }
    if (message.memoryFree !== "0") {
      obj.memoryFree = message.memoryFree;
    }
    if (message.cpuUserTime !== 0) {
      obj.cpuUserTime = message.cpuUserTime;
    }
    if (message.cpuSystemTime !== 0) {
      obj.cpuSystemTime = message.cpuSystemTime;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServiceInstanceHealth>, I>>(base?: I): ServiceInstanceHealth {
    return ServiceInstanceHealth.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServiceInstanceHealth>, I>>(object: I): ServiceInstanceHealth {
    const message = createBaseServiceInstanceHealth();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    message.instanceUid = object.instanceUid ?? "";
    message.memoryTotal = object.memoryTotal ?? "0";
    message.memoryFree = object.memoryFree ?? "0";
    message.cpuUserTime = object.cpuUserTime ?? 0;
    message.cpuSystemTime = object.cpuSystemTime ?? 0;
    return message;
  },
};

function createBaseAssertConfigLinkUpData(): AssertConfigLinkUpData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    port: undefined,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigLinkUpData: MessageFns<AssertConfigLinkUpData> = {
  encode(message: AssertConfigLinkUpData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.port !== undefined) {
      PortConfigDetails.encode(message.port, writer.uint32(34).fork()).join();
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigLinkUpData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigLinkUpData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.port = PortConfigDetails.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigLinkUpData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      port: isSet(object.port) ? PortConfigDetails.fromJSON(object.port) : undefined,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigLinkUpData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.port !== undefined) {
      obj.port = PortConfigDetails.toJSON(message.port);
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigLinkUpData>, I>>(base?: I): AssertConfigLinkUpData {
    return AssertConfigLinkUpData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigLinkUpData>, I>>(object: I): AssertConfigLinkUpData {
    const message = createBaseAssertConfigLinkUpData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.port = (object.port !== undefined && object.port !== null)
      ? PortConfigDetails.fromPartial(object.port)
      : undefined;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigPortLinkUp(): AssertConfigPortLinkUp {
  return { id: undefined, config: undefined };
}

export const AssertConfigPortLinkUp: MessageFns<AssertConfigPortLinkUp> = {
  encode(message: AssertConfigPortLinkUp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigLinkUpData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortLinkUp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortLinkUp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigLinkUpData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortLinkUp {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigLinkUpData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigPortLinkUp): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigLinkUpData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortLinkUp>, I>>(base?: I): AssertConfigPortLinkUp {
    return AssertConfigPortLinkUp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortLinkUp>, I>>(object: I): AssertConfigPortLinkUp {
    const message = createBaseAssertConfigPortLinkUp();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigLinkUpData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertPortLinkUp(): AssertPortLinkUp {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertPortLinkUp: MessageFns<AssertPortLinkUp> = {
  encode(message: AssertPortLinkUp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigLinkUpData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertPortLinkUp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertPortLinkUp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigLinkUpData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertPortLinkUp {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigLinkUpData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertPortLinkUp): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigLinkUpData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertPortLinkUp>, I>>(base?: I): AssertPortLinkUp {
    return AssertPortLinkUp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertPortLinkUp>, I>>(object: I): AssertPortLinkUp {
    const message = createBaseAssertPortLinkUp();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigLinkUpData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigSubInterfaceUpData(): AssertConfigSubInterfaceUpData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    subInterface: undefined,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigSubInterfaceUpData: MessageFns<AssertConfigSubInterfaceUpData> = {
  encode(message: AssertConfigSubInterfaceUpData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.subInterface !== undefined) {
      SubInterfaceDetails.encode(message.subInterface, writer.uint32(34).fork()).join();
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigSubInterfaceUpData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigSubInterfaceUpData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subInterface = SubInterfaceDetails.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigSubInterfaceUpData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      subInterface: isSet(object.subInterface) ? SubInterfaceDetails.fromJSON(object.subInterface) : undefined,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigSubInterfaceUpData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.subInterface !== undefined) {
      obj.subInterface = SubInterfaceDetails.toJSON(message.subInterface);
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigSubInterfaceUpData>, I>>(base?: I): AssertConfigSubInterfaceUpData {
    return AssertConfigSubInterfaceUpData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigSubInterfaceUpData>, I>>(
    object: I,
  ): AssertConfigSubInterfaceUpData {
    const message = createBaseAssertConfigSubInterfaceUpData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.subInterface = (object.subInterface !== undefined && object.subInterface !== null)
      ? SubInterfaceDetails.fromPartial(object.subInterface)
      : undefined;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigSubInterfaceUp(): AssertConfigSubInterfaceUp {
  return { id: undefined, config: undefined };
}

export const AssertConfigSubInterfaceUp: MessageFns<AssertConfigSubInterfaceUp> = {
  encode(message: AssertConfigSubInterfaceUp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigSubInterfaceUpData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigSubInterfaceUp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigSubInterfaceUp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigSubInterfaceUpData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigSubInterfaceUp {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigSubInterfaceUpData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigSubInterfaceUp): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigSubInterfaceUpData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigSubInterfaceUp>, I>>(base?: I): AssertConfigSubInterfaceUp {
    return AssertConfigSubInterfaceUp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigSubInterfaceUp>, I>>(object: I): AssertConfigSubInterfaceUp {
    const message = createBaseAssertConfigSubInterfaceUp();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigSubInterfaceUpData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertSubInterfaceUp(): AssertSubInterfaceUp {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertSubInterfaceUp: MessageFns<AssertSubInterfaceUp> = {
  encode(message: AssertSubInterfaceUp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigSubInterfaceUpData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertSubInterfaceUp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertSubInterfaceUp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigSubInterfaceUpData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertSubInterfaceUp {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigSubInterfaceUpData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertSubInterfaceUp): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigSubInterfaceUpData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertSubInterfaceUp>, I>>(base?: I): AssertSubInterfaceUp {
    return AssertSubInterfaceUp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertSubInterfaceUp>, I>>(object: I): AssertSubInterfaceUp {
    const message = createBaseAssertSubInterfaceUp();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigSubInterfaceUpData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigSubInterfaceDownData(): AssertConfigSubInterfaceDownData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    subInterface: undefined,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigSubInterfaceDownData: MessageFns<AssertConfigSubInterfaceDownData> = {
  encode(message: AssertConfigSubInterfaceDownData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.subInterface !== undefined) {
      SubInterfaceDetails.encode(message.subInterface, writer.uint32(34).fork()).join();
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigSubInterfaceDownData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigSubInterfaceDownData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subInterface = SubInterfaceDetails.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigSubInterfaceDownData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      subInterface: isSet(object.subInterface) ? SubInterfaceDetails.fromJSON(object.subInterface) : undefined,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigSubInterfaceDownData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.subInterface !== undefined) {
      obj.subInterface = SubInterfaceDetails.toJSON(message.subInterface);
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigSubInterfaceDownData>, I>>(
    base?: I,
  ): AssertConfigSubInterfaceDownData {
    return AssertConfigSubInterfaceDownData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigSubInterfaceDownData>, I>>(
    object: I,
  ): AssertConfigSubInterfaceDownData {
    const message = createBaseAssertConfigSubInterfaceDownData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.subInterface = (object.subInterface !== undefined && object.subInterface !== null)
      ? SubInterfaceDetails.fromPartial(object.subInterface)
      : undefined;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigSubInterfaceDown(): AssertConfigSubInterfaceDown {
  return { id: undefined, config: undefined };
}

export const AssertConfigSubInterfaceDown: MessageFns<AssertConfigSubInterfaceDown> = {
  encode(message: AssertConfigSubInterfaceDown, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigSubInterfaceDownData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigSubInterfaceDown {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigSubInterfaceDown();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigSubInterfaceDownData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigSubInterfaceDown {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigSubInterfaceDownData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigSubInterfaceDown): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigSubInterfaceDownData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigSubInterfaceDown>, I>>(base?: I): AssertConfigSubInterfaceDown {
    return AssertConfigSubInterfaceDown.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigSubInterfaceDown>, I>>(object: I): AssertConfigSubInterfaceDown {
    const message = createBaseAssertConfigSubInterfaceDown();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigSubInterfaceDownData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertSubInterfaceDown(): AssertSubInterfaceDown {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertSubInterfaceDown: MessageFns<AssertSubInterfaceDown> = {
  encode(message: AssertSubInterfaceDown, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigSubInterfaceDownData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertSubInterfaceDown {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertSubInterfaceDown();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigSubInterfaceDownData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertSubInterfaceDown {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigSubInterfaceDownData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertSubInterfaceDown): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigSubInterfaceDownData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertSubInterfaceDown>, I>>(base?: I): AssertSubInterfaceDown {
    return AssertSubInterfaceDown.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertSubInterfaceDown>, I>>(object: I): AssertSubInterfaceDown {
    const message = createBaseAssertSubInterfaceDown();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigSubInterfaceDownData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigLinkDownData(): AssertConfigLinkDownData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    port: undefined,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigLinkDownData: MessageFns<AssertConfigLinkDownData> = {
  encode(message: AssertConfigLinkDownData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.port !== undefined) {
      PortConfigDetails.encode(message.port, writer.uint32(34).fork()).join();
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigLinkDownData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigLinkDownData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.port = PortConfigDetails.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigLinkDownData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      port: isSet(object.port) ? PortConfigDetails.fromJSON(object.port) : undefined,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigLinkDownData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.port !== undefined) {
      obj.port = PortConfigDetails.toJSON(message.port);
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigLinkDownData>, I>>(base?: I): AssertConfigLinkDownData {
    return AssertConfigLinkDownData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigLinkDownData>, I>>(object: I): AssertConfigLinkDownData {
    const message = createBaseAssertConfigLinkDownData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.port = (object.port !== undefined && object.port !== null)
      ? PortConfigDetails.fromPartial(object.port)
      : undefined;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigPortLinkDown(): AssertConfigPortLinkDown {
  return { id: undefined, config: undefined };
}

export const AssertConfigPortLinkDown: MessageFns<AssertConfigPortLinkDown> = {
  encode(message: AssertConfigPortLinkDown, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigLinkDownData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortLinkDown {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortLinkDown();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigLinkDownData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortLinkDown {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigLinkDownData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigPortLinkDown): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigLinkDownData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortLinkDown>, I>>(base?: I): AssertConfigPortLinkDown {
    return AssertConfigPortLinkDown.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortLinkDown>, I>>(object: I): AssertConfigPortLinkDown {
    const message = createBaseAssertConfigPortLinkDown();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigLinkDownData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertPortLinkDown(): AssertPortLinkDown {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    remoteDeviceId: "",
    remotePortName: "",
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertPortLinkDown: MessageFns<AssertPortLinkDown> = {
  encode(message: AssertPortLinkDown, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigLinkDownData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.remoteDeviceId !== "") {
      writer.uint32(74).string(message.remoteDeviceId);
    }
    if (message.remotePortName !== "") {
      writer.uint32(82).string(message.remotePortName);
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(88).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(96).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertPortLinkDown {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertPortLinkDown();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigLinkDownData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.remoteDeviceId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.remotePortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertPortLinkDown {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigLinkDownData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      remoteDeviceId: isSet(object.remoteDeviceId) ? globalThis.String(object.remoteDeviceId) : "",
      remotePortName: isSet(object.remotePortName) ? globalThis.String(object.remotePortName) : "",
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertPortLinkDown): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigLinkDownData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.remoteDeviceId !== "") {
      obj.remoteDeviceId = message.remoteDeviceId;
    }
    if (message.remotePortName !== "") {
      obj.remotePortName = message.remotePortName;
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertPortLinkDown>, I>>(base?: I): AssertPortLinkDown {
    return AssertPortLinkDown.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertPortLinkDown>, I>>(object: I): AssertPortLinkDown {
    const message = createBaseAssertPortLinkDown();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigLinkDownData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.remoteDeviceId = object.remoteDeviceId ?? "";
    message.remotePortName = object.remotePortName ?? "";
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigPortChannelMemberUpData(): AssertConfigPortChannelMemberUpData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    portChannelMember: undefined,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigPortChannelMemberUpData: MessageFns<AssertConfigPortChannelMemberUpData> = {
  encode(message: AssertConfigPortChannelMemberUpData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.portChannelMember !== undefined) {
      PortChannelMemberState.encode(message.portChannelMember, writer.uint32(34).fork()).join();
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortChannelMemberUpData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortChannelMemberUpData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.portChannelMember = PortChannelMemberState.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortChannelMemberUpData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      portChannelMember: isSet(object.portChannelMember)
        ? PortChannelMemberState.fromJSON(object.portChannelMember)
        : undefined,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigPortChannelMemberUpData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.portChannelMember !== undefined) {
      obj.portChannelMember = PortChannelMemberState.toJSON(message.portChannelMember);
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortChannelMemberUpData>, I>>(
    base?: I,
  ): AssertConfigPortChannelMemberUpData {
    return AssertConfigPortChannelMemberUpData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortChannelMemberUpData>, I>>(
    object: I,
  ): AssertConfigPortChannelMemberUpData {
    const message = createBaseAssertConfigPortChannelMemberUpData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.portChannelMember = (object.portChannelMember !== undefined && object.portChannelMember !== null)
      ? PortChannelMemberState.fromPartial(object.portChannelMember)
      : undefined;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigPortChannelMemberUp(): AssertConfigPortChannelMemberUp {
  return { id: undefined, config: undefined };
}

export const AssertConfigPortChannelMemberUp: MessageFns<AssertConfigPortChannelMemberUp> = {
  encode(message: AssertConfigPortChannelMemberUp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigPortChannelMemberUpData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortChannelMemberUp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortChannelMemberUp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigPortChannelMemberUpData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortChannelMemberUp {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigPortChannelMemberUpData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigPortChannelMemberUp): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigPortChannelMemberUpData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortChannelMemberUp>, I>>(base?: I): AssertConfigPortChannelMemberUp {
    return AssertConfigPortChannelMemberUp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortChannelMemberUp>, I>>(
    object: I,
  ): AssertConfigPortChannelMemberUp {
    const message = createBaseAssertConfigPortChannelMemberUp();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigPortChannelMemberUpData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertPortChannelMemberUp(): AssertPortChannelMemberUp {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertPortChannelMemberUp: MessageFns<AssertPortChannelMemberUp> = {
  encode(message: AssertPortChannelMemberUp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigPortChannelMemberUpData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertPortChannelMemberUp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertPortChannelMemberUp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigPortChannelMemberUpData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertPortChannelMemberUp {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigPortChannelMemberUpData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertPortChannelMemberUp): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigPortChannelMemberUpData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertPortChannelMemberUp>, I>>(base?: I): AssertPortChannelMemberUp {
    return AssertPortChannelMemberUp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertPortChannelMemberUp>, I>>(object: I): AssertPortChannelMemberUp {
    const message = createBaseAssertPortChannelMemberUp();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigPortChannelMemberUpData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigPortVlanStpStateConsistentData(): AssertConfigPortVlanStpStateConsistentData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    stpVlanPortState: undefined,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigPortVlanStpStateConsistentData: MessageFns<AssertConfigPortVlanStpStateConsistentData> = {
  encode(message: AssertConfigPortVlanStpStateConsistentData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.stpVlanPortState !== undefined) {
      StpVlanPortState.encode(message.stpVlanPortState, writer.uint32(34).fork()).join();
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortVlanStpStateConsistentData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortVlanStpStateConsistentData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.stpVlanPortState = StpVlanPortState.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortVlanStpStateConsistentData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      stpVlanPortState: isSet(object.stpVlanPortState) ? StpVlanPortState.fromJSON(object.stpVlanPortState) : undefined,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigPortVlanStpStateConsistentData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.stpVlanPortState !== undefined) {
      obj.stpVlanPortState = StpVlanPortState.toJSON(message.stpVlanPortState);
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortVlanStpStateConsistentData>, I>>(
    base?: I,
  ): AssertConfigPortVlanStpStateConsistentData {
    return AssertConfigPortVlanStpStateConsistentData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortVlanStpStateConsistentData>, I>>(
    object: I,
  ): AssertConfigPortVlanStpStateConsistentData {
    const message = createBaseAssertConfigPortVlanStpStateConsistentData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.stpVlanPortState = (object.stpVlanPortState !== undefined && object.stpVlanPortState !== null)
      ? StpVlanPortState.fromPartial(object.stpVlanPortState)
      : undefined;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigPortVlanStpStateConsistent(): AssertConfigPortVlanStpStateConsistent {
  return { id: undefined, config: undefined };
}

export const AssertConfigPortVlanStpStateConsistent: MessageFns<AssertConfigPortVlanStpStateConsistent> = {
  encode(message: AssertConfigPortVlanStpStateConsistent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigPortVlanStpStateConsistentData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortVlanStpStateConsistent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortVlanStpStateConsistent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigPortVlanStpStateConsistentData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortVlanStpStateConsistent {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigPortVlanStpStateConsistentData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigPortVlanStpStateConsistent): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigPortVlanStpStateConsistentData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortVlanStpStateConsistent>, I>>(
    base?: I,
  ): AssertConfigPortVlanStpStateConsistent {
    return AssertConfigPortVlanStpStateConsistent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortVlanStpStateConsistent>, I>>(
    object: I,
  ): AssertConfigPortVlanStpStateConsistent {
    const message = createBaseAssertConfigPortVlanStpStateConsistent();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigPortVlanStpStateConsistentData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertPortVlanStpStateConsistent(): AssertPortVlanStpStateConsistent {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    observedStpVlanPortState: 0,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertPortVlanStpStateConsistent: MessageFns<AssertPortVlanStpStateConsistent> = {
  encode(message: AssertPortVlanStpStateConsistent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigPortVlanStpStateConsistentData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.observedStpVlanPortState !== 0) {
      writer.uint32(56).int32(message.observedStpVlanPortState);
    }
    if (message.masked !== false) {
      writer.uint32(64).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(74).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(80).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(88).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertPortVlanStpStateConsistent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertPortVlanStpStateConsistent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigPortVlanStpStateConsistentData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.observedStpVlanPortState = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertPortVlanStpStateConsistent {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigPortVlanStpStateConsistentData.fromJSON(object.config) : undefined,
      observedStpVlanPortState: isSet(object.observedStpVlanPortState)
        ? stpVlanPortStateStatusFromJSON(object.observedStpVlanPortState)
        : 0,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertPortVlanStpStateConsistent): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigPortVlanStpStateConsistentData.toJSON(message.config);
    }
    if (message.observedStpVlanPortState !== 0) {
      obj.observedStpVlanPortState = stpVlanPortStateStatusToJSON(message.observedStpVlanPortState);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertPortVlanStpStateConsistent>, I>>(
    base?: I,
  ): AssertPortVlanStpStateConsistent {
    return AssertPortVlanStpStateConsistent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertPortVlanStpStateConsistent>, I>>(
    object: I,
  ): AssertPortVlanStpStateConsistent {
    const message = createBaseAssertPortVlanStpStateConsistent();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigPortVlanStpStateConsistentData.fromPartial(object.config)
      : undefined;
    message.observedStpVlanPortState = object.observedStpVlanPortState ?? 0;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBasePortPluggableDetails(): PortPluggableDetails {
  return { pid: "", portType: 0, portName: "" };
}

export const PortPluggableDetails: MessageFns<PortPluggableDetails> = {
  encode(message: PortPluggableDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pid !== "") {
      writer.uint32(10).string(message.pid);
    }
    if (message.portType !== 0) {
      writer.uint32(16).int32(message.portType);
    }
    if (message.portName !== "") {
      writer.uint32(26).string(message.portName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortPluggableDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortPluggableDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.portType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortPluggableDetails {
    return {
      pid: isSet(object.pid) ? globalThis.String(object.pid) : "",
      portType: isSet(object.portType) ? neighborTypeFromJSON(object.portType) : 0,
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
    };
  },

  toJSON(message: PortPluggableDetails): unknown {
    const obj: any = {};
    if (message.pid !== "") {
      obj.pid = message.pid;
    }
    if (message.portType !== 0) {
      obj.portType = neighborTypeToJSON(message.portType);
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortPluggableDetails>, I>>(base?: I): PortPluggableDetails {
    return PortPluggableDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortPluggableDetails>, I>>(object: I): PortPluggableDetails {
    const message = createBasePortPluggableDetails();
    message.pid = object.pid ?? "";
    message.portType = object.portType ?? 0;
    message.portName = object.portName ?? "";
    return message;
  },
};

function createBaseAssertConfigPortPluggablePidSameData(): AssertConfigPortPluggablePidSameData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    pluggableDetails: undefined,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigPortPluggablePidSameData: MessageFns<AssertConfigPortPluggablePidSameData> = {
  encode(message: AssertConfigPortPluggablePidSameData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.pluggableDetails !== undefined) {
      PortPluggableDetails.encode(message.pluggableDetails, writer.uint32(34).fork()).join();
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortPluggablePidSameData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortPluggablePidSameData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pluggableDetails = PortPluggableDetails.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortPluggablePidSameData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      pluggableDetails: isSet(object.pluggableDetails)
        ? PortPluggableDetails.fromJSON(object.pluggableDetails)
        : undefined,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigPortPluggablePidSameData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.pluggableDetails !== undefined) {
      obj.pluggableDetails = PortPluggableDetails.toJSON(message.pluggableDetails);
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortPluggablePidSameData>, I>>(
    base?: I,
  ): AssertConfigPortPluggablePidSameData {
    return AssertConfigPortPluggablePidSameData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortPluggablePidSameData>, I>>(
    object: I,
  ): AssertConfigPortPluggablePidSameData {
    const message = createBaseAssertConfigPortPluggablePidSameData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.pluggableDetails = (object.pluggableDetails !== undefined && object.pluggableDetails !== null)
      ? PortPluggableDetails.fromPartial(object.pluggableDetails)
      : undefined;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigPortPluggablePidSame(): AssertConfigPortPluggablePidSame {
  return { id: undefined, config: undefined };
}

export const AssertConfigPortPluggablePidSame: MessageFns<AssertConfigPortPluggablePidSame> = {
  encode(message: AssertConfigPortPluggablePidSame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigPortPluggablePidSameData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortPluggablePidSame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortPluggablePidSame();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigPortPluggablePidSameData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortPluggablePidSame {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigPortPluggablePidSameData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigPortPluggablePidSame): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigPortPluggablePidSameData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortPluggablePidSame>, I>>(
    base?: I,
  ): AssertConfigPortPluggablePidSame {
    return AssertConfigPortPluggablePidSame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortPluggablePidSame>, I>>(
    object: I,
  ): AssertConfigPortPluggablePidSame {
    const message = createBaseAssertConfigPortPluggablePidSame();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigPortPluggablePidSameData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertPortPluggablePidSame(): AssertPortPluggablePidSame {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    observedPortPluggableDetails: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertPortPluggablePidSame: MessageFns<AssertPortPluggablePidSame> = {
  encode(message: AssertPortPluggablePidSame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigPortPluggablePidSameData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.observedPortPluggableDetails !== undefined) {
      PortPluggableDetails.encode(message.observedPortPluggableDetails, writer.uint32(58).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(64).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(74).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(80).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(88).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertPortPluggablePidSame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertPortPluggablePidSame();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigPortPluggablePidSameData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.observedPortPluggableDetails = PortPluggableDetails.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertPortPluggablePidSame {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigPortPluggablePidSameData.fromJSON(object.config) : undefined,
      observedPortPluggableDetails: isSet(object.observedPortPluggableDetails)
        ? PortPluggableDetails.fromJSON(object.observedPortPluggableDetails)
        : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertPortPluggablePidSame): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigPortPluggablePidSameData.toJSON(message.config);
    }
    if (message.observedPortPluggableDetails !== undefined) {
      obj.observedPortPluggableDetails = PortPluggableDetails.toJSON(message.observedPortPluggableDetails);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertPortPluggablePidSame>, I>>(base?: I): AssertPortPluggablePidSame {
    return AssertPortPluggablePidSame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertPortPluggablePidSame>, I>>(object: I): AssertPortPluggablePidSame {
    const message = createBaseAssertPortPluggablePidSame();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigPortPluggablePidSameData.fromPartial(object.config)
      : undefined;
    message.observedPortPluggableDetails =
      (object.observedPortPluggableDetails !== undefined && object.observedPortPluggableDetails !== null)
        ? PortPluggableDetails.fromPartial(object.observedPortPluggableDetails)
        : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseQsfpHealthDetails(): QsfpHealthDetails {
  return {
    laserTemperatureWithinThreshold: false,
    temperatureWithinThreshold: false,
    voltageWithinThreshold: false,
    rx1powerWithinThreshold: false,
    rx2powerWithinThreshold: false,
    rx3powerWithinThreshold: false,
    rx4powerWithinThreshold: false,
    rx5powerWithinThreshold: false,
    rx6powerWithinThreshold: false,
    rx7powerWithinThreshold: false,
    rx8powerWithinThreshold: false,
    tx1powerWithinThreshold: false,
    tx2powerWithinThreshold: false,
    tx3powerWithinThreshold: false,
    tx4powerWithinThreshold: false,
    tx5powerWithinThreshold: false,
    tx6powerWithinThreshold: false,
    tx7powerWithinThreshold: false,
    tx8powerWithinThreshold: false,
    tx1biasWithinThreshold: false,
    tx2biasWithinThreshold: false,
    tx3biasWithinThreshold: false,
    tx4biasWithinThreshold: false,
    tx5biasWithinThreshold: false,
    tx6biasWithinThreshold: false,
    tx7biasWithinThreshold: false,
    tx8biasWithinThreshold: false,
  };
}

export const QsfpHealthDetails: MessageFns<QsfpHealthDetails> = {
  encode(message: QsfpHealthDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.laserTemperatureWithinThreshold !== false) {
      writer.uint32(8).bool(message.laserTemperatureWithinThreshold);
    }
    if (message.temperatureWithinThreshold !== false) {
      writer.uint32(16).bool(message.temperatureWithinThreshold);
    }
    if (message.voltageWithinThreshold !== false) {
      writer.uint32(24).bool(message.voltageWithinThreshold);
    }
    if (message.rx1powerWithinThreshold !== false) {
      writer.uint32(32).bool(message.rx1powerWithinThreshold);
    }
    if (message.rx2powerWithinThreshold !== false) {
      writer.uint32(40).bool(message.rx2powerWithinThreshold);
    }
    if (message.rx3powerWithinThreshold !== false) {
      writer.uint32(48).bool(message.rx3powerWithinThreshold);
    }
    if (message.rx4powerWithinThreshold !== false) {
      writer.uint32(56).bool(message.rx4powerWithinThreshold);
    }
    if (message.rx5powerWithinThreshold !== false) {
      writer.uint32(64).bool(message.rx5powerWithinThreshold);
    }
    if (message.rx6powerWithinThreshold !== false) {
      writer.uint32(72).bool(message.rx6powerWithinThreshold);
    }
    if (message.rx7powerWithinThreshold !== false) {
      writer.uint32(80).bool(message.rx7powerWithinThreshold);
    }
    if (message.rx8powerWithinThreshold !== false) {
      writer.uint32(88).bool(message.rx8powerWithinThreshold);
    }
    if (message.tx1powerWithinThreshold !== false) {
      writer.uint32(96).bool(message.tx1powerWithinThreshold);
    }
    if (message.tx2powerWithinThreshold !== false) {
      writer.uint32(104).bool(message.tx2powerWithinThreshold);
    }
    if (message.tx3powerWithinThreshold !== false) {
      writer.uint32(112).bool(message.tx3powerWithinThreshold);
    }
    if (message.tx4powerWithinThreshold !== false) {
      writer.uint32(120).bool(message.tx4powerWithinThreshold);
    }
    if (message.tx5powerWithinThreshold !== false) {
      writer.uint32(128).bool(message.tx5powerWithinThreshold);
    }
    if (message.tx6powerWithinThreshold !== false) {
      writer.uint32(136).bool(message.tx6powerWithinThreshold);
    }
    if (message.tx7powerWithinThreshold !== false) {
      writer.uint32(144).bool(message.tx7powerWithinThreshold);
    }
    if (message.tx8powerWithinThreshold !== false) {
      writer.uint32(152).bool(message.tx8powerWithinThreshold);
    }
    if (message.tx1biasWithinThreshold !== false) {
      writer.uint32(160).bool(message.tx1biasWithinThreshold);
    }
    if (message.tx2biasWithinThreshold !== false) {
      writer.uint32(168).bool(message.tx2biasWithinThreshold);
    }
    if (message.tx3biasWithinThreshold !== false) {
      writer.uint32(176).bool(message.tx3biasWithinThreshold);
    }
    if (message.tx4biasWithinThreshold !== false) {
      writer.uint32(184).bool(message.tx4biasWithinThreshold);
    }
    if (message.tx5biasWithinThreshold !== false) {
      writer.uint32(192).bool(message.tx5biasWithinThreshold);
    }
    if (message.tx6biasWithinThreshold !== false) {
      writer.uint32(200).bool(message.tx6biasWithinThreshold);
    }
    if (message.tx7biasWithinThreshold !== false) {
      writer.uint32(208).bool(message.tx7biasWithinThreshold);
    }
    if (message.tx8biasWithinThreshold !== false) {
      writer.uint32(216).bool(message.tx8biasWithinThreshold);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QsfpHealthDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQsfpHealthDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.laserTemperatureWithinThreshold = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.temperatureWithinThreshold = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.voltageWithinThreshold = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.rx1powerWithinThreshold = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.rx2powerWithinThreshold = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.rx3powerWithinThreshold = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.rx4powerWithinThreshold = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.rx5powerWithinThreshold = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.rx6powerWithinThreshold = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.rx7powerWithinThreshold = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.rx8powerWithinThreshold = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.tx1powerWithinThreshold = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.tx2powerWithinThreshold = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.tx3powerWithinThreshold = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.tx4powerWithinThreshold = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.tx5powerWithinThreshold = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.tx6powerWithinThreshold = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.tx7powerWithinThreshold = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.tx8powerWithinThreshold = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.tx1biasWithinThreshold = reader.bool();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.tx2biasWithinThreshold = reader.bool();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.tx3biasWithinThreshold = reader.bool();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.tx4biasWithinThreshold = reader.bool();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.tx5biasWithinThreshold = reader.bool();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.tx6biasWithinThreshold = reader.bool();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.tx7biasWithinThreshold = reader.bool();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.tx8biasWithinThreshold = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QsfpHealthDetails {
    return {
      laserTemperatureWithinThreshold: isSet(object.laserTemperatureWithinThreshold)
        ? globalThis.Boolean(object.laserTemperatureWithinThreshold)
        : false,
      temperatureWithinThreshold: isSet(object.temperatureWithinThreshold)
        ? globalThis.Boolean(object.temperatureWithinThreshold)
        : false,
      voltageWithinThreshold: isSet(object.voltageWithinThreshold)
        ? globalThis.Boolean(object.voltageWithinThreshold)
        : false,
      rx1powerWithinThreshold: isSet(object.rx1powerWithinThreshold)
        ? globalThis.Boolean(object.rx1powerWithinThreshold)
        : false,
      rx2powerWithinThreshold: isSet(object.rx2powerWithinThreshold)
        ? globalThis.Boolean(object.rx2powerWithinThreshold)
        : false,
      rx3powerWithinThreshold: isSet(object.rx3powerWithinThreshold)
        ? globalThis.Boolean(object.rx3powerWithinThreshold)
        : false,
      rx4powerWithinThreshold: isSet(object.rx4powerWithinThreshold)
        ? globalThis.Boolean(object.rx4powerWithinThreshold)
        : false,
      rx5powerWithinThreshold: isSet(object.rx5powerWithinThreshold)
        ? globalThis.Boolean(object.rx5powerWithinThreshold)
        : false,
      rx6powerWithinThreshold: isSet(object.rx6powerWithinThreshold)
        ? globalThis.Boolean(object.rx6powerWithinThreshold)
        : false,
      rx7powerWithinThreshold: isSet(object.rx7powerWithinThreshold)
        ? globalThis.Boolean(object.rx7powerWithinThreshold)
        : false,
      rx8powerWithinThreshold: isSet(object.rx8powerWithinThreshold)
        ? globalThis.Boolean(object.rx8powerWithinThreshold)
        : false,
      tx1powerWithinThreshold: isSet(object.tx1powerWithinThreshold)
        ? globalThis.Boolean(object.tx1powerWithinThreshold)
        : false,
      tx2powerWithinThreshold: isSet(object.tx2powerWithinThreshold)
        ? globalThis.Boolean(object.tx2powerWithinThreshold)
        : false,
      tx3powerWithinThreshold: isSet(object.tx3powerWithinThreshold)
        ? globalThis.Boolean(object.tx3powerWithinThreshold)
        : false,
      tx4powerWithinThreshold: isSet(object.tx4powerWithinThreshold)
        ? globalThis.Boolean(object.tx4powerWithinThreshold)
        : false,
      tx5powerWithinThreshold: isSet(object.tx5powerWithinThreshold)
        ? globalThis.Boolean(object.tx5powerWithinThreshold)
        : false,
      tx6powerWithinThreshold: isSet(object.tx6powerWithinThreshold)
        ? globalThis.Boolean(object.tx6powerWithinThreshold)
        : false,
      tx7powerWithinThreshold: isSet(object.tx7powerWithinThreshold)
        ? globalThis.Boolean(object.tx7powerWithinThreshold)
        : false,
      tx8powerWithinThreshold: isSet(object.tx8powerWithinThreshold)
        ? globalThis.Boolean(object.tx8powerWithinThreshold)
        : false,
      tx1biasWithinThreshold: isSet(object.tx1biasWithinThreshold)
        ? globalThis.Boolean(object.tx1biasWithinThreshold)
        : false,
      tx2biasWithinThreshold: isSet(object.tx2biasWithinThreshold)
        ? globalThis.Boolean(object.tx2biasWithinThreshold)
        : false,
      tx3biasWithinThreshold: isSet(object.tx3biasWithinThreshold)
        ? globalThis.Boolean(object.tx3biasWithinThreshold)
        : false,
      tx4biasWithinThreshold: isSet(object.tx4biasWithinThreshold)
        ? globalThis.Boolean(object.tx4biasWithinThreshold)
        : false,
      tx5biasWithinThreshold: isSet(object.tx5biasWithinThreshold)
        ? globalThis.Boolean(object.tx5biasWithinThreshold)
        : false,
      tx6biasWithinThreshold: isSet(object.tx6biasWithinThreshold)
        ? globalThis.Boolean(object.tx6biasWithinThreshold)
        : false,
      tx7biasWithinThreshold: isSet(object.tx7biasWithinThreshold)
        ? globalThis.Boolean(object.tx7biasWithinThreshold)
        : false,
      tx8biasWithinThreshold: isSet(object.tx8biasWithinThreshold)
        ? globalThis.Boolean(object.tx8biasWithinThreshold)
        : false,
    };
  },

  toJSON(message: QsfpHealthDetails): unknown {
    const obj: any = {};
    if (message.laserTemperatureWithinThreshold !== false) {
      obj.laserTemperatureWithinThreshold = message.laserTemperatureWithinThreshold;
    }
    if (message.temperatureWithinThreshold !== false) {
      obj.temperatureWithinThreshold = message.temperatureWithinThreshold;
    }
    if (message.voltageWithinThreshold !== false) {
      obj.voltageWithinThreshold = message.voltageWithinThreshold;
    }
    if (message.rx1powerWithinThreshold !== false) {
      obj.rx1powerWithinThreshold = message.rx1powerWithinThreshold;
    }
    if (message.rx2powerWithinThreshold !== false) {
      obj.rx2powerWithinThreshold = message.rx2powerWithinThreshold;
    }
    if (message.rx3powerWithinThreshold !== false) {
      obj.rx3powerWithinThreshold = message.rx3powerWithinThreshold;
    }
    if (message.rx4powerWithinThreshold !== false) {
      obj.rx4powerWithinThreshold = message.rx4powerWithinThreshold;
    }
    if (message.rx5powerWithinThreshold !== false) {
      obj.rx5powerWithinThreshold = message.rx5powerWithinThreshold;
    }
    if (message.rx6powerWithinThreshold !== false) {
      obj.rx6powerWithinThreshold = message.rx6powerWithinThreshold;
    }
    if (message.rx7powerWithinThreshold !== false) {
      obj.rx7powerWithinThreshold = message.rx7powerWithinThreshold;
    }
    if (message.rx8powerWithinThreshold !== false) {
      obj.rx8powerWithinThreshold = message.rx8powerWithinThreshold;
    }
    if (message.tx1powerWithinThreshold !== false) {
      obj.tx1powerWithinThreshold = message.tx1powerWithinThreshold;
    }
    if (message.tx2powerWithinThreshold !== false) {
      obj.tx2powerWithinThreshold = message.tx2powerWithinThreshold;
    }
    if (message.tx3powerWithinThreshold !== false) {
      obj.tx3powerWithinThreshold = message.tx3powerWithinThreshold;
    }
    if (message.tx4powerWithinThreshold !== false) {
      obj.tx4powerWithinThreshold = message.tx4powerWithinThreshold;
    }
    if (message.tx5powerWithinThreshold !== false) {
      obj.tx5powerWithinThreshold = message.tx5powerWithinThreshold;
    }
    if (message.tx6powerWithinThreshold !== false) {
      obj.tx6powerWithinThreshold = message.tx6powerWithinThreshold;
    }
    if (message.tx7powerWithinThreshold !== false) {
      obj.tx7powerWithinThreshold = message.tx7powerWithinThreshold;
    }
    if (message.tx8powerWithinThreshold !== false) {
      obj.tx8powerWithinThreshold = message.tx8powerWithinThreshold;
    }
    if (message.tx1biasWithinThreshold !== false) {
      obj.tx1biasWithinThreshold = message.tx1biasWithinThreshold;
    }
    if (message.tx2biasWithinThreshold !== false) {
      obj.tx2biasWithinThreshold = message.tx2biasWithinThreshold;
    }
    if (message.tx3biasWithinThreshold !== false) {
      obj.tx3biasWithinThreshold = message.tx3biasWithinThreshold;
    }
    if (message.tx4biasWithinThreshold !== false) {
      obj.tx4biasWithinThreshold = message.tx4biasWithinThreshold;
    }
    if (message.tx5biasWithinThreshold !== false) {
      obj.tx5biasWithinThreshold = message.tx5biasWithinThreshold;
    }
    if (message.tx6biasWithinThreshold !== false) {
      obj.tx6biasWithinThreshold = message.tx6biasWithinThreshold;
    }
    if (message.tx7biasWithinThreshold !== false) {
      obj.tx7biasWithinThreshold = message.tx7biasWithinThreshold;
    }
    if (message.tx8biasWithinThreshold !== false) {
      obj.tx8biasWithinThreshold = message.tx8biasWithinThreshold;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QsfpHealthDetails>, I>>(base?: I): QsfpHealthDetails {
    return QsfpHealthDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QsfpHealthDetails>, I>>(object: I): QsfpHealthDetails {
    const message = createBaseQsfpHealthDetails();
    message.laserTemperatureWithinThreshold = object.laserTemperatureWithinThreshold ?? false;
    message.temperatureWithinThreshold = object.temperatureWithinThreshold ?? false;
    message.voltageWithinThreshold = object.voltageWithinThreshold ?? false;
    message.rx1powerWithinThreshold = object.rx1powerWithinThreshold ?? false;
    message.rx2powerWithinThreshold = object.rx2powerWithinThreshold ?? false;
    message.rx3powerWithinThreshold = object.rx3powerWithinThreshold ?? false;
    message.rx4powerWithinThreshold = object.rx4powerWithinThreshold ?? false;
    message.rx5powerWithinThreshold = object.rx5powerWithinThreshold ?? false;
    message.rx6powerWithinThreshold = object.rx6powerWithinThreshold ?? false;
    message.rx7powerWithinThreshold = object.rx7powerWithinThreshold ?? false;
    message.rx8powerWithinThreshold = object.rx8powerWithinThreshold ?? false;
    message.tx1powerWithinThreshold = object.tx1powerWithinThreshold ?? false;
    message.tx2powerWithinThreshold = object.tx2powerWithinThreshold ?? false;
    message.tx3powerWithinThreshold = object.tx3powerWithinThreshold ?? false;
    message.tx4powerWithinThreshold = object.tx4powerWithinThreshold ?? false;
    message.tx5powerWithinThreshold = object.tx5powerWithinThreshold ?? false;
    message.tx6powerWithinThreshold = object.tx6powerWithinThreshold ?? false;
    message.tx7powerWithinThreshold = object.tx7powerWithinThreshold ?? false;
    message.tx8powerWithinThreshold = object.tx8powerWithinThreshold ?? false;
    message.tx1biasWithinThreshold = object.tx1biasWithinThreshold ?? false;
    message.tx2biasWithinThreshold = object.tx2biasWithinThreshold ?? false;
    message.tx3biasWithinThreshold = object.tx3biasWithinThreshold ?? false;
    message.tx4biasWithinThreshold = object.tx4biasWithinThreshold ?? false;
    message.tx5biasWithinThreshold = object.tx5biasWithinThreshold ?? false;
    message.tx6biasWithinThreshold = object.tx6biasWithinThreshold ?? false;
    message.tx7biasWithinThreshold = object.tx7biasWithinThreshold ?? false;
    message.tx8biasWithinThreshold = object.tx8biasWithinThreshold ?? false;
    return message;
  },
};

function createBaseAssertConfigPortQsfpHealthyData(): AssertConfigPortQsfpHealthyData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    orgId: "",
    fabricId: "",
    hostname: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigPortQsfpHealthyData: MessageFns<AssertConfigPortQsfpHealthyData> = {
  encode(message: AssertConfigPortQsfpHealthyData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(50).string(message.fabricId);
    }
    if (message.hostname !== "") {
      writer.uint32(58).string(message.hostname);
    }
    if (message.groupShortName !== "") {
      writer.uint32(66).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(72).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(80).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortQsfpHealthyData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortQsfpHealthyData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.hostname = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortQsfpHealthyData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      hostname: isSet(object.hostname) ? globalThis.String(object.hostname) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigPortQsfpHealthyData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.hostname !== "") {
      obj.hostname = message.hostname;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortQsfpHealthyData>, I>>(base?: I): AssertConfigPortQsfpHealthyData {
    return AssertConfigPortQsfpHealthyData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortQsfpHealthyData>, I>>(
    object: I,
  ): AssertConfigPortQsfpHealthyData {
    const message = createBaseAssertConfigPortQsfpHealthyData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.hostname = object.hostname ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigPortQsfpHealthy(): AssertConfigPortQsfpHealthy {
  return { id: undefined, config: undefined };
}

export const AssertConfigPortQsfpHealthy: MessageFns<AssertConfigPortQsfpHealthy> = {
  encode(message: AssertConfigPortQsfpHealthy, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigPortQsfpHealthyData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortQsfpHealthy {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortQsfpHealthy();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigPortQsfpHealthyData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortQsfpHealthy {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigPortQsfpHealthyData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigPortQsfpHealthy): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigPortQsfpHealthyData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortQsfpHealthy>, I>>(base?: I): AssertConfigPortQsfpHealthy {
    return AssertConfigPortQsfpHealthy.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortQsfpHealthy>, I>>(object: I): AssertConfigPortQsfpHealthy {
    const message = createBaseAssertConfigPortQsfpHealthy();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigPortQsfpHealthyData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertPortQsfpHealthy(): AssertPortQsfpHealthy {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    observedQsfpHealthDetails: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertPortQsfpHealthy: MessageFns<AssertPortQsfpHealthy> = {
  encode(message: AssertPortQsfpHealthy, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigPortQsfpHealthyData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.observedQsfpHealthDetails !== undefined) {
      QsfpHealthDetails.encode(message.observedQsfpHealthDetails, writer.uint32(58).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(64).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(74).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(80).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(88).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertPortQsfpHealthy {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertPortQsfpHealthy();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigPortQsfpHealthyData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.observedQsfpHealthDetails = QsfpHealthDetails.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertPortQsfpHealthy {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigPortQsfpHealthyData.fromJSON(object.config) : undefined,
      observedQsfpHealthDetails: isSet(object.observedQsfpHealthDetails)
        ? QsfpHealthDetails.fromJSON(object.observedQsfpHealthDetails)
        : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertPortQsfpHealthy): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigPortQsfpHealthyData.toJSON(message.config);
    }
    if (message.observedQsfpHealthDetails !== undefined) {
      obj.observedQsfpHealthDetails = QsfpHealthDetails.toJSON(message.observedQsfpHealthDetails);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertPortQsfpHealthy>, I>>(base?: I): AssertPortQsfpHealthy {
    return AssertPortQsfpHealthy.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertPortQsfpHealthy>, I>>(object: I): AssertPortQsfpHealthy {
    const message = createBaseAssertPortQsfpHealthy();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigPortQsfpHealthyData.fromPartial(object.config)
      : undefined;
    message.observedQsfpHealthDetails =
      (object.observedQsfpHealthDetails !== undefined && object.observedQsfpHealthDetails !== null)
        ? QsfpHealthDetails.fromPartial(object.observedQsfpHealthDetails)
        : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigConnectedToCloudData(): AssertConfigConnectedToCloudData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigConnectedToCloudData: MessageFns<AssertConfigConnectedToCloudData> = {
  encode(message: AssertConfigConnectedToCloudData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(50).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(66).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(80).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(96).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigConnectedToCloudData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigConnectedToCloudData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigConnectedToCloudData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigConnectedToCloudData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigConnectedToCloudData>, I>>(
    base?: I,
  ): AssertConfigConnectedToCloudData {
    return AssertConfigConnectedToCloudData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigConnectedToCloudData>, I>>(
    object: I,
  ): AssertConfigConnectedToCloudData {
    const message = createBaseAssertConfigConnectedToCloudData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigDeviceConnectedToCloud(): AssertConfigDeviceConnectedToCloud {
  return { id: undefined, config: undefined };
}

export const AssertConfigDeviceConnectedToCloud: MessageFns<AssertConfigDeviceConnectedToCloud> = {
  encode(message: AssertConfigDeviceConnectedToCloud, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigConnectedToCloudData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigDeviceConnectedToCloud {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigDeviceConnectedToCloud();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigConnectedToCloudData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigDeviceConnectedToCloud {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigConnectedToCloudData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigDeviceConnectedToCloud): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigConnectedToCloudData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigDeviceConnectedToCloud>, I>>(
    base?: I,
  ): AssertConfigDeviceConnectedToCloud {
    return AssertConfigDeviceConnectedToCloud.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigDeviceConnectedToCloud>, I>>(
    object: I,
  ): AssertConfigDeviceConnectedToCloud {
    const message = createBaseAssertConfigDeviceConnectedToCloud();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigConnectedToCloudData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertDeviceConnectedToCloud(): AssertDeviceConnectedToCloud {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertDeviceConnectedToCloud: MessageFns<AssertDeviceConnectedToCloud> = {
  encode(message: AssertDeviceConnectedToCloud, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigConnectedToCloudData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertDeviceConnectedToCloud {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertDeviceConnectedToCloud();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigConnectedToCloudData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertDeviceConnectedToCloud {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigConnectedToCloudData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertDeviceConnectedToCloud): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigConnectedToCloudData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertDeviceConnectedToCloud>, I>>(base?: I): AssertDeviceConnectedToCloud {
    return AssertDeviceConnectedToCloud.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertDeviceConnectedToCloud>, I>>(object: I): AssertDeviceConnectedToCloud {
    const message = createBaseAssertDeviceConnectedToCloud();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigConnectedToCloudData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigExpectedNeighborData(): AssertConfigExpectedNeighborData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    port: undefined,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigExpectedNeighborData: MessageFns<AssertConfigExpectedNeighborData> = {
  encode(message: AssertConfigExpectedNeighborData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.port !== undefined) {
      PortConfigDetails.encode(message.port, writer.uint32(34).fork()).join();
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigExpectedNeighborData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigExpectedNeighborData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.port = PortConfigDetails.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigExpectedNeighborData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      port: isSet(object.port) ? PortConfigDetails.fromJSON(object.port) : undefined,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigExpectedNeighborData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.port !== undefined) {
      obj.port = PortConfigDetails.toJSON(message.port);
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigExpectedNeighborData>, I>>(
    base?: I,
  ): AssertConfigExpectedNeighborData {
    return AssertConfigExpectedNeighborData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigExpectedNeighborData>, I>>(
    object: I,
  ): AssertConfigExpectedNeighborData {
    const message = createBaseAssertConfigExpectedNeighborData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.port = (object.port !== undefined && object.port !== null)
      ? PortConfigDetails.fromPartial(object.port)
      : undefined;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigPortExpectedNeighbor(): AssertConfigPortExpectedNeighbor {
  return { id: undefined, config: undefined };
}

export const AssertConfigPortExpectedNeighbor: MessageFns<AssertConfigPortExpectedNeighbor> = {
  encode(message: AssertConfigPortExpectedNeighbor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigExpectedNeighborData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortExpectedNeighbor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortExpectedNeighbor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigExpectedNeighborData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortExpectedNeighbor {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigExpectedNeighborData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigPortExpectedNeighbor): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigExpectedNeighborData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortExpectedNeighbor>, I>>(
    base?: I,
  ): AssertConfigPortExpectedNeighbor {
    return AssertConfigPortExpectedNeighbor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortExpectedNeighbor>, I>>(
    object: I,
  ): AssertConfigPortExpectedNeighbor {
    const message = createBaseAssertConfigPortExpectedNeighbor();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigExpectedNeighborData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertPortExpectedNeighbor(): AssertPortExpectedNeighbor {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    remoteDeviceId: "",
    remotePortName: "",
    numNeighbors: 0,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertPortExpectedNeighbor: MessageFns<AssertPortExpectedNeighbor> = {
  encode(message: AssertPortExpectedNeighbor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigExpectedNeighborData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.remoteDeviceId !== "") {
      writer.uint32(74).string(message.remoteDeviceId);
    }
    if (message.remotePortName !== "") {
      writer.uint32(82).string(message.remotePortName);
    }
    if (message.numNeighbors !== 0) {
      writer.uint32(88).int32(message.numNeighbors);
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(96).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(104).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertPortExpectedNeighbor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertPortExpectedNeighbor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigExpectedNeighborData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.remoteDeviceId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.remotePortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.numNeighbors = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertPortExpectedNeighbor {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigExpectedNeighborData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      remoteDeviceId: isSet(object.remoteDeviceId) ? globalThis.String(object.remoteDeviceId) : "",
      remotePortName: isSet(object.remotePortName) ? globalThis.String(object.remotePortName) : "",
      numNeighbors: isSet(object.numNeighbors) ? globalThis.Number(object.numNeighbors) : 0,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertPortExpectedNeighbor): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigExpectedNeighborData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.remoteDeviceId !== "") {
      obj.remoteDeviceId = message.remoteDeviceId;
    }
    if (message.remotePortName !== "") {
      obj.remotePortName = message.remotePortName;
    }
    if (message.numNeighbors !== 0) {
      obj.numNeighbors = Math.round(message.numNeighbors);
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertPortExpectedNeighbor>, I>>(base?: I): AssertPortExpectedNeighbor {
    return AssertPortExpectedNeighbor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertPortExpectedNeighbor>, I>>(object: I): AssertPortExpectedNeighbor {
    const message = createBaseAssertPortExpectedNeighbor();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigExpectedNeighborData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.remoteDeviceId = object.remoteDeviceId ?? "";
    message.remotePortName = object.remotePortName ?? "";
    message.numNeighbors = object.numNeighbors ?? 0;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigNotConnectedToFabricData(): AssertConfigNotConnectedToFabricData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    port: undefined,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigNotConnectedToFabricData: MessageFns<AssertConfigNotConnectedToFabricData> = {
  encode(message: AssertConfigNotConnectedToFabricData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.port !== undefined) {
      PortConfigDetails.encode(message.port, writer.uint32(34).fork()).join();
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigNotConnectedToFabricData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigNotConnectedToFabricData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.port = PortConfigDetails.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigNotConnectedToFabricData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      port: isSet(object.port) ? PortConfigDetails.fromJSON(object.port) : undefined,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigNotConnectedToFabricData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.port !== undefined) {
      obj.port = PortConfigDetails.toJSON(message.port);
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigNotConnectedToFabricData>, I>>(
    base?: I,
  ): AssertConfigNotConnectedToFabricData {
    return AssertConfigNotConnectedToFabricData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigNotConnectedToFabricData>, I>>(
    object: I,
  ): AssertConfigNotConnectedToFabricData {
    const message = createBaseAssertConfigNotConnectedToFabricData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.port = (object.port !== undefined && object.port !== null)
      ? PortConfigDetails.fromPartial(object.port)
      : undefined;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigPortNotConnectedToFabric(): AssertConfigPortNotConnectedToFabric {
  return { id: undefined, config: undefined };
}

export const AssertConfigPortNotConnectedToFabric: MessageFns<AssertConfigPortNotConnectedToFabric> = {
  encode(message: AssertConfigPortNotConnectedToFabric, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigNotConnectedToFabricData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortNotConnectedToFabric {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortNotConnectedToFabric();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigNotConnectedToFabricData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortNotConnectedToFabric {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigNotConnectedToFabricData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigPortNotConnectedToFabric): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigNotConnectedToFabricData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortNotConnectedToFabric>, I>>(
    base?: I,
  ): AssertConfigPortNotConnectedToFabric {
    return AssertConfigPortNotConnectedToFabric.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortNotConnectedToFabric>, I>>(
    object: I,
  ): AssertConfigPortNotConnectedToFabric {
    const message = createBaseAssertConfigPortNotConnectedToFabric();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigNotConnectedToFabricData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertPortNotConnectedToFabric(): AssertPortNotConnectedToFabric {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    remoteDeviceId: "",
    remotePortName: "",
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertPortNotConnectedToFabric: MessageFns<AssertPortNotConnectedToFabric> = {
  encode(message: AssertPortNotConnectedToFabric, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigNotConnectedToFabricData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.remoteDeviceId !== "") {
      writer.uint32(74).string(message.remoteDeviceId);
    }
    if (message.remotePortName !== "") {
      writer.uint32(82).string(message.remotePortName);
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(88).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(96).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertPortNotConnectedToFabric {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertPortNotConnectedToFabric();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigNotConnectedToFabricData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.remoteDeviceId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.remotePortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertPortNotConnectedToFabric {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigNotConnectedToFabricData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      remoteDeviceId: isSet(object.remoteDeviceId) ? globalThis.String(object.remoteDeviceId) : "",
      remotePortName: isSet(object.remotePortName) ? globalThis.String(object.remotePortName) : "",
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertPortNotConnectedToFabric): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigNotConnectedToFabricData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.remoteDeviceId !== "") {
      obj.remoteDeviceId = message.remoteDeviceId;
    }
    if (message.remotePortName !== "") {
      obj.remotePortName = message.remotePortName;
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertPortNotConnectedToFabric>, I>>(base?: I): AssertPortNotConnectedToFabric {
    return AssertPortNotConnectedToFabric.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertPortNotConnectedToFabric>, I>>(
    object: I,
  ): AssertPortNotConnectedToFabric {
    const message = createBaseAssertPortNotConnectedToFabric();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigNotConnectedToFabricData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.remoteDeviceId = object.remoteDeviceId ?? "";
    message.remotePortName = object.remotePortName ?? "";
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigConnectedToFabricData(): AssertConfigConnectedToFabricData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigConnectedToFabricData: MessageFns<AssertConfigConnectedToFabricData> = {
  encode(message: AssertConfigConnectedToFabricData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(50).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(66).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(80).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(96).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigConnectedToFabricData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigConnectedToFabricData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigConnectedToFabricData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigConnectedToFabricData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigConnectedToFabricData>, I>>(
    base?: I,
  ): AssertConfigConnectedToFabricData {
    return AssertConfigConnectedToFabricData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigConnectedToFabricData>, I>>(
    object: I,
  ): AssertConfigConnectedToFabricData {
    const message = createBaseAssertConfigConnectedToFabricData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigDeviceConnectedToFabric(): AssertConfigDeviceConnectedToFabric {
  return { id: undefined, config: undefined };
}

export const AssertConfigDeviceConnectedToFabric: MessageFns<AssertConfigDeviceConnectedToFabric> = {
  encode(message: AssertConfigDeviceConnectedToFabric, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigConnectedToFabricData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigDeviceConnectedToFabric {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigDeviceConnectedToFabric();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigConnectedToFabricData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigDeviceConnectedToFabric {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigConnectedToFabricData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigDeviceConnectedToFabric): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigConnectedToFabricData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigDeviceConnectedToFabric>, I>>(
    base?: I,
  ): AssertConfigDeviceConnectedToFabric {
    return AssertConfigDeviceConnectedToFabric.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigDeviceConnectedToFabric>, I>>(
    object: I,
  ): AssertConfigDeviceConnectedToFabric {
    const message = createBaseAssertConfigDeviceConnectedToFabric();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigConnectedToFabricData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertDeviceConnectedToFabric(): AssertDeviceConnectedToFabric {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertDeviceConnectedToFabric: MessageFns<AssertDeviceConnectedToFabric> = {
  encode(message: AssertDeviceConnectedToFabric, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigConnectedToFabricData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertDeviceConnectedToFabric {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertDeviceConnectedToFabric();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigConnectedToFabricData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertDeviceConnectedToFabric {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigConnectedToFabricData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertDeviceConnectedToFabric): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigConnectedToFabricData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertDeviceConnectedToFabric>, I>>(base?: I): AssertDeviceConnectedToFabric {
    return AssertDeviceConnectedToFabric.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertDeviceConnectedToFabric>, I>>(
    object: I,
  ): AssertDeviceConnectedToFabric {
    const message = createBaseAssertDeviceConnectedToFabric();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigConnectedToFabricData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigConnectedPortSpeedsMatchData(): AssertConfigConnectedPortSpeedsMatchData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    port: undefined,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigConnectedPortSpeedsMatchData: MessageFns<AssertConfigConnectedPortSpeedsMatchData> = {
  encode(message: AssertConfigConnectedPortSpeedsMatchData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.port !== undefined) {
      PortConfigDetails.encode(message.port, writer.uint32(34).fork()).join();
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigConnectedPortSpeedsMatchData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigConnectedPortSpeedsMatchData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.port = PortConfigDetails.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigConnectedPortSpeedsMatchData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      port: isSet(object.port) ? PortConfigDetails.fromJSON(object.port) : undefined,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigConnectedPortSpeedsMatchData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.port !== undefined) {
      obj.port = PortConfigDetails.toJSON(message.port);
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigConnectedPortSpeedsMatchData>, I>>(
    base?: I,
  ): AssertConfigConnectedPortSpeedsMatchData {
    return AssertConfigConnectedPortSpeedsMatchData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigConnectedPortSpeedsMatchData>, I>>(
    object: I,
  ): AssertConfigConnectedPortSpeedsMatchData {
    const message = createBaseAssertConfigConnectedPortSpeedsMatchData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.port = (object.port !== undefined && object.port !== null)
      ? PortConfigDetails.fromPartial(object.port)
      : undefined;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigPortConnectionSpeedMatch(): AssertConfigPortConnectionSpeedMatch {
  return { id: undefined, config: undefined };
}

export const AssertConfigPortConnectionSpeedMatch: MessageFns<AssertConfigPortConnectionSpeedMatch> = {
  encode(message: AssertConfigPortConnectionSpeedMatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigConnectedPortSpeedsMatchData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortConnectionSpeedMatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortConnectionSpeedMatch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigConnectedPortSpeedsMatchData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortConnectionSpeedMatch {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigConnectedPortSpeedsMatchData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigPortConnectionSpeedMatch): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigConnectedPortSpeedsMatchData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortConnectionSpeedMatch>, I>>(
    base?: I,
  ): AssertConfigPortConnectionSpeedMatch {
    return AssertConfigPortConnectionSpeedMatch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortConnectionSpeedMatch>, I>>(
    object: I,
  ): AssertConfigPortConnectionSpeedMatch {
    const message = createBaseAssertConfigPortConnectionSpeedMatch();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigConnectedPortSpeedsMatchData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertPortConnectionSpeedMatch(): AssertPortConnectionSpeedMatch {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    localPortSpeed: "0",
    remotePortName: "",
    remoteDeviceId: "",
    remotePortSpeed: "0",
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertPortConnectionSpeedMatch: MessageFns<AssertPortConnectionSpeedMatch> = {
  encode(message: AssertPortConnectionSpeedMatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigConnectedPortSpeedsMatchData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.localPortSpeed !== "0") {
      writer.uint32(72).uint64(message.localPortSpeed);
    }
    if (message.remotePortName !== "") {
      writer.uint32(82).string(message.remotePortName);
    }
    if (message.remoteDeviceId !== "") {
      writer.uint32(90).string(message.remoteDeviceId);
    }
    if (message.remotePortSpeed !== "0") {
      writer.uint32(96).uint64(message.remotePortSpeed);
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(104).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(112).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertPortConnectionSpeedMatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertPortConnectionSpeedMatch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigConnectedPortSpeedsMatchData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.localPortSpeed = reader.uint64().toString();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.remotePortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.remoteDeviceId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.remotePortSpeed = reader.uint64().toString();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertPortConnectionSpeedMatch {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigConnectedPortSpeedsMatchData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      localPortSpeed: isSet(object.localPortSpeed) ? globalThis.String(object.localPortSpeed) : "0",
      remotePortName: isSet(object.remotePortName) ? globalThis.String(object.remotePortName) : "",
      remoteDeviceId: isSet(object.remoteDeviceId) ? globalThis.String(object.remoteDeviceId) : "",
      remotePortSpeed: isSet(object.remotePortSpeed) ? globalThis.String(object.remotePortSpeed) : "0",
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertPortConnectionSpeedMatch): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigConnectedPortSpeedsMatchData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.localPortSpeed !== "0") {
      obj.localPortSpeed = message.localPortSpeed;
    }
    if (message.remotePortName !== "") {
      obj.remotePortName = message.remotePortName;
    }
    if (message.remoteDeviceId !== "") {
      obj.remoteDeviceId = message.remoteDeviceId;
    }
    if (message.remotePortSpeed !== "0") {
      obj.remotePortSpeed = message.remotePortSpeed;
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertPortConnectionSpeedMatch>, I>>(base?: I): AssertPortConnectionSpeedMatch {
    return AssertPortConnectionSpeedMatch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertPortConnectionSpeedMatch>, I>>(
    object: I,
  ): AssertPortConnectionSpeedMatch {
    const message = createBaseAssertPortConnectionSpeedMatch();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigConnectedPortSpeedsMatchData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.localPortSpeed = object.localPortSpeed ?? "0";
    message.remotePortName = object.remotePortName ?? "";
    message.remoteDeviceId = object.remoteDeviceId ?? "";
    message.remotePortSpeed = object.remotePortSpeed ?? "0";
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigPortSpeedConsistentData(): AssertConfigPortSpeedConsistentData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    port: undefined,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigPortSpeedConsistentData: MessageFns<AssertConfigPortSpeedConsistentData> = {
  encode(message: AssertConfigPortSpeedConsistentData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.port !== undefined) {
      PortConfigDetails.encode(message.port, writer.uint32(34).fork()).join();
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortSpeedConsistentData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortSpeedConsistentData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.port = PortConfigDetails.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortSpeedConsistentData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      port: isSet(object.port) ? PortConfigDetails.fromJSON(object.port) : undefined,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigPortSpeedConsistentData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.port !== undefined) {
      obj.port = PortConfigDetails.toJSON(message.port);
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortSpeedConsistentData>, I>>(
    base?: I,
  ): AssertConfigPortSpeedConsistentData {
    return AssertConfigPortSpeedConsistentData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortSpeedConsistentData>, I>>(
    object: I,
  ): AssertConfigPortSpeedConsistentData {
    const message = createBaseAssertConfigPortSpeedConsistentData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.port = (object.port !== undefined && object.port !== null)
      ? PortConfigDetails.fromPartial(object.port)
      : undefined;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigPortSpeedConsistent(): AssertConfigPortSpeedConsistent {
  return { id: undefined, config: undefined };
}

export const AssertConfigPortSpeedConsistent: MessageFns<AssertConfigPortSpeedConsistent> = {
  encode(message: AssertConfigPortSpeedConsistent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigPortSpeedConsistentData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortSpeedConsistent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortSpeedConsistent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigPortSpeedConsistentData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortSpeedConsistent {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigPortSpeedConsistentData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigPortSpeedConsistent): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigPortSpeedConsistentData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortSpeedConsistent>, I>>(base?: I): AssertConfigPortSpeedConsistent {
    return AssertConfigPortSpeedConsistent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortSpeedConsistent>, I>>(
    object: I,
  ): AssertConfigPortSpeedConsistent {
    const message = createBaseAssertConfigPortSpeedConsistent();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigPortSpeedConsistentData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertPortSpeedConsistent(): AssertPortSpeedConsistent {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    localPortSpeed: "0",
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertPortSpeedConsistent: MessageFns<AssertPortSpeedConsistent> = {
  encode(message: AssertPortSpeedConsistent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigPortSpeedConsistentData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.localPortSpeed !== "0") {
      writer.uint32(72).uint64(message.localPortSpeed);
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(80).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(88).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertPortSpeedConsistent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertPortSpeedConsistent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigPortSpeedConsistentData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.localPortSpeed = reader.uint64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertPortSpeedConsistent {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigPortSpeedConsistentData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      localPortSpeed: isSet(object.localPortSpeed) ? globalThis.String(object.localPortSpeed) : "0",
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertPortSpeedConsistent): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigPortSpeedConsistentData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.localPortSpeed !== "0") {
      obj.localPortSpeed = message.localPortSpeed;
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertPortSpeedConsistent>, I>>(base?: I): AssertPortSpeedConsistent {
    return AssertPortSpeedConsistent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertPortSpeedConsistent>, I>>(object: I): AssertPortSpeedConsistent {
    const message = createBaseAssertPortSpeedConsistent();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigPortSpeedConsistentData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.localPortSpeed = object.localPortSpeed ?? "0";
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigVlanHasTrafficData(): AssertConfigVlanHasTrafficData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
    maxVlanId: 0,
  };
}

export const AssertConfigVlanHasTrafficData: MessageFns<AssertConfigVlanHasTrafficData> = {
  encode(message: AssertConfigVlanHasTrafficData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(50).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(66).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(80).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(96).int32(message.deviceType);
    }
    if (message.maxVlanId !== 0) {
      writer.uint32(104).uint32(message.maxVlanId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigVlanHasTrafficData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigVlanHasTrafficData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.maxVlanId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigVlanHasTrafficData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
      maxVlanId: isSet(object.maxVlanId) ? globalThis.Number(object.maxVlanId) : 0,
    };
  },

  toJSON(message: AssertConfigVlanHasTrafficData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    if (message.maxVlanId !== 0) {
      obj.maxVlanId = Math.round(message.maxVlanId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigVlanHasTrafficData>, I>>(base?: I): AssertConfigVlanHasTrafficData {
    return AssertConfigVlanHasTrafficData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigVlanHasTrafficData>, I>>(
    object: I,
  ): AssertConfigVlanHasTrafficData {
    const message = createBaseAssertConfigVlanHasTrafficData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    message.maxVlanId = object.maxVlanId ?? 0;
    return message;
  },
};

function createBaseAssertConfigVlanHasTraffic(): AssertConfigVlanHasTraffic {
  return { id: undefined, config: undefined };
}

export const AssertConfigVlanHasTraffic: MessageFns<AssertConfigVlanHasTraffic> = {
  encode(message: AssertConfigVlanHasTraffic, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigVlanHasTrafficData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigVlanHasTraffic {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigVlanHasTraffic();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigVlanHasTrafficData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigVlanHasTraffic {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigVlanHasTrafficData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigVlanHasTraffic): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigVlanHasTrafficData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigVlanHasTraffic>, I>>(base?: I): AssertConfigVlanHasTraffic {
    return AssertConfigVlanHasTraffic.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigVlanHasTraffic>, I>>(object: I): AssertConfigVlanHasTraffic {
    const message = createBaseAssertConfigVlanHasTraffic();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigVlanHasTrafficData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertVlanHasTraffic(): AssertVlanHasTraffic {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    lastTrafficBytes: "0",
    lastTrafficTime: undefined,
    recentTrafficBytes: "0",
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertVlanHasTraffic: MessageFns<AssertVlanHasTraffic> = {
  encode(message: AssertVlanHasTraffic, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigVlanHasTrafficData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.lastTrafficBytes !== "0") {
      writer.uint32(72).uint64(message.lastTrafficBytes);
    }
    if (message.lastTrafficTime !== undefined) {
      Timestamp.encode(toTimestamp(message.lastTrafficTime), writer.uint32(82).fork()).join();
    }
    if (message.recentTrafficBytes !== "0") {
      writer.uint32(88).uint64(message.recentTrafficBytes);
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(96).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(104).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertVlanHasTraffic {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertVlanHasTraffic();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigVlanHasTrafficData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.lastTrafficBytes = reader.uint64().toString();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.lastTrafficTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.recentTrafficBytes = reader.uint64().toString();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertVlanHasTraffic {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigVlanHasTrafficData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      lastTrafficBytes: isSet(object.lastTrafficBytes) ? globalThis.String(object.lastTrafficBytes) : "0",
      lastTrafficTime: isSet(object.lastTrafficTime) ? fromJsonTimestamp(object.lastTrafficTime) : undefined,
      recentTrafficBytes: isSet(object.recentTrafficBytes) ? globalThis.String(object.recentTrafficBytes) : "0",
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertVlanHasTraffic): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigVlanHasTrafficData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.lastTrafficBytes !== "0") {
      obj.lastTrafficBytes = message.lastTrafficBytes;
    }
    if (message.lastTrafficTime !== undefined) {
      obj.lastTrafficTime = message.lastTrafficTime.toISOString();
    }
    if (message.recentTrafficBytes !== "0") {
      obj.recentTrafficBytes = message.recentTrafficBytes;
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertVlanHasTraffic>, I>>(base?: I): AssertVlanHasTraffic {
    return AssertVlanHasTraffic.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertVlanHasTraffic>, I>>(object: I): AssertVlanHasTraffic {
    const message = createBaseAssertVlanHasTraffic();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigVlanHasTrafficData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.lastTrafficBytes = object.lastTrafficBytes ?? "0";
    message.lastTrafficTime = object.lastTrafficTime ?? undefined;
    message.recentTrafficBytes = object.recentTrafficBytes ?? "0";
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigStaticDefaultRouteExistsData(): AssertConfigStaticDefaultRouteExistsData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigStaticDefaultRouteExistsData: MessageFns<AssertConfigStaticDefaultRouteExistsData> = {
  encode(message: AssertConfigStaticDefaultRouteExistsData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(50).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(66).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(80).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(96).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigStaticDefaultRouteExistsData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigStaticDefaultRouteExistsData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigStaticDefaultRouteExistsData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigStaticDefaultRouteExistsData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigStaticDefaultRouteExistsData>, I>>(
    base?: I,
  ): AssertConfigStaticDefaultRouteExistsData {
    return AssertConfigStaticDefaultRouteExistsData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigStaticDefaultRouteExistsData>, I>>(
    object: I,
  ): AssertConfigStaticDefaultRouteExistsData {
    const message = createBaseAssertConfigStaticDefaultRouteExistsData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigStaticDefaultRouteExists(): AssertConfigStaticDefaultRouteExists {
  return { id: undefined, config: undefined, interfaceName: "" };
}

export const AssertConfigStaticDefaultRouteExists: MessageFns<AssertConfigStaticDefaultRouteExists> = {
  encode(message: AssertConfigStaticDefaultRouteExists, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigStaticDefaultRouteExistsData.encode(message.config, writer.uint32(26).fork()).join();
    }
    if (message.interfaceName !== "") {
      writer.uint32(34).string(message.interfaceName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigStaticDefaultRouteExists {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigStaticDefaultRouteExists();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigStaticDefaultRouteExistsData.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.interfaceName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigStaticDefaultRouteExists {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigStaticDefaultRouteExistsData.fromJSON(object.config) : undefined,
      interfaceName: isSet(object.interfaceName) ? globalThis.String(object.interfaceName) : "",
    };
  },

  toJSON(message: AssertConfigStaticDefaultRouteExists): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigStaticDefaultRouteExistsData.toJSON(message.config);
    }
    if (message.interfaceName !== "") {
      obj.interfaceName = message.interfaceName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigStaticDefaultRouteExists>, I>>(
    base?: I,
  ): AssertConfigStaticDefaultRouteExists {
    return AssertConfigStaticDefaultRouteExists.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigStaticDefaultRouteExists>, I>>(
    object: I,
  ): AssertConfigStaticDefaultRouteExists {
    const message = createBaseAssertConfigStaticDefaultRouteExists();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigStaticDefaultRouteExistsData.fromPartial(object.config)
      : undefined;
    message.interfaceName = object.interfaceName ?? "";
    return message;
  },
};

function createBaseAssertStaticDefaultRouteExists(): AssertStaticDefaultRouteExists {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertStaticDefaultRouteExists: MessageFns<AssertStaticDefaultRouteExists> = {
  encode(message: AssertStaticDefaultRouteExists, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigStaticDefaultRouteExistsData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertStaticDefaultRouteExists {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertStaticDefaultRouteExists();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigStaticDefaultRouteExistsData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertStaticDefaultRouteExists {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigStaticDefaultRouteExistsData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertStaticDefaultRouteExists): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigStaticDefaultRouteExistsData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertStaticDefaultRouteExists>, I>>(base?: I): AssertStaticDefaultRouteExists {
    return AssertStaticDefaultRouteExists.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertStaticDefaultRouteExists>, I>>(
    object: I,
  ): AssertStaticDefaultRouteExists {
    const message = createBaseAssertStaticDefaultRouteExists();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigStaticDefaultRouteExistsData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigManagementPortConfigData(): AssertConfigManagementPortConfigData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    mgmtPortState: undefined,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigManagementPortConfigData: MessageFns<AssertConfigManagementPortConfigData> = {
  encode(message: AssertConfigManagementPortConfigData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.mgmtPortState !== undefined) {
      ManagementState.encode(message.mgmtPortState, writer.uint32(34).fork()).join();
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigManagementPortConfigData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigManagementPortConfigData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.mgmtPortState = ManagementState.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigManagementPortConfigData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      mgmtPortState: isSet(object.mgmtPortState) ? ManagementState.fromJSON(object.mgmtPortState) : undefined,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigManagementPortConfigData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.mgmtPortState !== undefined) {
      obj.mgmtPortState = ManagementState.toJSON(message.mgmtPortState);
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigManagementPortConfigData>, I>>(
    base?: I,
  ): AssertConfigManagementPortConfigData {
    return AssertConfigManagementPortConfigData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigManagementPortConfigData>, I>>(
    object: I,
  ): AssertConfigManagementPortConfigData {
    const message = createBaseAssertConfigManagementPortConfigData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.mgmtPortState = (object.mgmtPortState !== undefined && object.mgmtPortState !== null)
      ? ManagementState.fromPartial(object.mgmtPortState)
      : undefined;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigManagementPortConfigSame(): AssertConfigManagementPortConfigSame {
  return { id: undefined, config: undefined };
}

export const AssertConfigManagementPortConfigSame: MessageFns<AssertConfigManagementPortConfigSame> = {
  encode(message: AssertConfigManagementPortConfigSame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigManagementPortConfigData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigManagementPortConfigSame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigManagementPortConfigSame();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigManagementPortConfigData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigManagementPortConfigSame {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigManagementPortConfigData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigManagementPortConfigSame): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigManagementPortConfigData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigManagementPortConfigSame>, I>>(
    base?: I,
  ): AssertConfigManagementPortConfigSame {
    return AssertConfigManagementPortConfigSame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigManagementPortConfigSame>, I>>(
    object: I,
  ): AssertConfigManagementPortConfigSame {
    const message = createBaseAssertConfigManagementPortConfigSame();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigManagementPortConfigData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertManagementPortConfigSame(): AssertManagementPortConfigSame {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    operationalMgmtPortState: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertManagementPortConfigSame: MessageFns<AssertManagementPortConfigSame> = {
  encode(message: AssertManagementPortConfigSame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigManagementPortConfigData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.operationalMgmtPortState !== undefined) {
      ManagementState.encode(message.operationalMgmtPortState, writer.uint32(74).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(80).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(88).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertManagementPortConfigSame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertManagementPortConfigSame();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigManagementPortConfigData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.operationalMgmtPortState = ManagementState.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertManagementPortConfigSame {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigManagementPortConfigData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      operationalMgmtPortState: isSet(object.operationalMgmtPortState)
        ? ManagementState.fromJSON(object.operationalMgmtPortState)
        : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertManagementPortConfigSame): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigManagementPortConfigData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.operationalMgmtPortState !== undefined) {
      obj.operationalMgmtPortState = ManagementState.toJSON(message.operationalMgmtPortState);
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertManagementPortConfigSame>, I>>(base?: I): AssertManagementPortConfigSame {
    return AssertManagementPortConfigSame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertManagementPortConfigSame>, I>>(
    object: I,
  ): AssertManagementPortConfigSame {
    const message = createBaseAssertManagementPortConfigSame();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigManagementPortConfigData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.operationalMgmtPortState =
      (object.operationalMgmtPortState !== undefined && object.operationalMgmtPortState !== null)
        ? ManagementState.fromPartial(object.operationalMgmtPortState)
        : undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigExpectedPortBreakoutExistsData(): AssertConfigExpectedPortBreakoutExistsData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    expectedPortBreakoutCfg: undefined,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigExpectedPortBreakoutExistsData: MessageFns<AssertConfigExpectedPortBreakoutExistsData> = {
  encode(message: AssertConfigExpectedPortBreakoutExistsData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.expectedPortBreakoutCfg !== undefined) {
      PortBreakoutConfig.encode(message.expectedPortBreakoutCfg, writer.uint32(42).fork()).join();
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigExpectedPortBreakoutExistsData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigExpectedPortBreakoutExistsData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.expectedPortBreakoutCfg = PortBreakoutConfig.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigExpectedPortBreakoutExistsData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      expectedPortBreakoutCfg: isSet(object.expectedPortBreakoutCfg)
        ? PortBreakoutConfig.fromJSON(object.expectedPortBreakoutCfg)
        : undefined,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigExpectedPortBreakoutExistsData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.expectedPortBreakoutCfg !== undefined) {
      obj.expectedPortBreakoutCfg = PortBreakoutConfig.toJSON(message.expectedPortBreakoutCfg);
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigExpectedPortBreakoutExistsData>, I>>(
    base?: I,
  ): AssertConfigExpectedPortBreakoutExistsData {
    return AssertConfigExpectedPortBreakoutExistsData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigExpectedPortBreakoutExistsData>, I>>(
    object: I,
  ): AssertConfigExpectedPortBreakoutExistsData {
    const message = createBaseAssertConfigExpectedPortBreakoutExistsData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.expectedPortBreakoutCfg =
      (object.expectedPortBreakoutCfg !== undefined && object.expectedPortBreakoutCfg !== null)
        ? PortBreakoutConfig.fromPartial(object.expectedPortBreakoutCfg)
        : undefined;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigExpectedPortBreakoutExists(): AssertConfigExpectedPortBreakoutExists {
  return { id: undefined, config: undefined };
}

export const AssertConfigExpectedPortBreakoutExists: MessageFns<AssertConfigExpectedPortBreakoutExists> = {
  encode(message: AssertConfigExpectedPortBreakoutExists, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigExpectedPortBreakoutExistsData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigExpectedPortBreakoutExists {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigExpectedPortBreakoutExists();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigExpectedPortBreakoutExistsData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigExpectedPortBreakoutExists {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigExpectedPortBreakoutExistsData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigExpectedPortBreakoutExists): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigExpectedPortBreakoutExistsData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigExpectedPortBreakoutExists>, I>>(
    base?: I,
  ): AssertConfigExpectedPortBreakoutExists {
    return AssertConfigExpectedPortBreakoutExists.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigExpectedPortBreakoutExists>, I>>(
    object: I,
  ): AssertConfigExpectedPortBreakoutExists {
    const message = createBaseAssertConfigExpectedPortBreakoutExists();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigExpectedPortBreakoutExistsData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertExpectedPortBreakoutExists(): AssertExpectedPortBreakoutExists {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertExpectedPortBreakoutExists: MessageFns<AssertExpectedPortBreakoutExists> = {
  encode(message: AssertExpectedPortBreakoutExists, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigExpectedPortBreakoutExistsData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertExpectedPortBreakoutExists {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertExpectedPortBreakoutExists();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigExpectedPortBreakoutExistsData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertExpectedPortBreakoutExists {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigExpectedPortBreakoutExistsData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertExpectedPortBreakoutExists): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigExpectedPortBreakoutExistsData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertExpectedPortBreakoutExists>, I>>(
    base?: I,
  ): AssertExpectedPortBreakoutExists {
    return AssertExpectedPortBreakoutExists.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertExpectedPortBreakoutExists>, I>>(
    object: I,
  ): AssertExpectedPortBreakoutExists {
    const message = createBaseAssertExpectedPortBreakoutExists();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigExpectedPortBreakoutExistsData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBasePortBreakoutConfig(): PortBreakoutConfig {
  return { speed: "0", media: 0, name: "" };
}

export const PortBreakoutConfig: MessageFns<PortBreakoutConfig> = {
  encode(message: PortBreakoutConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.speed !== "0") {
      writer.uint32(8).uint64(message.speed);
    }
    if (message.media !== 0) {
      writer.uint32(16).int32(message.media);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortBreakoutConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortBreakoutConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.speed = reader.uint64().toString();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.media = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortBreakoutConfig {
    return {
      speed: isSet(object.speed) ? globalThis.String(object.speed) : "0",
      media: isSet(object.media) ? cableTypeFromJSON(object.media) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: PortBreakoutConfig): unknown {
    const obj: any = {};
    if (message.speed !== "0") {
      obj.speed = message.speed;
    }
    if (message.media !== 0) {
      obj.media = cableTypeToJSON(message.media);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortBreakoutConfig>, I>>(base?: I): PortBreakoutConfig {
    return PortBreakoutConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortBreakoutConfig>, I>>(object: I): PortBreakoutConfig {
    const message = createBasePortBreakoutConfig();
    message.speed = object.speed ?? "0";
    message.media = object.media ?? 0;
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseAssertConfigDeviceResourceUsageBelowThresholdData(): AssertConfigDeviceResourceUsageBelowThresholdData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    cpuThreshold: 0,
    memoryThreshold: 0,
    diskThreshold: 0,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigDeviceResourceUsageBelowThresholdData: MessageFns<
  AssertConfigDeviceResourceUsageBelowThresholdData
> = {
  encode(
    message: AssertConfigDeviceResourceUsageBelowThresholdData,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.cpuThreshold !== 0) {
      writer.uint32(37).float(message.cpuThreshold);
    }
    if (message.memoryThreshold !== 0) {
      writer.uint32(45).float(message.memoryThreshold);
    }
    if (message.diskThreshold !== 0) {
      writer.uint32(53).float(message.diskThreshold);
    }
    if (message.implicit !== false) {
      writer.uint32(56).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(66).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(90).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(104).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(120).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigDeviceResourceUsageBelowThresholdData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigDeviceResourceUsageBelowThresholdData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.cpuThreshold = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.memoryThreshold = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.diskThreshold = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigDeviceResourceUsageBelowThresholdData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      cpuThreshold: isSet(object.cpuThreshold) ? globalThis.Number(object.cpuThreshold) : 0,
      memoryThreshold: isSet(object.memoryThreshold) ? globalThis.Number(object.memoryThreshold) : 0,
      diskThreshold: isSet(object.diskThreshold) ? globalThis.Number(object.diskThreshold) : 0,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigDeviceResourceUsageBelowThresholdData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.cpuThreshold !== 0) {
      obj.cpuThreshold = message.cpuThreshold;
    }
    if (message.memoryThreshold !== 0) {
      obj.memoryThreshold = message.memoryThreshold;
    }
    if (message.diskThreshold !== 0) {
      obj.diskThreshold = message.diskThreshold;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigDeviceResourceUsageBelowThresholdData>, I>>(
    base?: I,
  ): AssertConfigDeviceResourceUsageBelowThresholdData {
    return AssertConfigDeviceResourceUsageBelowThresholdData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigDeviceResourceUsageBelowThresholdData>, I>>(
    object: I,
  ): AssertConfigDeviceResourceUsageBelowThresholdData {
    const message = createBaseAssertConfigDeviceResourceUsageBelowThresholdData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.cpuThreshold = object.cpuThreshold ?? 0;
    message.memoryThreshold = object.memoryThreshold ?? 0;
    message.diskThreshold = object.diskThreshold ?? 0;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigDeviceResourceUsageBelowThreshold(): AssertConfigDeviceResourceUsageBelowThreshold {
  return { id: undefined, config: undefined };
}

export const AssertConfigDeviceResourceUsageBelowThreshold: MessageFns<AssertConfigDeviceResourceUsageBelowThreshold> =
  {
    encode(
      message: AssertConfigDeviceResourceUsageBelowThreshold,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.id !== undefined) {
        PathId.encode(message.id, writer.uint32(18).fork()).join();
      }
      if (message.config !== undefined) {
        AssertConfigDeviceResourceUsageBelowThresholdData.encode(message.config, writer.uint32(26).fork()).join();
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigDeviceResourceUsageBelowThreshold {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      let end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseAssertConfigDeviceResourceUsageBelowThreshold();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.id = PathId.decode(reader, reader.uint32());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.config = AssertConfigDeviceResourceUsageBelowThresholdData.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): AssertConfigDeviceResourceUsageBelowThreshold {
      return {
        id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
        config: isSet(object.config)
          ? AssertConfigDeviceResourceUsageBelowThresholdData.fromJSON(object.config)
          : undefined,
      };
    },

    toJSON(message: AssertConfigDeviceResourceUsageBelowThreshold): unknown {
      const obj: any = {};
      if (message.id !== undefined) {
        obj.id = PathId.toJSON(message.id);
      }
      if (message.config !== undefined) {
        obj.config = AssertConfigDeviceResourceUsageBelowThresholdData.toJSON(message.config);
      }
      return obj;
    },

    create<I extends Exact<DeepPartial<AssertConfigDeviceResourceUsageBelowThreshold>, I>>(
      base?: I,
    ): AssertConfigDeviceResourceUsageBelowThreshold {
      return AssertConfigDeviceResourceUsageBelowThreshold.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<AssertConfigDeviceResourceUsageBelowThreshold>, I>>(
      object: I,
    ): AssertConfigDeviceResourceUsageBelowThreshold {
      const message = createBaseAssertConfigDeviceResourceUsageBelowThreshold();
      message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
      message.config = (object.config !== undefined && object.config !== null)
        ? AssertConfigDeviceResourceUsageBelowThresholdData.fromPartial(object.config)
        : undefined;
      return message;
    },
  };

function createBaseAssertDeviceResourceUsageBelowThreshold(): AssertDeviceResourceUsageBelowThreshold {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    currentSystemStats: undefined,
    highCpuUtil: false,
    highMemUtil: false,
    highDiskUtil: false,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertDeviceResourceUsageBelowThreshold: MessageFns<AssertDeviceResourceUsageBelowThreshold> = {
  encode(message: AssertDeviceResourceUsageBelowThreshold, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigDeviceResourceUsageBelowThresholdData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.currentSystemStats !== undefined) {
      SystemStats.encode(message.currentSystemStats, writer.uint32(74).fork()).join();
    }
    if (message.highCpuUtil !== false) {
      writer.uint32(80).bool(message.highCpuUtil);
    }
    if (message.highMemUtil !== false) {
      writer.uint32(88).bool(message.highMemUtil);
    }
    if (message.highDiskUtil !== false) {
      writer.uint32(96).bool(message.highDiskUtil);
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(104).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(112).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertDeviceResourceUsageBelowThreshold {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertDeviceResourceUsageBelowThreshold();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigDeviceResourceUsageBelowThresholdData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.currentSystemStats = SystemStats.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.highCpuUtil = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.highMemUtil = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.highDiskUtil = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertDeviceResourceUsageBelowThreshold {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config)
        ? AssertConfigDeviceResourceUsageBelowThresholdData.fromJSON(object.config)
        : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      currentSystemStats: isSet(object.currentSystemStats)
        ? SystemStats.fromJSON(object.currentSystemStats)
        : undefined,
      highCpuUtil: isSet(object.highCpuUtil) ? globalThis.Boolean(object.highCpuUtil) : false,
      highMemUtil: isSet(object.highMemUtil) ? globalThis.Boolean(object.highMemUtil) : false,
      highDiskUtil: isSet(object.highDiskUtil) ? globalThis.Boolean(object.highDiskUtil) : false,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertDeviceResourceUsageBelowThreshold): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigDeviceResourceUsageBelowThresholdData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.currentSystemStats !== undefined) {
      obj.currentSystemStats = SystemStats.toJSON(message.currentSystemStats);
    }
    if (message.highCpuUtil !== false) {
      obj.highCpuUtil = message.highCpuUtil;
    }
    if (message.highMemUtil !== false) {
      obj.highMemUtil = message.highMemUtil;
    }
    if (message.highDiskUtil !== false) {
      obj.highDiskUtil = message.highDiskUtil;
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertDeviceResourceUsageBelowThreshold>, I>>(
    base?: I,
  ): AssertDeviceResourceUsageBelowThreshold {
    return AssertDeviceResourceUsageBelowThreshold.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertDeviceResourceUsageBelowThreshold>, I>>(
    object: I,
  ): AssertDeviceResourceUsageBelowThreshold {
    const message = createBaseAssertDeviceResourceUsageBelowThreshold();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigDeviceResourceUsageBelowThresholdData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.currentSystemStats = (object.currentSystemStats !== undefined && object.currentSystemStats !== null)
      ? SystemStats.fromPartial(object.currentSystemStats)
      : undefined;
    message.highCpuUtil = object.highCpuUtil ?? false;
    message.highMemUtil = object.highMemUtil ?? false;
    message.highDiskUtil = object.highDiskUtil ?? false;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigDevicePsuUsageBelowThreshold(): AssertConfigDevicePsuUsageBelowThreshold {
  return { id: undefined, config: undefined };
}

export const AssertConfigDevicePsuUsageBelowThreshold: MessageFns<AssertConfigDevicePsuUsageBelowThreshold> = {
  encode(message: AssertConfigDevicePsuUsageBelowThreshold, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigDevicePsuUsageBelowThresholdData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigDevicePsuUsageBelowThreshold {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigDevicePsuUsageBelowThreshold();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigDevicePsuUsageBelowThresholdData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigDevicePsuUsageBelowThreshold {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigDevicePsuUsageBelowThresholdData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigDevicePsuUsageBelowThreshold): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigDevicePsuUsageBelowThresholdData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigDevicePsuUsageBelowThreshold>, I>>(
    base?: I,
  ): AssertConfigDevicePsuUsageBelowThreshold {
    return AssertConfigDevicePsuUsageBelowThreshold.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigDevicePsuUsageBelowThreshold>, I>>(
    object: I,
  ): AssertConfigDevicePsuUsageBelowThreshold {
    const message = createBaseAssertConfigDevicePsuUsageBelowThreshold();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigDevicePsuUsageBelowThresholdData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertConfigDevicePsuUsageBelowThresholdData(): AssertConfigDevicePsuUsageBelowThresholdData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    fanSpeedThreshold: 0,
    powerDrawnThreshold: 0,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigDevicePsuUsageBelowThresholdData: MessageFns<AssertConfigDevicePsuUsageBelowThresholdData> = {
  encode(
    message: AssertConfigDevicePsuUsageBelowThresholdData,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.fanSpeedThreshold !== 0) {
      writer.uint32(37).float(message.fanSpeedThreshold);
    }
    if (message.powerDrawnThreshold !== 0) {
      writer.uint32(45).float(message.powerDrawnThreshold);
    }
    if (message.implicit !== false) {
      writer.uint32(48).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(58).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(66).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(82).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(96).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(112).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigDevicePsuUsageBelowThresholdData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigDevicePsuUsageBelowThresholdData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.fanSpeedThreshold = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.powerDrawnThreshold = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigDevicePsuUsageBelowThresholdData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      fanSpeedThreshold: isSet(object.fanSpeedThreshold) ? globalThis.Number(object.fanSpeedThreshold) : 0,
      powerDrawnThreshold: isSet(object.powerDrawnThreshold) ? globalThis.Number(object.powerDrawnThreshold) : 0,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigDevicePsuUsageBelowThresholdData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.fanSpeedThreshold !== 0) {
      obj.fanSpeedThreshold = message.fanSpeedThreshold;
    }
    if (message.powerDrawnThreshold !== 0) {
      obj.powerDrawnThreshold = message.powerDrawnThreshold;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigDevicePsuUsageBelowThresholdData>, I>>(
    base?: I,
  ): AssertConfigDevicePsuUsageBelowThresholdData {
    return AssertConfigDevicePsuUsageBelowThresholdData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigDevicePsuUsageBelowThresholdData>, I>>(
    object: I,
  ): AssertConfigDevicePsuUsageBelowThresholdData {
    const message = createBaseAssertConfigDevicePsuUsageBelowThresholdData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.fanSpeedThreshold = object.fanSpeedThreshold ?? 0;
    message.powerDrawnThreshold = object.powerDrawnThreshold ?? 0;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertDevicePsuUsageBelowThreshold(): AssertDevicePsuUsageBelowThreshold {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertDevicePsuUsageBelowThreshold: MessageFns<AssertDevicePsuUsageBelowThreshold> = {
  encode(message: AssertDevicePsuUsageBelowThreshold, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigDevicePsuUsageBelowThresholdData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertDevicePsuUsageBelowThreshold {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertDevicePsuUsageBelowThreshold();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigDevicePsuUsageBelowThresholdData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertDevicePsuUsageBelowThreshold {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigDevicePsuUsageBelowThresholdData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertDevicePsuUsageBelowThreshold): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigDevicePsuUsageBelowThresholdData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertDevicePsuUsageBelowThreshold>, I>>(
    base?: I,
  ): AssertDevicePsuUsageBelowThreshold {
    return AssertDevicePsuUsageBelowThreshold.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertDevicePsuUsageBelowThreshold>, I>>(
    object: I,
  ): AssertDevicePsuUsageBelowThreshold {
    const message = createBaseAssertDevicePsuUsageBelowThreshold();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigDevicePsuUsageBelowThresholdData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigDeviceFanSpeedBelowThreshold(): AssertConfigDeviceFanSpeedBelowThreshold {
  return { id: undefined, config: undefined };
}

export const AssertConfigDeviceFanSpeedBelowThreshold: MessageFns<AssertConfigDeviceFanSpeedBelowThreshold> = {
  encode(message: AssertConfigDeviceFanSpeedBelowThreshold, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigDeviceFanSpeedBelowThresholdData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigDeviceFanSpeedBelowThreshold {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigDeviceFanSpeedBelowThreshold();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigDeviceFanSpeedBelowThresholdData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigDeviceFanSpeedBelowThreshold {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigDeviceFanSpeedBelowThresholdData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigDeviceFanSpeedBelowThreshold): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigDeviceFanSpeedBelowThresholdData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigDeviceFanSpeedBelowThreshold>, I>>(
    base?: I,
  ): AssertConfigDeviceFanSpeedBelowThreshold {
    return AssertConfigDeviceFanSpeedBelowThreshold.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigDeviceFanSpeedBelowThreshold>, I>>(
    object: I,
  ): AssertConfigDeviceFanSpeedBelowThreshold {
    const message = createBaseAssertConfigDeviceFanSpeedBelowThreshold();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigDeviceFanSpeedBelowThresholdData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertConfigDeviceFanSpeedBelowThresholdData(): AssertConfigDeviceFanSpeedBelowThresholdData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    fanSpeedThreshold: 0,
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigDeviceFanSpeedBelowThresholdData: MessageFns<AssertConfigDeviceFanSpeedBelowThresholdData> = {
  encode(
    message: AssertConfigDeviceFanSpeedBelowThresholdData,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.fanSpeedThreshold !== 0) {
      writer.uint32(37).float(message.fanSpeedThreshold);
    }
    if (message.implicit !== false) {
      writer.uint32(40).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(50).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(58).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(74).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(88).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(104).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigDeviceFanSpeedBelowThresholdData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigDeviceFanSpeedBelowThresholdData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.fanSpeedThreshold = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigDeviceFanSpeedBelowThresholdData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      fanSpeedThreshold: isSet(object.fanSpeedThreshold) ? globalThis.Number(object.fanSpeedThreshold) : 0,
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigDeviceFanSpeedBelowThresholdData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.fanSpeedThreshold !== 0) {
      obj.fanSpeedThreshold = message.fanSpeedThreshold;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigDeviceFanSpeedBelowThresholdData>, I>>(
    base?: I,
  ): AssertConfigDeviceFanSpeedBelowThresholdData {
    return AssertConfigDeviceFanSpeedBelowThresholdData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigDeviceFanSpeedBelowThresholdData>, I>>(
    object: I,
  ): AssertConfigDeviceFanSpeedBelowThresholdData {
    const message = createBaseAssertConfigDeviceFanSpeedBelowThresholdData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.fanSpeedThreshold = object.fanSpeedThreshold ?? 0;
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertDeviceFanSpeedBelowThreshold(): AssertDeviceFanSpeedBelowThreshold {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertDeviceFanSpeedBelowThreshold: MessageFns<AssertDeviceFanSpeedBelowThreshold> = {
  encode(message: AssertDeviceFanSpeedBelowThreshold, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigDeviceFanSpeedBelowThresholdData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertDeviceFanSpeedBelowThreshold {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertDeviceFanSpeedBelowThreshold();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigDeviceFanSpeedBelowThresholdData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertDeviceFanSpeedBelowThreshold {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigDeviceFanSpeedBelowThresholdData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertDeviceFanSpeedBelowThreshold): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigDeviceFanSpeedBelowThresholdData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertDeviceFanSpeedBelowThreshold>, I>>(
    base?: I,
  ): AssertDeviceFanSpeedBelowThreshold {
    return AssertDeviceFanSpeedBelowThreshold.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertDeviceFanSpeedBelowThreshold>, I>>(
    object: I,
  ): AssertDeviceFanSpeedBelowThreshold {
    const message = createBaseAssertDeviceFanSpeedBelowThreshold();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigDeviceFanSpeedBelowThresholdData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigDeviceTemperatureBelowThreshold(): AssertConfigDeviceTemperatureBelowThreshold {
  return { id: undefined, config: undefined };
}

export const AssertConfigDeviceTemperatureBelowThreshold: MessageFns<AssertConfigDeviceTemperatureBelowThreshold> = {
  encode(
    message: AssertConfigDeviceTemperatureBelowThreshold,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigDeviceTemperatureBelowThresholdData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigDeviceTemperatureBelowThreshold {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigDeviceTemperatureBelowThreshold();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigDeviceTemperatureBelowThresholdData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigDeviceTemperatureBelowThreshold {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config)
        ? AssertConfigDeviceTemperatureBelowThresholdData.fromJSON(object.config)
        : undefined,
    };
  },

  toJSON(message: AssertConfigDeviceTemperatureBelowThreshold): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigDeviceTemperatureBelowThresholdData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigDeviceTemperatureBelowThreshold>, I>>(
    base?: I,
  ): AssertConfigDeviceTemperatureBelowThreshold {
    return AssertConfigDeviceTemperatureBelowThreshold.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigDeviceTemperatureBelowThreshold>, I>>(
    object: I,
  ): AssertConfigDeviceTemperatureBelowThreshold {
    const message = createBaseAssertConfigDeviceTemperatureBelowThreshold();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigDeviceTemperatureBelowThresholdData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertConfigDeviceTemperatureBelowThresholdData(): AssertConfigDeviceTemperatureBelowThresholdData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigDeviceTemperatureBelowThresholdData: MessageFns<
  AssertConfigDeviceTemperatureBelowThresholdData
> = {
  encode(
    message: AssertConfigDeviceTemperatureBelowThresholdData,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(50).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(66).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(80).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(96).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigDeviceTemperatureBelowThresholdData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigDeviceTemperatureBelowThresholdData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigDeviceTemperatureBelowThresholdData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigDeviceTemperatureBelowThresholdData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigDeviceTemperatureBelowThresholdData>, I>>(
    base?: I,
  ): AssertConfigDeviceTemperatureBelowThresholdData {
    return AssertConfigDeviceTemperatureBelowThresholdData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigDeviceTemperatureBelowThresholdData>, I>>(
    object: I,
  ): AssertConfigDeviceTemperatureBelowThresholdData {
    const message = createBaseAssertConfigDeviceTemperatureBelowThresholdData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertDeviceTemperatureBelowThreshold(): AssertDeviceTemperatureBelowThreshold {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertDeviceTemperatureBelowThreshold: MessageFns<AssertDeviceTemperatureBelowThreshold> = {
  encode(message: AssertDeviceTemperatureBelowThreshold, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigDeviceTemperatureBelowThresholdData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertDeviceTemperatureBelowThreshold {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertDeviceTemperatureBelowThreshold();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigDeviceTemperatureBelowThresholdData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertDeviceTemperatureBelowThreshold {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config)
        ? AssertConfigDeviceTemperatureBelowThresholdData.fromJSON(object.config)
        : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertDeviceTemperatureBelowThreshold): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigDeviceTemperatureBelowThresholdData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertDeviceTemperatureBelowThreshold>, I>>(
    base?: I,
  ): AssertDeviceTemperatureBelowThreshold {
    return AssertDeviceTemperatureBelowThreshold.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertDeviceTemperatureBelowThreshold>, I>>(
    object: I,
  ): AssertDeviceTemperatureBelowThreshold {
    const message = createBaseAssertDeviceTemperatureBelowThreshold();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigDeviceTemperatureBelowThresholdData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigBgpPeerEstablishedData(): AssertConfigBgpPeerEstablishedData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    orgId: "",
    peerRemoteAs: 0,
    vrfName: "",
    fabricId: "",
    peerIp: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
    bgpPeerId: "",
    bgpPeerName: "",
    isMultisitePeer: false,
    multisiteName: "",
    multisiteId: "",
    localMultisiteLinkIp: "",
    localBgpPeerId: "",
  };
}

export const AssertConfigBgpPeerEstablishedData: MessageFns<AssertConfigBgpPeerEstablishedData> = {
  encode(message: AssertConfigBgpPeerEstablishedData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.peerRemoteAs !== 0) {
      writer.uint32(48).uint32(message.peerRemoteAs);
    }
    if (message.vrfName !== "") {
      writer.uint32(58).string(message.vrfName);
    }
    if (message.fabricId !== "") {
      writer.uint32(66).string(message.fabricId);
    }
    if (message.peerIp !== "") {
      writer.uint32(74).string(message.peerIp);
    }
    if (message.groupShortName !== "") {
      writer.uint32(90).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(104).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(120).int32(message.deviceType);
    }
    if (message.bgpPeerId !== "") {
      writer.uint32(130).string(message.bgpPeerId);
    }
    if (message.bgpPeerName !== "") {
      writer.uint32(138).string(message.bgpPeerName);
    }
    if (message.isMultisitePeer !== false) {
      writer.uint32(144).bool(message.isMultisitePeer);
    }
    if (message.multisiteName !== "") {
      writer.uint32(154).string(message.multisiteName);
    }
    if (message.multisiteId !== "") {
      writer.uint32(162).string(message.multisiteId);
    }
    if (message.localMultisiteLinkIp !== "") {
      writer.uint32(170).string(message.localMultisiteLinkIp);
    }
    if (message.localBgpPeerId !== "") {
      writer.uint32(178).string(message.localBgpPeerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigBgpPeerEstablishedData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigBgpPeerEstablishedData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.peerRemoteAs = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.vrfName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.peerIp = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.bgpPeerId = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.bgpPeerName = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.isMultisitePeer = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.multisiteName = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.multisiteId = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.localMultisiteLinkIp = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.localBgpPeerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigBgpPeerEstablishedData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      peerRemoteAs: isSet(object.peerRemoteAs) ? globalThis.Number(object.peerRemoteAs) : 0,
      vrfName: isSet(object.vrfName) ? globalThis.String(object.vrfName) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      peerIp: isSet(object.peerIp) ? globalThis.String(object.peerIp) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
      bgpPeerId: isSet(object.bgpPeerId) ? globalThis.String(object.bgpPeerId) : "",
      bgpPeerName: isSet(object.bgpPeerName) ? globalThis.String(object.bgpPeerName) : "",
      isMultisitePeer: isSet(object.isMultisitePeer) ? globalThis.Boolean(object.isMultisitePeer) : false,
      multisiteName: isSet(object.multisiteName) ? globalThis.String(object.multisiteName) : "",
      multisiteId: isSet(object.multisiteId) ? globalThis.String(object.multisiteId) : "",
      localMultisiteLinkIp: isSet(object.localMultisiteLinkIp) ? globalThis.String(object.localMultisiteLinkIp) : "",
      localBgpPeerId: isSet(object.localBgpPeerId) ? globalThis.String(object.localBgpPeerId) : "",
    };
  },

  toJSON(message: AssertConfigBgpPeerEstablishedData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.peerRemoteAs !== 0) {
      obj.peerRemoteAs = Math.round(message.peerRemoteAs);
    }
    if (message.vrfName !== "") {
      obj.vrfName = message.vrfName;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.peerIp !== "") {
      obj.peerIp = message.peerIp;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    if (message.bgpPeerId !== "") {
      obj.bgpPeerId = message.bgpPeerId;
    }
    if (message.bgpPeerName !== "") {
      obj.bgpPeerName = message.bgpPeerName;
    }
    if (message.isMultisitePeer !== false) {
      obj.isMultisitePeer = message.isMultisitePeer;
    }
    if (message.multisiteName !== "") {
      obj.multisiteName = message.multisiteName;
    }
    if (message.multisiteId !== "") {
      obj.multisiteId = message.multisiteId;
    }
    if (message.localMultisiteLinkIp !== "") {
      obj.localMultisiteLinkIp = message.localMultisiteLinkIp;
    }
    if (message.localBgpPeerId !== "") {
      obj.localBgpPeerId = message.localBgpPeerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigBgpPeerEstablishedData>, I>>(
    base?: I,
  ): AssertConfigBgpPeerEstablishedData {
    return AssertConfigBgpPeerEstablishedData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigBgpPeerEstablishedData>, I>>(
    object: I,
  ): AssertConfigBgpPeerEstablishedData {
    const message = createBaseAssertConfigBgpPeerEstablishedData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.peerRemoteAs = object.peerRemoteAs ?? 0;
    message.vrfName = object.vrfName ?? "";
    message.fabricId = object.fabricId ?? "";
    message.peerIp = object.peerIp ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    message.bgpPeerId = object.bgpPeerId ?? "";
    message.bgpPeerName = object.bgpPeerName ?? "";
    message.isMultisitePeer = object.isMultisitePeer ?? false;
    message.multisiteName = object.multisiteName ?? "";
    message.multisiteId = object.multisiteId ?? "";
    message.localMultisiteLinkIp = object.localMultisiteLinkIp ?? "";
    message.localBgpPeerId = object.localBgpPeerId ?? "";
    return message;
  },
};

function createBaseAssertConfigBgpPeerEstablished(): AssertConfigBgpPeerEstablished {
  return { id: undefined, config: undefined };
}

export const AssertConfigBgpPeerEstablished: MessageFns<AssertConfigBgpPeerEstablished> = {
  encode(message: AssertConfigBgpPeerEstablished, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigBgpPeerEstablishedData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigBgpPeerEstablished {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigBgpPeerEstablished();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigBgpPeerEstablishedData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigBgpPeerEstablished {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigBgpPeerEstablishedData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigBgpPeerEstablished): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigBgpPeerEstablishedData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigBgpPeerEstablished>, I>>(base?: I): AssertConfigBgpPeerEstablished {
    return AssertConfigBgpPeerEstablished.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigBgpPeerEstablished>, I>>(
    object: I,
  ): AssertConfigBgpPeerEstablished {
    const message = createBaseAssertConfigBgpPeerEstablished();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigBgpPeerEstablishedData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertBgpPeerEstablished(): AssertBgpPeerEstablished {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertBgpPeerEstablished: MessageFns<AssertBgpPeerEstablished> = {
  encode(message: AssertBgpPeerEstablished, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigBgpPeerEstablishedData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertBgpPeerEstablished {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertBgpPeerEstablished();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigBgpPeerEstablishedData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertBgpPeerEstablished {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigBgpPeerEstablishedData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertBgpPeerEstablished): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigBgpPeerEstablishedData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertBgpPeerEstablished>, I>>(base?: I): AssertBgpPeerEstablished {
    return AssertBgpPeerEstablished.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertBgpPeerEstablished>, I>>(object: I): AssertBgpPeerEstablished {
    const message = createBaseAssertBgpPeerEstablished();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigBgpPeerEstablishedData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigPortNoUnknownVlanFoundData(): AssertConfigPortNoUnknownVlanFoundData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
    portName: "",
  };
}

export const AssertConfigPortNoUnknownVlanFoundData: MessageFns<AssertConfigPortNoUnknownVlanFoundData> = {
  encode(message: AssertConfigPortNoUnknownVlanFoundData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(50).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(66).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(80).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(96).int32(message.deviceType);
    }
    if (message.portName !== "") {
      writer.uint32(106).string(message.portName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortNoUnknownVlanFoundData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortNoUnknownVlanFoundData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortNoUnknownVlanFoundData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
    };
  },

  toJSON(message: AssertConfigPortNoUnknownVlanFoundData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortNoUnknownVlanFoundData>, I>>(
    base?: I,
  ): AssertConfigPortNoUnknownVlanFoundData {
    return AssertConfigPortNoUnknownVlanFoundData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortNoUnknownVlanFoundData>, I>>(
    object: I,
  ): AssertConfigPortNoUnknownVlanFoundData {
    const message = createBaseAssertConfigPortNoUnknownVlanFoundData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    message.portName = object.portName ?? "";
    return message;
  },
};

function createBaseAssertConfigPortNoUnknownVlanFound(): AssertConfigPortNoUnknownVlanFound {
  return { id: undefined, config: undefined };
}

export const AssertConfigPortNoUnknownVlanFound: MessageFns<AssertConfigPortNoUnknownVlanFound> = {
  encode(message: AssertConfigPortNoUnknownVlanFound, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigPortNoUnknownVlanFoundData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigPortNoUnknownVlanFound {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigPortNoUnknownVlanFound();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigPortNoUnknownVlanFoundData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigPortNoUnknownVlanFound {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigPortNoUnknownVlanFoundData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigPortNoUnknownVlanFound): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigPortNoUnknownVlanFoundData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigPortNoUnknownVlanFound>, I>>(
    base?: I,
  ): AssertConfigPortNoUnknownVlanFound {
    return AssertConfigPortNoUnknownVlanFound.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigPortNoUnknownVlanFound>, I>>(
    object: I,
  ): AssertConfigPortNoUnknownVlanFound {
    const message = createBaseAssertConfigPortNoUnknownVlanFound();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigPortNoUnknownVlanFoundData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertPortNoUnknownVlanFound(): AssertPortNoUnknownVlanFound {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    unknownVlan1: 0,
    unknownVlan2: 0,
    unknownVlan3: 0,
    unknownVlan4: 0,
    unknownVlan5: 0,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
    hasAdditionalUnknownVlans: false,
  };
}

export const AssertPortNoUnknownVlanFound: MessageFns<AssertPortNoUnknownVlanFound> = {
  encode(message: AssertPortNoUnknownVlanFound, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigPortNoUnknownVlanFoundData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.unknownVlan1 !== 0) {
      writer.uint32(72).int32(message.unknownVlan1);
    }
    if (message.unknownVlan2 !== 0) {
      writer.uint32(80).int32(message.unknownVlan2);
    }
    if (message.unknownVlan3 !== 0) {
      writer.uint32(88).int32(message.unknownVlan3);
    }
    if (message.unknownVlan4 !== 0) {
      writer.uint32(96).int32(message.unknownVlan4);
    }
    if (message.unknownVlan5 !== 0) {
      writer.uint32(104).int32(message.unknownVlan5);
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(112).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(120).bool(message.maskedByConnectionToCloud);
    }
    if (message.hasAdditionalUnknownVlans !== false) {
      writer.uint32(128).bool(message.hasAdditionalUnknownVlans);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertPortNoUnknownVlanFound {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertPortNoUnknownVlanFound();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigPortNoUnknownVlanFoundData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.unknownVlan1 = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.unknownVlan2 = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.unknownVlan3 = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.unknownVlan4 = reader.int32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.unknownVlan5 = reader.int32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.hasAdditionalUnknownVlans = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertPortNoUnknownVlanFound {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigPortNoUnknownVlanFoundData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      unknownVlan1: isSet(object.unknownVlan1) ? globalThis.Number(object.unknownVlan1) : 0,
      unknownVlan2: isSet(object.unknownVlan2) ? globalThis.Number(object.unknownVlan2) : 0,
      unknownVlan3: isSet(object.unknownVlan3) ? globalThis.Number(object.unknownVlan3) : 0,
      unknownVlan4: isSet(object.unknownVlan4) ? globalThis.Number(object.unknownVlan4) : 0,
      unknownVlan5: isSet(object.unknownVlan5) ? globalThis.Number(object.unknownVlan5) : 0,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
      hasAdditionalUnknownVlans: isSet(object.hasAdditionalUnknownVlans)
        ? globalThis.Boolean(object.hasAdditionalUnknownVlans)
        : false,
    };
  },

  toJSON(message: AssertPortNoUnknownVlanFound): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigPortNoUnknownVlanFoundData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.unknownVlan1 !== 0) {
      obj.unknownVlan1 = Math.round(message.unknownVlan1);
    }
    if (message.unknownVlan2 !== 0) {
      obj.unknownVlan2 = Math.round(message.unknownVlan2);
    }
    if (message.unknownVlan3 !== 0) {
      obj.unknownVlan3 = Math.round(message.unknownVlan3);
    }
    if (message.unknownVlan4 !== 0) {
      obj.unknownVlan4 = Math.round(message.unknownVlan4);
    }
    if (message.unknownVlan5 !== 0) {
      obj.unknownVlan5 = Math.round(message.unknownVlan5);
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    if (message.hasAdditionalUnknownVlans !== false) {
      obj.hasAdditionalUnknownVlans = message.hasAdditionalUnknownVlans;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertPortNoUnknownVlanFound>, I>>(base?: I): AssertPortNoUnknownVlanFound {
    return AssertPortNoUnknownVlanFound.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertPortNoUnknownVlanFound>, I>>(object: I): AssertPortNoUnknownVlanFound {
    const message = createBaseAssertPortNoUnknownVlanFound();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigPortNoUnknownVlanFoundData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.unknownVlan1 = object.unknownVlan1 ?? 0;
    message.unknownVlan2 = object.unknownVlan2 ?? 0;
    message.unknownVlan3 = object.unknownVlan3 ?? 0;
    message.unknownVlan4 = object.unknownVlan4 ?? 0;
    message.unknownVlan5 = object.unknownVlan5 ?? 0;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    message.hasAdditionalUnknownVlans = object.hasAdditionalUnknownVlans ?? false;
    return message;
  },
};

function createBaseMultisiteLink(): MultisiteLink {
  return { id: undefined };
}

export const MultisiteLink: MessageFns<MultisiteLink> = {
  encode(message: MultisiteLink, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultisiteLink {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultisiteLink();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MultisiteLink {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: MultisiteLink): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MultisiteLink>, I>>(base?: I): MultisiteLink {
    return MultisiteLink.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultisiteLink>, I>>(object: I): MultisiteLink {
    const message = createBaseMultisiteLink();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseTwampSession(): TwampSession {
  return {
    id: undefined,
    localIp: "",
    state: 0,
    lastProbe: undefined,
    lastProbeRttUs: 0,
    medianRttUs: 0,
    stdDevRttUs: 0,
    discoveredPathMtu: 0,
    mtuDiscoveryReason: 0,
    consecutiveRttDeviations: 0,
    minRttUs: 0,
    maxRttUs: 0,
  };
}

export const TwampSession: MessageFns<TwampSession> = {
  encode(message: TwampSession, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.localIp !== "") {
      writer.uint32(26).string(message.localIp);
    }
    if (message.state !== 0) {
      writer.uint32(32).int32(message.state);
    }
    if (message.lastProbe !== undefined) {
      Timestamp.encode(toTimestamp(message.lastProbe), writer.uint32(42).fork()).join();
    }
    if (message.lastProbeRttUs !== 0) {
      writer.uint32(48).uint32(message.lastProbeRttUs);
    }
    if (message.medianRttUs !== 0) {
      writer.uint32(56).uint32(message.medianRttUs);
    }
    if (message.stdDevRttUs !== 0) {
      writer.uint32(64).uint32(message.stdDevRttUs);
    }
    if (message.discoveredPathMtu !== 0) {
      writer.uint32(72).int32(message.discoveredPathMtu);
    }
    if (message.mtuDiscoveryReason !== 0) {
      writer.uint32(80).int32(message.mtuDiscoveryReason);
    }
    if (message.consecutiveRttDeviations !== 0) {
      writer.uint32(88).int32(message.consecutiveRttDeviations);
    }
    if (message.minRttUs !== 0) {
      writer.uint32(96).uint32(message.minRttUs);
    }
    if (message.maxRttUs !== 0) {
      writer.uint32(104).uint32(message.maxRttUs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TwampSession {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTwampSession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.localIp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.lastProbe = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.lastProbeRttUs = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.medianRttUs = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.stdDevRttUs = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.discoveredPathMtu = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.mtuDiscoveryReason = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.consecutiveRttDeviations = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.minRttUs = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.maxRttUs = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TwampSession {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      localIp: isSet(object.localIp) ? globalThis.String(object.localIp) : "",
      state: isSet(object.state) ? twampSessionStateFromJSON(object.state) : 0,
      lastProbe: isSet(object.lastProbe) ? fromJsonTimestamp(object.lastProbe) : undefined,
      lastProbeRttUs: isSet(object.lastProbeRttUs) ? globalThis.Number(object.lastProbeRttUs) : 0,
      medianRttUs: isSet(object.medianRttUs) ? globalThis.Number(object.medianRttUs) : 0,
      stdDevRttUs: isSet(object.stdDevRttUs) ? globalThis.Number(object.stdDevRttUs) : 0,
      discoveredPathMtu: isSet(object.discoveredPathMtu) ? globalThis.Number(object.discoveredPathMtu) : 0,
      mtuDiscoveryReason: isSet(object.mtuDiscoveryReason)
        ? twampPathMtuDiscoveryReasonFromJSON(object.mtuDiscoveryReason)
        : 0,
      consecutiveRttDeviations: isSet(object.consecutiveRttDeviations)
        ? globalThis.Number(object.consecutiveRttDeviations)
        : 0,
      minRttUs: isSet(object.minRttUs) ? globalThis.Number(object.minRttUs) : 0,
      maxRttUs: isSet(object.maxRttUs) ? globalThis.Number(object.maxRttUs) : 0,
    };
  },

  toJSON(message: TwampSession): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.localIp !== "") {
      obj.localIp = message.localIp;
    }
    if (message.state !== 0) {
      obj.state = twampSessionStateToJSON(message.state);
    }
    if (message.lastProbe !== undefined) {
      obj.lastProbe = message.lastProbe.toISOString();
    }
    if (message.lastProbeRttUs !== 0) {
      obj.lastProbeRttUs = Math.round(message.lastProbeRttUs);
    }
    if (message.medianRttUs !== 0) {
      obj.medianRttUs = Math.round(message.medianRttUs);
    }
    if (message.stdDevRttUs !== 0) {
      obj.stdDevRttUs = Math.round(message.stdDevRttUs);
    }
    if (message.discoveredPathMtu !== 0) {
      obj.discoveredPathMtu = Math.round(message.discoveredPathMtu);
    }
    if (message.mtuDiscoveryReason !== 0) {
      obj.mtuDiscoveryReason = twampPathMtuDiscoveryReasonToJSON(message.mtuDiscoveryReason);
    }
    if (message.consecutiveRttDeviations !== 0) {
      obj.consecutiveRttDeviations = Math.round(message.consecutiveRttDeviations);
    }
    if (message.minRttUs !== 0) {
      obj.minRttUs = Math.round(message.minRttUs);
    }
    if (message.maxRttUs !== 0) {
      obj.maxRttUs = Math.round(message.maxRttUs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TwampSession>, I>>(base?: I): TwampSession {
    return TwampSession.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TwampSession>, I>>(object: I): TwampSession {
    const message = createBaseTwampSession();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.localIp = object.localIp ?? "";
    message.state = object.state ?? 0;
    message.lastProbe = object.lastProbe ?? undefined;
    message.lastProbeRttUs = object.lastProbeRttUs ?? 0;
    message.medianRttUs = object.medianRttUs ?? 0;
    message.stdDevRttUs = object.stdDevRttUs ?? 0;
    message.discoveredPathMtu = object.discoveredPathMtu ?? 0;
    message.mtuDiscoveryReason = object.mtuDiscoveryReason ?? 0;
    message.consecutiveRttDeviations = object.consecutiveRttDeviations ?? 0;
    message.minRttUs = object.minRttUs ?? 0;
    message.maxRttUs = object.maxRttUs ?? 0;
    return message;
  },
};

function createBaseAssertConfigMultisiteLinkUpData(): AssertConfigMultisiteLinkUpData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    orgId: "",
    fabricId: "",
    severity: 0,
    groupShortName: "",
    deviceType: 0,
    bgpPeerId: "",
    bgpPeerName: "",
    multisiteName: "",
    multisiteId: "",
    localMultisiteLinkIp: "",
    localBgpPeerId: "",
  };
}

export const AssertConfigMultisiteLinkUpData: MessageFns<AssertConfigMultisiteLinkUpData> = {
  encode(message: AssertConfigMultisiteLinkUpData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(50).string(message.fabricId);
    }
    if (message.severity !== 0) {
      writer.uint32(56).int32(message.severity);
    }
    if (message.groupShortName !== "") {
      writer.uint32(66).string(message.groupShortName);
    }
    if (message.deviceType !== 0) {
      writer.uint32(72).int32(message.deviceType);
    }
    if (message.bgpPeerId !== "") {
      writer.uint32(82).string(message.bgpPeerId);
    }
    if (message.bgpPeerName !== "") {
      writer.uint32(90).string(message.bgpPeerName);
    }
    if (message.multisiteName !== "") {
      writer.uint32(98).string(message.multisiteName);
    }
    if (message.multisiteId !== "") {
      writer.uint32(106).string(message.multisiteId);
    }
    if (message.localMultisiteLinkIp !== "") {
      writer.uint32(114).string(message.localMultisiteLinkIp);
    }
    if (message.localBgpPeerId !== "") {
      writer.uint32(122).string(message.localBgpPeerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigMultisiteLinkUpData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigMultisiteLinkUpData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.bgpPeerId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.bgpPeerName = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.multisiteName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.multisiteId = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.localMultisiteLinkIp = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.localBgpPeerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigMultisiteLinkUpData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
      bgpPeerId: isSet(object.bgpPeerId) ? globalThis.String(object.bgpPeerId) : "",
      bgpPeerName: isSet(object.bgpPeerName) ? globalThis.String(object.bgpPeerName) : "",
      multisiteName: isSet(object.multisiteName) ? globalThis.String(object.multisiteName) : "",
      multisiteId: isSet(object.multisiteId) ? globalThis.String(object.multisiteId) : "",
      localMultisiteLinkIp: isSet(object.localMultisiteLinkIp) ? globalThis.String(object.localMultisiteLinkIp) : "",
      localBgpPeerId: isSet(object.localBgpPeerId) ? globalThis.String(object.localBgpPeerId) : "",
    };
  },

  toJSON(message: AssertConfigMultisiteLinkUpData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    if (message.bgpPeerId !== "") {
      obj.bgpPeerId = message.bgpPeerId;
    }
    if (message.bgpPeerName !== "") {
      obj.bgpPeerName = message.bgpPeerName;
    }
    if (message.multisiteName !== "") {
      obj.multisiteName = message.multisiteName;
    }
    if (message.multisiteId !== "") {
      obj.multisiteId = message.multisiteId;
    }
    if (message.localMultisiteLinkIp !== "") {
      obj.localMultisiteLinkIp = message.localMultisiteLinkIp;
    }
    if (message.localBgpPeerId !== "") {
      obj.localBgpPeerId = message.localBgpPeerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigMultisiteLinkUpData>, I>>(base?: I): AssertConfigMultisiteLinkUpData {
    return AssertConfigMultisiteLinkUpData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigMultisiteLinkUpData>, I>>(
    object: I,
  ): AssertConfigMultisiteLinkUpData {
    const message = createBaseAssertConfigMultisiteLinkUpData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.severity = object.severity ?? 0;
    message.groupShortName = object.groupShortName ?? "";
    message.deviceType = object.deviceType ?? 0;
    message.bgpPeerId = object.bgpPeerId ?? "";
    message.bgpPeerName = object.bgpPeerName ?? "";
    message.multisiteName = object.multisiteName ?? "";
    message.multisiteId = object.multisiteId ?? "";
    message.localMultisiteLinkIp = object.localMultisiteLinkIp ?? "";
    message.localBgpPeerId = object.localBgpPeerId ?? "";
    return message;
  },
};

function createBaseAssertConfigMultisiteLinkUp(): AssertConfigMultisiteLinkUp {
  return { id: undefined, config: undefined };
}

export const AssertConfigMultisiteLinkUp: MessageFns<AssertConfigMultisiteLinkUp> = {
  encode(message: AssertConfigMultisiteLinkUp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigMultisiteLinkUpData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigMultisiteLinkUp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigMultisiteLinkUp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigMultisiteLinkUpData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigMultisiteLinkUp {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigMultisiteLinkUpData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigMultisiteLinkUp): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigMultisiteLinkUpData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigMultisiteLinkUp>, I>>(base?: I): AssertConfigMultisiteLinkUp {
    return AssertConfigMultisiteLinkUp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigMultisiteLinkUp>, I>>(object: I): AssertConfigMultisiteLinkUp {
    const message = createBaseAssertConfigMultisiteLinkUp();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigMultisiteLinkUpData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertMultisiteLinkUp(): AssertMultisiteLinkUp {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertMultisiteLinkUp: MessageFns<AssertMultisiteLinkUp> = {
  encode(message: AssertMultisiteLinkUp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigMultisiteLinkUpData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertMultisiteLinkUp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertMultisiteLinkUp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigMultisiteLinkUpData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertMultisiteLinkUp {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigMultisiteLinkUpData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertMultisiteLinkUp): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigMultisiteLinkUpData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertMultisiteLinkUp>, I>>(base?: I): AssertMultisiteLinkUp {
    return AssertMultisiteLinkUp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertMultisiteLinkUp>, I>>(object: I): AssertMultisiteLinkUp {
    const message = createBaseAssertMultisiteLinkUp();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigMultisiteLinkUpData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseAssertConfigMultisiteLatencyStableData(): AssertConfigMultisiteLatencyStableData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    orgId: "",
    fabricId: "",
    severity: 0,
    groupShortName: "",
    deviceType: 0,
    bgpPeerId: "",
    bgpPeerName: "",
    multisiteName: "",
    multisiteId: "",
    localMultisiteLinkIp: "",
    localBgpPeerId: "",
  };
}

export const AssertConfigMultisiteLatencyStableData: MessageFns<AssertConfigMultisiteLatencyStableData> = {
  encode(message: AssertConfigMultisiteLatencyStableData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(50).string(message.fabricId);
    }
    if (message.severity !== 0) {
      writer.uint32(56).int32(message.severity);
    }
    if (message.groupShortName !== "") {
      writer.uint32(66).string(message.groupShortName);
    }
    if (message.deviceType !== 0) {
      writer.uint32(72).int32(message.deviceType);
    }
    if (message.bgpPeerId !== "") {
      writer.uint32(82).string(message.bgpPeerId);
    }
    if (message.bgpPeerName !== "") {
      writer.uint32(90).string(message.bgpPeerName);
    }
    if (message.multisiteName !== "") {
      writer.uint32(98).string(message.multisiteName);
    }
    if (message.multisiteId !== "") {
      writer.uint32(106).string(message.multisiteId);
    }
    if (message.localMultisiteLinkIp !== "") {
      writer.uint32(114).string(message.localMultisiteLinkIp);
    }
    if (message.localBgpPeerId !== "") {
      writer.uint32(122).string(message.localBgpPeerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigMultisiteLatencyStableData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigMultisiteLatencyStableData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.bgpPeerId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.bgpPeerName = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.multisiteName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.multisiteId = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.localMultisiteLinkIp = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.localBgpPeerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigMultisiteLatencyStableData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
      bgpPeerId: isSet(object.bgpPeerId) ? globalThis.String(object.bgpPeerId) : "",
      bgpPeerName: isSet(object.bgpPeerName) ? globalThis.String(object.bgpPeerName) : "",
      multisiteName: isSet(object.multisiteName) ? globalThis.String(object.multisiteName) : "",
      multisiteId: isSet(object.multisiteId) ? globalThis.String(object.multisiteId) : "",
      localMultisiteLinkIp: isSet(object.localMultisiteLinkIp) ? globalThis.String(object.localMultisiteLinkIp) : "",
      localBgpPeerId: isSet(object.localBgpPeerId) ? globalThis.String(object.localBgpPeerId) : "",
    };
  },

  toJSON(message: AssertConfigMultisiteLatencyStableData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    if (message.bgpPeerId !== "") {
      obj.bgpPeerId = message.bgpPeerId;
    }
    if (message.bgpPeerName !== "") {
      obj.bgpPeerName = message.bgpPeerName;
    }
    if (message.multisiteName !== "") {
      obj.multisiteName = message.multisiteName;
    }
    if (message.multisiteId !== "") {
      obj.multisiteId = message.multisiteId;
    }
    if (message.localMultisiteLinkIp !== "") {
      obj.localMultisiteLinkIp = message.localMultisiteLinkIp;
    }
    if (message.localBgpPeerId !== "") {
      obj.localBgpPeerId = message.localBgpPeerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigMultisiteLatencyStableData>, I>>(
    base?: I,
  ): AssertConfigMultisiteLatencyStableData {
    return AssertConfigMultisiteLatencyStableData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigMultisiteLatencyStableData>, I>>(
    object: I,
  ): AssertConfigMultisiteLatencyStableData {
    const message = createBaseAssertConfigMultisiteLatencyStableData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.severity = object.severity ?? 0;
    message.groupShortName = object.groupShortName ?? "";
    message.deviceType = object.deviceType ?? 0;
    message.bgpPeerId = object.bgpPeerId ?? "";
    message.bgpPeerName = object.bgpPeerName ?? "";
    message.multisiteName = object.multisiteName ?? "";
    message.multisiteId = object.multisiteId ?? "";
    message.localMultisiteLinkIp = object.localMultisiteLinkIp ?? "";
    message.localBgpPeerId = object.localBgpPeerId ?? "";
    return message;
  },
};

function createBaseAssertConfigMultisiteLatencyStable(): AssertConfigMultisiteLatencyStable {
  return { id: undefined, config: undefined };
}

export const AssertConfigMultisiteLatencyStable: MessageFns<AssertConfigMultisiteLatencyStable> = {
  encode(message: AssertConfigMultisiteLatencyStable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigMultisiteLatencyStableData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigMultisiteLatencyStable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigMultisiteLatencyStable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigMultisiteLatencyStableData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigMultisiteLatencyStable {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigMultisiteLatencyStableData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigMultisiteLatencyStable): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigMultisiteLatencyStableData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigMultisiteLatencyStable>, I>>(
    base?: I,
  ): AssertConfigMultisiteLatencyStable {
    return AssertConfigMultisiteLatencyStable.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigMultisiteLatencyStable>, I>>(
    object: I,
  ): AssertConfigMultisiteLatencyStable {
    const message = createBaseAssertConfigMultisiteLatencyStable();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigMultisiteLatencyStableData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertMultisiteLatencyStable(): AssertMultisiteLatencyStable {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
    medianRttUs: 0,
    lastRttUs: 0,
    minRttUs: 0,
    maxRttUs: 0,
  };
}

export const AssertMultisiteLatencyStable: MessageFns<AssertMultisiteLatencyStable> = {
  encode(message: AssertMultisiteLatencyStable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigMultisiteLatencyStableData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    if (message.medianRttUs !== 0) {
      writer.uint32(88).uint32(message.medianRttUs);
    }
    if (message.lastRttUs !== 0) {
      writer.uint32(96).uint32(message.lastRttUs);
    }
    if (message.minRttUs !== 0) {
      writer.uint32(104).uint32(message.minRttUs);
    }
    if (message.maxRttUs !== 0) {
      writer.uint32(112).uint32(message.maxRttUs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertMultisiteLatencyStable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertMultisiteLatencyStable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigMultisiteLatencyStableData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.medianRttUs = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.lastRttUs = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.minRttUs = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.maxRttUs = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertMultisiteLatencyStable {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigMultisiteLatencyStableData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
      medianRttUs: isSet(object.medianRttUs) ? globalThis.Number(object.medianRttUs) : 0,
      lastRttUs: isSet(object.lastRttUs) ? globalThis.Number(object.lastRttUs) : 0,
      minRttUs: isSet(object.minRttUs) ? globalThis.Number(object.minRttUs) : 0,
      maxRttUs: isSet(object.maxRttUs) ? globalThis.Number(object.maxRttUs) : 0,
    };
  },

  toJSON(message: AssertMultisiteLatencyStable): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigMultisiteLatencyStableData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    if (message.medianRttUs !== 0) {
      obj.medianRttUs = Math.round(message.medianRttUs);
    }
    if (message.lastRttUs !== 0) {
      obj.lastRttUs = Math.round(message.lastRttUs);
    }
    if (message.minRttUs !== 0) {
      obj.minRttUs = Math.round(message.minRttUs);
    }
    if (message.maxRttUs !== 0) {
      obj.maxRttUs = Math.round(message.maxRttUs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertMultisiteLatencyStable>, I>>(base?: I): AssertMultisiteLatencyStable {
    return AssertMultisiteLatencyStable.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertMultisiteLatencyStable>, I>>(object: I): AssertMultisiteLatencyStable {
    const message = createBaseAssertMultisiteLatencyStable();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigMultisiteLatencyStableData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    message.medianRttUs = object.medianRttUs ?? 0;
    message.lastRttUs = object.lastRttUs ?? 0;
    message.minRttUs = object.minRttUs ?? 0;
    message.maxRttUs = object.maxRttUs ?? 0;
    return message;
  },
};

function createBaseAssertConfigMultisiteExpectedMtuData(): AssertConfigMultisiteExpectedMtuData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    orgId: "",
    fabricId: "",
    severity: 0,
    groupShortName: "",
    deviceType: 0,
    expectedMtu: 0,
    bgpPeerId: "",
    bgpPeerName: "",
    multisiteName: "",
    multisiteId: "",
    localMultisiteLinkIp: "",
    localBgpPeerId: "",
  };
}

export const AssertConfigMultisiteExpectedMtuData: MessageFns<AssertConfigMultisiteExpectedMtuData> = {
  encode(message: AssertConfigMultisiteExpectedMtuData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(50).string(message.fabricId);
    }
    if (message.severity !== 0) {
      writer.uint32(56).int32(message.severity);
    }
    if (message.groupShortName !== "") {
      writer.uint32(66).string(message.groupShortName);
    }
    if (message.deviceType !== 0) {
      writer.uint32(72).int32(message.deviceType);
    }
    if (message.expectedMtu !== 0) {
      writer.uint32(80).uint32(message.expectedMtu);
    }
    if (message.bgpPeerId !== "") {
      writer.uint32(90).string(message.bgpPeerId);
    }
    if (message.bgpPeerName !== "") {
      writer.uint32(98).string(message.bgpPeerName);
    }
    if (message.multisiteName !== "") {
      writer.uint32(106).string(message.multisiteName);
    }
    if (message.multisiteId !== "") {
      writer.uint32(114).string(message.multisiteId);
    }
    if (message.localMultisiteLinkIp !== "") {
      writer.uint32(122).string(message.localMultisiteLinkIp);
    }
    if (message.localBgpPeerId !== "") {
      writer.uint32(130).string(message.localBgpPeerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigMultisiteExpectedMtuData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigMultisiteExpectedMtuData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.expectedMtu = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.bgpPeerId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.bgpPeerName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.multisiteName = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.multisiteId = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.localMultisiteLinkIp = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.localBgpPeerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigMultisiteExpectedMtuData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
      expectedMtu: isSet(object.expectedMtu) ? globalThis.Number(object.expectedMtu) : 0,
      bgpPeerId: isSet(object.bgpPeerId) ? globalThis.String(object.bgpPeerId) : "",
      bgpPeerName: isSet(object.bgpPeerName) ? globalThis.String(object.bgpPeerName) : "",
      multisiteName: isSet(object.multisiteName) ? globalThis.String(object.multisiteName) : "",
      multisiteId: isSet(object.multisiteId) ? globalThis.String(object.multisiteId) : "",
      localMultisiteLinkIp: isSet(object.localMultisiteLinkIp) ? globalThis.String(object.localMultisiteLinkIp) : "",
      localBgpPeerId: isSet(object.localBgpPeerId) ? globalThis.String(object.localBgpPeerId) : "",
    };
  },

  toJSON(message: AssertConfigMultisiteExpectedMtuData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    if (message.expectedMtu !== 0) {
      obj.expectedMtu = Math.round(message.expectedMtu);
    }
    if (message.bgpPeerId !== "") {
      obj.bgpPeerId = message.bgpPeerId;
    }
    if (message.bgpPeerName !== "") {
      obj.bgpPeerName = message.bgpPeerName;
    }
    if (message.multisiteName !== "") {
      obj.multisiteName = message.multisiteName;
    }
    if (message.multisiteId !== "") {
      obj.multisiteId = message.multisiteId;
    }
    if (message.localMultisiteLinkIp !== "") {
      obj.localMultisiteLinkIp = message.localMultisiteLinkIp;
    }
    if (message.localBgpPeerId !== "") {
      obj.localBgpPeerId = message.localBgpPeerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigMultisiteExpectedMtuData>, I>>(
    base?: I,
  ): AssertConfigMultisiteExpectedMtuData {
    return AssertConfigMultisiteExpectedMtuData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigMultisiteExpectedMtuData>, I>>(
    object: I,
  ): AssertConfigMultisiteExpectedMtuData {
    const message = createBaseAssertConfigMultisiteExpectedMtuData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.severity = object.severity ?? 0;
    message.groupShortName = object.groupShortName ?? "";
    message.deviceType = object.deviceType ?? 0;
    message.expectedMtu = object.expectedMtu ?? 0;
    message.bgpPeerId = object.bgpPeerId ?? "";
    message.bgpPeerName = object.bgpPeerName ?? "";
    message.multisiteName = object.multisiteName ?? "";
    message.multisiteId = object.multisiteId ?? "";
    message.localMultisiteLinkIp = object.localMultisiteLinkIp ?? "";
    message.localBgpPeerId = object.localBgpPeerId ?? "";
    return message;
  },
};

function createBaseAssertConfigMultisiteExpectedMtu(): AssertConfigMultisiteExpectedMtu {
  return { id: undefined, config: undefined };
}

export const AssertConfigMultisiteExpectedMtu: MessageFns<AssertConfigMultisiteExpectedMtu> = {
  encode(message: AssertConfigMultisiteExpectedMtu, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigMultisiteExpectedMtuData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigMultisiteExpectedMtu {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigMultisiteExpectedMtu();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigMultisiteExpectedMtuData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigMultisiteExpectedMtu {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigMultisiteExpectedMtuData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigMultisiteExpectedMtu): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigMultisiteExpectedMtuData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigMultisiteExpectedMtu>, I>>(
    base?: I,
  ): AssertConfigMultisiteExpectedMtu {
    return AssertConfigMultisiteExpectedMtu.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigMultisiteExpectedMtu>, I>>(
    object: I,
  ): AssertConfigMultisiteExpectedMtu {
    const message = createBaseAssertConfigMultisiteExpectedMtu();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigMultisiteExpectedMtuData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertMultisiteExpectedMtu(): AssertMultisiteExpectedMtu {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
    discoveredMtu: 0,
  };
}

export const AssertMultisiteExpectedMtu: MessageFns<AssertMultisiteExpectedMtu> = {
  encode(message: AssertMultisiteExpectedMtu, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigMultisiteExpectedMtuData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.masked !== false) {
      writer.uint32(56).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(66).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(72).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(80).bool(message.maskedByConnectionToCloud);
    }
    if (message.discoveredMtu !== 0) {
      writer.uint32(88).uint32(message.discoveredMtu);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertMultisiteExpectedMtu {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertMultisiteExpectedMtu();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigMultisiteExpectedMtuData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.discoveredMtu = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertMultisiteExpectedMtu {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigMultisiteExpectedMtuData.fromJSON(object.config) : undefined,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
      discoveredMtu: isSet(object.discoveredMtu) ? globalThis.Number(object.discoveredMtu) : 0,
    };
  },

  toJSON(message: AssertMultisiteExpectedMtu): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigMultisiteExpectedMtuData.toJSON(message.config);
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    if (message.discoveredMtu !== 0) {
      obj.discoveredMtu = Math.round(message.discoveredMtu);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertMultisiteExpectedMtu>, I>>(base?: I): AssertMultisiteExpectedMtu {
    return AssertMultisiteExpectedMtu.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertMultisiteExpectedMtu>, I>>(object: I): AssertMultisiteExpectedMtu {
    const message = createBaseAssertMultisiteExpectedMtu();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigMultisiteExpectedMtuData.fromPartial(object.config)
      : undefined;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    message.discoveredMtu = object.discoveredMtu ?? 0;
    return message;
  },
};

function createBaseAssertConfigNxosDeviceExpectedFeaturesData(): AssertConfigNxosDeviceExpectedFeaturesData {
  return {
    generationId: "0",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    orgId: "",
    fabricId: "",
    groupShortName: "",
    severity: 0,
    deviceType: 0,
  };
}

export const AssertConfigNxosDeviceExpectedFeaturesData: MessageFns<AssertConfigNxosDeviceExpectedFeaturesData> = {
  encode(message: AssertConfigNxosDeviceExpectedFeaturesData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generationId !== "0") {
      writer.uint32(8).int64(message.generationId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(18).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(24).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(32).bool(message.implicit);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(50).string(message.fabricId);
    }
    if (message.groupShortName !== "") {
      writer.uint32(58).string(message.groupShortName);
    }
    if (message.severity !== 0) {
      writer.uint32(64).int32(message.severity);
    }
    if (message.deviceType !== 0) {
      writer.uint32(72).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigNxosDeviceExpectedFeaturesData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigNxosDeviceExpectedFeaturesData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.generationId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigNxosDeviceExpectedFeaturesData {
    return {
      generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "0",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      severity: isSet(object.severity) ? assertSeverityTypeFromJSON(object.severity) : 0,
      deviceType: isSet(object.deviceType) ? assertDeviceTypeFromJSON(object.deviceType) : 0,
    };
  },

  toJSON(message: AssertConfigNxosDeviceExpectedFeaturesData): unknown {
    const obj: any = {};
    if (message.generationId !== "0") {
      obj.generationId = message.generationId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.severity !== 0) {
      obj.severity = assertSeverityTypeToJSON(message.severity);
    }
    if (message.deviceType !== 0) {
      obj.deviceType = assertDeviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigNxosDeviceExpectedFeaturesData>, I>>(
    base?: I,
  ): AssertConfigNxosDeviceExpectedFeaturesData {
    return AssertConfigNxosDeviceExpectedFeaturesData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigNxosDeviceExpectedFeaturesData>, I>>(
    object: I,
  ): AssertConfigNxosDeviceExpectedFeaturesData {
    const message = createBaseAssertConfigNxosDeviceExpectedFeaturesData();
    message.generationId = object.generationId ?? "0";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.severity = object.severity ?? 0;
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseAssertConfigNxosDeviceExpectedFeatures(): AssertConfigNxosDeviceExpectedFeatures {
  return { id: undefined, config: undefined };
}

export const AssertConfigNxosDeviceExpectedFeatures: MessageFns<AssertConfigNxosDeviceExpectedFeatures> = {
  encode(message: AssertConfigNxosDeviceExpectedFeatures, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigNxosDeviceExpectedFeaturesData.encode(message.config, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertConfigNxosDeviceExpectedFeatures {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertConfigNxosDeviceExpectedFeatures();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = AssertConfigNxosDeviceExpectedFeaturesData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertConfigNxosDeviceExpectedFeatures {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      config: isSet(object.config) ? AssertConfigNxosDeviceExpectedFeaturesData.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: AssertConfigNxosDeviceExpectedFeatures): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigNxosDeviceExpectedFeaturesData.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertConfigNxosDeviceExpectedFeatures>, I>>(
    base?: I,
  ): AssertConfigNxosDeviceExpectedFeatures {
    return AssertConfigNxosDeviceExpectedFeatures.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertConfigNxosDeviceExpectedFeatures>, I>>(
    object: I,
  ): AssertConfigNxosDeviceExpectedFeatures {
    const message = createBaseAssertConfigNxosDeviceExpectedFeatures();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigNxosDeviceExpectedFeaturesData.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAssertNxosDeviceExpectedFeatures(): AssertNxosDeviceExpectedFeatures {
  return {
    id: undefined,
    category: 0,
    assertState: 0,
    modifiedAt: undefined,
    config: undefined,
    grpcEnabled: false,
    lldpEnabled: false,
    masked: false,
    readyToLatchAt: undefined,
    maskedByPortLinkUp: false,
    maskedByConnectionToCloud: false,
  };
}

export const AssertNxosDeviceExpectedFeatures: MessageFns<AssertNxosDeviceExpectedFeatures> = {
  encode(message: AssertNxosDeviceExpectedFeatures, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(42).fork()).join();
    }
    if (message.config !== undefined) {
      AssertConfigNxosDeviceExpectedFeaturesData.encode(message.config, writer.uint32(50).fork()).join();
    }
    if (message.grpcEnabled !== false) {
      writer.uint32(56).bool(message.grpcEnabled);
    }
    if (message.lldpEnabled !== false) {
      writer.uint32(64).bool(message.lldpEnabled);
    }
    if (message.masked !== false) {
      writer.uint32(72).bool(message.masked);
    }
    if (message.readyToLatchAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyToLatchAt), writer.uint32(82).fork()).join();
    }
    if (message.maskedByPortLinkUp !== false) {
      writer.uint32(88).bool(message.maskedByPortLinkUp);
    }
    if (message.maskedByConnectionToCloud !== false) {
      writer.uint32(96).bool(message.maskedByConnectionToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertNxosDeviceExpectedFeatures {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertNxosDeviceExpectedFeatures();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = AssertConfigNxosDeviceExpectedFeaturesData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.grpcEnabled = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.lldpEnabled = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.readyToLatchAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.maskedByPortLinkUp = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.maskedByConnectionToCloud = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertNxosDeviceExpectedFeatures {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      config: isSet(object.config) ? AssertConfigNxosDeviceExpectedFeaturesData.fromJSON(object.config) : undefined,
      grpcEnabled: isSet(object.grpcEnabled) ? globalThis.Boolean(object.grpcEnabled) : false,
      lldpEnabled: isSet(object.lldpEnabled) ? globalThis.Boolean(object.lldpEnabled) : false,
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      readyToLatchAt: isSet(object.readyToLatchAt) ? fromJsonTimestamp(object.readyToLatchAt) : undefined,
      maskedByPortLinkUp: isSet(object.maskedByPortLinkUp) ? globalThis.Boolean(object.maskedByPortLinkUp) : false,
      maskedByConnectionToCloud: isSet(object.maskedByConnectionToCloud)
        ? globalThis.Boolean(object.maskedByConnectionToCloud)
        : false,
    };
  },

  toJSON(message: AssertNxosDeviceExpectedFeatures): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.config !== undefined) {
      obj.config = AssertConfigNxosDeviceExpectedFeaturesData.toJSON(message.config);
    }
    if (message.grpcEnabled !== false) {
      obj.grpcEnabled = message.grpcEnabled;
    }
    if (message.lldpEnabled !== false) {
      obj.lldpEnabled = message.lldpEnabled;
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.readyToLatchAt !== undefined) {
      obj.readyToLatchAt = message.readyToLatchAt.toISOString();
    }
    if (message.maskedByPortLinkUp !== false) {
      obj.maskedByPortLinkUp = message.maskedByPortLinkUp;
    }
    if (message.maskedByConnectionToCloud !== false) {
      obj.maskedByConnectionToCloud = message.maskedByConnectionToCloud;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertNxosDeviceExpectedFeatures>, I>>(
    base?: I,
  ): AssertNxosDeviceExpectedFeatures {
    return AssertNxosDeviceExpectedFeatures.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertNxosDeviceExpectedFeatures>, I>>(
    object: I,
  ): AssertNxosDeviceExpectedFeatures {
    const message = createBaseAssertNxosDeviceExpectedFeatures();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? AssertConfigNxosDeviceExpectedFeaturesData.fromPartial(object.config)
      : undefined;
    message.grpcEnabled = object.grpcEnabled ?? false;
    message.lldpEnabled = object.lldpEnabled ?? false;
    message.masked = object.masked ?? false;
    message.readyToLatchAt = object.readyToLatchAt ?? undefined;
    message.maskedByPortLinkUp = object.maskedByPortLinkUp ?? false;
    message.maskedByConnectionToCloud = object.maskedByConnectionToCloud ?? false;
    return message;
  },
};

function createBaseSonicConfig(): SonicConfig {
  return { ipv4Addr: "", ipv6Addr: "", ipv4Gateway: "", ipv6Gateway: "", hostname: "" };
}

export const SonicConfig: MessageFns<SonicConfig> = {
  encode(message: SonicConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ipv4Addr !== "") {
      writer.uint32(18).string(message.ipv4Addr);
    }
    if (message.ipv6Addr !== "") {
      writer.uint32(26).string(message.ipv6Addr);
    }
    if (message.ipv4Gateway !== "") {
      writer.uint32(34).string(message.ipv4Gateway);
    }
    if (message.ipv6Gateway !== "") {
      writer.uint32(42).string(message.ipv6Gateway);
    }
    if (message.hostname !== "") {
      writer.uint32(50).string(message.hostname);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SonicConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSonicConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ipv4Addr = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ipv6Addr = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ipv4Gateway = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ipv6Gateway = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.hostname = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SonicConfig {
    return {
      ipv4Addr: isSet(object.ipv4Addr) ? globalThis.String(object.ipv4Addr) : "",
      ipv6Addr: isSet(object.ipv6Addr) ? globalThis.String(object.ipv6Addr) : "",
      ipv4Gateway: isSet(object.ipv4Gateway) ? globalThis.String(object.ipv4Gateway) : "",
      ipv6Gateway: isSet(object.ipv6Gateway) ? globalThis.String(object.ipv6Gateway) : "",
      hostname: isSet(object.hostname) ? globalThis.String(object.hostname) : "",
    };
  },

  toJSON(message: SonicConfig): unknown {
    const obj: any = {};
    if (message.ipv4Addr !== "") {
      obj.ipv4Addr = message.ipv4Addr;
    }
    if (message.ipv6Addr !== "") {
      obj.ipv6Addr = message.ipv6Addr;
    }
    if (message.ipv4Gateway !== "") {
      obj.ipv4Gateway = message.ipv4Gateway;
    }
    if (message.ipv6Gateway !== "") {
      obj.ipv6Gateway = message.ipv6Gateway;
    }
    if (message.hostname !== "") {
      obj.hostname = message.hostname;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SonicConfig>, I>>(base?: I): SonicConfig {
    return SonicConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SonicConfig>, I>>(object: I): SonicConfig {
    const message = createBaseSonicConfig();
    message.ipv4Addr = object.ipv4Addr ?? "";
    message.ipv6Addr = object.ipv6Addr ?? "";
    message.ipv4Gateway = object.ipv4Gateway ?? "";
    message.ipv6Gateway = object.ipv6Gateway ?? "";
    message.hostname = object.hostname ?? "";
    return message;
  },
};

function createBaseProxyConfig(): ProxyConfig {
  return { httpProxy: "", httpsProxy: "", noProxy: "", user: "", pass: "" };
}

export const ProxyConfig: MessageFns<ProxyConfig> = {
  encode(message: ProxyConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.httpProxy !== "") {
      writer.uint32(18).string(message.httpProxy);
    }
    if (message.httpsProxy !== "") {
      writer.uint32(26).string(message.httpsProxy);
    }
    if (message.noProxy !== "") {
      writer.uint32(34).string(message.noProxy);
    }
    if (message.user !== "") {
      writer.uint32(42).string(message.user);
    }
    if (message.pass !== "") {
      writer.uint32(50).string(message.pass);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProxyConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProxyConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.httpProxy = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.httpsProxy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.noProxy = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.user = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.pass = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProxyConfig {
    return {
      httpProxy: isSet(object.httpProxy) ? globalThis.String(object.httpProxy) : "",
      httpsProxy: isSet(object.httpsProxy) ? globalThis.String(object.httpsProxy) : "",
      noProxy: isSet(object.noProxy) ? globalThis.String(object.noProxy) : "",
      user: isSet(object.user) ? globalThis.String(object.user) : "",
      pass: isSet(object.pass) ? globalThis.String(object.pass) : "",
    };
  },

  toJSON(message: ProxyConfig): unknown {
    const obj: any = {};
    if (message.httpProxy !== "") {
      obj.httpProxy = message.httpProxy;
    }
    if (message.httpsProxy !== "") {
      obj.httpsProxy = message.httpsProxy;
    }
    if (message.noProxy !== "") {
      obj.noProxy = message.noProxy;
    }
    if (message.user !== "") {
      obj.user = message.user;
    }
    if (message.pass !== "") {
      obj.pass = message.pass;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProxyConfig>, I>>(base?: I): ProxyConfig {
    return ProxyConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProxyConfig>, I>>(object: I): ProxyConfig {
    const message = createBaseProxyConfig();
    message.httpProxy = object.httpProxy ?? "";
    message.httpsProxy = object.httpsProxy ?? "";
    message.noProxy = object.noProxy ?? "";
    message.user = object.user ?? "";
    message.pass = object.pass ?? "";
    return message;
  },
};

function createBaseDnsConfig(): DnsConfig {
  return { dnsServers: [] };
}

export const DnsConfig: MessageFns<DnsConfig> = {
  encode(message: DnsConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.dnsServers) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DnsConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDnsConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.dnsServers.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DnsConfig {
    return {
      dnsServers: globalThis.Array.isArray(object?.dnsServers)
        ? object.dnsServers.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: DnsConfig): unknown {
    const obj: any = {};
    if (message.dnsServers?.length) {
      obj.dnsServers = message.dnsServers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DnsConfig>, I>>(base?: I): DnsConfig {
    return DnsConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DnsConfig>, I>>(object: I): DnsConfig {
    const message = createBaseDnsConfig();
    message.dnsServers = object.dnsServers?.map((e) => e) || [];
    return message;
  },
};

function createBaseDrakeConfig(): DrakeConfig {
  return { cloudBaseUrlList: [] };
}

export const DrakeConfig: MessageFns<DrakeConfig> = {
  encode(message: DrakeConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.cloudBaseUrlList) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DrakeConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDrakeConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cloudBaseUrlList.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DrakeConfig {
    return {
      cloudBaseUrlList: globalThis.Array.isArray(object?.cloudBaseUrlList)
        ? object.cloudBaseUrlList.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: DrakeConfig): unknown {
    const obj: any = {};
    if (message.cloudBaseUrlList?.length) {
      obj.cloudBaseUrlList = message.cloudBaseUrlList;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DrakeConfig>, I>>(base?: I): DrakeConfig {
    return DrakeConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DrakeConfig>, I>>(object: I): DrakeConfig {
    const message = createBaseDrakeConfig();
    message.cloudBaseUrlList = object.cloudBaseUrlList?.map((e) => e) || [];
    return message;
  },
};

function createBaseSoftwareUpdateStatus(): SoftwareUpdateStatus {
  return {
    id: undefined,
    state: 0,
    progress: 0,
    deviceDisconnectedAt: undefined,
    manifestFp: "",
    inSoftwareUpdate: false,
    fabricTag: "",
    fabricTargetTag: "",
    currentTag: "",
    desiredTag: "",
    runningPartitionStatus: 0,
    standbyPartitionStatus: 0,
    upgradeErrorCount: 0,
    lastUpgradeError: 0,
  };
}

export const SoftwareUpdateStatus: MessageFns<SoftwareUpdateStatus> = {
  encode(message: SoftwareUpdateStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.state !== 0) {
      writer.uint32(24).int32(message.state);
    }
    if (message.progress !== 0) {
      writer.uint32(32).uint32(message.progress);
    }
    if (message.deviceDisconnectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.deviceDisconnectedAt), writer.uint32(42).fork()).join();
    }
    if (message.manifestFp !== "") {
      writer.uint32(50).string(message.manifestFp);
    }
    if (message.inSoftwareUpdate !== false) {
      writer.uint32(56).bool(message.inSoftwareUpdate);
    }
    if (message.fabricTag !== "") {
      writer.uint32(66).string(message.fabricTag);
    }
    if (message.fabricTargetTag !== "") {
      writer.uint32(74).string(message.fabricTargetTag);
    }
    if (message.currentTag !== "") {
      writer.uint32(82).string(message.currentTag);
    }
    if (message.desiredTag !== "") {
      writer.uint32(90).string(message.desiredTag);
    }
    if (message.runningPartitionStatus !== 0) {
      writer.uint32(96).int32(message.runningPartitionStatus);
    }
    if (message.standbyPartitionStatus !== 0) {
      writer.uint32(104).int32(message.standbyPartitionStatus);
    }
    if (message.upgradeErrorCount !== 0) {
      writer.uint32(112).uint32(message.upgradeErrorCount);
    }
    if (message.lastUpgradeError !== 0) {
      writer.uint32(120).int32(message.lastUpgradeError);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SoftwareUpdateStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSoftwareUpdateStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.progress = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.deviceDisconnectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.manifestFp = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.inSoftwareUpdate = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.fabricTag = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricTargetTag = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.currentTag = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.desiredTag = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.runningPartitionStatus = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.standbyPartitionStatus = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.upgradeErrorCount = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.lastUpgradeError = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SoftwareUpdateStatus {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      state: isSet(object.state) ? softwareUpdateStateFromJSON(object.state) : 0,
      progress: isSet(object.progress) ? globalThis.Number(object.progress) : 0,
      deviceDisconnectedAt: isSet(object.deviceDisconnectedAt)
        ? fromJsonTimestamp(object.deviceDisconnectedAt)
        : undefined,
      manifestFp: isSet(object.manifestFp) ? globalThis.String(object.manifestFp) : "",
      inSoftwareUpdate: isSet(object.inSoftwareUpdate) ? globalThis.Boolean(object.inSoftwareUpdate) : false,
      fabricTag: isSet(object.fabricTag) ? globalThis.String(object.fabricTag) : "",
      fabricTargetTag: isSet(object.fabricTargetTag) ? globalThis.String(object.fabricTargetTag) : "",
      currentTag: isSet(object.currentTag) ? globalThis.String(object.currentTag) : "",
      desiredTag: isSet(object.desiredTag) ? globalThis.String(object.desiredTag) : "",
      runningPartitionStatus: isSet(object.runningPartitionStatus)
        ? manifestImagePartitionStatusFromJSON(object.runningPartitionStatus)
        : 0,
      standbyPartitionStatus: isSet(object.standbyPartitionStatus)
        ? manifestImagePartitionStatusFromJSON(object.standbyPartitionStatus)
        : 0,
      upgradeErrorCount: isSet(object.upgradeErrorCount) ? globalThis.Number(object.upgradeErrorCount) : 0,
      lastUpgradeError: isSet(object.lastUpgradeError)
        ? manifestImagePartitionStatusFromJSON(object.lastUpgradeError)
        : 0,
    };
  },

  toJSON(message: SoftwareUpdateStatus): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.state !== 0) {
      obj.state = softwareUpdateStateToJSON(message.state);
    }
    if (message.progress !== 0) {
      obj.progress = Math.round(message.progress);
    }
    if (message.deviceDisconnectedAt !== undefined) {
      obj.deviceDisconnectedAt = message.deviceDisconnectedAt.toISOString();
    }
    if (message.manifestFp !== "") {
      obj.manifestFp = message.manifestFp;
    }
    if (message.inSoftwareUpdate !== false) {
      obj.inSoftwareUpdate = message.inSoftwareUpdate;
    }
    if (message.fabricTag !== "") {
      obj.fabricTag = message.fabricTag;
    }
    if (message.fabricTargetTag !== "") {
      obj.fabricTargetTag = message.fabricTargetTag;
    }
    if (message.currentTag !== "") {
      obj.currentTag = message.currentTag;
    }
    if (message.desiredTag !== "") {
      obj.desiredTag = message.desiredTag;
    }
    if (message.runningPartitionStatus !== 0) {
      obj.runningPartitionStatus = manifestImagePartitionStatusToJSON(message.runningPartitionStatus);
    }
    if (message.standbyPartitionStatus !== 0) {
      obj.standbyPartitionStatus = manifestImagePartitionStatusToJSON(message.standbyPartitionStatus);
    }
    if (message.upgradeErrorCount !== 0) {
      obj.upgradeErrorCount = Math.round(message.upgradeErrorCount);
    }
    if (message.lastUpgradeError !== 0) {
      obj.lastUpgradeError = manifestImagePartitionStatusToJSON(message.lastUpgradeError);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SoftwareUpdateStatus>, I>>(base?: I): SoftwareUpdateStatus {
    return SoftwareUpdateStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SoftwareUpdateStatus>, I>>(object: I): SoftwareUpdateStatus {
    const message = createBaseSoftwareUpdateStatus();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.state = object.state ?? 0;
    message.progress = object.progress ?? 0;
    message.deviceDisconnectedAt = object.deviceDisconnectedAt ?? undefined;
    message.manifestFp = object.manifestFp ?? "";
    message.inSoftwareUpdate = object.inSoftwareUpdate ?? false;
    message.fabricTag = object.fabricTag ?? "";
    message.fabricTargetTag = object.fabricTargetTag ?? "";
    message.currentTag = object.currentTag ?? "";
    message.desiredTag = object.desiredTag ?? "";
    message.runningPartitionStatus = object.runningPartitionStatus ?? 0;
    message.standbyPartitionStatus = object.standbyPartitionStatus ?? 0;
    message.upgradeErrorCount = object.upgradeErrorCount ?? 0;
    message.lastUpgradeError = object.lastUpgradeError ?? 0;
    return message;
  },
};

function createBaseManifestRunningImageStatus(): ManifestRunningImageStatus {
  return {
    id: undefined,
    activeRunningImage: undefined,
    standByImage: undefined,
    collectedAt: undefined,
    manifestFp: "",
  };
}

export const ManifestRunningImageStatus: MessageFns<ManifestRunningImageStatus> = {
  encode(message: ManifestRunningImageStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.activeRunningImage !== undefined) {
      ManifestImageInfo.encode(message.activeRunningImage, writer.uint32(130).fork()).join();
    }
    if (message.standByImage !== undefined) {
      ManifestImageInfo.encode(message.standByImage, writer.uint32(138).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(146).fork()).join();
    }
    if (message.manifestFp !== "") {
      writer.uint32(154).string(message.manifestFp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManifestRunningImageStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManifestRunningImageStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.activeRunningImage = ManifestImageInfo.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.standByImage = ManifestImageInfo.decode(reader, reader.uint32());
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.manifestFp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManifestRunningImageStatus {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      activeRunningImage: isSet(object.activeRunningImage)
        ? ManifestImageInfo.fromJSON(object.activeRunningImage)
        : undefined,
      standByImage: isSet(object.standByImage) ? ManifestImageInfo.fromJSON(object.standByImage) : undefined,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      manifestFp: isSet(object.manifestFp) ? globalThis.String(object.manifestFp) : "",
    };
  },

  toJSON(message: ManifestRunningImageStatus): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.activeRunningImage !== undefined) {
      obj.activeRunningImage = ManifestImageInfo.toJSON(message.activeRunningImage);
    }
    if (message.standByImage !== undefined) {
      obj.standByImage = ManifestImageInfo.toJSON(message.standByImage);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.manifestFp !== "") {
      obj.manifestFp = message.manifestFp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManifestRunningImageStatus>, I>>(base?: I): ManifestRunningImageStatus {
    return ManifestRunningImageStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManifestRunningImageStatus>, I>>(object: I): ManifestRunningImageStatus {
    const message = createBaseManifestRunningImageStatus();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.activeRunningImage = (object.activeRunningImage !== undefined && object.activeRunningImage !== null)
      ? ManifestImageInfo.fromPartial(object.activeRunningImage)
      : undefined;
    message.standByImage = (object.standByImage !== undefined && object.standByImage !== null)
      ? ManifestImageInfo.fromPartial(object.standByImage)
      : undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    message.manifestFp = object.manifestFp ?? "";
    return message;
  },
};

function createBaseManifestImageInfo(): ManifestImageInfo {
  return {
    manifestIssued: undefined,
    bootloaderSha: "",
    bootloaderActualFileName: "",
    kernelSha: "",
    kernelActualFileName: "",
    monolithSha: "",
    monolithActualFileName: "",
    agentsSha: "",
    agentsActualFileName: "",
    dockerfsSha: "",
    dockerfsActualFileName: "",
    initrdSha: "",
    initrdActualFileName: "",
    partitionName: "",
    partitionStatus: 0,
    releaseTag: "",
    downloadProgress: 0,
    bootloaderCfgSha: "",
    bootloaderCfgActualFileName: "",
    nexusOsSha: "",
    nexusOsActualFileName: "",
    upgradeErrorCount: 0,
    lastUpgradeErrorStatus: 0,
  };
}

export const ManifestImageInfo: MessageFns<ManifestImageInfo> = {
  encode(message: ManifestImageInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.manifestIssued !== undefined) {
      Timestamp.encode(toTimestamp(message.manifestIssued), writer.uint32(26).fork()).join();
    }
    if (message.bootloaderSha !== "") {
      writer.uint32(34).string(message.bootloaderSha);
    }
    if (message.bootloaderActualFileName !== "") {
      writer.uint32(42).string(message.bootloaderActualFileName);
    }
    if (message.kernelSha !== "") {
      writer.uint32(50).string(message.kernelSha);
    }
    if (message.kernelActualFileName !== "") {
      writer.uint32(58).string(message.kernelActualFileName);
    }
    if (message.monolithSha !== "") {
      writer.uint32(66).string(message.monolithSha);
    }
    if (message.monolithActualFileName !== "") {
      writer.uint32(74).string(message.monolithActualFileName);
    }
    if (message.agentsSha !== "") {
      writer.uint32(82).string(message.agentsSha);
    }
    if (message.agentsActualFileName !== "") {
      writer.uint32(90).string(message.agentsActualFileName);
    }
    if (message.dockerfsSha !== "") {
      writer.uint32(98).string(message.dockerfsSha);
    }
    if (message.dockerfsActualFileName !== "") {
      writer.uint32(106).string(message.dockerfsActualFileName);
    }
    if (message.initrdSha !== "") {
      writer.uint32(114).string(message.initrdSha);
    }
    if (message.initrdActualFileName !== "") {
      writer.uint32(122).string(message.initrdActualFileName);
    }
    if (message.partitionName !== "") {
      writer.uint32(130).string(message.partitionName);
    }
    if (message.partitionStatus !== 0) {
      writer.uint32(136).int32(message.partitionStatus);
    }
    if (message.releaseTag !== "") {
      writer.uint32(146).string(message.releaseTag);
    }
    if (message.downloadProgress !== 0) {
      writer.uint32(152).uint32(message.downloadProgress);
    }
    if (message.bootloaderCfgSha !== "") {
      writer.uint32(162).string(message.bootloaderCfgSha);
    }
    if (message.bootloaderCfgActualFileName !== "") {
      writer.uint32(170).string(message.bootloaderCfgActualFileName);
    }
    if (message.nexusOsSha !== "") {
      writer.uint32(178).string(message.nexusOsSha);
    }
    if (message.nexusOsActualFileName !== "") {
      writer.uint32(186).string(message.nexusOsActualFileName);
    }
    if (message.upgradeErrorCount !== 0) {
      writer.uint32(192).uint32(message.upgradeErrorCount);
    }
    if (message.lastUpgradeErrorStatus !== 0) {
      writer.uint32(200).int32(message.lastUpgradeErrorStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManifestImageInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManifestImageInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.manifestIssued = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.bootloaderSha = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.bootloaderActualFileName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.kernelSha = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.kernelActualFileName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.monolithSha = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.monolithActualFileName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.agentsSha = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.agentsActualFileName = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.dockerfsSha = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.dockerfsActualFileName = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.initrdSha = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.initrdActualFileName = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.partitionName = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.partitionStatus = reader.int32() as any;
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.releaseTag = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.downloadProgress = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.bootloaderCfgSha = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.bootloaderCfgActualFileName = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.nexusOsSha = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.nexusOsActualFileName = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.upgradeErrorCount = reader.uint32();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.lastUpgradeErrorStatus = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManifestImageInfo {
    return {
      manifestIssued: isSet(object.manifestIssued) ? fromJsonTimestamp(object.manifestIssued) : undefined,
      bootloaderSha: isSet(object.bootloaderSha) ? globalThis.String(object.bootloaderSha) : "",
      bootloaderActualFileName: isSet(object.bootloaderActualFileName)
        ? globalThis.String(object.bootloaderActualFileName)
        : "",
      kernelSha: isSet(object.kernelSha) ? globalThis.String(object.kernelSha) : "",
      kernelActualFileName: isSet(object.kernelActualFileName) ? globalThis.String(object.kernelActualFileName) : "",
      monolithSha: isSet(object.monolithSha) ? globalThis.String(object.monolithSha) : "",
      monolithActualFileName: isSet(object.monolithActualFileName)
        ? globalThis.String(object.monolithActualFileName)
        : "",
      agentsSha: isSet(object.agentsSha) ? globalThis.String(object.agentsSha) : "",
      agentsActualFileName: isSet(object.agentsActualFileName) ? globalThis.String(object.agentsActualFileName) : "",
      dockerfsSha: isSet(object.dockerfsSha) ? globalThis.String(object.dockerfsSha) : "",
      dockerfsActualFileName: isSet(object.dockerfsActualFileName)
        ? globalThis.String(object.dockerfsActualFileName)
        : "",
      initrdSha: isSet(object.initrdSha) ? globalThis.String(object.initrdSha) : "",
      initrdActualFileName: isSet(object.initrdActualFileName) ? globalThis.String(object.initrdActualFileName) : "",
      partitionName: isSet(object.partitionName) ? globalThis.String(object.partitionName) : "",
      partitionStatus: isSet(object.partitionStatus) ? manifestImagePartitionStatusFromJSON(object.partitionStatus) : 0,
      releaseTag: isSet(object.releaseTag) ? globalThis.String(object.releaseTag) : "",
      downloadProgress: isSet(object.downloadProgress) ? globalThis.Number(object.downloadProgress) : 0,
      bootloaderCfgSha: isSet(object.bootloaderCfgSha) ? globalThis.String(object.bootloaderCfgSha) : "",
      bootloaderCfgActualFileName: isSet(object.bootloaderCfgActualFileName)
        ? globalThis.String(object.bootloaderCfgActualFileName)
        : "",
      nexusOsSha: isSet(object.nexusOsSha) ? globalThis.String(object.nexusOsSha) : "",
      nexusOsActualFileName: isSet(object.nexusOsActualFileName) ? globalThis.String(object.nexusOsActualFileName) : "",
      upgradeErrorCount: isSet(object.upgradeErrorCount) ? globalThis.Number(object.upgradeErrorCount) : 0,
      lastUpgradeErrorStatus: isSet(object.lastUpgradeErrorStatus)
        ? manifestImagePartitionStatusFromJSON(object.lastUpgradeErrorStatus)
        : 0,
    };
  },

  toJSON(message: ManifestImageInfo): unknown {
    const obj: any = {};
    if (message.manifestIssued !== undefined) {
      obj.manifestIssued = message.manifestIssued.toISOString();
    }
    if (message.bootloaderSha !== "") {
      obj.bootloaderSha = message.bootloaderSha;
    }
    if (message.bootloaderActualFileName !== "") {
      obj.bootloaderActualFileName = message.bootloaderActualFileName;
    }
    if (message.kernelSha !== "") {
      obj.kernelSha = message.kernelSha;
    }
    if (message.kernelActualFileName !== "") {
      obj.kernelActualFileName = message.kernelActualFileName;
    }
    if (message.monolithSha !== "") {
      obj.monolithSha = message.monolithSha;
    }
    if (message.monolithActualFileName !== "") {
      obj.monolithActualFileName = message.monolithActualFileName;
    }
    if (message.agentsSha !== "") {
      obj.agentsSha = message.agentsSha;
    }
    if (message.agentsActualFileName !== "") {
      obj.agentsActualFileName = message.agentsActualFileName;
    }
    if (message.dockerfsSha !== "") {
      obj.dockerfsSha = message.dockerfsSha;
    }
    if (message.dockerfsActualFileName !== "") {
      obj.dockerfsActualFileName = message.dockerfsActualFileName;
    }
    if (message.initrdSha !== "") {
      obj.initrdSha = message.initrdSha;
    }
    if (message.initrdActualFileName !== "") {
      obj.initrdActualFileName = message.initrdActualFileName;
    }
    if (message.partitionName !== "") {
      obj.partitionName = message.partitionName;
    }
    if (message.partitionStatus !== 0) {
      obj.partitionStatus = manifestImagePartitionStatusToJSON(message.partitionStatus);
    }
    if (message.releaseTag !== "") {
      obj.releaseTag = message.releaseTag;
    }
    if (message.downloadProgress !== 0) {
      obj.downloadProgress = Math.round(message.downloadProgress);
    }
    if (message.bootloaderCfgSha !== "") {
      obj.bootloaderCfgSha = message.bootloaderCfgSha;
    }
    if (message.bootloaderCfgActualFileName !== "") {
      obj.bootloaderCfgActualFileName = message.bootloaderCfgActualFileName;
    }
    if (message.nexusOsSha !== "") {
      obj.nexusOsSha = message.nexusOsSha;
    }
    if (message.nexusOsActualFileName !== "") {
      obj.nexusOsActualFileName = message.nexusOsActualFileName;
    }
    if (message.upgradeErrorCount !== 0) {
      obj.upgradeErrorCount = Math.round(message.upgradeErrorCount);
    }
    if (message.lastUpgradeErrorStatus !== 0) {
      obj.lastUpgradeErrorStatus = manifestImagePartitionStatusToJSON(message.lastUpgradeErrorStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManifestImageInfo>, I>>(base?: I): ManifestImageInfo {
    return ManifestImageInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManifestImageInfo>, I>>(object: I): ManifestImageInfo {
    const message = createBaseManifestImageInfo();
    message.manifestIssued = object.manifestIssued ?? undefined;
    message.bootloaderSha = object.bootloaderSha ?? "";
    message.bootloaderActualFileName = object.bootloaderActualFileName ?? "";
    message.kernelSha = object.kernelSha ?? "";
    message.kernelActualFileName = object.kernelActualFileName ?? "";
    message.monolithSha = object.monolithSha ?? "";
    message.monolithActualFileName = object.monolithActualFileName ?? "";
    message.agentsSha = object.agentsSha ?? "";
    message.agentsActualFileName = object.agentsActualFileName ?? "";
    message.dockerfsSha = object.dockerfsSha ?? "";
    message.dockerfsActualFileName = object.dockerfsActualFileName ?? "";
    message.initrdSha = object.initrdSha ?? "";
    message.initrdActualFileName = object.initrdActualFileName ?? "";
    message.partitionName = object.partitionName ?? "";
    message.partitionStatus = object.partitionStatus ?? 0;
    message.releaseTag = object.releaseTag ?? "";
    message.downloadProgress = object.downloadProgress ?? 0;
    message.bootloaderCfgSha = object.bootloaderCfgSha ?? "";
    message.bootloaderCfgActualFileName = object.bootloaderCfgActualFileName ?? "";
    message.nexusOsSha = object.nexusOsSha ?? "";
    message.nexusOsActualFileName = object.nexusOsActualFileName ?? "";
    message.upgradeErrorCount = object.upgradeErrorCount ?? 0;
    message.lastUpgradeErrorStatus = object.lastUpgradeErrorStatus ?? 0;
    return message;
  },
};

function createBaseManifestImageState(): ManifestImageState {
  return { id: undefined };
}

export const ManifestImageState: MessageFns<ManifestImageState> = {
  encode(message: ManifestImageState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManifestImageState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManifestImageState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManifestImageState {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: ManifestImageState): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManifestImageState>, I>>(base?: I): ManifestImageState {
    return ManifestImageState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManifestImageState>, I>>(object: I): ManifestImageState {
    const message = createBaseManifestImageState();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseManifestPartitionFileCacheStatus(): ManifestPartitionFileCacheStatus {
  return { id: undefined, partitionName: "", file: undefined, collectedAt: undefined };
}

export const ManifestPartitionFileCacheStatus: MessageFns<ManifestPartitionFileCacheStatus> = {
  encode(message: ManifestPartitionFileCacheStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.partitionName !== "") {
      writer.uint32(26).string(message.partitionName);
    }
    if (message.file !== undefined) {
      FileCacheStatus.encode(message.file, writer.uint32(34).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManifestPartitionFileCacheStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManifestPartitionFileCacheStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.partitionName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.file = FileCacheStatus.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManifestPartitionFileCacheStatus {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      partitionName: isSet(object.partitionName) ? globalThis.String(object.partitionName) : "",
      file: isSet(object.file) ? FileCacheStatus.fromJSON(object.file) : undefined,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: ManifestPartitionFileCacheStatus): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.partitionName !== "") {
      obj.partitionName = message.partitionName;
    }
    if (message.file !== undefined) {
      obj.file = FileCacheStatus.toJSON(message.file);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManifestPartitionFileCacheStatus>, I>>(
    base?: I,
  ): ManifestPartitionFileCacheStatus {
    return ManifestPartitionFileCacheStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManifestPartitionFileCacheStatus>, I>>(
    object: I,
  ): ManifestPartitionFileCacheStatus {
    const message = createBaseManifestPartitionFileCacheStatus();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.partitionName = object.partitionName ?? "";
    message.file = (object.file !== undefined && object.file !== null)
      ? FileCacheStatus.fromPartial(object.file)
      : undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseFileCacheStatus(): FileCacheStatus {
  return {
    filename: "",
    expectedSize: "0",
    actualSize: "0",
    sha512224: "",
    lastChanged: undefined,
    lastChecked: undefined,
    status: 0,
    partitionName: "",
    packageName: "",
  };
}

export const FileCacheStatus: MessageFns<FileCacheStatus> = {
  encode(message: FileCacheStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filename !== "") {
      writer.uint32(10).string(message.filename);
    }
    if (message.expectedSize !== "0") {
      writer.uint32(16).uint64(message.expectedSize);
    }
    if (message.actualSize !== "0") {
      writer.uint32(24).uint64(message.actualSize);
    }
    if (message.sha512224 !== "") {
      writer.uint32(34).string(message.sha512224);
    }
    if (message.lastChanged !== undefined) {
      Timestamp.encode(toTimestamp(message.lastChanged), writer.uint32(42).fork()).join();
    }
    if (message.lastChecked !== undefined) {
      Timestamp.encode(toTimestamp(message.lastChecked), writer.uint32(50).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(56).int32(message.status);
    }
    if (message.partitionName !== "") {
      writer.uint32(66).string(message.partitionName);
    }
    if (message.packageName !== "") {
      writer.uint32(74).string(message.packageName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FileCacheStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFileCacheStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.expectedSize = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.actualSize = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sha512224 = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.lastChanged = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.lastChecked = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.partitionName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.packageName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FileCacheStatus {
    return {
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
      expectedSize: isSet(object.expectedSize) ? globalThis.String(object.expectedSize) : "0",
      actualSize: isSet(object.actualSize) ? globalThis.String(object.actualSize) : "0",
      sha512224: isSet(object.sha512224) ? globalThis.String(object.sha512224) : "",
      lastChanged: isSet(object.lastChanged) ? fromJsonTimestamp(object.lastChanged) : undefined,
      lastChecked: isSet(object.lastChecked) ? fromJsonTimestamp(object.lastChecked) : undefined,
      status: isSet(object.status) ? cacheStatusFromJSON(object.status) : 0,
      partitionName: isSet(object.partitionName) ? globalThis.String(object.partitionName) : "",
      packageName: isSet(object.packageName) ? globalThis.String(object.packageName) : "",
    };
  },

  toJSON(message: FileCacheStatus): unknown {
    const obj: any = {};
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    if (message.expectedSize !== "0") {
      obj.expectedSize = message.expectedSize;
    }
    if (message.actualSize !== "0") {
      obj.actualSize = message.actualSize;
    }
    if (message.sha512224 !== "") {
      obj.sha512224 = message.sha512224;
    }
    if (message.lastChanged !== undefined) {
      obj.lastChanged = message.lastChanged.toISOString();
    }
    if (message.lastChecked !== undefined) {
      obj.lastChecked = message.lastChecked.toISOString();
    }
    if (message.status !== 0) {
      obj.status = cacheStatusToJSON(message.status);
    }
    if (message.partitionName !== "") {
      obj.partitionName = message.partitionName;
    }
    if (message.packageName !== "") {
      obj.packageName = message.packageName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FileCacheStatus>, I>>(base?: I): FileCacheStatus {
    return FileCacheStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FileCacheStatus>, I>>(object: I): FileCacheStatus {
    const message = createBaseFileCacheStatus();
    message.filename = object.filename ?? "";
    message.expectedSize = object.expectedSize ?? "0";
    message.actualSize = object.actualSize ?? "0";
    message.sha512224 = object.sha512224 ?? "";
    message.lastChanged = object.lastChanged ?? undefined;
    message.lastChecked = object.lastChecked ?? undefined;
    message.status = object.status ?? 0;
    message.partitionName = object.partitionName ?? "";
    message.packageName = object.packageName ?? "";
    return message;
  },
};

function createBaseStpPortState(): StpPortState {
  return { id: undefined, portName: "", portFast: false, bpduGuardShutdown: false };
}

export const StpPortState: MessageFns<StpPortState> = {
  encode(message: StpPortState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.portName !== "") {
      writer.uint32(18).string(message.portName);
    }
    if (message.portFast !== false) {
      writer.uint32(32).bool(message.portFast);
    }
    if (message.bpduGuardShutdown !== false) {
      writer.uint32(40).bool(message.bpduGuardShutdown);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StpPortState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStpPortState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.portFast = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.bpduGuardShutdown = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StpPortState {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      portFast: isSet(object.portFast) ? globalThis.Boolean(object.portFast) : false,
      bpduGuardShutdown: isSet(object.bpduGuardShutdown) ? globalThis.Boolean(object.bpduGuardShutdown) : false,
    };
  },

  toJSON(message: StpPortState): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.portFast !== false) {
      obj.portFast = message.portFast;
    }
    if (message.bpduGuardShutdown !== false) {
      obj.bpduGuardShutdown = message.bpduGuardShutdown;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StpPortState>, I>>(base?: I): StpPortState {
    return StpPortState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StpPortState>, I>>(object: I): StpPortState {
    const message = createBaseStpPortState();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.portName = object.portName ?? "";
    message.portFast = object.portFast ?? false;
    message.bpduGuardShutdown = object.bpduGuardShutdown ?? false;
    return message;
  },
};

function createBaseStpVlanState(): StpVlanState {
  return {
    id: undefined,
    vlanId: 0,
    bridgeId: "",
    designatedBridgeId: "",
    forwardDelay: 0,
    helloTime: 0,
    holdTime: 0,
    lastTopologyChange: 0,
    maxAge: 0,
    rootBridgeId: "",
    rootForwardDelay: 0,
    rootHelloTime: 0,
    rootMaxAge: 0,
    rootPathCost: 0,
    rootPort: "",
    stpInstance: 0,
    topologyChangeCount: 0,
  };
}

export const StpVlanState: MessageFns<StpVlanState> = {
  encode(message: StpVlanState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.vlanId !== 0) {
      writer.uint32(16).uint32(message.vlanId);
    }
    if (message.bridgeId !== "") {
      writer.uint32(26).string(message.bridgeId);
    }
    if (message.designatedBridgeId !== "") {
      writer.uint32(34).string(message.designatedBridgeId);
    }
    if (message.forwardDelay !== 0) {
      writer.uint32(40).uint32(message.forwardDelay);
    }
    if (message.helloTime !== 0) {
      writer.uint32(48).uint32(message.helloTime);
    }
    if (message.holdTime !== 0) {
      writer.uint32(56).uint32(message.holdTime);
    }
    if (message.lastTopologyChange !== 0) {
      writer.uint32(64).uint32(message.lastTopologyChange);
    }
    if (message.maxAge !== 0) {
      writer.uint32(72).uint32(message.maxAge);
    }
    if (message.rootBridgeId !== "") {
      writer.uint32(82).string(message.rootBridgeId);
    }
    if (message.rootForwardDelay !== 0) {
      writer.uint32(88).uint32(message.rootForwardDelay);
    }
    if (message.rootHelloTime !== 0) {
      writer.uint32(96).uint32(message.rootHelloTime);
    }
    if (message.rootMaxAge !== 0) {
      writer.uint32(104).uint32(message.rootMaxAge);
    }
    if (message.rootPathCost !== 0) {
      writer.uint32(112).uint32(message.rootPathCost);
    }
    if (message.rootPort !== "") {
      writer.uint32(122).string(message.rootPort);
    }
    if (message.stpInstance !== 0) {
      writer.uint32(128).uint32(message.stpInstance);
    }
    if (message.topologyChangeCount !== 0) {
      writer.uint32(136).uint32(message.topologyChangeCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StpVlanState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStpVlanState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.bridgeId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.designatedBridgeId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.forwardDelay = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.helloTime = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.holdTime = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.lastTopologyChange = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maxAge = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.rootBridgeId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.rootForwardDelay = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.rootHelloTime = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.rootMaxAge = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.rootPathCost = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.rootPort = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.stpInstance = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.topologyChangeCount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StpVlanState {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      bridgeId: isSet(object.bridgeId) ? globalThis.String(object.bridgeId) : "",
      designatedBridgeId: isSet(object.designatedBridgeId) ? globalThis.String(object.designatedBridgeId) : "",
      forwardDelay: isSet(object.forwardDelay) ? globalThis.Number(object.forwardDelay) : 0,
      helloTime: isSet(object.helloTime) ? globalThis.Number(object.helloTime) : 0,
      holdTime: isSet(object.holdTime) ? globalThis.Number(object.holdTime) : 0,
      lastTopologyChange: isSet(object.lastTopologyChange) ? globalThis.Number(object.lastTopologyChange) : 0,
      maxAge: isSet(object.maxAge) ? globalThis.Number(object.maxAge) : 0,
      rootBridgeId: isSet(object.rootBridgeId) ? globalThis.String(object.rootBridgeId) : "",
      rootForwardDelay: isSet(object.rootForwardDelay) ? globalThis.Number(object.rootForwardDelay) : 0,
      rootHelloTime: isSet(object.rootHelloTime) ? globalThis.Number(object.rootHelloTime) : 0,
      rootMaxAge: isSet(object.rootMaxAge) ? globalThis.Number(object.rootMaxAge) : 0,
      rootPathCost: isSet(object.rootPathCost) ? globalThis.Number(object.rootPathCost) : 0,
      rootPort: isSet(object.rootPort) ? globalThis.String(object.rootPort) : "",
      stpInstance: isSet(object.stpInstance) ? globalThis.Number(object.stpInstance) : 0,
      topologyChangeCount: isSet(object.topologyChangeCount) ? globalThis.Number(object.topologyChangeCount) : 0,
    };
  },

  toJSON(message: StpVlanState): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.bridgeId !== "") {
      obj.bridgeId = message.bridgeId;
    }
    if (message.designatedBridgeId !== "") {
      obj.designatedBridgeId = message.designatedBridgeId;
    }
    if (message.forwardDelay !== 0) {
      obj.forwardDelay = Math.round(message.forwardDelay);
    }
    if (message.helloTime !== 0) {
      obj.helloTime = Math.round(message.helloTime);
    }
    if (message.holdTime !== 0) {
      obj.holdTime = Math.round(message.holdTime);
    }
    if (message.lastTopologyChange !== 0) {
      obj.lastTopologyChange = Math.round(message.lastTopologyChange);
    }
    if (message.maxAge !== 0) {
      obj.maxAge = Math.round(message.maxAge);
    }
    if (message.rootBridgeId !== "") {
      obj.rootBridgeId = message.rootBridgeId;
    }
    if (message.rootForwardDelay !== 0) {
      obj.rootForwardDelay = Math.round(message.rootForwardDelay);
    }
    if (message.rootHelloTime !== 0) {
      obj.rootHelloTime = Math.round(message.rootHelloTime);
    }
    if (message.rootMaxAge !== 0) {
      obj.rootMaxAge = Math.round(message.rootMaxAge);
    }
    if (message.rootPathCost !== 0) {
      obj.rootPathCost = Math.round(message.rootPathCost);
    }
    if (message.rootPort !== "") {
      obj.rootPort = message.rootPort;
    }
    if (message.stpInstance !== 0) {
      obj.stpInstance = Math.round(message.stpInstance);
    }
    if (message.topologyChangeCount !== 0) {
      obj.topologyChangeCount = Math.round(message.topologyChangeCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StpVlanState>, I>>(base?: I): StpVlanState {
    return StpVlanState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StpVlanState>, I>>(object: I): StpVlanState {
    const message = createBaseStpVlanState();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vlanId = object.vlanId ?? 0;
    message.bridgeId = object.bridgeId ?? "";
    message.designatedBridgeId = object.designatedBridgeId ?? "";
    message.forwardDelay = object.forwardDelay ?? 0;
    message.helloTime = object.helloTime ?? 0;
    message.holdTime = object.holdTime ?? 0;
    message.lastTopologyChange = object.lastTopologyChange ?? 0;
    message.maxAge = object.maxAge ?? 0;
    message.rootBridgeId = object.rootBridgeId ?? "";
    message.rootForwardDelay = object.rootForwardDelay ?? 0;
    message.rootHelloTime = object.rootHelloTime ?? 0;
    message.rootMaxAge = object.rootMaxAge ?? 0;
    message.rootPathCost = object.rootPathCost ?? 0;
    message.rootPort = object.rootPort ?? "";
    message.stpInstance = object.stpInstance ?? 0;
    message.topologyChangeCount = object.topologyChangeCount ?? 0;
    return message;
  },
};

function createBaseStpVlanPortState(): StpVlanPortState {
  return {
    id: undefined,
    vlanId: 0,
    portName: "",
    bpduReceived: 0,
    bpduSent: 0,
    desigBridge: "",
    desigCost: 0,
    desigPort: "",
    desigRoot: "",
    fwdTransitions: 0,
    pathCost: 0,
    portNum: "",
    portState: 0,
    priority: 0,
    rootGuardTimer: 0,
    tcReceived: 0,
    tcSent: 0,
  };
}

export const StpVlanPortState: MessageFns<StpVlanPortState> = {
  encode(message: StpVlanPortState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.vlanId !== 0) {
      writer.uint32(16).uint32(message.vlanId);
    }
    if (message.portName !== "") {
      writer.uint32(26).string(message.portName);
    }
    if (message.bpduReceived !== 0) {
      writer.uint32(32).uint32(message.bpduReceived);
    }
    if (message.bpduSent !== 0) {
      writer.uint32(40).uint32(message.bpduSent);
    }
    if (message.desigBridge !== "") {
      writer.uint32(50).string(message.desigBridge);
    }
    if (message.desigCost !== 0) {
      writer.uint32(56).uint32(message.desigCost);
    }
    if (message.desigPort !== "") {
      writer.uint32(66).string(message.desigPort);
    }
    if (message.desigRoot !== "") {
      writer.uint32(74).string(message.desigRoot);
    }
    if (message.fwdTransitions !== 0) {
      writer.uint32(80).uint32(message.fwdTransitions);
    }
    if (message.pathCost !== 0) {
      writer.uint32(88).uint32(message.pathCost);
    }
    if (message.portNum !== "") {
      writer.uint32(98).string(message.portNum);
    }
    if (message.portState !== 0) {
      writer.uint32(104).int32(message.portState);
    }
    if (message.priority !== 0) {
      writer.uint32(112).uint32(message.priority);
    }
    if (message.rootGuardTimer !== 0) {
      writer.uint32(120).uint32(message.rootGuardTimer);
    }
    if (message.tcReceived !== 0) {
      writer.uint32(128).uint32(message.tcReceived);
    }
    if (message.tcSent !== 0) {
      writer.uint32(136).uint32(message.tcSent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StpVlanPortState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStpVlanPortState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.bpduReceived = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.bpduSent = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.desigBridge = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.desigCost = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.desigPort = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.desigRoot = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.fwdTransitions = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.pathCost = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.portNum = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.portState = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.priority = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.rootGuardTimer = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.tcReceived = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.tcSent = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StpVlanPortState {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      bpduReceived: isSet(object.bpduReceived) ? globalThis.Number(object.bpduReceived) : 0,
      bpduSent: isSet(object.bpduSent) ? globalThis.Number(object.bpduSent) : 0,
      desigBridge: isSet(object.desigBridge) ? globalThis.String(object.desigBridge) : "",
      desigCost: isSet(object.desigCost) ? globalThis.Number(object.desigCost) : 0,
      desigPort: isSet(object.desigPort) ? globalThis.String(object.desigPort) : "",
      desigRoot: isSet(object.desigRoot) ? globalThis.String(object.desigRoot) : "",
      fwdTransitions: isSet(object.fwdTransitions) ? globalThis.Number(object.fwdTransitions) : 0,
      pathCost: isSet(object.pathCost) ? globalThis.Number(object.pathCost) : 0,
      portNum: isSet(object.portNum) ? globalThis.String(object.portNum) : "",
      portState: isSet(object.portState) ? stpVlanPortStateStatusFromJSON(object.portState) : 0,
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
      rootGuardTimer: isSet(object.rootGuardTimer) ? globalThis.Number(object.rootGuardTimer) : 0,
      tcReceived: isSet(object.tcReceived) ? globalThis.Number(object.tcReceived) : 0,
      tcSent: isSet(object.tcSent) ? globalThis.Number(object.tcSent) : 0,
    };
  },

  toJSON(message: StpVlanPortState): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.bpduReceived !== 0) {
      obj.bpduReceived = Math.round(message.bpduReceived);
    }
    if (message.bpduSent !== 0) {
      obj.bpduSent = Math.round(message.bpduSent);
    }
    if (message.desigBridge !== "") {
      obj.desigBridge = message.desigBridge;
    }
    if (message.desigCost !== 0) {
      obj.desigCost = Math.round(message.desigCost);
    }
    if (message.desigPort !== "") {
      obj.desigPort = message.desigPort;
    }
    if (message.desigRoot !== "") {
      obj.desigRoot = message.desigRoot;
    }
    if (message.fwdTransitions !== 0) {
      obj.fwdTransitions = Math.round(message.fwdTransitions);
    }
    if (message.pathCost !== 0) {
      obj.pathCost = Math.round(message.pathCost);
    }
    if (message.portNum !== "") {
      obj.portNum = message.portNum;
    }
    if (message.portState !== 0) {
      obj.portState = stpVlanPortStateStatusToJSON(message.portState);
    }
    if (message.priority !== 0) {
      obj.priority = Math.round(message.priority);
    }
    if (message.rootGuardTimer !== 0) {
      obj.rootGuardTimer = Math.round(message.rootGuardTimer);
    }
    if (message.tcReceived !== 0) {
      obj.tcReceived = Math.round(message.tcReceived);
    }
    if (message.tcSent !== 0) {
      obj.tcSent = Math.round(message.tcSent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StpVlanPortState>, I>>(base?: I): StpVlanPortState {
    return StpVlanPortState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StpVlanPortState>, I>>(object: I): StpVlanPortState {
    const message = createBaseStpVlanPortState();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vlanId = object.vlanId ?? 0;
    message.portName = object.portName ?? "";
    message.bpduReceived = object.bpduReceived ?? 0;
    message.bpduSent = object.bpduSent ?? 0;
    message.desigBridge = object.desigBridge ?? "";
    message.desigCost = object.desigCost ?? 0;
    message.desigPort = object.desigPort ?? "";
    message.desigRoot = object.desigRoot ?? "";
    message.fwdTransitions = object.fwdTransitions ?? 0;
    message.pathCost = object.pathCost ?? 0;
    message.portNum = object.portNum ?? "";
    message.portState = object.portState ?? 0;
    message.priority = object.priority ?? 0;
    message.rootGuardTimer = object.rootGuardTimer ?? 0;
    message.tcReceived = object.tcReceived ?? 0;
    message.tcSent = object.tcSent ?? 0;
    return message;
  },
};

function createBaseEsiInfo(): EsiInfo {
  return {
    id: undefined,
    esi: "",
    accessPort: "",
    vniCount: 0,
    macCount: 0,
    dfPreference: 0,
    nextHopGroup: 0,
    local: false,
    remote: false,
    df: false,
    readyForBgp: false,
    bridgePort: false,
    operUp: false,
    nextHopGroupActive: false,
    collectedAt: undefined,
  };
}

export const EsiInfo: MessageFns<EsiInfo> = {
  encode(message: EsiInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.esi !== "") {
      writer.uint32(18).string(message.esi);
    }
    if (message.accessPort !== "") {
      writer.uint32(26).string(message.accessPort);
    }
    if (message.vniCount !== 0) {
      writer.uint32(32).uint32(message.vniCount);
    }
    if (message.macCount !== 0) {
      writer.uint32(40).uint32(message.macCount);
    }
    if (message.dfPreference !== 0) {
      writer.uint32(48).uint32(message.dfPreference);
    }
    if (message.nextHopGroup !== 0) {
      writer.uint32(56).uint32(message.nextHopGroup);
    }
    if (message.local !== false) {
      writer.uint32(64).bool(message.local);
    }
    if (message.remote !== false) {
      writer.uint32(72).bool(message.remote);
    }
    if (message.df !== false) {
      writer.uint32(80).bool(message.df);
    }
    if (message.readyForBgp !== false) {
      writer.uint32(88).bool(message.readyForBgp);
    }
    if (message.bridgePort !== false) {
      writer.uint32(96).bool(message.bridgePort);
    }
    if (message.operUp !== false) {
      writer.uint32(104).bool(message.operUp);
    }
    if (message.nextHopGroupActive !== false) {
      writer.uint32(112).bool(message.nextHopGroupActive);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EsiInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEsiInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.esi = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.accessPort = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.vniCount = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.macCount = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.dfPreference = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.nextHopGroup = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.local = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.remote = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.df = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.readyForBgp = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.bridgePort = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.operUp = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.nextHopGroupActive = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EsiInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      esi: isSet(object.esi) ? globalThis.String(object.esi) : "",
      accessPort: isSet(object.accessPort) ? globalThis.String(object.accessPort) : "",
      vniCount: isSet(object.vniCount) ? globalThis.Number(object.vniCount) : 0,
      macCount: isSet(object.macCount) ? globalThis.Number(object.macCount) : 0,
      dfPreference: isSet(object.dfPreference) ? globalThis.Number(object.dfPreference) : 0,
      nextHopGroup: isSet(object.nextHopGroup) ? globalThis.Number(object.nextHopGroup) : 0,
      local: isSet(object.local) ? globalThis.Boolean(object.local) : false,
      remote: isSet(object.remote) ? globalThis.Boolean(object.remote) : false,
      df: isSet(object.df) ? globalThis.Boolean(object.df) : false,
      readyForBgp: isSet(object.readyForBgp) ? globalThis.Boolean(object.readyForBgp) : false,
      bridgePort: isSet(object.bridgePort) ? globalThis.Boolean(object.bridgePort) : false,
      operUp: isSet(object.operUp) ? globalThis.Boolean(object.operUp) : false,
      nextHopGroupActive: isSet(object.nextHopGroupActive) ? globalThis.Boolean(object.nextHopGroupActive) : false,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: EsiInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.esi !== "") {
      obj.esi = message.esi;
    }
    if (message.accessPort !== "") {
      obj.accessPort = message.accessPort;
    }
    if (message.vniCount !== 0) {
      obj.vniCount = Math.round(message.vniCount);
    }
    if (message.macCount !== 0) {
      obj.macCount = Math.round(message.macCount);
    }
    if (message.dfPreference !== 0) {
      obj.dfPreference = Math.round(message.dfPreference);
    }
    if (message.nextHopGroup !== 0) {
      obj.nextHopGroup = Math.round(message.nextHopGroup);
    }
    if (message.local !== false) {
      obj.local = message.local;
    }
    if (message.remote !== false) {
      obj.remote = message.remote;
    }
    if (message.df !== false) {
      obj.df = message.df;
    }
    if (message.readyForBgp !== false) {
      obj.readyForBgp = message.readyForBgp;
    }
    if (message.bridgePort !== false) {
      obj.bridgePort = message.bridgePort;
    }
    if (message.operUp !== false) {
      obj.operUp = message.operUp;
    }
    if (message.nextHopGroupActive !== false) {
      obj.nextHopGroupActive = message.nextHopGroupActive;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EsiInfo>, I>>(base?: I): EsiInfo {
    return EsiInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EsiInfo>, I>>(object: I): EsiInfo {
    const message = createBaseEsiInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.esi = object.esi ?? "";
    message.accessPort = object.accessPort ?? "";
    message.vniCount = object.vniCount ?? 0;
    message.macCount = object.macCount ?? 0;
    message.dfPreference = object.dfPreference ?? 0;
    message.nextHopGroup = object.nextHopGroup ?? 0;
    message.local = object.local ?? false;
    message.remote = object.remote ?? false;
    message.df = object.df ?? false;
    message.readyForBgp = object.readyForBgp ?? false;
    message.bridgePort = object.bridgePort ?? false;
    message.operUp = object.operUp ?? false;
    message.nextHopGroupActive = object.nextHopGroupActive ?? false;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseEsiVtepInfo(): EsiVtepInfo {
  return { id: undefined, vtep: "", esi: "", dfAlgorithm: "", dfPreference: 0, nextHopId: 0, collectedAt: undefined };
}

export const EsiVtepInfo: MessageFns<EsiVtepInfo> = {
  encode(message: EsiVtepInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.vtep !== "") {
      writer.uint32(18).string(message.vtep);
    }
    if (message.esi !== "") {
      writer.uint32(26).string(message.esi);
    }
    if (message.dfAlgorithm !== "") {
      writer.uint32(34).string(message.dfAlgorithm);
    }
    if (message.dfPreference !== 0) {
      writer.uint32(40).uint32(message.dfPreference);
    }
    if (message.nextHopId !== 0) {
      writer.uint32(48).uint32(message.nextHopId);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EsiVtepInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEsiVtepInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.vtep = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.esi = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dfAlgorithm = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.dfPreference = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.nextHopId = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EsiVtepInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vtep: isSet(object.vtep) ? globalThis.String(object.vtep) : "",
      esi: isSet(object.esi) ? globalThis.String(object.esi) : "",
      dfAlgorithm: isSet(object.dfAlgorithm) ? globalThis.String(object.dfAlgorithm) : "",
      dfPreference: isSet(object.dfPreference) ? globalThis.Number(object.dfPreference) : 0,
      nextHopId: isSet(object.nextHopId) ? globalThis.Number(object.nextHopId) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: EsiVtepInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vtep !== "") {
      obj.vtep = message.vtep;
    }
    if (message.esi !== "") {
      obj.esi = message.esi;
    }
    if (message.dfAlgorithm !== "") {
      obj.dfAlgorithm = message.dfAlgorithm;
    }
    if (message.dfPreference !== 0) {
      obj.dfPreference = Math.round(message.dfPreference);
    }
    if (message.nextHopId !== 0) {
      obj.nextHopId = Math.round(message.nextHopId);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EsiVtepInfo>, I>>(base?: I): EsiVtepInfo {
    return EsiVtepInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EsiVtepInfo>, I>>(object: I): EsiVtepInfo {
    const message = createBaseEsiVtepInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vtep = object.vtep ?? "";
    message.esi = object.esi ?? "";
    message.dfAlgorithm = object.dfAlgorithm ?? "";
    message.dfPreference = object.dfPreference ?? 0;
    message.nextHopId = object.nextHopId ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseServerInterfaceInfo(): ServerInterfaceInfo {
  return {
    id: undefined,
    macAddress: "",
    ifName: "",
    alias: "",
    ipv4Prefix1: "",
    ipv4Method1: 0,
    ipv4Prefix2: "",
    ipv4Method2: 0,
    vlanTagging: "",
    familyType: 0,
    collectedAt: undefined,
  };
}

export const ServerInterfaceInfo: MessageFns<ServerInterfaceInfo> = {
  encode(message: ServerInterfaceInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(34).fork()).join();
    }
    if (message.macAddress !== "") {
      writer.uint32(42).string(message.macAddress);
    }
    if (message.ifName !== "") {
      writer.uint32(50).string(message.ifName);
    }
    if (message.alias !== "") {
      writer.uint32(58).string(message.alias);
    }
    if (message.ipv4Prefix1 !== "") {
      writer.uint32(66).string(message.ipv4Prefix1);
    }
    if (message.ipv4Method1 !== 0) {
      writer.uint32(72).int32(message.ipv4Method1);
    }
    if (message.ipv4Prefix2 !== "") {
      writer.uint32(82).string(message.ipv4Prefix2);
    }
    if (message.ipv4Method2 !== 0) {
      writer.uint32(88).int32(message.ipv4Method2);
    }
    if (message.vlanTagging !== "") {
      writer.uint32(98).string(message.vlanTagging);
    }
    if (message.familyType !== 0) {
      writer.uint32(104).int32(message.familyType);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(114).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerInterfaceInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerInterfaceInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.macAddress = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ifName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.alias = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.ipv4Prefix1 = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.ipv4Method1 = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ipv4Prefix2 = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.ipv4Method2 = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.vlanTagging = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.familyType = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerInterfaceInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      macAddress: isSet(object.macAddress) ? globalThis.String(object.macAddress) : "",
      ifName: isSet(object.ifName) ? globalThis.String(object.ifName) : "",
      alias: isSet(object.alias) ? globalThis.String(object.alias) : "",
      ipv4Prefix1: isSet(object.ipv4Prefix1) ? globalThis.String(object.ipv4Prefix1) : "",
      ipv4Method1: isSet(object.ipv4Method1) ? ipMethodTypeFromJSON(object.ipv4Method1) : 0,
      ipv4Prefix2: isSet(object.ipv4Prefix2) ? globalThis.String(object.ipv4Prefix2) : "",
      ipv4Method2: isSet(object.ipv4Method2) ? ipMethodTypeFromJSON(object.ipv4Method2) : 0,
      vlanTagging: isSet(object.vlanTagging) ? globalThis.String(object.vlanTagging) : "",
      familyType: isSet(object.familyType) ? ipFamilyTypeFromJSON(object.familyType) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: ServerInterfaceInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.macAddress !== "") {
      obj.macAddress = message.macAddress;
    }
    if (message.ifName !== "") {
      obj.ifName = message.ifName;
    }
    if (message.alias !== "") {
      obj.alias = message.alias;
    }
    if (message.ipv4Prefix1 !== "") {
      obj.ipv4Prefix1 = message.ipv4Prefix1;
    }
    if (message.ipv4Method1 !== 0) {
      obj.ipv4Method1 = ipMethodTypeToJSON(message.ipv4Method1);
    }
    if (message.ipv4Prefix2 !== "") {
      obj.ipv4Prefix2 = message.ipv4Prefix2;
    }
    if (message.ipv4Method2 !== 0) {
      obj.ipv4Method2 = ipMethodTypeToJSON(message.ipv4Method2);
    }
    if (message.vlanTagging !== "") {
      obj.vlanTagging = message.vlanTagging;
    }
    if (message.familyType !== 0) {
      obj.familyType = ipFamilyTypeToJSON(message.familyType);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerInterfaceInfo>, I>>(base?: I): ServerInterfaceInfo {
    return ServerInterfaceInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerInterfaceInfo>, I>>(object: I): ServerInterfaceInfo {
    const message = createBaseServerInterfaceInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.macAddress = object.macAddress ?? "";
    message.ifName = object.ifName ?? "";
    message.alias = object.alias ?? "";
    message.ipv4Prefix1 = object.ipv4Prefix1 ?? "";
    message.ipv4Method1 = object.ipv4Method1 ?? 0;
    message.ipv4Prefix2 = object.ipv4Prefix2 ?? "";
    message.ipv4Method2 = object.ipv4Method2 ?? 0;
    message.vlanTagging = object.vlanTagging ?? "";
    message.familyType = object.familyType ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseServerInterface(): ServerInterface {
  return { id: undefined };
}

export const ServerInterface: MessageFns<ServerInterface> = {
  encode(message: ServerInterface, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerInterface {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerInterface();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerInterface {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: ServerInterface): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerInterface>, I>>(base?: I): ServerInterface {
    return ServerInterface.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerInterface>, I>>(object: I): ServerInterface {
    const message = createBaseServerInterface();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseServerMac(): ServerMac {
  return { id: undefined };
}

export const ServerMac: MessageFns<ServerMac> = {
  encode(message: ServerMac, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerMac {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerMac();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerMac {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: ServerMac): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerMac>, I>>(base?: I): ServerMac {
    return ServerMac.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerMac>, I>>(object: I): ServerMac {
    const message = createBaseServerMac();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseServerL3Table(): ServerL3Table {
  return {
    id: undefined,
    macAddress: "",
    ifName: "",
    ipAddress: "",
    familyType: 0,
    status: 0,
    collectedAt: undefined,
    alias: "",
  };
}

export const ServerL3Table: MessageFns<ServerL3Table> = {
  encode(message: ServerL3Table, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(34).fork()).join();
    }
    if (message.macAddress !== "") {
      writer.uint32(42).string(message.macAddress);
    }
    if (message.ifName !== "") {
      writer.uint32(50).string(message.ifName);
    }
    if (message.ipAddress !== "") {
      writer.uint32(58).string(message.ipAddress);
    }
    if (message.familyType !== 0) {
      writer.uint32(64).int32(message.familyType);
    }
    if (message.status !== 0) {
      writer.uint32(72).int32(message.status);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(82).fork()).join();
    }
    if (message.alias !== "") {
      writer.uint32(98).string(message.alias);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerL3Table {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerL3Table();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.macAddress = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ifName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.familyType = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.alias = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerL3Table {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      macAddress: isSet(object.macAddress) ? globalThis.String(object.macAddress) : "",
      ifName: isSet(object.ifName) ? globalThis.String(object.ifName) : "",
      ipAddress: isSet(object.ipAddress) ? globalThis.String(object.ipAddress) : "",
      familyType: isSet(object.familyType) ? ipFamilyTypeFromJSON(object.familyType) : 0,
      status: isSet(object.status) ? l3StatusFromJSON(object.status) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      alias: isSet(object.alias) ? globalThis.String(object.alias) : "",
    };
  },

  toJSON(message: ServerL3Table): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.macAddress !== "") {
      obj.macAddress = message.macAddress;
    }
    if (message.ifName !== "") {
      obj.ifName = message.ifName;
    }
    if (message.ipAddress !== "") {
      obj.ipAddress = message.ipAddress;
    }
    if (message.familyType !== 0) {
      obj.familyType = ipFamilyTypeToJSON(message.familyType);
    }
    if (message.status !== 0) {
      obj.status = l3StatusToJSON(message.status);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.alias !== "") {
      obj.alias = message.alias;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerL3Table>, I>>(base?: I): ServerL3Table {
    return ServerL3Table.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerL3Table>, I>>(object: I): ServerL3Table {
    const message = createBaseServerL3Table();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.macAddress = object.macAddress ?? "";
    message.ifName = object.ifName ?? "";
    message.ipAddress = object.ipAddress ?? "";
    message.familyType = object.familyType ?? 0;
    message.status = object.status ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.alias = object.alias ?? "";
    return message;
  },
};

function createBaseServerIpRouteAddress(): ServerIpRouteAddress {
  return { id: undefined };
}

export const ServerIpRouteAddress: MessageFns<ServerIpRouteAddress> = {
  encode(message: ServerIpRouteAddress, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerIpRouteAddress {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerIpRouteAddress();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerIpRouteAddress {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: ServerIpRouteAddress): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerIpRouteAddress>, I>>(base?: I): ServerIpRouteAddress {
    return ServerIpRouteAddress.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerIpRouteAddress>, I>>(object: I): ServerIpRouteAddress {
    const message = createBaseServerIpRouteAddress();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseServerIpRouteTable(): ServerIpRouteTable {
  return {
    id: undefined,
    dst: "",
    interfaceName: "",
    protocol: 0,
    scope: 0,
    prefSrc: "",
    metric: 0,
    type: 0,
    dstMask: 0,
    collectedAt: undefined,
    familyType: 0,
    gatewayMacAddress: "",
    gateway: "",
  };
}

export const ServerIpRouteTable: MessageFns<ServerIpRouteTable> = {
  encode(message: ServerIpRouteTable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.dst !== "") {
      writer.uint32(18).string(message.dst);
    }
    if (message.interfaceName !== "") {
      writer.uint32(26).string(message.interfaceName);
    }
    if (message.protocol !== 0) {
      writer.uint32(32).int32(message.protocol);
    }
    if (message.scope !== 0) {
      writer.uint32(40).int32(message.scope);
    }
    if (message.prefSrc !== "") {
      writer.uint32(50).string(message.prefSrc);
    }
    if (message.metric !== 0) {
      writer.uint32(56).uint32(message.metric);
    }
    if (message.type !== 0) {
      writer.uint32(64).int32(message.type);
    }
    if (message.dstMask !== 0) {
      writer.uint32(72).uint32(message.dstMask);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(82).fork()).join();
    }
    if (message.familyType !== 0) {
      writer.uint32(88).int32(message.familyType);
    }
    if (message.gatewayMacAddress !== "") {
      writer.uint32(98).string(message.gatewayMacAddress);
    }
    if (message.gateway !== "") {
      writer.uint32(106).string(message.gateway);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerIpRouteTable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerIpRouteTable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.dst = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.interfaceName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.protocol = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.scope = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.prefSrc = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.metric = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.dstMask = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.familyType = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.gatewayMacAddress = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.gateway = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerIpRouteTable {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      dst: isSet(object.dst) ? globalThis.String(object.dst) : "",
      interfaceName: isSet(object.interfaceName) ? globalThis.String(object.interfaceName) : "",
      protocol: isSet(object.protocol) ? protocolTypeFromJSON(object.protocol) : 0,
      scope: isSet(object.scope) ? serverIpRouteScopeFromJSON(object.scope) : 0,
      prefSrc: isSet(object.prefSrc) ? globalThis.String(object.prefSrc) : "",
      metric: isSet(object.metric) ? globalThis.Number(object.metric) : 0,
      type: isSet(object.type) ? serverIpRouteTypeFromJSON(object.type) : 0,
      dstMask: isSet(object.dstMask) ? globalThis.Number(object.dstMask) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      familyType: isSet(object.familyType) ? ipFamilyTypeFromJSON(object.familyType) : 0,
      gatewayMacAddress: isSet(object.gatewayMacAddress) ? globalThis.String(object.gatewayMacAddress) : "",
      gateway: isSet(object.gateway) ? globalThis.String(object.gateway) : "",
    };
  },

  toJSON(message: ServerIpRouteTable): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.dst !== "") {
      obj.dst = message.dst;
    }
    if (message.interfaceName !== "") {
      obj.interfaceName = message.interfaceName;
    }
    if (message.protocol !== 0) {
      obj.protocol = protocolTypeToJSON(message.protocol);
    }
    if (message.scope !== 0) {
      obj.scope = serverIpRouteScopeToJSON(message.scope);
    }
    if (message.prefSrc !== "") {
      obj.prefSrc = message.prefSrc;
    }
    if (message.metric !== 0) {
      obj.metric = Math.round(message.metric);
    }
    if (message.type !== 0) {
      obj.type = serverIpRouteTypeToJSON(message.type);
    }
    if (message.dstMask !== 0) {
      obj.dstMask = Math.round(message.dstMask);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.familyType !== 0) {
      obj.familyType = ipFamilyTypeToJSON(message.familyType);
    }
    if (message.gatewayMacAddress !== "") {
      obj.gatewayMacAddress = message.gatewayMacAddress;
    }
    if (message.gateway !== "") {
      obj.gateway = message.gateway;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerIpRouteTable>, I>>(base?: I): ServerIpRouteTable {
    return ServerIpRouteTable.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerIpRouteTable>, I>>(object: I): ServerIpRouteTable {
    const message = createBaseServerIpRouteTable();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.dst = object.dst ?? "";
    message.interfaceName = object.interfaceName ?? "";
    message.protocol = object.protocol ?? 0;
    message.scope = object.scope ?? 0;
    message.prefSrc = object.prefSrc ?? "";
    message.metric = object.metric ?? 0;
    message.type = object.type ?? 0;
    message.dstMask = object.dstMask ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.familyType = object.familyType ?? 0;
    message.gatewayMacAddress = object.gatewayMacAddress ?? "";
    message.gateway = object.gateway ?? "";
    return message;
  },
};

function createBaseGpuDevice(): GpuDevice {
  return { id: undefined, description: "", product: "", vendor: "", busId: "", slot: 0, collectedAt: undefined };
}

export const GpuDevice: MessageFns<GpuDevice> = {
  encode(message: GpuDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.product !== "") {
      writer.uint32(26).string(message.product);
    }
    if (message.vendor !== "") {
      writer.uint32(34).string(message.vendor);
    }
    if (message.busId !== "") {
      writer.uint32(42).string(message.busId);
    }
    if (message.slot !== 0) {
      writer.uint32(48).uint32(message.slot);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GpuDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGpuDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.product = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.vendor = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.busId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.slot = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GpuDevice {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      product: isSet(object.product) ? globalThis.String(object.product) : "",
      vendor: isSet(object.vendor) ? globalThis.String(object.vendor) : "",
      busId: isSet(object.busId) ? globalThis.String(object.busId) : "",
      slot: isSet(object.slot) ? globalThis.Number(object.slot) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: GpuDevice): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.product !== "") {
      obj.product = message.product;
    }
    if (message.vendor !== "") {
      obj.vendor = message.vendor;
    }
    if (message.busId !== "") {
      obj.busId = message.busId;
    }
    if (message.slot !== 0) {
      obj.slot = Math.round(message.slot);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GpuDevice>, I>>(base?: I): GpuDevice {
    return GpuDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GpuDevice>, I>>(object: I): GpuDevice {
    const message = createBaseGpuDevice();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.description = object.description ?? "";
    message.product = object.product ?? "";
    message.vendor = object.vendor ?? "";
    message.busId = object.busId ?? "";
    message.slot = object.slot ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseServerInterfaceMapping(): ServerInterfaceMapping {
  return {
    id: undefined,
    nativeInterfaceName: "",
    interfaceAlias: "",
    pciBusId: "",
    serverType: 0,
    serverProductName: "",
    collectedAt: undefined,
    slot: 0,
  };
}

export const ServerInterfaceMapping: MessageFns<ServerInterfaceMapping> = {
  encode(message: ServerInterfaceMapping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.nativeInterfaceName !== "") {
      writer.uint32(18).string(message.nativeInterfaceName);
    }
    if (message.interfaceAlias !== "") {
      writer.uint32(26).string(message.interfaceAlias);
    }
    if (message.pciBusId !== "") {
      writer.uint32(34).string(message.pciBusId);
    }
    if (message.serverType !== 0) {
      writer.uint32(40).int32(message.serverType);
    }
    if (message.serverProductName !== "") {
      writer.uint32(50).string(message.serverProductName);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(58).fork()).join();
    }
    if (message.slot !== 0) {
      writer.uint32(64).uint32(message.slot);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerInterfaceMapping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerInterfaceMapping();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nativeInterfaceName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.interfaceAlias = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pciBusId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.serverType = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.serverProductName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.slot = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerInterfaceMapping {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      nativeInterfaceName: isSet(object.nativeInterfaceName) ? globalThis.String(object.nativeInterfaceName) : "",
      interfaceAlias: isSet(object.interfaceAlias) ? globalThis.String(object.interfaceAlias) : "",
      pciBusId: isSet(object.pciBusId) ? globalThis.String(object.pciBusId) : "",
      serverType: isSet(object.serverType) ? serverTypeFromJSON(object.serverType) : 0,
      serverProductName: isSet(object.serverProductName) ? globalThis.String(object.serverProductName) : "",
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      slot: isSet(object.slot) ? globalThis.Number(object.slot) : 0,
    };
  },

  toJSON(message: ServerInterfaceMapping): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.nativeInterfaceName !== "") {
      obj.nativeInterfaceName = message.nativeInterfaceName;
    }
    if (message.interfaceAlias !== "") {
      obj.interfaceAlias = message.interfaceAlias;
    }
    if (message.pciBusId !== "") {
      obj.pciBusId = message.pciBusId;
    }
    if (message.serverType !== 0) {
      obj.serverType = serverTypeToJSON(message.serverType);
    }
    if (message.serverProductName !== "") {
      obj.serverProductName = message.serverProductName;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.slot !== 0) {
      obj.slot = Math.round(message.slot);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerInterfaceMapping>, I>>(base?: I): ServerInterfaceMapping {
    return ServerInterfaceMapping.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerInterfaceMapping>, I>>(object: I): ServerInterfaceMapping {
    const message = createBaseServerInterfaceMapping();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.nativeInterfaceName = object.nativeInterfaceName ?? "";
    message.interfaceAlias = object.interfaceAlias ?? "";
    message.pciBusId = object.pciBusId ?? "";
    message.serverType = object.serverType ?? 0;
    message.serverProductName = object.serverProductName ?? "";
    message.collectedAt = object.collectedAt ?? undefined;
    message.slot = object.slot ?? 0;
    return message;
  },
};

function createBaseServerPsu(): ServerPsu {
  return {
    id: undefined,
    watts: 0,
    fanSpeed: 0,
    status: 0,
    name: "",
    model: "",
    serial: "",
    current: 0,
    currentHighCriticalThreshold: 0,
    voltage: 0,
    voltageHighCriticalThreshold: 0,
    pid: "",
  };
}

export const ServerPsu: MessageFns<ServerPsu> = {
  encode(message: ServerPsu, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.watts !== 0) {
      writer.uint32(24).uint32(message.watts);
    }
    if (message.fanSpeed !== 0) {
      writer.uint32(32).uint32(message.fanSpeed);
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status);
    }
    if (message.name !== "") {
      writer.uint32(50).string(message.name);
    }
    if (message.model !== "") {
      writer.uint32(58).string(message.model);
    }
    if (message.serial !== "") {
      writer.uint32(66).string(message.serial);
    }
    if (message.current !== 0) {
      writer.uint32(72).uint32(message.current);
    }
    if (message.currentHighCriticalThreshold !== 0) {
      writer.uint32(80).uint32(message.currentHighCriticalThreshold);
    }
    if (message.voltage !== 0) {
      writer.uint32(88).uint32(message.voltage);
    }
    if (message.voltageHighCriticalThreshold !== 0) {
      writer.uint32(96).uint32(message.voltageHighCriticalThreshold);
    }
    if (message.pid !== "") {
      writer.uint32(106).string(message.pid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerPsu {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerPsu();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.watts = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.fanSpeed = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.current = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.currentHighCriticalThreshold = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.voltage = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.voltageHighCriticalThreshold = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.pid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerPsu {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      watts: isSet(object.watts) ? globalThis.Number(object.watts) : 0,
      fanSpeed: isSet(object.fanSpeed) ? globalThis.Number(object.fanSpeed) : 0,
      status: isSet(object.status) ? envStatusFromJSON(object.status) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      current: isSet(object.current) ? globalThis.Number(object.current) : 0,
      currentHighCriticalThreshold: isSet(object.currentHighCriticalThreshold)
        ? globalThis.Number(object.currentHighCriticalThreshold)
        : 0,
      voltage: isSet(object.voltage) ? globalThis.Number(object.voltage) : 0,
      voltageHighCriticalThreshold: isSet(object.voltageHighCriticalThreshold)
        ? globalThis.Number(object.voltageHighCriticalThreshold)
        : 0,
      pid: isSet(object.pid) ? globalThis.String(object.pid) : "",
    };
  },

  toJSON(message: ServerPsu): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.watts !== 0) {
      obj.watts = Math.round(message.watts);
    }
    if (message.fanSpeed !== 0) {
      obj.fanSpeed = Math.round(message.fanSpeed);
    }
    if (message.status !== 0) {
      obj.status = envStatusToJSON(message.status);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.current !== 0) {
      obj.current = Math.round(message.current);
    }
    if (message.currentHighCriticalThreshold !== 0) {
      obj.currentHighCriticalThreshold = Math.round(message.currentHighCriticalThreshold);
    }
    if (message.voltage !== 0) {
      obj.voltage = Math.round(message.voltage);
    }
    if (message.voltageHighCriticalThreshold !== 0) {
      obj.voltageHighCriticalThreshold = Math.round(message.voltageHighCriticalThreshold);
    }
    if (message.pid !== "") {
      obj.pid = message.pid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerPsu>, I>>(base?: I): ServerPsu {
    return ServerPsu.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerPsu>, I>>(object: I): ServerPsu {
    const message = createBaseServerPsu();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.watts = object.watts ?? 0;
    message.fanSpeed = object.fanSpeed ?? 0;
    message.status = object.status ?? 0;
    message.name = object.name ?? "";
    message.model = object.model ?? "";
    message.serial = object.serial ?? "";
    message.current = object.current ?? 0;
    message.currentHighCriticalThreshold = object.currentHighCriticalThreshold ?? 0;
    message.voltage = object.voltage ?? 0;
    message.voltageHighCriticalThreshold = object.voltageHighCriticalThreshold ?? 0;
    message.pid = object.pid ?? "";
    return message;
  },
};

function createBaseBmcServer(): BmcServer {
  return { id: undefined, bmcId: undefined };
}

export const BmcServer: MessageFns<BmcServer> = {
  encode(message: BmcServer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.bmcId !== undefined) {
      PathId.encode(message.bmcId, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BmcServer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBmcServer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.bmcId = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BmcServer {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      bmcId: isSet(object.bmcId) ? PathId.fromJSON(object.bmcId) : undefined,
    };
  },

  toJSON(message: BmcServer): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.bmcId !== undefined) {
      obj.bmcId = PathId.toJSON(message.bmcId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BmcServer>, I>>(base?: I): BmcServer {
    return BmcServer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BmcServer>, I>>(object: I): BmcServer {
    const message = createBaseBmcServer();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.bmcId = (object.bmcId !== undefined && object.bmcId !== null)
      ? PathId.fromPartial(object.bmcId)
      : undefined;
    return message;
  },
};

function createBaseServerToBmc(): ServerToBmc {
  return { id: undefined, bmcId: undefined };
}

export const ServerToBmc: MessageFns<ServerToBmc> = {
  encode(message: ServerToBmc, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.bmcId !== undefined) {
      PathId.encode(message.bmcId, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerToBmc {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerToBmc();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.bmcId = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerToBmc {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      bmcId: isSet(object.bmcId) ? PathId.fromJSON(object.bmcId) : undefined,
    };
  },

  toJSON(message: ServerToBmc): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.bmcId !== undefined) {
      obj.bmcId = PathId.toJSON(message.bmcId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerToBmc>, I>>(base?: I): ServerToBmc {
    return ServerToBmc.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerToBmc>, I>>(object: I): ServerToBmc {
    const message = createBaseServerToBmc();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.bmcId = (object.bmcId !== undefined && object.bmcId !== null)
      ? PathId.fromPartial(object.bmcId)
      : undefined;
    return message;
  },
};

function createBaseBmcServerPsu(): BmcServerPsu {
  return { id: undefined, serverPsu: undefined };
}

export const BmcServerPsu: MessageFns<BmcServerPsu> = {
  encode(message: BmcServerPsu, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.serverPsu !== undefined) {
      ServerPsu.encode(message.serverPsu, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BmcServerPsu {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBmcServerPsu();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serverPsu = ServerPsu.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BmcServerPsu {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      serverPsu: isSet(object.serverPsu) ? ServerPsu.fromJSON(object.serverPsu) : undefined,
    };
  },

  toJSON(message: BmcServerPsu): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.serverPsu !== undefined) {
      obj.serverPsu = ServerPsu.toJSON(message.serverPsu);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BmcServerPsu>, I>>(base?: I): BmcServerPsu {
    return BmcServerPsu.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BmcServerPsu>, I>>(object: I): BmcServerPsu {
    const message = createBaseBmcServerPsu();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.serverPsu = (object.serverPsu !== undefined && object.serverPsu !== null)
      ? ServerPsu.fromPartial(object.serverPsu)
      : undefined;
    return message;
  },
};

function createBaseServerTempSensor(): ServerTempSensor {
  return {
    id: undefined,
    degCelsius: 0,
    highThreshold: 0,
    lowThreshold: 0,
    highCriticalThreshold: 0,
    lowCriticalThreshold: 0,
    category: 0,
  };
}

export const ServerTempSensor: MessageFns<ServerTempSensor> = {
  encode(message: ServerTempSensor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.degCelsius !== 0) {
      writer.uint32(24).int32(message.degCelsius);
    }
    if (message.highThreshold !== 0) {
      writer.uint32(32).uint32(message.highThreshold);
    }
    if (message.lowThreshold !== 0) {
      writer.uint32(40).int32(message.lowThreshold);
    }
    if (message.highCriticalThreshold !== 0) {
      writer.uint32(48).uint32(message.highCriticalThreshold);
    }
    if (message.lowCriticalThreshold !== 0) {
      writer.uint32(56).int32(message.lowCriticalThreshold);
    }
    if (message.category !== 0) {
      writer.uint32(64).int32(message.category);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerTempSensor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerTempSensor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.degCelsius = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.highThreshold = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.lowThreshold = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.highCriticalThreshold = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.lowCriticalThreshold = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerTempSensor {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      degCelsius: isSet(object.degCelsius) ? globalThis.Number(object.degCelsius) : 0,
      highThreshold: isSet(object.highThreshold) ? globalThis.Number(object.highThreshold) : 0,
      lowThreshold: isSet(object.lowThreshold) ? globalThis.Number(object.lowThreshold) : 0,
      highCriticalThreshold: isSet(object.highCriticalThreshold) ? globalThis.Number(object.highCriticalThreshold) : 0,
      lowCriticalThreshold: isSet(object.lowCriticalThreshold) ? globalThis.Number(object.lowCriticalThreshold) : 0,
      category: isSet(object.category) ? temperatureSensorCategoryFromJSON(object.category) : 0,
    };
  },

  toJSON(message: ServerTempSensor): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.degCelsius !== 0) {
      obj.degCelsius = Math.round(message.degCelsius);
    }
    if (message.highThreshold !== 0) {
      obj.highThreshold = Math.round(message.highThreshold);
    }
    if (message.lowThreshold !== 0) {
      obj.lowThreshold = Math.round(message.lowThreshold);
    }
    if (message.highCriticalThreshold !== 0) {
      obj.highCriticalThreshold = Math.round(message.highCriticalThreshold);
    }
    if (message.lowCriticalThreshold !== 0) {
      obj.lowCriticalThreshold = Math.round(message.lowCriticalThreshold);
    }
    if (message.category !== 0) {
      obj.category = temperatureSensorCategoryToJSON(message.category);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerTempSensor>, I>>(base?: I): ServerTempSensor {
    return ServerTempSensor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerTempSensor>, I>>(object: I): ServerTempSensor {
    const message = createBaseServerTempSensor();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.degCelsius = object.degCelsius ?? 0;
    message.highThreshold = object.highThreshold ?? 0;
    message.lowThreshold = object.lowThreshold ?? 0;
    message.highCriticalThreshold = object.highCriticalThreshold ?? 0;
    message.lowCriticalThreshold = object.lowCriticalThreshold ?? 0;
    message.category = object.category ?? 0;
    return message;
  },
};

function createBaseBmcServerTempSensor(): BmcServerTempSensor {
  return { id: undefined, serverTempSensor: undefined };
}

export const BmcServerTempSensor: MessageFns<BmcServerTempSensor> = {
  encode(message: BmcServerTempSensor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.serverTempSensor !== undefined) {
      ServerTempSensor.encode(message.serverTempSensor, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BmcServerTempSensor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBmcServerTempSensor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serverTempSensor = ServerTempSensor.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BmcServerTempSensor {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      serverTempSensor: isSet(object.serverTempSensor) ? ServerTempSensor.fromJSON(object.serverTempSensor) : undefined,
    };
  },

  toJSON(message: BmcServerTempSensor): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.serverTempSensor !== undefined) {
      obj.serverTempSensor = ServerTempSensor.toJSON(message.serverTempSensor);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BmcServerTempSensor>, I>>(base?: I): BmcServerTempSensor {
    return BmcServerTempSensor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BmcServerTempSensor>, I>>(object: I): BmcServerTempSensor {
    const message = createBaseBmcServerTempSensor();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.serverTempSensor = (object.serverTempSensor !== undefined && object.serverTempSensor !== null)
      ? ServerTempSensor.fromPartial(object.serverTempSensor)
      : undefined;
    return message;
  },
};

function createBaseServerBmcPreAuthInfo(): ServerBmcPreAuthInfo {
  return { id: "", vendor: "", product: "" };
}

export const ServerBmcPreAuthInfo: MessageFns<ServerBmcPreAuthInfo> = {
  encode(message: ServerBmcPreAuthInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.vendor !== "") {
      writer.uint32(18).string(message.vendor);
    }
    if (message.product !== "") {
      writer.uint32(26).string(message.product);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerBmcPreAuthInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerBmcPreAuthInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.vendor = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.product = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerBmcPreAuthInfo {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      vendor: isSet(object.vendor) ? globalThis.String(object.vendor) : "",
      product: isSet(object.product) ? globalThis.String(object.product) : "",
    };
  },

  toJSON(message: ServerBmcPreAuthInfo): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.vendor !== "") {
      obj.vendor = message.vendor;
    }
    if (message.product !== "") {
      obj.product = message.product;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerBmcPreAuthInfo>, I>>(base?: I): ServerBmcPreAuthInfo {
    return ServerBmcPreAuthInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerBmcPreAuthInfo>, I>>(object: I): ServerBmcPreAuthInfo {
    const message = createBaseServerBmcPreAuthInfo();
    message.id = object.id ?? "";
    message.vendor = object.vendor ?? "";
    message.product = object.product ?? "";
    return message;
  },
};

function createBaseServerFirmwareInventoryItem(): ServerFirmwareInventoryItem {
  return { name: "", description: "", manufacturer: "", version: "" };
}

export const ServerFirmwareInventoryItem: MessageFns<ServerFirmwareInventoryItem> = {
  encode(message: ServerFirmwareInventoryItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.manufacturer !== "") {
      writer.uint32(26).string(message.manufacturer);
    }
    if (message.version !== "") {
      writer.uint32(34).string(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerFirmwareInventoryItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerFirmwareInventoryItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.version = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerFirmwareInventoryItem {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
    };
  },

  toJSON(message: ServerFirmwareInventoryItem): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.manufacturer !== "") {
      obj.manufacturer = message.manufacturer;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerFirmwareInventoryItem>, I>>(base?: I): ServerFirmwareInventoryItem {
    return ServerFirmwareInventoryItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerFirmwareInventoryItem>, I>>(object: I): ServerFirmwareInventoryItem {
    const message = createBaseServerFirmwareInventoryItem();
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.manufacturer = object.manufacturer ?? "";
    message.version = object.version ?? "";
    return message;
  },
};

function createBaseServerIpv4Address(): ServerIpv4Address {
  return { ipPrefix: "", gateway: "", addressOrigin: "" };
}

export const ServerIpv4Address: MessageFns<ServerIpv4Address> = {
  encode(message: ServerIpv4Address, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ipPrefix !== "") {
      writer.uint32(10).string(message.ipPrefix);
    }
    if (message.gateway !== "") {
      writer.uint32(18).string(message.gateway);
    }
    if (message.addressOrigin !== "") {
      writer.uint32(26).string(message.addressOrigin);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerIpv4Address {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerIpv4Address();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ipPrefix = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.gateway = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.addressOrigin = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerIpv4Address {
    return {
      ipPrefix: isSet(object.ipPrefix) ? globalThis.String(object.ipPrefix) : "",
      gateway: isSet(object.gateway) ? globalThis.String(object.gateway) : "",
      addressOrigin: isSet(object.addressOrigin) ? globalThis.String(object.addressOrigin) : "",
    };
  },

  toJSON(message: ServerIpv4Address): unknown {
    const obj: any = {};
    if (message.ipPrefix !== "") {
      obj.ipPrefix = message.ipPrefix;
    }
    if (message.gateway !== "") {
      obj.gateway = message.gateway;
    }
    if (message.addressOrigin !== "") {
      obj.addressOrigin = message.addressOrigin;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerIpv4Address>, I>>(base?: I): ServerIpv4Address {
    return ServerIpv4Address.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerIpv4Address>, I>>(object: I): ServerIpv4Address {
    const message = createBaseServerIpv4Address();
    message.ipPrefix = object.ipPrefix ?? "";
    message.gateway = object.gateway ?? "";
    message.addressOrigin = object.addressOrigin ?? "";
    return message;
  },
};

function createBaseServerIPv6Address(): ServerIPv6Address {
  return { ipPrefix: "", addressOrigin: "" };
}

export const ServerIPv6Address: MessageFns<ServerIPv6Address> = {
  encode(message: ServerIPv6Address, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ipPrefix !== "") {
      writer.uint32(10).string(message.ipPrefix);
    }
    if (message.addressOrigin !== "") {
      writer.uint32(18).string(message.addressOrigin);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerIPv6Address {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerIPv6Address();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ipPrefix = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.addressOrigin = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerIPv6Address {
    return {
      ipPrefix: isSet(object.ipPrefix) ? globalThis.String(object.ipPrefix) : "",
      addressOrigin: isSet(object.addressOrigin) ? globalThis.String(object.addressOrigin) : "",
    };
  },

  toJSON(message: ServerIPv6Address): unknown {
    const obj: any = {};
    if (message.ipPrefix !== "") {
      obj.ipPrefix = message.ipPrefix;
    }
    if (message.addressOrigin !== "") {
      obj.addressOrigin = message.addressOrigin;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerIPv6Address>, I>>(base?: I): ServerIPv6Address {
    return ServerIPv6Address.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerIPv6Address>, I>>(object: I): ServerIPv6Address {
    const message = createBaseServerIPv6Address();
    message.ipPrefix = object.ipPrefix ?? "";
    message.addressOrigin = object.addressOrigin ?? "";
    return message;
  },
};

function createBaseServerEthernetInterface(): ServerEthernetInterface {
  return {
    id: "",
    name: "",
    description: "",
    macAddress: "",
    ipv4Addresses: [],
    ipv6Addresses: [],
    nameServers: [],
    speedMbps: 0,
    mtu: 0,
  };
}

export const ServerEthernetInterface: MessageFns<ServerEthernetInterface> = {
  encode(message: ServerEthernetInterface, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.macAddress !== "") {
      writer.uint32(34).string(message.macAddress);
    }
    for (const v of message.ipv4Addresses) {
      ServerIpv4Address.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.ipv6Addresses) {
      ServerIPv6Address.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.nameServers) {
      writer.uint32(58).string(v!);
    }
    if (message.speedMbps !== 0) {
      writer.uint32(64).int32(message.speedMbps);
    }
    if (message.mtu !== 0) {
      writer.uint32(72).int32(message.mtu);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerEthernetInterface {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerEthernetInterface();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.macAddress = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ipv4Addresses.push(ServerIpv4Address.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ipv6Addresses.push(ServerIPv6Address.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.nameServers.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.speedMbps = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.mtu = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerEthernetInterface {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      macAddress: isSet(object.macAddress) ? globalThis.String(object.macAddress) : "",
      ipv4Addresses: globalThis.Array.isArray(object?.ipv4Addresses)
        ? object.ipv4Addresses.map((e: any) => ServerIpv4Address.fromJSON(e))
        : [],
      ipv6Addresses: globalThis.Array.isArray(object?.ipv6Addresses)
        ? object.ipv6Addresses.map((e: any) => ServerIPv6Address.fromJSON(e))
        : [],
      nameServers: globalThis.Array.isArray(object?.nameServers)
        ? object.nameServers.map((e: any) => globalThis.String(e))
        : [],
      speedMbps: isSet(object.speedMbps) ? globalThis.Number(object.speedMbps) : 0,
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
    };
  },

  toJSON(message: ServerEthernetInterface): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.macAddress !== "") {
      obj.macAddress = message.macAddress;
    }
    if (message.ipv4Addresses?.length) {
      obj.ipv4Addresses = message.ipv4Addresses.map((e) => ServerIpv4Address.toJSON(e));
    }
    if (message.ipv6Addresses?.length) {
      obj.ipv6Addresses = message.ipv6Addresses.map((e) => ServerIPv6Address.toJSON(e));
    }
    if (message.nameServers?.length) {
      obj.nameServers = message.nameServers;
    }
    if (message.speedMbps !== 0) {
      obj.speedMbps = Math.round(message.speedMbps);
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerEthernetInterface>, I>>(base?: I): ServerEthernetInterface {
    return ServerEthernetInterface.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerEthernetInterface>, I>>(object: I): ServerEthernetInterface {
    const message = createBaseServerEthernetInterface();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.macAddress = object.macAddress ?? "";
    message.ipv4Addresses = object.ipv4Addresses?.map((e) => ServerIpv4Address.fromPartial(e)) || [];
    message.ipv6Addresses = object.ipv6Addresses?.map((e) => ServerIPv6Address.fromPartial(e)) || [];
    message.nameServers = object.nameServers?.map((e) => e) || [];
    message.speedMbps = object.speedMbps ?? 0;
    message.mtu = object.mtu ?? 0;
    return message;
  },
};

function createBaseServerPcieInterface(): ServerPcieInterface {
  return { maxLanes: 0, lanesInUse: 0, pcieType: "" };
}

export const ServerPcieInterface: MessageFns<ServerPcieInterface> = {
  encode(message: ServerPcieInterface, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.maxLanes !== 0) {
      writer.uint32(8).int32(message.maxLanes);
    }
    if (message.lanesInUse !== 0) {
      writer.uint32(16).int32(message.lanesInUse);
    }
    if (message.pcieType !== "") {
      writer.uint32(26).string(message.pcieType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerPcieInterface {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerPcieInterface();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.maxLanes = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.lanesInUse = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pcieType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerPcieInterface {
    return {
      maxLanes: isSet(object.maxLanes) ? globalThis.Number(object.maxLanes) : 0,
      lanesInUse: isSet(object.lanesInUse) ? globalThis.Number(object.lanesInUse) : 0,
      pcieType: isSet(object.pcieType) ? globalThis.String(object.pcieType) : "",
    };
  },

  toJSON(message: ServerPcieInterface): unknown {
    const obj: any = {};
    if (message.maxLanes !== 0) {
      obj.maxLanes = Math.round(message.maxLanes);
    }
    if (message.lanesInUse !== 0) {
      obj.lanesInUse = Math.round(message.lanesInUse);
    }
    if (message.pcieType !== "") {
      obj.pcieType = message.pcieType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerPcieInterface>, I>>(base?: I): ServerPcieInterface {
    return ServerPcieInterface.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerPcieInterface>, I>>(object: I): ServerPcieInterface {
    const message = createBaseServerPcieInterface();
    message.maxLanes = object.maxLanes ?? 0;
    message.lanesInUse = object.lanesInUse ?? 0;
    message.pcieType = object.pcieType ?? "";
    return message;
  },
};

function createBaseServerPcieDevice(): ServerPcieDevice {
  return {
    id: "",
    slotNumber: 0,
    name: "",
    partNumber: "",
    firmwareVersion: "",
    manufacturer: "",
    sku: "",
    serialNumber: "",
    model: "",
    pcieInterface: undefined,
  };
}

export const ServerPcieDevice: MessageFns<ServerPcieDevice> = {
  encode(message: ServerPcieDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.slotNumber !== 0) {
      writer.uint32(16).int32(message.slotNumber);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.partNumber !== "") {
      writer.uint32(34).string(message.partNumber);
    }
    if (message.firmwareVersion !== "") {
      writer.uint32(42).string(message.firmwareVersion);
    }
    if (message.manufacturer !== "") {
      writer.uint32(50).string(message.manufacturer);
    }
    if (message.sku !== "") {
      writer.uint32(58).string(message.sku);
    }
    if (message.serialNumber !== "") {
      writer.uint32(66).string(message.serialNumber);
    }
    if (message.model !== "") {
      writer.uint32(74).string(message.model);
    }
    if (message.pcieInterface !== undefined) {
      ServerPcieInterface.encode(message.pcieInterface, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerPcieDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerPcieDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.slotNumber = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.partNumber = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.firmwareVersion = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.sku = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pcieInterface = ServerPcieInterface.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerPcieDevice {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      slotNumber: isSet(object.slotNumber) ? globalThis.Number(object.slotNumber) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      partNumber: isSet(object.partNumber) ? globalThis.String(object.partNumber) : "",
      firmwareVersion: isSet(object.firmwareVersion) ? globalThis.String(object.firmwareVersion) : "",
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : "",
      sku: isSet(object.sku) ? globalThis.String(object.sku) : "",
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      pcieInterface: isSet(object.pcieInterface) ? ServerPcieInterface.fromJSON(object.pcieInterface) : undefined,
    };
  },

  toJSON(message: ServerPcieDevice): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.slotNumber !== 0) {
      obj.slotNumber = Math.round(message.slotNumber);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.partNumber !== "") {
      obj.partNumber = message.partNumber;
    }
    if (message.firmwareVersion !== "") {
      obj.firmwareVersion = message.firmwareVersion;
    }
    if (message.manufacturer !== "") {
      obj.manufacturer = message.manufacturer;
    }
    if (message.sku !== "") {
      obj.sku = message.sku;
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.pcieInterface !== undefined) {
      obj.pcieInterface = ServerPcieInterface.toJSON(message.pcieInterface);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerPcieDevice>, I>>(base?: I): ServerPcieDevice {
    return ServerPcieDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerPcieDevice>, I>>(object: I): ServerPcieDevice {
    const message = createBaseServerPcieDevice();
    message.id = object.id ?? "";
    message.slotNumber = object.slotNumber ?? 0;
    message.name = object.name ?? "";
    message.partNumber = object.partNumber ?? "";
    message.firmwareVersion = object.firmwareVersion ?? "";
    message.manufacturer = object.manufacturer ?? "";
    message.sku = object.sku ?? "";
    message.serialNumber = object.serialNumber ?? "";
    message.model = object.model ?? "";
    message.pcieInterface = (object.pcieInterface !== undefined && object.pcieInterface !== null)
      ? ServerPcieInterface.fromPartial(object.pcieInterface)
      : undefined;
    return message;
  },
};

function createBaseServerPCIeFunction(): ServerPCIeFunction {
  return { id: "", name: "", vendorId: "", deviceId: "", deviceName: "", ethernetInterfaceIds: [] };
}

export const ServerPCIeFunction: MessageFns<ServerPCIeFunction> = {
  encode(message: ServerPCIeFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.vendorId !== "") {
      writer.uint32(26).string(message.vendorId);
    }
    if (message.deviceId !== "") {
      writer.uint32(34).string(message.deviceId);
    }
    if (message.deviceName !== "") {
      writer.uint32(42).string(message.deviceName);
    }
    for (const v of message.ethernetInterfaceIds) {
      writer.uint32(50).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerPCIeFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerPCIeFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.vendorId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.deviceName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ethernetInterfaceIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerPCIeFunction {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      vendorId: isSet(object.vendorId) ? globalThis.String(object.vendorId) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      deviceName: isSet(object.deviceName) ? globalThis.String(object.deviceName) : "",
      ethernetInterfaceIds: globalThis.Array.isArray(object?.ethernetInterfaceIds)
        ? object.ethernetInterfaceIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ServerPCIeFunction): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.vendorId !== "") {
      obj.vendorId = message.vendorId;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.deviceName !== "") {
      obj.deviceName = message.deviceName;
    }
    if (message.ethernetInterfaceIds?.length) {
      obj.ethernetInterfaceIds = message.ethernetInterfaceIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerPCIeFunction>, I>>(base?: I): ServerPCIeFunction {
    return ServerPCIeFunction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerPCIeFunction>, I>>(object: I): ServerPCIeFunction {
    const message = createBaseServerPCIeFunction();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.vendorId = object.vendorId ?? "";
    message.deviceId = object.deviceId ?? "";
    message.deviceName = object.deviceName ?? "";
    message.ethernetInterfaceIds = object.ethernetInterfaceIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseServerStorageController(): ServerStorageController {
  return { id: "", manufacturer: "", model: "", serialNumber: "", firmwareVersion: "" };
}

export const ServerStorageController: MessageFns<ServerStorageController> = {
  encode(message: ServerStorageController, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.manufacturer !== "") {
      writer.uint32(18).string(message.manufacturer);
    }
    if (message.model !== "") {
      writer.uint32(26).string(message.model);
    }
    if (message.serialNumber !== "") {
      writer.uint32(34).string(message.serialNumber);
    }
    if (message.firmwareVersion !== "") {
      writer.uint32(42).string(message.firmwareVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerStorageController {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerStorageController();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.firmwareVersion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerStorageController {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : "",
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      firmwareVersion: isSet(object.firmwareVersion) ? globalThis.String(object.firmwareVersion) : "",
    };
  },

  toJSON(message: ServerStorageController): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.manufacturer !== "") {
      obj.manufacturer = message.manufacturer;
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.firmwareVersion !== "") {
      obj.firmwareVersion = message.firmwareVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerStorageController>, I>>(base?: I): ServerStorageController {
    return ServerStorageController.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerStorageController>, I>>(object: I): ServerStorageController {
    const message = createBaseServerStorageController();
    message.id = object.id ?? "";
    message.manufacturer = object.manufacturer ?? "";
    message.model = object.model ?? "";
    message.serialNumber = object.serialNumber ?? "";
    message.firmwareVersion = object.firmwareVersion ?? "";
    return message;
  },
};

function createBaseServerStorage(): ServerStorage {
  return { id: "", name: "", description: "", controllers: [] };
}

export const ServerStorage: MessageFns<ServerStorage> = {
  encode(message: ServerStorage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.controllers) {
      ServerStorageController.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerStorage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerStorage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.controllers.push(ServerStorageController.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerStorage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      controllers: globalThis.Array.isArray(object?.controllers)
        ? object.controllers.map((e: any) => ServerStorageController.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ServerStorage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.controllers?.length) {
      obj.controllers = message.controllers.map((e) => ServerStorageController.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerStorage>, I>>(base?: I): ServerStorage {
    return ServerStorage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerStorage>, I>>(object: I): ServerStorage {
    const message = createBaseServerStorage();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.controllers = object.controllers?.map((e) => ServerStorageController.fromPartial(e)) || [];
    return message;
  },
};

function createBaseServerDrive(): ServerDrive {
  return {
    id: "",
    name: "",
    description: "",
    manufacturer: "",
    model: "",
    mediaType: "",
    blockSizeBytes: 0,
    capacityBytes: "0",
    revision: "",
    serialNumber: "",
  };
}

export const ServerDrive: MessageFns<ServerDrive> = {
  encode(message: ServerDrive, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.manufacturer !== "") {
      writer.uint32(34).string(message.manufacturer);
    }
    if (message.model !== "") {
      writer.uint32(42).string(message.model);
    }
    if (message.mediaType !== "") {
      writer.uint32(50).string(message.mediaType);
    }
    if (message.blockSizeBytes !== 0) {
      writer.uint32(56).int32(message.blockSizeBytes);
    }
    if (message.capacityBytes !== "0") {
      writer.uint32(64).int64(message.capacityBytes);
    }
    if (message.revision !== "") {
      writer.uint32(74).string(message.revision);
    }
    if (message.serialNumber !== "") {
      writer.uint32(82).string(message.serialNumber);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerDrive {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerDrive();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.mediaType = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.blockSizeBytes = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.capacityBytes = reader.int64().toString();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.revision = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerDrive {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : "",
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      mediaType: isSet(object.mediaType) ? globalThis.String(object.mediaType) : "",
      blockSizeBytes: isSet(object.blockSizeBytes) ? globalThis.Number(object.blockSizeBytes) : 0,
      capacityBytes: isSet(object.capacityBytes) ? globalThis.String(object.capacityBytes) : "0",
      revision: isSet(object.revision) ? globalThis.String(object.revision) : "",
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
    };
  },

  toJSON(message: ServerDrive): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.manufacturer !== "") {
      obj.manufacturer = message.manufacturer;
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.mediaType !== "") {
      obj.mediaType = message.mediaType;
    }
    if (message.blockSizeBytes !== 0) {
      obj.blockSizeBytes = Math.round(message.blockSizeBytes);
    }
    if (message.capacityBytes !== "0") {
      obj.capacityBytes = message.capacityBytes;
    }
    if (message.revision !== "") {
      obj.revision = message.revision;
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerDrive>, I>>(base?: I): ServerDrive {
    return ServerDrive.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerDrive>, I>>(object: I): ServerDrive {
    const message = createBaseServerDrive();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.manufacturer = object.manufacturer ?? "";
    message.model = object.model ?? "";
    message.mediaType = object.mediaType ?? "";
    message.blockSizeBytes = object.blockSizeBytes ?? 0;
    message.capacityBytes = object.capacityBytes ?? "0";
    message.revision = object.revision ?? "";
    message.serialNumber = object.serialNumber ?? "";
    return message;
  },
};

function createBaseServerTemperature(): ServerTemperature {
  return {
    name: "",
    sensorNumber: 0,
    memberId: "",
    physicalContext: "",
    readingCelsius: 0,
    lowerThresholdCritical: 0,
    lowerThresholdNonCritical: 0,
    upperThresholdCritical: 0,
    upperThresholdNonCritical: 0,
    minReadingRangeTemp: 0,
    maxReadingRangeTemp: 0,
  };
}

export const ServerTemperature: MessageFns<ServerTemperature> = {
  encode(message: ServerTemperature, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.sensorNumber !== 0) {
      writer.uint32(16).int32(message.sensorNumber);
    }
    if (message.memberId !== "") {
      writer.uint32(26).string(message.memberId);
    }
    if (message.physicalContext !== "") {
      writer.uint32(34).string(message.physicalContext);
    }
    if (message.readingCelsius !== 0) {
      writer.uint32(45).float(message.readingCelsius);
    }
    if (message.lowerThresholdCritical !== 0) {
      writer.uint32(53).float(message.lowerThresholdCritical);
    }
    if (message.lowerThresholdNonCritical !== 0) {
      writer.uint32(61).float(message.lowerThresholdNonCritical);
    }
    if (message.upperThresholdCritical !== 0) {
      writer.uint32(69).float(message.upperThresholdCritical);
    }
    if (message.upperThresholdNonCritical !== 0) {
      writer.uint32(77).float(message.upperThresholdNonCritical);
    }
    if (message.minReadingRangeTemp !== 0) {
      writer.uint32(85).float(message.minReadingRangeTemp);
    }
    if (message.maxReadingRangeTemp !== 0) {
      writer.uint32(93).float(message.maxReadingRangeTemp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerTemperature {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerTemperature();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sensorNumber = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.memberId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.physicalContext = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.readingCelsius = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.lowerThresholdCritical = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.lowerThresholdNonCritical = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.upperThresholdCritical = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.upperThresholdNonCritical = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.minReadingRangeTemp = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.maxReadingRangeTemp = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerTemperature {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      sensorNumber: isSet(object.sensorNumber) ? globalThis.Number(object.sensorNumber) : 0,
      memberId: isSet(object.memberId) ? globalThis.String(object.memberId) : "",
      physicalContext: isSet(object.physicalContext) ? globalThis.String(object.physicalContext) : "",
      readingCelsius: isSet(object.readingCelsius) ? globalThis.Number(object.readingCelsius) : 0,
      lowerThresholdCritical: isSet(object.lowerThresholdCritical)
        ? globalThis.Number(object.lowerThresholdCritical)
        : 0,
      lowerThresholdNonCritical: isSet(object.lowerThresholdNonCritical)
        ? globalThis.Number(object.lowerThresholdNonCritical)
        : 0,
      upperThresholdCritical: isSet(object.upperThresholdCritical)
        ? globalThis.Number(object.upperThresholdCritical)
        : 0,
      upperThresholdNonCritical: isSet(object.upperThresholdNonCritical)
        ? globalThis.Number(object.upperThresholdNonCritical)
        : 0,
      minReadingRangeTemp: isSet(object.minReadingRangeTemp) ? globalThis.Number(object.minReadingRangeTemp) : 0,
      maxReadingRangeTemp: isSet(object.maxReadingRangeTemp) ? globalThis.Number(object.maxReadingRangeTemp) : 0,
    };
  },

  toJSON(message: ServerTemperature): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.sensorNumber !== 0) {
      obj.sensorNumber = Math.round(message.sensorNumber);
    }
    if (message.memberId !== "") {
      obj.memberId = message.memberId;
    }
    if (message.physicalContext !== "") {
      obj.physicalContext = message.physicalContext;
    }
    if (message.readingCelsius !== 0) {
      obj.readingCelsius = message.readingCelsius;
    }
    if (message.lowerThresholdCritical !== 0) {
      obj.lowerThresholdCritical = message.lowerThresholdCritical;
    }
    if (message.lowerThresholdNonCritical !== 0) {
      obj.lowerThresholdNonCritical = message.lowerThresholdNonCritical;
    }
    if (message.upperThresholdCritical !== 0) {
      obj.upperThresholdCritical = message.upperThresholdCritical;
    }
    if (message.upperThresholdNonCritical !== 0) {
      obj.upperThresholdNonCritical = message.upperThresholdNonCritical;
    }
    if (message.minReadingRangeTemp !== 0) {
      obj.minReadingRangeTemp = message.minReadingRangeTemp;
    }
    if (message.maxReadingRangeTemp !== 0) {
      obj.maxReadingRangeTemp = message.maxReadingRangeTemp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerTemperature>, I>>(base?: I): ServerTemperature {
    return ServerTemperature.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerTemperature>, I>>(object: I): ServerTemperature {
    const message = createBaseServerTemperature();
    message.name = object.name ?? "";
    message.sensorNumber = object.sensorNumber ?? 0;
    message.memberId = object.memberId ?? "";
    message.physicalContext = object.physicalContext ?? "";
    message.readingCelsius = object.readingCelsius ?? 0;
    message.lowerThresholdCritical = object.lowerThresholdCritical ?? 0;
    message.lowerThresholdNonCritical = object.lowerThresholdNonCritical ?? 0;
    message.upperThresholdCritical = object.upperThresholdCritical ?? 0;
    message.upperThresholdNonCritical = object.upperThresholdNonCritical ?? 0;
    message.minReadingRangeTemp = object.minReadingRangeTemp ?? 0;
    message.maxReadingRangeTemp = object.maxReadingRangeTemp ?? 0;
    return message;
  },
};

function createBaseServerThermal(): ServerThermal {
  return { temperatures: [] };
}

export const ServerThermal: MessageFns<ServerThermal> = {
  encode(message: ServerThermal, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.temperatures) {
      ServerTemperature.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerThermal {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerThermal();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.temperatures.push(ServerTemperature.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerThermal {
    return {
      temperatures: globalThis.Array.isArray(object?.temperatures)
        ? object.temperatures.map((e: any) => ServerTemperature.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ServerThermal): unknown {
    const obj: any = {};
    if (message.temperatures?.length) {
      obj.temperatures = message.temperatures.map((e) => ServerTemperature.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerThermal>, I>>(base?: I): ServerThermal {
    return ServerThermal.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerThermal>, I>>(object: I): ServerThermal {
    const message = createBaseServerThermal();
    message.temperatures = object.temperatures?.map((e) => ServerTemperature.fromPartial(e)) || [];
    return message;
  },
};

function createBaseServerManager(): ServerManager {
  return { id: "", name: "", managerType: "", ethernetInterfaces: [], certificates: [] };
}

export const ServerManager: MessageFns<ServerManager> = {
  encode(message: ServerManager, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.managerType !== "") {
      writer.uint32(26).string(message.managerType);
    }
    for (const v of message.ethernetInterfaces) {
      ServerEthernetInterface.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.certificates) {
      ServerCertificate.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerManager {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerManager();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.managerType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ethernetInterfaces.push(ServerEthernetInterface.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.certificates.push(ServerCertificate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerManager {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      managerType: isSet(object.managerType) ? globalThis.String(object.managerType) : "",
      ethernetInterfaces: globalThis.Array.isArray(object?.ethernetInterfaces)
        ? object.ethernetInterfaces.map((e: any) => ServerEthernetInterface.fromJSON(e))
        : [],
      certificates: globalThis.Array.isArray(object?.certificates)
        ? object.certificates.map((e: any) => ServerCertificate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ServerManager): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.managerType !== "") {
      obj.managerType = message.managerType;
    }
    if (message.ethernetInterfaces?.length) {
      obj.ethernetInterfaces = message.ethernetInterfaces.map((e) => ServerEthernetInterface.toJSON(e));
    }
    if (message.certificates?.length) {
      obj.certificates = message.certificates.map((e) => ServerCertificate.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerManager>, I>>(base?: I): ServerManager {
    return ServerManager.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerManager>, I>>(object: I): ServerManager {
    const message = createBaseServerManager();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.managerType = object.managerType ?? "";
    message.ethernetInterfaces = object.ethernetInterfaces?.map((e) => ServerEthernetInterface.fromPartial(e)) || [];
    message.certificates = object.certificates?.map((e) => ServerCertificate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseServerCertificateIssuerOrSubject(): ServerCertificateIssuerOrSubject {
  return { commonName: "", organization: "", organizationUnit: "", city: "", state: "", country: "" };
}

export const ServerCertificateIssuerOrSubject: MessageFns<ServerCertificateIssuerOrSubject> = {
  encode(message: ServerCertificateIssuerOrSubject, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.commonName !== "") {
      writer.uint32(10).string(message.commonName);
    }
    if (message.organization !== "") {
      writer.uint32(18).string(message.organization);
    }
    if (message.organizationUnit !== "") {
      writer.uint32(26).string(message.organizationUnit);
    }
    if (message.city !== "") {
      writer.uint32(34).string(message.city);
    }
    if (message.state !== "") {
      writer.uint32(42).string(message.state);
    }
    if (message.country !== "") {
      writer.uint32(50).string(message.country);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerCertificateIssuerOrSubject {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerCertificateIssuerOrSubject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.commonName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.organization = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.organizationUnit = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.city = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.state = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.country = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerCertificateIssuerOrSubject {
    return {
      commonName: isSet(object.commonName) ? globalThis.String(object.commonName) : "",
      organization: isSet(object.organization) ? globalThis.String(object.organization) : "",
      organizationUnit: isSet(object.organizationUnit) ? globalThis.String(object.organizationUnit) : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      state: isSet(object.state) ? globalThis.String(object.state) : "",
      country: isSet(object.country) ? globalThis.String(object.country) : "",
    };
  },

  toJSON(message: ServerCertificateIssuerOrSubject): unknown {
    const obj: any = {};
    if (message.commonName !== "") {
      obj.commonName = message.commonName;
    }
    if (message.organization !== "") {
      obj.organization = message.organization;
    }
    if (message.organizationUnit !== "") {
      obj.organizationUnit = message.organizationUnit;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    if (message.country !== "") {
      obj.country = message.country;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerCertificateIssuerOrSubject>, I>>(
    base?: I,
  ): ServerCertificateIssuerOrSubject {
    return ServerCertificateIssuerOrSubject.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerCertificateIssuerOrSubject>, I>>(
    object: I,
  ): ServerCertificateIssuerOrSubject {
    const message = createBaseServerCertificateIssuerOrSubject();
    message.commonName = object.commonName ?? "";
    message.organization = object.organization ?? "";
    message.organizationUnit = object.organizationUnit ?? "";
    message.city = object.city ?? "";
    message.state = object.state ?? "";
    message.country = object.country ?? "";
    return message;
  },
};

function createBaseServerCertificate(): ServerCertificate {
  return {
    id: "",
    name: "",
    description: "",
    certString: "",
    certType: "",
    validNotBefore: "",
    validNotAfter: "",
    issuer: undefined,
    subject: undefined,
    serialNumber: "",
  };
}

export const ServerCertificate: MessageFns<ServerCertificate> = {
  encode(message: ServerCertificate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.certString !== "") {
      writer.uint32(34).string(message.certString);
    }
    if (message.certType !== "") {
      writer.uint32(42).string(message.certType);
    }
    if (message.validNotBefore !== "") {
      writer.uint32(50).string(message.validNotBefore);
    }
    if (message.validNotAfter !== "") {
      writer.uint32(58).string(message.validNotAfter);
    }
    if (message.issuer !== undefined) {
      ServerCertificateIssuerOrSubject.encode(message.issuer, writer.uint32(66).fork()).join();
    }
    if (message.subject !== undefined) {
      ServerCertificateIssuerOrSubject.encode(message.subject, writer.uint32(74).fork()).join();
    }
    if (message.serialNumber !== "") {
      writer.uint32(82).string(message.serialNumber);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerCertificate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerCertificate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.certString = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.certType = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.validNotBefore = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.validNotAfter = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.issuer = ServerCertificateIssuerOrSubject.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.subject = ServerCertificateIssuerOrSubject.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerCertificate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      certString: isSet(object.certString) ? globalThis.String(object.certString) : "",
      certType: isSet(object.certType) ? globalThis.String(object.certType) : "",
      validNotBefore: isSet(object.validNotBefore) ? globalThis.String(object.validNotBefore) : "",
      validNotAfter: isSet(object.validNotAfter) ? globalThis.String(object.validNotAfter) : "",
      issuer: isSet(object.issuer) ? ServerCertificateIssuerOrSubject.fromJSON(object.issuer) : undefined,
      subject: isSet(object.subject) ? ServerCertificateIssuerOrSubject.fromJSON(object.subject) : undefined,
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
    };
  },

  toJSON(message: ServerCertificate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.certString !== "") {
      obj.certString = message.certString;
    }
    if (message.certType !== "") {
      obj.certType = message.certType;
    }
    if (message.validNotBefore !== "") {
      obj.validNotBefore = message.validNotBefore;
    }
    if (message.validNotAfter !== "") {
      obj.validNotAfter = message.validNotAfter;
    }
    if (message.issuer !== undefined) {
      obj.issuer = ServerCertificateIssuerOrSubject.toJSON(message.issuer);
    }
    if (message.subject !== undefined) {
      obj.subject = ServerCertificateIssuerOrSubject.toJSON(message.subject);
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerCertificate>, I>>(base?: I): ServerCertificate {
    return ServerCertificate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerCertificate>, I>>(object: I): ServerCertificate {
    const message = createBaseServerCertificate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.certString = object.certString ?? "";
    message.certType = object.certType ?? "";
    message.validNotBefore = object.validNotBefore ?? "";
    message.validNotAfter = object.validNotAfter ?? "";
    message.issuer = (object.issuer !== undefined && object.issuer !== null)
      ? ServerCertificateIssuerOrSubject.fromPartial(object.issuer)
      : undefined;
    message.subject = (object.subject !== undefined && object.subject !== null)
      ? ServerCertificateIssuerOrSubject.fromPartial(object.subject)
      : undefined;
    message.serialNumber = object.serialNumber ?? "";
    return message;
  },
};

function createBaseManagedEndpointServerInfo(): ManagedEndpointServerInfo {
  return {
    manufacturer: "",
    product: "",
    version: "",
    serialNum: "",
    uuid: "",
    sku: "",
    family: "",
    pcieSlot: 0,
    pcieBus: 0,
    pcieFunction: 0,
  };
}

export const ManagedEndpointServerInfo: MessageFns<ManagedEndpointServerInfo> = {
  encode(message: ManagedEndpointServerInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.manufacturer !== "") {
      writer.uint32(10).string(message.manufacturer);
    }
    if (message.product !== "") {
      writer.uint32(18).string(message.product);
    }
    if (message.version !== "") {
      writer.uint32(26).string(message.version);
    }
    if (message.serialNum !== "") {
      writer.uint32(34).string(message.serialNum);
    }
    if (message.uuid !== "") {
      writer.uint32(42).string(message.uuid);
    }
    if (message.sku !== "") {
      writer.uint32(50).string(message.sku);
    }
    if (message.family !== "") {
      writer.uint32(58).string(message.family);
    }
    if (message.pcieSlot !== 0) {
      writer.uint32(64).uint32(message.pcieSlot);
    }
    if (message.pcieBus !== 0) {
      writer.uint32(72).uint32(message.pcieBus);
    }
    if (message.pcieFunction !== 0) {
      writer.uint32(80).uint32(message.pcieFunction);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManagedEndpointServerInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManagedEndpointServerInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.product = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.serialNum = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.sku = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.family = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.pcieSlot = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.pcieBus = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.pcieFunction = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManagedEndpointServerInfo {
    return {
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : "",
      product: isSet(object.product) ? globalThis.String(object.product) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      serialNum: isSet(object.serialNum) ? globalThis.String(object.serialNum) : "",
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      sku: isSet(object.sku) ? globalThis.String(object.sku) : "",
      family: isSet(object.family) ? globalThis.String(object.family) : "",
      pcieSlot: isSet(object.pcieSlot) ? globalThis.Number(object.pcieSlot) : 0,
      pcieBus: isSet(object.pcieBus) ? globalThis.Number(object.pcieBus) : 0,
      pcieFunction: isSet(object.pcieFunction) ? globalThis.Number(object.pcieFunction) : 0,
    };
  },

  toJSON(message: ManagedEndpointServerInfo): unknown {
    const obj: any = {};
    if (message.manufacturer !== "") {
      obj.manufacturer = message.manufacturer;
    }
    if (message.product !== "") {
      obj.product = message.product;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.serialNum !== "") {
      obj.serialNum = message.serialNum;
    }
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.sku !== "") {
      obj.sku = message.sku;
    }
    if (message.family !== "") {
      obj.family = message.family;
    }
    if (message.pcieSlot !== 0) {
      obj.pcieSlot = Math.round(message.pcieSlot);
    }
    if (message.pcieBus !== 0) {
      obj.pcieBus = Math.round(message.pcieBus);
    }
    if (message.pcieFunction !== 0) {
      obj.pcieFunction = Math.round(message.pcieFunction);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManagedEndpointServerInfo>, I>>(base?: I): ManagedEndpointServerInfo {
    return ManagedEndpointServerInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManagedEndpointServerInfo>, I>>(object: I): ManagedEndpointServerInfo {
    const message = createBaseManagedEndpointServerInfo();
    message.manufacturer = object.manufacturer ?? "";
    message.product = object.product ?? "";
    message.version = object.version ?? "";
    message.serialNum = object.serialNum ?? "";
    message.uuid = object.uuid ?? "";
    message.sku = object.sku ?? "";
    message.family = object.family ?? "";
    message.pcieSlot = object.pcieSlot ?? 0;
    message.pcieBus = object.pcieBus ?? 0;
    message.pcieFunction = object.pcieFunction ?? 0;
    return message;
  },
};

function createBaseManagedEndpointLldpInfo(): ManagedEndpointLldpInfo {
  return { macAddress: "", sysName: "", sysDesc: "", localInterface: "", mgmtAddrs: [], serverInfo: undefined };
}

export const ManagedEndpointLldpInfo: MessageFns<ManagedEndpointLldpInfo> = {
  encode(message: ManagedEndpointLldpInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.macAddress !== "") {
      writer.uint32(10).string(message.macAddress);
    }
    if (message.sysName !== "") {
      writer.uint32(18).string(message.sysName);
    }
    if (message.sysDesc !== "") {
      writer.uint32(26).string(message.sysDesc);
    }
    if (message.localInterface !== "") {
      writer.uint32(34).string(message.localInterface);
    }
    for (const v of message.mgmtAddrs) {
      writer.uint32(42).string(v!);
    }
    if (message.serverInfo !== undefined) {
      ManagedEndpointServerInfo.encode(message.serverInfo, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManagedEndpointLldpInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManagedEndpointLldpInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.macAddress = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sysName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sysDesc = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.localInterface = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.mgmtAddrs.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.serverInfo = ManagedEndpointServerInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManagedEndpointLldpInfo {
    return {
      macAddress: isSet(object.macAddress) ? globalThis.String(object.macAddress) : "",
      sysName: isSet(object.sysName) ? globalThis.String(object.sysName) : "",
      sysDesc: isSet(object.sysDesc) ? globalThis.String(object.sysDesc) : "",
      localInterface: isSet(object.localInterface) ? globalThis.String(object.localInterface) : "",
      mgmtAddrs: globalThis.Array.isArray(object?.mgmtAddrs)
        ? object.mgmtAddrs.map((e: any) => globalThis.String(e))
        : [],
      serverInfo: isSet(object.serverInfo) ? ManagedEndpointServerInfo.fromJSON(object.serverInfo) : undefined,
    };
  },

  toJSON(message: ManagedEndpointLldpInfo): unknown {
    const obj: any = {};
    if (message.macAddress !== "") {
      obj.macAddress = message.macAddress;
    }
    if (message.sysName !== "") {
      obj.sysName = message.sysName;
    }
    if (message.sysDesc !== "") {
      obj.sysDesc = message.sysDesc;
    }
    if (message.localInterface !== "") {
      obj.localInterface = message.localInterface;
    }
    if (message.mgmtAddrs?.length) {
      obj.mgmtAddrs = message.mgmtAddrs;
    }
    if (message.serverInfo !== undefined) {
      obj.serverInfo = ManagedEndpointServerInfo.toJSON(message.serverInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManagedEndpointLldpInfo>, I>>(base?: I): ManagedEndpointLldpInfo {
    return ManagedEndpointLldpInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManagedEndpointLldpInfo>, I>>(object: I): ManagedEndpointLldpInfo {
    const message = createBaseManagedEndpointLldpInfo();
    message.macAddress = object.macAddress ?? "";
    message.sysName = object.sysName ?? "";
    message.sysDesc = object.sysDesc ?? "";
    message.localInterface = object.localInterface ?? "";
    message.mgmtAddrs = object.mgmtAddrs?.map((e) => e) || [];
    message.serverInfo = (object.serverInfo !== undefined && object.serverInfo !== null)
      ? ManagedEndpointServerInfo.fromPartial(object.serverInfo)
      : undefined;
    return message;
  },
};

function createBaseServerSystem(): ServerSystem {
  return { id: "", name: "", manufacturer: "", model: "", serialNum: "", uuid: "", hostName: "", powerState: 0 };
}

export const ServerSystem: MessageFns<ServerSystem> = {
  encode(message: ServerSystem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.manufacturer !== "") {
      writer.uint32(26).string(message.manufacturer);
    }
    if (message.model !== "") {
      writer.uint32(34).string(message.model);
    }
    if (message.serialNum !== "") {
      writer.uint32(42).string(message.serialNum);
    }
    if (message.uuid !== "") {
      writer.uint32(50).string(message.uuid);
    }
    if (message.hostName !== "") {
      writer.uint32(58).string(message.hostName);
    }
    if (message.powerState !== 0) {
      writer.uint32(64).int32(message.powerState);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerSystem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerSystem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.serialNum = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.hostName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.powerState = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerSystem {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : "",
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      serialNum: isSet(object.serialNum) ? globalThis.String(object.serialNum) : "",
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      hostName: isSet(object.hostName) ? globalThis.String(object.hostName) : "",
      powerState: isSet(object.powerState) ? powerStateEnumFromJSON(object.powerState) : 0,
    };
  },

  toJSON(message: ServerSystem): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.manufacturer !== "") {
      obj.manufacturer = message.manufacturer;
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.serialNum !== "") {
      obj.serialNum = message.serialNum;
    }
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.hostName !== "") {
      obj.hostName = message.hostName;
    }
    if (message.powerState !== 0) {
      obj.powerState = powerStateEnumToJSON(message.powerState);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerSystem>, I>>(base?: I): ServerSystem {
    return ServerSystem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerSystem>, I>>(object: I): ServerSystem {
    const message = createBaseServerSystem();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.manufacturer = object.manufacturer ?? "";
    message.model = object.model ?? "";
    message.serialNum = object.serialNum ?? "";
    message.uuid = object.uuid ?? "";
    message.hostName = object.hostName ?? "";
    message.powerState = object.powerState ?? 0;
    return message;
  },
};

function createBaseManagedEndpointOtherState(): ManagedEndpointOtherState {
  return { state: 0, description: "" };
}

export const ManagedEndpointOtherState: MessageFns<ManagedEndpointOtherState> = {
  encode(message: ManagedEndpointOtherState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.state !== 0) {
      writer.uint32(8).int32(message.state);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManagedEndpointOtherState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManagedEndpointOtherState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManagedEndpointOtherState {
    return {
      state: isSet(object.state) ? managedEndpointOtherStateEnumFromJSON(object.state) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: ManagedEndpointOtherState): unknown {
    const obj: any = {};
    if (message.state !== 0) {
      obj.state = managedEndpointOtherStateEnumToJSON(message.state);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManagedEndpointOtherState>, I>>(base?: I): ManagedEndpointOtherState {
    return ManagedEndpointOtherState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManagedEndpointOtherState>, I>>(object: I): ManagedEndpointOtherState {
    const message = createBaseManagedEndpointOtherState();
    message.state = object.state ?? 0;
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseManagedEndpoint(): ManagedEndpoint {
  return {
    lldpInfo: undefined,
    lastLldpReceivedAt: undefined,
    lastConnectedAt: undefined,
    connectivityStatus: 0,
    connectionReason: "",
    meType: 0,
    spdmSupported: false,
    otherStates: [],
  };
}

export const ManagedEndpoint: MessageFns<ManagedEndpoint> = {
  encode(message: ManagedEndpoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.lldpInfo !== undefined) {
      ManagedEndpointLldpInfo.encode(message.lldpInfo, writer.uint32(10).fork()).join();
    }
    if (message.lastLldpReceivedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.lastLldpReceivedAt), writer.uint32(18).fork()).join();
    }
    if (message.lastConnectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.lastConnectedAt), writer.uint32(26).fork()).join();
    }
    if (message.connectivityStatus !== 0) {
      writer.uint32(32).int32(message.connectivityStatus);
    }
    if (message.connectionReason !== "") {
      writer.uint32(42).string(message.connectionReason);
    }
    if (message.meType !== 0) {
      writer.uint32(48).int32(message.meType);
    }
    if (message.spdmSupported !== false) {
      writer.uint32(56).bool(message.spdmSupported);
    }
    for (const v of message.otherStates) {
      ManagedEndpointOtherState.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManagedEndpoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManagedEndpoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.lldpInfo = ManagedEndpointLldpInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lastLldpReceivedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lastConnectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.connectivityStatus = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.connectionReason = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.meType = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.spdmSupported = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.otherStates.push(ManagedEndpointOtherState.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManagedEndpoint {
    return {
      lldpInfo: isSet(object.lldpInfo) ? ManagedEndpointLldpInfo.fromJSON(object.lldpInfo) : undefined,
      lastLldpReceivedAt: isSet(object.lastLldpReceivedAt) ? fromJsonTimestamp(object.lastLldpReceivedAt) : undefined,
      lastConnectedAt: isSet(object.lastConnectedAt) ? fromJsonTimestamp(object.lastConnectedAt) : undefined,
      connectivityStatus: isSet(object.connectivityStatus) ? connectivityStatusFromJSON(object.connectivityStatus) : 0,
      connectionReason: isSet(object.connectionReason) ? globalThis.String(object.connectionReason) : "",
      meType: isSet(object.meType) ? managedEndpointTypeFromJSON(object.meType) : 0,
      spdmSupported: isSet(object.spdmSupported) ? globalThis.Boolean(object.spdmSupported) : false,
      otherStates: globalThis.Array.isArray(object?.otherStates)
        ? object.otherStates.map((e: any) => ManagedEndpointOtherState.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ManagedEndpoint): unknown {
    const obj: any = {};
    if (message.lldpInfo !== undefined) {
      obj.lldpInfo = ManagedEndpointLldpInfo.toJSON(message.lldpInfo);
    }
    if (message.lastLldpReceivedAt !== undefined) {
      obj.lastLldpReceivedAt = message.lastLldpReceivedAt.toISOString();
    }
    if (message.lastConnectedAt !== undefined) {
      obj.lastConnectedAt = message.lastConnectedAt.toISOString();
    }
    if (message.connectivityStatus !== 0) {
      obj.connectivityStatus = connectivityStatusToJSON(message.connectivityStatus);
    }
    if (message.connectionReason !== "") {
      obj.connectionReason = message.connectionReason;
    }
    if (message.meType !== 0) {
      obj.meType = managedEndpointTypeToJSON(message.meType);
    }
    if (message.spdmSupported !== false) {
      obj.spdmSupported = message.spdmSupported;
    }
    if (message.otherStates?.length) {
      obj.otherStates = message.otherStates.map((e) => ManagedEndpointOtherState.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManagedEndpoint>, I>>(base?: I): ManagedEndpoint {
    return ManagedEndpoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManagedEndpoint>, I>>(object: I): ManagedEndpoint {
    const message = createBaseManagedEndpoint();
    message.lldpInfo = (object.lldpInfo !== undefined && object.lldpInfo !== null)
      ? ManagedEndpointLldpInfo.fromPartial(object.lldpInfo)
      : undefined;
    message.lastLldpReceivedAt = object.lastLldpReceivedAt ?? undefined;
    message.lastConnectedAt = object.lastConnectedAt ?? undefined;
    message.connectivityStatus = object.connectivityStatus ?? 0;
    message.connectionReason = object.connectionReason ?? "";
    message.meType = object.meType ?? 0;
    message.spdmSupported = object.spdmSupported ?? false;
    message.otherStates = object.otherStates?.map((e) => ManagedEndpointOtherState.fromPartial(e)) || [];
    return message;
  },
};

function createBaseServerPortInfo(): ServerPortInfo {
  return {
    id: undefined,
    name: "",
    mac: "",
    adminState: 0,
    operState: 0,
    adaptorId: "",
    rfPortName: "",
    osNativeIfName: "",
  };
}

export const ServerPortInfo: MessageFns<ServerPortInfo> = {
  encode(message: ServerPortInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.mac !== "") {
      writer.uint32(34).string(message.mac);
    }
    if (message.adminState !== 0) {
      writer.uint32(40).int32(message.adminState);
    }
    if (message.operState !== 0) {
      writer.uint32(48).int32(message.operState);
    }
    if (message.adaptorId !== "") {
      writer.uint32(58).string(message.adaptorId);
    }
    if (message.rfPortName !== "") {
      writer.uint32(66).string(message.rfPortName);
    }
    if (message.osNativeIfName !== "") {
      writer.uint32(74).string(message.osNativeIfName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerPortInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerPortInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.mac = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.adminState = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.operState = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.adaptorId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.rfPortName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.osNativeIfName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerPortInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      mac: isSet(object.mac) ? globalThis.String(object.mac) : "",
      adminState: isSet(object.adminState) ? adminStateFromJSON(object.adminState) : 0,
      operState: isSet(object.operState) ? operStateFromJSON(object.operState) : 0,
      adaptorId: isSet(object.adaptorId) ? globalThis.String(object.adaptorId) : "",
      rfPortName: isSet(object.rfPortName) ? globalThis.String(object.rfPortName) : "",
      osNativeIfName: isSet(object.osNativeIfName) ? globalThis.String(object.osNativeIfName) : "",
    };
  },

  toJSON(message: ServerPortInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.mac !== "") {
      obj.mac = message.mac;
    }
    if (message.adminState !== 0) {
      obj.adminState = adminStateToJSON(message.adminState);
    }
    if (message.operState !== 0) {
      obj.operState = operStateToJSON(message.operState);
    }
    if (message.adaptorId !== "") {
      obj.adaptorId = message.adaptorId;
    }
    if (message.rfPortName !== "") {
      obj.rfPortName = message.rfPortName;
    }
    if (message.osNativeIfName !== "") {
      obj.osNativeIfName = message.osNativeIfName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerPortInfo>, I>>(base?: I): ServerPortInfo {
    return ServerPortInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerPortInfo>, I>>(object: I): ServerPortInfo {
    const message = createBaseServerPortInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.name = object.name ?? "";
    message.mac = object.mac ?? "";
    message.adminState = object.adminState ?? 0;
    message.operState = object.operState ?? 0;
    message.adaptorId = object.adaptorId ?? "";
    message.rfPortName = object.rfPortName ?? "";
    message.osNativeIfName = object.osNativeIfName ?? "";
    return message;
  },
};

function createBaseBmcServerPortInfo(): BmcServerPortInfo {
  return { id: undefined, serverPortInfo: undefined };
}

export const BmcServerPortInfo: MessageFns<BmcServerPortInfo> = {
  encode(message: BmcServerPortInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.serverPortInfo !== undefined) {
      ServerPortInfo.encode(message.serverPortInfo, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BmcServerPortInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBmcServerPortInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serverPortInfo = ServerPortInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BmcServerPortInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      serverPortInfo: isSet(object.serverPortInfo) ? ServerPortInfo.fromJSON(object.serverPortInfo) : undefined,
    };
  },

  toJSON(message: BmcServerPortInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.serverPortInfo !== undefined) {
      obj.serverPortInfo = ServerPortInfo.toJSON(message.serverPortInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BmcServerPortInfo>, I>>(base?: I): BmcServerPortInfo {
    return BmcServerPortInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BmcServerPortInfo>, I>>(object: I): BmcServerPortInfo {
    const message = createBaseBmcServerPortInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.serverPortInfo = (object.serverPortInfo !== undefined && object.serverPortInfo !== null)
      ? ServerPortInfo.fromPartial(object.serverPortInfo)
      : undefined;
    return message;
  },
};

function createBaseBmc(): Bmc {
  return {
    id: undefined,
    managedEndpoint: undefined,
    state: 0,
    preAuthInfo: undefined,
    bmcProduct: 0,
    firmwareInventory: [],
    serverSystem: undefined,
    bmcManager: undefined,
    serverDeviceId: "",
  };
}

export const Bmc: MessageFns<Bmc> = {
  encode(message: Bmc, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.managedEndpoint !== undefined) {
      ManagedEndpoint.encode(message.managedEndpoint, writer.uint32(18).fork()).join();
    }
    if (message.state !== 0) {
      writer.uint32(24).int32(message.state);
    }
    if (message.preAuthInfo !== undefined) {
      ServerBmcPreAuthInfo.encode(message.preAuthInfo, writer.uint32(34).fork()).join();
    }
    if (message.bmcProduct !== 0) {
      writer.uint32(40).int32(message.bmcProduct);
    }
    for (const v of message.firmwareInventory) {
      ServerFirmwareInventoryItem.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.serverSystem !== undefined) {
      ServerSystem.encode(message.serverSystem, writer.uint32(58).fork()).join();
    }
    if (message.bmcManager !== undefined) {
      ServerManager.encode(message.bmcManager, writer.uint32(66).fork()).join();
    }
    if (message.serverDeviceId !== "") {
      writer.uint32(74).string(message.serverDeviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Bmc {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBmc();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.managedEndpoint = ManagedEndpoint.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.preAuthInfo = ServerBmcPreAuthInfo.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.bmcProduct = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.firmwareInventory.push(ServerFirmwareInventoryItem.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.serverSystem = ServerSystem.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.bmcManager = ServerManager.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.serverDeviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Bmc {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      managedEndpoint: isSet(object.managedEndpoint) ? ManagedEndpoint.fromJSON(object.managedEndpoint) : undefined,
      state: isSet(object.state) ? bmcStateTypeFromJSON(object.state) : 0,
      preAuthInfo: isSet(object.preAuthInfo) ? ServerBmcPreAuthInfo.fromJSON(object.preAuthInfo) : undefined,
      bmcProduct: isSet(object.bmcProduct) ? bmcProductTypeFromJSON(object.bmcProduct) : 0,
      firmwareInventory: globalThis.Array.isArray(object?.firmwareInventory)
        ? object.firmwareInventory.map((e: any) => ServerFirmwareInventoryItem.fromJSON(e))
        : [],
      serverSystem: isSet(object.serverSystem) ? ServerSystem.fromJSON(object.serverSystem) : undefined,
      bmcManager: isSet(object.bmcManager) ? ServerManager.fromJSON(object.bmcManager) : undefined,
      serverDeviceId: isSet(object.serverDeviceId) ? globalThis.String(object.serverDeviceId) : "",
    };
  },

  toJSON(message: Bmc): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.managedEndpoint !== undefined) {
      obj.managedEndpoint = ManagedEndpoint.toJSON(message.managedEndpoint);
    }
    if (message.state !== 0) {
      obj.state = bmcStateTypeToJSON(message.state);
    }
    if (message.preAuthInfo !== undefined) {
      obj.preAuthInfo = ServerBmcPreAuthInfo.toJSON(message.preAuthInfo);
    }
    if (message.bmcProduct !== 0) {
      obj.bmcProduct = bmcProductTypeToJSON(message.bmcProduct);
    }
    if (message.firmwareInventory?.length) {
      obj.firmwareInventory = message.firmwareInventory.map((e) => ServerFirmwareInventoryItem.toJSON(e));
    }
    if (message.serverSystem !== undefined) {
      obj.serverSystem = ServerSystem.toJSON(message.serverSystem);
    }
    if (message.bmcManager !== undefined) {
      obj.bmcManager = ServerManager.toJSON(message.bmcManager);
    }
    if (message.serverDeviceId !== "") {
      obj.serverDeviceId = message.serverDeviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Bmc>, I>>(base?: I): Bmc {
    return Bmc.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Bmc>, I>>(object: I): Bmc {
    const message = createBaseBmc();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.managedEndpoint = (object.managedEndpoint !== undefined && object.managedEndpoint !== null)
      ? ManagedEndpoint.fromPartial(object.managedEndpoint)
      : undefined;
    message.state = object.state ?? 0;
    message.preAuthInfo = (object.preAuthInfo !== undefined && object.preAuthInfo !== null)
      ? ServerBmcPreAuthInfo.fromPartial(object.preAuthInfo)
      : undefined;
    message.bmcProduct = object.bmcProduct ?? 0;
    message.firmwareInventory = object.firmwareInventory?.map((e) => ServerFirmwareInventoryItem.fromPartial(e)) || [];
    message.serverSystem = (object.serverSystem !== undefined && object.serverSystem !== null)
      ? ServerSystem.fromPartial(object.serverSystem)
      : undefined;
    message.bmcManager = (object.bmcManager !== undefined && object.bmcManager !== null)
      ? ServerManager.fromPartial(object.bmcManager)
      : undefined;
    message.serverDeviceId = object.serverDeviceId ?? "";
    return message;
  },
};

function createBaseServerFan(): ServerFan {
  return {
    id: undefined,
    fanId: 0,
    speed: 0,
    name: "",
    status: 0,
    position: 0,
    highThreshold: 0,
    lowThreshold: 0,
    highCriticalThreshold: 0,
    lowCriticalThreshold: 0,
    collectedAt: undefined,
  };
}

export const ServerFan: MessageFns<ServerFan> = {
  encode(message: ServerFan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.fanId !== 0) {
      writer.uint32(24).uint32(message.fanId);
    }
    if (message.speed !== 0) {
      writer.uint32(32).uint32(message.speed);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.status !== 0) {
      writer.uint32(48).int32(message.status);
    }
    if (message.position !== 0) {
      writer.uint32(56).int32(message.position);
    }
    if (message.highThreshold !== 0) {
      writer.uint32(64).uint32(message.highThreshold);
    }
    if (message.lowThreshold !== 0) {
      writer.uint32(72).uint32(message.lowThreshold);
    }
    if (message.highCriticalThreshold !== 0) {
      writer.uint32(80).uint32(message.highCriticalThreshold);
    }
    if (message.lowCriticalThreshold !== 0) {
      writer.uint32(88).uint32(message.lowCriticalThreshold);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerFan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerFan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fanId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.speed = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.position = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.highThreshold = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.lowThreshold = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.highCriticalThreshold = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.lowCriticalThreshold = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerFan {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      fanId: isSet(object.fanId) ? globalThis.Number(object.fanId) : 0,
      speed: isSet(object.speed) ? globalThis.Number(object.speed) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      status: isSet(object.status) ? envStatusFromJSON(object.status) : 0,
      position: isSet(object.position) ? serverFanPositionFromJSON(object.position) : 0,
      highThreshold: isSet(object.highThreshold) ? globalThis.Number(object.highThreshold) : 0,
      lowThreshold: isSet(object.lowThreshold) ? globalThis.Number(object.lowThreshold) : 0,
      highCriticalThreshold: isSet(object.highCriticalThreshold) ? globalThis.Number(object.highCriticalThreshold) : 0,
      lowCriticalThreshold: isSet(object.lowCriticalThreshold) ? globalThis.Number(object.lowCriticalThreshold) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: ServerFan): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.fanId !== 0) {
      obj.fanId = Math.round(message.fanId);
    }
    if (message.speed !== 0) {
      obj.speed = Math.round(message.speed);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.status !== 0) {
      obj.status = envStatusToJSON(message.status);
    }
    if (message.position !== 0) {
      obj.position = serverFanPositionToJSON(message.position);
    }
    if (message.highThreshold !== 0) {
      obj.highThreshold = Math.round(message.highThreshold);
    }
    if (message.lowThreshold !== 0) {
      obj.lowThreshold = Math.round(message.lowThreshold);
    }
    if (message.highCriticalThreshold !== 0) {
      obj.highCriticalThreshold = Math.round(message.highCriticalThreshold);
    }
    if (message.lowCriticalThreshold !== 0) {
      obj.lowCriticalThreshold = Math.round(message.lowCriticalThreshold);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerFan>, I>>(base?: I): ServerFan {
    return ServerFan.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerFan>, I>>(object: I): ServerFan {
    const message = createBaseServerFan();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.fanId = object.fanId ?? 0;
    message.speed = object.speed ?? 0;
    message.name = object.name ?? "";
    message.status = object.status ?? 0;
    message.position = object.position ?? 0;
    message.highThreshold = object.highThreshold ?? 0;
    message.lowThreshold = object.lowThreshold ?? 0;
    message.highCriticalThreshold = object.highCriticalThreshold ?? 0;
    message.lowCriticalThreshold = object.lowCriticalThreshold ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseBmcServerFan(): BmcServerFan {
  return { id: undefined, serverFan: undefined };
}

export const BmcServerFan: MessageFns<BmcServerFan> = {
  encode(message: BmcServerFan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.serverFan !== undefined) {
      ServerFan.encode(message.serverFan, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BmcServerFan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBmcServerFan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serverFan = ServerFan.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BmcServerFan {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      serverFan: isSet(object.serverFan) ? ServerFan.fromJSON(object.serverFan) : undefined,
    };
  },

  toJSON(message: BmcServerFan): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.serverFan !== undefined) {
      obj.serverFan = ServerFan.toJSON(message.serverFan);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BmcServerFan>, I>>(base?: I): BmcServerFan {
    return BmcServerFan.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BmcServerFan>, I>>(object: I): BmcServerFan {
    const message = createBaseBmcServerFan();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.serverFan = (object.serverFan !== undefined && object.serverFan !== null)
      ? ServerFan.fromPartial(object.serverFan)
      : undefined;
    return message;
  },
};

function createBaseBearerToken(): BearerToken {
  return {
    id: undefined,
    orgId: "",
    tenantId: "",
    email: "",
    provider: 0,
    userRole: 0,
    tokenId: "",
    fingerprint: "",
    notBefore: undefined,
    expires: undefined,
    scope: 0,
    signingPublicKey: "",
    signingPublicKeyFp: "",
    permissionOnboardDevice: false,
    permissionTest: false,
    permissionMcp: false,
  };
}

export const BearerToken: MessageFns<BearerToken> = {
  encode(message: BearerToken, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    if (message.tenantId !== "") {
      writer.uint32(26).string(message.tenantId);
    }
    if (message.email !== "") {
      writer.uint32(34).string(message.email);
    }
    if (message.provider !== 0) {
      writer.uint32(40).int32(message.provider);
    }
    if (message.userRole !== 0) {
      writer.uint32(48).int32(message.userRole);
    }
    if (message.tokenId !== "") {
      writer.uint32(58).string(message.tokenId);
    }
    if (message.fingerprint !== "") {
      writer.uint32(66).string(message.fingerprint);
    }
    if (message.notBefore !== undefined) {
      Timestamp.encode(toTimestamp(message.notBefore), writer.uint32(74).fork()).join();
    }
    if (message.expires !== undefined) {
      Timestamp.encode(toTimestamp(message.expires), writer.uint32(82).fork()).join();
    }
    if (message.scope !== 0) {
      writer.uint32(88).int32(message.scope);
    }
    if (message.signingPublicKey !== "") {
      writer.uint32(98).string(message.signingPublicKey);
    }
    if (message.signingPublicKeyFp !== "") {
      writer.uint32(106).string(message.signingPublicKeyFp);
    }
    if (message.permissionOnboardDevice !== false) {
      writer.uint32(112).bool(message.permissionOnboardDevice);
    }
    if (message.permissionTest !== false) {
      writer.uint32(120).bool(message.permissionTest);
    }
    if (message.permissionMcp !== false) {
      writer.uint32(128).bool(message.permissionMcp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BearerToken {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBearerToken();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.userRole = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tokenId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.fingerprint = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.notBefore = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.expires = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.scope = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.signingPublicKey = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.signingPublicKeyFp = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.permissionOnboardDevice = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.permissionTest = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.permissionMcp = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BearerToken {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      provider: isSet(object.provider) ? knownProviderFromJSON(object.provider) : 0,
      userRole: isSet(object.userRole) ? userRoleFromJSON(object.userRole) : 0,
      tokenId: isSet(object.tokenId) ? globalThis.String(object.tokenId) : "",
      fingerprint: isSet(object.fingerprint) ? globalThis.String(object.fingerprint) : "",
      notBefore: isSet(object.notBefore) ? fromJsonTimestamp(object.notBefore) : undefined,
      expires: isSet(object.expires) ? fromJsonTimestamp(object.expires) : undefined,
      scope: isSet(object.scope) ? tokenScopeFromJSON(object.scope) : 0,
      signingPublicKey: isSet(object.signingPublicKey) ? globalThis.String(object.signingPublicKey) : "",
      signingPublicKeyFp: isSet(object.signingPublicKeyFp) ? globalThis.String(object.signingPublicKeyFp) : "",
      permissionOnboardDevice: isSet(object.permissionOnboardDevice)
        ? globalThis.Boolean(object.permissionOnboardDevice)
        : false,
      permissionTest: isSet(object.permissionTest) ? globalThis.Boolean(object.permissionTest) : false,
      permissionMcp: isSet(object.permissionMcp) ? globalThis.Boolean(object.permissionMcp) : false,
    };
  },

  toJSON(message: BearerToken): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.provider !== 0) {
      obj.provider = knownProviderToJSON(message.provider);
    }
    if (message.userRole !== 0) {
      obj.userRole = userRoleToJSON(message.userRole);
    }
    if (message.tokenId !== "") {
      obj.tokenId = message.tokenId;
    }
    if (message.fingerprint !== "") {
      obj.fingerprint = message.fingerprint;
    }
    if (message.notBefore !== undefined) {
      obj.notBefore = message.notBefore.toISOString();
    }
    if (message.expires !== undefined) {
      obj.expires = message.expires.toISOString();
    }
    if (message.scope !== 0) {
      obj.scope = tokenScopeToJSON(message.scope);
    }
    if (message.signingPublicKey !== "") {
      obj.signingPublicKey = message.signingPublicKey;
    }
    if (message.signingPublicKeyFp !== "") {
      obj.signingPublicKeyFp = message.signingPublicKeyFp;
    }
    if (message.permissionOnboardDevice !== false) {
      obj.permissionOnboardDevice = message.permissionOnboardDevice;
    }
    if (message.permissionTest !== false) {
      obj.permissionTest = message.permissionTest;
    }
    if (message.permissionMcp !== false) {
      obj.permissionMcp = message.permissionMcp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BearerToken>, I>>(base?: I): BearerToken {
    return BearerToken.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BearerToken>, I>>(object: I): BearerToken {
    const message = createBaseBearerToken();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.orgId = object.orgId ?? "";
    message.tenantId = object.tenantId ?? "";
    message.email = object.email ?? "";
    message.provider = object.provider ?? 0;
    message.userRole = object.userRole ?? 0;
    message.tokenId = object.tokenId ?? "";
    message.fingerprint = object.fingerprint ?? "";
    message.notBefore = object.notBefore ?? undefined;
    message.expires = object.expires ?? undefined;
    message.scope = object.scope ?? 0;
    message.signingPublicKey = object.signingPublicKey ?? "";
    message.signingPublicKeyFp = object.signingPublicKeyFp ?? "";
    message.permissionOnboardDevice = object.permissionOnboardDevice ?? false;
    message.permissionTest = object.permissionTest ?? false;
    message.permissionMcp = object.permissionMcp ?? false;
    return message;
  },
};

function createBaseApiKey(): ApiKey {
  return {
    id: undefined,
    orgId: "",
    tenantId: "",
    email: "",
    provider: 0,
    userRole: 0,
    keyId: "",
    fingerprint: "",
    notBefore: undefined,
    notAfter: undefined,
    scope: 0,
    keyType: 0,
    publicKey: "",
  };
}

export const ApiKey: MessageFns<ApiKey> = {
  encode(message: ApiKey, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    if (message.tenantId !== "") {
      writer.uint32(26).string(message.tenantId);
    }
    if (message.email !== "") {
      writer.uint32(34).string(message.email);
    }
    if (message.provider !== 0) {
      writer.uint32(40).int32(message.provider);
    }
    if (message.userRole !== 0) {
      writer.uint32(48).int32(message.userRole);
    }
    if (message.keyId !== "") {
      writer.uint32(58).string(message.keyId);
    }
    if (message.fingerprint !== "") {
      writer.uint32(66).string(message.fingerprint);
    }
    if (message.notBefore !== undefined) {
      Timestamp.encode(toTimestamp(message.notBefore), writer.uint32(74).fork()).join();
    }
    if (message.notAfter !== undefined) {
      Timestamp.encode(toTimestamp(message.notAfter), writer.uint32(82).fork()).join();
    }
    if (message.scope !== 0) {
      writer.uint32(88).int32(message.scope);
    }
    if (message.keyType !== 0) {
      writer.uint32(96).int32(message.keyType);
    }
    if (message.publicKey !== "") {
      writer.uint32(106).string(message.publicKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiKey {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiKey();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.userRole = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.keyId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.fingerprint = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.notBefore = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.notAfter = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.scope = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.keyType = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.publicKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiKey {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      provider: isSet(object.provider) ? knownProviderFromJSON(object.provider) : 0,
      userRole: isSet(object.userRole) ? userRoleFromJSON(object.userRole) : 0,
      keyId: isSet(object.keyId) ? globalThis.String(object.keyId) : "",
      fingerprint: isSet(object.fingerprint) ? globalThis.String(object.fingerprint) : "",
      notBefore: isSet(object.notBefore) ? fromJsonTimestamp(object.notBefore) : undefined,
      notAfter: isSet(object.notAfter) ? fromJsonTimestamp(object.notAfter) : undefined,
      scope: isSet(object.scope) ? tokenScopeFromJSON(object.scope) : 0,
      keyType: isSet(object.keyType) ? restKeyTypeFromJSON(object.keyType) : 0,
      publicKey: isSet(object.publicKey) ? globalThis.String(object.publicKey) : "",
    };
  },

  toJSON(message: ApiKey): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.provider !== 0) {
      obj.provider = knownProviderToJSON(message.provider);
    }
    if (message.userRole !== 0) {
      obj.userRole = userRoleToJSON(message.userRole);
    }
    if (message.keyId !== "") {
      obj.keyId = message.keyId;
    }
    if (message.fingerprint !== "") {
      obj.fingerprint = message.fingerprint;
    }
    if (message.notBefore !== undefined) {
      obj.notBefore = message.notBefore.toISOString();
    }
    if (message.notAfter !== undefined) {
      obj.notAfter = message.notAfter.toISOString();
    }
    if (message.scope !== 0) {
      obj.scope = tokenScopeToJSON(message.scope);
    }
    if (message.keyType !== 0) {
      obj.keyType = restKeyTypeToJSON(message.keyType);
    }
    if (message.publicKey !== "") {
      obj.publicKey = message.publicKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApiKey>, I>>(base?: I): ApiKey {
    return ApiKey.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApiKey>, I>>(object: I): ApiKey {
    const message = createBaseApiKey();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.orgId = object.orgId ?? "";
    message.tenantId = object.tenantId ?? "";
    message.email = object.email ?? "";
    message.provider = object.provider ?? 0;
    message.userRole = object.userRole ?? 0;
    message.keyId = object.keyId ?? "";
    message.fingerprint = object.fingerprint ?? "";
    message.notBefore = object.notBefore ?? undefined;
    message.notAfter = object.notAfter ?? undefined;
    message.scope = object.scope ?? 0;
    message.keyType = object.keyType ?? 0;
    message.publicKey = object.publicKey ?? "";
    return message;
  },
};

function createBaseNode(): Node {
  return {
    id: undefined,
    deviceId: "",
    serialNumber: "",
    position: 0,
    role: 0,
    model: "",
    orgId: "",
    name: "",
    tags: [],
    connectedToCloud: false,
    groupId: "",
    groupName: "",
    overallGroupPosition: 0,
    groupShortName: "",
  };
}

export const Node: MessageFns<Node> = {
  encode(message: Node, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    if (message.serialNumber !== "") {
      writer.uint32(34).string(message.serialNumber);
    }
    if (message.position !== 0) {
      writer.uint32(40).uint32(message.position);
    }
    if (message.role !== 0) {
      writer.uint32(48).int32(message.role);
    }
    if (message.model !== "") {
      writer.uint32(58).string(message.model);
    }
    if (message.orgId !== "") {
      writer.uint32(66).string(message.orgId);
    }
    if (message.name !== "") {
      writer.uint32(74).string(message.name);
    }
    for (const v of message.tags) {
      writer.uint32(82).string(v!);
    }
    if (message.connectedToCloud !== false) {
      writer.uint32(88).bool(message.connectedToCloud);
    }
    if (message.groupId !== "") {
      writer.uint32(98).string(message.groupId);
    }
    if (message.groupName !== "") {
      writer.uint32(106).string(message.groupName);
    }
    if (message.overallGroupPosition !== 0) {
      writer.uint32(112).uint32(message.overallGroupPosition);
    }
    if (message.groupShortName !== "") {
      writer.uint32(122).string(message.groupShortName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Node {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.connectedToCloud = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.groupName = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.overallGroupPosition = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Node {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      role: isSet(object.role) ? nodeRoleFromJSON(object.role) : 0,
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
      connectedToCloud: isSet(object.connectedToCloud) ? globalThis.Boolean(object.connectedToCloud) : false,
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : "",
      overallGroupPosition: isSet(object.overallGroupPosition) ? globalThis.Number(object.overallGroupPosition) : 0,
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
    };
  },

  toJSON(message: Node): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.role !== 0) {
      obj.role = nodeRoleToJSON(message.role);
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    if (message.connectedToCloud !== false) {
      obj.connectedToCloud = message.connectedToCloud;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.groupName !== "") {
      obj.groupName = message.groupName;
    }
    if (message.overallGroupPosition !== 0) {
      obj.overallGroupPosition = Math.round(message.overallGroupPosition);
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Node>, I>>(base?: I): Node {
    return Node.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Node>, I>>(object: I): Node {
    const message = createBaseNode();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.deviceId = object.deviceId ?? "";
    message.serialNumber = object.serialNumber ?? "";
    message.position = object.position ?? 0;
    message.role = object.role ?? 0;
    message.model = object.model ?? "";
    message.orgId = object.orgId ?? "";
    message.name = object.name ?? "";
    message.tags = object.tags?.map((e) => e) || [];
    message.connectedToCloud = object.connectedToCloud ?? false;
    message.groupId = object.groupId ?? "";
    message.groupName = object.groupName ?? "";
    message.overallGroupPosition = object.overallGroupPosition ?? 0;
    message.groupShortName = object.groupShortName ?? "";
    return message;
  },
};

function createBaseNodeLineCard(): NodeLineCard {
  return { id: undefined };
}

export const NodeLineCard: MessageFns<NodeLineCard> = {
  encode(message: NodeLineCard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeLineCard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNodeLineCard();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NodeLineCard {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: NodeLineCard): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodeLineCard>, I>>(base?: I): NodeLineCard {
    return NodeLineCard.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeLineCard>, I>>(object: I): NodeLineCard {
    const message = createBaseNodeLineCard();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseNodePort(): NodePort {
  return { id: undefined };
}

export const NodePort: MessageFns<NodePort> = {
  encode(message: NodePort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodePort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNodePort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NodePort {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: NodePort): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodePort>, I>>(base?: I): NodePort {
    return NodePort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodePort>, I>>(object: I): NodePort {
    const message = createBaseNodePort();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseNodeBreakout(): NodeBreakout {
  return {
    id: undefined,
    requiredToPort: undefined,
    requiredOpticPid: "",
    interfaceName: "",
    requiredRemoteOpticPid: "",
    portRole: 0,
    usedInCablingPlan: false,
    isCablingDest: false,
  };
}

export const NodeBreakout: MessageFns<NodeBreakout> = {
  encode(message: NodeBreakout, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.requiredToPort !== undefined) {
      SmartHandsPort.encode(message.requiredToPort, writer.uint32(26).fork()).join();
    }
    if (message.requiredOpticPid !== "") {
      writer.uint32(34).string(message.requiredOpticPid);
    }
    if (message.interfaceName !== "") {
      writer.uint32(42).string(message.interfaceName);
    }
    if (message.requiredRemoteOpticPid !== "") {
      writer.uint32(50).string(message.requiredRemoteOpticPid);
    }
    if (message.portRole !== 0) {
      writer.uint32(56).int32(message.portRole);
    }
    if (message.usedInCablingPlan !== false) {
      writer.uint32(64).bool(message.usedInCablingPlan);
    }
    if (message.isCablingDest !== false) {
      writer.uint32(72).bool(message.isCablingDest);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeBreakout {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNodeBreakout();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.requiredToPort = SmartHandsPort.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.requiredOpticPid = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.interfaceName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.requiredRemoteOpticPid = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.portRole = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.usedInCablingPlan = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.isCablingDest = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NodeBreakout {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      requiredToPort: isSet(object.requiredToPort) ? SmartHandsPort.fromJSON(object.requiredToPort) : undefined,
      requiredOpticPid: isSet(object.requiredOpticPid) ? globalThis.String(object.requiredOpticPid) : "",
      interfaceName: isSet(object.interfaceName) ? globalThis.String(object.interfaceName) : "",
      requiredRemoteOpticPid: isSet(object.requiredRemoteOpticPid)
        ? globalThis.String(object.requiredRemoteOpticPid)
        : "",
      portRole: isSet(object.portRole) ? portRoleFromJSON(object.portRole) : 0,
      usedInCablingPlan: isSet(object.usedInCablingPlan) ? globalThis.Boolean(object.usedInCablingPlan) : false,
      isCablingDest: isSet(object.isCablingDest) ? globalThis.Boolean(object.isCablingDest) : false,
    };
  },

  toJSON(message: NodeBreakout): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.requiredToPort !== undefined) {
      obj.requiredToPort = SmartHandsPort.toJSON(message.requiredToPort);
    }
    if (message.requiredOpticPid !== "") {
      obj.requiredOpticPid = message.requiredOpticPid;
    }
    if (message.interfaceName !== "") {
      obj.interfaceName = message.interfaceName;
    }
    if (message.requiredRemoteOpticPid !== "") {
      obj.requiredRemoteOpticPid = message.requiredRemoteOpticPid;
    }
    if (message.portRole !== 0) {
      obj.portRole = portRoleToJSON(message.portRole);
    }
    if (message.usedInCablingPlan !== false) {
      obj.usedInCablingPlan = message.usedInCablingPlan;
    }
    if (message.isCablingDest !== false) {
      obj.isCablingDest = message.isCablingDest;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodeBreakout>, I>>(base?: I): NodeBreakout {
    return NodeBreakout.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeBreakout>, I>>(object: I): NodeBreakout {
    const message = createBaseNodeBreakout();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.requiredToPort = (object.requiredToPort !== undefined && object.requiredToPort !== null)
      ? SmartHandsPort.fromPartial(object.requiredToPort)
      : undefined;
    message.requiredOpticPid = object.requiredOpticPid ?? "";
    message.interfaceName = object.interfaceName ?? "";
    message.requiredRemoteOpticPid = object.requiredRemoteOpticPid ?? "";
    message.portRole = object.portRole ?? 0;
    message.usedInCablingPlan = object.usedInCablingPlan ?? false;
    message.isCablingDest = object.isCablingDest ?? false;
    return message;
  },
};

function createBaseSmartHandsPort(): SmartHandsPort {
  return {
    deviceId: "",
    interfaceName: "",
    linecard: 0,
    port: 0,
    breakout: 0,
    nodeId: "",
    role: 0,
    position: 0,
    groupName: "",
  };
}

export const SmartHandsPort: MessageFns<SmartHandsPort> = {
  encode(message: SmartHandsPort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.interfaceName !== "") {
      writer.uint32(18).string(message.interfaceName);
    }
    if (message.linecard !== 0) {
      writer.uint32(24).uint32(message.linecard);
    }
    if (message.port !== 0) {
      writer.uint32(32).uint32(message.port);
    }
    if (message.breakout !== 0) {
      writer.uint32(40).uint32(message.breakout);
    }
    if (message.nodeId !== "") {
      writer.uint32(50).string(message.nodeId);
    }
    if (message.role !== 0) {
      writer.uint32(56).int32(message.role);
    }
    if (message.position !== 0) {
      writer.uint32(64).uint32(message.position);
    }
    if (message.groupName !== "") {
      writer.uint32(74).string(message.groupName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SmartHandsPort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSmartHandsPort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.interfaceName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.linecard = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.port = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.breakout = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groupName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SmartHandsPort {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      interfaceName: isSet(object.interfaceName) ? globalThis.String(object.interfaceName) : "",
      linecard: isSet(object.linecard) ? globalThis.Number(object.linecard) : 0,
      port: isSet(object.port) ? globalThis.Number(object.port) : 0,
      breakout: isSet(object.breakout) ? globalThis.Number(object.breakout) : 0,
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      role: isSet(object.role) ? nodeRoleFromJSON(object.role) : 0,
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : "",
    };
  },

  toJSON(message: SmartHandsPort): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.interfaceName !== "") {
      obj.interfaceName = message.interfaceName;
    }
    if (message.linecard !== 0) {
      obj.linecard = Math.round(message.linecard);
    }
    if (message.port !== 0) {
      obj.port = Math.round(message.port);
    }
    if (message.breakout !== 0) {
      obj.breakout = Math.round(message.breakout);
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.role !== 0) {
      obj.role = nodeRoleToJSON(message.role);
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.groupName !== "") {
      obj.groupName = message.groupName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SmartHandsPort>, I>>(base?: I): SmartHandsPort {
    return SmartHandsPort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SmartHandsPort>, I>>(object: I): SmartHandsPort {
    const message = createBaseSmartHandsPort();
    message.deviceId = object.deviceId ?? "";
    message.interfaceName = object.interfaceName ?? "";
    message.linecard = object.linecard ?? 0;
    message.port = object.port ?? 0;
    message.breakout = object.breakout ?? 0;
    message.nodeId = object.nodeId ?? "";
    message.role = object.role ?? 0;
    message.position = object.position ?? 0;
    message.groupName = object.groupName ?? "";
    return message;
  },
};

function createBaseSmartHandsCommonTask(): SmartHandsCommonTask {
  return {
    role: 0,
    deviceId: "",
    nodeId: "",
    serialNumber: "",
    hint: "",
    position: 0,
    order: 0,
    completed: 0,
    naturalOrder: "",
    worker: "",
    connectedToCloud: false,
    groupName: "",
    groupPosition: 0,
    groupId: "",
    totalTasks: 0,
  };
}

export const SmartHandsCommonTask: MessageFns<SmartHandsCommonTask> = {
  encode(message: SmartHandsCommonTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.role !== 0) {
      writer.uint32(8).int32(message.role);
    }
    if (message.deviceId !== "") {
      writer.uint32(18).string(message.deviceId);
    }
    if (message.nodeId !== "") {
      writer.uint32(26).string(message.nodeId);
    }
    if (message.serialNumber !== "") {
      writer.uint32(34).string(message.serialNumber);
    }
    if (message.hint !== "") {
      writer.uint32(42).string(message.hint);
    }
    if (message.position !== 0) {
      writer.uint32(48).uint32(message.position);
    }
    if (message.order !== 0) {
      writer.uint32(56).uint32(message.order);
    }
    if (message.completed !== 0) {
      writer.uint32(64).int32(message.completed);
    }
    if (message.naturalOrder !== "") {
      writer.uint32(74).string(message.naturalOrder);
    }
    if (message.worker !== "") {
      writer.uint32(82).string(message.worker);
    }
    if (message.connectedToCloud !== false) {
      writer.uint32(88).bool(message.connectedToCloud);
    }
    if (message.groupName !== "") {
      writer.uint32(98).string(message.groupName);
    }
    if (message.groupPosition !== 0) {
      writer.uint32(104).uint32(message.groupPosition);
    }
    if (message.groupId !== "") {
      writer.uint32(114).string(message.groupId);
    }
    if (message.totalTasks !== 0) {
      writer.uint32(128).uint32(message.totalTasks);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SmartHandsCommonTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSmartHandsCommonTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.hint = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.order = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.completed = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.naturalOrder = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.worker = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.connectedToCloud = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.groupName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.groupPosition = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.totalTasks = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SmartHandsCommonTask {
    return {
      role: isSet(object.role) ? nodeRoleFromJSON(object.role) : 0,
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      hint: isSet(object.hint) ? globalThis.String(object.hint) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      order: isSet(object.order) ? globalThis.Number(object.order) : 0,
      completed: isSet(object.completed) ? smartHandsCompletionStatusFromJSON(object.completed) : 0,
      naturalOrder: isSet(object.naturalOrder) ? globalThis.String(object.naturalOrder) : "",
      worker: isSet(object.worker) ? globalThis.String(object.worker) : "",
      connectedToCloud: isSet(object.connectedToCloud) ? globalThis.Boolean(object.connectedToCloud) : false,
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : "",
      groupPosition: isSet(object.groupPosition) ? globalThis.Number(object.groupPosition) : 0,
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      totalTasks: isSet(object.totalTasks) ? globalThis.Number(object.totalTasks) : 0,
    };
  },

  toJSON(message: SmartHandsCommonTask): unknown {
    const obj: any = {};
    if (message.role !== 0) {
      obj.role = nodeRoleToJSON(message.role);
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.hint !== "") {
      obj.hint = message.hint;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.order !== 0) {
      obj.order = Math.round(message.order);
    }
    if (message.completed !== 0) {
      obj.completed = smartHandsCompletionStatusToJSON(message.completed);
    }
    if (message.naturalOrder !== "") {
      obj.naturalOrder = message.naturalOrder;
    }
    if (message.worker !== "") {
      obj.worker = message.worker;
    }
    if (message.connectedToCloud !== false) {
      obj.connectedToCloud = message.connectedToCloud;
    }
    if (message.groupName !== "") {
      obj.groupName = message.groupName;
    }
    if (message.groupPosition !== 0) {
      obj.groupPosition = Math.round(message.groupPosition);
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.totalTasks !== 0) {
      obj.totalTasks = Math.round(message.totalTasks);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SmartHandsCommonTask>, I>>(base?: I): SmartHandsCommonTask {
    return SmartHandsCommonTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SmartHandsCommonTask>, I>>(object: I): SmartHandsCommonTask {
    const message = createBaseSmartHandsCommonTask();
    message.role = object.role ?? 0;
    message.deviceId = object.deviceId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.serialNumber = object.serialNumber ?? "";
    message.hint = object.hint ?? "";
    message.position = object.position ?? 0;
    message.order = object.order ?? 0;
    message.completed = object.completed ?? 0;
    message.naturalOrder = object.naturalOrder ?? "";
    message.worker = object.worker ?? "";
    message.connectedToCloud = object.connectedToCloud ?? false;
    message.groupName = object.groupName ?? "";
    message.groupPosition = object.groupPosition ?? 0;
    message.groupId = object.groupId ?? "";
    message.totalTasks = object.totalTasks ?? 0;
    return message;
  },
};

function createBaseSmartHandsPsu(): SmartHandsPsu {
  return { required: false, correctPid: 0, foundPid: "", poweredOn: 0, requiredPid: "" };
}

export const SmartHandsPsu: MessageFns<SmartHandsPsu> = {
  encode(message: SmartHandsPsu, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.required !== false) {
      writer.uint32(8).bool(message.required);
    }
    if (message.correctPid !== 0) {
      writer.uint32(16).int32(message.correctPid);
    }
    if (message.foundPid !== "") {
      writer.uint32(26).string(message.foundPid);
    }
    if (message.poweredOn !== 0) {
      writer.uint32(32).int32(message.poweredOn);
    }
    if (message.requiredPid !== "") {
      writer.uint32(42).string(message.requiredPid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SmartHandsPsu {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSmartHandsPsu();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.required = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.correctPid = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.foundPid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.poweredOn = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.requiredPid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SmartHandsPsu {
    return {
      required: isSet(object.required) ? globalThis.Boolean(object.required) : false,
      correctPid: isSet(object.correctPid) ? smartHandsCompletionStatusFromJSON(object.correctPid) : 0,
      foundPid: isSet(object.foundPid) ? globalThis.String(object.foundPid) : "",
      poweredOn: isSet(object.poweredOn) ? smartHandsCompletionStatusFromJSON(object.poweredOn) : 0,
      requiredPid: isSet(object.requiredPid) ? globalThis.String(object.requiredPid) : "",
    };
  },

  toJSON(message: SmartHandsPsu): unknown {
    const obj: any = {};
    if (message.required !== false) {
      obj.required = message.required;
    }
    if (message.correctPid !== 0) {
      obj.correctPid = smartHandsCompletionStatusToJSON(message.correctPid);
    }
    if (message.foundPid !== "") {
      obj.foundPid = message.foundPid;
    }
    if (message.poweredOn !== 0) {
      obj.poweredOn = smartHandsCompletionStatusToJSON(message.poweredOn);
    }
    if (message.requiredPid !== "") {
      obj.requiredPid = message.requiredPid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SmartHandsPsu>, I>>(base?: I): SmartHandsPsu {
    return SmartHandsPsu.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SmartHandsPsu>, I>>(object: I): SmartHandsPsu {
    const message = createBaseSmartHandsPsu();
    message.required = object.required ?? false;
    message.correctPid = object.correctPid ?? 0;
    message.foundPid = object.foundPid ?? "";
    message.poweredOn = object.poweredOn ?? 0;
    message.requiredPid = object.requiredPid ?? "";
    return message;
  },
};

function createBaseSmartHandsFanTray(): SmartHandsFanTray {
  return { required: false, correctPid: 0, foundPid: "", running: 0, requiredPid: "" };
}

export const SmartHandsFanTray: MessageFns<SmartHandsFanTray> = {
  encode(message: SmartHandsFanTray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.required !== false) {
      writer.uint32(8).bool(message.required);
    }
    if (message.correctPid !== 0) {
      writer.uint32(16).int32(message.correctPid);
    }
    if (message.foundPid !== "") {
      writer.uint32(26).string(message.foundPid);
    }
    if (message.running !== 0) {
      writer.uint32(32).int32(message.running);
    }
    if (message.requiredPid !== "") {
      writer.uint32(42).string(message.requiredPid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SmartHandsFanTray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSmartHandsFanTray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.required = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.correctPid = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.foundPid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.running = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.requiredPid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SmartHandsFanTray {
    return {
      required: isSet(object.required) ? globalThis.Boolean(object.required) : false,
      correctPid: isSet(object.correctPid) ? smartHandsCompletionStatusFromJSON(object.correctPid) : 0,
      foundPid: isSet(object.foundPid) ? globalThis.String(object.foundPid) : "",
      running: isSet(object.running) ? smartHandsCompletionStatusFromJSON(object.running) : 0,
      requiredPid: isSet(object.requiredPid) ? globalThis.String(object.requiredPid) : "",
    };
  },

  toJSON(message: SmartHandsFanTray): unknown {
    const obj: any = {};
    if (message.required !== false) {
      obj.required = message.required;
    }
    if (message.correctPid !== 0) {
      obj.correctPid = smartHandsCompletionStatusToJSON(message.correctPid);
    }
    if (message.foundPid !== "") {
      obj.foundPid = message.foundPid;
    }
    if (message.running !== 0) {
      obj.running = smartHandsCompletionStatusToJSON(message.running);
    }
    if (message.requiredPid !== "") {
      obj.requiredPid = message.requiredPid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SmartHandsFanTray>, I>>(base?: I): SmartHandsFanTray {
    return SmartHandsFanTray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SmartHandsFanTray>, I>>(object: I): SmartHandsFanTray {
    const message = createBaseSmartHandsFanTray();
    message.required = object.required ?? false;
    message.correctPid = object.correctPid ?? 0;
    message.foundPid = object.foundPid ?? "";
    message.running = object.running ?? 0;
    message.requiredPid = object.requiredPid ?? "";
    return message;
  },
};

function createBaseUnpackAndAssembleTask(): UnpackAndAssembleTask {
  return {
    id: undefined,
    common: undefined,
    psu1: undefined,
    psu2: undefined,
    fanTray1: undefined,
    fanTray2: undefined,
    fanTray3: undefined,
    fanTray4: undefined,
    fanTray5: undefined,
    fanTray6: undefined,
    connectManagementPort: false,
    managementPortUp: 0,
  };
}

export const UnpackAndAssembleTask: MessageFns<UnpackAndAssembleTask> = {
  encode(message: UnpackAndAssembleTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.common !== undefined) {
      SmartHandsCommonTask.encode(message.common, writer.uint32(18).fork()).join();
    }
    if (message.psu1 !== undefined) {
      SmartHandsPsu.encode(message.psu1, writer.uint32(26).fork()).join();
    }
    if (message.psu2 !== undefined) {
      SmartHandsPsu.encode(message.psu2, writer.uint32(34).fork()).join();
    }
    if (message.fanTray1 !== undefined) {
      SmartHandsFanTray.encode(message.fanTray1, writer.uint32(42).fork()).join();
    }
    if (message.fanTray2 !== undefined) {
      SmartHandsFanTray.encode(message.fanTray2, writer.uint32(50).fork()).join();
    }
    if (message.fanTray3 !== undefined) {
      SmartHandsFanTray.encode(message.fanTray3, writer.uint32(58).fork()).join();
    }
    if (message.fanTray4 !== undefined) {
      SmartHandsFanTray.encode(message.fanTray4, writer.uint32(66).fork()).join();
    }
    if (message.fanTray5 !== undefined) {
      SmartHandsFanTray.encode(message.fanTray5, writer.uint32(74).fork()).join();
    }
    if (message.fanTray6 !== undefined) {
      SmartHandsFanTray.encode(message.fanTray6, writer.uint32(82).fork()).join();
    }
    if (message.connectManagementPort !== false) {
      writer.uint32(88).bool(message.connectManagementPort);
    }
    if (message.managementPortUp !== 0) {
      writer.uint32(96).int32(message.managementPortUp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnpackAndAssembleTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnpackAndAssembleTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.common = SmartHandsCommonTask.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.psu1 = SmartHandsPsu.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.psu2 = SmartHandsPsu.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fanTray1 = SmartHandsFanTray.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fanTray2 = SmartHandsFanTray.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fanTray3 = SmartHandsFanTray.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.fanTray4 = SmartHandsFanTray.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fanTray5 = SmartHandsFanTray.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.fanTray6 = SmartHandsFanTray.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.connectManagementPort = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.managementPortUp = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnpackAndAssembleTask {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      common: isSet(object.common) ? SmartHandsCommonTask.fromJSON(object.common) : undefined,
      psu1: isSet(object.psu1) ? SmartHandsPsu.fromJSON(object.psu1) : undefined,
      psu2: isSet(object.psu2) ? SmartHandsPsu.fromJSON(object.psu2) : undefined,
      fanTray1: isSet(object.fanTray1) ? SmartHandsFanTray.fromJSON(object.fanTray1) : undefined,
      fanTray2: isSet(object.fanTray2) ? SmartHandsFanTray.fromJSON(object.fanTray2) : undefined,
      fanTray3: isSet(object.fanTray3) ? SmartHandsFanTray.fromJSON(object.fanTray3) : undefined,
      fanTray4: isSet(object.fanTray4) ? SmartHandsFanTray.fromJSON(object.fanTray4) : undefined,
      fanTray5: isSet(object.fanTray5) ? SmartHandsFanTray.fromJSON(object.fanTray5) : undefined,
      fanTray6: isSet(object.fanTray6) ? SmartHandsFanTray.fromJSON(object.fanTray6) : undefined,
      connectManagementPort: isSet(object.connectManagementPort)
        ? globalThis.Boolean(object.connectManagementPort)
        : false,
      managementPortUp: isSet(object.managementPortUp)
        ? smartHandsCompletionStatusFromJSON(object.managementPortUp)
        : 0,
    };
  },

  toJSON(message: UnpackAndAssembleTask): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.common !== undefined) {
      obj.common = SmartHandsCommonTask.toJSON(message.common);
    }
    if (message.psu1 !== undefined) {
      obj.psu1 = SmartHandsPsu.toJSON(message.psu1);
    }
    if (message.psu2 !== undefined) {
      obj.psu2 = SmartHandsPsu.toJSON(message.psu2);
    }
    if (message.fanTray1 !== undefined) {
      obj.fanTray1 = SmartHandsFanTray.toJSON(message.fanTray1);
    }
    if (message.fanTray2 !== undefined) {
      obj.fanTray2 = SmartHandsFanTray.toJSON(message.fanTray2);
    }
    if (message.fanTray3 !== undefined) {
      obj.fanTray3 = SmartHandsFanTray.toJSON(message.fanTray3);
    }
    if (message.fanTray4 !== undefined) {
      obj.fanTray4 = SmartHandsFanTray.toJSON(message.fanTray4);
    }
    if (message.fanTray5 !== undefined) {
      obj.fanTray5 = SmartHandsFanTray.toJSON(message.fanTray5);
    }
    if (message.fanTray6 !== undefined) {
      obj.fanTray6 = SmartHandsFanTray.toJSON(message.fanTray6);
    }
    if (message.connectManagementPort !== false) {
      obj.connectManagementPort = message.connectManagementPort;
    }
    if (message.managementPortUp !== 0) {
      obj.managementPortUp = smartHandsCompletionStatusToJSON(message.managementPortUp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnpackAndAssembleTask>, I>>(base?: I): UnpackAndAssembleTask {
    return UnpackAndAssembleTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnpackAndAssembleTask>, I>>(object: I): UnpackAndAssembleTask {
    const message = createBaseUnpackAndAssembleTask();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.common = (object.common !== undefined && object.common !== null)
      ? SmartHandsCommonTask.fromPartial(object.common)
      : undefined;
    message.psu1 = (object.psu1 !== undefined && object.psu1 !== null)
      ? SmartHandsPsu.fromPartial(object.psu1)
      : undefined;
    message.psu2 = (object.psu2 !== undefined && object.psu2 !== null)
      ? SmartHandsPsu.fromPartial(object.psu2)
      : undefined;
    message.fanTray1 = (object.fanTray1 !== undefined && object.fanTray1 !== null)
      ? SmartHandsFanTray.fromPartial(object.fanTray1)
      : undefined;
    message.fanTray2 = (object.fanTray2 !== undefined && object.fanTray2 !== null)
      ? SmartHandsFanTray.fromPartial(object.fanTray2)
      : undefined;
    message.fanTray3 = (object.fanTray3 !== undefined && object.fanTray3 !== null)
      ? SmartHandsFanTray.fromPartial(object.fanTray3)
      : undefined;
    message.fanTray4 = (object.fanTray4 !== undefined && object.fanTray4 !== null)
      ? SmartHandsFanTray.fromPartial(object.fanTray4)
      : undefined;
    message.fanTray5 = (object.fanTray5 !== undefined && object.fanTray5 !== null)
      ? SmartHandsFanTray.fromPartial(object.fanTray5)
      : undefined;
    message.fanTray6 = (object.fanTray6 !== undefined && object.fanTray6 !== null)
      ? SmartHandsFanTray.fromPartial(object.fanTray6)
      : undefined;
    message.connectManagementPort = object.connectManagementPort ?? false;
    message.managementPortUp = object.managementPortUp ?? 0;
    return message;
  },
};

function createBaseClaimAndBindTask(): ClaimAndBindTask {
  return { id: undefined, common: undefined, bound: 0, connectedToCloud: 0 };
}

export const ClaimAndBindTask: MessageFns<ClaimAndBindTask> = {
  encode(message: ClaimAndBindTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.common !== undefined) {
      SmartHandsCommonTask.encode(message.common, writer.uint32(18).fork()).join();
    }
    if (message.bound !== 0) {
      writer.uint32(24).int32(message.bound);
    }
    if (message.connectedToCloud !== 0) {
      writer.uint32(32).int32(message.connectedToCloud);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimAndBindTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimAndBindTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.common = SmartHandsCommonTask.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.bound = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.connectedToCloud = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClaimAndBindTask {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      common: isSet(object.common) ? SmartHandsCommonTask.fromJSON(object.common) : undefined,
      bound: isSet(object.bound) ? smartHandsCompletionStatusFromJSON(object.bound) : 0,
      connectedToCloud: isSet(object.connectedToCloud)
        ? smartHandsCompletionStatusFromJSON(object.connectedToCloud)
        : 0,
    };
  },

  toJSON(message: ClaimAndBindTask): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.common !== undefined) {
      obj.common = SmartHandsCommonTask.toJSON(message.common);
    }
    if (message.bound !== 0) {
      obj.bound = smartHandsCompletionStatusToJSON(message.bound);
    }
    if (message.connectedToCloud !== 0) {
      obj.connectedToCloud = smartHandsCompletionStatusToJSON(message.connectedToCloud);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClaimAndBindTask>, I>>(base?: I): ClaimAndBindTask {
    return ClaimAndBindTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClaimAndBindTask>, I>>(object: I): ClaimAndBindTask {
    const message = createBaseClaimAndBindTask();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.common = (object.common !== undefined && object.common !== null)
      ? SmartHandsCommonTask.fromPartial(object.common)
      : undefined;
    message.bound = object.bound ?? 0;
    message.connectedToCloud = object.connectedToCloud ?? 0;
    return message;
  },
};

function createBasePortSetupTask(): PortSetupTask {
  return { id: undefined, common: undefined, requiredPid: "", correctPid: 0, fromPort: undefined };
}

export const PortSetupTask: MessageFns<PortSetupTask> = {
  encode(message: PortSetupTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.common !== undefined) {
      SmartHandsCommonTask.encode(message.common, writer.uint32(18).fork()).join();
    }
    if (message.requiredPid !== "") {
      writer.uint32(26).string(message.requiredPid);
    }
    if (message.correctPid !== 0) {
      writer.uint32(32).int32(message.correctPid);
    }
    if (message.fromPort !== undefined) {
      SmartHandsPort.encode(message.fromPort, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortSetupTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortSetupTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.common = SmartHandsCommonTask.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.requiredPid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.correctPid = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fromPort = SmartHandsPort.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortSetupTask {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      common: isSet(object.common) ? SmartHandsCommonTask.fromJSON(object.common) : undefined,
      requiredPid: isSet(object.requiredPid) ? globalThis.String(object.requiredPid) : "",
      correctPid: isSet(object.correctPid) ? smartHandsCompletionStatusFromJSON(object.correctPid) : 0,
      fromPort: isSet(object.fromPort) ? SmartHandsPort.fromJSON(object.fromPort) : undefined,
    };
  },

  toJSON(message: PortSetupTask): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.common !== undefined) {
      obj.common = SmartHandsCommonTask.toJSON(message.common);
    }
    if (message.requiredPid !== "") {
      obj.requiredPid = message.requiredPid;
    }
    if (message.correctPid !== 0) {
      obj.correctPid = smartHandsCompletionStatusToJSON(message.correctPid);
    }
    if (message.fromPort !== undefined) {
      obj.fromPort = SmartHandsPort.toJSON(message.fromPort);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortSetupTask>, I>>(base?: I): PortSetupTask {
    return PortSetupTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortSetupTask>, I>>(object: I): PortSetupTask {
    const message = createBasePortSetupTask();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.common = (object.common !== undefined && object.common !== null)
      ? SmartHandsCommonTask.fromPartial(object.common)
      : undefined;
    message.requiredPid = object.requiredPid ?? "";
    message.correctPid = object.correctPid ?? 0;
    message.fromPort = (object.fromPort !== undefined && object.fromPort !== null)
      ? SmartHandsPort.fromPartial(object.fromPort)
      : undefined;
    return message;
  },
};

function createBaseFabricConnectionTask(): FabricConnectionTask {
  return {
    id: undefined,
    common: undefined,
    requiredToPort: undefined,
    foundToPort: undefined,
    portConnected: 0,
    fromPort: undefined,
    fromPortState: 0,
    toPortState: 0,
    requiredFromPid: "",
    correctFromPid: 0,
    requiredToPid: "",
    correctToPid: 0,
  };
}

export const FabricConnectionTask: MessageFns<FabricConnectionTask> = {
  encode(message: FabricConnectionTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.common !== undefined) {
      SmartHandsCommonTask.encode(message.common, writer.uint32(18).fork()).join();
    }
    if (message.requiredToPort !== undefined) {
      SmartHandsPort.encode(message.requiredToPort, writer.uint32(26).fork()).join();
    }
    if (message.foundToPort !== undefined) {
      SmartHandsPort.encode(message.foundToPort, writer.uint32(34).fork()).join();
    }
    if (message.portConnected !== 0) {
      writer.uint32(40).int32(message.portConnected);
    }
    if (message.fromPort !== undefined) {
      SmartHandsPort.encode(message.fromPort, writer.uint32(50).fork()).join();
    }
    if (message.fromPortState !== 0) {
      writer.uint32(56).int32(message.fromPortState);
    }
    if (message.toPortState !== 0) {
      writer.uint32(64).int32(message.toPortState);
    }
    if (message.requiredFromPid !== "") {
      writer.uint32(74).string(message.requiredFromPid);
    }
    if (message.correctFromPid !== 0) {
      writer.uint32(80).int32(message.correctFromPid);
    }
    if (message.requiredToPid !== "") {
      writer.uint32(90).string(message.requiredToPid);
    }
    if (message.correctToPid !== 0) {
      writer.uint32(96).int32(message.correctToPid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricConnectionTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricConnectionTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.common = SmartHandsCommonTask.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.requiredToPort = SmartHandsPort.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.foundToPort = SmartHandsPort.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.portConnected = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fromPort = SmartHandsPort.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.fromPortState = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.toPortState = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.requiredFromPid = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.correctFromPid = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.requiredToPid = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.correctToPid = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricConnectionTask {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      common: isSet(object.common) ? SmartHandsCommonTask.fromJSON(object.common) : undefined,
      requiredToPort: isSet(object.requiredToPort) ? SmartHandsPort.fromJSON(object.requiredToPort) : undefined,
      foundToPort: isSet(object.foundToPort) ? SmartHandsPort.fromJSON(object.foundToPort) : undefined,
      portConnected: isSet(object.portConnected) ? smartHandsCompletionStatusFromJSON(object.portConnected) : 0,
      fromPort: isSet(object.fromPort) ? SmartHandsPort.fromJSON(object.fromPort) : undefined,
      fromPortState: isSet(object.fromPortState) ? operStateFromJSON(object.fromPortState) : 0,
      toPortState: isSet(object.toPortState) ? operStateFromJSON(object.toPortState) : 0,
      requiredFromPid: isSet(object.requiredFromPid) ? globalThis.String(object.requiredFromPid) : "",
      correctFromPid: isSet(object.correctFromPid) ? smartHandsCompletionStatusFromJSON(object.correctFromPid) : 0,
      requiredToPid: isSet(object.requiredToPid) ? globalThis.String(object.requiredToPid) : "",
      correctToPid: isSet(object.correctToPid) ? smartHandsCompletionStatusFromJSON(object.correctToPid) : 0,
    };
  },

  toJSON(message: FabricConnectionTask): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.common !== undefined) {
      obj.common = SmartHandsCommonTask.toJSON(message.common);
    }
    if (message.requiredToPort !== undefined) {
      obj.requiredToPort = SmartHandsPort.toJSON(message.requiredToPort);
    }
    if (message.foundToPort !== undefined) {
      obj.foundToPort = SmartHandsPort.toJSON(message.foundToPort);
    }
    if (message.portConnected !== 0) {
      obj.portConnected = smartHandsCompletionStatusToJSON(message.portConnected);
    }
    if (message.fromPort !== undefined) {
      obj.fromPort = SmartHandsPort.toJSON(message.fromPort);
    }
    if (message.fromPortState !== 0) {
      obj.fromPortState = operStateToJSON(message.fromPortState);
    }
    if (message.toPortState !== 0) {
      obj.toPortState = operStateToJSON(message.toPortState);
    }
    if (message.requiredFromPid !== "") {
      obj.requiredFromPid = message.requiredFromPid;
    }
    if (message.correctFromPid !== 0) {
      obj.correctFromPid = smartHandsCompletionStatusToJSON(message.correctFromPid);
    }
    if (message.requiredToPid !== "") {
      obj.requiredToPid = message.requiredToPid;
    }
    if (message.correctToPid !== 0) {
      obj.correctToPid = smartHandsCompletionStatusToJSON(message.correctToPid);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricConnectionTask>, I>>(base?: I): FabricConnectionTask {
    return FabricConnectionTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricConnectionTask>, I>>(object: I): FabricConnectionTask {
    const message = createBaseFabricConnectionTask();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.common = (object.common !== undefined && object.common !== null)
      ? SmartHandsCommonTask.fromPartial(object.common)
      : undefined;
    message.requiredToPort = (object.requiredToPort !== undefined && object.requiredToPort !== null)
      ? SmartHandsPort.fromPartial(object.requiredToPort)
      : undefined;
    message.foundToPort = (object.foundToPort !== undefined && object.foundToPort !== null)
      ? SmartHandsPort.fromPartial(object.foundToPort)
      : undefined;
    message.portConnected = object.portConnected ?? 0;
    message.fromPort = (object.fromPort !== undefined && object.fromPort !== null)
      ? SmartHandsPort.fromPartial(object.fromPort)
      : undefined;
    message.fromPortState = object.fromPortState ?? 0;
    message.toPortState = object.toPortState ?? 0;
    message.requiredFromPid = object.requiredFromPid ?? "";
    message.correctFromPid = object.correctFromPid ?? 0;
    message.requiredToPid = object.requiredToPid ?? "";
    message.correctToPid = object.correctToPid ?? 0;
    return message;
  },
};

function createBaseNegativeConnectionTask(): NegativeConnectionTask {
  return { id: undefined, common: undefined, foundToPort: undefined, foundOpticPid: "", fromPort: undefined };
}

export const NegativeConnectionTask: MessageFns<NegativeConnectionTask> = {
  encode(message: NegativeConnectionTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.common !== undefined) {
      SmartHandsCommonTask.encode(message.common, writer.uint32(18).fork()).join();
    }
    if (message.foundToPort !== undefined) {
      SmartHandsPort.encode(message.foundToPort, writer.uint32(26).fork()).join();
    }
    if (message.foundOpticPid !== "") {
      writer.uint32(34).string(message.foundOpticPid);
    }
    if (message.fromPort !== undefined) {
      SmartHandsPort.encode(message.fromPort, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NegativeConnectionTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNegativeConnectionTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.common = SmartHandsCommonTask.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.foundToPort = SmartHandsPort.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.foundOpticPid = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fromPort = SmartHandsPort.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NegativeConnectionTask {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      common: isSet(object.common) ? SmartHandsCommonTask.fromJSON(object.common) : undefined,
      foundToPort: isSet(object.foundToPort) ? SmartHandsPort.fromJSON(object.foundToPort) : undefined,
      foundOpticPid: isSet(object.foundOpticPid) ? globalThis.String(object.foundOpticPid) : "",
      fromPort: isSet(object.fromPort) ? SmartHandsPort.fromJSON(object.fromPort) : undefined,
    };
  },

  toJSON(message: NegativeConnectionTask): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.common !== undefined) {
      obj.common = SmartHandsCommonTask.toJSON(message.common);
    }
    if (message.foundToPort !== undefined) {
      obj.foundToPort = SmartHandsPort.toJSON(message.foundToPort);
    }
    if (message.foundOpticPid !== "") {
      obj.foundOpticPid = message.foundOpticPid;
    }
    if (message.fromPort !== undefined) {
      obj.fromPort = SmartHandsPort.toJSON(message.fromPort);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NegativeConnectionTask>, I>>(base?: I): NegativeConnectionTask {
    return NegativeConnectionTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NegativeConnectionTask>, I>>(object: I): NegativeConnectionTask {
    const message = createBaseNegativeConnectionTask();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.common = (object.common !== undefined && object.common !== null)
      ? SmartHandsCommonTask.fromPartial(object.common)
      : undefined;
    message.foundToPort = (object.foundToPort !== undefined && object.foundToPort !== null)
      ? SmartHandsPort.fromPartial(object.foundToPort)
      : undefined;
    message.foundOpticPid = object.foundOpticPid ?? "";
    message.fromPort = (object.fromPort !== undefined && object.fromPort !== null)
      ? SmartHandsPort.fromPartial(object.fromPort)
      : undefined;
    return message;
  },
};

function createBaseActiveWorker(): ActiveWorker {
  return { id: undefined };
}

export const ActiveWorker: MessageFns<ActiveWorker> = {
  encode(message: ActiveWorker, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActiveWorker {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActiveWorker();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActiveWorker {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: ActiveWorker): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActiveWorker>, I>>(base?: I): ActiveWorker {
    return ActiveWorker.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActiveWorker>, I>>(object: I): ActiveWorker {
    const message = createBaseActiveWorker();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseTenantMetadata(): TenantMetadata {
  return {
    id: undefined,
    orgName: "",
    tenantName: "",
    enabled: false,
    orgId: "",
    createdBy: "",
    orgKind: 0,
    cellPairUuid: "",
    cuiTenantId: "",
  };
}

export const TenantMetadata: MessageFns<TenantMetadata> = {
  encode(message: TenantMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.orgName !== "") {
      writer.uint32(18).string(message.orgName);
    }
    if (message.tenantName !== "") {
      writer.uint32(26).string(message.tenantName);
    }
    if (message.enabled !== false) {
      writer.uint32(32).bool(message.enabled);
    }
    if (message.orgId !== "") {
      writer.uint32(42).string(message.orgId);
    }
    if (message.createdBy !== "") {
      writer.uint32(50).string(message.createdBy);
    }
    if (message.orgKind !== 0) {
      writer.uint32(56).int32(message.orgKind);
    }
    if (message.cellPairUuid !== "") {
      writer.uint32(66).string(message.cellPairUuid);
    }
    if (message.cuiTenantId !== "") {
      writer.uint32(74).string(message.cuiTenantId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TenantMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTenantMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tenantName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.orgKind = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.cellPairUuid = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.cuiTenantId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TenantMetadata {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      orgName: isSet(object.orgName) ? globalThis.String(object.orgName) : "",
      tenantName: isSet(object.tenantName) ? globalThis.String(object.tenantName) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      createdBy: isSet(object.createdBy) ? globalThis.String(object.createdBy) : "",
      orgKind: isSet(object.orgKind) ? orgKindFromJSON(object.orgKind) : 0,
      cellPairUuid: isSet(object.cellPairUuid) ? globalThis.String(object.cellPairUuid) : "",
      cuiTenantId: isSet(object.cuiTenantId) ? globalThis.String(object.cuiTenantId) : "",
    };
  },

  toJSON(message: TenantMetadata): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.orgName !== "") {
      obj.orgName = message.orgName;
    }
    if (message.tenantName !== "") {
      obj.tenantName = message.tenantName;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.orgKind !== 0) {
      obj.orgKind = orgKindToJSON(message.orgKind);
    }
    if (message.cellPairUuid !== "") {
      obj.cellPairUuid = message.cellPairUuid;
    }
    if (message.cuiTenantId !== "") {
      obj.cuiTenantId = message.cuiTenantId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TenantMetadata>, I>>(base?: I): TenantMetadata {
    return TenantMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TenantMetadata>, I>>(object: I): TenantMetadata {
    const message = createBaseTenantMetadata();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.orgName = object.orgName ?? "";
    message.tenantName = object.tenantName ?? "";
    message.enabled = object.enabled ?? false;
    message.orgId = object.orgId ?? "";
    message.createdBy = object.createdBy ?? "";
    message.orgKind = object.orgKind ?? 0;
    message.cellPairUuid = object.cellPairUuid ?? "";
    message.cuiTenantId = object.cuiTenantId ?? "";
    return message;
  },
};

function createBaseBulkUpliftJobRequest(): BulkUpliftJobRequest {
  return {
    id: undefined,
    jobType: 0,
    directory: "",
    fileName: "",
    external: false,
    dependsOn: undefined,
    pullInterval: 0,
  };
}

export const BulkUpliftJobRequest: MessageFns<BulkUpliftJobRequest> = {
  encode(message: BulkUpliftJobRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.jobType !== 0) {
      writer.uint32(16).int32(message.jobType);
    }
    if (message.directory !== "") {
      writer.uint32(26).string(message.directory);
    }
    if (message.fileName !== "") {
      writer.uint32(34).string(message.fileName);
    }
    if (message.external !== false) {
      writer.uint32(40).bool(message.external);
    }
    if (message.dependsOn !== undefined) {
      PathId.encode(message.dependsOn, writer.uint32(50).fork()).join();
    }
    if (message.pullInterval !== 0) {
      writer.uint32(56).uint32(message.pullInterval);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BulkUpliftJobRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBulkUpliftJobRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.jobType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.directory = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.external = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.dependsOn = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.pullInterval = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BulkUpliftJobRequest {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      jobType: isSet(object.jobType) ? bulkUpliftJobTypeFromJSON(object.jobType) : 0,
      directory: isSet(object.directory) ? globalThis.String(object.directory) : "",
      fileName: isSet(object.fileName) ? globalThis.String(object.fileName) : "",
      external: isSet(object.external) ? globalThis.Boolean(object.external) : false,
      dependsOn: isSet(object.dependsOn) ? PathId.fromJSON(object.dependsOn) : undefined,
      pullInterval: isSet(object.pullInterval) ? globalThis.Number(object.pullInterval) : 0,
    };
  },

  toJSON(message: BulkUpliftJobRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.jobType !== 0) {
      obj.jobType = bulkUpliftJobTypeToJSON(message.jobType);
    }
    if (message.directory !== "") {
      obj.directory = message.directory;
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.external !== false) {
      obj.external = message.external;
    }
    if (message.dependsOn !== undefined) {
      obj.dependsOn = PathId.toJSON(message.dependsOn);
    }
    if (message.pullInterval !== 0) {
      obj.pullInterval = Math.round(message.pullInterval);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BulkUpliftJobRequest>, I>>(base?: I): BulkUpliftJobRequest {
    return BulkUpliftJobRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BulkUpliftJobRequest>, I>>(object: I): BulkUpliftJobRequest {
    const message = createBaseBulkUpliftJobRequest();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.jobType = object.jobType ?? 0;
    message.directory = object.directory ?? "";
    message.fileName = object.fileName ?? "";
    message.external = object.external ?? false;
    message.dependsOn = (object.dependsOn !== undefined && object.dependsOn !== null)
      ? PathId.fromPartial(object.dependsOn)
      : undefined;
    message.pullInterval = object.pullInterval ?? 0;
    return message;
  },
};

function createBaseBulkUpliftJobStatus(): BulkUpliftJobStatus {
  return { id: undefined, status: 0, bytesDropped: "0", bytesUploaded: "0" };
}

export const BulkUpliftJobStatus: MessageFns<BulkUpliftJobStatus> = {
  encode(message: BulkUpliftJobStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.bytesDropped !== "0") {
      writer.uint32(24).uint64(message.bytesDropped);
    }
    if (message.bytesUploaded !== "0") {
      writer.uint32(32).uint64(message.bytesUploaded);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BulkUpliftJobStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBulkUpliftJobStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.bytesDropped = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.bytesUploaded = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BulkUpliftJobStatus {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      status: isSet(object.status) ? bulkUpliftStatusFromJSON(object.status) : 0,
      bytesDropped: isSet(object.bytesDropped) ? globalThis.String(object.bytesDropped) : "0",
      bytesUploaded: isSet(object.bytesUploaded) ? globalThis.String(object.bytesUploaded) : "0",
    };
  },

  toJSON(message: BulkUpliftJobStatus): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.status !== 0) {
      obj.status = bulkUpliftStatusToJSON(message.status);
    }
    if (message.bytesDropped !== "0") {
      obj.bytesDropped = message.bytesDropped;
    }
    if (message.bytesUploaded !== "0") {
      obj.bytesUploaded = message.bytesUploaded;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BulkUpliftJobStatus>, I>>(base?: I): BulkUpliftJobStatus {
    return BulkUpliftJobStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BulkUpliftJobStatus>, I>>(object: I): BulkUpliftJobStatus {
    const message = createBaseBulkUpliftJobStatus();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.status = object.status ?? 0;
    message.bytesDropped = object.bytesDropped ?? "0";
    message.bytesUploaded = object.bytesUploaded ?? "0";
    return message;
  },
};

function createBaseRefPoint(): RefPoint {
  return {
    id: undefined,
    orgId: "",
    name: "",
    created: undefined,
    deviceIds: [],
    createJobState: 0,
    createCompleted: undefined,
    diffJobState: 0,
    diffAgainstTime: undefined,
  };
}

export const RefPoint: MessageFns<RefPoint> = {
  encode(message: RefPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.created !== undefined) {
      Timestamp.encode(toTimestamp(message.created), writer.uint32(34).fork()).join();
    }
    for (const v of message.deviceIds) {
      writer.uint32(42).string(v!);
    }
    if (message.createJobState !== 0) {
      writer.uint32(48).int32(message.createJobState);
    }
    if (message.createCompleted !== undefined) {
      Timestamp.encode(toTimestamp(message.createCompleted), writer.uint32(58).fork()).join();
    }
    if (message.diffJobState !== 0) {
      writer.uint32(64).int32(message.diffJobState);
    }
    if (message.diffAgainstTime !== undefined) {
      Timestamp.encode(toTimestamp(message.diffAgainstTime), writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RefPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRefPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.created = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.deviceIds.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.createJobState = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createCompleted = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.diffJobState = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.diffAgainstTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RefPoint {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      created: isSet(object.created) ? fromJsonTimestamp(object.created) : undefined,
      deviceIds: globalThis.Array.isArray(object?.deviceIds)
        ? object.deviceIds.map((e: any) => globalThis.String(e))
        : [],
      createJobState: isSet(object.createJobState) ? refPointJobStateFromJSON(object.createJobState) : 0,
      createCompleted: isSet(object.createCompleted) ? fromJsonTimestamp(object.createCompleted) : undefined,
      diffJobState: isSet(object.diffJobState) ? refPointJobStateFromJSON(object.diffJobState) : 0,
      diffAgainstTime: isSet(object.diffAgainstTime) ? fromJsonTimestamp(object.diffAgainstTime) : undefined,
    };
  },

  toJSON(message: RefPoint): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.created !== undefined) {
      obj.created = message.created.toISOString();
    }
    if (message.deviceIds?.length) {
      obj.deviceIds = message.deviceIds;
    }
    if (message.createJobState !== 0) {
      obj.createJobState = refPointJobStateToJSON(message.createJobState);
    }
    if (message.createCompleted !== undefined) {
      obj.createCompleted = message.createCompleted.toISOString();
    }
    if (message.diffJobState !== 0) {
      obj.diffJobState = refPointJobStateToJSON(message.diffJobState);
    }
    if (message.diffAgainstTime !== undefined) {
      obj.diffAgainstTime = message.diffAgainstTime.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RefPoint>, I>>(base?: I): RefPoint {
    return RefPoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RefPoint>, I>>(object: I): RefPoint {
    const message = createBaseRefPoint();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.orgId = object.orgId ?? "";
    message.name = object.name ?? "";
    message.created = object.created ?? undefined;
    message.deviceIds = object.deviceIds?.map((e) => e) || [];
    message.createJobState = object.createJobState ?? 0;
    message.createCompleted = object.createCompleted ?? undefined;
    message.diffJobState = object.diffJobState ?? 0;
    message.diffAgainstTime = object.diffAgainstTime ?? undefined;
    return message;
  },
};

function createBaseRefPointStatus(): RefPointStatus {
  return { id: undefined, jobType: 0, jobState: 0, completedAt: undefined };
}

export const RefPointStatus: MessageFns<RefPointStatus> = {
  encode(message: RefPointStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.jobType !== 0) {
      writer.uint32(16).int32(message.jobType);
    }
    if (message.jobState !== 0) {
      writer.uint32(24).int32(message.jobState);
    }
    if (message.completedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.completedAt), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RefPointStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRefPointStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.jobType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.jobState = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.completedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RefPointStatus {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      jobType: isSet(object.jobType) ? refPointJobTypeFromJSON(object.jobType) : 0,
      jobState: isSet(object.jobState) ? refPointJobStateFromJSON(object.jobState) : 0,
      completedAt: isSet(object.completedAt) ? fromJsonTimestamp(object.completedAt) : undefined,
    };
  },

  toJSON(message: RefPointStatus): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.jobType !== 0) {
      obj.jobType = refPointJobTypeToJSON(message.jobType);
    }
    if (message.jobState !== 0) {
      obj.jobState = refPointJobStateToJSON(message.jobState);
    }
    if (message.completedAt !== undefined) {
      obj.completedAt = message.completedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RefPointStatus>, I>>(base?: I): RefPointStatus {
    return RefPointStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RefPointStatus>, I>>(object: I): RefPointStatus {
    const message = createBaseRefPointStatus();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.jobType = object.jobType ?? 0;
    message.jobState = object.jobState ?? 0;
    message.completedAt = object.completedAt ?? undefined;
    return message;
  },
};

function createBaseUserPreferenceItem(): UserPreferenceItem {
  return {
    id: undefined,
    provider: "",
    timezone: "",
    theme: 0,
    skipVideoTour: false,
    skipFeatureHighlights: false,
    timeFormat: 0,
  };
}

export const UserPreferenceItem: MessageFns<UserPreferenceItem> = {
  encode(message: UserPreferenceItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.provider !== "") {
      writer.uint32(18).string(message.provider);
    }
    if (message.timezone !== "") {
      writer.uint32(26).string(message.timezone);
    }
    if (message.theme !== 0) {
      writer.uint32(40).int32(message.theme);
    }
    if (message.skipVideoTour !== false) {
      writer.uint32(48).bool(message.skipVideoTour);
    }
    if (message.skipFeatureHighlights !== false) {
      writer.uint32(56).bool(message.skipFeatureHighlights);
    }
    if (message.timeFormat !== 0) {
      writer.uint32(64).int32(message.timeFormat);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserPreferenceItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserPreferenceItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.timezone = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.theme = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.skipVideoTour = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.skipFeatureHighlights = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.timeFormat = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserPreferenceItem {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      timezone: isSet(object.timezone) ? globalThis.String(object.timezone) : "",
      theme: isSet(object.theme) ? themeFromJSON(object.theme) : 0,
      skipVideoTour: isSet(object.skipVideoTour) ? globalThis.Boolean(object.skipVideoTour) : false,
      skipFeatureHighlights: isSet(object.skipFeatureHighlights)
        ? globalThis.Boolean(object.skipFeatureHighlights)
        : false,
      timeFormat: isSet(object.timeFormat) ? timeFormatFromJSON(object.timeFormat) : 0,
    };
  },

  toJSON(message: UserPreferenceItem): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.timezone !== "") {
      obj.timezone = message.timezone;
    }
    if (message.theme !== 0) {
      obj.theme = themeToJSON(message.theme);
    }
    if (message.skipVideoTour !== false) {
      obj.skipVideoTour = message.skipVideoTour;
    }
    if (message.skipFeatureHighlights !== false) {
      obj.skipFeatureHighlights = message.skipFeatureHighlights;
    }
    if (message.timeFormat !== 0) {
      obj.timeFormat = timeFormatToJSON(message.timeFormat);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserPreferenceItem>, I>>(base?: I): UserPreferenceItem {
    return UserPreferenceItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserPreferenceItem>, I>>(object: I): UserPreferenceItem {
    const message = createBaseUserPreferenceItem();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.provider = object.provider ?? "";
    message.timezone = object.timezone ?? "";
    message.theme = object.theme ?? 0;
    message.skipVideoTour = object.skipVideoTour ?? false;
    message.skipFeatureHighlights = object.skipFeatureHighlights ?? false;
    message.timeFormat = object.timeFormat ?? 0;
    return message;
  },
};

function createBaseUserEula(): UserEula {
  return { id: undefined, provider: "", version: "" };
}

export const UserEula: MessageFns<UserEula> = {
  encode(message: UserEula, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.provider !== "") {
      writer.uint32(18).string(message.provider);
    }
    if (message.version !== "") {
      writer.uint32(26).string(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserEula {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserEula();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.version = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserEula {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
    };
  },

  toJSON(message: UserEula): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserEula>, I>>(base?: I): UserEula {
    return UserEula.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserEula>, I>>(object: I): UserEula {
    const message = createBaseUserEula();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.provider = object.provider ?? "";
    message.version = object.version ?? "";
    return message;
  },
};

function createBaseBrigSymmetricSigningKey(): BrigSymmetricSigningKey {
  return { id: undefined, keyId: 0, keyValue: "", createdAt: undefined };
}

export const BrigSymmetricSigningKey: MessageFns<BrigSymmetricSigningKey> = {
  encode(message: BrigSymmetricSigningKey, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.keyId !== 0) {
      writer.uint32(16).uint32(message.keyId);
    }
    if (message.keyValue !== "") {
      writer.uint32(26).string(message.keyValue);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BrigSymmetricSigningKey {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBrigSymmetricSigningKey();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.keyId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.keyValue = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BrigSymmetricSigningKey {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      keyId: isSet(object.keyId) ? globalThis.Number(object.keyId) : 0,
      keyValue: isSet(object.keyValue) ? globalThis.String(object.keyValue) : "",
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
    };
  },

  toJSON(message: BrigSymmetricSigningKey): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.keyId !== 0) {
      obj.keyId = Math.round(message.keyId);
    }
    if (message.keyValue !== "") {
      obj.keyValue = message.keyValue;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BrigSymmetricSigningKey>, I>>(base?: I): BrigSymmetricSigningKey {
    return BrigSymmetricSigningKey.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BrigSymmetricSigningKey>, I>>(object: I): BrigSymmetricSigningKey {
    const message = createBaseBrigSymmetricSigningKey();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.keyId = object.keyId ?? 0;
    message.keyValue = object.keyValue ?? "";
    message.createdAt = object.createdAt ?? undefined;
    return message;
  },
};

function createBaseLoadBalancedSvcRoute(): LoadBalancedSvcRoute {
  return { id: undefined, updatedTs: undefined, host: undefined };
}

export const LoadBalancedSvcRoute: MessageFns<LoadBalancedSvcRoute> = {
  encode(message: LoadBalancedSvcRoute, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.updatedTs !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedTs), writer.uint32(26).fork()).join();
    }
    if (message.host !== undefined) {
      HostPort.encode(message.host, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadBalancedSvcRoute {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadBalancedSvcRoute();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedTs = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.host = HostPort.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadBalancedSvcRoute {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      updatedTs: isSet(object.updatedTs) ? fromJsonTimestamp(object.updatedTs) : undefined,
      host: isSet(object.host) ? HostPort.fromJSON(object.host) : undefined,
    };
  },

  toJSON(message: LoadBalancedSvcRoute): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.updatedTs !== undefined) {
      obj.updatedTs = message.updatedTs.toISOString();
    }
    if (message.host !== undefined) {
      obj.host = HostPort.toJSON(message.host);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadBalancedSvcRoute>, I>>(base?: I): LoadBalancedSvcRoute {
    return LoadBalancedSvcRoute.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadBalancedSvcRoute>, I>>(object: I): LoadBalancedSvcRoute {
    const message = createBaseLoadBalancedSvcRoute();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.updatedTs = object.updatedTs ?? undefined;
    message.host = (object.host !== undefined && object.host !== null) ? HostPort.fromPartial(object.host) : undefined;
    return message;
  },
};

function createBaseAssignmentSvcRoute(): AssignmentSvcRoute {
  return { id: undefined, ready: false, orgId: "", revision: 0, updatedTs: undefined, host: undefined };
}

export const AssignmentSvcRoute: MessageFns<AssignmentSvcRoute> = {
  encode(message: AssignmentSvcRoute, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.ready !== false) {
      writer.uint32(24).bool(message.ready);
    }
    if (message.orgId !== "") {
      writer.uint32(34).string(message.orgId);
    }
    if (message.revision !== 0) {
      writer.uint32(40).uint32(message.revision);
    }
    if (message.updatedTs !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedTs), writer.uint32(50).fork()).join();
    }
    if (message.host !== undefined) {
      HostPort.encode(message.host, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignmentSvcRoute {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignmentSvcRoute();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.ready = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.revision = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedTs = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.host = HostPort.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssignmentSvcRoute {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      ready: isSet(object.ready) ? globalThis.Boolean(object.ready) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      revision: isSet(object.revision) ? globalThis.Number(object.revision) : 0,
      updatedTs: isSet(object.updatedTs) ? fromJsonTimestamp(object.updatedTs) : undefined,
      host: isSet(object.host) ? HostPort.fromJSON(object.host) : undefined,
    };
  },

  toJSON(message: AssignmentSvcRoute): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.ready !== false) {
      obj.ready = message.ready;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.revision !== 0) {
      obj.revision = Math.round(message.revision);
    }
    if (message.updatedTs !== undefined) {
      obj.updatedTs = message.updatedTs.toISOString();
    }
    if (message.host !== undefined) {
      obj.host = HostPort.toJSON(message.host);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignmentSvcRoute>, I>>(base?: I): AssignmentSvcRoute {
    return AssignmentSvcRoute.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignmentSvcRoute>, I>>(object: I): AssignmentSvcRoute {
    const message = createBaseAssignmentSvcRoute();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.ready = object.ready ?? false;
    message.orgId = object.orgId ?? "";
    message.revision = object.revision ?? 0;
    message.updatedTs = object.updatedTs ?? undefined;
    message.host = (object.host !== undefined && object.host !== null) ? HostPort.fromPartial(object.host) : undefined;
    return message;
  },
};

function createBaseDbTableUpdateNotification(): DbTableUpdateNotification {
  return { id: undefined, instanceName: "", dbTable: 0, tableUpdatedAt: undefined, createdAt: undefined };
}

export const DbTableUpdateNotification: MessageFns<DbTableUpdateNotification> = {
  encode(message: DbTableUpdateNotification, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.instanceName !== "") {
      writer.uint32(18).string(message.instanceName);
    }
    if (message.dbTable !== 0) {
      writer.uint32(24).int32(message.dbTable);
    }
    if (message.tableUpdatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.tableUpdatedAt), writer.uint32(34).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DbTableUpdateNotification {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDbTableUpdateNotification();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.instanceName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.dbTable = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tableUpdatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DbTableUpdateNotification {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      instanceName: isSet(object.instanceName) ? globalThis.String(object.instanceName) : "",
      dbTable: isSet(object.dbTable) ? dbTableEnumFromJSON(object.dbTable) : 0,
      tableUpdatedAt: isSet(object.tableUpdatedAt) ? fromJsonTimestamp(object.tableUpdatedAt) : undefined,
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
    };
  },

  toJSON(message: DbTableUpdateNotification): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.instanceName !== "") {
      obj.instanceName = message.instanceName;
    }
    if (message.dbTable !== 0) {
      obj.dbTable = dbTableEnumToJSON(message.dbTable);
    }
    if (message.tableUpdatedAt !== undefined) {
      obj.tableUpdatedAt = message.tableUpdatedAt.toISOString();
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DbTableUpdateNotification>, I>>(base?: I): DbTableUpdateNotification {
    return DbTableUpdateNotification.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DbTableUpdateNotification>, I>>(object: I): DbTableUpdateNotification {
    const message = createBaseDbTableUpdateNotification();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.instanceName = object.instanceName ?? "";
    message.dbTable = object.dbTable ?? 0;
    message.tableUpdatedAt = object.tableUpdatedAt ?? undefined;
    message.createdAt = object.createdAt ?? undefined;
    return message;
  },
};

function createBaseIpRouteJoinedView(): IpRouteJoinedView {
  return {
    id: undefined,
    prefix: "",
    prefixLen: 0,
    vrfId: 0,
    vrfName: "",
    distance: 0,
    metric: 0,
    internalNextHopNum: 0,
    internalNextHopActiveNum: 0,
    ipFamily: 0,
    protocol: 0,
    multipleDiffNextHops: false,
    directlyConnected: false,
    nexthopIp: "",
    interfaceName: "",
    active: false,
    onLink: false,
    weight: 0,
    recursive: false,
    blackhole: false,
    macAddress: "",
    vlan: 0,
    vni: 0,
    internal: false,
    nexthopLocation: "",
    bgpOrigin: 0,
    bgpPeerId: "",
    bgpPeerAsnPath: "",
    bgpPathFrom: 0,
    bgpSelectionReason: 0,
    bgpWeight: 0,
    bgpMed: 0,
    bgpNhIp: "",
    bgpNhName: "",
    fabricLocation: 0,
    remoteFabricId: "",
  };
}

export const IpRouteJoinedView: MessageFns<IpRouteJoinedView> = {
  encode(message: IpRouteJoinedView, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.prefix !== "") {
      writer.uint32(18).string(message.prefix);
    }
    if (message.prefixLen !== 0) {
      writer.uint32(24).uint32(message.prefixLen);
    }
    if (message.vrfId !== 0) {
      writer.uint32(32).uint32(message.vrfId);
    }
    if (message.vrfName !== "") {
      writer.uint32(42).string(message.vrfName);
    }
    if (message.distance !== 0) {
      writer.uint32(48).uint32(message.distance);
    }
    if (message.metric !== 0) {
      writer.uint32(56).uint32(message.metric);
    }
    if (message.internalNextHopNum !== 0) {
      writer.uint32(64).uint32(message.internalNextHopNum);
    }
    if (message.internalNextHopActiveNum !== 0) {
      writer.uint32(72).uint32(message.internalNextHopActiveNum);
    }
    if (message.ipFamily !== 0) {
      writer.uint32(80).int32(message.ipFamily);
    }
    if (message.protocol !== 0) {
      writer.uint32(88).int32(message.protocol);
    }
    if (message.multipleDiffNextHops !== false) {
      writer.uint32(96).bool(message.multipleDiffNextHops);
    }
    if (message.directlyConnected !== false) {
      writer.uint32(168).bool(message.directlyConnected);
    }
    if (message.nexthopIp !== "") {
      writer.uint32(178).string(message.nexthopIp);
    }
    if (message.interfaceName !== "") {
      writer.uint32(186).string(message.interfaceName);
    }
    if (message.active !== false) {
      writer.uint32(192).bool(message.active);
    }
    if (message.onLink !== false) {
      writer.uint32(200).bool(message.onLink);
    }
    if (message.weight !== 0) {
      writer.uint32(208).int32(message.weight);
    }
    if (message.recursive !== false) {
      writer.uint32(216).bool(message.recursive);
    }
    if (message.blackhole !== false) {
      writer.uint32(224).bool(message.blackhole);
    }
    if (message.macAddress !== "") {
      writer.uint32(250).string(message.macAddress);
    }
    if (message.vlan !== 0) {
      writer.uint32(256).uint32(message.vlan);
    }
    if (message.vni !== 0) {
      writer.uint32(264).uint32(message.vni);
    }
    if (message.internal !== false) {
      writer.uint32(272).bool(message.internal);
    }
    if (message.nexthopLocation !== "") {
      writer.uint32(330).string(message.nexthopLocation);
    }
    if (message.bgpOrigin !== 0) {
      writer.uint32(360).int32(message.bgpOrigin);
    }
    if (message.bgpPeerId !== "") {
      writer.uint32(370).string(message.bgpPeerId);
    }
    if (message.bgpPeerAsnPath !== "") {
      writer.uint32(378).string(message.bgpPeerAsnPath);
    }
    if (message.bgpPathFrom !== 0) {
      writer.uint32(384).int32(message.bgpPathFrom);
    }
    if (message.bgpSelectionReason !== 0) {
      writer.uint32(392).int32(message.bgpSelectionReason);
    }
    if (message.bgpWeight !== 0) {
      writer.uint32(400).int32(message.bgpWeight);
    }
    if (message.bgpMed !== 0) {
      writer.uint32(408).int32(message.bgpMed);
    }
    if (message.bgpNhIp !== "") {
      writer.uint32(418).string(message.bgpNhIp);
    }
    if (message.bgpNhName !== "") {
      writer.uint32(426).string(message.bgpNhName);
    }
    if (message.fabricLocation !== 0) {
      writer.uint32(432).int32(message.fabricLocation);
    }
    if (message.remoteFabricId !== "") {
      writer.uint32(442).string(message.remoteFabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpRouteJoinedView {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpRouteJoinedView();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.prefix = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.prefixLen = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.vrfId = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.vrfName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.distance = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.metric = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.internalNextHopNum = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.internalNextHopActiveNum = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.ipFamily = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.protocol = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.multipleDiffNextHops = reader.bool();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.directlyConnected = reader.bool();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.nexthopIp = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.interfaceName = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.onLink = reader.bool();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.weight = reader.int32();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.recursive = reader.bool();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.blackhole = reader.bool();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.macAddress = reader.string();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.vlan = reader.uint32();
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.internal = reader.bool();
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.nexthopLocation = reader.string();
          continue;
        }
        case 45: {
          if (tag !== 360) {
            break;
          }

          message.bgpOrigin = reader.int32() as any;
          continue;
        }
        case 46: {
          if (tag !== 370) {
            break;
          }

          message.bgpPeerId = reader.string();
          continue;
        }
        case 47: {
          if (tag !== 378) {
            break;
          }

          message.bgpPeerAsnPath = reader.string();
          continue;
        }
        case 48: {
          if (tag !== 384) {
            break;
          }

          message.bgpPathFrom = reader.int32() as any;
          continue;
        }
        case 49: {
          if (tag !== 392) {
            break;
          }

          message.bgpSelectionReason = reader.int32() as any;
          continue;
        }
        case 50: {
          if (tag !== 400) {
            break;
          }

          message.bgpWeight = reader.int32();
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.bgpMed = reader.int32();
          continue;
        }
        case 52: {
          if (tag !== 418) {
            break;
          }

          message.bgpNhIp = reader.string();
          continue;
        }
        case 53: {
          if (tag !== 426) {
            break;
          }

          message.bgpNhName = reader.string();
          continue;
        }
        case 54: {
          if (tag !== 432) {
            break;
          }

          message.fabricLocation = reader.int32() as any;
          continue;
        }
        case 55: {
          if (tag !== 442) {
            break;
          }

          message.remoteFabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpRouteJoinedView {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      prefix: isSet(object.prefix) ? globalThis.String(object.prefix) : "",
      prefixLen: isSet(object.prefixLen) ? globalThis.Number(object.prefixLen) : 0,
      vrfId: isSet(object.vrfId) ? globalThis.Number(object.vrfId) : 0,
      vrfName: isSet(object.vrfName) ? globalThis.String(object.vrfName) : "",
      distance: isSet(object.distance) ? globalThis.Number(object.distance) : 0,
      metric: isSet(object.metric) ? globalThis.Number(object.metric) : 0,
      internalNextHopNum: isSet(object.internalNextHopNum) ? globalThis.Number(object.internalNextHopNum) : 0,
      internalNextHopActiveNum: isSet(object.internalNextHopActiveNum)
        ? globalThis.Number(object.internalNextHopActiveNum)
        : 0,
      ipFamily: isSet(object.ipFamily) ? ipFamilyTypeFromJSON(object.ipFamily) : 0,
      protocol: isSet(object.protocol) ? protocolTypeFromJSON(object.protocol) : 0,
      multipleDiffNextHops: isSet(object.multipleDiffNextHops)
        ? globalThis.Boolean(object.multipleDiffNextHops)
        : false,
      directlyConnected: isSet(object.directlyConnected) ? globalThis.Boolean(object.directlyConnected) : false,
      nexthopIp: isSet(object.nexthopIp) ? globalThis.String(object.nexthopIp) : "",
      interfaceName: isSet(object.interfaceName) ? globalThis.String(object.interfaceName) : "",
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      onLink: isSet(object.onLink) ? globalThis.Boolean(object.onLink) : false,
      weight: isSet(object.weight) ? globalThis.Number(object.weight) : 0,
      recursive: isSet(object.recursive) ? globalThis.Boolean(object.recursive) : false,
      blackhole: isSet(object.blackhole) ? globalThis.Boolean(object.blackhole) : false,
      macAddress: isSet(object.macAddress) ? globalThis.String(object.macAddress) : "",
      vlan: isSet(object.vlan) ? globalThis.Number(object.vlan) : 0,
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      internal: isSet(object.internal) ? globalThis.Boolean(object.internal) : false,
      nexthopLocation: isSet(object.nexthopLocation) ? globalThis.String(object.nexthopLocation) : "",
      bgpOrigin: isSet(object.bgpOrigin) ? bgpRouteOriginTypeFromJSON(object.bgpOrigin) : 0,
      bgpPeerId: isSet(object.bgpPeerId) ? globalThis.String(object.bgpPeerId) : "",
      bgpPeerAsnPath: isSet(object.bgpPeerAsnPath) ? globalThis.String(object.bgpPeerAsnPath) : "",
      bgpPathFrom: isSet(object.bgpPathFrom) ? bgpPathSourceFromJSON(object.bgpPathFrom) : 0,
      bgpSelectionReason: isSet(object.bgpSelectionReason)
        ? bgpPathSelectionReasonFromJSON(object.bgpSelectionReason)
        : 0,
      bgpWeight: isSet(object.bgpWeight) ? globalThis.Number(object.bgpWeight) : 0,
      bgpMed: isSet(object.bgpMed) ? globalThis.Number(object.bgpMed) : 0,
      bgpNhIp: isSet(object.bgpNhIp) ? globalThis.String(object.bgpNhIp) : "",
      bgpNhName: isSet(object.bgpNhName) ? globalThis.String(object.bgpNhName) : "",
      fabricLocation: isSet(object.fabricLocation) ? remoteEntryLocationFromJSON(object.fabricLocation) : 0,
      remoteFabricId: isSet(object.remoteFabricId) ? globalThis.String(object.remoteFabricId) : "",
    };
  },

  toJSON(message: IpRouteJoinedView): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.prefix !== "") {
      obj.prefix = message.prefix;
    }
    if (message.prefixLen !== 0) {
      obj.prefixLen = Math.round(message.prefixLen);
    }
    if (message.vrfId !== 0) {
      obj.vrfId = Math.round(message.vrfId);
    }
    if (message.vrfName !== "") {
      obj.vrfName = message.vrfName;
    }
    if (message.distance !== 0) {
      obj.distance = Math.round(message.distance);
    }
    if (message.metric !== 0) {
      obj.metric = Math.round(message.metric);
    }
    if (message.internalNextHopNum !== 0) {
      obj.internalNextHopNum = Math.round(message.internalNextHopNum);
    }
    if (message.internalNextHopActiveNum !== 0) {
      obj.internalNextHopActiveNum = Math.round(message.internalNextHopActiveNum);
    }
    if (message.ipFamily !== 0) {
      obj.ipFamily = ipFamilyTypeToJSON(message.ipFamily);
    }
    if (message.protocol !== 0) {
      obj.protocol = protocolTypeToJSON(message.protocol);
    }
    if (message.multipleDiffNextHops !== false) {
      obj.multipleDiffNextHops = message.multipleDiffNextHops;
    }
    if (message.directlyConnected !== false) {
      obj.directlyConnected = message.directlyConnected;
    }
    if (message.nexthopIp !== "") {
      obj.nexthopIp = message.nexthopIp;
    }
    if (message.interfaceName !== "") {
      obj.interfaceName = message.interfaceName;
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.onLink !== false) {
      obj.onLink = message.onLink;
    }
    if (message.weight !== 0) {
      obj.weight = Math.round(message.weight);
    }
    if (message.recursive !== false) {
      obj.recursive = message.recursive;
    }
    if (message.blackhole !== false) {
      obj.blackhole = message.blackhole;
    }
    if (message.macAddress !== "") {
      obj.macAddress = message.macAddress;
    }
    if (message.vlan !== 0) {
      obj.vlan = Math.round(message.vlan);
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.internal !== false) {
      obj.internal = message.internal;
    }
    if (message.nexthopLocation !== "") {
      obj.nexthopLocation = message.nexthopLocation;
    }
    if (message.bgpOrigin !== 0) {
      obj.bgpOrigin = bgpRouteOriginTypeToJSON(message.bgpOrigin);
    }
    if (message.bgpPeerId !== "") {
      obj.bgpPeerId = message.bgpPeerId;
    }
    if (message.bgpPeerAsnPath !== "") {
      obj.bgpPeerAsnPath = message.bgpPeerAsnPath;
    }
    if (message.bgpPathFrom !== 0) {
      obj.bgpPathFrom = bgpPathSourceToJSON(message.bgpPathFrom);
    }
    if (message.bgpSelectionReason !== 0) {
      obj.bgpSelectionReason = bgpPathSelectionReasonToJSON(message.bgpSelectionReason);
    }
    if (message.bgpWeight !== 0) {
      obj.bgpWeight = Math.round(message.bgpWeight);
    }
    if (message.bgpMed !== 0) {
      obj.bgpMed = Math.round(message.bgpMed);
    }
    if (message.bgpNhIp !== "") {
      obj.bgpNhIp = message.bgpNhIp;
    }
    if (message.bgpNhName !== "") {
      obj.bgpNhName = message.bgpNhName;
    }
    if (message.fabricLocation !== 0) {
      obj.fabricLocation = remoteEntryLocationToJSON(message.fabricLocation);
    }
    if (message.remoteFabricId !== "") {
      obj.remoteFabricId = message.remoteFabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpRouteJoinedView>, I>>(base?: I): IpRouteJoinedView {
    return IpRouteJoinedView.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpRouteJoinedView>, I>>(object: I): IpRouteJoinedView {
    const message = createBaseIpRouteJoinedView();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.prefix = object.prefix ?? "";
    message.prefixLen = object.prefixLen ?? 0;
    message.vrfId = object.vrfId ?? 0;
    message.vrfName = object.vrfName ?? "";
    message.distance = object.distance ?? 0;
    message.metric = object.metric ?? 0;
    message.internalNextHopNum = object.internalNextHopNum ?? 0;
    message.internalNextHopActiveNum = object.internalNextHopActiveNum ?? 0;
    message.ipFamily = object.ipFamily ?? 0;
    message.protocol = object.protocol ?? 0;
    message.multipleDiffNextHops = object.multipleDiffNextHops ?? false;
    message.directlyConnected = object.directlyConnected ?? false;
    message.nexthopIp = object.nexthopIp ?? "";
    message.interfaceName = object.interfaceName ?? "";
    message.active = object.active ?? false;
    message.onLink = object.onLink ?? false;
    message.weight = object.weight ?? 0;
    message.recursive = object.recursive ?? false;
    message.blackhole = object.blackhole ?? false;
    message.macAddress = object.macAddress ?? "";
    message.vlan = object.vlan ?? 0;
    message.vni = object.vni ?? 0;
    message.internal = object.internal ?? false;
    message.nexthopLocation = object.nexthopLocation ?? "";
    message.bgpOrigin = object.bgpOrigin ?? 0;
    message.bgpPeerId = object.bgpPeerId ?? "";
    message.bgpPeerAsnPath = object.bgpPeerAsnPath ?? "";
    message.bgpPathFrom = object.bgpPathFrom ?? 0;
    message.bgpSelectionReason = object.bgpSelectionReason ?? 0;
    message.bgpWeight = object.bgpWeight ?? 0;
    message.bgpMed = object.bgpMed ?? 0;
    message.bgpNhIp = object.bgpNhIp ?? "";
    message.bgpNhName = object.bgpNhName ?? "";
    message.fabricLocation = object.fabricLocation ?? 0;
    message.remoteFabricId = object.remoteFabricId ?? "";
    return message;
  },
};

function createBasePluggableConnectionInfo(): PluggableConnectionInfo {
  return {
    id: undefined,
    interfaceName: "",
    expectedPid: "",
    expectedRemoteDeviceId: "",
    expectedRemoteDeviceName: "",
    expectedRemoteInterfaceName: "",
    discoveredPid: "",
    discoveredRemoteDeviceId: "",
    discoveredRemoteDeviceName: "",
    discoveredRemoteInterfaceName: "",
  };
}

export const PluggableConnectionInfo: MessageFns<PluggableConnectionInfo> = {
  encode(message: PluggableConnectionInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.interfaceName !== "") {
      writer.uint32(18).string(message.interfaceName);
    }
    if (message.expectedPid !== "") {
      writer.uint32(26).string(message.expectedPid);
    }
    if (message.expectedRemoteDeviceId !== "") {
      writer.uint32(34).string(message.expectedRemoteDeviceId);
    }
    if (message.expectedRemoteDeviceName !== "") {
      writer.uint32(42).string(message.expectedRemoteDeviceName);
    }
    if (message.expectedRemoteInterfaceName !== "") {
      writer.uint32(50).string(message.expectedRemoteInterfaceName);
    }
    if (message.discoveredPid !== "") {
      writer.uint32(58).string(message.discoveredPid);
    }
    if (message.discoveredRemoteDeviceId !== "") {
      writer.uint32(66).string(message.discoveredRemoteDeviceId);
    }
    if (message.discoveredRemoteDeviceName !== "") {
      writer.uint32(74).string(message.discoveredRemoteDeviceName);
    }
    if (message.discoveredRemoteInterfaceName !== "") {
      writer.uint32(82).string(message.discoveredRemoteInterfaceName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PluggableConnectionInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePluggableConnectionInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.interfaceName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.expectedPid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.expectedRemoteDeviceId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.expectedRemoteDeviceName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.expectedRemoteInterfaceName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.discoveredPid = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.discoveredRemoteDeviceId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.discoveredRemoteDeviceName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.discoveredRemoteInterfaceName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PluggableConnectionInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      interfaceName: isSet(object.interfaceName) ? globalThis.String(object.interfaceName) : "",
      expectedPid: isSet(object.expectedPid) ? globalThis.String(object.expectedPid) : "",
      expectedRemoteDeviceId: isSet(object.expectedRemoteDeviceId)
        ? globalThis.String(object.expectedRemoteDeviceId)
        : "",
      expectedRemoteDeviceName: isSet(object.expectedRemoteDeviceName)
        ? globalThis.String(object.expectedRemoteDeviceName)
        : "",
      expectedRemoteInterfaceName: isSet(object.expectedRemoteInterfaceName)
        ? globalThis.String(object.expectedRemoteInterfaceName)
        : "",
      discoveredPid: isSet(object.discoveredPid) ? globalThis.String(object.discoveredPid) : "",
      discoveredRemoteDeviceId: isSet(object.discoveredRemoteDeviceId)
        ? globalThis.String(object.discoveredRemoteDeviceId)
        : "",
      discoveredRemoteDeviceName: isSet(object.discoveredRemoteDeviceName)
        ? globalThis.String(object.discoveredRemoteDeviceName)
        : "",
      discoveredRemoteInterfaceName: isSet(object.discoveredRemoteInterfaceName)
        ? globalThis.String(object.discoveredRemoteInterfaceName)
        : "",
    };
  },

  toJSON(message: PluggableConnectionInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.interfaceName !== "") {
      obj.interfaceName = message.interfaceName;
    }
    if (message.expectedPid !== "") {
      obj.expectedPid = message.expectedPid;
    }
    if (message.expectedRemoteDeviceId !== "") {
      obj.expectedRemoteDeviceId = message.expectedRemoteDeviceId;
    }
    if (message.expectedRemoteDeviceName !== "") {
      obj.expectedRemoteDeviceName = message.expectedRemoteDeviceName;
    }
    if (message.expectedRemoteInterfaceName !== "") {
      obj.expectedRemoteInterfaceName = message.expectedRemoteInterfaceName;
    }
    if (message.discoveredPid !== "") {
      obj.discoveredPid = message.discoveredPid;
    }
    if (message.discoveredRemoteDeviceId !== "") {
      obj.discoveredRemoteDeviceId = message.discoveredRemoteDeviceId;
    }
    if (message.discoveredRemoteDeviceName !== "") {
      obj.discoveredRemoteDeviceName = message.discoveredRemoteDeviceName;
    }
    if (message.discoveredRemoteInterfaceName !== "") {
      obj.discoveredRemoteInterfaceName = message.discoveredRemoteInterfaceName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PluggableConnectionInfo>, I>>(base?: I): PluggableConnectionInfo {
    return PluggableConnectionInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PluggableConnectionInfo>, I>>(object: I): PluggableConnectionInfo {
    const message = createBasePluggableConnectionInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.interfaceName = object.interfaceName ?? "";
    message.expectedPid = object.expectedPid ?? "";
    message.expectedRemoteDeviceId = object.expectedRemoteDeviceId ?? "";
    message.expectedRemoteDeviceName = object.expectedRemoteDeviceName ?? "";
    message.expectedRemoteInterfaceName = object.expectedRemoteInterfaceName ?? "";
    message.discoveredPid = object.discoveredPid ?? "";
    message.discoveredRemoteDeviceId = object.discoveredRemoteDeviceId ?? "";
    message.discoveredRemoteDeviceName = object.discoveredRemoteDeviceName ?? "";
    message.discoveredRemoteInterfaceName = object.discoveredRemoteInterfaceName ?? "";
    return message;
  },
};

function createBaseIpRouteJoinedViewCountSpace(): IpRouteJoinedViewCountSpace {
  return { id: undefined };
}

export const IpRouteJoinedViewCountSpace: MessageFns<IpRouteJoinedViewCountSpace> = {
  encode(message: IpRouteJoinedViewCountSpace, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpRouteJoinedViewCountSpace {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpRouteJoinedViewCountSpace();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpRouteJoinedViewCountSpace {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: IpRouteJoinedViewCountSpace): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpRouteJoinedViewCountSpace>, I>>(base?: I): IpRouteJoinedViewCountSpace {
    return IpRouteJoinedViewCountSpace.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpRouteJoinedViewCountSpace>, I>>(object: I): IpRouteJoinedViewCountSpace {
    const message = createBaseIpRouteJoinedViewCountSpace();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseIpRouteJoinedViewCount(): IpRouteJoinedViewCount {
  return { id: undefined, vrfId: 0, vrfName: "", entryCount: 0, ipFamily: 0, staticRoutesCount: 0 };
}

export const IpRouteJoinedViewCount: MessageFns<IpRouteJoinedViewCount> = {
  encode(message: IpRouteJoinedViewCount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.vrfId !== 0) {
      writer.uint32(32).uint32(message.vrfId);
    }
    if (message.vrfName !== "") {
      writer.uint32(42).string(message.vrfName);
    }
    if (message.entryCount !== 0) {
      writer.uint32(48).uint32(message.entryCount);
    }
    if (message.ipFamily !== 0) {
      writer.uint32(56).int32(message.ipFamily);
    }
    if (message.staticRoutesCount !== 0) {
      writer.uint32(64).uint32(message.staticRoutesCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpRouteJoinedViewCount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpRouteJoinedViewCount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.vrfId = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.vrfName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.entryCount = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.ipFamily = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.staticRoutesCount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpRouteJoinedViewCount {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vrfId: isSet(object.vrfId) ? globalThis.Number(object.vrfId) : 0,
      vrfName: isSet(object.vrfName) ? globalThis.String(object.vrfName) : "",
      entryCount: isSet(object.entryCount) ? globalThis.Number(object.entryCount) : 0,
      ipFamily: isSet(object.ipFamily) ? ipFamilyTypeFromJSON(object.ipFamily) : 0,
      staticRoutesCount: isSet(object.staticRoutesCount) ? globalThis.Number(object.staticRoutesCount) : 0,
    };
  },

  toJSON(message: IpRouteJoinedViewCount): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vrfId !== 0) {
      obj.vrfId = Math.round(message.vrfId);
    }
    if (message.vrfName !== "") {
      obj.vrfName = message.vrfName;
    }
    if (message.entryCount !== 0) {
      obj.entryCount = Math.round(message.entryCount);
    }
    if (message.ipFamily !== 0) {
      obj.ipFamily = ipFamilyTypeToJSON(message.ipFamily);
    }
    if (message.staticRoutesCount !== 0) {
      obj.staticRoutesCount = Math.round(message.staticRoutesCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpRouteJoinedViewCount>, I>>(base?: I): IpRouteJoinedViewCount {
    return IpRouteJoinedViewCount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpRouteJoinedViewCount>, I>>(object: I): IpRouteJoinedViewCount {
    const message = createBaseIpRouteJoinedViewCount();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vrfId = object.vrfId ?? 0;
    message.vrfName = object.vrfName ?? "";
    message.entryCount = object.entryCount ?? 0;
    message.ipFamily = object.ipFamily ?? 0;
    message.staticRoutesCount = object.staticRoutesCount ?? 0;
    return message;
  },
};

function createBaseIpRouteFabricJoinedViewCountSpace(): IpRouteFabricJoinedViewCountSpace {
  return { id: undefined };
}

export const IpRouteFabricJoinedViewCountSpace: MessageFns<IpRouteFabricJoinedViewCountSpace> = {
  encode(message: IpRouteFabricJoinedViewCountSpace, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpRouteFabricJoinedViewCountSpace {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpRouteFabricJoinedViewCountSpace();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpRouteFabricJoinedViewCountSpace {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: IpRouteFabricJoinedViewCountSpace): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpRouteFabricJoinedViewCountSpace>, I>>(
    base?: I,
  ): IpRouteFabricJoinedViewCountSpace {
    return IpRouteFabricJoinedViewCountSpace.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpRouteFabricJoinedViewCountSpace>, I>>(
    object: I,
  ): IpRouteFabricJoinedViewCountSpace {
    const message = createBaseIpRouteFabricJoinedViewCountSpace();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseIpRouteFabricJoinedViewCount(): IpRouteFabricJoinedViewCount {
  return { id: undefined, vrfId: 0, vrfName: "", entryCount: 0, ipFamily: 0, staticRoutesCount: 0 };
}

export const IpRouteFabricJoinedViewCount: MessageFns<IpRouteFabricJoinedViewCount> = {
  encode(message: IpRouteFabricJoinedViewCount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.vrfId !== 0) {
      writer.uint32(16).uint32(message.vrfId);
    }
    if (message.vrfName !== "") {
      writer.uint32(26).string(message.vrfName);
    }
    if (message.entryCount !== 0) {
      writer.uint32(32).uint32(message.entryCount);
    }
    if (message.ipFamily !== 0) {
      writer.uint32(40).int32(message.ipFamily);
    }
    if (message.staticRoutesCount !== 0) {
      writer.uint32(48).uint32(message.staticRoutesCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpRouteFabricJoinedViewCount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpRouteFabricJoinedViewCount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.vrfId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.vrfName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.entryCount = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.ipFamily = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.staticRoutesCount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpRouteFabricJoinedViewCount {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      vrfId: isSet(object.vrfId) ? globalThis.Number(object.vrfId) : 0,
      vrfName: isSet(object.vrfName) ? globalThis.String(object.vrfName) : "",
      entryCount: isSet(object.entryCount) ? globalThis.Number(object.entryCount) : 0,
      ipFamily: isSet(object.ipFamily) ? ipFamilyTypeFromJSON(object.ipFamily) : 0,
      staticRoutesCount: isSet(object.staticRoutesCount) ? globalThis.Number(object.staticRoutesCount) : 0,
    };
  },

  toJSON(message: IpRouteFabricJoinedViewCount): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.vrfId !== 0) {
      obj.vrfId = Math.round(message.vrfId);
    }
    if (message.vrfName !== "") {
      obj.vrfName = message.vrfName;
    }
    if (message.entryCount !== 0) {
      obj.entryCount = Math.round(message.entryCount);
    }
    if (message.ipFamily !== 0) {
      obj.ipFamily = ipFamilyTypeToJSON(message.ipFamily);
    }
    if (message.staticRoutesCount !== 0) {
      obj.staticRoutesCount = Math.round(message.staticRoutesCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpRouteFabricJoinedViewCount>, I>>(base?: I): IpRouteFabricJoinedViewCount {
    return IpRouteFabricJoinedViewCount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpRouteFabricJoinedViewCount>, I>>(object: I): IpRouteFabricJoinedViewCount {
    const message = createBaseIpRouteFabricJoinedViewCount();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.vrfId = object.vrfId ?? 0;
    message.vrfName = object.vrfName ?? "";
    message.entryCount = object.entryCount ?? 0;
    message.ipFamily = object.ipFamily ?? 0;
    message.staticRoutesCount = object.staticRoutesCount ?? 0;
    return message;
  },
};

function createBaseSigningKeyFlavor(): SigningKeyFlavor {
  return { id: undefined };
}

export const SigningKeyFlavor: MessageFns<SigningKeyFlavor> = {
  encode(message: SigningKeyFlavor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SigningKeyFlavor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSigningKeyFlavor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SigningKeyFlavor {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: SigningKeyFlavor): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SigningKeyFlavor>, I>>(base?: I): SigningKeyFlavor {
    return SigningKeyFlavor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SigningKeyFlavor>, I>>(object: I): SigningKeyFlavor {
    const message = createBaseSigningKeyFlavor();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseSigningKey(): SigningKey {
  return { id: undefined, clusterId: "", signingKeyType: 0, keyCreatedAt: undefined, publicKey: "" };
}

export const SigningKey: MessageFns<SigningKey> = {
  encode(message: SigningKey, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.clusterId !== "") {
      writer.uint32(18).string(message.clusterId);
    }
    if (message.signingKeyType !== 0) {
      writer.uint32(24).int32(message.signingKeyType);
    }
    if (message.keyCreatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.keyCreatedAt), writer.uint32(34).fork()).join();
    }
    if (message.publicKey !== "") {
      writer.uint32(42).string(message.publicKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SigningKey {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSigningKey();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.clusterId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.signingKeyType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.keyCreatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.publicKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SigningKey {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      clusterId: isSet(object.clusterId) ? globalThis.String(object.clusterId) : "",
      signingKeyType: isSet(object.signingKeyType) ? signingKeyEnumFromJSON(object.signingKeyType) : 0,
      keyCreatedAt: isSet(object.keyCreatedAt) ? fromJsonTimestamp(object.keyCreatedAt) : undefined,
      publicKey: isSet(object.publicKey) ? globalThis.String(object.publicKey) : "",
    };
  },

  toJSON(message: SigningKey): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.clusterId !== "") {
      obj.clusterId = message.clusterId;
    }
    if (message.signingKeyType !== 0) {
      obj.signingKeyType = signingKeyEnumToJSON(message.signingKeyType);
    }
    if (message.keyCreatedAt !== undefined) {
      obj.keyCreatedAt = message.keyCreatedAt.toISOString();
    }
    if (message.publicKey !== "") {
      obj.publicKey = message.publicKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SigningKey>, I>>(base?: I): SigningKey {
    return SigningKey.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SigningKey>, I>>(object: I): SigningKey {
    const message = createBaseSigningKey();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.clusterId = object.clusterId ?? "";
    message.signingKeyType = object.signingKeyType ?? 0;
    message.keyCreatedAt = object.keyCreatedAt ?? undefined;
    message.publicKey = object.publicKey ?? "";
    return message;
  },
};

function createBaseStaticRoute(): StaticRoute {
  return { id: undefined, nextHop: "", nextHopVrf: "", probeId: "", distance: 0, isActive: false, blackhole: false };
}

export const StaticRoute: MessageFns<StaticRoute> = {
  encode(message: StaticRoute, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.nextHop !== "") {
      writer.uint32(26).string(message.nextHop);
    }
    if (message.nextHopVrf !== "") {
      writer.uint32(34).string(message.nextHopVrf);
    }
    if (message.probeId !== "") {
      writer.uint32(42).string(message.probeId);
    }
    if (message.distance !== 0) {
      writer.uint32(48).uint32(message.distance);
    }
    if (message.isActive !== false) {
      writer.uint32(56).bool(message.isActive);
    }
    if (message.blackhole !== false) {
      writer.uint32(64).bool(message.blackhole);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StaticRoute {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStaticRoute();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nextHop = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.nextHopVrf = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.probeId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.distance = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.blackhole = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StaticRoute {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      nextHop: isSet(object.nextHop) ? globalThis.String(object.nextHop) : "",
      nextHopVrf: isSet(object.nextHopVrf) ? globalThis.String(object.nextHopVrf) : "",
      probeId: isSet(object.probeId) ? globalThis.String(object.probeId) : "",
      distance: isSet(object.distance) ? globalThis.Number(object.distance) : 0,
      isActive: isSet(object.isActive) ? globalThis.Boolean(object.isActive) : false,
      blackhole: isSet(object.blackhole) ? globalThis.Boolean(object.blackhole) : false,
    };
  },

  toJSON(message: StaticRoute): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.nextHop !== "") {
      obj.nextHop = message.nextHop;
    }
    if (message.nextHopVrf !== "") {
      obj.nextHopVrf = message.nextHopVrf;
    }
    if (message.probeId !== "") {
      obj.probeId = message.probeId;
    }
    if (message.distance !== 0) {
      obj.distance = Math.round(message.distance);
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive;
    }
    if (message.blackhole !== false) {
      obj.blackhole = message.blackhole;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StaticRoute>, I>>(base?: I): StaticRoute {
    return StaticRoute.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StaticRoute>, I>>(object: I): StaticRoute {
    const message = createBaseStaticRoute();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.nextHop = object.nextHop ?? "";
    message.nextHopVrf = object.nextHopVrf ?? "";
    message.probeId = object.probeId ?? "";
    message.distance = object.distance ?? 0;
    message.isActive = object.isActive ?? false;
    message.blackhole = object.blackhole ?? false;
    return message;
  },
};

function createBaseIpSlaProbe(): IpSlaProbe {
  return {
    id: undefined,
    probeId: "",
    type: 0,
    operationalState: 0,
    srcIp: "",
    srcIntf: "",
    vrf: "",
    dstIp: "",
    affectedRoutePrefix: "",
    affectedNexthop: "",
    frequency: 0,
    timeout: 0,
    multiplier: 0,
    tos: 0,
    ttl: 0,
    dstPort: 0,
    srcPort: 0,
    pktSize: 0,
    pktCount: 0,
    successCount: 0,
    failureCount: 0,
    totalOperations: 0,
    consecutiveFailures: 0,
    latestRttMs: 0,
    minRttMs: 0,
    maxRttMs: 0,
    avgRttMs: 0,
    enabled: false,
    routeCurrentlyWithdrawn: false,
    lastSuccessTime: undefined,
    lastFailureTime: undefined,
    lastRouteWithdrawal: undefined,
    lastRouteInstallation: undefined,
    collectedAt: undefined,
  };
}

export const IpSlaProbe: MessageFns<IpSlaProbe> = {
  encode(message: IpSlaProbe, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.probeId !== "") {
      writer.uint32(26).string(message.probeId);
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    if (message.operationalState !== 0) {
      writer.uint32(40).int32(message.operationalState);
    }
    if (message.srcIp !== "") {
      writer.uint32(50).string(message.srcIp);
    }
    if (message.srcIntf !== "") {
      writer.uint32(58).string(message.srcIntf);
    }
    if (message.vrf !== "") {
      writer.uint32(66).string(message.vrf);
    }
    if (message.dstIp !== "") {
      writer.uint32(74).string(message.dstIp);
    }
    if (message.affectedRoutePrefix !== "") {
      writer.uint32(82).string(message.affectedRoutePrefix);
    }
    if (message.affectedNexthop !== "") {
      writer.uint32(90).string(message.affectedNexthop);
    }
    if (message.frequency !== 0) {
      writer.uint32(96).uint32(message.frequency);
    }
    if (message.timeout !== 0) {
      writer.uint32(104).uint32(message.timeout);
    }
    if (message.multiplier !== 0) {
      writer.uint32(112).uint32(message.multiplier);
    }
    if (message.tos !== 0) {
      writer.uint32(120).uint32(message.tos);
    }
    if (message.ttl !== 0) {
      writer.uint32(128).uint32(message.ttl);
    }
    if (message.dstPort !== 0) {
      writer.uint32(136).uint32(message.dstPort);
    }
    if (message.srcPort !== 0) {
      writer.uint32(144).uint32(message.srcPort);
    }
    if (message.pktSize !== 0) {
      writer.uint32(152).uint32(message.pktSize);
    }
    if (message.pktCount !== 0) {
      writer.uint32(160).uint32(message.pktCount);
    }
    if (message.successCount !== 0) {
      writer.uint32(168).uint32(message.successCount);
    }
    if (message.failureCount !== 0) {
      writer.uint32(176).uint32(message.failureCount);
    }
    if (message.totalOperations !== 0) {
      writer.uint32(184).uint32(message.totalOperations);
    }
    if (message.consecutiveFailures !== 0) {
      writer.uint32(192).uint32(message.consecutiveFailures);
    }
    if (message.latestRttMs !== 0) {
      writer.uint32(200).uint32(message.latestRttMs);
    }
    if (message.minRttMs !== 0) {
      writer.uint32(208).uint32(message.minRttMs);
    }
    if (message.maxRttMs !== 0) {
      writer.uint32(216).uint32(message.maxRttMs);
    }
    if (message.avgRttMs !== 0) {
      writer.uint32(224).uint32(message.avgRttMs);
    }
    if (message.enabled !== false) {
      writer.uint32(232).bool(message.enabled);
    }
    if (message.routeCurrentlyWithdrawn !== false) {
      writer.uint32(240).bool(message.routeCurrentlyWithdrawn);
    }
    if (message.lastSuccessTime !== undefined) {
      Timestamp.encode(toTimestamp(message.lastSuccessTime), writer.uint32(250).fork()).join();
    }
    if (message.lastFailureTime !== undefined) {
      Timestamp.encode(toTimestamp(message.lastFailureTime), writer.uint32(258).fork()).join();
    }
    if (message.lastRouteWithdrawal !== undefined) {
      Timestamp.encode(toTimestamp(message.lastRouteWithdrawal), writer.uint32(266).fork()).join();
    }
    if (message.lastRouteInstallation !== undefined) {
      Timestamp.encode(toTimestamp(message.lastRouteInstallation), writer.uint32(274).fork()).join();
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(282).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpSlaProbe {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpSlaProbe();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.probeId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.operationalState = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.srcIp = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.srcIntf = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.vrf = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.dstIp = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.affectedRoutePrefix = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.affectedNexthop = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.frequency = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.timeout = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.multiplier = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.tos = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.ttl = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.dstPort = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.srcPort = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.pktSize = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.pktCount = reader.uint32();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.successCount = reader.uint32();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.failureCount = reader.uint32();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.totalOperations = reader.uint32();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.consecutiveFailures = reader.uint32();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.latestRttMs = reader.uint32();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.minRttMs = reader.uint32();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.maxRttMs = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.avgRttMs = reader.uint32();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.routeCurrentlyWithdrawn = reader.bool();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.lastSuccessTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.lastFailureTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.lastRouteWithdrawal = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.lastRouteInstallation = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpSlaProbe {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      probeId: isSet(object.probeId) ? globalThis.String(object.probeId) : "",
      type: isSet(object.type) ? ipSlaProbeConnectionTypeFromJSON(object.type) : 0,
      operationalState: isSet(object.operationalState) ? ipSlaProbeOpStateTypeFromJSON(object.operationalState) : 0,
      srcIp: isSet(object.srcIp) ? globalThis.String(object.srcIp) : "",
      srcIntf: isSet(object.srcIntf) ? globalThis.String(object.srcIntf) : "",
      vrf: isSet(object.vrf) ? globalThis.String(object.vrf) : "",
      dstIp: isSet(object.dstIp) ? globalThis.String(object.dstIp) : "",
      affectedRoutePrefix: isSet(object.affectedRoutePrefix) ? globalThis.String(object.affectedRoutePrefix) : "",
      affectedNexthop: isSet(object.affectedNexthop) ? globalThis.String(object.affectedNexthop) : "",
      frequency: isSet(object.frequency) ? globalThis.Number(object.frequency) : 0,
      timeout: isSet(object.timeout) ? globalThis.Number(object.timeout) : 0,
      multiplier: isSet(object.multiplier) ? globalThis.Number(object.multiplier) : 0,
      tos: isSet(object.tos) ? globalThis.Number(object.tos) : 0,
      ttl: isSet(object.ttl) ? globalThis.Number(object.ttl) : 0,
      dstPort: isSet(object.dstPort) ? globalThis.Number(object.dstPort) : 0,
      srcPort: isSet(object.srcPort) ? globalThis.Number(object.srcPort) : 0,
      pktSize: isSet(object.pktSize) ? globalThis.Number(object.pktSize) : 0,
      pktCount: isSet(object.pktCount) ? globalThis.Number(object.pktCount) : 0,
      successCount: isSet(object.successCount) ? globalThis.Number(object.successCount) : 0,
      failureCount: isSet(object.failureCount) ? globalThis.Number(object.failureCount) : 0,
      totalOperations: isSet(object.totalOperations) ? globalThis.Number(object.totalOperations) : 0,
      consecutiveFailures: isSet(object.consecutiveFailures) ? globalThis.Number(object.consecutiveFailures) : 0,
      latestRttMs: isSet(object.latestRttMs) ? globalThis.Number(object.latestRttMs) : 0,
      minRttMs: isSet(object.minRttMs) ? globalThis.Number(object.minRttMs) : 0,
      maxRttMs: isSet(object.maxRttMs) ? globalThis.Number(object.maxRttMs) : 0,
      avgRttMs: isSet(object.avgRttMs) ? globalThis.Number(object.avgRttMs) : 0,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      routeCurrentlyWithdrawn: isSet(object.routeCurrentlyWithdrawn)
        ? globalThis.Boolean(object.routeCurrentlyWithdrawn)
        : false,
      lastSuccessTime: isSet(object.lastSuccessTime) ? fromJsonTimestamp(object.lastSuccessTime) : undefined,
      lastFailureTime: isSet(object.lastFailureTime) ? fromJsonTimestamp(object.lastFailureTime) : undefined,
      lastRouteWithdrawal: isSet(object.lastRouteWithdrawal)
        ? fromJsonTimestamp(object.lastRouteWithdrawal)
        : undefined,
      lastRouteInstallation: isSet(object.lastRouteInstallation)
        ? fromJsonTimestamp(object.lastRouteInstallation)
        : undefined,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: IpSlaProbe): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.probeId !== "") {
      obj.probeId = message.probeId;
    }
    if (message.type !== 0) {
      obj.type = ipSlaProbeConnectionTypeToJSON(message.type);
    }
    if (message.operationalState !== 0) {
      obj.operationalState = ipSlaProbeOpStateTypeToJSON(message.operationalState);
    }
    if (message.srcIp !== "") {
      obj.srcIp = message.srcIp;
    }
    if (message.srcIntf !== "") {
      obj.srcIntf = message.srcIntf;
    }
    if (message.vrf !== "") {
      obj.vrf = message.vrf;
    }
    if (message.dstIp !== "") {
      obj.dstIp = message.dstIp;
    }
    if (message.affectedRoutePrefix !== "") {
      obj.affectedRoutePrefix = message.affectedRoutePrefix;
    }
    if (message.affectedNexthop !== "") {
      obj.affectedNexthop = message.affectedNexthop;
    }
    if (message.frequency !== 0) {
      obj.frequency = Math.round(message.frequency);
    }
    if (message.timeout !== 0) {
      obj.timeout = Math.round(message.timeout);
    }
    if (message.multiplier !== 0) {
      obj.multiplier = Math.round(message.multiplier);
    }
    if (message.tos !== 0) {
      obj.tos = Math.round(message.tos);
    }
    if (message.ttl !== 0) {
      obj.ttl = Math.round(message.ttl);
    }
    if (message.dstPort !== 0) {
      obj.dstPort = Math.round(message.dstPort);
    }
    if (message.srcPort !== 0) {
      obj.srcPort = Math.round(message.srcPort);
    }
    if (message.pktSize !== 0) {
      obj.pktSize = Math.round(message.pktSize);
    }
    if (message.pktCount !== 0) {
      obj.pktCount = Math.round(message.pktCount);
    }
    if (message.successCount !== 0) {
      obj.successCount = Math.round(message.successCount);
    }
    if (message.failureCount !== 0) {
      obj.failureCount = Math.round(message.failureCount);
    }
    if (message.totalOperations !== 0) {
      obj.totalOperations = Math.round(message.totalOperations);
    }
    if (message.consecutiveFailures !== 0) {
      obj.consecutiveFailures = Math.round(message.consecutiveFailures);
    }
    if (message.latestRttMs !== 0) {
      obj.latestRttMs = Math.round(message.latestRttMs);
    }
    if (message.minRttMs !== 0) {
      obj.minRttMs = Math.round(message.minRttMs);
    }
    if (message.maxRttMs !== 0) {
      obj.maxRttMs = Math.round(message.maxRttMs);
    }
    if (message.avgRttMs !== 0) {
      obj.avgRttMs = Math.round(message.avgRttMs);
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.routeCurrentlyWithdrawn !== false) {
      obj.routeCurrentlyWithdrawn = message.routeCurrentlyWithdrawn;
    }
    if (message.lastSuccessTime !== undefined) {
      obj.lastSuccessTime = message.lastSuccessTime.toISOString();
    }
    if (message.lastFailureTime !== undefined) {
      obj.lastFailureTime = message.lastFailureTime.toISOString();
    }
    if (message.lastRouteWithdrawal !== undefined) {
      obj.lastRouteWithdrawal = message.lastRouteWithdrawal.toISOString();
    }
    if (message.lastRouteInstallation !== undefined) {
      obj.lastRouteInstallation = message.lastRouteInstallation.toISOString();
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpSlaProbe>, I>>(base?: I): IpSlaProbe {
    return IpSlaProbe.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpSlaProbe>, I>>(object: I): IpSlaProbe {
    const message = createBaseIpSlaProbe();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.probeId = object.probeId ?? "";
    message.type = object.type ?? 0;
    message.operationalState = object.operationalState ?? 0;
    message.srcIp = object.srcIp ?? "";
    message.srcIntf = object.srcIntf ?? "";
    message.vrf = object.vrf ?? "";
    message.dstIp = object.dstIp ?? "";
    message.affectedRoutePrefix = object.affectedRoutePrefix ?? "";
    message.affectedNexthop = object.affectedNexthop ?? "";
    message.frequency = object.frequency ?? 0;
    message.timeout = object.timeout ?? 0;
    message.multiplier = object.multiplier ?? 0;
    message.tos = object.tos ?? 0;
    message.ttl = object.ttl ?? 0;
    message.dstPort = object.dstPort ?? 0;
    message.srcPort = object.srcPort ?? 0;
    message.pktSize = object.pktSize ?? 0;
    message.pktCount = object.pktCount ?? 0;
    message.successCount = object.successCount ?? 0;
    message.failureCount = object.failureCount ?? 0;
    message.totalOperations = object.totalOperations ?? 0;
    message.consecutiveFailures = object.consecutiveFailures ?? 0;
    message.latestRttMs = object.latestRttMs ?? 0;
    message.minRttMs = object.minRttMs ?? 0;
    message.maxRttMs = object.maxRttMs ?? 0;
    message.avgRttMs = object.avgRttMs ?? 0;
    message.enabled = object.enabled ?? false;
    message.routeCurrentlyWithdrawn = object.routeCurrentlyWithdrawn ?? false;
    message.lastSuccessTime = object.lastSuccessTime ?? undefined;
    message.lastFailureTime = object.lastFailureTime ?? undefined;
    message.lastRouteWithdrawal = object.lastRouteWithdrawal ?? undefined;
    message.lastRouteInstallation = object.lastRouteInstallation ?? undefined;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseInterconnect(): Interconnect {
  return { id: undefined };
}

export const Interconnect: MessageFns<Interconnect> = {
  encode(message: Interconnect, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Interconnect {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterconnect();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Interconnect {
    return { id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined };
  },

  toJSON(message: Interconnect): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Interconnect>, I>>(base?: I): Interconnect {
    return Interconnect.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Interconnect>, I>>(object: I): Interconnect {
    const message = createBaseInterconnect();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    return message;
  },
};

function createBaseInterconnectTransaction(): InterconnectTransaction {
  return { id: undefined, orgId: "", committed: false };
}

export const InterconnectTransaction: MessageFns<InterconnectTransaction> = {
  encode(message: InterconnectTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    if (message.committed !== false) {
      writer.uint32(24).bool(message.committed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InterconnectTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterconnectTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.committed = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InterconnectTransaction {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      committed: isSet(object.committed) ? globalThis.Boolean(object.committed) : false,
    };
  },

  toJSON(message: InterconnectTransaction): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.committed !== false) {
      obj.committed = message.committed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InterconnectTransaction>, I>>(base?: I): InterconnectTransaction {
    return InterconnectTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InterconnectTransaction>, I>>(object: I): InterconnectTransaction {
    const message = createBaseInterconnectTransaction();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.orgId = object.orgId ?? "";
    message.committed = object.committed ?? false;
    return message;
  },
};

function createBaseSpanSession(): SpanSession {
  return {
    id: undefined,
    status: 0,
    rxBandwidth: 0,
    txBandwidth: 0,
    rxBytes: "0",
    txBytes: "0",
    rxPackets: "0",
    txPackets: "0",
    collectedAt: undefined,
  };
}

export const SpanSession: MessageFns<SpanSession> = {
  encode(message: SpanSession, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.rxBandwidth !== 0) {
      writer.uint32(29).float(message.rxBandwidth);
    }
    if (message.txBandwidth !== 0) {
      writer.uint32(37).float(message.txBandwidth);
    }
    if (message.rxBytes !== "0") {
      writer.uint32(40).uint64(message.rxBytes);
    }
    if (message.txBytes !== "0") {
      writer.uint32(48).uint64(message.txBytes);
    }
    if (message.rxPackets !== "0") {
      writer.uint32(56).uint64(message.rxPackets);
    }
    if (message.txPackets !== "0") {
      writer.uint32(64).uint64(message.txPackets);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpanSession {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpanSession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.rxBandwidth = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.txBandwidth = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.rxBytes = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.txBytes = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.rxPackets = reader.uint64().toString();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.txPackets = reader.uint64().toString();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpanSession {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      status: isSet(object.status) ? spanSessionStatusFromJSON(object.status) : 0,
      rxBandwidth: isSet(object.rxBandwidth) ? globalThis.Number(object.rxBandwidth) : 0,
      txBandwidth: isSet(object.txBandwidth) ? globalThis.Number(object.txBandwidth) : 0,
      rxBytes: isSet(object.rxBytes) ? globalThis.String(object.rxBytes) : "0",
      txBytes: isSet(object.txBytes) ? globalThis.String(object.txBytes) : "0",
      rxPackets: isSet(object.rxPackets) ? globalThis.String(object.rxPackets) : "0",
      txPackets: isSet(object.txPackets) ? globalThis.String(object.txPackets) : "0",
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: SpanSession): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.status !== 0) {
      obj.status = spanSessionStatusToJSON(message.status);
    }
    if (message.rxBandwidth !== 0) {
      obj.rxBandwidth = message.rxBandwidth;
    }
    if (message.txBandwidth !== 0) {
      obj.txBandwidth = message.txBandwidth;
    }
    if (message.rxBytes !== "0") {
      obj.rxBytes = message.rxBytes;
    }
    if (message.txBytes !== "0") {
      obj.txBytes = message.txBytes;
    }
    if (message.rxPackets !== "0") {
      obj.rxPackets = message.rxPackets;
    }
    if (message.txPackets !== "0") {
      obj.txPackets = message.txPackets;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpanSession>, I>>(base?: I): SpanSession {
    return SpanSession.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpanSession>, I>>(object: I): SpanSession {
    const message = createBaseSpanSession();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.status = object.status ?? 0;
    message.rxBandwidth = object.rxBandwidth ?? 0;
    message.txBandwidth = object.txBandwidth ?? 0;
    message.rxBytes = object.rxBytes ?? "0";
    message.txBytes = object.txBytes ?? "0";
    message.rxPackets = object.rxPackets ?? "0";
    message.txPackets = object.txPackets ?? "0";
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseArsConfig(): ArsConfig {
  return { id: undefined, enableAllPackets: false, mode: 0, collectedAt: undefined };
}

export const ArsConfig: MessageFns<ArsConfig> = {
  encode(message: ArsConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.enableAllPackets !== false) {
      writer.uint32(16).bool(message.enableAllPackets);
    }
    if (message.mode !== 0) {
      writer.uint32(24).int32(message.mode);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArsConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArsConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enableAllPackets = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArsConfig {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      enableAllPackets: isSet(object.enableAllPackets) ? globalThis.Boolean(object.enableAllPackets) : false,
      mode: isSet(object.mode) ? arsModeFromJSON(object.mode) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: ArsConfig): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.enableAllPackets !== false) {
      obj.enableAllPackets = message.enableAllPackets;
    }
    if (message.mode !== 0) {
      obj.mode = arsModeToJSON(message.mode);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArsConfig>, I>>(base?: I): ArsConfig {
    return ArsConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArsConfig>, I>>(object: I): ArsConfig {
    const message = createBaseArsConfig();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.enableAllPackets = object.enableAllPackets ?? false;
    message.mode = object.mode ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseArsPortInfo(): ArsPortInfo {
  return { id: undefined, enabled: false, collectedAt: undefined };
}

export const ArsPortInfo: MessageFns<ArsPortInfo> = {
  encode(message: ArsPortInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArsPortInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArsPortInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArsPortInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: ArsPortInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArsPortInfo>, I>>(base?: I): ArsPortInfo {
    return ArsPortInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArsPortInfo>, I>>(object: I): ArsPortInfo {
    const message = createBaseArsPortInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.enabled = object.enabled ?? false;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseBgpRouteStats(): BgpRouteStats {
  return { id: undefined, evpnType2RouteCount: 0, collectedAt: undefined, evpnType2PathCount: 0 };
}

export const BgpRouteStats: MessageFns<BgpRouteStats> = {
  encode(message: BgpRouteStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.evpnType2RouteCount !== 0) {
      writer.uint32(16).uint32(message.evpnType2RouteCount);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(26).fork()).join();
    }
    if (message.evpnType2PathCount !== 0) {
      writer.uint32(32).uint32(message.evpnType2PathCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpRouteStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpRouteStats();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.evpnType2RouteCount = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.evpnType2PathCount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpRouteStats {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      evpnType2RouteCount: isSet(object.evpnType2RouteCount) ? globalThis.Number(object.evpnType2RouteCount) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      evpnType2PathCount: isSet(object.evpnType2PathCount) ? globalThis.Number(object.evpnType2PathCount) : 0,
    };
  },

  toJSON(message: BgpRouteStats): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.evpnType2RouteCount !== 0) {
      obj.evpnType2RouteCount = Math.round(message.evpnType2RouteCount);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.evpnType2PathCount !== 0) {
      obj.evpnType2PathCount = Math.round(message.evpnType2PathCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpRouteStats>, I>>(base?: I): BgpRouteStats {
    return BgpRouteStats.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpRouteStats>, I>>(object: I): BgpRouteStats {
    const message = createBaseBgpRouteStats();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.evpnType2RouteCount = object.evpnType2RouteCount ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.evpnType2PathCount = object.evpnType2PathCount ?? 0;
    return message;
  },
};

function createBaseCommandRequest(): CommandRequest {
  return { id: undefined, command: "", captureStream: 0, expiry: undefined, status: 0 };
}

export const CommandRequest: MessageFns<CommandRequest> = {
  encode(message: CommandRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.command !== "") {
      writer.uint32(18).string(message.command);
    }
    if (message.captureStream !== 0) {
      writer.uint32(24).int32(message.captureStream);
    }
    if (message.expiry !== undefined) {
      Timestamp.encode(toTimestamp(message.expiry), writer.uint32(34).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommandRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommandRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.command = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.captureStream = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.expiry = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommandRequest {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      command: isSet(object.command) ? globalThis.String(object.command) : "",
      captureStream: isSet(object.captureStream) ? commandOutputStreamFromJSON(object.captureStream) : 0,
      expiry: isSet(object.expiry) ? fromJsonTimestamp(object.expiry) : undefined,
      status: isSet(object.status) ? commandStatusFromJSON(object.status) : 0,
    };
  },

  toJSON(message: CommandRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.command !== "") {
      obj.command = message.command;
    }
    if (message.captureStream !== 0) {
      obj.captureStream = commandOutputStreamToJSON(message.captureStream);
    }
    if (message.expiry !== undefined) {
      obj.expiry = message.expiry.toISOString();
    }
    if (message.status !== 0) {
      obj.status = commandStatusToJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommandRequest>, I>>(base?: I): CommandRequest {
    return CommandRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommandRequest>, I>>(object: I): CommandRequest {
    const message = createBaseCommandRequest();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.command = object.command ?? "";
    message.captureStream = object.captureStream ?? 0;
    message.expiry = object.expiry ?? undefined;
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseCommandOutput(): CommandOutput {
  return {
    id: undefined,
    status: 0,
    exitCode: 0,
    error: "",
    collectedAt: undefined,
    startedAt: undefined,
    endedAt: undefined,
    totalRecords: 0,
  };
}

export const CommandOutput: MessageFns<CommandOutput> = {
  encode(message: CommandOutput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.exitCode !== 0) {
      writer.uint32(24).int32(message.exitCode);
    }
    if (message.error !== "") {
      writer.uint32(34).string(message.error);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(42).fork()).join();
    }
    if (message.startedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.startedAt), writer.uint32(50).fork()).join();
    }
    if (message.endedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.endedAt), writer.uint32(58).fork()).join();
    }
    if (message.totalRecords !== 0) {
      writer.uint32(64).uint32(message.totalRecords);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommandOutput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommandOutput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.exitCode = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.error = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.startedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.endedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.totalRecords = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommandOutput {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      status: isSet(object.status) ? commandStatusFromJSON(object.status) : 0,
      exitCode: isSet(object.exitCode) ? globalThis.Number(object.exitCode) : 0,
      error: isSet(object.error) ? globalThis.String(object.error) : "",
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      startedAt: isSet(object.startedAt) ? fromJsonTimestamp(object.startedAt) : undefined,
      endedAt: isSet(object.endedAt) ? fromJsonTimestamp(object.endedAt) : undefined,
      totalRecords: isSet(object.totalRecords) ? globalThis.Number(object.totalRecords) : 0,
    };
  },

  toJSON(message: CommandOutput): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.status !== 0) {
      obj.status = commandStatusToJSON(message.status);
    }
    if (message.exitCode !== 0) {
      obj.exitCode = Math.round(message.exitCode);
    }
    if (message.error !== "") {
      obj.error = message.error;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.startedAt !== undefined) {
      obj.startedAt = message.startedAt.toISOString();
    }
    if (message.endedAt !== undefined) {
      obj.endedAt = message.endedAt.toISOString();
    }
    if (message.totalRecords !== 0) {
      obj.totalRecords = Math.round(message.totalRecords);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommandOutput>, I>>(base?: I): CommandOutput {
    return CommandOutput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommandOutput>, I>>(object: I): CommandOutput {
    const message = createBaseCommandOutput();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.status = object.status ?? 0;
    message.exitCode = object.exitCode ?? 0;
    message.error = object.error ?? "";
    message.collectedAt = object.collectedAt ?? undefined;
    message.startedAt = object.startedAt ?? undefined;
    message.endedAt = object.endedAt ?? undefined;
    message.totalRecords = object.totalRecords ?? 0;
    return message;
  },
};

function createBaseCommandOutputRecord(): CommandOutputRecord {
  return { id: undefined, output: "", captureStream: 0, collectedAt: undefined };
}

export const CommandOutputRecord: MessageFns<CommandOutputRecord> = {
  encode(message: CommandOutputRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.output !== "") {
      writer.uint32(18).string(message.output);
    }
    if (message.captureStream !== 0) {
      writer.uint32(24).int32(message.captureStream);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommandOutputRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommandOutputRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.output = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.captureStream = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommandOutputRecord {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      output: isSet(object.output) ? globalThis.String(object.output) : "",
      captureStream: isSet(object.captureStream) ? commandOutputStreamFromJSON(object.captureStream) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: CommandOutputRecord): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.output !== "") {
      obj.output = message.output;
    }
    if (message.captureStream !== 0) {
      obj.captureStream = commandOutputStreamToJSON(message.captureStream);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommandOutputRecord>, I>>(base?: I): CommandOutputRecord {
    return CommandOutputRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommandOutputRecord>, I>>(object: I): CommandOutputRecord {
    const message = createBaseCommandOutputRecord();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.output = object.output ?? "";
    message.captureStream = object.captureStream ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseImageManifestInfo(): ImageManifestInfo {
  return {
    id: undefined,
    manifestFp: "",
    targetTag: "",
    runningTag: "",
    nodeTag: "",
    inSwUpdate: false,
    issuedAt: undefined,
    agentVersion: "",
  };
}

export const ImageManifestInfo: MessageFns<ImageManifestInfo> = {
  encode(message: ImageManifestInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.manifestFp !== "") {
      writer.uint32(18).string(message.manifestFp);
    }
    if (message.targetTag !== "") {
      writer.uint32(26).string(message.targetTag);
    }
    if (message.runningTag !== "") {
      writer.uint32(34).string(message.runningTag);
    }
    if (message.nodeTag !== "") {
      writer.uint32(42).string(message.nodeTag);
    }
    if (message.inSwUpdate !== false) {
      writer.uint32(48).bool(message.inSwUpdate);
    }
    if (message.issuedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.issuedAt), writer.uint32(58).fork()).join();
    }
    if (message.agentVersion !== "") {
      writer.uint32(66).string(message.agentVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImageManifestInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImageManifestInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.manifestFp = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.targetTag = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.runningTag = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.nodeTag = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.inSwUpdate = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.issuedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.agentVersion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImageManifestInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      manifestFp: isSet(object.manifestFp) ? globalThis.String(object.manifestFp) : "",
      targetTag: isSet(object.targetTag) ? globalThis.String(object.targetTag) : "",
      runningTag: isSet(object.runningTag) ? globalThis.String(object.runningTag) : "",
      nodeTag: isSet(object.nodeTag) ? globalThis.String(object.nodeTag) : "",
      inSwUpdate: isSet(object.inSwUpdate) ? globalThis.Boolean(object.inSwUpdate) : false,
      issuedAt: isSet(object.issuedAt) ? fromJsonTimestamp(object.issuedAt) : undefined,
      agentVersion: isSet(object.agentVersion) ? globalThis.String(object.agentVersion) : "",
    };
  },

  toJSON(message: ImageManifestInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.manifestFp !== "") {
      obj.manifestFp = message.manifestFp;
    }
    if (message.targetTag !== "") {
      obj.targetTag = message.targetTag;
    }
    if (message.runningTag !== "") {
      obj.runningTag = message.runningTag;
    }
    if (message.nodeTag !== "") {
      obj.nodeTag = message.nodeTag;
    }
    if (message.inSwUpdate !== false) {
      obj.inSwUpdate = message.inSwUpdate;
    }
    if (message.issuedAt !== undefined) {
      obj.issuedAt = message.issuedAt.toISOString();
    }
    if (message.agentVersion !== "") {
      obj.agentVersion = message.agentVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImageManifestInfo>, I>>(base?: I): ImageManifestInfo {
    return ImageManifestInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImageManifestInfo>, I>>(object: I): ImageManifestInfo {
    const message = createBaseImageManifestInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.manifestFp = object.manifestFp ?? "";
    message.targetTag = object.targetTag ?? "";
    message.runningTag = object.runningTag ?? "";
    message.nodeTag = object.nodeTag ?? "";
    message.inSwUpdate = object.inSwUpdate ?? false;
    message.issuedAt = object.issuedAt ?? undefined;
    message.agentVersion = object.agentVersion ?? "";
    return message;
  },
};

function createBaseOpticsFirmwareUpdate(): OpticsFirmwareUpdate {
  return { id: undefined, pid: "", currentVersion: "", targetVersion: "", status: 0, collectedAt: undefined };
}

export const OpticsFirmwareUpdate: MessageFns<OpticsFirmwareUpdate> = {
  encode(message: OpticsFirmwareUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.pid !== "") {
      writer.uint32(26).string(message.pid);
    }
    if (message.currentVersion !== "") {
      writer.uint32(34).string(message.currentVersion);
    }
    if (message.targetVersion !== "") {
      writer.uint32(42).string(message.targetVersion);
    }
    if (message.status !== 0) {
      writer.uint32(48).int32(message.status);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpticsFirmwareUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpticsFirmwareUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.currentVersion = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.targetVersion = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpticsFirmwareUpdate {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      pid: isSet(object.pid) ? globalThis.String(object.pid) : "",
      currentVersion: isSet(object.currentVersion) ? globalThis.String(object.currentVersion) : "",
      targetVersion: isSet(object.targetVersion) ? globalThis.String(object.targetVersion) : "",
      status: isSet(object.status) ? opticsFirmwareUpdateStatusFromJSON(object.status) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: OpticsFirmwareUpdate): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.pid !== "") {
      obj.pid = message.pid;
    }
    if (message.currentVersion !== "") {
      obj.currentVersion = message.currentVersion;
    }
    if (message.targetVersion !== "") {
      obj.targetVersion = message.targetVersion;
    }
    if (message.status !== 0) {
      obj.status = opticsFirmwareUpdateStatusToJSON(message.status);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpticsFirmwareUpdate>, I>>(base?: I): OpticsFirmwareUpdate {
    return OpticsFirmwareUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpticsFirmwareUpdate>, I>>(object: I): OpticsFirmwareUpdate {
    const message = createBaseOpticsFirmwareUpdate();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.pid = object.pid ?? "";
    message.currentVersion = object.currentVersion ?? "";
    message.targetVersion = object.targetVersion ?? "";
    message.status = object.status ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseVxlanRemoteVtepInfo(): VxlanRemoteVtepInfo {
  return { id: undefined, srcIp: "", dstIp: "", tunnelSrc: 0, operStatus: 0, collectedAt: undefined };
}

export const VxlanRemoteVtepInfo: MessageFns<VxlanRemoteVtepInfo> = {
  encode(message: VxlanRemoteVtepInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(18).fork()).join();
    }
    if (message.srcIp !== "") {
      writer.uint32(26).string(message.srcIp);
    }
    if (message.dstIp !== "") {
      writer.uint32(34).string(message.dstIp);
    }
    if (message.tunnelSrc !== 0) {
      writer.uint32(40).int32(message.tunnelSrc);
    }
    if (message.operStatus !== 0) {
      writer.uint32(48).int32(message.operStatus);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VxlanRemoteVtepInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVxlanRemoteVtepInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.srcIp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dstIp = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.tunnelSrc = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.operStatus = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VxlanRemoteVtepInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      srcIp: isSet(object.srcIp) ? globalThis.String(object.srcIp) : "",
      dstIp: isSet(object.dstIp) ? globalThis.String(object.dstIp) : "",
      tunnelSrc: isSet(object.tunnelSrc) ? vxlanTunnelSrcTypeFromJSON(object.tunnelSrc) : 0,
      operStatus: isSet(object.operStatus) ? operStateFromJSON(object.operStatus) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: VxlanRemoteVtepInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.srcIp !== "") {
      obj.srcIp = message.srcIp;
    }
    if (message.dstIp !== "") {
      obj.dstIp = message.dstIp;
    }
    if (message.tunnelSrc !== 0) {
      obj.tunnelSrc = vxlanTunnelSrcTypeToJSON(message.tunnelSrc);
    }
    if (message.operStatus !== 0) {
      obj.operStatus = operStateToJSON(message.operStatus);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VxlanRemoteVtepInfo>, I>>(base?: I): VxlanRemoteVtepInfo {
    return VxlanRemoteVtepInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VxlanRemoteVtepInfo>, I>>(object: I): VxlanRemoteVtepInfo {
    const message = createBaseVxlanRemoteVtepInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.srcIp = object.srcIp ?? "";
    message.dstIp = object.dstIp ?? "";
    message.tunnelSrc = object.tunnelSrc ?? 0;
    message.operStatus = object.operStatus ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function createBaseArsInfo(): ArsInfo {
  return {
    id: undefined,
    sliceIndex: 0,
    agingTimeUsec: "0",
    incomingDlbPktCount: "0",
    activeFlowsCount: "0",
    maxFlowsSeen: "0",
    agedFlowsCount: "0",
    flowletPathChanges: "0",
    droppedPktCount: "0",
    loadAwareness: false,
    disableAging: false,
    decayFactor: 0,
    collectedAt: undefined,
  };
}

export const ArsInfo: MessageFns<ArsInfo> = {
  encode(message: ArsInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      PathId.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.sliceIndex !== 0) {
      writer.uint32(16).uint32(message.sliceIndex);
    }
    if (message.agingTimeUsec !== "0") {
      writer.uint32(24).uint64(message.agingTimeUsec);
    }
    if (message.incomingDlbPktCount !== "0") {
      writer.uint32(32).uint64(message.incomingDlbPktCount);
    }
    if (message.activeFlowsCount !== "0") {
      writer.uint32(40).uint64(message.activeFlowsCount);
    }
    if (message.maxFlowsSeen !== "0") {
      writer.uint32(48).uint64(message.maxFlowsSeen);
    }
    if (message.agedFlowsCount !== "0") {
      writer.uint32(56).uint64(message.agedFlowsCount);
    }
    if (message.flowletPathChanges !== "0") {
      writer.uint32(64).uint64(message.flowletPathChanges);
    }
    if (message.droppedPktCount !== "0") {
      writer.uint32(72).uint64(message.droppedPktCount);
    }
    if (message.loadAwareness !== false) {
      writer.uint32(80).bool(message.loadAwareness);
    }
    if (message.disableAging !== false) {
      writer.uint32(88).bool(message.disableAging);
    }
    if (message.decayFactor !== 0) {
      writer.uint32(96).uint32(message.decayFactor);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArsInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArsInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sliceIndex = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.agingTimeUsec = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.incomingDlbPktCount = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.activeFlowsCount = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.maxFlowsSeen = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.agedFlowsCount = reader.uint64().toString();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.flowletPathChanges = reader.uint64().toString();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.droppedPktCount = reader.uint64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.loadAwareness = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.disableAging = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.decayFactor = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArsInfo {
    return {
      id: isSet(object.id) ? PathId.fromJSON(object.id) : undefined,
      sliceIndex: isSet(object.sliceIndex) ? globalThis.Number(object.sliceIndex) : 0,
      agingTimeUsec: isSet(object.agingTimeUsec) ? globalThis.String(object.agingTimeUsec) : "0",
      incomingDlbPktCount: isSet(object.incomingDlbPktCount) ? globalThis.String(object.incomingDlbPktCount) : "0",
      activeFlowsCount: isSet(object.activeFlowsCount) ? globalThis.String(object.activeFlowsCount) : "0",
      maxFlowsSeen: isSet(object.maxFlowsSeen) ? globalThis.String(object.maxFlowsSeen) : "0",
      agedFlowsCount: isSet(object.agedFlowsCount) ? globalThis.String(object.agedFlowsCount) : "0",
      flowletPathChanges: isSet(object.flowletPathChanges) ? globalThis.String(object.flowletPathChanges) : "0",
      droppedPktCount: isSet(object.droppedPktCount) ? globalThis.String(object.droppedPktCount) : "0",
      loadAwareness: isSet(object.loadAwareness) ? globalThis.Boolean(object.loadAwareness) : false,
      disableAging: isSet(object.disableAging) ? globalThis.Boolean(object.disableAging) : false,
      decayFactor: isSet(object.decayFactor) ? globalThis.Number(object.decayFactor) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
    };
  },

  toJSON(message: ArsInfo): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = PathId.toJSON(message.id);
    }
    if (message.sliceIndex !== 0) {
      obj.sliceIndex = Math.round(message.sliceIndex);
    }
    if (message.agingTimeUsec !== "0") {
      obj.agingTimeUsec = message.agingTimeUsec;
    }
    if (message.incomingDlbPktCount !== "0") {
      obj.incomingDlbPktCount = message.incomingDlbPktCount;
    }
    if (message.activeFlowsCount !== "0") {
      obj.activeFlowsCount = message.activeFlowsCount;
    }
    if (message.maxFlowsSeen !== "0") {
      obj.maxFlowsSeen = message.maxFlowsSeen;
    }
    if (message.agedFlowsCount !== "0") {
      obj.agedFlowsCount = message.agedFlowsCount;
    }
    if (message.flowletPathChanges !== "0") {
      obj.flowletPathChanges = message.flowletPathChanges;
    }
    if (message.droppedPktCount !== "0") {
      obj.droppedPktCount = message.droppedPktCount;
    }
    if (message.loadAwareness !== false) {
      obj.loadAwareness = message.loadAwareness;
    }
    if (message.disableAging !== false) {
      obj.disableAging = message.disableAging;
    }
    if (message.decayFactor !== 0) {
      obj.decayFactor = Math.round(message.decayFactor);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArsInfo>, I>>(base?: I): ArsInfo {
    return ArsInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArsInfo>, I>>(object: I): ArsInfo {
    const message = createBaseArsInfo();
    message.id = (object.id !== undefined && object.id !== null) ? PathId.fromPartial(object.id) : undefined;
    message.sliceIndex = object.sliceIndex ?? 0;
    message.agingTimeUsec = object.agingTimeUsec ?? "0";
    message.incomingDlbPktCount = object.incomingDlbPktCount ?? "0";
    message.activeFlowsCount = object.activeFlowsCount ?? "0";
    message.maxFlowsSeen = object.maxFlowsSeen ?? "0";
    message.agedFlowsCount = object.agedFlowsCount ?? "0";
    message.flowletPathChanges = object.flowletPathChanges ?? "0";
    message.droppedPktCount = object.droppedPktCount ?? "0";
    message.loadAwareness = object.loadAwareness ?? false;
    message.disableAging = object.disableAging ?? false;
    message.decayFactor = object.decayFactor ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
